var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _path1662, _path1663, _path1664, _path1665, _path1666, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672, _path1673, _path1674, _path1675, _path1676, _path1677, _path1678, _path1679, _path1680, _path1681, _path1682, _path1683, _path1684, _path1685, _path1686, _path1687, _path1688, _path1689, _path1690, _path1691, _path1692, _path1693, _path1694, _path1695, _path1696, _path1697, _path1698, _path1699, _path1700, _path1701, _path1702, _path1703, _path1704, _path1705, _path1706, _path1707, _path1708, _path1709, _path1710, _path1711, _path1712, _path1713, _path1714, _path1715, _path1716, _path1717, _path1718, _path1719, _path1720, _path1721, _path1722, _path1723, _path1724, _path1725, _path1726, _path1727, _path1728, _path1729, _path1730, _path1731, _path1732, _path1733, _path1734, _path1735, _path1736, _path1737, _path1738, _path1739, _path1740, _path1741, _path1742, _path1743, _path1744, _path1745, _path1746, _path1747, _path1748, _path1749, _path1750, _path1751, _path1752, _path1753, _path1754, _path1755, _path1756, _path1757, _path1758, _path1759, _path1760, _path1761, _path1762, _path1763, _path1764, _path1765, _path1766, _path1767, _path1768, _path1769, _path1770, _path1771, _path1772, _path1773, _path1774, _path1775, _path1776, _path1777, _path1778, _path1779, _path1780, _path1781, _path1782, _path1783, _path1784, _path1785, _path1786, _path1787, _path1788, _path1789, _path1790, _path1791, _path1792, _path1793, _path1794, _path1795, _path1796, _path1797, _path1798, _path1799, _path1800, _path1801, _path1802, _path1803, _path1804, _path1805, _path1806, _path1807, _path1808, _path1809, _path1810, _path1811, _path1812, _path1813, _path1814, _path1815, _path1816, _path1817, _path1818, _path1819, _path1820, _path1821, _path1822, _path1823, _path1824, _path1825, _path1826, _path1827, _path1828, _path1829, _path1830, _path1831, _path1832, _path1833, _path1834, _path1835, _path1836, _path1837, _path1838, _path1839, _path1840, _path1841, _path1842, _path1843, _path1844, _path1845, _path1846, _path1847, _path1848, _path1849, _path1850, _path1851, _path1852, _path1853, _path1854, _path1855, _path1856, _path1857, _path1858, _path1859, _path1860, _path1861, _path1862, _path1863, _path1864, _path1865, _path1866, _path1867, _path1868, _path1869, _path1870, _path1871, _path1872, _path1873, _path1874, _path1875, _path1876, _path1877, _path1878, _path1879, _path1880, _path1881, _path1882, _path1883, _path1884, _path1885, _path1886, _path1887, _path1888, _path1889, _path1890, _path1891, _path1892, _path1893, _path1894, _path1895, _path1896, _path1897, _path1898, _path1899, _path1900, _path1901, _path1902, _path1903, _path1904, _path1905, _path1906, _path1907, _path1908, _path1909, _path1910, _path1911, _path1912, _path1913, _path1914, _path1915, _path1916, _path1917, _path1918, _path1919, _path1920, _path1921, _path1922, _path1923, _path1924, _path1925, _path1926, _path1927, _path1928, _path1929, _path1930, _path1931, _path1932, _path1933, _path1934, _path1935, _path1936, _path1937, _path1938, _path1939, _path1940, _path1941, _path1942, _path1943, _path1944, _path1945, _path1946, _path1947, _path1948, _path1949, _path1950, _path1951, _path1952, _path1953, _path1954, _path1955, _path1956, _path1957, _path1958, _path1959, _path1960, _path1961, _path1962, _path1963, _path1964, _path1965, _path1966, _path1967, _path1968, _path1969, _path1970, _path1971, _path1972, _path1973, _path1974, _path1975, _path1976, _path1977, _path1978, _path1979, _path1980, _path1981, _path1982, _path1983, _path1984, _path1985, _path1986, _path1987, _path1988, _path1989, _path1990, _path1991, _path1992, _path1993, _path1994, _path1995, _path1996, _path1997, _path1998, _path1999, _path2000, _path2001, _path2002, _path2003, _path2004, _path2005, _path2006, _path2007, _path2008, _path2009, _path2010, _path2011, _path2012, _path2013, _path2014, _path2015, _path2016, _path2017, _path2018, _path2019, _path2020, _path2021, _path2022, _path2023, _path2024, _path2025, _path2026, _path2027, _path2028, _path2029, _path2030, _path2031, _path2032, _path2033, _path2034, _path2035, _path2036, _path2037, _path2038, _path2039, _path2040, _path2041, _path2042, _path2043, _path2044, _path2045, _path2046, _path2047, _path2048, _path2049, _path2050, _path2051, _path2052, _path2053, _path2054, _path2055, _path2056, _path2057, _path2058, _path2059, _path2060, _path2061, _path2062, _path2063, _path2064, _path2065, _path2066, _path2067, _path2068, _path2069, _path2070, _path2071, _path2072, _path2073, _path2074, _path2075, _path2076, _path2077, _path2078, _path2079, _path2080, _path2081, _path2082, _path2083, _path2084, _path2085, _path2086, _path2087, _path2088, _path2089, _path2090, _path2091, _path2092, _path2093, _path2094, _path2095, _path2096, _path2097, _path2098, _path2099, _path2100, _path2101, _path2102, _path2103, _path2104, _path2105, _path2106, _path2107, _path2108, _path2109, _path2110, _path2111, _path2112, _path2113, _path2114, _path2115, _path2116, _path2117, _path2118, _path2119, _path2120, _path2121, _path2122, _path2123, _path2124, _path2125, _path2126, _path2127, _path2128, _path2129, _path2130, _path2131, _path2132, _path2133, _path2134, _path2135, _path2136, _path2137, _path2138, _path2139, _path2140, _path2141, _path2142, _path2143, _path2144, _path2145, _path2146, _path2147, _path2148, _path2149, _path2150, _path2151, _path2152, _path2153, _path2154, _path2155, _path2156, _path2157, _path2158, _path2159, _path2160, _path2161, _path2162, _path2163, _path2164, _path2165, _path2166, _path2167, _path2168, _path2169, _path2170, _path2171, _path2172, _path2173, _path2174, _path2175, _path2176, _path2177, _path2178, _path2179, _path2180, _path2181, _path2182, _path2183, _path2184, _path2185, _path2186, _path2187, _path2188, _path2189, _path2190, _path2191, _path2192, _path2193, _path2194, _path2195, _path2196, _path2197, _path2198, _path2199, _path2200, _path2201, _path2202, _path2203, _path2204, _path2205, _path2206, _path2207, _path2208, _path2209, _path2210, _path2211, _path2212, _path2213, _path2214, _path2215, _path2216, _path2217, _path2218, _path2219, _path2220, _path2221, _path2222, _path2223, _path2224, _path2225, _path2226, _path2227, _path2228, _path2229, _path2230, _path2231, _path2232, _path2233, _path2234, _path2235, _path2236, _path2237, _path2238, _path2239, _path2240, _path2241, _path2242, _path2243, _path2244, _path2245, _path2246, _path2247, _path2248, _path2249, _path2250, _path2251, _path2252, _path2253, _path2254, _path2255, _path2256, _path2257, _path2258, _path2259, _path2260, _path2261, _path2262, _path2263, _path2264, _path2265, _path2266, _path2267, _path2268, _path2269, _path2270, _path2271, _path2272, _path2273, _path2274, _path2275, _path2276, _path2277, _path2278, _path2279, _path2280, _path2281, _path2282, _path2283, _path2284, _path2285, _path2286, _path2287, _path2288, _path2289, _path2290, _path2291, _path2292, _path2293, _path2294, _path2295, _path2296, _path2297, _path2298, _path2299, _path2300, _path2301, _path2302, _path2303, _path2304, _path2305, _path2306, _path2307, _path2308, _path2309, _path2310, _path2311, _path2312, _path2313, _path2314, _path2315, _path2316, _path2317, _path2318, _path2319, _path2320, _path2321, _path2322, _path2323, _path2324, _path2325, _path2326, _path2327, _path2328, _path2329, _path2330, _path2331, _path2332, _path2333, _path2334, _path2335, _path2336, _path2337, _path2338, _path2339, _path2340, _path2341, _path2342, _path2343, _path2344, _path2345, _path2346, _path2347, _path2348, _path2349, _path2350, _path2351, _path2352, _path2353, _path2354, _path2355, _path2356, _path2357, _path2358, _path2359, _path2360, _path2361, _path2362, _path2363, _path2364, _path2365, _path2366, _path2367, _path2368, _path2369, _path2370, _path2371, _path2372, _path2373, _path2374, _path2375, _path2376, _path2377, _path2378, _path2379, _path2380, _path2381, _path2382, _path2383, _path2384, _path2385, _path2386, _path2387, _path2388, _path2389, _path2390, _path2391, _path2392, _path2393, _path2394, _path2395, _path2396, _path2397, _path2398, _path2399, _path2400, _path2401, _path2402, _path2403, _path2404, _path2405, _path2406, _path2407, _path2408, _path2409, _path2410, _path2411, _path2412, _path2413, _path2414, _path2415, _path2416, _path2417, _path2418, _path2419, _path2420, _path2421, _path2422, _path2423, _path2424, _path2425, _path2426, _path2427, _path2428, _path2429, _path2430, _path2431, _path2432, _path2433, _path2434, _path2435, _path2436, _path2437, _path2438, _path2439, _path2440, _path2441, _path2442, _path2443, _path2444, _path2445, _path2446, _path2447, _path2448, _path2449, _path2450, _path2451, _path2452, _path2453, _path2454, _path2455, _path2456, _path2457, _path2458, _path2459, _path2460, _path2461, _path2462, _path2463, _path2464, _path2465, _path2466, _path2467, _path2468, _path2469, _path2470, _path2471, _path2472, _path2473, _path2474, _path2475, _path2476, _path2477, _path2478, _path2479, _path2480, _path2481, _path2482, _path2483, _path2484, _path2485, _path2486, _path2487, _path2488, _path2489, _path2490, _path2491, _path2492, _path2493, _path2494, _path2495, _path2496, _path2497, _path2498, _path2499, _path2500, _path2501, _path2502, _path2503, _path2504, _path2505, _path2506, _path2507, _path2508, _path2509, _path2510, _path2511, _path2512, _path2513, _path2514, _path2515, _path2516, _path2517, _path2518, _path2519, _path2520, _path2521, _path2522, _path2523, _path2524, _path2525, _path2526, _path2527, _path2528, _path2529, _path2530, _path2531, _path2532, _path2533, _path2534, _path2535, _path2536, _path2537, _path2538, _path2539, _path2540, _path2541, _path2542, _path2543, _path2544, _path2545, _path2546, _path2547, _path2548, _path2549, _path2550, _path2551, _path2552, _path2553, _path2554, _path2555, _path2556, _path2557, _path2558, _path2559, _path2560, _path2561, _path2562, _path2563, _path2564, _path2565, _path2566, _path2567, _path2568, _path2569, _path2570, _path2571, _path2572, _path2573, _path2574, _path2575, _path2576, _path2577, _path2578, _path2579, _path2580, _path2581, _path2582, _path2583, _path2584, _path2585, _path2586, _path2587, _path2588, _path2589, _path2590, _path2591, _path2592, _path2593, _path2594, _path2595, _path2596, _path2597, _path2598, _path2599, _path2600, _path2601, _path2602, _path2603, _path2604, _path2605, _path2606, _path2607, _path2608, _path2609, _path2610, _path2611, _path2612, _path2613, _path2614, _path2615, _path2616, _path2617, _path2618, _path2619, _path2620, _path2621, _path2622, _path2623, _path2624, _path2625, _path2626, _path2627, _path2628, _path2629, _path2630, _path2631, _path2632, _path2633, _path2634, _path2635, _path2636, _path2637, _path2638, _path2639, _path2640, _path2641, _path2642, _path2643, _path2644, _path2645, _path2646, _path2647, _path2648, _path2649, _path2650, _path2651, _path2652, _path2653, _path2654, _path2655, _path2656, _path2657, _path2658, _path2659, _path2660, _path2661, _path2662, _path2663, _path2664, _path2665, _path2666, _path2667, _path2668, _path2669, _path2670, _path2671, _path2672, _path2673, _path2674, _path2675, _path2676, _path2677, _path2678, _path2679, _path2680, _path2681, _path2682, _path2683, _path2684, _path2685, _path2686, _path2687, _path2688, _path2689, _path2690, _path2691, _path2692, _path2693, _path2694, _path2695, _path2696, _path2697, _path2698, _path2699, _path2700, _path2701, _path2702, _path2703, _path2704, _path2705, _path2706, _path2707, _path2708, _path2709, _path2710, _path2711, _path2712, _path2713, _path2714, _path2715, _path2716, _path2717, _path2718, _path2719, _path2720, _path2721, _path2722, _path2723, _path2724, _path2725, _path2726, _path2727, _path2728, _path2729, _path2730, _path2731, _path2732, _path2733, _path2734, _path2735, _path2736, _path2737, _path2738, _path2739, _path2740, _path2741, _path2742, _path2743, _path2744, _path2745, _path2746, _path2747, _path2748, _path2749, _path2750, _path2751, _path2752, _path2753, _path2754, _path2755, _path2756, _path2757, _path2758, _path2759, _path2760, _path2761, _path2762, _path2763, _path2764, _path2765, _path2766, _path2767, _path2768, _path2769, _path2770, _path2771, _path2772, _path2773, _path2774, _path2775, _path2776, _path2777, _path2778, _path2779, _path2780, _path2781, _path2782, _path2783, _path2784, _path2785, _path2786, _path2787, _path2788, _path2789, _path2790, _path2791, _path2792, _path2793, _path2794, _path2795, _path2796, _path2797, _path2798, _path2799, _path2800, _path2801, _path2802, _path2803, _path2804, _path2805, _path2806, _path2807, _path2808, _path2809, _path2810, _path2811, _path2812, _path2813, _path2814, _path2815, _path2816, _path2817, _path2818, _path2819, _path2820, _path2821, _path2822, _path2823, _path2824, _path2825, _path2826, _path2827, _path2828, _path2829, _path2830, _path2831, _path2832, _path2833, _path2834, _path2835, _path2836, _path2837, _path2838, _path2839, _path2840, _path2841, _path2842, _path2843, _path2844, _path2845, _path2846, _path2847, _path2848, _path2849, _path2850, _path2851, _path2852, _path2853, _path2854, _path2855, _path2856, _path2857, _path2858, _path2859, _path2860, _path2861, _path2862, _path2863, _path2864, _path2865, _path2866, _path2867, _path2868, _path2869, _path2870, _path2871, _path2872, _path2873, _path2874, _path2875, _path2876, _path2877, _path2878, _path2879, _path2880, _path2881, _path2882, _path2883, _path2884, _path2885, _path2886, _path2887, _path2888, _path2889, _path2890, _path2891, _path2892, _path2893, _path2894, _path2895, _path2896, _path2897, _path2898, _path2899, _path2900, _path2901, _path2902, _path2903, _path2904, _path2905, _path2906, _path2907, _path2908, _path2909, _path2910, _path2911, _path2912, _path2913, _path2914, _path2915, _path2916, _path2917, _path2918, _path2919, _path2920, _path2921, _path2922, _path2923, _path2924, _path2925, _path2926, _path2927, _path2928, _path2929, _path2930, _path2931, _path2932, _path2933, _path2934, _path2935, _path2936, _path2937, _path2938, _path2939, _path2940, _path2941, _path2942, _path2943, _path2944, _path2945, _path2946, _path2947, _path2948, _path2949, _path2950, _path2951, _path2952, _path2953, _path2954, _path2955, _path2956, _path2957, _path2958, _path2959, _path2960, _path2961, _path2962, _path2963, _path2964, _path2965, _path2966, _path2967, _path2968, _path2969, _path2970, _path2971, _path2972, _path2973, _path2974, _path2975, _path2976, _path2977, _path2978, _path2979, _path2980, _path2981, _path2982, _path2983, _path2984, _path2985, _path2986, _path2987, _path2988, _path2989, _path2990, _path2991, _path2992, _path2993, _path2994, _path2995, _path2996, _path2997, _path2998, _path2999, _path3000, _path3001, _path3002, _path3003, _path3004, _path3005, _path3006, _path3007, _path3008, _path3009, _path3010, _path3011, _path3012, _path3013, _path3014, _path3015, _path3016, _path3017, _path3018, _path3019, _path3020, _path3021, _path3022, _path3023, _path3024, _path3025, _path3026, _path3027, _path3028, _path3029, _path3030, _path3031, _path3032, _path3033, _path3034, _path3035, _path3036, _path3037, _path3038, _path3039, _path3040, _path3041, _path3042, _path3043, _path3044, _path3045, _path3046, _path3047, _path3048, _path3049, _path3050, _path3051, _path3052, _path3053, _path3054, _path3055, _path3056, _path3057, _path3058, _path3059, _path3060, _path3061, _path3062, _path3063, _path3064, _path3065, _path3066, _path3067, _path3068, _path3069, _path3070, _path3071, _path3072, _path3073, _path3074, _path3075, _path3076, _path3077, _path3078, _path3079, _path3080, _path3081, _path3082, _path3083, _path3084, _path3085, _path3086, _path3087, _path3088, _path3089, _path3090, _path3091, _path3092, _path3093, _path3094, _path3095, _path3096, _path3097, _path3098, _path3099, _path3100, _path3101, _path3102, _path3103, _path3104, _path3105, _path3106, _path3107, _path3108, _path3109, _path3110, _path3111, _path3112, _path3113, _path3114, _path3115, _path3116, _path3117, _path3118, _path3119, _path3120, _path3121, _path3122, _path3123, _path3124, _path3125, _path3126, _path3127, _path3128, _path3129, _path3130, _path3131, _path3132, _path3133, _path3134, _path3135, _path3136, _path3137, _path3138, _path3139, _path3140, _path3141, _path3142, _path3143, _path3144, _path3145, _path3146, _path3147, _path3148, _path3149, _path3150, _path3151, _path3152, _path3153, _path3154, _path3155, _path3156, _path3157, _path3158, _path3159, _path3160, _path3161, _path3162, _path3163, _path3164, _path3165, _path3166, _path3167, _path3168, _path3169, _path3170, _path3171, _path3172, _path3173, _path3174, _path3175, _path3176, _path3177, _path3178, _path3179, _path3180, _path3181, _path3182, _path3183, _path3184, _path3185, _path3186, _path3187, _path3188, _path3189, _path3190, _path3191, _path3192, _path3193, _path3194, _path3195, _path3196, _path3197, _path3198, _path3199, _path3200, _path3201, _path3202, _path3203, _path3204, _path3205, _path3206, _path3207, _path3208, _path3209, _path3210, _path3211, _path3212, _path3213, _path3214, _path3215, _path3216, _path3217, _path3218, _path3219, _path3220, _path3221, _path3222, _path3223, _path3224, _path3225, _path3226, _path3227, _path3228, _path3229, _path3230, _path3231, _path3232, _path3233, _path3234, _path3235, _path3236, _path3237, _path3238, _path3239, _path3240, _path3241, _path3242, _path3243, _path3244, _path3245, _path3246, _path3247, _path3248, _path3249, _path3250, _path3251, _path3252, _path3253, _path3254, _path3255, _path3256, _path3257, _path3258, _path3259, _path3260, _path3261, _path3262, _path3263, _path3264, _path3265, _path3266, _path3267, _path3268, _path3269, _path3270, _path3271, _path3272, _path3273, _path3274, _path3275, _path3276, _path3277, _path3278, _path3279, _path3280, _path3281, _path3282, _path3283, _path3284, _path3285, _path3286, _path3287, _path3288, _path3289, _path3290, _path3291, _path3292, _path3293, _path3294, _path3295, _path3296, _path3297, _path3298, _path3299, _path3300, _path3301, _path3302, _path3303, _path3304, _path3305, _path3306, _path3307, _path3308, _path3309, _path3310, _path3311, _path3312, _path3313, _path3314, _path3315, _path3316, _path3317, _path3318, _path3319, _path3320, _path3321, _path3322, _path3323, _path3324, _path3325, _path3326, _path3327, _path3328, _path3329, _path3330, _path3331, _path3332, _path3333, _path3334, _path3335, _path3336, _path3337, _path3338, _path3339, _path3340, _path3341, _path3342, _path3343, _path3344, _path3345, _path3346, _path3347, _path3348, _path3349, _path3350, _path3351, _path3352, _path3353, _path3354, _path3355, _path3356, _path3357, _path3358, _path3359, _path3360, _path3361, _path3362, _path3363, _path3364, _path3365, _path3366, _path3367, _path3368, _path3369, _path3370, _path3371, _path3372, _path3373, _path3374, _path3375, _path3376, _path3377, _path3378, _path3379, _path3380, _path3381, _path3382, _path3383, _path3384, _path3385, _path3386, _path3387, _path3388, _path3389, _path3390, _path3391, _path3392, _path3393, _path3394, _path3395, _path3396, _path3397, _path3398, _path3399, _path3400, _path3401, _path3402, _path3403, _path3404, _path3405, _path3406, _path3407, _path3408, _path3409, _path3410, _path3411, _path3412, _path3413, _path3414, _path3415, _path3416, _path3417, _path3418, _path3419, _path3420, _path3421, _path3422, _path3423, _path3424, _path3425, _path3426, _path3427, _path3428, _path3429, _path3430, _path3431, _path3432, _path3433, _path3434, _path3435, _path3436, _path3437, _path3438, _path3439, _path3440, _path3441, _path3442, _path3443, _path3444, _path3445, _path3446, _path3447, _path3448, _path3449, _path3450, _path3451, _path3452, _path3453, _path3454, _path3455, _path3456, _path3457, _path3458, _path3459, _path3460, _path3461, _path3462, _path3463, _path3464, _path3465, _path3466, _path3467, _path3468, _path3469, _path3470, _path3471, _path3472, _path3473, _path3474, _path3475, _path3476, _path3477, _path3478, _path3479, _path3480, _path3481, _path3482, _path3483, _path3484, _path3485, _path3486, _path3487, _path3488, _path3489, _path3490, _path3491, _path3492, _path3493, _path3494, _path3495, _path3496, _path3497, _path3498, _path3499, _path3500, _path3501, _path3502, _path3503, _path3504, _path3505, _path3506, _path3507, _path3508, _path3509, _path3510, _path3511, _path3512, _path3513, _path3514, _path3515, _path3516, _path3517, _path3518, _path3519, _path3520, _path3521, _path3522, _path3523, _path3524, _path3525, _path3526, _path3527, _path3528, _path3529, _path3530, _path3531, _path3532, _path3533, _path3534, _path3535, _path3536, _path3537, _path3538, _path3539, _path3540, _path3541, _path3542, _path3543, _path3544, _path3545, _path3546, _path3547, _path3548, _path3549, _path3550, _path3551, _path3552, _path3553, _path3554, _path3555, _path3556, _path3557, _path3558, _path3559, _path3560, _path3561, _path3562, _path3563, _path3564, _path3565, _path3566, _path3567, _path3568, _path3569, _path3570, _path3571, _path3572, _path3573, _path3574, _path3575, _path3576, _path3577, _path3578, _path3579, _path3580, _path3581, _path3582, _path3583, _path3584, _path3585, _path3586, _path3587, _path3588, _path3589, _path3590, _path3591, _path3592, _path3593, _path3594, _path3595, _path3596, _path3597, _path3598, _path3599, _path3600, _path3601, _path3602, _path3603, _path3604, _path3605, _path3606, _path3607, _path3608, _path3609, _path3610, _path3611, _path3612, _path3613, _path3614, _path3615, _path3616, _path3617, _path3618, _path3619, _path3620, _path3621, _path3622, _path3623, _path3624, _path3625, _path3626, _path3627, _path3628, _path3629, _path3630, _path3631, _path3632, _path3633, _path3634, _path3635, _path3636, _path3637, _path3638, _path3639, _path3640, _path3641, _path3642, _path3643, _path3644, _path3645, _path3646, _path3647, _path3648, _path3649, _path3650, _path3651, _path3652, _path3653, _path3654, _path3655, _path3656, _path3657, _path3658, _path3659, _path3660, _path3661, _path3662, _path3663, _path3664, _path3665, _path3666, _path3667, _path3668, _path3669, _path3670, _path3671, _path3672, _path3673, _path3674, _path3675, _path3676, _path3677, _path3678, _path3679, _path3680, _path3681, _path3682, _path3683, _path3684, _path3685, _path3686, _path3687, _path3688, _path3689, _path3690, _path3691, _path3692, _path3693, _path3694, _path3695, _path3696, _path3697, _path3698, _path3699, _path3700, _path3701, _path3702, _path3703, _path3704, _path3705, _path3706, _path3707, _path3708, _path3709, _path3710, _path3711, _path3712, _path3713, _path3714, _path3715, _path3716, _path3717, _path3718, _path3719, _path3720, _path3721, _path3722, _path3723, _path3724, _path3725, _path3726, _path3727, _path3728, _path3729, _path3730, _path3731, _path3732, _path3733, _path3734, _path3735, _path3736, _path3737, _path3738, _path3739, _path3740, _path3741, _path3742, _path3743, _path3744, _path3745, _path3746, _path3747, _path3748, _path3749, _path3750, _path3751, _path3752, _path3753, _path3754, _path3755, _path3756, _path3757, _path3758, _path3759, _path3760, _path3761, _path3762, _path3763, _path3764, _path3765, _path3766, _path3767, _path3768, _path3769, _path3770, _path3771, _path3772, _path3773, _path3774, _path3775, _path3776, _path3777, _path3778, _path3779, _path3780, _path3781, _path3782, _path3783, _path3784, _path3785, _path3786, _path3787, _path3788, _path3789, _path3790, _path3791, _path3792, _path3793, _path3794, _path3795, _path3796, _path3797, _path3798, _path3799, _path3800, _path3801, _path3802, _path3803, _path3804, _path3805, _path3806, _path3807, _path3808, _path3809, _path3810, _path3811, _path3812, _path3813, _path3814, _path3815, _path3816, _path3817, _path3818, _path3819, _path3820, _path3821, _path3822, _path3823, _path3824, _path3825, _path3826, _path3827, _path3828, _path3829, _path3830, _path3831, _path3832, _path3833, _path3834, _path3835, _path3836, _path3837, _path3838, _path3839, _path3840, _path3841, _path3842, _path3843, _path3844, _path3845, _path3846, _path3847, _path3848, _path3849, _path3850, _path3851, _path3852, _path3853, _path3854, _path3855, _path3856, _path3857, _path3858, _path3859, _path3860, _path3861, _path3862, _path3863, _path3864, _path3865, _path3866, _path3867, _path3868, _path3869, _path3870, _path3871, _path3872, _path3873, _path3874, _path3875, _path3876, _path3877, _path3878, _path3879, _path3880, _path3881, _path3882, _path3883, _path3884, _path3885, _path3886, _path3887, _path3888, _path3889, _path3890, _path3891, _path3892, _path3893, _path3894, _path3895, _path3896, _path3897, _path3898, _path3899, _path3900, _path3901, _path3902, _path3903, _path3904, _path3905, _path3906, _path3907, _path3908, _path3909, _path3910, _path3911, _path3912, _path3913, _path3914, _path3915, _path3916, _path3917, _path3918, _path3919, _path3920, _path3921, _path3922, _path3923, _path3924, _path3925, _path3926, _path3927, _path3928, _path3929, _path3930, _path3931, _path3932, _path3933, _path3934, _path3935, _path3936, _path3937, _path3938, _path3939, _path3940, _path3941, _path3942, _path3943, _path3944, _path3945, _path3946, _path3947, _path3948, _path3949, _path3950, _path3951, _path3952, _path3953, _path3954, _path3955, _path3956, _path3957, _path3958, _path3959, _path3960, _path3961, _path3962, _path3963, _path3964, _path3965, _path3966, _path3967, _path3968, _path3969, _path3970, _path3971, _path3972, _path3973, _path3974, _path3975, _path3976, _path3977, _path3978, _path3979, _path3980, _path3981, _path3982, _path3983, _path3984, _path3985, _path3986, _path3987, _path3988, _path3989, _path3990, _path3991, _path3992, _path3993, _path3994, _path3995, _path3996, _path3997, _path3998, _path3999, _path4000, _path4001, _path4002, _path4003, _path4004, _path4005, _path4006, _path4007, _path4008, _path4009, _path4010, _path4011, _path4012, _path4013, _path4014, _path4015, _path4016, _path4017, _path4018, _path4019, _path4020, _path4021, _path4022, _path4023, _path4024, _path4025, _path4026, _path4027, _path4028, _path4029, _path4030, _path4031, _path4032, _path4033, _path4034, _path4035, _path4036, _path4037, _path4038, _path4039, _path4040, _path4041, _path4042, _path4043, _path4044, _path4045, _path4046, _path4047, _path4048, _path4049, _path4050, _path4051, _path4052, _path4053, _path4054, _path4055, _path4056, _path4057, _path4058, _path4059, _path4060, _path4061, _path4062, _path4063, _path4064, _path4065, _path4066, _path4067, _path4068, _path4069, _path4070, _path4071, _path4072, _path4073, _path4074, _path4075, _path4076, _path4077, _path4078, _path4079, _path4080, _path4081, _path4082, _path4083, _path4084, _path4085, _path4086, _path4087, _path4088, _path4089, _path4090, _path4091, _path4092, _path4093, _path4094, _path4095, _path4096, _path4097, _path4098, _path4099, _path4100, _path4101, _path4102, _path4103, _path4104, _path4105, _path4106, _path4107, _path4108, _path4109, _path4110, _path4111, _path4112, _path4113, _path4114, _path4115, _path4116, _path4117, _path4118, _path4119, _path4120, _path4121, _path4122, _path4123, _path4124, _path4125, _path4126, _path4127, _path4128, _path4129, _path4130, _path4131, _path4132, _path4133, _path4134, _path4135, _path4136, _path4137, _path4138, _path4139, _path4140, _path4141, _path4142, _path4143, _path4144, _path4145, _path4146, _path4147, _path4148, _path4149, _path4150, _path4151, _path4152, _path4153, _path4154, _path4155, _path4156, _path4157, _path4158, _path4159, _path4160, _path4161, _path4162, _path4163, _path4164, _path4165, _path4166, _path4167, _path4168, _path4169, _path4170, _path4171, _path4172, _path4173, _path4174, _path4175, _path4176, _path4177, _path4178, _path4179, _path4180, _path4181, _path4182, _path4183, _path4184, _path4185, _path4186, _path4187, _path4188, _path4189, _path4190, _path4191, _path4192, _path4193, _path4194, _path4195, _path4196, _path4197, _path4198, _path4199, _path4200, _path4201, _path4202, _path4203, _path4204, _path4205, _path4206, _path4207, _path4208, _path4209, _path4210, _path4211, _path4212, _path4213, _path4214, _path4215, _path4216, _path4217, _path4218, _path4219, _path4220, _path4221, _path4222, _path4223, _path4224, _path4225, _path4226, _path4227, _path4228, _path4229, _path4230, _path4231, _path4232, _path4233, _path4234, _path4235, _path4236, _path4237, _path4238, _path4239, _path4240, _path4241, _path4242, _path4243, _path4244, _path4245, _path4246, _path4247, _path4248, _path4249, _path4250, _path4251, _path4252, _path4253, _path4254, _path4255, _path4256, _path4257, _path4258, _path4259, _path4260, _path4261, _path4262, _path4263, _path4264, _path4265, _path4266, _path4267, _path4268, _path4269, _path4270, _path4271, _path4272, _path4273, _path4274, _path4275, _path4276, _path4277, _path4278, _path4279, _path4280, _path4281, _path4282, _path4283, _path4284, _path4285, _path4286, _path4287, _path4288, _path4289, _path4290, _path4291, _path4292, _path4293, _path4294, _path4295, _path4296, _path4297, _path4298, _path4299, _path4300, _path4301, _path4302, _path4303, _path4304, _path4305, _path4306, _path4307, _path4308, _path4309, _path4310, _path4311, _path4312, _path4313, _path4314, _path4315, _path4316, _path4317, _path4318, _path4319, _path4320, _path4321, _path4322, _path4323, _path4324, _path4325, _path4326, _path4327, _path4328, _path4329, _path4330, _path4331, _path4332, _path4333, _path4334, _path4335, _path4336, _path4337, _path4338, _path4339, _path4340, _path4341, _path4342, _path4343, _path4344, _path4345, _path4346, _path4347, _path4348, _path4349, _path4350, _path4351, _path4352, _path4353, _path4354, _path4355, _path4356, _path4357, _path4358, _path4359, _path4360, _path4361, _path4362, _path4363, _path4364, _path4365, _path4366, _path4367, _path4368, _path4369, _path4370, _path4371, _path4372, _path4373, _path4374, _path4375, _path4376, _path4377, _path4378, _path4379, _path4380, _path4381, _path4382, _path4383, _path4384, _path4385, _path4386, _path4387, _path4388, _path4389, _path4390, _path4391, _path4392, _path4393, _path4394, _path4395, _path4396, _path4397, _path4398, _path4399, _path4400, _path4401, _path4402, _path4403, _path4404, _path4405, _path4406, _path4407, _path4408, _path4409, _path4410, _path4411, _path4412, _path4413, _path4414, _path4415, _path4416, _path4417, _path4418, _path4419, _path4420, _path4421, _path4422, _path4423, _path4424, _path4425, _path4426, _path4427, _path4428, _path4429, _path4430, _path4431, _path4432, _path4433, _path4434, _path4435, _path4436, _path4437, _path4438, _path4439, _path4440, _path4441, _path4442, _path4443, _path4444, _path4445, _path4446, _path4447, _path4448, _path4449, _path4450, _path4451, _path4452, _path4453, _path4454, _path4455, _path4456, _path4457, _path4458, _path4459, _path4460, _path4461, _path4462, _path4463, _path4464, _path4465, _path4466, _path4467, _path4468, _path4469, _path4470, _path4471, _path4472, _path4473, _path4474, _path4475, _path4476, _path4477, _path4478, _path4479, _path4480, _path4481, _path4482, _path4483, _path4484, _path4485, _path4486, _path4487, _path4488, _path4489, _path4490, _path4491, _path4492, _path4493, _path4494, _path4495, _path4496, _path4497, _path4498, _path4499, _path4500, _path4501, _path4502, _path4503, _path4504, _path4505, _path4506, _path4507, _path4508, _path4509, _path4510, _path4511, _path4512, _path4513, _path4514, _path4515, _path4516, _path4517, _path4518, _path4519, _path4520, _path4521, _path4522, _path4523, _path4524, _path4525, _path4526, _path4527, _path4528, _path4529, _path4530, _path4531, _path4532, _path4533, _path4534, _path4535, _path4536, _path4537, _path4538, _path4539, _path4540, _path4541, _path4542, _path4543, _path4544, _path4545, _path4546, _path4547, _path4548, _path4549, _path4550, _path4551, _path4552, _path4553, _path4554, _path4555, _path4556, _path4557, _path4558, _path4559, _path4560, _path4561, _path4562, _path4563, _path4564, _path4565, _path4566, _path4567, _path4568, _path4569, _path4570, _path4571, _path4572, _path4573, _path4574, _path4575, _path4576, _path4577, _path4578, _path4579, _path4580, _path4581, _path4582, _path4583, _path4584, _path4585, _path4586, _path4587, _path4588, _path4589, _path4590, _path4591, _path4592, _path4593, _path4594, _path4595, _path4596, _path4597, _path4598, _path4599, _path4600, _path4601, _path4602, _path4603, _path4604, _path4605, _path4606, _path4607, _path4608, _path4609, _path4610, _path4611, _path4612, _path4613, _path4614, _path4615, _path4616, _path4617, _path4618, _path4619, _path4620, _path4621, _path4622, _path4623, _path4624, _path4625, _path4626, _path4627, _path4628, _path4629, _path4630, _path4631, _path4632, _path4633, _path4634, _path4635, _path4636, _path4637, _path4638, _path4639, _path4640, _path4641, _path4642, _path4643, _path4644, _path4645, _path4646, _path4647, _path4648, _path4649, _path4650, _path4651, _path4652, _path4653, _path4654, _path4655, _path4656, _path4657, _path4658, _path4659, _path4660, _path4661, _path4662, _path4663, _path4664, _path4665, _path4666, _path4667, _path4668, _path4669, _path4670, _path4671, _path4672, _path4673, _path4674, _path4675, _path4676, _path4677, _path4678, _path4679, _path4680, _path4681, _path4682, _path4683, _path4684, _path4685, _path4686, _path4687, _path4688, _path4689, _path4690, _path4691, _path4692, _path4693, _path4694, _path4695, _path4696, _path4697, _path4698, _path4699, _path4700, _path4701, _path4702, _path4703, _path4704, _path4705, _path4706, _path4707, _path4708, _path4709, _path4710, _path4711, _path4712, _path4713, _path4714, _path4715, _path4716, _path4717, _path4718, _path4719, _path4720, _path4721, _path4722, _path4723, _path4724, _path4725, _path4726, _path4727, _path4728, _path4729, _path4730, _path4731, _path4732, _path4733, _path4734, _path4735, _path4736, _path4737, _path4738, _path4739, _path4740, _path4741, _path4742, _path4743, _path4744, _path4745, _path4746, _path4747, _path4748, _path4749, _path4750, _path4751, _path4752, _path4753, _path4754, _path4755, _path4756, _path4757, _path4758, _path4759, _path4760, _path4761, _path4762, _path4763, _path4764, _path4765, _path4766, _path4767, _path4768, _path4769, _path4770, _path4771, _path4772, _path4773, _path4774, _path4775, _path4776, _path4777, _path4778, _path4779, _path4780, _path4781, _path4782, _path4783, _path4784, _path4785, _path4786, _path4787, _path4788, _path4789, _path4790, _path4791, _path4792, _path4793, _path4794, _path4795, _path4796, _path4797, _path4798, _path4799, _path4800, _path4801, _path4802, _path4803, _path4804, _path4805, _path4806, _path4807, _path4808, _path4809, _path4810, _path4811, _path4812, _path4813, _path4814, _path4815, _path4816, _path4817, _path4818, _path4819, _path4820, _path4821, _path4822, _path4823, _path4824, _path4825, _path4826, _path4827, _path4828, _path4829, _path4830, _path4831, _path4832, _path4833, _path4834, _path4835, _path4836, _path4837, _path4838, _path4839, _path4840, _path4841, _path4842, _path4843, _path4844, _path4845, _path4846, _path4847, _path4848, _path4849, _path4850, _path4851, _path4852, _path4853, _path4854, _path4855, _path4856, _path4857, _path4858, _path4859, _path4860, _path4861, _path4862, _path4863, _path4864, _path4865, _path4866, _path4867, _path4868, _path4869, _path4870, _path4871, _path4872, _path4873, _path4874, _path4875, _path4876, _path4877, _path4878, _path4879, _path4880, _path4881, _path4882, _path4883, _path4884, _path4885, _path4886, _path4887, _path4888, _path4889, _path4890, _path4891, _path4892, _path4893, _path4894, _path4895, _path4896, _path4897, _path4898, _path4899, _path4900, _path4901, _path4902, _path4903, _path4904, _path4905, _path4906, _path4907, _path4908, _path4909, _path4910, _path4911, _path4912, _path4913, _path4914, _path4915, _path4916, _path4917, _path4918, _path4919, _path4920, _path4921, _path4922, _path4923, _path4924, _path4925, _path4926, _path4927, _path4928, _path4929, _path4930, _path4931, _path4932, _path4933, _path4934, _path4935, _path4936, _path4937, _path4938, _path4939, _path4940, _path4941, _path4942, _path4943, _path4944, _path4945, _path4946, _path4947, _path4948, _path4949, _path4950, _path4951, _path4952, _path4953, _path4954, _path4955, _path4956, _path4957, _path4958, _path4959, _path4960, _path4961, _path4962, _path4963, _path4964, _path4965, _path4966, _path4967, _path4968, _path4969, _path4970, _path4971, _path4972, _path4973, _path4974, _path4975, _path4976, _path4977, _path4978, _path4979, _path4980, _path4981, _path4982, _path4983, _path4984, _path4985, _path4986, _path4987, _path4988, _path4989, _path4990, _path4991, _path4992, _path4993, _path4994, _path4995, _path4996, _path4997, _path4998, _path4999, _path5000, _path5001, _path5002, _path5003, _path5004, _path5005, _path5006, _path5007, _path5008, _path5009, _path5010, _path5011, _path5012, _path5013, _path5014, _path5015, _path5016, _path5017, _path5018, _path5019, _path5020, _path5021, _path5022, _path5023, _path5024, _path5025, _path5026, _path5027, _path5028, _path5029, _path5030, _path5031, _path5032, _path5033, _path5034, _path5035, _path5036, _path5037, _path5038, _path5039, _path5040, _path5041, _path5042, _path5043, _path5044, _path5045, _path5046, _path5047, _path5048, _path5049, _path5050, _path5051, _path5052, _path5053, _path5054, _path5055, _path5056, _path5057, _path5058, _path5059, _path5060, _path5061, _path5062, _path5063, _path5064, _path5065, _path5066, _path5067, _path5068, _path5069, _path5070, _path5071, _path5072, _path5073, _path5074, _path5075, _path5076, _path5077, _path5078, _path5079, _path5080, _path5081, _path5082, _path5083, _path5084, _path5085, _path5086, _path5087, _path5088, _path5089, _path5090, _path5091, _path5092, _path5093, _path5094, _path5095, _path5096, _path5097, _path5098, _path5099, _path5100, _path5101, _path5102, _path5103, _path5104, _path5105, _path5106, _path5107, _path5108, _path5109, _path5110, _path5111, _path5112, _path5113, _path5114, _path5115, _path5116, _path5117, _path5118, _path5119, _path5120, _path5121, _path5122, _path5123, _path5124, _path5125, _path5126, _path5127, _path5128, _path5129, _path5130, _path5131, _path5132, _path5133, _path5134, _path5135, _path5136, _path5137, _path5138, _path5139, _path5140, _path5141, _path5142, _path5143, _path5144, _path5145, _path5146, _path5147, _path5148, _path5149, _path5150, _path5151, _path5152, _path5153, _path5154, _path5155, _path5156, _path5157, _path5158, _path5159, _path5160, _path5161, _path5162, _path5163, _path5164, _path5165, _path5166, _path5167, _path5168, _path5169, _path5170, _path5171, _path5172, _path5173, _path5174, _path5175, _path5176, _path5177, _path5178, _path5179, _path5180, _path5181, _path5182, _path5183, _path5184, _path5185, _path5186, _path5187, _path5188, _path5189, _path5190, _path5191, _path5192, _path5193, _path5194, _path5195, _path5196, _path5197, _path5198, _path5199, _path5200, _path5201, _path5202, _path5203, _path5204, _path5205, _path5206, _path5207, _path5208, _path5209, _path5210, _path5211, _path5212, _path5213, _path5214, _path5215, _path5216, _path5217, _path5218, _path5219, _path5220, _path5221, _path5222, _path5223, _path5224, _path5225, _path5226, _path5227, _path5228, _path5229, _path5230, _path5231, _path5232, _path5233, _path5234, _path5235, _path5236, _path5237, _path5238, _path5239, _path5240, _path5241, _path5242, _path5243, _path5244, _path5245, _path5246, _path5247, _path5248, _path5249, _path5250, _path5251, _path5252, _path5253, _path5254, _path5255, _path5256, _path5257, _path5258, _path5259, _path5260, _path5261, _path5262, _path5263, _path5264, _path5265, _path5266, _path5267, _path5268, _path5269, _path5270, _path5271, _path5272, _path5273, _path5274, _path5275, _path5276, _path5277, _path5278, _path5279, _path5280, _path5281, _path5282, _path5283, _path5284, _path5285, _path5286, _path5287, _path5288, _path5289, _path5290, _path5291, _path5292, _path5293, _path5294, _path5295, _path5296, _path5297, _path5298, _path5299, _path5300, _path5301, _path5302, _path5303, _path5304, _path5305, _path5306, _path5307, _path5308, _path5309, _path5310, _path5311, _path5312, _path5313, _path5314, _path5315, _path5316, _path5317, _path5318, _path5319, _path5320, _path5321, _path5322, _path5323, _path5324, _path5325, _path5326, _path5327, _path5328, _path5329, _path5330, _path5331, _path5332, _path5333, _path5334, _path5335, _path5336, _path5337, _path5338, _path5339, _path5340, _path5341, _path5342, _path5343, _path5344, _path5345, _path5346, _path5347, _path5348, _path5349, _path5350, _path5351, _path5352, _path5353, _path5354, _path5355, _path5356, _path5357, _path5358, _path5359, _path5360, _path5361, _path5362, _path5363, _path5364, _path5365, _path5366, _path5367, _path5368, _path5369, _path5370, _path5371, _path5372, _path5373, _path5374, _path5375, _path5376, _path5377, _path5378, _path5379, _path5380, _path5381, _path5382, _path5383, _path5384, _path5385, _path5386, _path5387, _path5388, _path5389, _path5390, _path5391, _path5392, _path5393, _path5394, _path5395, _path5396, _path5397, _path5398, _path5399, _path5400, _path5401, _path5402, _path5403, _path5404, _path5405, _path5406, _path5407, _path5408, _path5409, _path5410, _path5411, _path5412, _path5413, _path5414, _path5415, _path5416, _path5417, _path5418, _path5419, _path5420, _path5421, _path5422, _path5423, _path5424, _path5425, _path5426, _path5427, _path5428, _path5429, _path5430, _path5431, _path5432, _path5433, _path5434, _path5435, _path5436, _path5437, _path5438, _path5439, _path5440, _path5441, _path5442, _path5443, _path5444, _path5445, _path5446, _path5447, _path5448, _path5449, _path5450, _path5451, _path5452, _path5453, _path5454, _path5455, _path5456, _path5457, _path5458, _path5459, _path5460, _path5461, _path5462, _path5463, _path5464, _path5465, _path5466, _path5467, _path5468, _path5469, _path5470, _path5471, _path5472, _path5473, _path5474, _path5475, _path5476, _path5477, _path5478, _path5479, _path5480, _path5481, _path5482, _path5483, _path5484, _path5485, _path5486, _path5487, _path5488, _path5489, _path5490, _path5491, _path5492, _path5493, _path5494, _path5495, _path5496, _path5497, _path5498, _path5499, _path5500, _path5501, _path5502, _path5503, _path5504, _path5505, _path5506, _path5507, _path5508, _path5509, _path5510, _path5511, _path5512, _path5513, _path5514, _path5515, _path5516, _path5517, _path5518, _path5519, _path5520, _path5521, _path5522, _path5523, _path5524, _path5525, _path5526, _path5527, _path5528, _path5529, _path5530, _path5531, _path5532, _path5533, _path5534, _path5535, _path5536, _path5537, _path5538, _path5539, _path5540, _path5541, _path5542, _path5543, _path5544, _path5545, _path5546, _path5547, _path5548, _path5549, _path5550, _path5551, _path5552, _path5553, _path5554, _path5555, _path5556, _path5557, _path5558, _path5559, _path5560, _path5561, _path5562, _path5563, _path5564, _path5565, _path5566, _path5567, _path5568, _path5569, _path5570, _path5571, _path5572, _path5573, _path5574, _path5575, _path5576, _path5577, _path5578, _path5579, _path5580, _path5581, _path5582, _path5583, _path5584, _path5585, _path5586, _path5587, _path5588, _path5589, _path5590, _path5591, _path5592, _path5593, _path5594, _path5595, _path5596, _path5597, _path5598, _path5599, _path5600, _path5601, _path5602, _path5603, _path5604, _path5605, _path5606, _path5607, _path5608, _path5609, _path5610, _path5611, _path5612, _path5613, _path5614, _path5615, _path5616, _path5617, _path5618, _path5619, _path5620, _path5621, _path5622, _path5623, _path5624, _path5625, _path5626, _path5627, _path5628, _path5629, _path5630, _path5631, _path5632, _path5633, _path5634, _path5635, _path5636, _path5637, _path5638, _path5639, _path5640, _path5641, _path5642, _path5643, _path5644, _path5645, _path5646, _path5647, _path5648, _path5649, _path5650, _path5651, _path5652, _path5653, _path5654, _path5655, _path5656, _path5657, _path5658, _path5659, _path5660, _path5661, _path5662, _path5663, _path5664, _path5665, _path5666, _path5667, _path5668, _path5669, _path5670, _path5671, _path5672, _path5673, _path5674, _path5675, _path5676, _path5677, _path5678, _path5679, _path5680, _path5681, _path5682, _path5683, _path5684, _path5685, _path5686, _path5687, _path5688, _path5689, _path5690, _path5691, _path5692, _path5693, _path5694, _path5695, _path5696, _path5697, _path5698, _path5699, _path5700, _path5701, _path5702, _path5703, _path5704, _path5705, _path5706, _path5707, _path5708, _path5709, _path5710, _path5711, _path5712, _path5713, _path5714, _path5715, _path5716, _path5717, _path5718, _path5719, _path5720, _path5721, _path5722, _path5723, _path5724, _path5725, _path5726, _path5727, _path5728, _path5729, _path5730, _path5731, _path5732, _path5733, _path5734, _path5735, _path5736, _path5737, _path5738, _path5739, _path5740, _path5741, _path5742, _path5743, _path5744, _path5745, _path5746, _path5747, _path5748, _path5749, _path5750, _path5751, _path5752, _path5753, _path5754, _path5755, _path5756, _path5757, _path5758, _path5759, _path5760, _path5761, _path5762, _path5763, _path5764, _path5765, _path5766, _path5767, _path5768, _path5769, _path5770, _path5771, _path5772, _path5773, _path5774, _path5775, _path5776, _path5777, _path5778, _path5779, _path5780, _path5781, _path5782, _path5783, _path5784, _path5785, _path5786, _path5787, _path5788, _path5789, _path5790, _path5791, _path5792, _path5793, _path5794, _path5795, _path5796, _path5797, _path5798, _path5799, _path5800, _path5801, _path5802, _path5803, _path5804, _path5805, _path5806, _path5807, _path5808, _path5809, _path5810, _path5811, _path5812, _path5813, _path5814, _path5815, _path5816, _path5817, _path5818, _path5819, _path5820, _path5821, _path5822, _path5823, _path5824, _path5825, _path5826, _path5827, _path5828, _path5829, _path5830, _path5831, _path5832, _path5833, _path5834, _path5835, _path5836, _path5837, _path5838, _path5839, _path5840, _path5841, _path5842, _path5843, _path5844, _path5845, _path5846, _path5847, _path5848, _path5849, _path5850, _path5851, _path5852, _path5853, _path5854, _path5855, _path5856, _path5857, _path5858, _path5859, _path5860, _path5861, _path5862, _path5863, _path5864, _path5865, _path5866, _path5867, _path5868, _path5869, _path5870, _path5871, _path5872, _path5873, _path5874, _path5875, _path5876, _path5877, _path5878, _path5879, _path5880, _path5881, _path5882, _path5883, _path5884, _path5885, _path5886, _path5887, _path5888, _path5889, _path5890, _path5891, _path5892, _path5893, _path5894, _path5895, _path5896, _path5897, _path5898, _path5899, _path5900, _path5901, _path5902, _path5903, _path5904, _path5905, _path5906, _path5907, _path5908, _path5909, _path5910, _path5911, _path5912, _path5913, _path5914, _path5915, _path5916, _path5917, _path5918, _path5919, _path5920, _path5921, _path5922, _path5923, _path5924, _path5925, _path5926, _path5927, _path5928, _path5929, _path5930, _path5931, _path5932, _path5933, _path5934, _path5935, _path5936, _path5937, _path5938, _path5939, _path5940, _path5941, _path5942, _path5943, _path5944, _path5945, _path5946, _path5947, _path5948, _path5949, _path5950, _path5951, _path5952, _path5953, _path5954, _path5955, _path5956, _path5957, _path5958, _path5959, _path5960, _path5961, _path5962, _path5963, _path5964, _path5965, _path5966, _path5967, _path5968, _path5969, _path5970, _path5971, _path5972, _path5973, _path5974, _path5975, _path5976, _path5977, _path5978, _path5979, _path5980, _path5981, _path5982, _path5983, _path5984, _path5985, _path5986, _path5987, _path5988, _path5989, _path5990, _path5991, _path5992, _path5993, _path5994, _path5995, _path5996, _path5997, _path5998, _path5999, _path6000, _path6001, _path6002, _path6003, _path6004, _path6005, _path6006, _path6007, _path6008, _path6009, _path6010, _path6011, _path6012, _path6013, _path6014, _path6015, _path6016, _path6017, _path6018, _path6019, _path6020, _path6021, _path6022, _path6023, _path6024, _path6025, _path6026, _path6027, _path6028, _path6029, _path6030, _path6031, _path6032, _path6033, _path6034, _path6035, _path6036, _path6037, _path6038, _path6039, _path6040, _path6041, _path6042, _path6043, _path6044, _path6045, _path6046, _path6047, _path6048, _path6049, _path6050, _path6051, _path6052, _path6053, _path6054, _path6055, _path6056, _path6057, _path6058, _path6059, _path6060, _path6061, _path6062, _path6063, _path6064, _path6065, _path6066, _path6067, _path6068, _path6069, _path6070, _path6071, _path6072, _path6073, _path6074, _path6075, _path6076, _path6077, _path6078, _path6079, _path6080, _path6081, _path6082, _path6083, _path6084, _path6085, _path6086, _path6087, _path6088, _path6089, _path6090, _path6091, _path6092, _path6093, _path6094, _path6095, _path6096, _path6097, _path6098, _path6099, _path6100, _path6101, _path6102, _path6103, _path6104, _path6105, _path6106, _path6107, _path6108, _path6109, _path6110, _path6111, _path6112, _path6113, _path6114, _path6115, _path6116, _path6117, _path6118, _path6119, _path6120, _path6121, _path6122, _path6123, _path6124, _path6125, _path6126, _path6127, _path6128, _path6129, _path6130, _path6131, _path6132, _path6133, _path6134, _path6135, _path6136, _path6137, _path6138, _path6139, _path6140, _path6141, _path6142, _path6143, _path6144, _path6145, _path6146, _path6147, _path6148, _path6149, _path6150, _path6151, _path6152, _path6153, _path6154, _path6155, _path6156, _path6157, _path6158, _path6159, _path6160, _path6161, _path6162, _path6163, _path6164, _path6165, _path6166, _path6167, _path6168, _path6169, _path6170, _path6171, _path6172, _path6173, _path6174, _path6175, _path6176, _path6177, _path6178, _path6179, _path6180, _path6181, _path6182, _path6183, _path6184, _path6185, _path6186, _path6187, _path6188, _path6189, _path6190, _path6191, _path6192, _path6193, _path6194, _path6195, _path6196, _path6197, _path6198, _path6199, _path6200, _path6201, _path6202, _path6203, _path6204, _path6205, _path6206, _path6207, _path6208, _path6209, _path6210, _path6211, _path6212, _path6213, _path6214, _path6215, _path6216, _path6217, _path6218, _path6219, _path6220, _path6221, _path6222, _path6223, _path6224, _path6225, _path6226, _path6227, _path6228, _path6229, _path6230, _path6231, _path6232, _path6233, _path6234, _path6235, _path6236, _path6237, _path6238, _path6239, _path6240, _path6241, _path6242, _path6243, _path6244, _path6245, _path6246, _path6247, _path6248, _path6249, _path6250, _path6251, _path6252, _path6253, _path6254, _path6255, _path6256, _path6257, _path6258, _path6259, _path6260, _path6261, _path6262, _path6263, _path6264, _path6265, _path6266, _path6267, _path6268, _path6269, _path6270, _path6271, _path6272, _path6273, _path6274, _path6275, _path6276, _path6277, _path6278, _path6279, _path6280, _path6281, _path6282, _path6283, _path6284, _path6285, _path6286, _path6287, _path6288, _path6289, _path6290, _path6291, _path6292, _path6293, _path6294, _path6295, _path6296, _path6297, _path6298, _path6299, _path6300, _path6301, _path6302, _path6303, _path6304, _path6305, _path6306, _path6307, _path6308, _path6309, _path6310, _path6311, _path6312, _path6313, _path6314, _path6315, _path6316, _path6317, _path6318, _path6319, _path6320, _path6321, _path6322, _path6323, _path6324, _path6325, _path6326, _path6327, _path6328, _path6329, _path6330, _path6331, _path6332, _path6333, _path6334, _path6335, _path6336, _path6337, _path6338, _path6339, _path6340, _path6341, _path6342, _path6343, _path6344, _path6345, _path6346, _path6347, _path6348, _path6349, _path6350, _path6351, _path6352, _path6353, _path6354, _path6355, _path6356, _path6357, _path6358, _path6359, _path6360, _path6361, _path6362, _path6363, _path6364, _path6365, _path6366, _path6367, _path6368, _path6369, _path6370, _path6371, _path6372, _path6373, _path6374, _path6375, _path6376, _path6377, _path6378, _path6379, _path6380, _path6381, _path6382, _path6383, _path6384, _path6385, _path6386, _path6387, _path6388, _path6389, _path6390, _path6391, _path6392, _path6393, _path6394, _path6395, _path6396, _path6397, _path6398, _path6399, _path6400, _path6401, _path6402, _path6403, _path6404, _path6405, _path6406, _path6407, _path6408, _path6409, _path6410, _path6411, _path6412, _path6413, _path6414, _path6415, _path6416, _path6417, _path6418, _path6419, _path6420, _path6421, _path6422, _path6423, _path6424, _path6425, _path6426, _path6427, _path6428, _path6429, _path6430, _path6431, _path6432, _path6433, _path6434, _path6435, _path6436, _path6437, _path6438, _path6439, _path6440, _path6441, _path6442, _path6443, _path6444, _path6445, _path6446, _path6447, _path6448, _path6449, _path6450, _path6451, _path6452, _path6453, _path6454, _path6455, _path6456, _path6457, _path6458, _path6459, _path6460, _path6461, _path6462, _path6463, _path6464, _path6465, _path6466, _path6467, _path6468, _path6469, _path6470, _path6471, _path6472, _path6473, _path6474, _path6475, _path6476, _path6477, _path6478, _path6479, _path6480, _path6481, _path6482, _path6483, _path6484, _path6485, _path6486, _path6487, _path6488, _path6489, _path6490, _path6491, _path6492, _path6493, _path6494, _path6495, _path6496, _path6497, _path6498, _path6499, _path6500, _path6501, _path6502, _path6503, _path6504, _path6505, _path6506, _path6507, _path6508, _path6509, _path6510, _path6511, _path6512, _path6513, _path6514, _path6515, _path6516, _path6517, _path6518, _path6519, _path6520, _path6521, _path6522, _path6523, _path6524, _path6525, _path6526, _path6527, _path6528, _path6529, _path6530, _path6531, _path6532, _path6533, _path6534, _path6535, _path6536, _path6537, _path6538, _path6539, _path6540, _path6541, _path6542, _path6543, _path6544, _path6545, _path6546, _path6547, _path6548, _path6549, _path6550, _path6551, _path6552, _path6553, _path6554, _path6555, _path6556, _path6557, _path6558, _path6559, _path6560, _path6561, _path6562, _path6563, _path6564, _path6565, _path6566, _path6567, _path6568, _path6569, _path6570, _path6571, _path6572, _path6573, _path6574, _path6575, _path6576, _path6577, _path6578, _path6579, _path6580, _path6581, _path6582, _path6583, _path6584, _path6585, _path6586, _path6587, _path6588, _path6589, _path6590, _path6591, _path6592, _path6593, _path6594, _path6595, _path6596, _path6597, _path6598, _path6599, _path6600, _path6601, _path6602, _path6603, _path6604, _path6605, _path6606, _path6607, _path6608, _path6609, _path6610, _path6611, _path6612, _path6613, _path6614, _path6615, _path6616, _path6617, _path6618, _path6619, _path6620, _path6621, _path6622, _path6623, _path6624, _path6625, _path6626, _path6627, _path6628, _path6629, _path6630, _path6631, _path6632, _path6633, _path6634, _path6635, _path6636, _path6637, _path6638, _path6639, _path6640, _path6641, _path6642, _path6643, _path6644, _path6645, _path6646, _path6647, _path6648, _path6649, _path6650, _path6651, _path6652, _path6653, _path6654, _path6655, _path6656, _path6657, _path6658, _path6659, _path6660, _path6661, _path6662, _path6663, _path6664, _path6665, _path6666, _path6667, _path6668, _path6669, _path6670, _path6671, _path6672, _path6673, _path6674, _path6675, _path6676, _path6677, _path6678, _path6679, _path6680, _path6681, _path6682, _path6683, _path6684, _path6685, _path6686, _path6687, _path6688, _path6689, _path6690, _path6691, _path6692, _path6693, _path6694, _path6695, _path6696, _path6697, _path6698, _path6699, _path6700, _path6701, _path6702, _path6703, _path6704, _path6705, _path6706, _path6707, _path6708, _path6709, _path6710, _path6711, _path6712, _path6713, _path6714, _path6715, _path6716, _path6717, _path6718, _path6719, _path6720, _path6721, _path6722, _path6723, _path6724, _path6725, _path6726, _path6727, _path6728, _path6729, _path6730, _path6731, _path6732, _path6733, _path6734, _path6735, _path6736, _path6737, _path6738, _path6739, _path6740, _path6741, _path6742, _path6743, _path6744, _path6745, _path6746, _path6747, _path6748, _path6749, _path6750, _path6751, _path6752, _path6753, _path6754, _path6755, _path6756, _path6757, _path6758, _path6759, _path6760, _path6761, _path6762, _path6763, _path6764, _path6765, _path6766, _path6767, _path6768, _path6769, _path6770, _path6771, _path6772, _path6773, _path6774, _path6775, _path6776, _path6777, _path6778, _path6779, _path6780, _path6781, _path6782, _path6783, _path6784, _path6785, _path6786, _path6787, _path6788, _path6789, _path6790, _path6791, _path6792, _path6793, _path6794, _path6795, _path6796, _path6797, _path6798, _path6799, _path6800, _path6801, _path6802, _path6803, _path6804, _path6805, _path6806, _path6807, _path6808, _path6809, _path6810, _path6811, _path6812, _path6813, _path6814, _path6815, _path6816, _path6817, _path6818, _path6819, _path6820, _path6821, _path6822, _path6823, _path6824, _path6825, _path6826, _path6827, _path6828, _path6829, _path6830, _path6831, _path6832, _path6833, _path6834, _path6835, _path6836, _path6837, _path6838, _path6839, _path6840, _path6841, _path6842, _path6843, _path6844, _path6845, _path6846, _path6847, _path6848, _path6849, _path6850, _path6851, _path6852, _path6853, _path6854, _path6855, _path6856, _path6857, _path6858, _path6859, _path6860, _path6861, _path6862, _path6863, _path6864, _path6865, _path6866, _path6867, _path6868, _path6869, _path6870, _path6871, _path6872, _path6873, _path6874, _path6875, _path6876, _path6877, _path6878, _path6879, _path6880, _path6881, _path6882, _path6883, _path6884, _path6885, _path6886, _path6887, _path6888, _path6889, _path6890, _path6891, _path6892, _path6893, _path6894, _path6895, _path6896, _path6897, _path6898, _path6899, _path6900, _path6901, _path6902, _path6903, _path6904, _path6905, _path6906, _path6907, _path6908, _path6909, _path6910, _path6911, _path6912, _path6913, _path6914, _path6915, _path6916, _path6917, _path6918, _path6919, _path6920, _path6921, _path6922, _path6923, _path6924, _path6925, _path6926, _path6927, _path6928, _path6929, _path6930, _path6931, _path6932, _path6933, _path6934, _path6935, _path6936, _path6937, _path6938, _path6939, _path6940, _path6941, _path6942, _path6943, _path6944, _path6945, _path6946, _path6947, _path6948, _path6949, _path6950, _path6951, _path6952, _path6953, _path6954, _path6955, _path6956, _path6957, _path6958, _path6959, _path6960, _path6961, _path6962, _path6963, _path6964, _path6965, _path6966, _path6967, _path6968, _path6969, _path6970, _path6971, _path6972, _path6973, _path6974, _path6975, _path6976, _path6977, _path6978, _path6979, _path6980, _path6981, _path6982, _path6983, _path6984, _path6985, _path6986, _path6987, _path6988, _path6989, _path6990, _path6991, _path6992, _path6993, _path6994, _path6995, _path6996, _path6997, _path6998, _path6999, _path7000, _path7001, _path7002, _path7003, _path7004, _path7005, _path7006, _path7007, _path7008, _path7009, _path7010, _path7011, _path7012, _path7013, _path7014, _path7015, _path7016;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFurniture(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    baseProfile: "full",
    height: 128,
    width: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127 7V6h1v1zm-27 10h1v1h-1zm-6 5h-1v-1h1zM17 38v-1h1v1zm101-1v1h-1v-1zM88 54v1h-1v-1zm-39 4h1v1h-1zM8 60v1H7v-1zm10 33h-1v-1h1zm61 8v1h-1v-1zm-41 4h-1v-1h1z",
    fill: "#fff",
    fillOpacity: 0.004
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122 65h-1v-4h1v1zm-28 2h1v2h-1v-1zM6 53h1v1H6zm93 29h1v1h-1zm-27 27v-1h1v1zm2 5h-1v-1h1z",
    fill: "#0ff",
    fillOpacity: 0.004
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104 23v-1h1v1zm4 11v1h-1v-1zm-7 40h-1v-1h1zM19 87v-1h1v1zm3 12v-1h1v1zm16 24h1v1h-1z",
    fillOpacity: 0.004
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63 27h-4v-1h4zm-13 0v-1h1v1zm4 0h-1v-1h1z",
    fill: "#9e8466"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113 12v1h-1v-1zM28 52v-1h1v1zm55 1v1h-1v-1zM71 67v-1h1v1zM15 98h1v1h-1z",
    fill: "#7f6f5f",
    fillOpacity: 0.063
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82 29v-1h2v-1h1v2zm-3 1h-1v-1h1z",
    fill: "#9a7950"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M95 4v1h-1V4zM66 18v1h-1v-1zM38 87h-1v-1h1zM27 98h1v1h-1z",
    fill: "#7f7f7f",
    fillOpacity: 0.008
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M111 13v-1h1v1zm16 3h-1v-1h1zm-25 1h1v1h-1zM53 76v-1h1v1z",
    fill: "#6d6d6d",
    fillOpacity: 0.027
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M106 18v-1h1v1zm-46 1v-1h1v1zm62 48v1h-1v-1zm-6 9h1v1h-1z",
    fill: "#7f7f7f",
    fillOpacity: 0.024
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M108 18h-1v-1h1zM84 43v1h-1v-1zm37 24v-1h1v1zM34 96v1h-1v-1z",
    fill: "#7f7f7f",
    fillOpacity: 0.016
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M67 21v1h-2v-1h1zm2 0v1h-1v-1zm-21 4h1v1h-1z",
    fill: "#a0876a"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68 24h-2v-2h2z",
    fill: "#a18767"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M73 57h-1v-3h1zM20 24h-1v-1h1z",
    fill: "#916035"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M63 24h2v1h-1v1h-1zm-4 3h-1v-1h1z",
    fill: "#9d8466"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M53 28v-1h3v1h-1zm11-2v1h-1v-1z",
    fill: "#9f8466"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M65 32h1v-1h1v2h-2zm12-5h-1v-1h1z",
    fill: "#987b54"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M80 27h-1v-1h1zm1-1h1v1h-1zm-9 5v-1h1v1zm-5 2h1v1h-1z",
    fill: "#9c7c54"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M69 31h1v1h-2v-1zm14-4v-1h1v1zm-8 4h-1v-1h1z",
    fill: "#9a7a52"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M87 28h-1v-1h1zm-1 0v1h-1v-1zm-1 1v1h-1v-1zm-7 2h-1v-1h1z",
    fill: "#98774e"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M54 28h4v1h-4z",
    fill: "#9f8464"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M76 29v1h-3v-1zm-8 3h-1v-1h1z",
    fill: "#9a7a53"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M82 29h2v1h-2zm4 1h-1v-1h1zm-7 1h-1v-1h1z",
    fill: "#98774d"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M82 31v-1h3v1h-1v1h-1v-1z",
    fill: "#96754a"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M4 36v1H3v-1zm117 22h1v1h-1zm-22 1v1h-1v-1zm-27 46h1v1h-1z",
    fill: "#919191",
    fillOpacity: 0.027
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M64 53v3h-1v-3zm1-9v1h-1v-1z",
    fill: "#9a683e"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M116 44v1h-1v-1zm5 25v-1h1v1zM15 100h1v1h-1zm0 13v1h-1v-1z",
    fill: "#7f7f7f",
    fillOpacity: 0.031
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M69 74v1h-1v-4h1z",
    fill: "#a97",
    fillOpacity: 0.059
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M105 7h2v1h-2zm0 2h1v1h-1z",
    fill: "#b18f74"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M100 11v1h-1v-1zM51 39h1v1h-1zm19 4v-1h1v1z",
    fill: "#3f3f7f",
    fillOpacity: 0.016
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M106 18h-2v-1h2zM50 87h-1v-1h1z",
    fill: "#8d7171",
    fillOpacity: 0.035
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1 20H0v-1h1zm105 57v1h-1v-1zM69 95h1v1h-1z",
    fill: "#999",
    fillOpacity: 0.02
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M83 20h1v1h-1zm11 46v1h-1v-1zm-23 4h1v1h-1z",
    fill: "#8d8d8d",
    fillOpacity: 0.035
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22h-1v-1h1zm97 64v-1h1v1zm-70 29v1h-1v-1z",
    fill: "#aff",
    fillOpacity: 0.012
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M49 25h2v1h-2zm14-2v-1h1v1z",
    fill: "#a1886a"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M80 22v1h-3v-1h1z",
    fill: "#9d8562"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M51 26v-1h2v1h-1zm13-3h1v1h-1z",
    fill: "#a08769"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M91 23v1h-1v-1zm-18 9v1h-1v-1zm2 0v1h-1v-1z",
    fill: "#95754d"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M80 24v1h-1v-1zm4 1h-1v-1h1zm-19 4v-1h1v1z",
    fill: "#9f815b"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M20 25h1v1h-1zm45 29h-1v-1h1zm28-1v1h-1v-1z",
    fill: "#965e36"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M22 26v-1h1v1zm1 1v-1h1v1zm42 30v1h-1v-1z",
    fill: "#925d33"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M27 26h-1v-1h2v1zm0 13v1h-1v-1z",
    fill: "#915d35"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M31 25v1h-1v-1zm91 5v1h-1v-1zm-2 15v1h-1v-1z",
    fill: "#996944"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M52 27h-1v-1h2v1zm2-1h1v1h-1z",
    fill: "#9d8366"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M76 26v1h-1v-1zm2 0v1h-1v-1zm-28 5v1h-1v-1z",
    fill: "#997c55"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M78 27v-1h1v1zm-5 3h-1v-1h1zm-4 4h-1v-1h1z",
    fill: "#9b7b54"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M82 26h1v1h-1zm-9 3h-1v-1h1zm0 1h1v1h-1z",
    fill: "#9b7b53"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M47 28v1h-1v-2h2v1z",
    fill: "#9f8465"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M58 27h1v1h-2v-1zm-7 1v-1h1v1z",
    fill: "#9d8264"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M69 28h-1v-1h2v1zm-6 2v-1h1v1z",
    fill: "#a2845d"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M100 28h-2v-1h2zm-6 0v-1h1v1z",
    fill: "#9d7340"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M47 29v-1h2v1h-1zm6 0v-1h1v1z",
    fill: "#9f8564"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M51 29v-1h2v1h-1zm7-1h1v1h-1z",
    fill: "#9e8564"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M75 29v-1h2v1h-1zm-1 2h1v1h-1z",
    fill: "#9c7d51"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30v-1h1v1zm72 11v-1h1v1zM61 64h-1v-1h1z",
    fill: "#925a33"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M79 29h3v1h-3z",
    fill: "#99784f"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M64 31v-1h3v1h-1z",
    fill: "#a08358"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M79 31v1h-1v-1zm1 1v1h-1v-1zm1 0h1v1h-1z",
    fill: "#9a794e"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M80 32v-1h1v1zm-3 1v-1h1v1zm0 1h-1v-1h1z",
    fill: "#98774c"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M3 32v1H2v-1zm29 4h1v1h-1zm74 34v-1h1v1z",
    fill: "#00f",
    fillOpacity: 0.004
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M92 38h1v1h-1zM49 58v1h-1v-1zM16 78h-1v-1h1z",
    fill: "#897575",
    fillOpacity: 0.051
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M4 42v-1h1v1zm84 0h1v1h-1zm26 15v-1h1v1z",
    fill: "#7f7faa",
    fillOpacity: 0.024
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M123 42h-1v-1h1zM15 64h-1v-1h1zm34 16v-1h1v1z",
    fill: "#bfbfff",
    fillOpacity: 0.016
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M7 52v1H6v-1zm1 17v-1h1v1zm1 46H8v-1h1z",
    fill: "#897562",
    fillOpacity: 0.051
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M68 67v-1h1v1zm-8 15v-1h1v1zm18 14v-1h1v1z",
    fill: "#b6a3a3",
    fillOpacity: 0.055
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M8 69h1v1H8zm63 3v-1h1v1zm-42 7h-1v-1h1z",
    fill: "#7fbfbf",
    fillOpacity: 0.016
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M76 72h-1v-2h1v1zm-1 1h1v1h-1z",
    fill: "#b28256"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M115 6h-1V5h1zm11 15h-1v-1h1z",
    fill: "#947f6a",
    fillOpacity: 0.047
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M108 7h1v2h-1V8z",
    fill: "#b08d6d"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M112 8h-1V7h1zm13 4v-1h1v1z",
    fill: "#ab835c"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M115 9V8h1v1zm5 1v1h-1v-1z",
    fill: "#a88153"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M114 10h1v1h-1zM77 52h1v1h-1z",
    fill: "#af875c"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M116 11v-1h2v1h-1z",
    fill: "#a98251"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M128 10v1h-1v-1zM19 77h-1v-1h1z",
    fill: "#7f6a55",
    fillOpacity: 0.047
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M100 12v-1h1v1zM59 41h-1v-1h1z",
    fill: "#756262",
    fillOpacity: 0.051
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M101 18v-1h1v1zm20 42v-1h1v1z",
    fill: "#699",
    fillOpacity: 0.02
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M103 18v-1h1v1zM85 40h1v1h-1z",
    fill: "#7f7f5f",
    fillOpacity: 0.031
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M116 18v1h-1v-1zM72 69v1h-1v-1z",
    fill: "#997f7f",
    fillOpacity: 0.039
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M121 19h-1v-1h1zM11 42h1v1h-1z",
    fill: "#6d9191",
    fillOpacity: 0.027
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M73 20v-1h1v1zm-31 94v-1h1v1z",
    fill: "#8c8c7f",
    fillOpacity: 0.078
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M106 19h1v1h-2v-1z",
    fill: "#a87f64"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M49 20h1v1h-1zm21 82h1v1h-1z",
    fill: "#aaa",
    fillOpacity: 0.012
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M96 20h1v1h-1zM63 58v1h-1v-1z",
    fill: "#94673c"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M9 22H8v-1h1zm2 0v-1h1v1z",
    fill: "#cfbfbf",
    fillOpacity: 0.063
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M14 22v-1h1v1zm111 4v1h-1v-1z",
    fill: "#9f9f9f",
    fillOpacity: 0.031
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M57 22h-1v-1h1zm-9 2v-1h1v1z",
    fill: "#a38c70"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M62 22v-1h1v1zm0 1v1h-1v-1z",
    fill: "#9f8669"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M63 21h1v1h-1zm-18 5v1h-1v-1z",
    fill: "#9f8569"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M74 22v-1h2v1h-1z",
    fill: "#a68b6c"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M112 21v1h-1v-1zm-2 48v1h-1v-1z",
    fill: "#9c7040"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M25 23h-1v-1h1zm79 20h-1v-1h1z",
    fill: "#aaa",
    fillOpacity: 0.024
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M50 23h-1v-1h2v1z",
    fill: "#a58e72"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M60 22h1v1h-1zm-17 3h1v1h-1z",
    fill: "#a18a6b"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M63 23h-1v-1h1zm-9 2h1v1h-1z",
    fill: "#a2896a"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M65 23v-1h1v1zm-2 1v-1h1v1z",
    fill: "#a08768"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M74 22v1h-1v-1zm1 1v-1h1v1z",
    fill: "#9e8664"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M82 23h-1v-1h1zm-21 6h-1v-1h1z",
    fill: "#9d8461"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M82 23v-1h1v1zm-23 5h1v1h-1z",
    fill: "#9d8462"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M85 22h1v1h-1zm-15 4h1v1h-1z",
    fill: "#9e805e"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M101 23v-1h1v1zM20 58h-1v-1h1z",
    fill: "#055",
    fillOpacity: 0.012
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M122 23v-1h1v1zm0 1h1v1h-1z",
    fill: "#a47753"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M12 23v1h-1v-1zm1 2v1h-1v-1z",
    fill: "#a97654"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M15 24h-1v-1h1zm48 45v1h-1v-1z",
    fill: "#a26f50"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M17 23v1h-1v-1zm0 3v-1h1v1z",
    fill: "#9c6842"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M21 24h-1v-1h1zm42 19v-1h1v1z",
    fill: "#946338"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M55 23h1v1h-1zm-11 2v-1h1v1z",
    fill: "#a0886e"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M59 23h1v1h-1zm-14 1h1v1h-1z",
    fill: "#a0866c"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M61 23v1h-1v-1zm-1 3v-1h1v1z",
    fill: "#a0866b"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M62 24v-1h1v1zm3-1h1v1h-1z",
    fill: "#a08668"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M71 23h2v1h-2z",
    fill: "#a08764"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M110 23v1h-1v-1zM27 96v-1h1v1z",
    fill: "#9a7f6d",
    fillOpacity: 0.11
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M16 25h-1v-1h1zm70 14v-1h1v1z",
    fill: "#a16e4d"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M19 25h-1v-1h1zm46 59h-1v-1h1z",
    fill: "#915a34"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M25 24h1v1h-1zm94 14v-1h1v1z",
    fill: "#8d582d"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M47 24v1h-1v-1zm-2 1h1v1h-1z",
    fill: "#9f856a"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M65 25v-1h1v1zm-16 1h1v1h-1z",
    fill: "#9e8467"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M68 25v-1h2v1h-1z",
    fill: "#a08567"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M95 24v1h-1v-1zm-2 5h1v1h-1z",
    fill: "#96703f"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M99 24h2v1h-2z",
    fill: "#9b7040"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M7 26v-1h1v1zm3-1v1H9v-1z",
    fill: "#af8264"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M21 27v-2h1v2z",
    fill: "#945e34"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M29 25h1v1h-1zm-6 61v-1h1v1z",
    fill: "#95633d"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M38 25v1h-1v-1zm33 9h-1v-1h1z",
    fill: "#987850"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M40 25h1v1h-1zm30 10v1h-1v-1z",
    fill: "#82572c"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M48 25v1h-2v-1h1z",
    fill: "#9e8569"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M64 25h2v1h-2z",
    fill: "#9e8366"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M73 25h1v1h-1zm-23 6h-1v-1h1z",
    fill: "#9b7e5c"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M103 26v-1h2v1h-1z",
    fill: "#9e7444"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M107 26h-1v-1h1zM76 56h1v1h-1z",
    fill: "#9d7240"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M113 26h-1v-1h1zm-4 1h-1v-1h1z",
    fill: "#a77e47"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M122 25v1h-1v-1zm-94 3v1h-1v-1z",
    fill: "#996844"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M14 28h-1v-2h1v1z",
    fill: "#a57453"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M19 26h1v1h-1zm76 27h-1v-1h1z",
    fill: "#976038"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M23 26v2h-1v-2z",
    fill: "#966036"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26h1v1h-1zm1 67h1v1h-1z",
    fill: "#935e36"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M44 27h-1v-1h1zm1 0h1v1h-1z",
    fill: "#9f8565"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M58 27h-2v-1h2z",
    fill: "#9d8365"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M70 26v1h-2v-1h1z",
    fill: "#9f825f"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M73 27h-1v-1h1zm-11 3h1v1h-1z",
    fill: "#9e805b"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M85 27h-1v-1h2v1z",
    fill: "#9a7851"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M86 26h1v1h-1zm-9 4v1h-1v-1z",
    fill: "#99774f"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M100 26v1h-1v-1zM76 61v-1h1v1z",
    fill: "#9f7544"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M103 27v-1h1v1zm-4 3h-1v-1h1z",
    fill: "#a37a48"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M18 27v1h-1v-1zm81 25v1h-1v-1z",
    fill: "#9c6440"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M18 27h1v1h-1zm2 0h1v1h-1z",
    fill: "#99623a"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M19 28v-1h1v1zm77 25h1v1h-1z",
    fill: "#986139"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M25 28v-1h1v1zm55 23h-1v-1h1z",
    fill: "#956039"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M29 28v-1h1v1zm-1 1v-1h1v1z",
    fill: "#9d6b49"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M53 27v1h-1v-1zm4 1h-1v-1h1z",
    fill: "#9e8365"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M86 28h-1v-1h1zm-5 5h-1v-1h1z",
    fill: "#9a794f"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M96 28v-1h1v1zM76 63h1v1h-1z",
    fill: "#9e6f3b"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M6 28v1H5v-1zm74 19v1h-1v-1z",
    fill: "#7d5331"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M16 29h-1v-1h1zM8 50h1v1H8z",
    fill: "#a46c44"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M22 28h1v1h-1zm2 1v-1h1v1z",
    fill: "#925c33"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M26 29h-1v-1h1zm-4 10v1h-1v-1z",
    fill: "#96613a"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M70 29h-1v-1h2v1z",
    fill: "#a08059"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M74 28v1h-1v-1zm-3 3v1h-1v-1z",
    fill: "#9b7b52"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M78 29h-1v-1h1zm1 0v-1h1v1z",
    fill: "#9c7d50"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M89 28v1h-1v-1zm-1 4v-1h1v1z",
    fill: "#967348"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M116 29h-1v-1h1zm-74 85h1v1h-1z",
    fill: "#949494",
    fillOpacity: 0.047
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M8 30v-1h1v1zm14 64h1v1h-1z",
    fill: "#716346",
    fillOpacity: 0.071
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M28 29h1v1h-1zM16 70v1h-1v-1z",
    fill: "#9c6847"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M54 30v-1h2v1h-1z",
    fill: "#a28561"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M61 29v1h-2v-1h1z",
    fill: "#9f8562"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M86 29h1v1h-1zm-5 2h-1v-1h1z",
    fill: "#96754c"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M16 30h1v1h-1zm92 5v1h-1v-1z",
    fill: "#5c4545",
    fillOpacity: 0.043
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M54 30h1v1h-2v-1z",
    fill: "#9e825b"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30h1v1h-1zm3 1h1v1h-1z",
    fill: "#9a7c59"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M62 30v1h-1v-1zm-6 2h-1v-1h1z",
    fill: "#9d7f5b"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M64 30v1h-1v-1zm-6 2v1h-1v-1z",
    fill: "#9f8259"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M82 30v2h-1v-2z",
    fill: "#97764b"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M86 32h-1v-2h1v1z",
    fill: "#947348"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M102 30h1v1h-1zM21 75h-1v-1h1z",
    fill: "#bf875e"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M109 30v1h-1v-1zm-14 6v1h-1v-1z",
    fill: "#b27a52"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M110 30h1v1h-1zM12 99h1v1h-1z",
    fill: "#9e6439"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M37 32h-1v-1h1zm-1 29h1v1h-1z",
    fill: "#8a5d41"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M42 32h-1v-1h1zm40 6v-1h1v1z",
    fill: "#7a4f30"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M47 31v1h-1v-1zm41 15h-1v-1h1z",
    fill: "#957155"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M55 32h-2v-1h2z",
    fill: "#9d8059"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M64 31h2v1h-2z",
    fill: "#997b55"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M73 32h-2v-1h2z",
    fill: "#9a7a51"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M82 31h1v1h-1zm-13 4h-1v-1h1z",
    fill: "#97764a"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M23 32h1v1h-1zm40 33v1h-1v-1z",
    fill: "#83512b"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M27 32h1v1h-1zm6 0v1h-1v-1z",
    fill: "#704123"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M74 32v2h-1v-2z",
    fill: "#95754e"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M77 33h-1v-1h1zm-8 1h1v1h-1z",
    fill: "#96764b"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M99 33v-1h1v1zM8 52h1v1H8z",
    fill: "#ab744a"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M118 33v-1h1v1zm-42 6h1v1h-1z",
    fill: "#7b4e24"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M10 34H9v-1h1zm5 22h1v1h-1z",
    fill: "#555",
    fillOpacity: 0.035
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M28 34h-1v-1h1zm35 5h1v1h-1z",
    fill: "#7f4f28"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M52 34v-1h1v1zm28 6h-1v-1h1z",
    fill: "#895d3b"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M59 33h1v1h-1zm20 0v1h-1v-1z",
    fill: "#9b794c"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M65 34h-2v-1h2z",
    fill: "#9b7d51"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M80 34h-1v-1h2v1z",
    fill: "#9a794c"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M84 33h1v1h-1zm-5 1h1v1h-1z",
    fill: "#9a784a"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M67 34h1v1h-1zm11 1v-1h1v1z",
    fill: "#997749"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M85 35v-1h1v1zm24 47v-1h1v1z",
    fill: "#99734f"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M92 35h-1v-1h1zM35 70v1h-1v-1z",
    fill: "#986b48"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M120 35h-1v-1h1zM48 64v1h-1v-1z",
    fill: "#86552e"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M8 35h1v1H8zm54 31h1v1h-1z",
    fill: "#825636"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M35 35h1v1h-1zm62 15h1v1h-1z",
    fill: "#815230"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M53 35v1h-1v-1zm13 44h-1v-1h1z",
    fill: "#794829"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M63 36v-1h1v1zm4 2v1h-1v-1z",
    fill: "#70421d"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M81 35h1v1h-1zM20 64v1h-1v-1z",
    fill: "#8e694a"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M120 36h-1v-1h1zm-10 23h-1v-1h1z",
    fill: "#885730"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M44 36h1v1h-1zm50 15h-1v-1h1z",
    fill: "#844f2f"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M48 37h-1v-1h1zm33 28h1v1h-1z",
    fill: "#7b4a2e"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M52 37v-1h2v1h-1z",
    fill: "#814d2f"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M75 37h-1v-1h1zM27 70v-1h1v1z",
    fill: "#905c29"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M85 36v1h-1v-1zm-4 2h1v1h-1z",
    fill: "#885e3d"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M88 37v-1h1v1zM62 70h-1v-1h1z",
    fill: "#9b694a"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M90 36v1h-1v-1zm8 36h-1v-1h1z",
    fill: "#a06d50"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M97 36v1h-1v-1zM20 88v1h-1v-1z",
    fill: "#c38a60"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M17 38h-1v-1h1zm51 29h1v1h-1z",
    fill: "#b09c9c",
    fillOpacity: 0.051
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M51 38h-1v-1h1zm30 25v-1h1v1z",
    fill: "#835033"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M80 37h1v1h-1zM59 70h1v1h-1z",
    fill: "#835838"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M47 38v1h-1v-1zm45 23h1v1h-1z",
    fill: "#6b4e3a",
    fillOpacity: 0.102
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M59 38h1v1h-1zm51 24v1h-1v-1z",
    fill: "#8f5a33"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M64 38v1h-1v-1zm44 8h1v1h-1z",
    fill: "#815128"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M97 39v-1h1v1zm0 1h1v1h-1z",
    fill: "#8a6b58",
    fillOpacity: 0.42
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M121 39v1h-1v-2h1z",
    fill: "#9e6b46"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M13 40v-1h1v1zm53 63v-1h1v1z",
    fill: "#9c6140"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M20 40v-1h1v1zm13 46h1v1h-1z",
    fill: "#9a6343"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M23 39h1v1h-1zm72 8h1v1h-1z",
    fill: "#9a663c"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M68 39h1v1h-1zm41 4v-1h1v1z",
    fill: "#75481f"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M14 41h-1v-1h2v1z",
    fill: "#9d6240"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M24 41v-1h1v1zM12 80v-1h1v1z",
    fill: "#90542c"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M78 40h1v1h-1zM50 68v1h-1v-1z",
    fill: "#93673d"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M95 42v-2h1v2z",
    fill: "#915428"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M20 41v1h-1v-1zm83 26v1h-1v-1z",
    fill: "#9a603c"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M63 43h-1v-2h1v1z",
    fill: "#8a5a2b"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M65 42h-1v-1h1zm7 3v-1h1v1z",
    fill: "#906032"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M20 42v1h-1v-1zm1 27h1v1h-1z",
    fill: "#9b5e38"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M21 43h-1v-1h1zm47 20v1h-1v-1z",
    fill: "#9c5d35"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M65 42v1h-1v-1zM48 71h-1v-1h1z",
    fill: "#956538"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M9 44H8v-1h1zm39 19h1v1h-1z",
    fill: "#875836"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M16 43v1h-1v-1zm21 58h-1v-1h1z",
    fill: "#366",
    fillOpacity: 0.02
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M99 43h1v1h-1zm-9 1v1h-1v-1z",
    fill: "#9b7254"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M94 45h-1v-1h1zM33 71v-1h1v1z",
    fill: "#976844"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M96 45v-1h1v1zm-22 8v-1h1v1z",
    fill: "#966031"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M105 45h-1v-1h2v1z",
    fill: "#946d4f"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M42 45v2h-1v-2z",
    fill: "#ae8476"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M63 46v-1h1v1zm12 7v-1h1v1z",
    fill: "#986538"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M82 45h1v1h-1zm6 1v1h-1v-1z",
    fill: "#906c55"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M5 47v-1h1v1zm116 10v-1h1v1z",
    fill: "#a3917f",
    fillOpacity: 0.055
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M95 47h-1v-1h1zm-31 3v1h-1v-1z",
    fill: "#99653a"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M29 48h-1v-1h1zm27 26v1h-1v-1z",
    fill: "#6b5844",
    fillOpacity: 0.102
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M64 48h-1v-1h1zm-1 1h1v1h-1z",
    fill: "#9b683a"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M72 47v2h-1v-2z",
    fill: "#876241",
    fillOpacity: 0.243
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M76 48v-1h1v1zm1 1v1h-1v-1z",
    fill: "#96683b"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M62 48v1h-1v-1zm14 2h-1v-1h1z",
    fill: "#976334"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M76 48h1v1h-1zm-13 7v1h-1v-1z",
    fill: "#96683c"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M88 49v-1h1v1zM30 67h1v1h-1z",
    fill: "#896249"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M62 50h-1v-1h1zM24 79h1v1h-1z",
    fill: "#976435"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M73 50v1h-1v-2h1z",
    fill: "#96663a"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M90 49h1v1h-1zM54 82h1v1h-1z",
    fill: "#8b5b3f"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M94 50h-1v-1h1zM34 64h-1v-1h1z",
    fill: "#90603d"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M105 49v1h-2v-1h1z",
    fill: "#a67a5d"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M119 50h-1v-1h1zM66 99h1v1h-1z",
    fill: "#915634"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M9 50h1v1H9zm20 15v-1h1v1z",
    fill: "#8b562e"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M62 50h1v1h-1zm10 2h1v1h-1z",
    fill: "#936337"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M81 50h1v1h-1zM64 73v1h-1v-1z",
    fill: "#915937"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M93 50v1h-1v-1zm5 1h1v1h-1z",
    fill: "#885333"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M63 51v1h-1v-1zM50 70h-1v-1h1z",
    fill: "#94663b"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M85 52v-1h1v1zm14 1h1v1h-1z",
    fill: "#955f3b"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M92 52v-1h1v1zm27 3v1h-1v-1z",
    fill: "#98613f"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M117 53h-1v-1h1zM73 96h-1v-1h1z",
    fill: "#826655",
    fillOpacity: 0.176
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M122 52v1h-1v-1zM78 91h1v1h-1z",
    fill: "#a3886d",
    fillOpacity: 0.11
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M33 54v-1h1v1zm65 36v-1h1v1z",
    fill: "#007fff",
    fillOpacity: 0.008
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M95 53h1v1h-1zm-85 9h1v1h-1z",
    fill: "#985f38"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M119 54v-1h1v2h-1z",
    fill: "#b07d5c"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M43 56h-1v-2h1v1z",
    fill: "#81553a"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M92 54h1v1h-1zm10 15h1v1h-1z",
    fill: "#98603a"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M101 55v-1h1v1zM65 91v-1h1v1z",
    fill: "#90562d"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M117 55h-1v-1h1zM18 81h1v1h-1z",
    fill: "#7f6d61",
    fillOpacity: 0.165
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M24 55h1v1h-1zm2 1v-1h1v1z",
    fill: "#9c582f"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M10 57v-1h1v2h-1z",
    fill: "#834e28"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M28 57h-1v-1h1zm75 13v-1h1v1z",
    fill: "#a56741"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M119 56v1h-1v-1zM66 96v-1h1v1z",
    fill: "#975f3d"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M75 57v1h-1v-1zm0 28v-1h1v1z",
    fill: "#ad7d4b"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M121 58v-1h1v1zM15 79h1v1h-1z",
    fill: "#a28b8b",
    fillOpacity: 0.043
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M76 58v1h-1v-1zm1 19h1v1h-1z",
    fill: "#a97b4b"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M8 59v1H7v-1zm114 10v1h-1v-1z",
    fill: "#917f6d",
    fillOpacity: 0.055
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M38 60h-2v-1h2z",
    fill: "#8b5c42"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M103 60h-1v-1h1zM19 90v-1h1v1z",
    fill: "#8c502d"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M48 60h1v2h-1v-1z",
    fill: "#8f6346"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M122 61h-1v-1h1zM16 101v1h-1v-1z",
    fill: "#7f7fff",
    fillOpacity: 0.008
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M30 62h-1v-1h1zm23 7v1h-1v-1z",
    fill: "#926039"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M30 61h1v1h-1zm17 6v-1h1v1z",
    fill: "#90623d"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M47 62h-1v-1h1zm2 11v1h-1v-1z",
    fill: "#8e6247"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M61 62v-1h1v1zm2-1h1v1h-1z",
    fill: "#894c26"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M20 63h-1v-1h1zm60 2h-1v-1h1z",
    fill: "#7f7f71",
    fillOpacity: 0.071
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M32 63h-1v-1h1zm0 1h1v1h-1z",
    fill: "#8a5a36"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M33 62v1h-1v-1zm18 2v-1h1v1z",
    fill: "#8b5938"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M64 62h1v1h-1zm-39 1v1h-1v-1z",
    fill: "#8c5024"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M66 62h1v1h-1zm-53 2h-1v-1h1z",
    fill: "#8c5026"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M22 64h-1v-1h1zm30 4h1v1h-1z",
    fill: "#936237"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M35 63v1h-1v-1zm22 0h1v1h-1z",
    fill: "#90603e"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M35 64v-1h1v1zm19 1v-1h1v1z",
    fill: "#8e5e3d"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M42 63h1v1h-1zm22 15v-1h1v1z",
    fill: "#86573c"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M54 64h-1v-1h2v1z",
    fill: "#906240"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M120 63v1h-1v-1zm0 10v1h-1v-1z",
    fill: "#be8968"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M11 64h1v2h-1v-1z",
    fill: "#874d25"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M13 64v1h-1v-1zm1 16v1h-1v-1z",
    fill: "#8e5024"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M14 65v-1h1v1zm58 43v-1h1v1z",
    fill: "#05a",
    fillOpacity: 0.012
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M34 64v1h-1v-1zm20 1v1h-1v-1z",
    fill: "#8c5c38"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M34 65v-1h1v1zm17 0h-1v-1h1z",
    fill: "#8d5d39"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M32 66h-1v-1h2v1z",
    fill: "#885b37"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M53 66h-1v-1h1zm-11 6v-1h1v1z",
    fill: "#8d5e3b"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M75 66v-1h1v1zm0 2v-1h1v1z",
    fill: "#af8051"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M104 66h-1v-1h1zm14 0v1h-1v-1z",
    fill: "#9b5d39"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M77 66v2h-1v-2z",
    fill: "#9c6e3c"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M97 66v1h-1v-1zm-62 5h1v1h-1z",
    fill: "#a36c4b"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M103 67h-1v-1h1zm-1 12h1v1h-1z",
    fill: "#9a5b37"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M97 68h-1v-1h1zm-57 52v-1h1v1z",
    fill: "#a56b4c"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M20 68v1h-1v-1zm44 9v1h-1v-1z",
    fill: "#966645"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M23 69h-1v-1h1zm87 2h-1v-1h1z",
    fill: "#9c6e43"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M47 68v1h-1v-1zm1 6h1v1h-1z",
    fill: "#956948"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M77 69h-1v-1h1zm-1 1h1v1h-1z",
    fill: "#9d6d3c"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M66 71v-1h1v2h-1z",
    fill: "#b17d5c"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M77 72v-2h1v2z",
    fill: "#a97945"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M32 71h1v1h-1zM14 94v1h-1v-1z",
    fill: "#9e5f39"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M56 73v-2h1v2z",
    fill: "#825432"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M75 72v1h-1v-2h1z",
    fill: "#b88959"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M76 72v-1h1v2h-1z",
    fill: "#9e6e3d"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M55 72v1h-1v-1zm-1 1v1h-1v-1z",
    fill: "#8e5e37"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M67 73h1v2h-1v-1z",
    fill: "#b28867",
    fillOpacity: 0.878
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M73 75v-2h1v2z",
    fill: "#b4814e"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M98 74h-1v-1h1zM36 99h-1v-1h1z",
    fill: "#a26e4f"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M26 74v2h-1v-2z",
    fill: "#be8357"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M27 74h1v1h-1zm-17 35v-1h1v1z",
    fill: "#bf8257"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M52 75h-1v-1h1zM34 86h-1v-1h1z",
    fill: "#98643f"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M64 74h1v1h-1zm2 9h-1v-1h1z",
    fill: "#8b532d"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M65 74h1v1h-1zm0 7v1h-1v-1z",
    fill: "#89542c"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M110 76h-1v-2h1v1z",
    fill: "#9d7149"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M40 75v2h-1v-2z",
    fill: "#d5a992"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M117 76h-1v-1h1zM22 96v-1h1v1z",
    fill: "#6a5555",
    fillOpacity: 0.047
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M103 77h-1v-1h1zM66 94v1h-1v-1z",
    fill: "#985b35"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M121 77v-1h1v1zM31 89h1v1h-1z",
    fill: "#947664",
    fillOpacity: 0.169
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M74 77v2h-1v-2z",
    fill: "#b07e4a"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M98 78v-1h1v1zm-59 45h1v1h-1z",
    fill: "#7f7f55",
    fillOpacity: 0.024
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M15 79v-1h1v1zm29 21h-1v-1h1z",
    fill: "#7f6f6f",
    fillOpacity: 0.063
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M76 78h1v2h-1v-1z",
    fill: "#a37543"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M102 78v1h-1v-1zm-36 23h1v1h-1z",
    fill: "#9a5e3e"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M75 81v2h-1v-2z",
    fill: "#b38050"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M119 83h-1v-1h1zm-77 40h-1v-1h1z",
    fill: "#666",
    fillOpacity: 0.02
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M43 83v2h-1v-2z",
    fill: "#986f5b"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M66 84v-1h1v1zm1 1v1h-1v-1z",
    fill: "#b68368"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M71 84h1v1h-1zm2 16h-1v-1h1z",
    fill: "#6a554a",
    fillOpacity: 0.094
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M11 86v-1h1v1zm1 11v1h-1v-1z",
    fill: "#ae6f40"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M9 87h1v1H9zm0 4v-1h1v1z",
    fill: "#a1785d",
    fillOpacity: 0.149
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M33 88v-1h2v1h-1z",
    fill: "#915d3e"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M61 87h1v1h-1zm-33 1h1v1h-1z",
    fillOpacity: 0.008
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M11 93v-2h1v2z",
    fill: "#b07444"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M12 92v-1h1v1zm0 2v-1h1v1z",
    fill: "#9d623a"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M58 92h1v1h-1zm21 9h-1v-1h1z",
    fill: "#fff",
    fillOpacity: 0.012
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M12 95v1h-1v-2h1z",
    fill: "#b37545"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M34 96h-1v-1h1zm-19 17h-1v-1h1z",
    fill: "#745f4a",
    fillOpacity: 0.094
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M77 100v2h-1v-2z",
    fill: "#ca9c82"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M11 103v1h-1v-2h1z",
    fill: "#c4895c"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M12 106v1h-1v-2h1z",
    fill: "#a6693b"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M12 109h-1v-1h1zm0 1h1v1h-1z",
    fill: "#a6693c"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M41 108v2h-1v-2z",
    fill: "#bb7c59"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M40 111h-1v-2h1v1z",
    fill: "#c1815e"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M12 110v2h-1v-2z",
    fill: "#a16236"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M95 5V4h1v1z",
    fill: "#927c61",
    fillOpacity: 0.184
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M97 4v1h-1V4z",
    fill: "#997d61",
    fillOpacity: 0.247
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M98 4v1h-1V4z",
    fill: "#917f67",
    fillOpacity: 0.165
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M94 6V5h1v1z",
    fill: "#9f8f7f",
    fillOpacity: 0.125
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M96 6h-1V5h1z",
    fill: "#a4845b",
    fillOpacity: 0.922
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M97 6h-1V5h1z",
    fill: "#b38a5c"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M98 6h-1V5h1z",
    fill: "#9f8266",
    fillOpacity: 0.745
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M102 6h-1V5h1z",
    fill: "#b9b9a2",
    fillOpacity: 0.043
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M102 5h1v1h-1z",
    fill: "#a38e7a",
    fillOpacity: 0.098
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M104 5v1h-1V5z",
    fill: "#9a866b",
    fillOpacity: 0.149
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M105 6h-1V5h1z",
    fill: "#9c826d",
    fillOpacity: 0.192
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M105 5h1v1h-1z",
    fill: "#9e8570",
    fillOpacity: 0.239
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M106 6V5h1v1z",
    fill: "#9f896e",
    fillOpacity: 0.263
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M107 6V5h1v1z",
    fill: "#9b8366",
    fillOpacity: 0.282
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M109 5v1h-1V5z",
    fill: "#967a5e",
    fillOpacity: 0.286
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M109 6V5h1v1z",
    fill: "#92785a",
    fillOpacity: 0.267
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M110 5h1v1h-1z",
    fill: "#957959",
    fillOpacity: 0.247
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M111 6V5h1v1z",
    fill: "#967d5a",
    fillOpacity: 0.2
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M113 6h-1V5h1z",
    fill: "#9a7f5d",
    fillOpacity: 0.149
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M113 5h1v1h-1z",
    fill: "#977a5e",
    fillOpacity: 0.106
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M94 6h1v1h-1z",
    fill: "#a58d76",
    fillOpacity: 0.212
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M95 7V6h1v1z",
    fill: "#b6966c",
    fillOpacity: 0.996
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M96 7V6h1v1z",
    fill: "#b59367"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M98 6v1h-1V6z",
    fill: "#9e7c58",
    fillOpacity: 0.914
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M98 7V6h1v1z",
    fill: "#a48160",
    fillOpacity: 0.541
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M99 6h1v1h-1z",
    fill: "#a88864",
    fillOpacity: 0.639
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M100 7V6h1v1z",
    fill: "#ae8c66",
    fillOpacity: 0.761
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M102 6v1h-1V6z",
    fill: "#ac8966",
    fillOpacity: 0.851
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M102 7V6h1v1z",
    fill: "#aa8964",
    fillOpacity: 0.914
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M104 7h-1V6h1z",
    fill: "#aa8964",
    fillOpacity: 0.957
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M104 6h1v1h-1z",
    fill: "#aa8868",
    fillOpacity: 0.984
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M106 7h-1V6h1z",
    fill: "#ad8a6c"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M106 6h1v1h-1z",
    fill: "#b08e6e"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M107 6h1v1h-1z",
    fill: "#af8d6b"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M109 7h-1V6h1z",
    fill: "#ac8865"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M110 6v1h-1V6z",
    fill: "#a5825d"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M110 7V6h1v1z",
    fill: "#a7815b"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M111 6h1v1h-1z",
    fill: "#a47e52",
    fillOpacity: 0.988
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M113 6v1h-1V6z",
    fill: "#a27b50",
    fillOpacity: 0.961
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M113 7V6h1v1z",
    fill: "#a27c51",
    fillOpacity: 0.922
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M115 6v1h-1V6z",
    fill: "#a17b51",
    fillOpacity: 0.847
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M115 7V6h1v1z",
    fill: "#a07c52",
    fillOpacity: 0.753
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M116 6h1v1h-1z",
    fill: "#997a4f",
    fillOpacity: 0.627
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M117 7V6h1v1z",
    fill: "#937d4c",
    fillOpacity: 0.455
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M119 6v1h-1V6z",
    fill: "#96834d",
    fillOpacity: 0.259
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M119 6h1v1h-1z",
    fill: "#917955",
    fillOpacity: 0.082
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M124 7V6h1v1z",
    fill: "#887760",
    fillOpacity: 0.176
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M125 7V6h1v1z",
    fill: "#927f60",
    fillOpacity: 0.259
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M127 7h-1V6h1z",
    fill: "#9c8b62",
    fillOpacity: 0.122
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M95 7v1h-1V7z",
    fill: "#9b7f63",
    fillOpacity: 0.251
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M95 7h1v1h-1z",
    fill: "#b28b63"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M96 7h1v1h-1z",
    fill: "#ab855d"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M97 8V7h1v1z",
    fill: "#a17948"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M99 7v1h-1V7z",
    fill: "#b0885a"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M100 8h-1V7h1z",
    fill: "#b48c5f"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M100 7h1v1h-1z",
    fill: "#b48f60"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M101 8V7h1v1z",
    fill: "#b49066"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M102 7h1v1h-1z",
    fill: "#b38f69"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M103 8V7h1v1z",
    fill: "#b2906d"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M105 7v1h-1V7z",
    fill: "#b29073"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M108 7v1h-1V7z",
    fill: "#b29074"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M109 8V7h1v1z",
    fill: "#ac8765"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M111 8h-1V7h1z",
    fill: "#ab8561"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M113 8h-1V7h1z",
    fill: "#a98154"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M114 8h-1V7h1z",
    fill: "#aa8052"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M114 7h1v1h-1z",
    fill: "#ad8153"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M115 7h1v1h-1z",
    fill: "#ae8254"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M116 8V7h1v1z",
    fill: "#ae8352"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M118 8h-1V7h1z",
    fill: "#ab8350"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M118 8V7h1v1z",
    fill: "#a57d4c"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M119 7h1v1h-1z",
    fill: "#a2784b",
    fillOpacity: 0.902
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M121 8h-1V7h1z",
    fill: "#9b7a50",
    fillOpacity: 0.686
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M121 8V7h1v1z",
    fill: "#997c56",
    fillOpacity: 0.392
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M122 7h1v1h-1z",
    fill: "#a17f5d",
    fillOpacity: 0.118
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M124 7v1h-1V7z",
    fill: "#9c8768",
    fillOpacity: 0.192
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M124 7h1v1h-1z",
    fill: "#9e7d52",
    fillOpacity: 0.922
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M125 7h1v1h-1z",
    fill: "#aa825a"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M126 7h1v1h-1z",
    fill: "#9d7b58",
    fillOpacity: 0.925
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M128 7v1h-1V7z",
    fill: "#856e58",
    fillOpacity: 0.271
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M95 9h-1V8h1z",
    fill: "#9e8163",
    fillOpacity: 0.271
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M96 8v1h-1V8z",
    fill: "#b38b65"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M96 8h1v1h-1z",
    fill: "#a98460"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M98 8v1h-1V8z",
    fill: "#9d764a"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M99 8v1h-1V8z",
    fill: "#ab8354"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M99 8h1v1h-1z",
    fill: "#af875b"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M101 9h-1V8h1z",
    fill: "#af895f"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M102 9h-1V8h1z",
    fill: "#af8b63"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M102 8h1v1h-1z",
    fill: "#af8c69"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M104 8v1h-1V8z",
    fill: "#b18f6e"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M104 9V8h1v1z",
    fill: "#b28f71"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M105 9V8h1v1z",
    fill: "#af8e72"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M106 9V8h1v1z",
    fill: "#ab8a70"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M107 8h1v1h-1z",
    fill: "#ae8c70"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M109 8h1v1h-1z",
    fill: "#b18c6a"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M111 9h-1V8h1z",
    fill: "#b08a68"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M112 8v1h-1V8z",
    fill: "#af8865"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M112 8h1v1h-1z",
    fill: "#ae865f"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M114 9h-1V8h1z",
    fill: "#ae8459"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M115 8v1h-1V8z",
    fill: "#ac8356"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M116 8h1v1h-1z",
    fill: "#a67e4f"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M118 9h-1V8h1z",
    fill: "#a77d4e"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M118 8h1v1h-1z",
    fill: "#a97d4e"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M120 8v1h-1V8z",
    fill: "#ac8050"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M120 9V8h1v1z",
    fill: "#ab8351"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M122 8v1h-1V8z",
    fill: "#a68151"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M122 9V8h1v1z",
    fill: "#a37c52",
    fillOpacity: 0.918
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M124 9h-1V8h1z",
    fill: "#a88157",
    fillOpacity: 0.898
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M125 8v1h-1V8z",
    fill: "#ae8454"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M125 9V8h1v1z",
    fill: "#ab7c59"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M127 9h-1V8h1z",
    fill: "#a17758"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M127 9V8h1v1z",
    fill: "#896c56",
    fillOpacity: 0.314
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M95 9v1h-1V9z",
    fill: "#a5896f",
    fillOpacity: 0.314
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M95 10V9h1v1z",
    fill: "#b58d68"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M97 9v1h-1V9z",
    fill: "#aa835d"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M98 10h-1V9h1z",
    fill: "#9f754d"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M98 9h1v1h-1z",
    fill: "#ae875b"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M100 9v1h-1V9z",
    fill: "#b18a60"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M100 10V9h1v1z",
    fill: "#b48b64"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M102 9v1h-1V9z",
    fill: "#b58b66"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M103 10h-1V9h1z",
    fill: "#b18b68"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M104 10h-1V9h1z",
    fill: "#b08e6b"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M105 10h-1V9h1z",
    fill: "#b39172"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M106 9h1v1h-1z",
    fill: "#ae8c71"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M107 10V9h1v1z",
    fill: "#b18d6f"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M108 9h1v1h-1z",
    fill: "#b28c6a"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M110 10h-1V9h1z",
    fill: "#b18a67"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M111 10h-1V9h1z",
    fill: "#af8964"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M112 9v1h-1V9z",
    fill: "#ad885f"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M112 9h1v1h-1z",
    fill: "#ad885e"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M114 9v1h-1V9z",
    fill: "#b08a5e"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M115 9v1h-1V9z",
    fill: "#ae895b"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M115 9h1v1h-1z",
    fill: "#ab8457"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M117 9v1h-1V9z",
    fill: "#a88355"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M117 9h1v1h-1z",
    fill: "#a88254"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M118 10V9h1v1z",
    fill: "#a78151"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M119 9h1v1h-1z",
    fill: "#a67f4e"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M120 9h1v1h-1z",
    fill: "#a47f4e"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M121 9h1v1h-1z",
    fill: "#a27d4d"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M123 10h-1V9h1z",
    fill: "#aa8355"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M123 10V9h1v1z",
    fill: "#ae865a"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M124 9h1v1h-1z",
    fill: "#aa8256"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M126 10h-1V9h1z",
    fill: "#a57a56"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M126 9h1v1h-1z",
    fill: "#9f7756",
    fillOpacity: 0.945
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M127 9h1v1h-1z",
    fill: "#887058",
    fillOpacity: 0.169
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M95 11h-1v-1h1z",
    fill: "#a48e73",
    fillOpacity: 0.365
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M96 10v1h-1v-1z",
    fill: "#b18b67"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M96 11v-1h1v1z",
    fill: "#a9805a"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M98 10v1h-1v-1z",
    fill: "#8f6748",
    fillOpacity: 0.914
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M98 11v-1h1v1z",
    fill: "#957955",
    fillOpacity: 0.722
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M99 10h1v1h-1z",
    fill: "#9a7e5a",
    fillOpacity: 0.804
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M100 10h1v1h-1z",
    fill: "#9d7e5d",
    fillOpacity: 0.871
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M101 11v-1h1v1z",
    fill: "#a28262",
    fillOpacity: 0.925
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M103 10v1h-1v-1z",
    fill: "#a78565",
    fillOpacity: 0.957
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M103 10h1v1h-1z",
    fill: "#aa8769",
    fillOpacity: 0.988
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M105 11h-1v-1h1z",
    fill: "#b08e71"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M106 10v1h-1v-1z",
    fill: "#b49075"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M106 11v-1h1v1z",
    fill: "#b59277"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M108 10v1h-1v-1z",
    fill: "#b69378"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M108 10h1v1h-1z",
    fill: "#b79274"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M109 11v-1h1v1z",
    fill: "#b38d6c"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M111 11h-1v-1h1z",
    fill: "#af8a64"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M111 11v-1h1v1z",
    fill: "#af8a62"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M113 10v1h-1v-1z",
    fill: "#af8961"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M113 10h1v1h-1z",
    fill: "#af885f"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M115 10h1v1h-1z",
    fill: "#ab8253"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M118 11v-1h1v1z",
    fill: "#ab8353"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M121 10v1h-1v-1z",
    fill: "#a48051"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M122 10v1h-1v-1z",
    fill: "#a27f4f"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M122 11v-1h1v1z",
    fill: "#a88354"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M123 10h1v1h-1z",
    fill: "#ab865d"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M125 11h-1v-1h1z",
    fill: "#a78059"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M125 10h1v1h-1z",
    fill: "#a77c57"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M127 10v1h-1v-1z",
    fill: "#9c7556",
    fillOpacity: 0.839
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M95 11v1h-1v-1z",
    fill: "#a48b71",
    fillOpacity: 0.388
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M96 12h-1v-1h1z",
    fill: "#ad8864"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M97 12h-1v-1h1z",
    fill: "#a9825f"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M97 11h1v1h-1z",
    fill: "#957763",
    fillOpacity: 0.702
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M101 11h1v1h-1z",
    fill: "#847171",
    fillOpacity: 0.106
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M103 12h-1v-1h1z",
    fill: "#967c68",
    fillOpacity: 0.153
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M104 12h-1v-1h1z",
    fill: "#947d61",
    fillOpacity: 0.216
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M105 11v1h-1v-1z",
    fill: "#998168",
    fillOpacity: 0.286
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M105 12v-1h1v1z",
    fill: "#977e6a",
    fillOpacity: 0.349
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M107 11v1h-1v-1z",
    fill: "#9a7b64",
    fillOpacity: 0.427
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M108 12h-1v-1h1z",
    fill: "#9f7e67",
    fillOpacity: 0.514
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M108 12v-1h1v1z",
    fill: "#a5856c",
    fillOpacity: 0.6
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M110 12h-1v-1h1z",
    fill: "#a28064",
    fillOpacity: 0.678
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M111 12h-1v-1h1z",
    fill: "#a07f5f",
    fillOpacity: 0.753
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M111 11h1v1h-1z",
    fill: "#a1815d",
    fillOpacity: 0.82
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M113 12h-1v-1h1z",
    fill: "#a2815c",
    fillOpacity: 0.878
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M113 12v-1h1v1z",
    fill: "#a38058",
    fillOpacity: 0.922
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M114 12v-1h1v1z",
    fill: "#a5805a",
    fillOpacity: 0.957
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M115 12v-1h1v1z",
    fill: "#a27f5a",
    fillOpacity: 0.98
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M117 11v1h-1v-1z",
    fill: "#a58159"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M117 12v-1h1v1z",
    fill: "#ab8458"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M118 11h1v1h-1z",
    fill: "#ad8458"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M120 11v1h-1v-1z",
    fill: "#b1865a"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M120 12v-1h1v1z",
    fill: "#ad8658"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M121 11h1v1h-1z",
    fill: "#ac8555"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M123 11v1h-1v-1z",
    fill: "#ab8455"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M123 11h1v1h-1z",
    fill: "#ac875f"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M124 11h1v1h-1z",
    fill: "#a67c5a"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M127 11v1h-1v-1z",
    fill: "#997756",
    fillOpacity: 0.678
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M95 12v1h-1v-1z",
    fill: "#a1866e",
    fillOpacity: 0.408
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M96 13h-1v-1h1z",
    fill: "#ac8660"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M97 12v1h-1v-1z",
    fill: "#aa8260"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M98 13h-1v-1h1z",
    fill: "#997e6a",
    fillOpacity: 0.682
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M113 12h1v1h-1z",
    fill: "#847a66",
    fillOpacity: 0.098
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M115 13h-1v-1h1z",
    fill: "#8a745e",
    fillOpacity: 0.137
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M115 12h1v1h-1z",
    fill: "#8f7a5f",
    fillOpacity: 0.188
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M116 13v-1h1v1z",
    fill: "#93775b",
    fillOpacity: 0.251
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M118 12v1h-1v-1z",
    fill: "#977d5e",
    fillOpacity: 0.318
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M119 13h-1v-1h1z",
    fill: "#967a5b",
    fillOpacity: 0.384
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M119 12h1v1h-1z",
    fill: "#997857",
    fillOpacity: 0.455
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M120 12h1v1h-1z",
    fill: "#977959",
    fillOpacity: 0.502
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M121 13v-1h1v1z",
    fill: "#987a58",
    fillOpacity: 0.545
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M123 13h-1v-1h1z",
    fill: "#a9825a",
    fillOpacity: 0.902
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M124 12v1h-1v-1z",
    fill: "#af8862"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M124 12h1v1h-1z",
    fill: "#a37854"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M126 13h-1v-1h1z",
    fill: "#ad835f"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M127 12v1h-1v-1z",
    fill: "#9d7b5b",
    fillOpacity: 0.471
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M94 13h1v1h-1z",
    fill: "#a1856b",
    fillOpacity: 0.427
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M96 13v1h-1v-1z",
    fill: "#aa825c"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M96 13h1v1h-1z",
    fill: "#aa815e"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M98 13v1h-1v-1z",
    fill: "#997c67",
    fillOpacity: 0.659
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M122 14v-1h1v1z",
    fill: "#a4866a",
    fillOpacity: 0.816
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M123 13h1v1h-1z",
    fill: "#b08963"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M124 13h1v1h-1z",
    fill: "#a37953"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M125 14v-1h1v1z",
    fill: "#a8815f"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M127 13v1h-1v-1z",
    fill: "#9e7a5d",
    fillOpacity: 0.278
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M95 14v1h-1v-1z",
    fill: "#9b7d66",
    fillOpacity: 0.471
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M95 15v-1h1v1z",
    fill: "#a87f57"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M97 15h-1v-1h1z",
    fill: "#aa805d"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M97 15v-1h1v1z",
    fill: "#997d68",
    fillOpacity: 0.631
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M121 15v-1h1v1z",
    fill: "#9d8778",
    fillOpacity: 0.133
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M123 15h-1v-1h1z",
    fill: "#a68766",
    fillOpacity: 0.945
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M123 15v-1h1v1z",
    fill: "#ac835b"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M124 14h1v1h-1z",
    fill: "#a87d58"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M126 14v1h-1v-1z",
    fill: "#a47f5e",
    fillOpacity: 0.941
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M126 14h1v1h-1z",
    fill: "#976",
    fillOpacity: 0.118
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M94 15h1v1h-1z",
    fill: "#997b61",
    fillOpacity: 0.502
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M96 16h-1v-1h1z",
    fill: "#a77c53"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M96 16v-1h1v1z",
    fill: "#a87d5a"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M98 15v1h-1v-1z",
    fill: "#957964",
    fillOpacity: 0.608
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M122 15v1h-1v-1z",
    fill: "#907864",
    fillOpacity: 0.298
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M122 16v-1h1v1z",
    fill: "#a27e5d"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M123 16v-1h1v1z",
    fill: "#a77951"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M125 16h-1v-1h1z",
    fill: "#ac7f5d"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M125 15h1v1h-1z",
    fill: "#a57d5e",
    fillOpacity: 0.816
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M94 16h1v1h-1z",
    fill: "#997b5f",
    fillOpacity: 0.533
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M96 16v1h-1v-1z",
    fill: "#a67b51"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M97 17h-1v-1h1z",
    fill: "#a87b59"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M97 17v-1h1v1z",
    fill: "#947460",
    fillOpacity: 0.6
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M121 16h1v1h-1z",
    fill: "#97775f",
    fillOpacity: 0.494
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M123 16v1h-1v-1z",
    fill: "#ac7e57"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M123 16h1v1h-1z",
    fill: "#a67a53"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M125 16v1h-1v-1z",
    fill: "#af835f"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M125 17v-1h1v1z",
    fill: "#a47e60",
    fillOpacity: 0.671
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M95 18h-1v-1h1z",
    fill: "#97795a",
    fillOpacity: 0.553
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M96 18h-1v-1h1z",
    fill: "#a37a4e"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M96 17h1v1h-1z",
    fill: "#a47858"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M97 17h1v1h-1z",
    fill: "#92715f",
    fillOpacity: 0.565
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M121 18v-1h1v1z",
    fill: "#987858",
    fillOpacity: 0.675
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M122 17h1v1h-1z",
    fill: "#aa7e51"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M124 18h-1v-1h1z",
    fill: "#a87f59"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M125 18h-1v-1h1z",
    fill: "#b18560"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M125 17h1v1h-1z",
    fill: "#9e7b60",
    fillOpacity: 0.478
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M61 18h1v1h-1z",
    fill: "#958c7b",
    fillOpacity: 0.114
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M63 19h-1v-1h1z",
    fill: "#978579",
    fillOpacity: 0.165
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M63 18h1v1h-1z",
    fill: "#97847a",
    fillOpacity: 0.106
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M64 19v-1h1v1z",
    fill: "#9c8975",
    fillOpacity: 0.051
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M94 18h1v1h-1z",
    fill: "#9c785d",
    fillOpacity: 0.557
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M96 18v1h-1v-1z",
    fill: "#a6774e"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M96 18h1v1h-1z",
    fill: "#9d7049"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M98 18v1h-1v-1z",
    fill: "#8b6340",
    fillOpacity: 0.831
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M98 19v-1h1v1z",
    fill: "#916e48",
    fillOpacity: 0.631
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M100 19h-1v-1h1z",
    fill: "#916d43",
    fillOpacity: 0.682
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M101 18v1h-1v-1z",
    fill: "#916f47",
    fillOpacity: 0.765
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M101 18h1v1h-1z",
    fill: "#967450",
    fillOpacity: 0.8
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M103 18v1h-1v-1z",
    fill: "#977356",
    fillOpacity: 0.82
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M103 18h1v1h-1z",
    fill: "#987459",
    fillOpacity: 0.831
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M105 19h-1v-1h1z",
    fill: "#987458",
    fillOpacity: 0.839
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M106 19h-1v-1h1z",
    fill: "#987458",
    fillOpacity: 0.835
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M106 18h1v1h-1z",
    fill: "#967256",
    fillOpacity: 0.82
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M108 19h-1v-1h1z",
    fill: "#937155",
    fillOpacity: 0.8
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M108 19v-1h1v1z",
    fill: "#906f50",
    fillOpacity: 0.745
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M109 19v-1h1v1z",
    fill: "#947050",
    fillOpacity: 0.682
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M110 19v-1h1v1z",
    fill: "#92714e",
    fillOpacity: 0.627
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M111 18h1v1h-1z",
    fill: "#8b6e47",
    fillOpacity: 0.518
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M113 19h-1v-1h1z",
    fill: "#8e704b",
    fillOpacity: 0.4
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M113 19v-1h1v1z",
    fill: "#8e704e",
    fillOpacity: 0.267
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M115 18v1h-1v-1z",
    fill: "#998366",
    fillOpacity: 0.137
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M121 18h1v1h-1z",
    fill: "#9b7659",
    fillOpacity: 0.827
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M123 19h-1v-1h1z",
    fill: "#aa7b53"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M123 18h1v1h-1z",
    fill: "#ab815c"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M124 19v-1h1v1z",
    fill: "#ac825f"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M126 18v1h-1v-1z",
    fill: "#99785e",
    fillOpacity: 0.306
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M1 19h1v1H1z",
    fill: "#a68e7a",
    fillOpacity: 0.294
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M3 20H2v-1h1z",
    fill: "#a88d71",
    fillOpacity: 0.404
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M3 20v-1h1v1z",
    fill: "#8b7358",
    fillOpacity: 0.259
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20v-1h1v1z",
    fill: "#6d6d5b",
    fillOpacity: 0.055
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M56 19v1h-1v-1z",
    fill: "#9c9c9c",
    fillOpacity: 0.051
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M57 20h-1v-1h1z",
    fill: "#9b8f82",
    fillOpacity: 0.161
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M58 20h-1v-1h1z",
    fill: "#9e8e7d",
    fillOpacity: 0.31
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M59 20h-1v-1h1z",
    fill: "#9d8a7a",
    fillOpacity: 0.49
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M60 20h-1v-1h1z",
    fill: "#998a76",
    fillOpacity: 0.667
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M61 19v1h-1v-1z",
    fill: "#9a8a73",
    fillOpacity: 0.824
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M61 19h1v1h-1z",
    fill: "#9d8970",
    fillOpacity: 0.925
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M62 19h1v1h-1z",
    fill: "#9e866d",
    fillOpacity: 0.965
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M64 19v1h-1v-1z",
    fill: "#9d856e",
    fillOpacity: 0.925
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M64 19h1v1h-1z",
    fill: "#9f866f",
    fillOpacity: 0.863
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M66 20h-1v-1h1z",
    fill: "#9a836d",
    fillOpacity: 0.804
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M67 20h-1v-1h1z",
    fill: "#97846e",
    fillOpacity: 0.718
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M67 19h1v1h-1z",
    fill: "#998670",
    fillOpacity: 0.612
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M68 20v-1h1v1z",
    fill: "#968370",
    fillOpacity: 0.518
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M70 19v1h-1v-1z",
    fill: "#958471",
    fillOpacity: 0.416
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M71 19v1h-1v-1z",
    fill: "#95856f",
    fillOpacity: 0.314
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M72 20h-1v-1h1z",
    fill: "#8c7f6d",
    fillOpacity: 0.227
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M73 20h-1v-1h1z",
    fill: "#938678",
    fillOpacity: 0.149
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M75 20h-1v-1h1z",
    fill: "#9191b6",
    fillOpacity: 0.027
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M95 19v1h-1v-1z",
    fill: "#9b735c",
    fillOpacity: 0.565
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M96 20h-1v-1h1z",
    fill: "#a8744d"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M96 19h1v1h-1z",
    fill: "#986b3e"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M97 20v-1h1v1z",
    fill: "#946332"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M99 20h-1v-1h1z",
    fill: "#a06e42"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M100 19v1h-1v-1z",
    fill: "#9e6c40"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M101 20h-1v-1h1z",
    fill: "#a06e46"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M101 19h1v1h-1z",
    fill: "#a47254"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M103 20h-1v-1h1z",
    fill: "#a5785d"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M104 20h-1v-1h1z",
    fill: "#a67d62"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M104 19h1v1h-1z",
    fill: "#a77e63"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M108 19v1h-1v-1z",
    fill: "#a67e61"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M109 20h-1v-1h1z",
    fill: "#a27b59"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M109 19h1v1h-1z",
    fill: "#a27854"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M111 20h-1v-1h1z",
    fill: "#a1764f"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M111 20v-1h1v1z",
    fill: "#9e7347"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M112 19h1v1h-1z",
    fill: "#9b7143"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M114 19v1h-1v-1z",
    fill: "#976e45"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M114 19h1v1h-1z",
    fill: "#99714a",
    fillOpacity: 0.945
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M115 19h1v1h-1z",
    fill: "#987246",
    fillOpacity: 0.847
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M116 20v-1h1v1z",
    fill: "#926f46",
    fillOpacity: 0.671
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M117 19h1v1h-1z",
    fill: "#8e704a",
    fillOpacity: 0.455
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M119 19v1h-1v-1z",
    fill: "#8a6f4c",
    fillOpacity: 0.224
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M119 19h1v1h-1z",
    fill: "#7f7f66",
    fillOpacity: 0.039
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M120 19h1v1h-1z",
    fill: "#887f7f",
    fillOpacity: 0.11
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M121 20v-1h1v1z",
    fill: "#a07652",
    fillOpacity: 0.945
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M123 19v1h-1v-1z",
    fill: "#a77b4f"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M124 20h-1v-1h1z",
    fill: "#ae835f"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M124 19h1v1h-1z",
    fill: "#a87f5e",
    fillOpacity: 0.957
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M125 19h1v1h-1z",
    fill: "#9c7c62",
    fillOpacity: 0.153
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M0 21v-1h1v1z",
    fill: "#bca89c",
    fillOpacity: 0.345
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M2 21H1v-1h1z",
    fill: "#c5a691"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M3 21H2v-1h1z",
    fill: "#b58f6d"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M3 20h1v1H3z",
    fill: "#7f5a34"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M5 20v1H4v-1z",
    fill: "#73523b",
    fillOpacity: 0.796
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M6 21H5v-1h1z",
    fill: "#674f47",
    fillOpacity: 0.125
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M50 20h1v1h-1z",
    fill: "#9b9085",
    fillOpacity: 0.09
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M52 21h-1v-1h1z",
    fill: "#9d8f7d",
    fillOpacity: 0.216
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M53 20v1h-1v-1z",
    fill: "#9c8c75",
    fillOpacity: 0.384
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M53 21v-1h1v1z",
    fill: "#9a8a74",
    fillOpacity: 0.557
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M55 20v1h-1v-1z",
    fill: "#9b8a77",
    fillOpacity: 0.722
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M55 20h1v1h-1z",
    fill: "#9b8976",
    fillOpacity: 0.863
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M57 21h-1v-1h1z",
    fill: "#9d8976",
    fillOpacity: 0.965
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M57 21v-1h1v1z",
    fill: "#a38c74"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M59 21h-1v-1h1z",
    fill: "#a78f74"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M60 20v1h-1v-1z",
    fill: "#a78e72"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M60 20h1v1h-1z",
    fill: "#a68c71"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M62 21h-1v-1h1z",
    fill: "#a48a70"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M63 20v1h-1v-1z",
    fill: "#a38a70"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M63 21v-1h1v1z",
    fill: "#a48b71"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M65 21h-1v-1h1z",
    fill: "#a58c73"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M65 21v-1h1v1z",
    fill: "#a78d72"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M67 20v1h-1v-1z",
    fill: "#aa8d71"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M67 21v-1h1v1z",
    fill: "#a98e72"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M68 20h1v1h-1z",
    fill: "#a78d73"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M70 21h-1v-1h1z",
    fill: "#a58c72"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M70 21v-1h1v1z",
    fill: "#a28970"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M71 20h1v1h-1z",
    fill: "#9d866e"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M72 20h1v1h-1z",
    fill: "#9c856e",
    fillOpacity: 0.961
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M73 20h1v1h-1z",
    fill: "#9d866f",
    fillOpacity: 0.894
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M75 21h-1v-1h1z",
    fill: "#9d8771",
    fillOpacity: 0.82
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M76 21h-1v-1h1z",
    fill: "#9c856e",
    fillOpacity: 0.749
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M77 21h-1v-1h1z",
    fill: "#9e876f",
    fillOpacity: 0.655
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M78 21h-1v-1h1z",
    fill: "#9a8369",
    fillOpacity: 0.557
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M79 20v1h-1v-1z",
    fill: "#968066",
    fillOpacity: 0.459
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M79 20h1v1h-1z",
    fill: "#99856b",
    fillOpacity: 0.345
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M81 20v1h-1v-1z",
    fill: "#97876f",
    fillOpacity: 0.251
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M81 21v-1h1v1z",
    fill: "#978573",
    fillOpacity: 0.165
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M82 20h1v1h-1z",
    fill: "#9b8579",
    fillOpacity: 0.09
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M95 21h-1v-1h1z",
    fill: "#957053",
    fillOpacity: 0.561
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M95 20h1v1h-1z",
    fill: "#a3734d"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M98 20v1h-1v-1z",
    fill: "#915d31"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M99 20v1h-1v-1z",
    fill: "#996a3f"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M99 21v-1h1v1z",
    fill: "#976a3d"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M101 20v1h-1v-1z",
    fill: "#996c42"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M101 21v-1h1v1z",
    fill: "#9e704b"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M103 20v1h-1v-1z",
    fill: "#a47756"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M103 20h1v1h-1z",
    fill: "#a5795b"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M105 21h-1v-1h1z",
    fill: "#a47a5d"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M106 20v1h-1v-1z",
    fill: "#a37c5f"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M107 21h-1v-1h1z",
    fill: "#a17b5f"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M107 20h1v1h-1z",
    fill: "#9f775b"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M109 20v1h-1v-1z",
    fill: "#9e7655"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M110 20v1h-1v-1z",
    fill: "#a0764f"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M110 21v-1h1v1z",
    fill: "#9e744b"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M112 21h-1v-1h1z",
    fill: "#9a7146"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M113 20v1h-1v-1z",
    fill: "#986d3e"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M113 21v-1h1v1z",
    fill: "#9a6d3e"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M114 20h1v1h-1z",
    fill: "#9e7143"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M116 21h-1v-1h1z",
    fill: "#9d7142"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M117 21h-1v-1h1z",
    fill: "#9d703f"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M118 20v1h-1v-1z",
    fill: "#9c6d3e"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M119 21h-1v-1h1z",
    fill: "#93683e",
    fillOpacity: 0.992
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M120 20v1h-1v-1z",
    fill: "#89663f",
    fillOpacity: 0.831
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M120 21v-1h1v1z",
    fill: "#926e47",
    fillOpacity: 0.725
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M122 20v1h-1v-1z",
    fill: "#a0734d",
    fillOpacity: 0.992
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M122 20h1v1h-1z",
    fill: "#a47a59"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M123 20h1v1h-1z",
    fill: "#b28360"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M125 20v1h-1v-1z",
    fill: "#a8805d",
    fillOpacity: 0.859
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M1 22H0v-1h1z",
    fill: "#ab9282",
    fillOpacity: 0.361
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M1 21h1v1H1z",
    fill: "#be9a83"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M2 21h1v1H2z",
    fill: "#9d7457"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M4 21v1H3v-1z",
    fill: "#7f512a"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M4 22v-1h1v1z",
    fill: "#875833"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M6 21v1H5v-1z",
    fill: "#7e5e46",
    fillOpacity: 0.655
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M7 22H6v-1h1z",
    fill: "#c3b4a5",
    fillOpacity: 0.067
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M8 22H7v-1h1z",
    fill: "#ccc",
    fillOpacity: 0.059
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M9 22v-1h1v1z",
    fill: "#c8c8c8",
    fillOpacity: 0.055
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M11 21v1h-1v-1z",
    fill: "#ccb",
    fillOpacity: 0.059
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21h1v1h-1z",
    fill: "#c3b4b4",
    fillOpacity: 0.067
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M13 21h1v1h-1z",
    fill: "#b6b6a3",
    fillOpacity: 0.055
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M44 21h1v1h-1z",
    fill: "#a2a28b",
    fillOpacity: 0.043
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M45 22v-1h1v1z",
    fill: "#9b8d86",
    fillOpacity: 0.141
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M47 21v1h-1v-1z",
    fill: "#95867b",
    fillOpacity: 0.275
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M47 22v-1h1v1z",
    fill: "#9b8b79",
    fillOpacity: 0.443
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M49 21v1h-1v-1z",
    fill: "#978974",
    fillOpacity: 0.627
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M50 21v1h-1v-1z",
    fill: "#998a74",
    fillOpacity: 0.796
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M51 21v1h-1v-1z",
    fill: "#9c8a77",
    fillOpacity: 0.914
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M52 21v1h-1v-1z",
    fill: "#9e8b75",
    fillOpacity: 0.988
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M52 21h1v1h-1z",
    fill: "#a89174"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M54 22h-1v-1h1z",
    fill: "#a99376"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M55 21v1h-1v-1z",
    fill: "#a89276"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M55 21h1v1h-1z",
    fill: "#a48e72"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M58 22h-1v-1h1z",
    fill: "#a28a70"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M58 21h1v1h-1z",
    fill: "#a28a6f"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M59 22v-1h1v1z",
    fill: "#a0886c"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M61 22h-1v-1h1z",
    fill: "#9f886b"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M62 22h-1v-1h1z",
    fill: "#9f876a"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M65 22h-1v-1h1z",
    fill: "#a0866a"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M67 22v-1h1v1z",
    fill: "#a0876b"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M69 22v-1h1v1z",
    fill: "#a1876b"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M70 21h1v1h-1z",
    fill: "#a2886b"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M71 21h1v1h-1z",
    fill: "#a2896c"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M73 21v1h-1v-1z",
    fill: "#a48a6c"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M73 21h1v1h-1z",
    fill: "#a58b6c"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M77 22h-1v-1h1z",
    fill: "#a68b6b"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M78 22h-1v-1h1z",
    fill: "#a68b69"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M78 21h1v1h-1z",
    fill: "#a58b69"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M79 21h1v1h-1z",
    fill: "#a28869"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M81 21v1h-1v-1z",
    fill: "#9b8567"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M81 21h1v1h-1z",
    fill: "#998367",
    fillOpacity: 0.965
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M82 21h1v1h-1z",
    fill: "#998464",
    fillOpacity: 0.914
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M84 21v1h-1v-1z",
    fill: "#988465",
    fillOpacity: 0.847
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M85 21v1h-1v-1z",
    fill: "#968164",
    fillOpacity: 0.757
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M85 22v-1h1v1z",
    fill: "#948164",
    fillOpacity: 0.686
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M86 21h1v1h-1z",
    fill: "#968468",
    fillOpacity: 0.565
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M88 22h-1v-1h1z",
    fill: "#938162",
    fillOpacity: 0.455
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M89 22h-1v-1h1z",
    fill: "#918064",
    fillOpacity: 0.357
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M90 21v1h-1v-1z",
    fill: "#8b775b",
    fillOpacity: 0.251
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M91 22h-1v-1h1z",
    fill: "#8e7c64",
    fillOpacity: 0.169
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M91 21h1v1h-1z",
    fill: "#937f6b",
    fillOpacity: 0.102
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M92 21h1v1h-1z",
    fill: "#9c8989",
    fillOpacity: 0.051
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M94 21h1v1h-1z",
    fill: "#916d4c",
    fillOpacity: 0.565
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M96 22h-1v-1h1z",
    fill: "#a36e41"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M97 21v1h-1v-1z",
    fill: "#976237"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M97 22v-1h1v1z",
    fill: "#7d523a",
    fillOpacity: 0.655
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M99 22h-1v-1h1z",
    fill: "#755534",
    fillOpacity: 0.306
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M99 21h1v1h-1z",
    fill: "#775435",
    fillOpacity: 0.392
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M101 22h-1v-1h1z",
    fill: "#7e5838",
    fillOpacity: 0.498
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M101 21h1v1h-1z",
    fill: "#845838",
    fillOpacity: 0.588
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M102 22v-1h1v1z",
    fill: "#835a3b",
    fillOpacity: 0.686
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M104 21v1h-1v-1z",
    fill: "#856143",
    fillOpacity: 0.773
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M104 22v-1h1v1z",
    fill: "#8c6848",
    fillOpacity: 0.839
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M105 22v-1h1v1z",
    fill: "#8f6a4a",
    fillOpacity: 0.898
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M106 21h1v1h-1z",
    fill: "#956e4c",
    fillOpacity: 0.941
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M108 21v1h-1v-1z",
    fill: "#966d4b",
    fillOpacity: 0.984
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M108 22v-1h1v1z",
    fill: "#99724e"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M110 22h-1v-1h1z",
    fill: "#9b7650"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M111 22h-1v-1h1z",
    fill: "#9b7348"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M113 21v1h-1v-1z",
    fill: "#996a3c"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M114 21v1h-1v-1z",
    fill: "#986b3b"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M114 21h1v1h-1z",
    fill: "#9f7141"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M115 22v-1h1v1z",
    fill: "#9d6e3e"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M116 22v-1h1v1z",
    fill: "#996c3b"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M117 22v-1h1v1z",
    fill: "#966b3d"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M119 21v1h-1v-1z",
    fill: "#966a3e"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M119 21h1v1h-1z",
    fill: "#99693e"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M120 22v-1h1v1z",
    fill: "#9e7044"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M121 22v-1h1v1z",
    fill: "#9d704a"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M123 22h-1v-1h1z",
    fill: "#a27757"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M124 21v1h-1v-1z",
    fill: "#b58560"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M124 21h1v1h-1z",
    fill: "#a7805e",
    fillOpacity: 0.71
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M0 23v-1h1v1z",
    fill: "#99886b",
    fillOpacity: 0.176
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M2 22v1H1v-1z",
    fill: "#aa8568",
    fillOpacity: 0.953
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M2 22h1v1H2z",
    fill: "#976c4a"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M4 22v1H3v-1z",
    fill: "#764a22"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M4 23v-1h1v1z",
    fill: "#8d5f38"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M5 23v-1h1v1z",
    fill: "#b18468",
    fillOpacity: 0.996
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M7 22v1H6v-1z",
    fill: "#bd9380",
    fillOpacity: 0.875
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M7 23v-1h1v1z",
    fill: "#bc9680",
    fillOpacity: 0.871
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M8 22h1v1H8z",
    fill: "#bc9582",
    fillOpacity: 0.875
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M10 23H9v-1h1z",
    fill: "#be9481",
    fillOpacity: 0.863
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M11 22v1h-1v-1z",
    fill: "#bd9380",
    fillOpacity: 0.867
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M11 22h1v1h-1z",
    fill: "#ba917c",
    fillOpacity: 0.875
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M13 22v1h-1v-1z",
    fill: "#b88d75",
    fillOpacity: 0.878
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M13 22h1v1h-1z",
    fill: "#b2896f",
    fillOpacity: 0.863
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M15 22v1h-1v-1z",
    fill: "#af886c",
    fillOpacity: 0.82
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M15 23v-1h1v1z",
    fill: "#aa8468",
    fillOpacity: 0.784
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M17 22v1h-1v-1z",
    fill: "#a28063",
    fillOpacity: 0.737
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M17 22h1v1h-1z",
    fill: "#9c7e5e",
    fillOpacity: 0.667
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22h1v1h-1z",
    fill: "#9b7e5e",
    fillOpacity: 0.592
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M20 22v1h-1v-1z",
    fill: "#997d5d",
    fillOpacity: 0.494
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M20 22h1v1h-1z",
    fill: "#9a7e5f",
    fillOpacity: 0.388
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M22 23h-1v-1h1z",
    fill: "#a08868",
    fillOpacity: 0.286
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M22 23v-1h1v1z",
    fill: "#a0906e",
    fillOpacity: 0.18
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M24 23h-1v-1h1z",
    fill: "#aa9d79",
    fillOpacity: 0.082
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M39 22h1v1h-1z",
    fill: "#aa9b8d",
    fillOpacity: 0.071
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M41 23h-1v-1h1z",
    fill: "#9e8e7f",
    fillOpacity: 0.196
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M42 22v1h-1v-1z",
    fill: "#a19280",
    fillOpacity: 0.341
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M42 23v-1h1v1z",
    fill: "#9c8b7f",
    fillOpacity: 0.518
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M43 23v-1h1v1z",
    fill: "#9c8979",
    fillOpacity: 0.698
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M45 23h-1v-1h1z",
    fill: "#9e8b75",
    fillOpacity: 0.843
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M45 22h1v1h-1z",
    fill: "#a08c76",
    fillOpacity: 0.949
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M46 22h1v1h-1z",
    fill: "#a08c75"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M48 23h-1v-1h1z",
    fill: "#a48e75"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M48 23v-1h1v1z",
    fill: "#a58e74"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M52 22v1h-1v-1z",
    fill: "#a48c70"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M52 22h1v1h-1z",
    fill: "#a48b6e"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M53 23v-1h1v1z",
    fill: "#a18b6f"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M55 23h-1v-1h1z",
    fill: "#9f896f"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M56 22v1h-1v-1z",
    fill: "#a0896e"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M57 23h-1v-1h1z",
    fill: "#a1896f"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M58 22v1h-1v-1z",
    fill: "#a18971"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M58 23v-1h1v1z",
    fill: "#a18970"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M59 23v-1h1v1z",
    fill: "#a1896d"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M61 23v-1h1v1z",
    fill: "#a1896a"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M65 22v1h-1v-1z",
    fill: "#a18869"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M69 23h-1v-1h1z",
    fill: "#a08766"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M70 22v1h-1v-1z",
    fill: "#9f8665"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M71 22v1h-1v-1z",
    fill: "#9e8766"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M72 23h-1v-1h1z",
    fill: "#9f8765"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M72 23v-1h1v1z",
    fill: "#9e8764"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M75 23h-1v-1h1z",
    fill: "#9e8665"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M77 22v1h-1v-1z",
    fill: "#9d8563"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M81 23h-1v-1h1z",
    fill: "#9d8460"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M83 23v-1h1v1z",
    fill: "#9d8261"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M84 23v-1h1v1z",
    fill: "#9d805f"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M87 23h-1v-1h1z",
    fill: "#9f845d"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M88 23h-1v-1h1z",
    fill: "#9f845c"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M88 22h1v1h-1z",
    fill: "#9d825b"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M90 22v1h-1v-1z",
    fill: "#997e59"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M91 23h-1v-1h1z",
    fill: "#967a55",
    fillOpacity: 0.973
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M91 23v-1h1v1z",
    fill: "#917450",
    fillOpacity: 0.922
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M93 22v1h-1v-1z",
    fill: "#917250",
    fillOpacity: 0.855
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M93 23v-1h1v1z",
    fill: "#927452",
    fillOpacity: 0.765
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M94 23v-1h1v1z",
    fill: "#946d43",
    fillOpacity: 0.898
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M96 23h-1v-1h1z",
    fill: "#9d6734"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M96 23v-1h1v1z",
    fill: "#966634"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M97 22h1v1h-1z",
    fill: "#8d6946",
    fillOpacity: 0.69
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M99 22v1h-1v-1z",
    fill: "#8f7756",
    fillOpacity: 0.243
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M100 23h-1v-1h1z",
    fill: "#977f61",
    fillOpacity: 0.165
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M101 22v1h-1v-1z",
    fill: "#998c66",
    fillOpacity: 0.078
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M106 22v1h-1v-1z",
    fill: "#454545",
    fillOpacity: 0.043
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M106 23v-1h1v1z",
    fill: "#74554a",
    fillOpacity: 0.094
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M107 23v-1h1v1z",
    fill: "#705841",
    fillOpacity: 0.169
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M108 22h1v1h-1z",
    fill: "#795e46",
    fillOpacity: 0.255
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M110 23h-1v-1h1z",
    fill: "#7c6044",
    fillOpacity: 0.353
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M111 22v1h-1v-1z",
    fill: "#7e5f3e",
    fillOpacity: 0.451
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M111 23v-1h1v1z",
    fill: "#855f3b",
    fillOpacity: 0.553
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M113 22v1h-1v-1z",
    fill: "#84613c",
    fillOpacity: 0.659
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M114 23h-1v-1h1z",
    fill: "#87613d",
    fillOpacity: 0.761
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M114 22h1v1h-1z",
    fill: "#8c6540",
    fillOpacity: 0.847
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M116 22v1h-1v-1z",
    fill: "#8f6640",
    fillOpacity: 0.922
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M117 23h-1v-1h1z",
    fill: "#8f663e",
    fillOpacity: 0.969
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M117 22h1v1h-1z",
    fill: "#91673d",
    fillOpacity: 0.996
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M119 23h-1v-1h1z",
    fill: "#93673c"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M120 23h-1v-1h1z",
    fill: "#95673f"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M120 22h1v1h-1z",
    fill: "#9b6e46"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M121 23v-1h1v1z",
    fill: "#9d6f48"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M124 23h-1v-1h1z",
    fill: "#b48662"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M125 23h-1v-1h1z",
    fill: "#a38164",
    fillOpacity: 0.549
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M0 24v-1h1v1z",
    fill: "#7f9966",
    fillOpacity: 0.039
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M2 24H1v-1h1z",
    fill: "#a88468",
    fillOpacity: 0.824
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M2 24v-1h1v1z",
    fill: "#a57957"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M3 23h1v1H3z",
    fill: "#764b24"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M5 24H4v-1h1z",
    fill: "#845430"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M6 23v1H5v-1z",
    fill: "#a77454"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M6 24v-1h1v1z",
    fill: "#b57f62"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M7 23h1v1H7z",
    fill: "#b48060"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M9 24H8v-1h1z",
    fill: "#b18062"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M9 24v-1h1v1z",
    fill: "#ae7e5f"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M11 24h-1v-1h1z",
    fill: "#ab7a58"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M13 24h-1v-1h1z",
    fill: "#a47151"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M14 23v1h-1v-1z",
    fill: "#a37051"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M16 24h-1v-1h1z",
    fill: "#9f6c4d"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M17 23h1v1h-1z",
    fill: "#97633a"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M19 23v1h-1v-1z",
    fill: "#915f35"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M21 24v-1h1v1z",
    fill: "#936339"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M23 23v1h-1v-1z",
    fill: "#90663a",
    fillOpacity: 0.973
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M23 24v-1h1v1z",
    fill: "#8e693a",
    fillOpacity: 0.91
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M24 23h1v1h-1z",
    fill: "#8e6a3c",
    fillOpacity: 0.824
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M26 23v1h-1v-1z",
    fill: "#906f44",
    fillOpacity: 0.698
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M27 24h-1v-1h1z",
    fill: "#93724c",
    fillOpacity: 0.549
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M28 23v1h-1v-1z",
    fill: "#957652",
    fillOpacity: 0.388
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M28 23h1v1h-1z",
    fill: "#987d59",
    fillOpacity: 0.224
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M29 23h1v1h-1z",
    fill: "#998e70",
    fillOpacity: 0.098
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M34 24h-1v-1h1z",
    fill: "#b0b0b0",
    fillOpacity: 0.051
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M35 24h-1v-1h1z",
    fill: "#96897c",
    fillOpacity: 0.153
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M36 23v1h-1v-1z",
    fill: "#93826e",
    fillOpacity: 0.298
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M36 24v-1h1v1z",
    fill: "#958672",
    fillOpacity: 0.455
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M38 24h-1v-1h1z",
    fill: "#99846c",
    fillOpacity: 0.62
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M38 24v-1h1v1z",
    fill: "#886f4c",
    fillOpacity: 0.761
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M40 24h-1v-1h1z",
    fill: "#91764e",
    fillOpacity: 0.894
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M41 23v1h-1v-1z",
    fill: "#977e58",
    fillOpacity: 0.98
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M41 23h1v1h-1z",
    fill: "#9c815d"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M42 23h1v1h-1z",
    fill: "#a58a70"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M44 24h-1v-1h1z",
    fill: "#aa9079"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M45 23v1h-1v-1z",
    fill: "#a88e71"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M45 24v-1h1v1z",
    fill: "#a58e6e"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M46 23h1v1h-1z",
    fill: "#a28b6d"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M48 23v1h-1v-1z",
    fill: "#a28a6e"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M49 23h1v1h-1z",
    fill: "#a48e71"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M50 24v-1h1v1z",
    fill: "#a58f6f"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M52 24h-1v-1h1z",
    fill: "#a48e6f"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M52 24v-1h1v1z",
    fill: "#a48d71"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M53 24v-1h1v1z",
    fill: "#a28c72"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M54 23h1v1h-1z",
    fill: "#a18a70"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M56 23h1v1h-1z",
    fill: "#a0876e"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M58 23v1h-1v-1z",
    fill: "#a1866e"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M59 24h-1v-1h1z",
    fill: "#a0866d"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M69 24h-1v-1h1z",
    fill: "#a18667"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M70 23v1h-1v-1z",
    fill: "#a08666"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M71 24h-1v-1h1z",
    fill: "#a18866"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M74 24h-1v-1h1z",
    fill: "#a08664"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M74 24v-1h1v1z",
    fill: "#a18664"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M76 23v1h-1v-1z",
    fill: "#a08562"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M77 24h-1v-1h1z",
    fill: "#a08561"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M77 24v-1h1v1z",
    fill: "#9f8460"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M78 23h1v1h-1z",
    fill: "#9e8560"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M79 24v-1h1v1z",
    fill: "#9d835f"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M81 24h-1v-1h1z",
    fill: "#9b815d"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M81 24v-1h1v1z",
    fill: "#9b825d"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M82 23h1v1h-1z",
    fill: "#9a825c"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M84 23v1h-1v-1z",
    fill: "#99805a"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M84 24v-1h1v1z",
    fill: "#9a7f57"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M85 23h1v1h-1z",
    fill: "#9a7e56"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M86 24v-1h1v1z",
    fill: "#9c7d57"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M87 23h1v1h-1z",
    fill: "#9b7c56"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M89 23v1h-1v-1z",
    fill: "#987a53"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M90 24h-1v-1h1z",
    fill: "#967950"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M91 24v-1h1v1z",
    fill: "#937249"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M93 23v1h-1v-1z",
    fill: "#947247"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M93 23h1v1h-1z",
    fill: "#977548"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M94 23h1v1h-1z",
    fill: "#976e3e"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M96 24h-1v-1h1z",
    fill: "#986835"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M97 24h-1v-1h1z",
    fill: "#93692e"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M98 23v1h-1v-1z",
    fill: "#976d33"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M99 24h-1v-1h1z",
    fill: "#977241"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M99 23h1v1h-1z",
    fill: "#977145",
    fillOpacity: 0.984
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M101 23v1h-1v-1z",
    fill: "#977044",
    fillOpacity: 0.937
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M102 23v1h-1v-1z",
    fill: "#966c40",
    fillOpacity: 0.867
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M103 23v1h-1v-1z",
    fill: "#926e43",
    fillOpacity: 0.784
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M103 23h1v1h-1z",
    fill: "#907045",
    fillOpacity: 0.686
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M104 23h1v1h-1z",
    fill: "#8d6f46",
    fillOpacity: 0.592
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M106 24h-1v-1h1z",
    fill: "#8e7049",
    fillOpacity: 0.49
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M106 23h1v1h-1z",
    fill: "#8f724b",
    fillOpacity: 0.384
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M108 24h-1v-1h1z",
    fill: "#967656",
    fillOpacity: 0.278
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M108 24v-1h1v1z",
    fill: "#92775c",
    fillOpacity: 0.184
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M110 23h1v1h-1z",
    fill: "#b2b299",
    fillOpacity: 0.039
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M115 24v-1h1v1z",
    fill: "#5b3636",
    fillOpacity: 0.055
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M116 23h1v1h-1z",
    fill: "#77573f",
    fillOpacity: 0.125
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M117 23h1v1h-1z",
    fill: "#815b3e",
    fillOpacity: 0.208
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M118 23h1v1h-1z",
    fill: "#846445",
    fillOpacity: 0.318
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M119 24v-1h1v1z",
    fill: "#7f6446",
    fillOpacity: 0.439
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M121 24h-1v-1h1z",
    fill: "#966d4a",
    fillOpacity: 0.894
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M121 23h1v1h-1z",
    fill: "#9f6e45"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M123 24h-1v-1h1z",
    fill: "#a47851"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M123 24v-1h1v1z",
    fill: "#af8360"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M124 23h1v1h-1z",
    fill: "#9f7f64",
    fillOpacity: 0.376
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M1 24h1v1H1z",
    fill: "#a6816b",
    fillOpacity: 0.631
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M3 24v1H2v-1z",
    fill: "#b18564"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M3 25v-1h1v1z",
    fill: "#7d502a"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M4 25v-1h1v1z",
    fill: "#814c24"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M5 25v-1h1v1z",
    fill: "#a16e48"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M6 24h1v1H6z",
    fill: "#ad7e5e"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M8 24v1H7v-1z",
    fill: "#af8366"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M8 25v-1h1v1z",
    fill: "#b08264"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M9 25v-1h1v1z",
    fill: "#ae8061"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M10 25v-1h1v1z",
    fill: "#ac7e5e"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M11 25v-1h1v1z",
    fill: "#a77755"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M13 24v1h-1v-1z",
    fill: "#a57352"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M13 25v-1h1v1z",
    fill: "#a3704f"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M14 24h1v1h-1z",
    fill: "#a16e4e"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M16 25v-1h1v1z",
    fill: "#9c6746"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M18 24v1h-1v-1z",
    fill: "#96603c"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M20 24v1h-1v-1z",
    fill: "#8e562f"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M21 25h-1v-1h1z",
    fill: "#8d572f"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M22 24v1h-1v-1z",
    fill: "#8c582f"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M22 24h1v1h-1z",
    fill: "#8b552b"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M23 25v-1h1v1z",
    fill: "#8a552a"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M25 25h-1v-1h1z",
    fill: "#8c572c"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M26 25v-1h1v1z",
    fill: "#8f5b2f"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M27 24h1v1h-1z",
    fill: "#905e31"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M28 24h1v1h-1z",
    fill: "#8f6033",
    fillOpacity: 0.992
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M30 25h-1v-1h1z",
    fill: "#8e6537",
    fillOpacity: 0.914
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M31 25h-1v-1h1z",
    fill: "#916d44",
    fillOpacity: 0.761
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M31 24h1v1h-1z",
    fill: "#916d46",
    fillOpacity: 0.627
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M33 24v1h-1v-1z",
    fill: "#93744b",
    fillOpacity: 0.698
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M34 25h-1v-1h1z",
    fill: "#9a7d58",
    fillOpacity: 0.859
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M34 25v-1h1v1z",
    fill: "#9c8161",
    fillOpacity: 0.957
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M36 25h-1v-1h1z",
    fill: "#a08667"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M37 25h-1v-1h1z",
    fill: "#a38a6d"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M38 24v1h-1v-1z",
    fill: "#a38568"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M38 25v-1h1v1z",
    fill: "#866034"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M40 24v1h-1v-1z",
    fill: "#8b6331"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M41 25h-1v-1h1z",
    fill: "#916b3c"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M41 24h1v1h-1z",
    fill: "#825d2d"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M43 25h-1v-1h1z",
    fill: "#856541"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M44 24v1h-1v-1z",
    fill: "#a38b71"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M47 24h1v1h-1z",
    fill: "#9f8668"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M49 25h-1v-1h1z",
    fill: "#a08968"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M50 25h-1v-1h1z",
    fill: "#a28b6b"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M51 25h-1v-1h1z",
    fill: "#a48d6c"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M51 24h1v1h-1z",
    fill: "#a68d6d"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M52 24h1v1h-1z",
    fill: "#a78e6f"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M54 24v1h-1v-1z",
    fill: "#a78f70"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M54 25v-1h1v1z",
    fill: "#a78f6f"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M55 25v-1h1v1z",
    fill: "#a68e6f"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M56 25v-1h1v1z",
    fill: "#a58c6d"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M58 25h-1v-1h1z",
    fill: "#a48a6d"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M59 25h-1v-1h1z",
    fill: "#a48a6e"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M59 25v-1h1v1z",
    fill: "#a3896e"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M61 24v1h-1v-1z",
    fill: "#a1876e"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M62 24v1h-1v-1z",
    fill: "#9f866a"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M63 24v1h-1v-1z",
    fill: "#9d8566"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M66 25v-1h1v1z",
    fill: "#9f8467"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M68 25h-1v-1h1z",
    fill: "#a08568"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M71 24v1h-1v-1z",
    fill: "#a18465"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M72 25h-1v-1h1z",
    fill: "#a08464"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M73 25h-1v-1h1z",
    fill: "#a08463"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M74 25h-1v-1h1z",
    fill: "#a08362"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M74 24h1v1h-1z",
    fill: "#a08261"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M76 25h-1v-1h1z",
    fill: "#9f8260"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M77 24v1h-1v-1z",
    fill: "#9e825e"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M77 25v-1h1v1z",
    fill: "#9e825d"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M78 25v-1h1v1z",
    fill: "#a0825b"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M81 25h-1v-1h1z",
    fill: "#9e805a"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M82 24v1h-1v-1z",
    fill: "#9f825c"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M83 25h-1v-1h1z",
    fill: "#a0825c"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M85 24v1h-1v-1z",
    fill: "#a1805b"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M86 25h-1v-1h1z",
    fill: "#a07f59"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M87 25h-1v-1h1z",
    fill: "#a07e58"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M87 25v-1h1v1z",
    fill: "#9f7e57"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M89 25h-1v-1h1z",
    fill: "#9e7d54"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M90 24v1h-1v-1z",
    fill: "#9c7b52"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M91 25h-1v-1h1z",
    fill: "#9a794d"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M92 25h-1v-1h1z",
    fill: "#967548"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M92 24h1v1h-1z",
    fill: "#957145"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M94 24v1h-1v-1z",
    fill: "#987246"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M95 25v-1h1v1z",
    fill: "#976b34"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M96 24h1v1h-1z",
    fill: "#966a2e"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M97 25v-1h1v1z",
    fill: "#966c37"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M98 24h1v1h-1z",
    fill: "#9a7140"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M102 24v1h-1v-1z",
    fill: "#9d7141"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M103 25h-1v-1h1z",
    fill: "#9d713f"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M104 24v1h-1v-1z",
    fill: "#9d703e"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M105 24v1h-1v-1z",
    fill: "#9d7040"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M105 24h1v1h-1z",
    fill: "#9c7142"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M107 24v1h-1v-1z",
    fill: "#9d7242"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M108 24v1h-1v-1z",
    fill: "#9c7342"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M109 24v1h-1v-1z",
    fill: "#997144",
    fillOpacity: 0.992
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M109 25v-1h1v1z",
    fill: "#997245",
    fillOpacity: 0.953
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M111 25h-1v-1h1z",
    fill: "#9a7348",
    fillOpacity: 0.894
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M111 24h1v1h-1z",
    fill: "#9a764c",
    fillOpacity: 0.82
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M112 25v-1h1v1z",
    fill: "#99794d",
    fillOpacity: 0.725
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M114 25h-1v-1h1z",
    fill: "#997d51",
    fillOpacity: 0.612
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M115 24v1h-1v-1z",
    fill: "#9e8258",
    fillOpacity: 0.498
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M115 24h1v1h-1z",
    fill: "#9e845b",
    fillOpacity: 0.392
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M116 25v-1h1v1z",
    fill: "#9f8b62",
    fillOpacity: 0.294
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M117 25v-1h1v1z",
    fill: "#9d8767",
    fillOpacity: 0.184
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M118 25v-1h1v1z",
    fill: "#998466",
    fillOpacity: 0.098
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M120 25h-1v-1h1z",
    fill: "#b09c93",
    fillOpacity: 0.102
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M120 24h1v1h-1z",
    fill: "#936b4f",
    fillOpacity: 0.847
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M121 24h1v1h-1z",
    fill: "#9e6c47"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M123 24h1v1h-1z",
    fill: "#a87e5d"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M125 24v1h-1v-1z",
    fill: "#9c7b66",
    fillOpacity: 0.243
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M2 25v1H1v-1z",
    fill: "#a07e6d",
    fillOpacity: 0.412
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M3 25v1H2v-1z",
    fill: "#b48869"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M4 26H3v-1h1z",
    fill: "#895b35"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M4 25h1v1H4z",
    fill: "#794721"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M6 26H5v-1h1z",
    fill: "#986441"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M7 26H6v-1h1z",
    fill: "#ad7b5c"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M8 25h1v1H8z",
    fill: "#ae8365"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M10 26v-1h1v1z",
    fill: "#ae7f60"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M11 25h1v1h-1z",
    fill: "#aa7855"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M14 25v1h-1v-1z",
    fill: "#a77554"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M14 26v-1h1v1z",
    fill: "#a47453"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M16 26h-1v-1h1z",
    fill: "#a17150"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M16 25h1v1h-1z",
    fill: "#9e6c49"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M19 25v1h-1v-1z",
    fill: "#98633a"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M20 25v1h-1v-1z",
    fill: "#965f37"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M24 25v1h-1v-1z",
    fill: "#905c31"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M25 25v1h-1v-1z",
    fill: "#905d33"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M25 26v-1h1v1z",
    fill: "#915d36"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M29 25v1h-1v-1z",
    fill: "#956139"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M31 26v-1h1v1z",
    fill: "#9c6f49"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M32 25h1v1h-1z",
    fill: "#9c7147"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M33 26v-1h1v1z",
    fill: "#9a7143"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M35 25v1h-1v-1z",
    fill: "#9b7448"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M36 25v1h-1v-1z",
    fill: "#9b784d"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M36 25h1v1h-1z",
    fill: "#9c7d52"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M39 26h-1v-1h1z",
    fill: "#784f24"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M39 25h1v1h-1z",
    fill: "#7f5126"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M41 26v-1h1v1z",
    fill: "#754a1e"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M43 25v1h-1v-1z",
    fill: "#7e5b31"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M44 25h1v1h-1z",
    fill: "#9f876c"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M53 25h1v1h-1z",
    fill: "#a18868"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M56 26h-1v-1h1z",
    fill: "#a28a6a"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M57 25v1h-1v-1z",
    fill: "#a38a6b"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M57 26v-1h1v1z",
    fill: "#a38b6c"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M59 26h-1v-1h1z",
    fill: "#a38a6c"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M59 25h1v1h-1z",
    fill: "#a1886c"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M62 25v1h-1v-1z",
    fill: "#9e8669"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M62 26v-1h1v1z",
    fill: "#9c8466"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M66 25h1v1h-1z",
    fill: "#9d8265"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M67 25h1v1h-1z",
    fill: "#9d8263"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M68 25h1v1h-1z",
    fill: "#9b8161"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M70 26h-1v-1h1z",
    fill: "#9c8061"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M71 26h-1v-1h1z",
    fill: "#9c7f60"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M72 26h-1v-1h1z",
    fill: "#9b7e5f"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M72 25h1v1h-1z",
    fill: "#9b7e5d"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M75 25v1h-1v-1z",
    fill: "#9a7d5a"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M75 26v-1h1v1z",
    fill: "#997c59"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M77 25v1h-1v-1z",
    fill: "#997b59"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M78 25v1h-1v-1z",
    fill: "#9a7d59"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M78 25h1v1h-1z",
    fill: "#9c7e58"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M80 25v1h-1v-1z",
    fill: "#9b7d56"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M80 25h1v1h-1z",
    fill: "#9b7e56"
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M82 25v1h-1v-1z",
    fill: "#9d8058"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M82 26v-1h1v1z",
    fill: "#9d8159"
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M84 25v1h-1v-1z",
    fill: "#9d7f57"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M84 26v-1h1v1z",
    fill: "#9b7a54"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M85 25h1v1h-1z",
    fill: "#9c7954"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M86 25h1v1h-1z",
    fill: "#9d7b55"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M88 26h-1v-1h1z",
    fill: "#9e7b54"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M89 25v1h-1v-1z",
    fill: "#9d7a52"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M89 26v-1h1v1z",
    fill: "#9e7951"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M90 25h1v1h-1z",
    fill: "#9d794f"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M91 26v-1h1v1z",
    fill: "#9a754a"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M93 25v1h-1v-1z",
    fill: "#9a7447"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M94 26h-1v-1h1z",
    fill: "#9c7446"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M95 26h-1v-1h1z",
    fill: "#9a7141"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M96 25v1h-1v-1z",
    fill: "#9b6f39"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M96 26v-1h1v1z",
    fill: "#9d6f36"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M97 25h1v1h-1z",
    fill: "#9e723d"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M99 26h-1v-1h1z",
    fill: "#a07545"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M100 26h-1v-1h1z",
    fill: "#9f7546"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M101 25v1h-1v-1z",
    fill: "#9f7445"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M101 26v-1h1v1z",
    fill: "#9d7344"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M102 25h1v1h-1z",
    fill: "#9e7443"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M105 26v-1h1v1z",
    fill: "#9d7342"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M108 26h-1v-1h1z",
    fill: "#9e7340"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M109 25v1h-1v-1z",
    fill: "#9e7441"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M110 25v1h-1v-1z",
    fill: "#a17542"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "M110 26v-1h1v1z",
    fill: "#a37745"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "M111 25h1v1h-1z",
    fill: "#a47b46"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "M113 26v-1h1v1z",
    fill: "#aa834c"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "M114 25h1v1h-1z",
    fill: "#ac844e"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M116 26h-1v-1h1z",
    fill: "#b18650"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M116 25h1v1h-1z",
    fill: "#b58758"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "M118 25v1h-1v-1z",
    fill: "#b68959",
    fillOpacity: 0.992
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M118 25h1v1h-1z",
    fill: "#c09363",
    fillOpacity: 0.957
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M120 25v1h-1v-1z",
    fill: "#c69974",
    fillOpacity: 0.937
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M120 26v-1h1v1z",
    fill: "#a47551",
    fillOpacity: 0.992
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M122 25h1v1h-1z",
    fill: "#a57954"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M124 26h-1v-1h1z",
    fill: "#a37c5d",
    fillOpacity: 0.937
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M125 25v1h-1v-1z",
    fill: "#8b6a62",
    fillOpacity: 0.122
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M2 26v1H1v-1z",
    fill: "#9b7d73",
    fillOpacity: 0.2
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M2 27v-1h1v1z",
    fill: "#ae8568",
    fillOpacity: 0.98
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M3 27v-1h1v1z",
    fill: "#976a44"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M5 27H4v-1h1z",
    fill: "#76451f"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M6 26v1H5v-1z",
    fill: "#8c5933"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M6 26h1v1H6z",
    fill: "#a5714d"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M7 26h1v1H7z",
    fill: "#b07d5b"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M9 26v1H8v-1z",
    fill: "#af7f5e"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M9 27v-1h1v1z",
    fill: "#af7d5d"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M10 26h1v1h-1z",
    fill: "#af7c5d"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "M12 27h-1v-1h1z",
    fill: "#ab7b5b"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M13 27h-1v-1h1z",
    fill: "#a77756"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M15 27h-1v-1h1z",
    fill: "#a47250"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M16 26v1h-1v-1z",
    fill: "#a26f4d"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "M16 27v-1h1v1z",
    fill: "#a16c49"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "M18 26v1h-1v-1z",
    fill: "#9e6843"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M18 27v-1h1v1z",
    fill: "#9a643b"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M20 26h1v1h-1z",
    fill: "#965e37"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M26 26v1h-1v-1z",
    fill: "#97623c"
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "M26 26h1v1h-1z",
    fill: "#97633d"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "M27 27v-1h1v1z",
    fill: "#97643f"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M29 27h-1v-1h1z",
    fill: "#9b6a45"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "M30 27h-1v-1h1z",
    fill: "#9d6d4d"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "M31 26v1h-1v-1z",
    fill: "#9e7155"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M32 27h-1v-1h1z",
    fill: "#a2775e"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "M33 27h-1v-1h1z",
    fill: "#a27a62"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M33 27v-1h1v1z",
    fill: "#a17a63"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M35 27h-1v-1h1z",
    fill: "#a67f68"
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "M35 27v-1h1v1z",
    fill: "#a57e65"
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "M36 27v-1h1v1z",
    fill: "#a27b5e"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "M38 26v1h-1v-1z",
    fill: "#9e7757"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M39 26v1h-1v-1z",
    fill: "#815331"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M39 27v-1h1v1z",
    fill: "#84542e"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "M41 27h-1v-1h1z",
    fill: "#82552d"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M41 26h1v1h-1z",
    fill: "#72471d"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "M42 26h1v1h-1z",
    fill: "#79542c"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M45 27v-1h1v1z",
    fill: "#9e8565"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "M46 26h1v1h-1z",
    fill: "#9e8566"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "M48 27h-1v-1h1z",
    fill: "#9f8567"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "M49 27h-1v-1h1z",
    fill: "#9f8468"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M55 26h1v1h-1z",
    fill: "#9c8365"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "M65 27h-1v-1h1z",
    fill: "#9e8264"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "M66 26v1h-1v-1z",
    fill: "#9f8263"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "M66 27v-1h1v1z",
    fill: "#a08363"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "M68 27h-1v-1h1z",
    fill: "#a08361"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "M71 26h1v1h-1z",
    fill: "#9e805d"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M73 27v-1h1v1z",
    fill: "#9d7f5a"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M74 27v-1h1v1z",
    fill: "#9b7e57"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M81 26v1h-1v-1z",
    fill: "#9c7d54"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "M87 26h1v1h-1z",
    fill: "#99764e"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "M89 27h-1v-1h1z",
    fill: "#98754d"
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "M89 26h1v1h-1z",
    fill: "#9a764c"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "M90 27v-1h1v1z",
    fill: "#9b754b"
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "M91 26h1v1h-1z",
    fill: "#9a7348"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "M92 26h1v1h-1z",
    fill: "#9c7347"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "M93 26h1v1h-1z",
    fill: "#9e7346"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "M95 26v1h-1v-1z",
    fill: "#9e7343"
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "M96 27h-1v-1h1z",
    fill: "#9f713d"
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "M96 26h1v1h-1z",
    fill: "#9e6f39"
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "M98 27h-1v-1h1z",
    fill: "#9e703e"
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "M98 26h1v1h-1z",
    fill: "#9e7342"
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "M100 27v-1h1v1z",
    fill: "#a07645"
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "M101 26h1v1h-1z",
    fill: "#a27846"
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "M102 27v-1h1v1z",
    fill: "#a27948"
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "M105 26v1h-1v-1z",
    fill: "#a57b49"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "M105 26h1v1h-1z",
    fill: "#a67b48"
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "M106 26h1v1h-1z",
    fill: "#a67d48"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "M108 26v1h-1v-1z",
    fill: "#a77f48"
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "M110 27h-1v-1h1z",
    fill: "#a97f49"
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "M110 26h1v1h-1z",
    fill: "#ad814a"
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "M112 26v1h-1v-1z",
    fill: "#b1844d"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "M112 27v-1h1v1z",
    fill: "#b98b57"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "M114 26v1h-1v-1z",
    fill: "#bf8f60"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "M114 26h1v1h-1z",
    fill: "#c79569"
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "M116 27h-1v-1h1z",
    fill: "#d29c70"
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "M117 26v1h-1v-1z",
    fill: "#d39a6c"
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "M118 27h-1v-1h1z",
    fill: "#cc976d"
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "M119 26v1h-1v-1z",
    fill: "#c49670",
    fillOpacity: 0.976
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "M119 26h1v1h-1z",
    fill: "#c18f6a",
    fillOpacity: 0.933
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "M120 26h1v1h-1z",
    fill: "#a06d47"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "M121 27v-1h1v1z",
    fill: "#976845"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "M123 27h-1v-1h1z",
    fill: "#a97a56"
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "M124 26v1h-1v-1z",
    fill: "#9f7f5f",
    fillOpacity: 0.831
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "M1 27h1v1H1z",
    fill: "#917f7f",
    fillOpacity: 0.055
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "M3 27v1H2v-1z",
    fill: "#aa8267",
    fillOpacity: 0.871
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "M3 27h1v1H3z",
    fill: "#a87954"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "M5 28H4v-1h1z",
    fill: "#784825"
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "M5 28v-1h1v1z",
    fill: "#7f4e27"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "M7 28H6v-1h1z",
    fill: "#905e38"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "M7 28v-1h1v1z",
    fill: "#9c6a4b",
    fillOpacity: 0.992
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "M9 27v1H8v-1z",
    fill: "#a47456"
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "M9 27h1v1H9z",
    fill: "#ae7b5b"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "M11 27v1h-1v-1z",
    fill: "#b17c5d"
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "M11 28v-1h1v1z",
    fill: "#ac7c5e"
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "M13 28h-1v-1h1z",
    fill: "#a77858"
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "M15 27v1h-1v-1z",
    fill: "#a36f4c"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "M15 27h1v1h-1z",
    fill: "#a06b47"
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "M17 27v1h-1v-1z",
    fill: "#9f6846"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "M22 27v1h-1v-1z",
    fill: "#986037"
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "M23 27h1v1h-1z",
    fill: "#925c32"
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "M24 28v-1h1v1z",
    fill: "#935d34"
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "M27 27v1h-1v-1z",
    fill: "#98633d"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "M27 27h1v1h-1z",
    fill: "#976540"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "M28 27h1v1h-1z",
    fill: "#996743"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "M31 28h-1v-1h1z",
    fill: "#9f7154"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "M31 27h1v1h-1z",
    fill: "#a37960"
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "M33 27v1h-1v-1z",
    fill: "#a88268"
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "M33 27h1v1h-1z",
    fill: "#a9876f"
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "M34 28v-1h1v1z",
    fill: "#ae8b78"
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "M35 27h1v1h-1z",
    fill: "#ac8878"
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "M36 28v-1h1v1z",
    fill: "#ae8779"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "M37 28v-1h1v1z",
    fill: "#ab8073"
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "M38 27h1v1h-1z",
    fill: "#8e604e"
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "M40 27v1h-1v-1z",
    fill: "#8c5e44"
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "M40 27h1v1h-1z",
    fill: "#8c6040"
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "M42 27v1h-1v-1z",
    fill: "#744922"
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "M42 27h1v1h-1z",
    fill: "#754d26"
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "M44 27v1h-1v-1z",
    fill: "#9f8161"
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "M45 28h-1v-1h1z",
    fill: "#a08468"
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "M48 28v-1h1v1z",
    fill: "#9e8465"
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "M49 28v-1h1v1z",
    fill: "#9f8366"
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "M51 27v1h-1v-1z",
    fill: "#9e8265"
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "M60 27v1h-1v-1z",
    fill: "#9b8061"
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "M60 28v-1h1v1z",
    fill: "#9a7f5f"
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "M62 28h-1v-1h1z",
    fill: "#987e5d"
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "M62 27h1v1h-1z",
    fill: "#997d5c"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "M63 27h1v1h-1z",
    fill: "#9d815d"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "M65 27v1h-1v-1z",
    fill: "#a0835e"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "M65 27h1v1h-1z",
    fill: "#a0825d"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "M67 28h-1v-1h1z",
    fill: "#a1835f"
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "M67 28v-1h1v1z",
    fill: "#a2845e"
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "M71 27v1h-1v-1z",
    fill: "#a3835c"
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "M72 27v1h-1v-1z",
    fill: "#a2825b"
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "M72 28v-1h1v1z",
    fill: "#a2825a"
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "M73 27h1v1h-1z",
    fill: "#a18159"
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "M75 27v1h-1v-1z",
    fill: "#9e8156"
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "M75 28v-1h1v1z",
    fill: "#9c7f54"
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "M77 27v1h-1v-1z",
    fill: "#9a7d52"
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "M77 28v-1h1v1z",
    fill: "#997c50"
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "M78 27h1v1h-1z",
    fill: "#9c7d4f"
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "M80 28h-1v-1h1z",
    fill: "#9f8054"
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "M80 27h1v1h-1z",
    fill: "#a18256"
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "M82 28h-1v-1h1z",
    fill: "#9f7f55"
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "M82 28v-1h1v1z",
    fill: "#9d7c53"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "M83 27h1v1h-1z",
    fill: "#9b7a51"
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "M88 28h-1v-1h1z",
    fill: "#9a774e"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "M89 27v1h-1v-1z",
    fill: "#9b784e"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "M89 28v-1h1v1z",
    fill: "#9d784e"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "M91 27v1h-1v-1z",
    fill: "#9e784c"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "M91 28v-1h1v1z",
    fill: "#9c7549"
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "M92 28v-1h1v1z",
    fill: "#9d7446"
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "M94 28h-1v-1h1z",
    fill: "#9e7345"
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "M95 27h1v1h-1z",
    fill: "#9d703c"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "M97 27h1v1h-1z",
    fill: "#9e703f"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "M101 28h-1v-1h1z",
    fill: "#9d7440"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "M102 27v1h-1v-1z",
    fill: "#9f7642"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "M102 27h1v1h-1z",
    fill: "#a27945"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "M104 27v1h-1v-1z",
    fill: "#a87e48"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "M105 28h-1v-1h1z",
    fill: "#ab7e48"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "M106 27v1h-1v-1z",
    fill: "#ab7e45"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "M107 28h-1v-1h1z",
    fill: "#ac7f45"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "M107 27h1v1h-1z",
    fill: "#af8247"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "M109 27v1h-1v-1z",
    fill: "#b8864e"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "M109 28v-1h1v1z",
    fill: "#c4915c"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "M111 27v1h-1v-1z",
    fill: "#d29d69"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "M111 28v-1h1v1z",
    fill: "#e1a87a"
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "M112 27h1v1h-1z",
    fill: "#e8af86"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "M114 28h-1v-1h1z",
    fill: "#dda57f"
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "M114 27h1v1h-1z",
    fill: "#cb9673",
    fillOpacity: 0.992
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "M116 27v1h-1v-1z",
    fill: "#bf8e70",
    fillOpacity: 0.839
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "M116 28v-1h1v1z",
    fill: "#b3895f",
    fillOpacity: 0.663
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "M117 27h1v1h-1z",
    fill: "#aa8861",
    fillOpacity: 0.439
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "M118 28v-1h1v1z",
    fill: "#a88d71",
    fillOpacity: 0.184
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "M120 28h-1v-1h1z",
    fill: "#846247",
    fillOpacity: 0.459
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "M121 28h-1v-1h1z",
    fill: "#92623b"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "M122 27v1h-1v-1z",
    fill: "#966842"
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "M122 28v-1h1v1z",
    fill: "#ac7c56"
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "M123 27h1v1h-1z",
    fill: "#a27f60",
    fillOpacity: 0.706
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "M3 29H2v-1h1z",
    fill: "#a78166",
    fillOpacity: 0.671
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "M4 28v1H3v-1z",
    fill: "#b38461"
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "M5 29H4v-1h1z",
    fill: "#855b3a"
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "M6 29v-1h1v1z",
    fill: "#805534"
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "M7 29v-1h1v1z",
    fill: "#7b543a",
    fillOpacity: 0.808
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "M9 29H8v-1h1z",
    fill: "#8a6651",
    fillOpacity: 0.282
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "M10 29H9v-1h1z",
    fill: "#916952",
    fillOpacity: 0.51
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "M11 29h-1v-1h1z",
    fill: "#9a6c52",
    fillOpacity: 0.737
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "M12 29h-1v-1h1z",
    fill: "#9f7053",
    fillOpacity: 0.89
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "M13 29h-1v-1h1z",
    fill: "#9f6e51",
    fillOpacity: 0.984
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "M14 28v1h-1v-1z",
    fill: "#a47150"
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "M14 28h1v1h-1z",
    fill: "#a7714b"
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "M17 28v1h-1v-1z",
    fill: "#a26742"
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "M17 28h1v1h-1z",
    fill: "#9c613c"
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "M19 28v1h-1v-1z",
    fill: "#955d35"
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "M19 28h1v1h-1z",
    fill: "#925b33"
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "M21 29h-1v-1h1z",
    fill: "#935b33"
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "M21 29v-1h1v1z",
    fill: "#925a31"
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "M23 28h1v1h-1z",
    fill: "#915b33"
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "M27 29h-1v-1h1z",
    fill: "#996640"
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "M30 28v1h-1v-1z",
    fill: "#a26f4f"
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "M31 29h-1v-1h1z",
    fill: "#a37459"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "M31 28h1v1h-1z",
    fill: "#a67b62"
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "M33 28v1h-1v-1z",
    fill: "#aa836b"
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "M34 28v1h-1v-1z",
    fill: "#aa8574"
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "M34 28h1v1h-1z",
    fill: "#ac867a"
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "M36 28v1h-1v-1z",
    fill: "#ad877c"
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "M36 29v-1h1v1z",
    fill: "#ae877b"
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "M38 28v1h-1v-1z",
    fill: "#ac8375"
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "M38 29v-1h1v1z",
    fill: "#926857"
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "M39 28h1v1h-1z",
    fill: "#916753"
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "M41 28v1h-1v-1z",
    fill: "#8e654e"
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    d: "M41 28h1v1h-1z",
    fill: "#734924"
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "M43 28v1h-1v-1z",
    fill: "#734a23"
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "M44 28v1h-1v-1z",
    fill: "#9d7f5d"
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "M45 29h-1v-1h1z",
    fill: "#a08466"
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    d: "M46 28v1h-1v-1z",
    fill: "#9f8365"
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "M50 28v1h-1v-1z",
    fill: "#9f8563"
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    d: "M50 29v-1h1v1z",
    fill: "#9e8563"
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "M61 28h1v1h-1z",
    fill: "#9e835f"
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "M62 28h1v1h-1z",
    fill: "#9e815c"
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "M63 29v-1h1v1z",
    fill: "#9e815b"
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    d: "M65 29h-1v-1h1z",
    fill: "#9f815a"
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    d: "M67 28v1h-1v-1z",
    fill: "#a0815c"
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "M67 29v-1h1v1z",
    fill: "#a1815b"
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "M68 28h1v1h-1z",
    fill: "#a0815a"
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    d: "M72 28v1h-1v-1z",
    fill: "#9e7e56"
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "M75 28v1h-1v-1z",
    fill: "#9c7c51"
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    d: "M79 28v1h-1v-1z",
    fill: "#9b7c4f"
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    d: "M81 28v1h-1v-1z",
    fill: "#9d7e52"
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "M81 28h1v1h-1z",
    fill: "#9b7c51"
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "M86 28h1v1h-1z",
    fill: "#98764d"
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    d: "M87 28h1v1h-1z",
    fill: "#97744b"
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "M90 29h-1v-1h1z",
    fill: "#967246"
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "M91 28v1h-1v-1z",
    fill: "#957144"
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "M91 28h1v1h-1z",
    fill: "#936e41"
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    d: "M92 29v-1h1v1z",
    fill: "#936c3e"
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    d: "M93 29v-1h1v1z",
    fill: "#966d3e"
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    d: "M95 29h-1v-1h1z",
    fill: "#98713d"
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    d: "M95 28h1v1h-1z",
    fill: "#9c743f"
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    d: "M96 28h1v1h-1z",
    fill: "#a07642"
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    d: "M98 28v1h-1v-1z",
    fill: "#a37848"
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    d: "M99 28v1h-1v-1z",
    fill: "#a67e4b"
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    d: "M99 29v-1h1v1z",
    fill: "#a9814c"
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    d: "M100 29v-1h1v1z",
    fill: "#aa824c"
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    d: "M102 29h-1v-1h1z",
    fill: "#ad844f"
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    d: "M103 28v1h-1v-1z",
    fill: "#b0844d"
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    d: "M103 28h1v1h-1z",
    fill: "#b2834a"
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    d: "M105 29h-1v-1h1z",
    fill: "#b6844a"
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    d: "M106 29h-1v-1h1z",
    fill: "#c49055"
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    d: "M107 28v1h-1v-1z",
    fill: "#d19860"
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    d: "M107 29v-1h1v1z",
    fill: "#dc9d6b"
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    d: "M108 29v-1h1v1z",
    fill: "#e2a173"
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    d: "M110 28v1h-1v-1z",
    fill: "#e1a175"
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    d: "M110 29v-1h1v1z",
    fill: "#e7ab80"
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    d: "M111 28h1v1h-1z",
    fill: "#e1a983"
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    d: "M112 29v-1h1v1z",
    fill: "#d29d77"
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    d: "M113 29v-1h1v1z",
    fill: "#b9845e"
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    d: "M114 29v-1h1v1z",
    fill: "#a17550",
    fillOpacity: 0.792
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    d: "M120 28v1h-1v-1z",
    fill: "#7f5f45",
    fillOpacity: 0.588
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    d: "M120 29v-1h1v1z",
    fill: "#935f33"
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    d: "M122 28v1h-1v-1z",
    fill: "#966840"
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    d: "M123 28v1h-1v-1z",
    fill: "#aa7c58"
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    d: "M124 28v1h-1v-1z",
    fill: "#9f785b",
    fillOpacity: 0.557
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    d: "M3 29v1H2v-1z",
    fill: "#a2806a",
    fillOpacity: 0.443
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    d: "M3 29h1v1H3z",
    fill: "#b68869"
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    d: "M5 29v1H4v-1z",
    fill: "#8e6444"
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    d: "M6 30H5v-1h1z",
    fill: "#825b38"
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    d: "M6 29h1v1H6z",
    fill: "#865c3c"
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    d: "M8 29v1H7v-1z",
    fill: "#7b553c",
    fillOpacity: 0.91
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    d: "M12 30h-1v-1h1z",
    fill: "#866b5d",
    fillOpacity: 0.075
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    d: "M13 29v1h-1v-1z",
    fill: "#8b6051",
    fillOpacity: 0.208
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    d: "M13 29h1v1h-1z",
    fill: "#865d43",
    fillOpacity: 0.373
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    d: "M14 29h1v1h-1z",
    fill: "#8d6142",
    fillOpacity: 0.553
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    d: "M15 29h1v1h-1z",
    fill: "#925c43",
    fillOpacity: 0.71
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    d: "M17 30h-1v-1h1z",
    fill: "#925c40",
    fillOpacity: 0.851
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    d: "M18 29v1h-1v-1z",
    fill: "#8e5a3b",
    fillOpacity: 0.949
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    d: "M19 30h-1v-1h1z",
    fill: "#8f5836"
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    d: "M19 29h1v1h-1z",
    fill: "#955a32"
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    d: "M21 30h-1v-1h1z",
    fill: "#93582f"
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    d: "M22 30h-1v-1h1z",
    fill: "#8c542b"
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    d: "M22 30v-1h1v1z",
    fill: "#8c552e"
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    d: "M23 30v-1h1v1z",
    fill: "#8f5730"
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    d: "M26 30h-1v-1h1z",
    fill: "#945d37"
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    d: "M27 29v1h-1v-1z",
    fill: "#95623d"
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    d: "M27 29h1v1h-1z",
    fill: "#976340"
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    d: "M30 29v1h-1v-1z",
    fill: "#a06e50"
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    d: "M31 30h-1v-1h1z",
    fill: "#a6785e"
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    d: "M31 29h1v1h-1z",
    fill: "#aa8068"
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    d: "M32 29h1v1h-1z",
    fill: "#ad866f"
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    d: "M34 30h-1v-1h1z",
    fill: "#af8976"
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    d: "M35 30h-1v-1h1z",
    fill: "#b28c7f"
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    d: "M36 29v1h-1v-1z",
    fill: "#b28d82"
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    d: "M37 29v1h-1v-1z",
    fill: "#b38e84"
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    d: "M38 30h-1v-1h1z",
    fill: "#b0887d"
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    d: "M39 30h-1v-1h1z",
    fill: "#936c5b"
  })), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    d: "M39 30v-1h1v1z",
    fill: "#926956"
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    d: "M40 30v-1h1v1z",
    fill: "#906851"
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    d: "M42 30h-1v-1h1z",
    fill: "#754c26"
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    d: "M42 30v-1h1v1z",
    fill: "#724922"
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    d: "M44 30h-1v-1h1z",
    fill: "#997b5a"
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    d: "M45 29v1h-1v-1z",
    fill: "#9b8163"
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    d: "M45 30v-1h1v1z",
    fill: "#9c8062"
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    d: "M47 30h-1v-1h1z",
    fill: "#9a8060"
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    d: "M48 30h-1v-1h1z",
    fill: "#9b805f"
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    d: "M48 29h1v1h-1z",
    fill: "#9c8160"
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    d: "M50 29v1h-1v-1z",
    fill: "#9d8162"
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    d: "M51 30h-1v-1h1z",
    fill: "#9e8261"
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    d: "M52 29v1h-1v-1z",
    fill: "#9f835f"
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    d: "M52 29h1v1h-1z",
    fill: "#a0855f"
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    d: "M53 30v-1h1v1z",
    fill: "#a28660"
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    d: "M57 30h-1v-1h1z",
    fill: "#a38662"
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    d: "M57 29h1v1h-1z",
    fill: "#a28764"
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    d: "M58 30v-1h1v1z",
    fill: "#a08663"
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    d: "M62 30h-1v-1h1z",
    fill: "#a18560"
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    d: "M63 30h-1v-1h1z",
    fill: "#a3855e"
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    d: "M65 30h-1v-1h1z",
    fill: "#a0835a"
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    d: "M66 29v1h-1v-1z",
    fill: "#a0825a"
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    d: "M67 30h-1v-1h1z",
    fill: "#9f825a"
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    d: "M67 29h1v1h-1z",
    fill: "#9f8057"
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    d: "M68 30v-1h1v1z",
    fill: "#9e7e54"
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    d: "M69 29h1v1h-1z",
    fill: "#9b7c53"
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    d: "M70 29h1v1h-1z",
    fill: "#9c7c55"
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    d: "M71 30v-1h1v1z",
    fill: "#9b7b55"
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    d: "M76 29h1v1h-1z",
    fill: "#9b7a52"
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    d: "M78 29v1h-1v-1z",
    fill: "#9c7a51"
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    d: "M88 29v1h-1v-1z",
    fill: "#967349"
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    d: "M88 30v-1h1v1z",
    fill: "#977449"
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    d: "M90 29v1h-1v-1z",
    fill: "#977247"
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    d: "M91 30h-1v-1h1z",
    fill: "#946f44"
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    d: "M92 30h-1v-1h1z",
    fill: "#916c40"
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    d: "M92 30v-1h1v1z",
    fill: "#926d3e"
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    d: "M95 29v1h-1v-1z",
    fill: "#9a7342"
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    d: "M96 30h-1v-1h1z",
    fill: "#9e7743"
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    d: "M96 29h1v1h-1z",
    fill: "#a07841"
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    d: "M98 30h-1v-1h1z",
    fill: "#a17843"
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    d: "M100 29v1h-1v-1z",
    fill: "#a57b48"
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    d: "M101 30h-1v-1h1z",
    fill: "#a97e49"
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    d: "M101 30v-1h1v1z",
    fill: "#af814f"
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    d: "M102 30v-1h1v1z",
    fill: "#bc8856"
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    d: "M104 30h-1v-1h1z",
    fill: "#d49b67"
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    d: "M105 30h-1v-1h1z",
    fill: "#dfa36e"
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    d: "M106 30h-1v-1h1z",
    fill: "#e8a973"
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    d: "M107 30h-1v-1h1z",
    fill: "#ebac7a"
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    d: "M108 29v1h-1v-1z",
    fill: "#e1a377"
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    d: "M109 29v1h-1v-1z",
    fill: "#d3976d"
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    d: "M109 30v-1h1v1z",
    fill: "#be855b"
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    d: "M111 29v1h-1v-1z",
    fill: "#b37d54"
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    d: "M111 30v-1h1v1z",
    fill: "#88512f"
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    d: "M113 30h-1v-1h1z",
    fill: "#9a683d"
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    d: "M113 29h1v1h-1z",
    fill: "#b78256"
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    d: "M115 29v1h-1v-1z",
    fill: "#af8054",
    fillOpacity: 0.733
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    d: "M120 30h-1v-1h1z",
    fill: "#7c573a",
    fillOpacity: 0.729
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    d: "M120 29h1v1h-1z",
    fill: "#8f5a32"
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    d: "M121 30v-1h1v1z",
    fill: "#976843"
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    d: "M123 29v1h-1v-1z",
    fill: "#a87a56"
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    d: "M123 30v-1h1v1z",
    fill: "#9b765c",
    fillOpacity: 0.424
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    d: "M3 31H2v-1h1z",
    fill: "#a38170",
    fillOpacity: 0.239
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    d: "M4 31H3v-1h1z",
    fill: "#af8668",
    fillOpacity: 0.992
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    d: "M4 30h1v1H4z",
    fill: "#986d4c"
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    d: "M5 30h1v1H5z",
    fill: "#855e3b"
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    d: "M6 30h1v1H6z",
    fill: "#8c6242"
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    d: "M8 31H7v-1h1z",
    fill: "#805a3e",
    fillOpacity: 0.996
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    d: "M9 31H8v-1h1z",
    fill: "#6e5842",
    fillOpacity: 0.271
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    d: "M17 31v-1h1v1z",
    fill: "#694b34",
    fillOpacity: 0.133
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    d: "M19 30v1h-1v-1z",
    fill: "#775239",
    fillOpacity: 0.243
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    d: "M19 31v-1h1v1z",
    fill: "#794f38",
    fillOpacity: 0.353
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    d: "M21 31h-1v-1h1z",
    fill: "#835332",
    fillOpacity: 0.675
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    d: "M22 31h-1v-1h1z",
    fill: "#8b562f"
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    d: "M22 30h1v1h-1z",
    fill: "#885129"
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30v1h-1v-1z",
    fill: "#864f29"
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    d: "M24 31v-1h1v1z",
    fill: "#86512e"
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    d: "M25 31v-1h1v1z",
    fill: "#8c5735"
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    d: "M27 31h-1v-1h1z",
    fill: "#925e3b"
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    d: "M27 30h1v1h-1z",
    fill: "#95603f"
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    d: "M28 30h1v1h-1z",
    fill: "#996346"
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    d: "M29 30h1v1h-1z",
    fill: "#9c6a4f"
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    d: "M31 30v1h-1v-1z",
    fill: "#a5775f"
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    d: "M32 31h-1v-1h1z",
    fill: "#ab816c"
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    d: "M33 30v1h-1v-1z",
    fill: "#b08877"
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    d: "M33 31v-1h1v1z",
    fill: "#b78e83"
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    d: "M34 30h1v1h-1z",
    fill: "#b78f85"
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    d: "M36 31h-1v-1h1z",
    fill: "#b78f86"
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    d: "M36 31v-1h1v1z",
    fill: "#b68e84"
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    d: "M38 30v1h-1v-1z",
    fill: "#b18b7a"
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    d: "M39 31h-1v-1h1z",
    fill: "#976f60"
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    d: "M40 31h-1v-1h1z",
    fill: "#956b5b"
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    d: "M40 30h1v1h-1z",
    fill: "#966b57"
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    d: "M41 31v-1h1v1z",
    fill: "#794e2b"
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    d: "M43 30v1h-1v-1z",
    fill: "#70461f"
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    d: "M43 31v-1h1v1z",
    fill: "#927253"
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    d: "M44 30h1v1h-1z",
    fill: "#977a60"
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    d: "M46 31h-1v-1h1z",
    fill: "#987b5c"
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    d: "M46 31v-1h1v1z",
    fill: "#997c5d"
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    d: "M48 30v1h-1v-1z",
    fill: "#9b7d5e"
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    d: "M48 30h1v1h-1z",
    fill: "#9c7d5c"
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    d: "M51 31h-1v-1h1z",
    fill: "#9b7f5b"
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    d: "M52 30v1h-1v-1z",
    fill: "#9b7f5a"
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    d: "M53 30v1h-1v-1z",
    fill: "#9d815a"
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    d: "M55 31v-1h1v1z",
    fill: "#9e825c"
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    d: "M57 31h-1v-1h1z",
    fill: "#9f835d"
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    d: "M58 31h-1v-1h1z",
    fill: "#9e805c"
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30v1h-1v-1z",
    fill: "#9c7d5a"
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    d: "M61 31h-1v-1h1z",
    fill: "#9c7e5a"
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    d: "M68 30v1h-1v-1z",
    fill: "#a28357"
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    d: "M69 30v1h-1v-1z",
    fill: "#a28355"
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    d: "M69 30h1v1h-1z",
    fill: "#a08054"
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    d: "M71 31h-1v-1h1z",
    fill: "#9e7e55"
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    d: "M72 30v1h-1v-1z",
    fill: "#9d7d55"
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    d: "M75 31v-1h1v1z",
    fill: "#997850"
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    d: "M80 30v1h-1v-1z",
    fill: "#97764c"
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    d: "M86 31v-1h1v1z",
    fill: "#927148"
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    d: "M87 30h1v1h-1z",
    fill: "#937048"
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    d: "M89 31h-1v-1h1z",
    fill: "#957248"
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    d: "M89 31v-1h1v1z",
    fill: "#987349"
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    d: "M91 31h-1v-1h1z",
    fill: "#977249"
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    d: "M91 31v-1h1v1z",
    fill: "#967144"
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    d: "M93 30v1h-1v-1z",
    fill: "#977240"
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    d: "M94 30v1h-1v-1z",
    fill: "#99743d"
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    d: "M94 30h1v1h-1z",
    fill: "#9c7340"
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    d: "M95 30h1v1h-1z",
    fill: "#9f7643"
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    d: "M96 31v-1h1v1z",
    fill: "#a27844"
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    d: "M98 30v1h-1v-1z",
    fill: "#a57a45"
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    d: "M98 30h1v1h-1z",
    fill: "#a8774b"
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    d: "M100 31h-1v-1h1z",
    fill: "#a8744b"
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    d: "M101 31h-1v-1h1z",
    fill: "#b17a50"
  })), _path1673 || (_path1673 = /*#__PURE__*/React.createElement("path", {
    d: "M102 31h-1v-1h1z",
    fill: "#b88258"
  })), _path1674 || (_path1674 = /*#__PURE__*/React.createElement("path", {
    d: "M104 31h-1v-1h1z",
    fill: "#d49a6f"
  })), _path1675 || (_path1675 = /*#__PURE__*/React.createElement("path", {
    d: "M104 30h1v1h-1z",
    fill: "#d4996c"
  })), _path1676 || (_path1676 = /*#__PURE__*/React.createElement("path", {
    d: "M106 30v1h-1v-1z",
    fill: "#ce9263"
  })), _path1677 || (_path1677 = /*#__PURE__*/React.createElement("path", {
    d: "M106 31v-1h1v1z",
    fill: "#c3895a"
  })), _path1678 || (_path1678 = /*#__PURE__*/React.createElement("path", {
    d: "M108 31h-1v-1h1z",
    fill: "#b67f54"
  })), _path1679 || (_path1679 = /*#__PURE__*/React.createElement("path", {
    d: "M110 30v1h-1v-1z",
    fill: "#a56d44"
  })), _path1680 || (_path1680 = /*#__PURE__*/React.createElement("path", {
    d: "M111 31v-1h1v1z",
    fill: "#7c421d"
  })), _path1681 || (_path1681 = /*#__PURE__*/React.createElement("path", {
    d: "M113 31h-1v-1h1z",
    fill: "#a97444"
  })), _path1682 || (_path1682 = /*#__PURE__*/React.createElement("path", {
    d: "M114 31h-1v-1h1z",
    fill: "#c68d5c"
  })), _path1683 || (_path1683 = /*#__PURE__*/React.createElement("path", {
    d: "M115 31h-1v-1h1z",
    fill: "#ac7a49",
    fillOpacity: 0.949
  })), _path1684 || (_path1684 = /*#__PURE__*/React.createElement("path", {
    d: "M116 31h-1v-1h1z",
    fill: "#6f4924",
    fillOpacity: 0.655
  })), _path1685 || (_path1685 = /*#__PURE__*/React.createElement("path", {
    d: "M116 30h1v1h-1z",
    fill: "#6e5238",
    fillOpacity: 0.388
  })), _path1686 || (_path1686 = /*#__PURE__*/React.createElement("path", {
    d: "M118 30v1h-1v-1z",
    fill: "#695243",
    fillOpacity: 0.133
  })), _path1687 || (_path1687 = /*#__PURE__*/React.createElement("path", {
    d: "M118 31v-1h1v1z",
    fill: "#486d91",
    fillOpacity: 0.027
  })), _path1688 || (_path1688 = /*#__PURE__*/React.createElement("path", {
    d: "M120 31h-1v-1h1z",
    fill: "#7d5435",
    fillOpacity: 0.843
  })), _path1689 || (_path1689 = /*#__PURE__*/React.createElement("path", {
    d: "M120 31v-1h1v1z",
    fill: "#8c5931"
  })), _path1690 || (_path1690 = /*#__PURE__*/React.createElement("path", {
    d: "M122 30h1v1h-1z",
    fill: "#a27655"
  })), _path1691 || (_path1691 = /*#__PURE__*/React.createElement("path", {
    d: "M124 31h-1v-1h1z",
    fill: "#997862",
    fillOpacity: 0.275
  })), _path1692 || (_path1692 = /*#__PURE__*/React.createElement("path", {
    d: "M2 32v-1h1v1z",
    fill: "#9d8579",
    fillOpacity: 0.082
  })), _path1693 || (_path1693 = /*#__PURE__*/React.createElement("path", {
    d: "M3 31h1v1H3z",
    fill: "#ac856a",
    fillOpacity: 0.902
  })), _path1694 || (_path1694 = /*#__PURE__*/React.createElement("path", {
    d: "M4 31h1v1H4z",
    fill: "#a47856"
  })), _path1695 || (_path1695 = /*#__PURE__*/React.createElement("path", {
    d: "M6 32H5v-1h1z",
    fill: "#855e3c"
  })), _path1696 || (_path1696 = /*#__PURE__*/React.createElement("path", {
    d: "M6 31h1v1H6z",
    fill: "#8e6445"
  })), _path1697 || (_path1697 = /*#__PURE__*/React.createElement("path", {
    d: "M7 31h1v1H7z",
    fill: "#8b6042"
  })), _path1698 || (_path1698 = /*#__PURE__*/React.createElement("path", {
    d: "M8 32v-1h1v1z",
    fill: "#775944",
    fillOpacity: 0.471
  })), _path1699 || (_path1699 = /*#__PURE__*/React.createElement("path", {
    d: "M20 32v-1h1v1z",
    fill: "#886344",
    fillOpacity: 0.353
  })), _path1700 || (_path1700 = /*#__PURE__*/React.createElement("path", {
    d: "M21 32v-1h1v1z",
    fill: "#8f623c"
  })), _path1701 || (_path1701 = /*#__PURE__*/React.createElement("path", {
    d: "M22 32v-1h1v1z",
    fill: "#89552c"
  })), _path1702 || (_path1702 = /*#__PURE__*/React.createElement("path", {
    d: "M23 32v-1h1v1z",
    fill: "#7e4d27"
  })), _path1703 || (_path1703 = /*#__PURE__*/React.createElement("path", {
    d: "M24 31h1v1h-1z",
    fill: "#55290d"
  })), _path1704 || (_path1704 = /*#__PURE__*/React.createElement("path", {
    d: "M25 31h1v1h-1z",
    fill: "#683a1e"
  })), _path1705 || (_path1705 = /*#__PURE__*/React.createElement("path", {
    d: "M26 31h1v1h-1z",
    fill: "#744526"
  })), _path1706 || (_path1706 = /*#__PURE__*/React.createElement("path", {
    d: "M28 31v1h-1v-1z",
    fill: "#744428"
  })), _path1707 || (_path1707 = /*#__PURE__*/React.createElement("path", {
    d: "M29 32h-1v-1h1z",
    fill: "#724229"
  })), _path1708 || (_path1708 = /*#__PURE__*/React.createElement("path", {
    d: "M30 31v1h-1v-1z",
    fill: "#724227"
  })), _path1709 || (_path1709 = /*#__PURE__*/React.createElement("path", {
    d: "M31 32h-1v-1h1z",
    fill: "#774a2e"
  })), _path1710 || (_path1710 = /*#__PURE__*/React.createElement("path", {
    d: "M32 31v1h-1v-1z",
    fill: "#7c5036"
  })), _path1711 || (_path1711 = /*#__PURE__*/React.createElement("path", {
    d: "M32 31h1v1h-1z",
    fill: "#81563e"
  })), _path1712 || (_path1712 = /*#__PURE__*/React.createElement("path", {
    d: "M33 32v-1h1v1z",
    fill: "#865a3f"
  })), _path1713 || (_path1713 = /*#__PURE__*/React.createElement("path", {
    d: "M34 31h1v1h-1z",
    fill: "#8a5f42"
  })), _path1714 || (_path1714 = /*#__PURE__*/React.createElement("path", {
    d: "M35 32v-1h1v1z",
    fill: "#8c6042"
  })), _path1715 || (_path1715 = /*#__PURE__*/React.createElement("path", {
    d: "M38 31v1h-1v-1z",
    fill: "#895f45"
  })), _path1716 || (_path1716 = /*#__PURE__*/React.createElement("path", {
    d: "M39 31v1h-1v-1z",
    fill: "#976b5a"
  })), _path1717 || (_path1717 = /*#__PURE__*/React.createElement("path", {
    d: "M40 31v1h-1v-1z",
    fill: "#996d60"
  })), _path1718 || (_path1718 = /*#__PURE__*/React.createElement("path", {
    d: "M41 32h-1v-1h1z",
    fill: "#9a6f5e"
  })), _path1719 || (_path1719 = /*#__PURE__*/React.createElement("path", {
    d: "M42 31h1v1h-1z",
    fill: "#6d401a"
  })), _path1720 || (_path1720 = /*#__PURE__*/React.createElement("path", {
    d: "M44 31v1h-1v-1z",
    fill: "#8d6545"
  })), _path1721 || (_path1721 = /*#__PURE__*/React.createElement("path", {
    d: "M45 31v1h-1v-1z",
    fill: "#956e53"
  })), _path1722 || (_path1722 = /*#__PURE__*/React.createElement("path", {
    d: "M46 32h-1v-1h1z",
    fill: "#946e4f"
  })), _path1723 || (_path1723 = /*#__PURE__*/React.createElement("path", {
    d: "M48 32h-1v-1h1z",
    fill: "#967356"
  })), _path1724 || (_path1724 = /*#__PURE__*/React.createElement("path", {
    d: "M49 31v1h-1v-1z",
    fill: "#9a7957"
  })), _path1725 || (_path1725 = /*#__PURE__*/React.createElement("path", {
    d: "M51 32h-1v-1h1z",
    fill: "#997d56"
  })), _path1726 || (_path1726 = /*#__PURE__*/React.createElement("path", {
    d: "M51 32v-1h1v1z",
    fill: "#9b7f58"
  })), _path1727 || (_path1727 = /*#__PURE__*/React.createElement("path", {
    d: "M53 31v1h-1v-1z",
    fill: "#9c805a"
  })), _path1728 || (_path1728 = /*#__PURE__*/React.createElement("path", {
    d: "M57 31v1h-1v-1z",
    fill: "#9d7f5c"
  })), _path1729 || (_path1729 = /*#__PURE__*/React.createElement("path", {
    d: "M58 32h-1v-1h1z",
    fill: "#9c7e5b"
  })), _path1730 || (_path1730 = /*#__PURE__*/React.createElement("path", {
    d: "M59 32h-1v-1h1z",
    fill: "#9b7e5a"
  })), _path1731 || (_path1731 = /*#__PURE__*/React.createElement("path", {
    d: "M59 31h1v1h-1z",
    fill: "#9b7d59"
  })), _path1732 || (_path1732 = /*#__PURE__*/React.createElement("path", {
    d: "M60 31h1v1h-1z",
    fill: "#997c57"
  })), _path1733 || (_path1733 = /*#__PURE__*/React.createElement("path", {
    d: "M62 31v1h-1v-1z",
    fill: "#997c58"
  })), _path1734 || (_path1734 = /*#__PURE__*/React.createElement("path", {
    d: "M63 32v-1h1v1z",
    fill: "#9a7c57"
  })), _path1735 || (_path1735 = /*#__PURE__*/React.createElement("path", {
    d: "M73 32v-1h1v1z",
    fill: "#9a7a50"
  })), _path1736 || (_path1736 = /*#__PURE__*/React.createElement("path", {
    d: "M76 32h-1v-1h1z",
    fill: "#9d7d50"
  })), _path1737 || (_path1737 = /*#__PURE__*/React.createElement("path", {
    d: "M77 32h-1v-1h1z",
    fill: "#9b7b4d"
  })), _path1738 || (_path1738 = /*#__PURE__*/React.createElement("path", {
    d: "M78 32h-1v-1h1z",
    fill: "#9b7a4d"
  })), _path1739 || (_path1739 = /*#__PURE__*/React.createElement("path", {
    d: "M79 31h1v1h-1z",
    fill: "#99784d"
  })), _path1740 || (_path1740 = /*#__PURE__*/React.createElement("path", {
    d: "M85 32h-1v-1h1z",
    fill: "#957449"
  })), _path1741 || (_path1741 = /*#__PURE__*/React.createElement("path", {
    d: "M87 32h-1v-1h1z",
    fill: "#947346"
  })), _path1742 || (_path1742 = /*#__PURE__*/React.createElement("path", {
    d: "M88 31v1h-1v-1z",
    fill: "#967448"
  })), _path1743 || (_path1743 = /*#__PURE__*/React.createElement("path", {
    d: "M90 32h-1v-1h1z",
    fill: "#946f45"
  })), _path1744 || (_path1744 = /*#__PURE__*/React.createElement("path", {
    d: "M91 32h-1v-1h1z",
    fill: "#936c40"
  })), _path1745 || (_path1745 = /*#__PURE__*/React.createElement("path", {
    d: "M92 31v1h-1v-1z",
    fill: "#956d3f"
  })), _path1746 || (_path1746 = /*#__PURE__*/React.createElement("path", {
    d: "M92 31h1v1h-1z",
    fill: "#966d3f"
  })), _path1747 || (_path1747 = /*#__PURE__*/React.createElement("path", {
    d: "M93 32v-1h1v1z",
    fill: "#9a7041"
  })), _path1748 || (_path1748 = /*#__PURE__*/React.createElement("path", {
    d: "M95 31v1h-1v-1z",
    fill: "#a27645"
  })), _path1749 || (_path1749 = /*#__PURE__*/React.createElement("path", {
    d: "M96 32h-1v-1h1z",
    fill: "#ad8051"
  })), _path1750 || (_path1750 = /*#__PURE__*/React.createElement("path", {
    d: "M97 32h-1v-1h1z",
    fill: "#b28359"
  })), _path1751 || (_path1751 = /*#__PURE__*/React.createElement("path", {
    d: "M97 32v-1h1v1z",
    fill: "#b18057"
  })), _path1752 || (_path1752 = /*#__PURE__*/React.createElement("path", {
    d: "M99 31v1h-1v-1z",
    fill: "#ad7953"
  })), _path1753 || (_path1753 = /*#__PURE__*/React.createElement("path", {
    d: "M100 31v1h-1v-1z",
    fill: "#a36b44"
  })), _path1754 || (_path1754 = /*#__PURE__*/React.createElement("path", {
    d: "M100 32v-1h1v1z",
    fill: "#a96f47"
  })), _path1755 || (_path1755 = /*#__PURE__*/React.createElement("path", {
    d: "M102 31v1h-1v-1z",
    fill: "#aa744c"
  })), _path1756 || (_path1756 = /*#__PURE__*/React.createElement("path", {
    d: "M102 32v-1h1v1z",
    fill: "#b8835a"
  })), _path1757 || (_path1757 = /*#__PURE__*/React.createElement("path", {
    d: "M103 31h1v1h-1z",
    fill: "#c38d61"
  })), _path1758 || (_path1758 = /*#__PURE__*/React.createElement("path", {
    d: "M105 31v1h-1v-1z",
    fill: "#c99162"
  })), _path1759 || (_path1759 = /*#__PURE__*/React.createElement("path", {
    d: "M105 32v-1h1v1z",
    fill: "#c88d5c"
  })), _path1760 || (_path1760 = /*#__PURE__*/React.createElement("path", {
    d: "M106 31h1v1h-1z",
    fill: "#c78a57"
  })), _path1761 || (_path1761 = /*#__PURE__*/React.createElement("path", {
    d: "M107 32v-1h1v1z",
    fill: "#bf804d"
  })), _path1762 || (_path1762 = /*#__PURE__*/React.createElement("path", {
    d: "M109 32h-1v-1h1z",
    fill: "#b57545"
  })), _path1763 || (_path1763 = /*#__PURE__*/React.createElement("path", {
    d: "M109 31h1v1h-1z",
    fill: "#b0703f"
  })), _path1764 || (_path1764 = /*#__PURE__*/React.createElement("path", {
    d: "M111 32h-1v-1h1z",
    fill: "#b37441"
  })), _path1765 || (_path1765 = /*#__PURE__*/React.createElement("path", {
    d: "M111 31h1v1h-1z",
    fill: "#865028"
  })), _path1766 || (_path1766 = /*#__PURE__*/React.createElement("path", {
    d: "M112 32v-1h1v1z",
    fill: "#a7733f"
  })), _path1767 || (_path1767 = /*#__PURE__*/React.createElement("path", {
    d: "M113 32v-1h1v1z",
    fill: "#c58853"
  })), _path1768 || (_path1768 = /*#__PURE__*/React.createElement("path", {
    d: "M114 32v-1h1v1z",
    fill: "#aa7442"
  })), _path1769 || (_path1769 = /*#__PURE__*/React.createElement("path", {
    d: "M116 32h-1v-1h1z",
    fill: "#734419"
  })), _path1770 || (_path1770 = /*#__PURE__*/React.createElement("path", {
    d: "M116 31h1v1h-1z",
    fill: "#784c24"
  })), _path1771 || (_path1771 = /*#__PURE__*/React.createElement("path", {
    d: "M118 32h-1v-1h1z",
    fill: "#754923",
    fillOpacity: 0.929
  })), _path1772 || (_path1772 = /*#__PURE__*/React.createElement("path", {
    d: "M119 31v1h-1v-1z",
    fill: "#724b27",
    fillOpacity: 0.757
  })), _path1773 || (_path1773 = /*#__PURE__*/React.createElement("path", {
    d: "M119 31h1v1h-1z",
    fill: "#82532d",
    fillOpacity: 0.965
  })), _path1774 || (_path1774 = /*#__PURE__*/React.createElement("path", {
    d: "M121 32h-1v-1h1z",
    fill: "#885630"
  })), _path1775 || (_path1775 = /*#__PURE__*/React.createElement("path", {
    d: "M121 31h1v1h-1z",
    fill: "#9d6c46"
  })), _path1776 || (_path1776 = /*#__PURE__*/React.createElement("path", {
    d: "M122 31h1v1h-1z",
    fill: "#9e7455",
    fillOpacity: 0.965
  })), _path1777 || (_path1777 = /*#__PURE__*/React.createElement("path", {
    d: "M124 31v1h-1v-1z",
    fill: "#957663",
    fillOpacity: 0.161
  })), _path1778 || (_path1778 = /*#__PURE__*/React.createElement("path", {
    d: "M3 33v-1h1v1z",
    fill: "#ac8368",
    fillOpacity: 0.729
  })), _path1779 || (_path1779 = /*#__PURE__*/React.createElement("path", {
    d: "M5 32v1H4v-1z",
    fill: "#af825f"
  })), _path1780 || (_path1780 = /*#__PURE__*/React.createElement("path", {
    d: "M6 33H5v-1h1z",
    fill: "#86603d"
  })), _path1781 || (_path1781 = /*#__PURE__*/React.createElement("path", {
    d: "M6 32h1v1H6z",
    fill: "#8e6443"
  })), _path1782 || (_path1782 = /*#__PURE__*/React.createElement("path", {
    d: "M8 32v1H7v-1z",
    fill: "#8d6240"
  })), _path1783 || (_path1783 = /*#__PURE__*/React.createElement("path", {
    d: "M8 32h1v1H8z",
    fill: "#7e593f",
    fillOpacity: 0.682
  })), _path1784 || (_path1784 = /*#__PURE__*/React.createElement("path", {
    d: "M21 33h-1v-1h1z",
    fill: "#876348",
    fillOpacity: 0.333
  })), _path1785 || (_path1785 = /*#__PURE__*/React.createElement("path", {
    d: "M22 33h-1v-1h1z",
    fill: "#92633d"
  })), _path1786 || (_path1786 = /*#__PURE__*/React.createElement("path", {
    d: "M22 32h1v1h-1z",
    fill: "#905a31"
  })), _path1787 || (_path1787 = /*#__PURE__*/React.createElement("path", {
    d: "M24 33v-1h1v1z",
    fill: "#52260b"
  })), _path1788 || (_path1788 = /*#__PURE__*/React.createElement("path", {
    d: "M26 32v1h-1v-1z",
    fill: "#65371a"
  })), _path1789 || (_path1789 = /*#__PURE__*/React.createElement("path", {
    d: "M26 33v-1h1v1z",
    fill: "#754524"
  })), _path1790 || (_path1790 = /*#__PURE__*/React.createElement("path", {
    d: "M28 32h1v1h-1z",
    fill: "#6c3f23"
  })), _path1791 || (_path1791 = /*#__PURE__*/React.createElement("path", {
    d: "M30 33h-1v-1h1z",
    fill: "#6b3e20"
  })), _path1792 || (_path1792 = /*#__PURE__*/React.createElement("path", {
    d: "M31 32v1h-1v-1z",
    fill: "#724423"
  })), _path1793 || (_path1793 = /*#__PURE__*/React.createElement("path", {
    d: "M32 32v1h-1v-1z",
    fill: "#6e401f"
  })), _path1794 || (_path1794 = /*#__PURE__*/React.createElement("path", {
    d: "M33 32h1v1h-1z",
    fill: "#6e4024"
  })), _path1795 || (_path1795 = /*#__PURE__*/React.createElement("path", {
    d: "M34 33v-1h1v1z",
    fill: "#724323"
  })), _path1796 || (_path1796 = /*#__PURE__*/React.createElement("path", {
    d: "M35 32h1v1h-1z",
    fill: "#754425"
  })), _path1797 || (_path1797 = /*#__PURE__*/React.createElement("path", {
    d: "M37 33h-1v-1h1z",
    fill: "#744222"
  })), _path1798 || (_path1798 = /*#__PURE__*/React.createElement("path", {
    d: "M37 33v-1h1v1z",
    fill: "#734522"
  })), _path1799 || (_path1799 = /*#__PURE__*/React.createElement("path", {
    d: "M38 32h1v1h-1z",
    fill: "#996b58"
  })), _path1800 || (_path1800 = /*#__PURE__*/React.createElement("path", {
    d: "M40 33h-1v-1h1z",
    fill: "#9d6f64"
  })), _path1801 || (_path1801 = /*#__PURE__*/React.createElement("path", {
    d: "M41 32v1h-1v-1z",
    fill: "#9f7263"
  })), _path1802 || (_path1802 = /*#__PURE__*/React.createElement("path", {
    d: "M42 32v1h-1v-1z",
    fill: "#7c5134"
  })), _path1803 || (_path1803 = /*#__PURE__*/React.createElement("path", {
    d: "M43 32v1h-1v-1z",
    fill: "#6a3b15"
  })), _path1804 || (_path1804 = /*#__PURE__*/React.createElement("path", {
    d: "M44 32v1h-1v-1z",
    fill: "#7b4d2a"
  })), _path1805 || (_path1805 = /*#__PURE__*/React.createElement("path", {
    d: "M44 33v-1h1v1z",
    fill: "#805030"
  })), _path1806 || (_path1806 = /*#__PURE__*/React.createElement("path", {
    d: "M46 32v1h-1v-1z",
    fill: "#845636"
  })), _path1807 || (_path1807 = /*#__PURE__*/React.createElement("path", {
    d: "M46 32h1v1h-1z",
    fill: "#8b5e41"
  })), _path1808 || (_path1808 = /*#__PURE__*/React.createElement("path", {
    d: "M48 32v1h-1v-1z",
    fill: "#8d6446"
  })), _path1809 || (_path1809 = /*#__PURE__*/React.createElement("path", {
    d: "M48 33v-1h1v1z",
    fill: "#8f6945"
  })), _path1810 || (_path1810 = /*#__PURE__*/React.createElement("path", {
    d: "M50 33h-1v-1h1z",
    fill: "#977050"
  })), _path1811 || (_path1811 = /*#__PURE__*/React.createElement("path", {
    d: "M51 33h-1v-1h1z",
    fill: "#9a7554"
  })), _path1812 || (_path1812 = /*#__PURE__*/React.createElement("path", {
    d: "M51 33v-1h1v1z",
    fill: "#9b7753"
  })), _path1813 || (_path1813 = /*#__PURE__*/React.createElement("path", {
    d: "M53 32v1h-1v-1z",
    fill: "#9a7551"
  })), _path1814 || (_path1814 = /*#__PURE__*/React.createElement("path", {
    d: "M53 33v-1h1v1z",
    fill: "#98784f"
  })), _path1815 || (_path1815 = /*#__PURE__*/React.createElement("path", {
    d: "M55 32v1h-1v-1z",
    fill: "#9c7c53"
  })), _path1816 || (_path1816 = /*#__PURE__*/React.createElement("path", {
    d: "M56 33h-1v-1h1z",
    fill: "#9d7e57"
  })), _path1817 || (_path1817 = /*#__PURE__*/React.createElement("path", {
    d: "M57 33h-1v-1h1z",
    fill: "#9e8059"
  })), _path1818 || (_path1818 = /*#__PURE__*/React.createElement("path", {
    d: "M58 33v-1h1v1z",
    fill: "#9e8159"
  })), _path1819 || (_path1819 = /*#__PURE__*/React.createElement("path", {
    d: "M60 32v1h-1v-1z",
    fill: "#9e825a"
  })), _path1820 || (_path1820 = /*#__PURE__*/React.createElement("path", {
    d: "M60 32h1v1h-1z",
    fill: "#9c8059"
  })), _path1821 || (_path1821 = /*#__PURE__*/React.createElement("path", {
    d: "M62 33h-1v-1h1z",
    fill: "#9c7f57"
  })), _path1822 || (_path1822 = /*#__PURE__*/React.createElement("path", {
    d: "M63 32v1h-1v-1z",
    fill: "#9b7e54"
  })), _path1823 || (_path1823 = /*#__PURE__*/React.createElement("path", {
    d: "M63 32h1v1h-1z",
    fill: "#997c53"
  })), _path1824 || (_path1824 = /*#__PURE__*/React.createElement("path", {
    d: "M65 32v1h-1v-1z",
    fill: "#987c53"
  })), _path1825 || (_path1825 = /*#__PURE__*/React.createElement("path", {
    d: "M68 32v1h-1v-1z",
    fill: "#987952"
  })), _path1826 || (_path1826 = /*#__PURE__*/React.createElement("path", {
    d: "M69 33h-1v-1h1z",
    fill: "#977650"
  })), _path1827 || (_path1827 = /*#__PURE__*/React.createElement("path", {
    d: "M70 33h-1v-1h1z",
    fill: "#96764f"
  })), _path1828 || (_path1828 = /*#__PURE__*/React.createElement("path", {
    d: "M70 33v-1h1v1z",
    fill: "#987750"
  })), _path1829 || (_path1829 = /*#__PURE__*/React.createElement("path", {
    d: "M71 32h1v1h-1z",
    fill: "#96764e"
  })), _path1830 || (_path1830 = /*#__PURE__*/React.createElement("path", {
    d: "M75 33v-1h1v1z",
    fill: "#96774d"
  })), _path1831 || (_path1831 = /*#__PURE__*/React.createElement("path", {
    d: "M78 32h1v1h-1z",
    fill: "#99784c"
  })), _path1832 || (_path1832 = /*#__PURE__*/React.createElement("path", {
    d: "M82 33v-1h1v1z",
    fill: "#9c7a4e"
  })), _path1833 || (_path1833 = /*#__PURE__*/React.createElement("path", {
    d: "M83 32h1v1h-1z",
    fill: "#9e7d4f"
  })), _path1834 || (_path1834 = /*#__PURE__*/React.createElement("path", {
    d: "M85 32v1h-1v-1z",
    fill: "#9f7e4e"
  })), _path1835 || (_path1835 = /*#__PURE__*/React.createElement("path", {
    d: "M86 33h-1v-1h1z",
    fill: "#a18050"
  })), _path1836 || (_path1836 = /*#__PURE__*/React.createElement("path", {
    d: "M87 33h-1v-1h1z",
    fill: "#a1804f"
  })), _path1837 || (_path1837 = /*#__PURE__*/React.createElement("path", {
    d: "M87 33v-1h1v1z",
    fill: "#9f7e4d"
  })), _path1838 || (_path1838 = /*#__PURE__*/React.createElement("path", {
    d: "M89 33h-1v-1h1z",
    fill: "#9c7a4c"
  })), _path1839 || (_path1839 = /*#__PURE__*/React.createElement("path", {
    d: "M89 33v-1h1v1z",
    fill: "#9c764a"
  })), _path1840 || (_path1840 = /*#__PURE__*/React.createElement("path", {
    d: "M90 32h1v1h-1z",
    fill: "#9f7449"
  })), _path1841 || (_path1841 = /*#__PURE__*/React.createElement("path", {
    d: "M92 32v1h-1v-1z",
    fill: "#9f7248"
  })), _path1842 || (_path1842 = /*#__PURE__*/React.createElement("path", {
    d: "M93 33h-1v-1h1z",
    fill: "#a67851"
  })), _path1843 || (_path1843 = /*#__PURE__*/React.createElement("path", {
    d: "M93 32h1v1h-1z",
    fill: "#a67651"
  })), _path1844 || (_path1844 = /*#__PURE__*/React.createElement("path", {
    d: "M94 33v-1h1v1z",
    fill: "#a57450"
  })), _path1845 || (_path1845 = /*#__PURE__*/React.createElement("path", {
    d: "M96 32v1h-1v-1z",
    fill: "#a87853"
  })), _path1846 || (_path1846 = /*#__PURE__*/React.createElement("path", {
    d: "M96 33v-1h1v1z",
    fill: "#ab7a54"
  })), _path1847 || (_path1847 = /*#__PURE__*/React.createElement("path", {
    d: "M98 33h-1v-1h1z",
    fill: "#a7764e"
  })), _path1848 || (_path1848 = /*#__PURE__*/React.createElement("path", {
    d: "M98 32h1v1h-1z",
    fill: "#ab784e"
  })), _path1849 || (_path1849 = /*#__PURE__*/React.createElement("path", {
    d: "M101 33h-1v-1h1z",
    fill: "#ba8156"
  })), _path1850 || (_path1850 = /*#__PURE__*/React.createElement("path", {
    d: "M102 33h-1v-1h1z",
    fill: "#cc9467"
  })), _path1851 || (_path1851 = /*#__PURE__*/React.createElement("path", {
    d: "M103 32v1h-1v-1z",
    fill: "#d69d6e"
  })), _path1852 || (_path1852 = /*#__PURE__*/React.createElement("path", {
    d: "M103 32h1v1h-1z",
    fill: "#db9f6f"
  })), _path1853 || (_path1853 = /*#__PURE__*/React.createElement("path", {
    d: "M105 33h-1v-1h1z",
    fill: "#dc9e6b"
  })), _path1854 || (_path1854 = /*#__PURE__*/React.createElement("path", {
    d: "M106 32v1h-1v-1z",
    fill: "#d69661"
  })), _path1855 || (_path1855 = /*#__PURE__*/React.createElement("path", {
    d: "M106 33v-1h1v1z",
    fill: "#d8925b"
  })), _path1856 || (_path1856 = /*#__PURE__*/React.createElement("path", {
    d: "M107 32h1v1h-1z",
    fill: "#d48f58"
  })), _path1857 || (_path1857 = /*#__PURE__*/React.createElement("path", {
    d: "M109 32v1h-1v-1z",
    fill: "#d5925d"
  })), _path1858 || (_path1858 = /*#__PURE__*/React.createElement("path", {
    d: "M109 33v-1h1v1z",
    fill: "#c28452"
  })), _path1859 || (_path1859 = /*#__PURE__*/React.createElement("path", {
    d: "M111 32v1h-1v-1z",
    fill: "#a46c3b"
  })), _path1860 || (_path1860 = /*#__PURE__*/React.createElement("path", {
    d: "M111 33v-1h1v1z",
    fill: "#73441d"
  })), _path1861 || (_path1861 = /*#__PURE__*/React.createElement("path", {
    d: "M112 33v-1h1v1z",
    fill: "#a8753f"
  })), _path1862 || (_path1862 = /*#__PURE__*/React.createElement("path", {
    d: "M113 33v-1h1v1z",
    fill: "#c3844d"
  })), _path1863 || (_path1863 = /*#__PURE__*/React.createElement("path", {
    d: "M115 33h-1v-1h1z",
    fill: "#a36d3f"
  })), _path1864 || (_path1864 = /*#__PURE__*/React.createElement("path", {
    d: "M115 33v-1h1v1z",
    fill: "#683810"
  })), _path1865 || (_path1865 = /*#__PURE__*/React.createElement("path", {
    d: "M116 33v-1h1v1z",
    fill: "#744317"
  })), _path1866 || (_path1866 = /*#__PURE__*/React.createElement("path", {
    d: "M117 32h1v1h-1z",
    fill: "#7b481a"
  })), _path1867 || (_path1867 = /*#__PURE__*/React.createElement("path", {
    d: "M120 33h-1v-1h1z",
    fill: "#845229"
  })), _path1868 || (_path1868 = /*#__PURE__*/React.createElement("path", {
    d: "M121 32v1h-1v-1z",
    fill: "#87562f"
  })), _path1869 || (_path1869 = /*#__PURE__*/React.createElement("path", {
    d: "M122 32v1h-1v-1z",
    fill: "#9f6e49"
  })), _path1870 || (_path1870 = /*#__PURE__*/React.createElement("path", {
    d: "M122 32h1v1h-1z",
    fill: "#9f7455",
    fillOpacity: 0.894
  })), _path1871 || (_path1871 = /*#__PURE__*/React.createElement("path", {
    d: "M123 33v-1h1v1z",
    fill: "#8d7163",
    fillOpacity: 0.071
  })), _path1872 || (_path1872 = /*#__PURE__*/React.createElement("path", {
    d: "M4 33v1H3v-1z",
    fill: "#ab8467",
    fillOpacity: 0.514
  })), _path1873 || (_path1873 = /*#__PURE__*/React.createElement("path", {
    d: "M5 34H4v-1h1z",
    fill: "#b58764"
  })), _path1874 || (_path1874 = /*#__PURE__*/React.createElement("path", {
    d: "M5 33h1v1H5z",
    fill: "#8e633f"
  })), _path1875 || (_path1875 = /*#__PURE__*/React.createElement("path", {
    d: "M7 34H6v-1h1z",
    fill: "#8d633e"
  })), _path1876 || (_path1876 = /*#__PURE__*/React.createElement("path", {
    d: "M8 34H7v-1h1z",
    fill: "#8c623d"
  })), _path1877 || (_path1877 = /*#__PURE__*/React.createElement("path", {
    d: "M9 34H8v-1h1z",
    fill: "#7e5838",
    fillOpacity: 0.847
  })), _path1878 || (_path1878 = /*#__PURE__*/React.createElement("path", {
    d: "M20 33h1v1h-1z",
    fill: "#87694f",
    fillOpacity: 0.302
  })), _path1879 || (_path1879 = /*#__PURE__*/React.createElement("path", {
    d: "M22 33v1h-1v-1z",
    fill: "#96643a"
  })), _path1880 || (_path1880 = /*#__PURE__*/React.createElement("path", {
    d: "M23 34h-1v-1h1z",
    fill: "#925e30"
  })), _path1881 || (_path1881 = /*#__PURE__*/React.createElement("path", {
    d: "M24 34h-1v-1h1z",
    fill: "#8d5b30"
  })), _path1882 || (_path1882 = /*#__PURE__*/React.createElement("path", {
    d: "M24 33h1v1h-1z",
    fill: "#5b2d0e"
  })), _path1883 || (_path1883 = /*#__PURE__*/React.createElement("path", {
    d: "M25 33h1v1h-1z",
    fill: "#67391b"
  })), _path1884 || (_path1884 = /*#__PURE__*/React.createElement("path", {
    d: "M26 33h1v1h-1z",
    fill: "#7c4b25"
  })), _path1885 || (_path1885 = /*#__PURE__*/React.createElement("path", {
    d: "M28 34v-1h1v1z",
    fill: "#7d4c27"
  })), _path1886 || (_path1886 = /*#__PURE__*/React.createElement("path", {
    d: "M29 33h1v1h-1z",
    fill: "#764624"
  })), _path1887 || (_path1887 = /*#__PURE__*/React.createElement("path", {
    d: "M31 33v1h-1v-1z",
    fill: "#774926"
  })), _path1888 || (_path1888 = /*#__PURE__*/React.createElement("path", {
    d: "M32 34h-1v-1h1z",
    fill: "#754828"
  })), _path1889 || (_path1889 = /*#__PURE__*/React.createElement("path", {
    d: "M33 33v1h-1v-1z",
    fill: "#74472a"
  })), _path1890 || (_path1890 = /*#__PURE__*/React.createElement("path", {
    d: "M33 34v-1h1v1z",
    fill: "#744426"
  })), _path1891 || (_path1891 = /*#__PURE__*/React.createElement("path", {
    d: "M35 33v1h-1v-1z",
    fill: "#754526"
  })), _path1892 || (_path1892 = /*#__PURE__*/React.createElement("path", {
    d: "M35 34v-1h1v1z",
    fill: "#784729"
  })), _path1893 || (_path1893 = /*#__PURE__*/React.createElement("path", {
    d: "M36 33h1v1h-1z",
    fill: "#774627"
  })), _path1894 || (_path1894 = /*#__PURE__*/React.createElement("path", {
    d: "M37 33h1v1h-1z",
    fill: "#78482c"
  })), _path1895 || (_path1895 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33h1v1h-1z",
    fill: "#9a6e60"
  })), _path1896 || (_path1896 = /*#__PURE__*/React.createElement("path", {
    d: "M39 33h1v1h-1z",
    fill: "#9a7167"
  })), _path1897 || (_path1897 = /*#__PURE__*/React.createElement("path", {
    d: "M40 34v-1h1v1z",
    fill: "#9e7463"
  })), _path1898 || (_path1898 = /*#__PURE__*/React.createElement("path", {
    d: "M42 34h-1v-1h1z",
    fill: "#7d5236"
  })), _path1899 || (_path1899 = /*#__PURE__*/React.createElement("path", {
    d: "M43 34h-1v-1h1z",
    fill: "#653714"
  })), _path1900 || (_path1900 = /*#__PURE__*/React.createElement("path", {
    d: "M43 33h1v1h-1z",
    fill: "#744221"
  })), _path1901 || (_path1901 = /*#__PURE__*/React.createElement("path", {
    d: "M44 33h1v1h-1z",
    fill: "#74421d"
  })), _path1902 || (_path1902 = /*#__PURE__*/React.createElement("path", {
    d: "M45 33h1v1h-1z",
    fill: "#714018"
  })), _path1903 || (_path1903 = /*#__PURE__*/React.createElement("path", {
    d: "M47 34h-1v-1h1z",
    fill: "#73431b"
  })), _path1904 || (_path1904 = /*#__PURE__*/React.createElement("path", {
    d: "M48 33v1h-1v-1z",
    fill: "#74441d"
  })), _path1905 || (_path1905 = /*#__PURE__*/React.createElement("path", {
    d: "M49 33v1h-1v-1z",
    fill: "#76471f"
  })), _path1906 || (_path1906 = /*#__PURE__*/React.createElement("path", {
    d: "M50 33v1h-1v-1z",
    fill: "#7b4b23"
  })), _path1907 || (_path1907 = /*#__PURE__*/React.createElement("path", {
    d: "M50 34v-1h1v1z",
    fill: "#7e512a"
  })), _path1908 || (_path1908 = /*#__PURE__*/React.createElement("path", {
    d: "M52 33v1h-1v-1z",
    fill: "#845a35"
  })), _path1909 || (_path1909 = /*#__PURE__*/React.createElement("path", {
    d: "M53 33h1v1h-1z",
    fill: "#855738"
  })), _path1910 || (_path1910 = /*#__PURE__*/React.createElement("path", {
    d: "M54 33h1v1h-1z",
    fill: "#8f6341"
  })), _path1911 || (_path1911 = /*#__PURE__*/React.createElement("path", {
    d: "M56 34h-1v-1h1z",
    fill: "#946a44"
  })), _path1912 || (_path1912 = /*#__PURE__*/React.createElement("path", {
    d: "M57 33v1h-1v-1z",
    fill: "#956d44"
  })), _path1913 || (_path1913 = /*#__PURE__*/React.createElement("path", {
    d: "M58 34h-1v-1h1z",
    fill: "#987346"
  })), _path1914 || (_path1914 = /*#__PURE__*/React.createElement("path", {
    d: "M59 34h-1v-1h1z",
    fill: "#9b784b"
  })), _path1915 || (_path1915 = /*#__PURE__*/React.createElement("path", {
    d: "M60 33h1v1h-1z",
    fill: "#9e7c51"
  })), _path1916 || (_path1916 = /*#__PURE__*/React.createElement("path", {
    d: "M62 33v1h-1v-1z",
    fill: "#9d7d51"
  })), _path1917 || (_path1917 = /*#__PURE__*/React.createElement("path", {
    d: "M62 34v-1h1v1z",
    fill: "#9b7c50"
  })), _path1918 || (_path1918 = /*#__PURE__*/React.createElement("path", {
    d: "M66 33v1h-1v-1z",
    fill: "#9a7d51"
  })), _path1919 || (_path1919 = /*#__PURE__*/React.createElement("path", {
    d: "M67 33v1h-1v-1z",
    fill: "#9b7d52"
  })), _path1920 || (_path1920 = /*#__PURE__*/React.createElement("path", {
    d: "M69 33h1v1h-1z",
    fill: "#997952"
  })), _path1921 || (_path1921 = /*#__PURE__*/React.createElement("path", {
    d: "M72 34h-1v-1h1z",
    fill: "#96764c"
  })), _path1922 || (_path1922 = /*#__PURE__*/React.createElement("path", {
    d: "M73 34h-1v-1h1z",
    fill: "#94744c"
  })), _path1923 || (_path1923 = /*#__PURE__*/React.createElement("path", {
    d: "M74 33h1v1h-1z",
    fill: "#95754b"
  })), _path1924 || (_path1924 = /*#__PURE__*/React.createElement("path", {
    d: "M75 34v-1h1v1z",
    fill: "#97774d"
  })), _path1925 || (_path1925 = /*#__PURE__*/React.createElement("path", {
    d: "M78 33v1h-1v-1z",
    fill: "#99784b"
  })), _path1926 || (_path1926 = /*#__PURE__*/React.createElement("path", {
    d: "M81 33h1v1h-1z",
    fill: "#99784a"
  })), _path1927 || (_path1927 = /*#__PURE__*/React.createElement("path", {
    d: "M82 34v-1h1v1z",
    fill: "#9a784b"
  })), _path1928 || (_path1928 = /*#__PURE__*/React.createElement("path", {
    d: "M84 33v1h-1v-1z",
    fill: "#997848"
  })), _path1929 || (_path1929 = /*#__PURE__*/React.createElement("path", {
    d: "M86 33v1h-1v-1z",
    fill: "#9c794d"
  })), _path1930 || (_path1930 = /*#__PURE__*/React.createElement("path", {
    d: "M86 33h1v1h-1z",
    fill: "#9f7b4d"
  })), _path1931 || (_path1931 = /*#__PURE__*/React.createElement("path", {
    d: "M87 33h1v1h-1z",
    fill: "#a2804f"
  })), _path1932 || (_path1932 = /*#__PURE__*/React.createElement("path", {
    d: "M89 33v1h-1v-1z",
    fill: "#a98456"
  })), _path1933 || (_path1933 = /*#__PURE__*/React.createElement("path", {
    d: "M90 34h-1v-1h1z",
    fill: "#ad8359"
  })), _path1934 || (_path1934 = /*#__PURE__*/React.createElement("path", {
    d: "M91 33v1h-1v-1z",
    fill: "#a67955"
  })), _path1935 || (_path1935 = /*#__PURE__*/React.createElement("path", {
    d: "M91 33h1v1h-1z",
    fill: "#9f704e"
  })), _path1936 || (_path1936 = /*#__PURE__*/React.createElement("path", {
    d: "M93 34h-1v-1h1z",
    fill: "#a1714f"
  })), _path1937 || (_path1937 = /*#__PURE__*/React.createElement("path", {
    d: "M93 33h1v1h-1z",
    fill: "#9e6d4b"
  })), _path1938 || (_path1938 = /*#__PURE__*/React.createElement("path", {
    d: "M95 33v1h-1v-1z",
    fill: "#a06f4b"
  })), _path1939 || (_path1939 = /*#__PURE__*/React.createElement("path", {
    d: "M96 33v1h-1v-1z",
    fill: "#9f714d"
  })), _path1940 || (_path1940 = /*#__PURE__*/React.createElement("path", {
    d: "M96 33h1v1h-1z",
    fill: "#a2724f"
  })), _path1941 || (_path1941 = /*#__PURE__*/React.createElement("path", {
    d: "M98 33v1h-1v-1z",
    fill: "#aa7651"
  })), _path1942 || (_path1942 = /*#__PURE__*/React.createElement("path", {
    d: "M98 34v-1h1v1z",
    fill: "#bb8357"
  })), _path1943 || (_path1943 = /*#__PURE__*/React.createElement("path", {
    d: "M99 33h1v1h-1z",
    fill: "#c78856"
  })), _path1944 || (_path1944 = /*#__PURE__*/React.createElement("path", {
    d: "M100 34v-1h1v1z",
    fill: "#d18d57"
  })), _path1945 || (_path1945 = /*#__PURE__*/React.createElement("path", {
    d: "M102 34h-1v-1h1z",
    fill: "#d89560"
  })), _path1946 || (_path1946 = /*#__PURE__*/React.createElement("path", {
    d: "M103 33v1h-1v-1z",
    fill: "#e6a26d"
  })), _path1947 || (_path1947 = /*#__PURE__*/React.createElement("path", {
    d: "M103 33h1v1h-1z",
    fill: "#e69f69"
  })), _path1948 || (_path1948 = /*#__PURE__*/React.createElement("path", {
    d: "M105 33v1h-1v-1z",
    fill: "#e19c64"
  })), _path1949 || (_path1949 = /*#__PURE__*/React.createElement("path", {
    d: "M106 33v1h-1v-1z",
    fill: "#d6945e",
    fillOpacity: 0.984
  })), _path1950 || (_path1950 = /*#__PURE__*/React.createElement("path", {
    d: "M106 33h1v1h-1z",
    fill: "#da9b68",
    fillOpacity: 0.843
  })), _path1951 || (_path1951 = /*#__PURE__*/React.createElement("path", {
    d: "M108 33v1h-1v-1z",
    fill: "#d19c72",
    fillOpacity: 0.631
  })), _path1952 || (_path1952 = /*#__PURE__*/React.createElement("path", {
    d: "M109 34h-1v-1h1z",
    fill: "#9e693d",
    fillOpacity: 0.914
  })), _path1953 || (_path1953 = /*#__PURE__*/React.createElement("path", {
    d: "M110 34h-1v-1h1z",
    fill: "#72451e"
  })), _path1954 || (_path1954 = /*#__PURE__*/React.createElement("path", {
    d: "M110 33h1v1h-1z",
    fill: "#55320f"
  })), _path1955 || (_path1955 = /*#__PURE__*/React.createElement("path", {
    d: "M112 33v1h-1v-1z",
    fill: "#593412"
  })), _path1956 || (_path1956 = /*#__PURE__*/React.createElement("path", {
    d: "M112 34v-1h1v1z",
    fill: "#a7723e"
  })), _path1957 || (_path1957 = /*#__PURE__*/React.createElement("path", {
    d: "M113 34v-1h1v1z",
    fill: "#bc8047"
  })), _path1958 || (_path1958 = /*#__PURE__*/React.createElement("path", {
    d: "M115 33v1h-1v-1z",
    fill: "#9a663e",
    fillOpacity: 0.965
  })), _path1959 || (_path1959 = /*#__PURE__*/React.createElement("path", {
    d: "M116 34h-1v-1h1z",
    fill: "#5a2f12",
    fillOpacity: 0.961
  })), _path1960 || (_path1960 = /*#__PURE__*/React.createElement("path", {
    d: "M116 33h1v1h-1z",
    fill: "#6a3f1b"
  })), _path1961 || (_path1961 = /*#__PURE__*/React.createElement("path", {
    d: "M117 34v-1h1v1z",
    fill: "#78451b"
  })), _path1962 || (_path1962 = /*#__PURE__*/React.createElement("path", {
    d: "M118 33h1v1h-1z",
    fill: "#7f4c23"
  })), _path1963 || (_path1963 = /*#__PURE__*/React.createElement("path", {
    d: "M120 33v1h-1v-1z",
    fill: "#84522b"
  })), _path1964 || (_path1964 = /*#__PURE__*/React.createElement("path", {
    d: "M121 34h-1v-1h1z",
    fill: "#895630"
  })), _path1965 || (_path1965 = /*#__PURE__*/React.createElement("path", {
    d: "M122 34h-1v-1h1z",
    fill: "#9f6e4c"
  })), _path1966 || (_path1966 = /*#__PURE__*/React.createElement("path", {
    d: "M122 33h1v1h-1z",
    fill: "#9d7153",
    fillOpacity: 0.804
  })), _path1967 || (_path1967 = /*#__PURE__*/React.createElement("path", {
    d: "M124 34h-1v-1h1z",
    fill: "#555",
    fillOpacity: 0.012
  })), _path1968 || (_path1968 = /*#__PURE__*/React.createElement("path", {
    d: "M3 34h1v1H3z",
    fill: "#a58469",
    fillOpacity: 0.302
  })), _path1969 || (_path1969 = /*#__PURE__*/React.createElement("path", {
    d: "M5 34v1H4v-1z",
    fill: "#b38666"
  })), _path1970 || (_path1970 = /*#__PURE__*/React.createElement("path", {
    d: "M6 35H5v-1h1z",
    fill: "#966947"
  })), _path1971 || (_path1971 = /*#__PURE__*/React.createElement("path", {
    d: "M6 34h1v1H6z",
    fill: "#8b5f3d"
  })), _path1972 || (_path1972 = /*#__PURE__*/React.createElement("path", {
    d: "M8 34v1H7v-1z",
    fill: "#8a5f3d"
  })), _path1973 || (_path1973 = /*#__PURE__*/React.createElement("path", {
    d: "M8 34h1v1H8z",
    fill: "#7e5739",
    fillOpacity: 0.965
  })), _path1974 || (_path1974 = /*#__PURE__*/React.createElement("path", {
    d: "M9 34h1v1H9z",
    fill: "#765d4a",
    fillOpacity: 0.161
  })), _path1975 || (_path1975 = /*#__PURE__*/React.createElement("path", {
    d: "M21 34v1h-1v-1z",
    fill: "#866a4d",
    fillOpacity: 0.282
  })), _path1976 || (_path1976 = /*#__PURE__*/React.createElement("path", {
    d: "M22 35h-1v-1h1z",
    fill: "#946439"
  })), _path1977 || (_path1977 = /*#__PURE__*/React.createElement("path", {
    d: "M23 34v1h-1v-1z",
    fill: "#936030"
  })), _path1978 || (_path1978 = /*#__PURE__*/React.createElement("path", {
    d: "M24 35h-1v-1h1z",
    fill: "#966134"
  })), _path1979 || (_path1979 = /*#__PURE__*/React.createElement("path", {
    d: "M25 35h-1v-1h1z",
    fill: "#6e3b1a"
  })), _path1980 || (_path1980 = /*#__PURE__*/React.createElement("path", {
    d: "M25 34h1v1h-1z",
    fill: "#653618"
  })), _path1981 || (_path1981 = /*#__PURE__*/React.createElement("path", {
    d: "M26 34h1v1h-1z",
    fill: "#764920"
  })), _path1982 || (_path1982 = /*#__PURE__*/React.createElement("path", {
    d: "M27 34h1v1h-1z",
    fill: "#7b4d25",
    fillOpacity: 0.957
  })), _path1983 || (_path1983 = /*#__PURE__*/React.createElement("path", {
    d: "M28 34h1v1h-1z",
    fill: "#794d2c",
    fillOpacity: 0.988
  })), _path1984 || (_path1984 = /*#__PURE__*/React.createElement("path", {
    d: "M29 35v-1h1v1z",
    fill: "#7a4c25"
  })), _path1985 || (_path1985 = /*#__PURE__*/React.createElement("path", {
    d: "M31 35h-1v-1h1z",
    fill: "#7c4e24"
  })), _path1986 || (_path1986 = /*#__PURE__*/React.createElement("path", {
    d: "M32 34v1h-1v-1z",
    fill: "#7d4e25"
  })), _path1987 || (_path1987 = /*#__PURE__*/React.createElement("path", {
    d: "M32 34h1v1h-1z",
    fill: "#7f502c"
  })), _path1988 || (_path1988 = /*#__PURE__*/React.createElement("path", {
    d: "M33 34h1v1h-1z",
    fill: "#7f4f32"
  })), _path1989 || (_path1989 = /*#__PURE__*/React.createElement("path", {
    d: "M34 35v-1h1v1z",
    fill: "#815333"
  })), _path1990 || (_path1990 = /*#__PURE__*/React.createElement("path", {
    d: "M36 35h-1v-1h1z",
    fill: "#7d4f2f"
  })), _path1991 || (_path1991 = /*#__PURE__*/React.createElement("path", {
    d: "M37 34v1h-1v-1z",
    fill: "#7b4d2c"
  })), _path1992 || (_path1992 = /*#__PURE__*/React.createElement("path", {
    d: "M38 35h-1v-1h1z",
    fill: "#7c4a2f"
  })), _path1993 || (_path1993 = /*#__PURE__*/React.createElement("path", {
    d: "M39 34v1h-1v-1z",
    fill: "#9d7061"
  })), _path1994 || (_path1994 = /*#__PURE__*/React.createElement("path", {
    d: "M39 35v-1h1v1z",
    fill: "#9d756a"
  })), _path1995 || (_path1995 = /*#__PURE__*/React.createElement("path", {
    d: "M41 35h-1v-1h1z",
    fill: "#9f7967"
  })), _path1996 || (_path1996 = /*#__PURE__*/React.createElement("path", {
    d: "M42 34v1h-1v-1z",
    fill: "#80563a"
  })), _path1997 || (_path1997 = /*#__PURE__*/React.createElement("path", {
    d: "M42 35v-1h1v1z",
    fill: "#613210"
  })), _path1998 || (_path1998 = /*#__PURE__*/React.createElement("path", {
    d: "M44 34v1h-1v-1z",
    fill: "#734020"
  })), _path1999 || (_path1999 = /*#__PURE__*/React.createElement("path", {
    d: "M45 35h-1v-1h1z",
    fill: "#794724"
  })), _path2000 || (_path2000 = /*#__PURE__*/React.createElement("path", {
    d: "M45 34h1v1h-1z",
    fill: "#764722"
  })), _path2001 || (_path2001 = /*#__PURE__*/React.createElement("path", {
    d: "M46 35v-1h1v1z",
    fill: "#744521"
  })), _path2002 || (_path2002 = /*#__PURE__*/React.createElement("path", {
    d: "M48 35h-1v-1h1z",
    fill: "#6e3e19"
  })), _path2003 || (_path2003 = /*#__PURE__*/React.createElement("path", {
    d: "M49 35h-1v-1h1z",
    fill: "#6e3c19"
  })), _path2004 || (_path2004 = /*#__PURE__*/React.createElement("path", {
    d: "M49 35v-1h1v1z",
    fill: "#6b3a1b"
  })), _path2005 || (_path2005 = /*#__PURE__*/React.createElement("path", {
    d: "M50 34h1v1h-1z",
    fill: "#6e3d1d"
  })), _path2006 || (_path2006 = /*#__PURE__*/React.createElement("path", {
    d: "M52 34v1h-1v-1z",
    fill: "#73411d"
  })), _path2007 || (_path2007 = /*#__PURE__*/React.createElement("path", {
    d: "M53 34v1h-1v-1z",
    fill: "#75421c"
  })), _path2008 || (_path2008 = /*#__PURE__*/React.createElement("path", {
    d: "M53 35v-1h1v1z",
    fill: "#6f3d19"
  })), _path2009 || (_path2009 = /*#__PURE__*/React.createElement("path", {
    d: "M55 34v1h-1v-1z",
    fill: "#7a4824"
  })), _path2010 || (_path2010 = /*#__PURE__*/React.createElement("path", {
    d: "M55 35v-1h1v1z",
    fill: "#7d4b23"
  })), _path2011 || (_path2011 = /*#__PURE__*/React.createElement("path", {
    d: "M56 35v-1h1v1z",
    fill: "#834f26"
  })), _path2012 || (_path2012 = /*#__PURE__*/React.createElement("path", {
    d: "M57 34h1v1h-1z",
    fill: "#83532a"
  })), _path2013 || (_path2013 = /*#__PURE__*/React.createElement("path", {
    d: "M58 35v-1h1v1z",
    fill: "#875a30"
  })), _path2014 || (_path2014 = /*#__PURE__*/React.createElement("path", {
    d: "M60 34v1h-1v-1z",
    fill: "#85592e"
  })), _path2015 || (_path2015 = /*#__PURE__*/React.createElement("path", {
    d: "M60 34h1v1h-1z",
    fill: "#895e34"
  })), _path2016 || (_path2016 = /*#__PURE__*/React.createElement("path", {
    d: "M61 35v-1h1v1z",
    fill: "#8a6036"
  })), _path2017 || (_path2017 = /*#__PURE__*/React.createElement("path", {
    d: "M63 35h-1v-1h1z",
    fill: "#8c643a"
  })), _path2018 || (_path2018 = /*#__PURE__*/React.createElement("path", {
    d: "M64 35h-1v-1h1z",
    fill: "#8f693d"
  })), _path2019 || (_path2019 = /*#__PURE__*/React.createElement("path", {
    d: "M65 34v1h-1v-1z",
    fill: "#936d40"
  })), _path2020 || (_path2020 = /*#__PURE__*/React.createElement("path", {
    d: "M65 34h1v1h-1z",
    fill: "#967344"
  })), _path2021 || (_path2021 = /*#__PURE__*/React.createElement("path", {
    d: "M67 35h-1v-1h1z",
    fill: "#997747"
  })), _path2022 || (_path2022 = /*#__PURE__*/React.createElement("path", {
    d: "M71 35h-1v-1h1z",
    fill: "#957549"
  })), _path2023 || (_path2023 = /*#__PURE__*/React.createElement("path", {
    d: "M71 35v-1h1v1z",
    fill: "#967647"
  })), _path2024 || (_path2024 = /*#__PURE__*/React.createElement("path", {
    d: "M72 34h1v1h-1z",
    fill: "#957647"
  })), _path2025 || (_path2025 = /*#__PURE__*/React.createElement("path", {
    d: "M73 35v-1h1v1z",
    fill: "#947549"
  })), _path2026 || (_path2026 = /*#__PURE__*/React.createElement("path", {
    d: "M74 35v-1h1v1z",
    fill: "#957749"
  })), _path2027 || (_path2027 = /*#__PURE__*/React.createElement("path", {
    d: "M75 34h1v1h-1z",
    fill: "#957648"
  })), _path2028 || (_path2028 = /*#__PURE__*/React.createElement("path", {
    d: "M77 34v1h-1v-1z",
    fill: "#947347"
  })), _path2029 || (_path2029 = /*#__PURE__*/React.createElement("path", {
    d: "M78 34v1h-1v-1z",
    fill: "#967549"
  })), _path2030 || (_path2030 = /*#__PURE__*/React.createElement("path", {
    d: "M80 34h1v1h-1z",
    fill: "#98774a"
  })), _path2031 || (_path2031 = /*#__PURE__*/React.createElement("path", {
    d: "M81 34h1v1h-1z",
    fill: "#97784c"
  })), _path2032 || (_path2032 = /*#__PURE__*/React.createElement("path", {
    d: "M83 34v1h-1v-1z",
    fill: "#997a4a"
  })), _path2033 || (_path2033 = /*#__PURE__*/React.createElement("path", {
    d: "M84 35h-1v-1h1z",
    fill: "#9c7b4e"
  })), _path2034 || (_path2034 = /*#__PURE__*/React.createElement("path", {
    d: "M85 34v1h-1v-1z",
    fill: "#9b764e"
  })), _path2035 || (_path2035 = /*#__PURE__*/React.createElement("path", {
    d: "M87 35h-1v-1h1z",
    fill: "#956d4b"
  })), _path2036 || (_path2036 = /*#__PURE__*/React.createElement("path", {
    d: "M87 35v-1h1v1z",
    fill: "#966e49"
  })), _path2037 || (_path2037 = /*#__PURE__*/React.createElement("path", {
    d: "M88 34h1v1h-1z",
    fill: "#9d724c"
  })), _path2038 || (_path2038 = /*#__PURE__*/React.createElement("path", {
    d: "M90 35h-1v-1h1z",
    fill: "#a07450"
  })), _path2039 || (_path2039 = /*#__PURE__*/React.createElement("path", {
    d: "M90 34h1v1h-1z",
    fill: "#9d704e"
  })), _path2040 || (_path2040 = /*#__PURE__*/React.createElement("path", {
    d: "M92 35v-1h1v1z",
    fill: "#9a6c48"
  })), _path2041 || (_path2041 = /*#__PURE__*/React.createElement("path", {
    d: "M93 34h1v1h-1z",
    fill: "#9d6f4a"
  })), _path2042 || (_path2042 = /*#__PURE__*/React.createElement("path", {
    d: "M95 35h-1v-1h1z",
    fill: "#a4714b"
  })), _path2043 || (_path2043 = /*#__PURE__*/React.createElement("path", {
    d: "M96 35h-1v-1h1z",
    fill: "#ad7956"
  })), _path2044 || (_path2044 = /*#__PURE__*/React.createElement("path", {
    d: "M97 35h-1v-1h1z",
    fill: "#ad7550"
  })), _path2045 || (_path2045 = /*#__PURE__*/React.createElement("path", {
    d: "M98 35h-1v-1h1z",
    fill: "#bd7a4d"
  })), _path2046 || (_path2046 = /*#__PURE__*/React.createElement("path", {
    d: "M99 34v1h-1v-1z",
    fill: "#cb8653"
  })), _path2047 || (_path2047 = /*#__PURE__*/React.createElement("path", {
    d: "M99 35v-1h1v1z",
    fill: "#d28a53"
  })), _path2048 || (_path2048 = /*#__PURE__*/React.createElement("path", {
    d: "M101 34v1h-1v-1z",
    fill: "#e2995f"
  })), _path2049 || (_path2049 = /*#__PURE__*/React.createElement("path", {
    d: "M101 35v-1h1v1z",
    fill: "#e39d67"
  })), _path2050 || (_path2050 = /*#__PURE__*/React.createElement("path", {
    d: "M102 34h1v1h-1z",
    fill: "#d79261",
    fillOpacity: 0.922
  })), _path2051 || (_path2051 = /*#__PURE__*/React.createElement("path", {
    d: "M104 35h-1v-1h1z",
    fill: "#c78555",
    fillOpacity: 0.722
  })), _path2052 || (_path2052 = /*#__PURE__*/React.createElement("path", {
    d: "M104 35v-1h1v1z",
    fill: "#cb9169",
    fillOpacity: 0.447
  })), _path2053 || (_path2053 = /*#__PURE__*/React.createElement("path", {
    d: "M106 35h-1v-1h1z",
    fill: "#ddad81",
    fillOpacity: 0.208
  })), _path2054 || (_path2054 = /*#__PURE__*/React.createElement("path", {
    d: "M106 35v-1h1v1z",
    fill: "#d0b9a2",
    fillOpacity: 0.043
  })), _path2055 || (_path2055 = /*#__PURE__*/React.createElement("path", {
    d: "M109 34v1h-1v-1z",
    fill: "#5a361c",
    fillOpacity: 0.843
  })), _path2056 || (_path2056 = /*#__PURE__*/React.createElement("path", {
    d: "M109 35v-1h1v1z",
    fill: "#633c19"
  })), _path2057 || (_path2057 = /*#__PURE__*/React.createElement("path", {
    d: "M110 34h1v1h-1z",
    fill: "#513010"
  })), _path2058 || (_path2058 = /*#__PURE__*/React.createElement("path", {
    d: "M112 34v1h-1v-1z",
    fill: "#523112"
  })), _path2059 || (_path2059 = /*#__PURE__*/React.createElement("path", {
    d: "M113 34v1h-1v-1z",
    fill: "#a4703d"
  })), _path2060 || (_path2060 = /*#__PURE__*/React.createElement("path", {
    d: "M114 34v1h-1v-1z",
    fill: "#bf864c"
  })), _path2061 || (_path2061 = /*#__PURE__*/React.createElement("path", {
    d: "M115 35h-1v-1h1z",
    fill: "#a97d52",
    fillOpacity: 0.62
  })), _path2062 || (_path2062 = /*#__PURE__*/React.createElement("path", {
    d: "M116 34v1h-1v-1z",
    fill: "#593f33",
    fillOpacity: 0.157
  })), _path2063 || (_path2063 = /*#__PURE__*/React.createElement("path", {
    d: "M116 35v-1h1v1z",
    fill: "#604032",
    fillOpacity: 0.278
  })), _path2064 || (_path2064 = /*#__PURE__*/React.createElement("path", {
    d: "M118 35h-1v-1h1z",
    fill: "#663f27",
    fillOpacity: 0.408
  })), _path2065 || (_path2065 = /*#__PURE__*/React.createElement("path", {
    d: "M119 35h-1v-1h1z",
    fill: "#764c28",
    fillOpacity: 0.757
  })), _path2066 || (_path2066 = /*#__PURE__*/React.createElement("path", {
    d: "M121 34v1h-1v-1z",
    fill: "#8d5a35"
  })), _path2067 || (_path2067 = /*#__PURE__*/React.createElement("path", {
    d: "M121 35v-1h1v1z",
    fill: "#a1704c"
  })), _path2068 || (_path2068 = /*#__PURE__*/React.createElement("path", {
    d: "M123 34v1h-1v-1z",
    fill: "#9a7256",
    fillOpacity: 0.706
  })), _path2069 || (_path2069 = /*#__PURE__*/React.createElement("path", {
    d: "M3 36v-1h1v1z",
    fill: "#99836d",
    fillOpacity: 0.137
  })), _path2070 || (_path2070 = /*#__PURE__*/React.createElement("path", {
    d: "M4 35h1v1H4z",
    fill: "#ad8260",
    fillOpacity: 0.953
  })), _path2071 || (_path2071 = /*#__PURE__*/React.createElement("path", {
    d: "M6 35v1H5v-1z",
    fill: "#9f704c"
  })), _path2072 || (_path2072 = /*#__PURE__*/React.createElement("path", {
    d: "M6 36v-1h1v1z",
    fill: "#8d5f3b"
  })), _path2073 || (_path2073 = /*#__PURE__*/React.createElement("path", {
    d: "M7 36v-1h1v1z",
    fill: "#8a5c3c"
  })), _path2074 || (_path2074 = /*#__PURE__*/React.createElement("path", {
    d: "M10 36H9v-1h1z",
    fill: "#76543c",
    fillOpacity: 0.345
  })), _path2075 || (_path2075 = /*#__PURE__*/React.createElement("path", {
    d: "M20 36v-1h1v1z",
    fill: "#836849",
    fillOpacity: 0.259
  })), _path2076 || (_path2076 = /*#__PURE__*/React.createElement("path", {
    d: "M22 36h-1v-1h1z",
    fill: "#906135"
  })), _path2077 || (_path2077 = /*#__PURE__*/React.createElement("path", {
    d: "M22 35h1v1h-1z",
    fill: "#93612f"
  })), _path2078 || (_path2078 = /*#__PURE__*/React.createElement("path", {
    d: "M24 35v1h-1v-1z",
    fill: "#9a6535"
  })), _path2079 || (_path2079 = /*#__PURE__*/React.createElement("path", {
    d: "M25 36h-1v-1h1z",
    fill: "#7c4821"
  })), _path2080 || (_path2080 = /*#__PURE__*/React.createElement("path", {
    d: "M26 35v1h-1v-1z",
    fill: "#653514"
  })), _path2081 || (_path2081 = /*#__PURE__*/React.createElement("path", {
    d: "M26 36v-1h1v1z",
    fill: "#673a16"
  })), _path2082 || (_path2082 = /*#__PURE__*/React.createElement("path", {
    d: "M28 36h-1v-1h1z",
    fill: "#644022",
    fillOpacity: 0.608
  })), _path2083 || (_path2083 = /*#__PURE__*/React.createElement("path", {
    d: "M29 36h-1v-1h1z",
    fill: "#654c3e",
    fillOpacity: 0.208
  })), _path2084 || (_path2084 = /*#__PURE__*/React.createElement("path", {
    d: "M29 36v-1h1v1z",
    fill: "#6e4831",
    fillOpacity: 0.361
  })), _path2085 || (_path2085 = /*#__PURE__*/React.createElement("path", {
    d: "M30 35h1v1h-1z",
    fill: "#734b31",
    fillOpacity: 0.502
  })), _path2086 || (_path2086 = /*#__PURE__*/React.createElement("path", {
    d: "M31 36v-1h1v1z",
    fill: "#774d2f",
    fillOpacity: 0.647
  })), _path2087 || (_path2087 = /*#__PURE__*/React.createElement("path", {
    d: "M32 35h1v1h-1z",
    fill: "#754a2e",
    fillOpacity: 0.78
  })), _path2088 || (_path2088 = /*#__PURE__*/React.createElement("path", {
    d: "M33 35h1v1h-1z",
    fill: "#7b5033",
    fillOpacity: 0.894
  })), _path2089 || (_path2089 = /*#__PURE__*/React.createElement("path", {
    d: "M34 35h1v1h-1z",
    fill: "#825537",
    fillOpacity: 0.969
  })), _path2090 || (_path2090 = /*#__PURE__*/React.createElement("path", {
    d: "M37 36h-1v-1h1z",
    fill: "#875631"
  })), _path2091 || (_path2091 = /*#__PURE__*/React.createElement("path", {
    d: "M38 35v1h-1v-1z",
    fill: "#865835"
  })), _path2092 || (_path2092 = /*#__PURE__*/React.createElement("path", {
    d: "M38 36v-1h1v1z",
    fill: "#a17461"
  })), _path2093 || (_path2093 = /*#__PURE__*/React.createElement("path", {
    d: "M39 35h1v1h-1z",
    fill: "#a2766b"
  })), _path2094 || (_path2094 = /*#__PURE__*/React.createElement("path", {
    d: "M41 36h-1v-1h1z",
    fill: "#a67b6e"
  })), _path2095 || (_path2095 = /*#__PURE__*/React.createElement("path", {
    d: "M42 36h-1v-1h1z",
    fill: "#84593e"
  })), _path2096 || (_path2096 = /*#__PURE__*/React.createElement("path", {
    d: "M43 35v1h-1v-1z",
    fill: "#5d2f0e"
  })), _path2097 || (_path2097 = /*#__PURE__*/React.createElement("path", {
    d: "M44 36h-1v-1h1z",
    fill: "#723f20"
  })), _path2098 || (_path2098 = /*#__PURE__*/React.createElement("path", {
    d: "M44 35h1v1h-1z",
    fill: "#794727"
  })), _path2099 || (_path2099 = /*#__PURE__*/React.createElement("path", {
    d: "M46 35v1h-1v-1z",
    fill: "#774726"
  })), _path2100 || (_path2100 = /*#__PURE__*/React.createElement("path", {
    d: "M47 36h-1v-1h1z",
    fill: "#784828"
  })), _path2101 || (_path2101 = /*#__PURE__*/React.createElement("path", {
    d: "M47 36v-1h1v1z",
    fill: "#7a4929"
  })), _path2102 || (_path2102 = /*#__PURE__*/React.createElement("path", {
    d: "M48 36v-1h1v1z",
    fill: "#7c4b2b"
  })), _path2103 || (_path2103 = /*#__PURE__*/React.createElement("path", {
    d: "M49 35h1v1h-1z",
    fill: "#794c2a"
  })), _path2104 || (_path2104 = /*#__PURE__*/React.createElement("path", {
    d: "M50 35h1v1h-1z",
    fill: "#7a4c2a"
  })), _path2105 || (_path2105 = /*#__PURE__*/React.createElement("path", {
    d: "M51 35h1v1h-1z",
    fill: "#7a4828"
  })), _path2106 || (_path2106 = /*#__PURE__*/React.createElement("path", {
    d: "M53 35h1v1h-1z",
    fill: "#764724"
  })), _path2107 || (_path2107 = /*#__PURE__*/React.createElement("path", {
    d: "M55 35v1h-1v-1z",
    fill: "#744520"
  })), _path2108 || (_path2108 = /*#__PURE__*/React.createElement("path", {
    d: "M55 36v-1h1v1z",
    fill: "#73431d"
  })), _path2109 || (_path2109 = /*#__PURE__*/React.createElement("path", {
    d: "M57 36h-1v-1h1z",
    fill: "#74421c"
  })), _path2110 || (_path2110 = /*#__PURE__*/React.createElement("path", {
    d: "M58 36h-1v-1h1z",
    fill: "#75421d"
  })), _path2111 || (_path2111 = /*#__PURE__*/React.createElement("path", {
    d: "M58 35h1v1h-1z",
    fill: "#74411b"
  })), _path2112 || (_path2112 = /*#__PURE__*/React.createElement("path", {
    d: "M59 35h1v1h-1z",
    fill: "#6d3c16"
  })), _path2113 || (_path2113 = /*#__PURE__*/React.createElement("path", {
    d: "M60 35h1v1h-1z",
    fill: "#6c3b16"
  })), _path2114 || (_path2114 = /*#__PURE__*/React.createElement("path", {
    d: "M61 35h1v1h-1z",
    fill: "#6e3e1a"
  })), _path2115 || (_path2115 = /*#__PURE__*/React.createElement("path", {
    d: "M62 36v-1h1v1z",
    fill: "#6d3e1b"
  })), _path2116 || (_path2116 = /*#__PURE__*/React.createElement("path", {
    d: "M65 35v1h-1v-1z",
    fill: "#754820"
  })), _path2117 || (_path2117 = /*#__PURE__*/React.createElement("path", {
    d: "M65 36v-1h1v1z",
    fill: "#7c5126"
  })), _path2118 || (_path2118 = /*#__PURE__*/React.createElement("path", {
    d: "M67 35v1h-1v-1z",
    fill: "#80582a"
  })), _path2119 || (_path2119 = /*#__PURE__*/React.createElement("path", {
    d: "M67 36v-1h1v1z",
    fill: "#7f5529"
  })), _path2120 || (_path2120 = /*#__PURE__*/React.createElement("path", {
    d: "M69 35v1h-1v-1z",
    fill: "#7e5228"
  })), _path2121 || (_path2121 = /*#__PURE__*/React.createElement("path", {
    d: "M70 36v-1h1v1z",
    fill: "#895f2f"
  })), _path2122 || (_path2122 = /*#__PURE__*/React.createElement("path", {
    d: "M72 36h-1v-1h1z",
    fill: "#8e6532"
  })), _path2123 || (_path2123 = /*#__PURE__*/React.createElement("path", {
    d: "M72 35h1v1h-1z",
    fill: "#926a36"
  })), _path2124 || (_path2124 = /*#__PURE__*/React.createElement("path", {
    d: "M74 35v1h-1v-1z",
    fill: "#966f3c"
  })), _path2125 || (_path2125 = /*#__PURE__*/React.createElement("path", {
    d: "M75 36h-1v-1h1z",
    fill: "#95723f"
  })), _path2126 || (_path2126 = /*#__PURE__*/React.createElement("path", {
    d: "M75 36v-1h1v1z",
    fill: "#95743e"
  })), _path2127 || (_path2127 = /*#__PURE__*/React.createElement("path", {
    d: "M77 36h-1v-1h1z",
    fill: "#937341"
  })), _path2128 || (_path2128 = /*#__PURE__*/React.createElement("path", {
    d: "M77 35h1v1h-1z",
    fill: "#917245"
  })), _path2129 || (_path2129 = /*#__PURE__*/React.createElement("path", {
    d: "M78 35h1v1h-1z",
    fill: "#917146"
  })), _path2130 || (_path2130 = /*#__PURE__*/React.createElement("path", {
    d: "M80 36h-1v-1h1z",
    fill: "#926e45"
  })), _path2131 || (_path2131 = /*#__PURE__*/React.createElement("path", {
    d: "M80 35h1v1h-1z",
    fill: "#916a47"
  })), _path2132 || (_path2132 = /*#__PURE__*/React.createElement("path", {
    d: "M82 36v-1h1v1z",
    fill: "#886345"
  })), _path2133 || (_path2133 = /*#__PURE__*/React.createElement("path", {
    d: "M83 35h1v1h-1z",
    fill: "#8d6749"
  })), _path2134 || (_path2134 = /*#__PURE__*/React.createElement("path", {
    d: "M84 35h1v1h-1z",
    fill: "#8a6343"
  })), _path2135 || (_path2135 = /*#__PURE__*/React.createElement("path", {
    d: "M86 35v1h-1v-1z",
    fill: "#8c6442"
  })), _path2136 || (_path2136 = /*#__PURE__*/React.createElement("path", {
    d: "M86 36v-1h1v1z",
    fill: "#916547"
  })), _path2137 || (_path2137 = /*#__PURE__*/React.createElement("path", {
    d: "M87 36v-1h1v1z",
    fill: "#926444"
  })), _path2138 || (_path2138 = /*#__PURE__*/React.createElement("path", {
    d: "M89 36h-1v-1h1z",
    fill: "#9b6c4c"
  })), _path2139 || (_path2139 = /*#__PURE__*/React.createElement("path", {
    d: "M89 36v-1h1v1z",
    fill: "#9c6c4e"
  })), _path2140 || (_path2140 = /*#__PURE__*/React.createElement("path", {
    d: "M91 35v1h-1v-1z",
    fill: "#9b6949"
  })), _path2141 || (_path2141 = /*#__PURE__*/React.createElement("path", {
    d: "M91 36v-1h1v1z",
    fill: "#9e6c4a"
  })), _path2142 || (_path2142 = /*#__PURE__*/React.createElement("path", {
    d: "M92 36v-1h1v1z",
    fill: "#a16f4b"
  })), _path2143 || (_path2143 = /*#__PURE__*/React.createElement("path", {
    d: "M94 36h-1v-1h1z",
    fill: "#a7744f"
  })), _path2144 || (_path2144 = /*#__PURE__*/React.createElement("path", {
    d: "M94 36v-1h1v1z",
    fill: "#ac714b"
  })), _path2145 || (_path2145 = /*#__PURE__*/React.createElement("path", {
    d: "M96 35v1h-1v-1z",
    fill: "#b97c52"
  })), _path2146 || (_path2146 = /*#__PURE__*/React.createElement("path", {
    d: "M96 36v-1h1v1z",
    fill: "#be804f"
  })), _path2147 || (_path2147 = /*#__PURE__*/React.createElement("path", {
    d: "M98 35v1h-1v-1z",
    fill: "#ca8b53"
  })), _path2148 || (_path2148 = /*#__PURE__*/React.createElement("path", {
    d: "M98 35h1v1h-1z",
    fill: "#cf8e5a",
    fillOpacity: 0.988
  })), _path2149 || (_path2149 = /*#__PURE__*/React.createElement("path", {
    d: "M99 36v-1h1v1z",
    fill: "#d29262",
    fillOpacity: 0.851
  })), _path2150 || (_path2150 = /*#__PURE__*/React.createElement("path", {
    d: "M101 35v1h-1v-1z",
    fill: "#cd946a",
    fillOpacity: 0.627
  })), _path2151 || (_path2151 = /*#__PURE__*/React.createElement("path", {
    d: "M101 36v-1h1v1z",
    fill: "#be8c6c",
    fillOpacity: 0.341
  })), _path2152 || (_path2152 = /*#__PURE__*/React.createElement("path", {
    d: "M102 35h1v1h-1z",
    fill: "#b38d7a",
    fillOpacity: 0.106
  })), _path2153 || (_path2153 = /*#__PURE__*/React.createElement("path", {
    d: "M108 36v-1h1v1z",
    fill: "#6a4025",
    fillOpacity: 0.863
  })), _path2154 || (_path2154 = /*#__PURE__*/React.createElement("path", {
    d: "M109 36v-1h1v1z",
    fill: "#6c411c"
  })), _path2155 || (_path2155 = /*#__PURE__*/React.createElement("path", {
    d: "M110 36v-1h1v1z",
    fill: "#502e14"
  })), _path2156 || (_path2156 = /*#__PURE__*/React.createElement("path", {
    d: "M112 36h-1v-1h1z",
    fill: "#4e2d12"
  })), _path2157 || (_path2157 = /*#__PURE__*/React.createElement("path", {
    d: "M113 36h-1v-1h1z",
    fill: "#a4713e"
  })), _path2158 || (_path2158 = /*#__PURE__*/React.createElement("path", {
    d: "M113 35h1v1h-1z",
    fill: "#c28a51"
  })), _path2159 || (_path2159 = /*#__PURE__*/React.createElement("path", {
    d: "M115 35v1h-1v-1z",
    fill: "#b0855b",
    fillOpacity: 0.545
  })), _path2160 || (_path2160 = /*#__PURE__*/React.createElement("path", {
    d: "M118 35h1v1h-1z",
    fill: "#765538",
    fillOpacity: 0.549
  })), _path2161 || (_path2161 = /*#__PURE__*/React.createElement("path", {
    d: "M121 36h-1v-1h1z",
    fill: "#905e3a"
  })), _path2162 || (_path2162 = /*#__PURE__*/React.createElement("path", {
    d: "M122 36h-1v-1h1z",
    fill: "#a6734f"
  })), _path2163 || (_path2163 = /*#__PURE__*/React.createElement("path", {
    d: "M122 35h1v1h-1z",
    fill: "#9a765c",
    fillOpacity: 0.565
  })), _path2164 || (_path2164 = /*#__PURE__*/React.createElement("path", {
    d: "M4 36h1v1H4z",
    fill: "#aa7d58",
    fillOpacity: 0.816
  })), _path2165 || (_path2165 = /*#__PURE__*/React.createElement("path", {
    d: "M6 36v1H5v-1z",
    fill: "#a8784f"
  })), _path2166 || (_path2166 = /*#__PURE__*/React.createElement("path", {
    d: "M7 36v1H6v-1z",
    fill: "#8c5e38"
  })), _path2167 || (_path2167 = /*#__PURE__*/React.createElement("path", {
    d: "M8 36v1H7v-1z",
    fill: "#8a5c38"
  })), _path2168 || (_path2168 = /*#__PURE__*/React.createElement("path", {
    d: "M9 37H8v-1h1z",
    fill: "#7e4f2c"
  })), _path2169 || (_path2169 = /*#__PURE__*/React.createElement("path", {
    d: "M10 37H9v-1h1z",
    fill: "#6a432a",
    fillOpacity: 0.545
  })), _path2170 || (_path2170 = /*#__PURE__*/React.createElement("path", {
    d: "M20 37v-1h1v1z",
    fill: "#836a4c",
    fillOpacity: 0.235
  })), _path2171 || (_path2171 = /*#__PURE__*/React.createElement("path", {
    d: "M22 37h-1v-1h1z",
    fill: "#906133",
    fillOpacity: 0.996
  })), _path2172 || (_path2172 = /*#__PURE__*/React.createElement("path", {
    d: "M22 37v-1h1v1z",
    fill: "#986331"
  })), _path2173 || (_path2173 = /*#__PURE__*/React.createElement("path", {
    d: "M24 37h-1v-1h1z",
    fill: "#9a6735"
  })), _path2174 || (_path2174 = /*#__PURE__*/React.createElement("path", {
    d: "M24 36h1v1h-1z",
    fill: "#7c4c22"
  })), _path2175 || (_path2175 = /*#__PURE__*/React.createElement("path", {
    d: "M25 36h1v1h-1z",
    fill: "#653917"
  })), _path2176 || (_path2176 = /*#__PURE__*/React.createElement("path", {
    d: "M27 37h-1v-1h1z",
    fill: "#6c3a18"
  })), _path2177 || (_path2177 = /*#__PURE__*/React.createElement("path", {
    d: "M28 36v1h-1v-1z",
    fill: "#623c1f",
    fillOpacity: 0.729
  })), _path2178 || (_path2178 = /*#__PURE__*/React.createElement("path", {
    d: "M33 37v-1h1v1z",
    fill: "#715546",
    fillOpacity: 0.071
  })), _path2179 || (_path2179 = /*#__PURE__*/React.createElement("path", {
    d: "M35 36v1h-1v-1z",
    fill: "#7c6049",
    fillOpacity: 0.176
  })), _path2180 || (_path2180 = /*#__PURE__*/React.createElement("path", {
    d: "M36 37h-1v-1h1z",
    fill: "#725039",
    fillOpacity: 0.298
  })), _path2181 || (_path2181 = /*#__PURE__*/React.createElement("path", {
    d: "M37 37h-1v-1h1z",
    fill: "#77553f",
    fillOpacity: 0.443
  })), _path2182 || (_path2182 = /*#__PURE__*/React.createElement("path", {
    d: "M38 36v1h-1v-1z",
    fill: "#77563e",
    fillOpacity: 0.576
  })), _path2183 || (_path2183 = /*#__PURE__*/React.createElement("path", {
    d: "M38 36h1v1h-1z",
    fill: "#9c776a",
    fillOpacity: 0.894
  })), _path2184 || (_path2184 = /*#__PURE__*/React.createElement("path", {
    d: "M40 37h-1v-1h1z",
    fill: "#a2786d"
  })), _path2185 || (_path2185 = /*#__PURE__*/React.createElement("path", {
    d: "M40 37v-1h1v1z",
    fill: "#a3796a"
  })), _path2186 || (_path2186 = /*#__PURE__*/React.createElement("path", {
    d: "M41 37v-1h1v1z",
    fill: "#855c41"
  })), _path2187 || (_path2187 = /*#__PURE__*/React.createElement("path", {
    d: "M43 37h-1v-1h1z",
    fill: "#643311"
  })), _path2188 || (_path2188 = /*#__PURE__*/React.createElement("path", {
    d: "M43 36h1v1h-1z",
    fill: "#774325"
  })), _path2189 || (_path2189 = /*#__PURE__*/React.createElement("path", {
    d: "M46 36v1h-1v-1z",
    fill: "#845032"
  })), _path2190 || (_path2190 = /*#__PURE__*/React.createElement("path", {
    d: "M47 36v1h-1v-1z",
    fill: "#804e31"
  })), _path2191 || (_path2191 = /*#__PURE__*/React.createElement("path", {
    d: "M48 36h1v1h-1z",
    fill: "#7a4a2e"
  })), _path2192 || (_path2192 = /*#__PURE__*/React.createElement("path", {
    d: "M50 36v1h-1v-1z",
    fill: "#7d4b2e"
  })), _path2193 || (_path2193 = /*#__PURE__*/React.createElement("path", {
    d: "M51 36v1h-1v-1z",
    fill: "#7e4a2c"
  })), _path2194 || (_path2194 = /*#__PURE__*/React.createElement("path", {
    d: "M51 36h1v1h-1z",
    fill: "#804b2e"
  })), _path2195 || (_path2195 = /*#__PURE__*/React.createElement("path", {
    d: "M54 37v-1h1v1z",
    fill: "#814e2e"
  })), _path2196 || (_path2196 = /*#__PURE__*/React.createElement("path", {
    d: "M56 37h-1v-1h1z",
    fill: "#7d4b29"
  })), _path2197 || (_path2197 = /*#__PURE__*/React.createElement("path", {
    d: "M57 37h-1v-1h1z",
    fill: "#7d4a27"
  })), _path2198 || (_path2198 = /*#__PURE__*/React.createElement("path", {
    d: "M58 37h-1v-1h1z",
    fill: "#7e4a26"
  })), _path2199 || (_path2199 = /*#__PURE__*/React.createElement("path", {
    d: "M59 37h-1v-1h1z",
    fill: "#7b4822"
  })), _path2200 || (_path2200 = /*#__PURE__*/React.createElement("path", {
    d: "M59 36h1v1h-1z",
    fill: "#6e3c18"
  })), _path2201 || (_path2201 = /*#__PURE__*/React.createElement("path", {
    d: "M61 37h-1v-1h1z",
    fill: "#653413"
  })), _path2202 || (_path2202 = /*#__PURE__*/React.createElement("path", {
    d: "M62 36v1h-1v-1z",
    fill: "#653214"
  })), _path2203 || (_path2203 = /*#__PURE__*/React.createElement("path", {
    d: "M62 36h1v1h-1z",
    fill: "#623012"
  })), _path2204 || (_path2204 = /*#__PURE__*/React.createElement("path", {
    d: "M64 37h-1v-1h1z",
    fill: "#623111"
  })), _path2205 || (_path2205 = /*#__PURE__*/React.createElement("path", {
    d: "M65 37h-1v-1h1z",
    fill: "#633312"
  })), _path2206 || (_path2206 = /*#__PURE__*/React.createElement("path", {
    d: "M66 36v1h-1v-1z",
    fill: "#653716"
  })), _path2207 || (_path2207 = /*#__PURE__*/React.createElement("path", {
    d: "M67 37h-1v-1h1z",
    fill: "#6a3c19"
  })), _path2208 || (_path2208 = /*#__PURE__*/React.createElement("path", {
    d: "M67 36h1v1h-1z",
    fill: "#6d3c18"
  })), _path2209 || (_path2209 = /*#__PURE__*/React.createElement("path", {
    d: "M68 37v-1h1v1z",
    fill: "#74401b"
  })), _path2210 || (_path2210 = /*#__PURE__*/React.createElement("path", {
    d: "M70 36v1h-1v-1z",
    fill: "#79431f"
  })), _path2211 || (_path2211 = /*#__PURE__*/React.createElement("path", {
    d: "M70 36h1v1h-1z",
    fill: "#7e4921"
  })), _path2212 || (_path2212 = /*#__PURE__*/React.createElement("path", {
    d: "M72 36v1h-1v-1z",
    fill: "#834e22"
  })), _path2213 || (_path2213 = /*#__PURE__*/React.createElement("path", {
    d: "M73 36v1h-1v-1z",
    fill: "#895426"
  })), _path2214 || (_path2214 = /*#__PURE__*/React.createElement("path", {
    d: "M73 37v-1h1v1z",
    fill: "#8f592b"
  })), _path2215 || (_path2215 = /*#__PURE__*/React.createElement("path", {
    d: "M75 36h1v1h-1z",
    fill: "#94642e"
  })), _path2216 || (_path2216 = /*#__PURE__*/React.createElement("path", {
    d: "M77 37h-1v-1h1z",
    fill: "#976c39"
  })), _path2217 || (_path2217 = /*#__PURE__*/React.createElement("path", {
    d: "M78 36v1h-1v-1z",
    fill: "#89623a"
  })), _path2218 || (_path2218 = /*#__PURE__*/React.createElement("path", {
    d: "M79 37h-1v-1h1z",
    fill: "#7a5a3f"
  })), _path2219 || (_path2219 = /*#__PURE__*/React.createElement("path", {
    d: "M79 36h1v1h-1z",
    fill: "#7d5535"
  })), _path2220 || (_path2220 = /*#__PURE__*/React.createElement("path", {
    d: "M81 36v1h-1v-1z",
    fill: "#7c5130"
  })), _path2221 || (_path2221 = /*#__PURE__*/React.createElement("path", {
    d: "M81 36h1v1h-1z",
    fill: "#795130"
  })), _path2222 || (_path2222 = /*#__PURE__*/React.createElement("path", {
    d: "M82 36h1v1h-1z",
    fill: "#7d5433"
  })), _path2223 || (_path2223 = /*#__PURE__*/React.createElement("path", {
    d: "M84 36v1h-1v-1z",
    fill: "#875d3c"
  })), _path2224 || (_path2224 = /*#__PURE__*/React.createElement("path", {
    d: "M86 36v1h-1v-1z",
    fill: "#8a613e"
  })), _path2225 || (_path2225 = /*#__PURE__*/React.createElement("path", {
    d: "M86 36h1v1h-1z",
    fill: "#916646"
  })), _path2226 || (_path2226 = /*#__PURE__*/React.createElement("path", {
    d: "M87 36h1v1h-1z",
    fill: "#956646"
  })), _path2227 || (_path2227 = /*#__PURE__*/React.createElement("path", {
    d: "M90 37v-1h1v1z",
    fill: "#a56e4f"
  })), _path2228 || (_path2228 = /*#__PURE__*/React.createElement("path", {
    d: "M92 37h-1v-1h1z",
    fill: "#a86f4c"
  })), _path2229 || (_path2229 = /*#__PURE__*/React.createElement("path", {
    d: "M93 36v1h-1v-1z",
    fill: "#ab6f4a"
  })), _path2230 || (_path2230 = /*#__PURE__*/React.createElement("path", {
    d: "M93 37v-1h1v1z",
    fill: "#b77c56"
  })), _path2231 || (_path2231 = /*#__PURE__*/React.createElement("path", {
    d: "M96 37h-1v-1h1z",
    fill: "#be8255"
  })), _path2232 || (_path2232 = /*#__PURE__*/React.createElement("path", {
    d: "M97 37v-1h1v1z",
    fill: "#b58967",
    fillOpacity: 0.678
  })), _path2233 || (_path2233 = /*#__PURE__*/React.createElement("path", {
    d: "M98 36h1v1h-1z",
    fill: "#c99c74",
    fillOpacity: 0.224
  })), _path2234 || (_path2234 = /*#__PURE__*/React.createElement("path", {
    d: "M99 36h1v1h-1z",
    fill: "#d0a2a2",
    fillOpacity: 0.043
  })), _path2235 || (_path2235 = /*#__PURE__*/React.createElement("path", {
    d: "M107 37v-1h1v1z",
    fill: "#656",
    fillOpacity: 0.059
  })), _path2236 || (_path2236 = /*#__PURE__*/React.createElement("path", {
    d: "M109 37h-1v-1h1z",
    fill: "#714425",
    fillOpacity: 0.878
  })), _path2237 || (_path2237 = /*#__PURE__*/React.createElement("path", {
    d: "M109 36h1v1h-1z",
    fill: "#70421b"
  })), _path2238 || (_path2238 = /*#__PURE__*/React.createElement("path", {
    d: "M110 37v-1h1v1z",
    fill: "#522f17"
  })), _path2239 || (_path2239 = /*#__PURE__*/React.createElement("path", {
    d: "M112 36v1h-1v-1z",
    fill: "#4e2c13"
  })), _path2240 || (_path2240 = /*#__PURE__*/React.createElement("path", {
    d: "M112 37v-1h1v1z",
    fill: "#a6703f"
  })), _path2241 || (_path2241 = /*#__PURE__*/React.createElement("path", {
    d: "M114 36v1h-1v-1z",
    fill: "#c48c54"
  })), _path2242 || (_path2242 = /*#__PURE__*/React.createElement("path", {
    d: "M114 36h1v1h-1z",
    fill: "#b1845d",
    fillOpacity: 0.514
  })), _path2243 || (_path2243 = /*#__PURE__*/React.createElement("path", {
    d: "M119 36v1h-1v-1z",
    fill: "#765137",
    fillOpacity: 0.69
  })), _path2244 || (_path2244 = /*#__PURE__*/React.createElement("path", {
    d: "M119 37v-1h1v1z",
    fill: "#895830"
  })), _path2245 || (_path2245 = /*#__PURE__*/React.createElement("path", {
    d: "M121 37h-1v-1h1z",
    fill: "#94623e"
  })), _path2246 || (_path2246 = /*#__PURE__*/React.createElement("path", {
    d: "M121 37v-1h1v1z",
    fill: "#a97652"
  })), _path2247 || (_path2247 = /*#__PURE__*/React.createElement("path", {
    d: "M123 37h-1v-1h1z",
    fill: "#997960",
    fillOpacity: 0.435
  })), _path2248 || (_path2248 = /*#__PURE__*/React.createElement("path", {
    d: "M5 37v1H4v-1z",
    fill: "#a57957",
    fillOpacity: 0.651
  })), _path2249 || (_path2249 = /*#__PURE__*/React.createElement("path", {
    d: "M6 38H5v-1h1z",
    fill: "#af7d54"
  })), _path2250 || (_path2250 = /*#__PURE__*/React.createElement("path", {
    d: "M7 38H6v-1h1z",
    fill: "#8d5d37"
  })), _path2251 || (_path2251 = /*#__PURE__*/React.createElement("path", {
    d: "M7 38v-1h1v1z",
    fill: "#83562c"
  })), _path2252 || (_path2252 = /*#__PURE__*/React.createElement("path", {
    d: "M9 37v1H8v-1z",
    fill: "#8c5c36"
  })), _path2253 || (_path2253 = /*#__PURE__*/React.createElement("path", {
    d: "M10 37v1H9v-1z",
    fill: "#a57c60",
    fillOpacity: 0.867
  })), _path2254 || (_path2254 = /*#__PURE__*/React.createElement("path", {
    d: "M10 37h1v1h-1z",
    fill: "#c2a494",
    fillOpacity: 0.498
  })), _path2255 || (_path2255 = /*#__PURE__*/React.createElement("path", {
    d: "M11 38v-1h1v1z",
    fill: "#c0aa9c",
    fillOpacity: 0.435
  })), _path2256 || (_path2256 = /*#__PURE__*/React.createElement("path", {
    d: "M12 37h1v1h-1z",
    fill: "#bda99a",
    fillOpacity: 0.337
  })), _path2257 || (_path2257 = /*#__PURE__*/React.createElement("path", {
    d: "M14 38h-1v-1h1z",
    fill: "#bfa89d",
    fillOpacity: 0.267
  })), _path2258 || (_path2258 = /*#__PURE__*/React.createElement("path", {
    d: "M15 37v1h-1v-1z",
    fill: "#b8a29d",
    fillOpacity: 0.184
  })), _path2259 || (_path2259 = /*#__PURE__*/React.createElement("path", {
    d: "M16 37v1h-1v-1z",
    fill: "#a7958c",
    fillOpacity: 0.114
  })), _path2260 || (_path2260 = /*#__PURE__*/React.createElement("path", {
    d: "M21 37v1h-1v-1z",
    fill: "#826950",
    fillOpacity: 0.161
  })), _path2261 || (_path2261 = /*#__PURE__*/React.createElement("path", {
    d: "M22 38h-1v-1h1z",
    fill: "#916330",
    fillOpacity: 0.976
  })), _path2262 || (_path2262 = /*#__PURE__*/React.createElement("path", {
    d: "M23 37v1h-1v-1z",
    fill: "#9e6333"
  })), _path2263 || (_path2263 = /*#__PURE__*/React.createElement("path", {
    d: "M24 37v1h-1v-1z",
    fill: "#976633"
  })), _path2264 || (_path2264 = /*#__PURE__*/React.createElement("path", {
    d: "M25 37v1h-1v-1z",
    fill: "#804d26"
  })), _path2265 || (_path2265 = /*#__PURE__*/React.createElement("path", {
    d: "M25 38v-1h1v1z",
    fill: "#683c19"
  })), _path2266 || (_path2266 = /*#__PURE__*/React.createElement("path", {
    d: "M27 38h-1v-1h1z",
    fill: "#6e3d19"
  })), _path2267 || (_path2267 = /*#__PURE__*/React.createElement("path", {
    d: "M27 38v-1h1v1z",
    fill: "#663e1f",
    fillOpacity: 0.741
  })), _path2268 || (_path2268 = /*#__PURE__*/React.createElement("path", {
    d: "M39 37v1h-1v-1z",
    fill: "#9f7f76",
    fillOpacity: 0.651
  })), _path2269 || (_path2269 = /*#__PURE__*/React.createElement("path", {
    d: "M39 38v-1h1v1z",
    fill: "#a77b72"
  })), _path2270 || (_path2270 = /*#__PURE__*/React.createElement("path", {
    d: "M41 38h-1v-1h1z",
    fill: "#a57d70"
  })), _path2271 || (_path2271 = /*#__PURE__*/React.createElement("path", {
    d: "M42 38h-1v-1h1z",
    fill: "#8b6148"
  })), _path2272 || (_path2272 = /*#__PURE__*/React.createElement("path", {
    d: "M42 38v-1h1v1z",
    fill: "#673413",
    fillOpacity: 0.996
  })), _path2273 || (_path2273 = /*#__PURE__*/React.createElement("path", {
    d: "M44 38h-1v-1h1z",
    fill: "#6e4026",
    fillOpacity: 0.671
  })), _path2274 || (_path2274 = /*#__PURE__*/React.createElement("path", {
    d: "M44 38v-1h1v1z",
    fill: "#75492f",
    fillOpacity: 0.671
  })), _path2275 || (_path2275 = /*#__PURE__*/React.createElement("path", {
    d: "M46 37v1h-1v-1z",
    fill: "#7b4c32",
    fillOpacity: 0.816
  })), _path2276 || (_path2276 = /*#__PURE__*/React.createElement("path", {
    d: "M46 38v-1h1v1z",
    fill: "#7c4f33",
    fillOpacity: 0.918
  })), _path2277 || (_path2277 = /*#__PURE__*/React.createElement("path", {
    d: "M48 37v1h-1v-1z",
    fill: "#7d4d30",
    fillOpacity: 0.988
  })), _path2278 || (_path2278 = /*#__PURE__*/React.createElement("path", {
    d: "M48 38v-1h1v1z",
    fill: "#835131"
  })), _path2279 || (_path2279 = /*#__PURE__*/React.createElement("path", {
    d: "M49 38v-1h1v1z",
    fill: "#835234"
  })), _path2280 || (_path2280 = /*#__PURE__*/React.createElement("path", {
    d: "M51 37h1v1h-1z",
    fill: "#834d30"
  })), _path2281 || (_path2281 = /*#__PURE__*/React.createElement("path", {
    d: "M53 38h-1v-1h1z",
    fill: "#80492c"
  })), _path2282 || (_path2282 = /*#__PURE__*/React.createElement("path", {
    d: "M53 38v-1h1v1z",
    fill: "#7f482c"
  })), _path2283 || (_path2283 = /*#__PURE__*/React.createElement("path", {
    d: "M54 37h1v1h-1z",
    fill: "#814a2d"
  })), _path2284 || (_path2284 = /*#__PURE__*/React.createElement("path", {
    d: "M56 38h-1v-1h1z",
    fill: "#7f4b2a"
  })), _path2285 || (_path2285 = /*#__PURE__*/React.createElement("path", {
    d: "M56 37h1v1h-1z",
    fill: "#855330"
  })), _path2286 || (_path2286 = /*#__PURE__*/React.createElement("path", {
    d: "M58 37v1h-1v-1z",
    fill: "#8f5e37"
  })), _path2287 || (_path2287 = /*#__PURE__*/React.createElement("path", {
    d: "M58 37h1v1h-1z",
    fill: "#8b5a32"
  })), _path2288 || (_path2288 = /*#__PURE__*/React.createElement("path", {
    d: "M60 37v1h-1v-1z",
    fill: "#895730"
  })), _path2289 || (_path2289 = /*#__PURE__*/React.createElement("path", {
    d: "M60 37h1v1h-1z",
    fill: "#825129"
  })), _path2290 || (_path2290 = /*#__PURE__*/React.createElement("path", {
    d: "M62 38h-1v-1h1z",
    fill: "#7b4a22"
  })), _path2291 || (_path2291 = /*#__PURE__*/React.createElement("path", {
    d: "M62 37h1v1h-1z",
    fill: "#74431d"
  })), _path2292 || (_path2292 = /*#__PURE__*/React.createElement("path", {
    d: "M63 38v-1h1v1z",
    fill: "#6f3f1b"
  })), _path2293 || (_path2293 = /*#__PURE__*/React.createElement("path", {
    d: "M64 37h1v1h-1z",
    fill: "#673817"
  })), _path2294 || (_path2294 = /*#__PURE__*/React.createElement("path", {
    d: "M65 38v-1h1v1z",
    fill: "#623315"
  })), _path2295 || (_path2295 = /*#__PURE__*/React.createElement("path", {
    d: "M66 37h1v1h-1z",
    fill: "#603116"
  })), _path2296 || (_path2296 = /*#__PURE__*/React.createElement("path", {
    d: "M68 38h-1v-1h1z",
    fill: "#5f3012"
  })), _path2297 || (_path2297 = /*#__PURE__*/React.createElement("path", {
    d: "M69 38h-1v-1h1z",
    fill: "#613212"
  })), _path2298 || (_path2298 = /*#__PURE__*/React.createElement("path", {
    d: "M70 37v1h-1v-1z",
    fill: "#663616"
  })), _path2299 || (_path2299 = /*#__PURE__*/React.createElement("path", {
    d: "M70 38v-1h1v1z",
    fill: "#6a3814"
  })), _path2300 || (_path2300 = /*#__PURE__*/React.createElement("path", {
    d: "M72 37v1h-1v-1z",
    fill: "#764118"
  })), _path2301 || (_path2301 = /*#__PURE__*/React.createElement("path", {
    d: "M73 37v1h-1v-1z",
    fill: "#864e21"
  })), _path2302 || (_path2302 = /*#__PURE__*/React.createElement("path", {
    d: "M73 37h1v1h-1z",
    fill: "#874d21"
  })), _path2303 || (_path2303 = /*#__PURE__*/React.createElement("path", {
    d: "M74 37h1v1h-1z",
    fill: "#844d1f"
  })), _path2304 || (_path2304 = /*#__PURE__*/React.createElement("path", {
    d: "M75 38v-1h1v1z",
    fill: "#895323"
  })), _path2305 || (_path2305 = /*#__PURE__*/React.createElement("path", {
    d: "M77 37v1h-1v-1z",
    fill: "#936235"
  })), _path2306 || (_path2306 = /*#__PURE__*/React.createElement("path", {
    d: "M77 37h1v1h-1z",
    fill: "#784c25"
  })), _path2307 || (_path2307 = /*#__PURE__*/React.createElement("path", {
    d: "M79 37v1h-1v-1z",
    fill: "#714a28"
  })), _path2308 || (_path2308 = /*#__PURE__*/React.createElement("path", {
    d: "M80 37v1h-1v-1z",
    fill: "#7c512f"
  })), _path2309 || (_path2309 = /*#__PURE__*/React.createElement("path", {
    d: "M81 38v-1h1v1z",
    fill: "#845c3e"
  })), _path2310 || (_path2310 = /*#__PURE__*/React.createElement("path", {
    d: "M83 37h1v1h-1z",
    fill: "#825430"
  })), _path2311 || (_path2311 = /*#__PURE__*/React.createElement("path", {
    d: "M84 37h1v1h-1z",
    fill: "#8e5d3a"
  })), _path2312 || (_path2312 = /*#__PURE__*/React.createElement("path", {
    d: "M85 37h1v1h-1z",
    fill: "#926142"
  })), _path2313 || (_path2313 = /*#__PURE__*/React.createElement("path", {
    d: "M87 37v1h-1v-1z",
    fill: "#94603f"
  })), _path2314 || (_path2314 = /*#__PURE__*/React.createElement("path", {
    d: "M87 38v-1h1v1z",
    fill: "#9b6443"
  })), _path2315 || (_path2315 = /*#__PURE__*/React.createElement("path", {
    d: "M88 38v-1h1v1z",
    fill: "#a76f4e"
  })), _path2316 || (_path2316 = /*#__PURE__*/React.createElement("path", {
    d: "M90 37v1h-1v-1z",
    fill: "#ae7957"
  })), _path2317 || (_path2317 = /*#__PURE__*/React.createElement("path", {
    d: "M91 38h-1v-1h1z",
    fill: "#ae7955"
  })), _path2318 || (_path2318 = /*#__PURE__*/React.createElement("path", {
    d: "M92 37v1h-1v-1z",
    fill: "#aa7451",
    fillOpacity: 0.988
  })), _path2319 || (_path2319 = /*#__PURE__*/React.createElement("path", {
    d: "M93 38h-1v-1h1z",
    fill: "#a57352",
    fillOpacity: 0.851
  })), _path2320 || (_path2320 = /*#__PURE__*/React.createElement("path", {
    d: "M94 38h-1v-1h1z",
    fill: "#aa7c5e",
    fillOpacity: 0.604
  })), _path2321 || (_path2321 = /*#__PURE__*/React.createElement("path", {
    d: "M94 38v-1h1v1z",
    fill: "#a06d4a",
    fillOpacity: 0.847
  })), _path2322 || (_path2322 = /*#__PURE__*/React.createElement("path", {
    d: "M95 37h1v1h-1z",
    fill: "#9c6034"
  })), _path2323 || (_path2323 = /*#__PURE__*/React.createElement("path", {
    d: "M96 38v-1h1v1z",
    fill: "#935e3b"
  })), _path2324 || (_path2324 = /*#__PURE__*/React.createElement("path", {
    d: "M97 37h1v1h-1z",
    fill: "#836455",
    fillOpacity: 0.396
  })), _path2325 || (_path2325 = /*#__PURE__*/React.createElement("path", {
    d: "M107 37h1v1h-1z",
    fill: "#715555",
    fillOpacity: 0.071
  })), _path2326 || (_path2326 = /*#__PURE__*/React.createElement("path", {
    d: "M109 37v1h-1v-1z",
    fill: "#734525",
    fillOpacity: 0.89
  })), _path2327 || (_path2327 = /*#__PURE__*/React.createElement("path", {
    d: "M110 37v1h-1v-1z",
    fill: "#70431a"
  })), _path2328 || (_path2328 = /*#__PURE__*/React.createElement("path", {
    d: "M110 37h1v1h-1z",
    fill: "#563416"
  })), _path2329 || (_path2329 = /*#__PURE__*/React.createElement("path", {
    d: "M111 38v-1h1v1z",
    fill: "#503013"
  })), _path2330 || (_path2330 = /*#__PURE__*/React.createElement("path", {
    d: "M112 37h1v1h-1z",
    fill: "#aa7440"
  })), _path2331 || (_path2331 = /*#__PURE__*/React.createElement("path", {
    d: "M113 38v-1h1v1z",
    fill: "#c0844d"
  })), _path2332 || (_path2332 = /*#__PURE__*/React.createElement("path", {
    d: "M114 38v-1h1v1z",
    fill: "#b08157",
    fillOpacity: 0.471
  })), _path2333 || (_path2333 = /*#__PURE__*/React.createElement("path", {
    d: "M119 38h-1v-1h1z",
    fill: "#7e5135",
    fillOpacity: 0.773
  })), _path2334 || (_path2334 = /*#__PURE__*/React.createElement("path", {
    d: "M121 37v1h-1v-1z",
    fill: "#9a6743"
  })), _path2335 || (_path2335 = /*#__PURE__*/React.createElement("path", {
    d: "M121 38v-1h1v1z",
    fill: "#a67855"
  })), _path2336 || (_path2336 = /*#__PURE__*/React.createElement("path", {
    d: "M123 38h-1v-1h1z",
    fill: "#9d7761",
    fillOpacity: 0.318
  })), _path2337 || (_path2337 = /*#__PURE__*/React.createElement("path", {
    d: "M5 39H4v-1h1z",
    fill: "#a17757",
    fillOpacity: 0.459
  })), _path2338 || (_path2338 = /*#__PURE__*/React.createElement("path", {
    d: "M6 39H5v-1h1z",
    fill: "#b27f58"
  })), _path2339 || (_path2339 = /*#__PURE__*/React.createElement("path", {
    d: "M7 39H6v-1h1z",
    fill: "#8e5b32"
  })), _path2340 || (_path2340 = /*#__PURE__*/React.createElement("path", {
    d: "M8 39H7v-1h1z",
    fill: "#7f4a22"
  })), _path2341 || (_path2341 = /*#__PURE__*/React.createElement("path", {
    d: "M9 38v1H8v-1z",
    fill: "#8d5831"
  })), _path2342 || (_path2342 = /*#__PURE__*/React.createElement("path", {
    d: "M9 38h1v1H9z",
    fill: "#ae7a59"
  })), _path2343 || (_path2343 = /*#__PURE__*/React.createElement("path", {
    d: "M11 39h-1v-1h1z",
    fill: "#b58368"
  })), _path2344 || (_path2344 = /*#__PURE__*/React.createElement("path", {
    d: "M11 39v-1h1v1z",
    fill: "#b8876e"
  })), _path2345 || (_path2345 = /*#__PURE__*/React.createElement("path", {
    d: "M12 39v-1h1v1z",
    fill: "#b68971"
  })), _path2346 || (_path2346 = /*#__PURE__*/React.createElement("path", {
    d: "M14 38v1h-1v-1z",
    fill: "#b58a74"
  })), _path2347 || (_path2347 = /*#__PURE__*/React.createElement("path", {
    d: "M14 39v-1h1v1z",
    fill: "#b88d7a",
    fillOpacity: 0.98
  })), _path2348 || (_path2348 = /*#__PURE__*/React.createElement("path", {
    d: "M16 38v1h-1v-1z",
    fill: "#b78e7a",
    fillOpacity: 0.929
  })), _path2349 || (_path2349 = /*#__PURE__*/React.createElement("path", {
    d: "M16 39v-1h1v1z",
    fill: "#b58c79",
    fillOpacity: 0.855
  })), _path2350 || (_path2350 = /*#__PURE__*/React.createElement("path", {
    d: "M17 38h1v1h-1z",
    fill: "#ad8775",
    fillOpacity: 0.773
  })), _path2351 || (_path2351 = /*#__PURE__*/React.createElement("path", {
    d: "M19 38v1h-1v-1z",
    fill: "#a68470",
    fillOpacity: 0.659
  })), _path2352 || (_path2352 = /*#__PURE__*/React.createElement("path", {
    d: "M19 39v-1h1v1z",
    fill: "#9f7f6a",
    fillOpacity: 0.533
  })), _path2353 || (_path2353 = /*#__PURE__*/React.createElement("path", {
    d: "M21 39h-1v-1h1z",
    fill: "#9d7860",
    fillOpacity: 0.541
  })), _path2354 || (_path2354 = /*#__PURE__*/React.createElement("path", {
    d: "M22 39h-1v-1h1z",
    fill: "#96673a",
    fillOpacity: 0.98
  })), _path2355 || (_path2355 = /*#__PURE__*/React.createElement("path", {
    d: "M22 39v-1h1v1z",
    fill: "#9d673b"
  })), _path2356 || (_path2356 = /*#__PURE__*/React.createElement("path", {
    d: "M24 38v1h-1v-1z",
    fill: "#966838"
  })), _path2357 || (_path2357 = /*#__PURE__*/React.createElement("path", {
    d: "M25 39h-1v-1h1z",
    fill: "#80512a"
  })), _path2358 || (_path2358 = /*#__PURE__*/React.createElement("path", {
    d: "M26 38v1h-1v-1z",
    fill: "#6f3e1a"
  })), _path2359 || (_path2359 = /*#__PURE__*/React.createElement("path", {
    d: "M26 39v-1h1v1z",
    fill: "#733e18"
  })), _path2360 || (_path2360 = /*#__PURE__*/React.createElement("path", {
    d: "M28 38v1h-1v-1z",
    fill: "#653d20",
    fillOpacity: 0.749
  })), _path2361 || (_path2361 = /*#__PURE__*/React.createElement("path", {
    d: "M38 38h1v1h-1z",
    fill: "#a08075",
    fillOpacity: 0.624
  })), _path2362 || (_path2362 = /*#__PURE__*/React.createElement("path", {
    d: "M40 39h-1v-1h1z",
    fill: "#a97e74"
  })), _path2363 || (_path2363 = /*#__PURE__*/React.createElement("path", {
    d: "M40 39v-1h1v1z",
    fill: "#a98072"
  })), _path2364 || (_path2364 = /*#__PURE__*/React.createElement("path", {
    d: "M42 39h-1v-1h1z",
    fill: "#94694c"
  })), _path2365 || (_path2365 = /*#__PURE__*/React.createElement("path", {
    d: "M43 39h-1v-1h1z",
    fill: "#633818"
  })), _path2366 || (_path2366 = /*#__PURE__*/React.createElement("path", {
    d: "M43 38h1v1h-1z",
    fill: "#5d3e31",
    fillOpacity: 0.224
  })), _path2367 || (_path2367 = /*#__PURE__*/React.createElement("path", {
    d: "M46 38v1h-1v-1z",
    fill: "#633",
    fillOpacity: 0.02
  })), _path2368 || (_path2368 = /*#__PURE__*/React.createElement("path", {
    d: "M48 38v1h-1v-1z",
    fill: "#6d4d36",
    fillOpacity: 0.22
  })), _path2369 || (_path2369 = /*#__PURE__*/React.createElement("path", {
    d: "M49 38v1h-1v-1z",
    fill: "#6f4d33",
    fillOpacity: 0.349
  })), _path2370 || (_path2370 = /*#__PURE__*/React.createElement("path", {
    d: "M50 38v1h-1v-1z",
    fill: "#7b533d",
    fillOpacity: 0.502
  })), _path2371 || (_path2371 = /*#__PURE__*/React.createElement("path", {
    d: "M50 39v-1h1v1z",
    fill: "#784c38",
    fillOpacity: 0.655
  })), _path2372 || (_path2372 = /*#__PURE__*/React.createElement("path", {
    d: "M51 38h1v1h-1z",
    fill: "#794a35",
    fillOpacity: 0.792
  })), _path2373 || (_path2373 = /*#__PURE__*/React.createElement("path", {
    d: "M52 39v-1h1v1z",
    fill: "#784832",
    fillOpacity: 0.91
  })), _path2374 || (_path2374 = /*#__PURE__*/React.createElement("path", {
    d: "M54 39h-1v-1h1z",
    fill: "#7c4a30",
    fillOpacity: 0.976
  })), _path2375 || (_path2375 = /*#__PURE__*/React.createElement("path", {
    d: "M54 38h1v1h-1z",
    fill: "#7f4b2e"
  })), _path2376 || (_path2376 = /*#__PURE__*/React.createElement("path", {
    d: "M56 38v1h-1v-1z",
    fill: "#834d2c"
  })), _path2377 || (_path2377 = /*#__PURE__*/React.createElement("path", {
    d: "M57 38v1h-1v-1z",
    fill: "#8e5833"
  })), _path2378 || (_path2378 = /*#__PURE__*/React.createElement("path", {
    d: "M58 39h-1v-1h1z",
    fill: "#95653b"
  })), _path2379 || (_path2379 = /*#__PURE__*/React.createElement("path", {
    d: "M59 38v1h-1v-1z",
    fill: "#916138"
  })), _path2380 || (_path2380 = /*#__PURE__*/React.createElement("path", {
    d: "M60 38h1v1h-1z",
    fill: "#8b582d"
  })), _path2381 || (_path2381 = /*#__PURE__*/React.createElement("path", {
    d: "M62 38v1h-1v-1z",
    fill: "#865628"
  })), _path2382 || (_path2382 = /*#__PURE__*/React.createElement("path", {
    d: "M62 38h1v1h-1z",
    fill: "#86562b"
  })), _path2383 || (_path2383 = /*#__PURE__*/React.createElement("path", {
    d: "M65 38v1h-1v-1z",
    fill: "#794a22"
  })), _path2384 || (_path2384 = /*#__PURE__*/React.createElement("path", {
    d: "M66 39h-1v-1h1z",
    fill: "#744620"
  })), _path2385 || (_path2385 = /*#__PURE__*/React.createElement("path", {
    d: "M67 38h1v1h-1z",
    fill: "#6c3f1a"
  })), _path2386 || (_path2386 = /*#__PURE__*/React.createElement("path", {
    d: "M68 39v-1h1v1z",
    fill: "#693b16"
  })), _path2387 || (_path2387 = /*#__PURE__*/React.createElement("path", {
    d: "M69 39v-1h1v1z",
    fill: "#673916"
  })), _path2388 || (_path2388 = /*#__PURE__*/React.createElement("path", {
    d: "M71 39h-1v-1h1z",
    fill: "#663813"
  })), _path2389 || (_path2389 = /*#__PURE__*/React.createElement("path", {
    d: "M71 38h1v1h-1z",
    fill: "#734219"
  })), _path2390 || (_path2390 = /*#__PURE__*/React.createElement("path", {
    d: "M72 39v-1h1v1z",
    fill: "#824f22"
  })), _path2391 || (_path2391 = /*#__PURE__*/React.createElement("path", {
    d: "M73 38h1v1h-1z",
    fill: "#855025"
  })), _path2392 || (_path2392 = /*#__PURE__*/React.createElement("path", {
    d: "M74 39v-1h1v1z",
    fill: "#8c592d"
  })), _path2393 || (_path2393 = /*#__PURE__*/React.createElement("path", {
    d: "M76 38v1h-1v-1z",
    fill: "#89582a"
  })), _path2394 || (_path2394 = /*#__PURE__*/React.createElement("path", {
    d: "M77 39h-1v-1h1z",
    fill: "#7b4d22"
  })), _path2395 || (_path2395 = /*#__PURE__*/React.createElement("path", {
    d: "M78 39h-1v-1h1z",
    fill: "#805530"
  })), _path2396 || (_path2396 = /*#__PURE__*/React.createElement("path", {
    d: "M79 38v1h-1v-1z",
    fill: "#845b39"
  })), _path2397 || (_path2397 = /*#__PURE__*/React.createElement("path", {
    d: "M80 39h-1v-1h1z",
    fill: "#7f5432"
  })), _path2398 || (_path2398 = /*#__PURE__*/React.createElement("path", {
    d: "M81 38v1h-1v-1z",
    fill: "#805533"
  })), _path2399 || (_path2399 = /*#__PURE__*/React.createElement("path", {
    d: "M82 38h1v1h-1z",
    fill: "#875d39"
  })), _path2400 || (_path2400 = /*#__PURE__*/React.createElement("path", {
    d: "M84 38v1h-1v-1z",
    fill: "#8f613d"
  })), _path2401 || (_path2401 = /*#__PURE__*/React.createElement("path", {
    d: "M84 38h1v1h-1z",
    fill: "#946442"
  })), _path2402 || (_path2402 = /*#__PURE__*/React.createElement("path", {
    d: "M85 39v-1h1v1z",
    fill: "#9b694b"
  })), _path2403 || (_path2403 = /*#__PURE__*/React.createElement("path", {
    d: "M87 38h1v1h-1z",
    fill: "#9f6e4f"
  })), _path2404 || (_path2404 = /*#__PURE__*/React.createElement("path", {
    d: "M88 39v-1h1v1z",
    fill: "#a07151",
    fillOpacity: 0.918
  })), _path2405 || (_path2405 = /*#__PURE__*/React.createElement("path", {
    d: "M89 39v-1h1v1z",
    fill: "#aa7c5b",
    fillOpacity: 0.714
  })), _path2406 || (_path2406 = /*#__PURE__*/React.createElement("path", {
    d: "M91 39h-1v-1h1z",
    fill: "#a47a5e",
    fillOpacity: 0.475
  })), _path2407 || (_path2407 = /*#__PURE__*/React.createElement("path", {
    d: "M91 38h1v1h-1z",
    fill: "#a17d62",
    fillOpacity: 0.224
  })), _path2408 || (_path2408 = /*#__PURE__*/React.createElement("path", {
    d: "M94 38h1v1h-1z",
    fill: "#8c5c39",
    fillOpacity: 0.682
  })), _path2409 || (_path2409 = /*#__PURE__*/React.createElement("path", {
    d: "M96 39h-1v-1h1z",
    fill: "#925629"
  })), _path2410 || (_path2410 = /*#__PURE__*/React.createElement("path", {
    d: "M96 38h1v1h-1z",
    fill: "#915b36"
  })), _path2411 || (_path2411 = /*#__PURE__*/React.createElement("path", {
    d: "M107 39v-1h1v1z",
    fill: "#796161",
    fillOpacity: 0.082
  })), _path2412 || (_path2412 = /*#__PURE__*/React.createElement("path", {
    d: "M109 39h-1v-1h1z",
    fill: "#734624",
    fillOpacity: 0.906
  })), _path2413 || (_path2413 = /*#__PURE__*/React.createElement("path", {
    d: "M110 39h-1v-1h1z",
    fill: "#72441b"
  })), _path2414 || (_path2414 = /*#__PURE__*/React.createElement("path", {
    d: "M110 39v-1h1v1z",
    fill: "#573618"
  })), _path2415 || (_path2415 = /*#__PURE__*/React.createElement("path", {
    d: "M111 38h1v1h-1z",
    fill: "#523414"
  })), _path2416 || (_path2416 = /*#__PURE__*/React.createElement("path", {
    d: "M113 38v1h-1v-1z",
    fill: "#a9723a"
  })), _path2417 || (_path2417 = /*#__PURE__*/React.createElement("path", {
    d: "M113 39v-1h1v1z",
    fill: "#b87b3f"
  })), _path2418 || (_path2418 = /*#__PURE__*/React.createElement("path", {
    d: "M114 39v-1h1v1z",
    fill: "#b68658",
    fillOpacity: 0.439
  })), _path2419 || (_path2419 = /*#__PURE__*/React.createElement("path", {
    d: "M117 39v-1h1v1z",
    fill: "#66667f",
    fillOpacity: 0.039
  })), _path2420 || (_path2420 = /*#__PURE__*/React.createElement("path", {
    d: "M119 38v1h-1v-1z",
    fill: "#805133",
    fillOpacity: 0.843
  })), _path2421 || (_path2421 = /*#__PURE__*/React.createElement("path", {
    d: "M120 38v1h-1v-1z",
    fill: "#8f592d"
  })), _path2422 || (_path2422 = /*#__PURE__*/React.createElement("path", {
    d: "M121 38h1v1h-1z",
    fill: "#a27654",
    fillOpacity: 0.984
  })), _path2423 || (_path2423 = /*#__PURE__*/React.createElement("path", {
    d: "M123 38v1h-1v-1z",
    fill: "#9e7a66",
    fillOpacity: 0.196
  })), _path2424 || (_path2424 = /*#__PURE__*/React.createElement("path", {
    d: "M5 39v1H4v-1z",
    fill: "#a27d60",
    fillOpacity: 0.271
  })), _path2425 || (_path2425 = /*#__PURE__*/React.createElement("path", {
    d: "M5 40v-1h1v1z",
    fill: "#ad7b57",
    fillOpacity: 0.996
  })), _path2426 || (_path2426 = /*#__PURE__*/React.createElement("path", {
    d: "M7 40H6v-1h1z",
    fill: "#996338"
  })), _path2427 || (_path2427 = /*#__PURE__*/React.createElement("path", {
    d: "M8 39v1H7v-1z",
    fill: "#834923"
  })), _path2428 || (_path2428 = /*#__PURE__*/React.createElement("path", {
    d: "M8 39h1v1H8z",
    fill: "#884927"
  })), _path2429 || (_path2429 = /*#__PURE__*/React.createElement("path", {
    d: "M10 40H9v-1h1z",
    fill: "#9f5f3f"
  })), _path2430 || (_path2430 = /*#__PURE__*/React.createElement("path", {
    d: "M11 39v1h-1v-1z",
    fill: "#a06342"
  })), _path2431 || (_path2431 = /*#__PURE__*/React.createElement("path", {
    d: "M12 40h-1v-1h1z",
    fill: "#9d6442"
  })), _path2432 || (_path2432 = /*#__PURE__*/React.createElement("path", {
    d: "M13 39v1h-1v-1z",
    fill: "#9c6240"
  })), _path2433 || (_path2433 = /*#__PURE__*/React.createElement("path", {
    d: "M14 39h1v1h-1z",
    fill: "#9e6444"
  })), _path2434 || (_path2434 = /*#__PURE__*/React.createElement("path", {
    d: "M15 40v-1h1v1z",
    fill: "#9b6344"
  })), _path2435 || (_path2435 = /*#__PURE__*/React.createElement("path", {
    d: "M17 40h-1v-1h1z",
    fill: "#9d6543"
  })), _path2436 || (_path2436 = /*#__PURE__*/React.createElement("path", {
    d: "M18 39v1h-1v-1z",
    fill: "#9e6644"
  })), _path2437 || (_path2437 = /*#__PURE__*/React.createElement("path", {
    d: "M18 40v-1h1v1z",
    fill: "#9f6645"
  })), _path2438 || (_path2438 = /*#__PURE__*/React.createElement("path", {
    d: "M19 39h1v1h-1z",
    fill: "#a06646"
  })), _path2439 || (_path2439 = /*#__PURE__*/React.createElement("path", {
    d: "M22 39h1v1h-1z",
    fill: "#99633b"
  })), _path2440 || (_path2440 = /*#__PURE__*/React.createElement("path", {
    d: "M25 40h-1v-1h1z",
    fill: "#99663e"
  })), _path2441 || (_path2441 = /*#__PURE__*/React.createElement("path", {
    d: "M25 40v-1h1v1z",
    fill: "#926038"
  })), _path2442 || (_path2442 = /*#__PURE__*/React.createElement("path", {
    d: "M28 39v1h-1v-1z",
    fill: "#845a3a",
    fillOpacity: 0.871
  })), _path2443 || (_path2443 = /*#__PURE__*/React.createElement("path", {
    d: "M29 40h-1v-1h1z",
    fill: "#86684e",
    fillOpacity: 0.306
  })), _path2444 || (_path2444 = /*#__PURE__*/React.createElement("path", {
    d: "M30 39v1h-1v-1z",
    fill: "#88704d",
    fillOpacity: 0.169
  })), _path2445 || (_path2445 = /*#__PURE__*/React.createElement("path", {
    d: "M31 40h-1v-1h1z",
    fill: "#877869",
    fillOpacity: 0.067
  })), _path2446 || (_path2446 = /*#__PURE__*/React.createElement("path", {
    d: "M39 40h-1v-1h1z",
    fill: "#a38478",
    fillOpacity: 0.588
  })), _path2447 || (_path2447 = /*#__PURE__*/React.createElement("path", {
    d: "M40 39v1h-1v-1z",
    fill: "#ae847a"
  })), _path2448 || (_path2448 = /*#__PURE__*/React.createElement("path", {
    d: "M41 39v1h-1v-1z",
    fill: "#ac8376"
  })), _path2449 || (_path2449 = /*#__PURE__*/React.createElement("path", {
    d: "M41 39h1v1h-1z",
    fill: "#976d54"
  })), _path2450 || (_path2450 = /*#__PURE__*/React.createElement("path", {
    d: "M43 40h-1v-1h1z",
    fill: "#663b1c"
  })), _path2451 || (_path2451 = /*#__PURE__*/React.createElement("path", {
    d: "M44 39v1h-1v-1z",
    fill: "#613f2d",
    fillOpacity: 0.267
  })), _path2452 || (_path2452 = /*#__PURE__*/React.createElement("path", {
    d: "M53 39v1h-1v-1z",
    fill: "#5c5139",
    fillOpacity: 0.086
  })), _path2453 || (_path2453 = /*#__PURE__*/React.createElement("path", {
    d: "M53 40v-1h1v1z",
    fill: "#6b493e",
    fillOpacity: 0.176
  })), _path2454 || (_path2454 = /*#__PURE__*/React.createElement("path", {
    d: "M54 40v-1h1v1z",
    fill: "#73523b",
    fillOpacity: 0.302
  })), _path2455 || (_path2455 = /*#__PURE__*/React.createElement("path", {
    d: "M56 40h-1v-1h1z",
    fill: "#734b35",
    fillOpacity: 0.451
  })), _path2456 || (_path2456 = /*#__PURE__*/React.createElement("path", {
    d: "M56 40v-1h1v1z",
    fill: "#7a5135",
    fillOpacity: 0.612
  })), _path2457 || (_path2457 = /*#__PURE__*/React.createElement("path", {
    d: "M57 39h1v1h-1z",
    fill: "#885d3f",
    fillOpacity: 0.741
  })), _path2458 || (_path2458 = /*#__PURE__*/React.createElement("path", {
    d: "M59 39v1h-1v-1z",
    fill: "#8b623c",
    fillOpacity: 0.855
  })), _path2459 || (_path2459 = /*#__PURE__*/React.createElement("path", {
    d: "M59 40v-1h1v1z",
    fill: "#8a6035",
    fillOpacity: 0.949
  })), _path2460 || (_path2460 = /*#__PURE__*/React.createElement("path", {
    d: "M60 40v-1h1v1z",
    fill: "#8c5d36"
  })), _path2461 || (_path2461 = /*#__PURE__*/React.createElement("path", {
    d: "M61 40v-1h1v1z",
    fill: "#8a5832"
  })), _path2462 || (_path2462 = /*#__PURE__*/React.createElement("path", {
    d: "M63 40h-1v-1h1z",
    fill: "#83532b"
  })), _path2463 || (_path2463 = /*#__PURE__*/React.createElement("path", {
    d: "M65 39v1h-1v-1z",
    fill: "#7b4c26"
  })), _path2464 || (_path2464 = /*#__PURE__*/React.createElement("path", {
    d: "M65 39h1v1h-1z",
    fill: "#794c24"
  })), _path2465 || (_path2465 = /*#__PURE__*/React.createElement("path", {
    d: "M67 40h-1v-1h1z",
    fill: "#784b21"
  })), _path2466 || (_path2466 = /*#__PURE__*/React.createElement("path", {
    d: "M68 40h-1v-1h1z",
    fill: "#774a20"
  })), _path2467 || (_path2467 = /*#__PURE__*/React.createElement("path", {
    d: "M70 40h-1v-1h1z",
    fill: "#74471f"
  })), _path2468 || (_path2468 = /*#__PURE__*/React.createElement("path", {
    d: "M71 39v1h-1v-1z",
    fill: "#744720"
  })), _path2469 || (_path2469 = /*#__PURE__*/React.createElement("path", {
    d: "M71 40v-1h1v1z",
    fill: "#7d4d22"
  })), _path2470 || (_path2470 = /*#__PURE__*/React.createElement("path", {
    d: "M72 40v-1h1v1z",
    fill: "#815022"
  })), _path2471 || (_path2471 = /*#__PURE__*/React.createElement("path", {
    d: "M74 40h-1v-1h1z",
    fill: "#845225"
  })), _path2472 || (_path2472 = /*#__PURE__*/React.createElement("path", {
    d: "M74 39h1v1h-1z",
    fill: "#8d5d31"
  })), _path2473 || (_path2473 = /*#__PURE__*/React.createElement("path", {
    d: "M75 40v-1h1v1z",
    fill: "#875729"
  })), _path2474 || (_path2474 = /*#__PURE__*/React.createElement("path", {
    d: "M77 40v-1h1v1z",
    fill: "#8e633d"
  })), _path2475 || (_path2475 = /*#__PURE__*/React.createElement("path", {
    d: "M78 39h1v1h-1z",
    fill: "#8c613d"
  })), _path2476 || (_path2476 = /*#__PURE__*/React.createElement("path", {
    d: "M81 40h-1v-1h1z",
    fill: "#865b38"
  })), _path2477 || (_path2477 = /*#__PURE__*/React.createElement("path", {
    d: "M82 39v1h-1v-1z",
    fill: "#926441"
  })), _path2478 || (_path2478 = /*#__PURE__*/React.createElement("path", {
    d: "M83 40h-1v-1h1z",
    fill: "#9b6946"
  })), _path2479 || (_path2479 = /*#__PURE__*/React.createElement("path", {
    d: "M84 39v1h-1v-1z",
    fill: "#9c6b49"
  })), _path2480 || (_path2480 = /*#__PURE__*/React.createElement("path", {
    d: "M85 39v1h-1v-1z",
    fill: "#956b4a",
    fillOpacity: 0.973
  })), _path2481 || (_path2481 = /*#__PURE__*/React.createElement("path", {
    d: "M85 39h1v1h-1z",
    fill: "#946d4b",
    fillOpacity: 0.82
  })), _path2482 || (_path2482 = /*#__PURE__*/React.createElement("path", {
    d: "M87 39v1h-1v-1z",
    fill: "#926a4f",
    fillOpacity: 0.58
  })), _path2483 || (_path2483 = /*#__PURE__*/React.createElement("path", {
    d: "M88 39v1h-1v-1z",
    fill: "#957259",
    fillOpacity: 0.314
  })), _path2484 || (_path2484 = /*#__PURE__*/React.createElement("path", {
    d: "M88 39h1v1h-1z",
    fill: "#8d715e",
    fillOpacity: 0.106
  })), _path2485 || (_path2485 = /*#__PURE__*/React.createElement("path", {
    d: "M95 39v1h-1v-1z",
    fill: "#8a5c3c",
    fillOpacity: 0.678
  })), _path2486 || (_path2486 = /*#__PURE__*/React.createElement("path", {
    d: "M96 40h-1v-1h1z",
    fill: "#915529"
  })), _path2487 || (_path2487 = /*#__PURE__*/React.createElement("path", {
    d: "M97 39v1h-1v-1z",
    fill: "#925a35"
  })), _path2488 || (_path2488 = /*#__PURE__*/React.createElement("path", {
    d: "M98 40h-1v-1h1z",
    fill: "#8c6b58",
    fillOpacity: 0.42
  })), _path2489 || (_path2489 = /*#__PURE__*/React.createElement("path", {
    d: "M107 40v-1h1v1z",
    fill: "#756262",
    fillOpacity: 0.102
  })), _path2490 || (_path2490 = /*#__PURE__*/React.createElement("path", {
    d: "M108 39h1v1h-1z",
    fill: "#764824",
    fillOpacity: 0.922
  })), _path2491 || (_path2491 = /*#__PURE__*/React.createElement("path", {
    d: "M109 40v-1h1v1z",
    fill: "#75471d"
  })), _path2492 || (_path2492 = /*#__PURE__*/React.createElement("path", {
    d: "M110 39h1v1h-1z",
    fill: "#59381a"
  })), _path2493 || (_path2493 = /*#__PURE__*/React.createElement("path", {
    d: "M112 40h-1v-1h1z",
    fill: "#553515"
  })), _path2494 || (_path2494 = /*#__PURE__*/React.createElement("path", {
    d: "M113 40h-1v-1h1z",
    fill: "#ad743a"
  })), _path2495 || (_path2495 = /*#__PURE__*/React.createElement("path", {
    d: "M114 39v1h-1v-1z",
    fill: "#c08348"
  })), _path2496 || (_path2496 = /*#__PURE__*/React.createElement("path", {
    d: "M114 40v-1h1v1z",
    fill: "#bd8f61",
    fillOpacity: 0.412
  })), _path2497 || (_path2497 = /*#__PURE__*/React.createElement("path", {
    d: "M118 40h-1v-1h1z",
    fill: "#746a5f",
    fillOpacity: 0.094
  })), _path2498 || (_path2498 = /*#__PURE__*/React.createElement("path", {
    d: "M119 40h-1v-1h1z",
    fill: "#825230",
    fillOpacity: 0.914
  })), _path2499 || (_path2499 = /*#__PURE__*/React.createElement("path", {
    d: "M120 40h-1v-1h1z",
    fill: "#8f5a2e"
  })), _path2500 || (_path2500 = /*#__PURE__*/React.createElement("path", {
    d: "M121 40v-1h1v1z",
    fill: "#a27757",
    fillOpacity: 0.937
  })), _path2501 || (_path2501 = /*#__PURE__*/React.createElement("path", {
    d: "M122 39h1v1h-1z",
    fill: "#9c7b6a",
    fillOpacity: 0.122
  })), _path2502 || (_path2502 = /*#__PURE__*/React.createElement("path", {
    d: "M4 40h1v1H4z",
    fill: "#a77f67",
    fillOpacity: 0.125
  })), _path2503 || (_path2503 = /*#__PURE__*/React.createElement("path", {
    d: "M5 41v-1h1v1z",
    fill: "#aa7955",
    fillOpacity: 0.941
  })), _path2504 || (_path2504 = /*#__PURE__*/React.createElement("path", {
    d: "M7 41H6v-1h1z",
    fill: "#a16d3e"
  })), _path2505 || (_path2505 = /*#__PURE__*/React.createElement("path", {
    d: "M7 41v-1h1v1z",
    fill: "#814a23"
  })), _path2506 || (_path2506 = /*#__PURE__*/React.createElement("path", {
    d: "M9 40v1H8v-1z",
    fill: "#824621"
  })), _path2507 || (_path2507 = /*#__PURE__*/React.createElement("path", {
    d: "M9 40h1v1H9z",
    fill: "#9b5c38"
  })), _path2508 || (_path2508 = /*#__PURE__*/React.createElement("path", {
    d: "M11 40v1h-1v-1z",
    fill: "#a4623e"
  })), _path2509 || (_path2509 = /*#__PURE__*/React.createElement("path", {
    d: "M12 40v1h-1v-1z",
    fill: "#a0613c"
  })), _path2510 || (_path2510 = /*#__PURE__*/React.createElement("path", {
    d: "M12 41v-1h1v1z",
    fill: "#9e623e"
  })), _path2511 || (_path2511 = /*#__PURE__*/React.createElement("path", {
    d: "M15 40h1v1h-1z",
    fill: "#9e6343"
  })), _path2512 || (_path2512 = /*#__PURE__*/React.createElement("path", {
    d: "M17 40v1h-1v-1z",
    fill: "#9e6140"
  })), _path2513 || (_path2513 = /*#__PURE__*/React.createElement("path", {
    d: "M17 40h1v1h-1z",
    fill: "#9c5d3c"
  })), _path2514 || (_path2514 = /*#__PURE__*/React.createElement("path", {
    d: "M19 41h-1v-1h1z",
    fill: "#9a5e3b"
  })), _path2515 || (_path2515 = /*#__PURE__*/React.createElement("path", {
    d: "M20 41h-1v-1h1z",
    fill: "#955a36"
  })), _path2516 || (_path2516 = /*#__PURE__*/React.createElement("path", {
    d: "M20 40h1v1h-1z",
    fill: "#925730"
  })), _path2517 || (_path2517 = /*#__PURE__*/React.createElement("path", {
    d: "M22 41h-1v-1h1z",
    fill: "#8e5431"
  })), _path2518 || (_path2518 = /*#__PURE__*/React.createElement("path", {
    d: "M23 41h-1v-1h1z",
    fill: "#90552f"
  })), _path2519 || (_path2519 = /*#__PURE__*/React.createElement("path", {
    d: "M23 41v-1h1v1z",
    fill: "#92552f"
  })), _path2520 || (_path2520 = /*#__PURE__*/React.createElement("path", {
    d: "M25 40h1v1h-1z",
    fill: "#935730"
  })), _path2521 || (_path2521 = /*#__PURE__*/React.createElement("path", {
    d: "M27 41h-1v-1h1z",
    fill: "#955c39"
  })), _path2522 || (_path2522 = /*#__PURE__*/React.createElement("path", {
    d: "M27 40h1v1h-1z",
    fill: "#9a6341"
  })), _path2523 || (_path2523 = /*#__PURE__*/React.createElement("path", {
    d: "M29 40v1h-1v-1z",
    fill: "#986442"
  })), _path2524 || (_path2524 = /*#__PURE__*/React.createElement("path", {
    d: "M29 40h1v1h-1z",
    fill: "#936140",
    fillOpacity: 0.965
  })), _path2525 || (_path2525 = /*#__PURE__*/React.createElement("path", {
    d: "M31 40v1h-1v-1z",
    fill: "#926345",
    fillOpacity: 0.882
  })), _path2526 || (_path2526 = /*#__PURE__*/React.createElement("path", {
    d: "M31 41v-1h1v1z",
    fill: "#8d6344",
    fillOpacity: 0.765
  })), _path2527 || (_path2527 = /*#__PURE__*/React.createElement("path", {
    d: "M32 40h1v1h-1z",
    fill: "#896441",
    fillOpacity: 0.627
  })), _path2528 || (_path2528 = /*#__PURE__*/React.createElement("path", {
    d: "M34 40v1h-1v-1z",
    fill: "#836443",
    fillOpacity: 0.447
  })), _path2529 || (_path2529 = /*#__PURE__*/React.createElement("path", {
    d: "M34 41v-1h1v1z",
    fill: "#816542",
    fillOpacity: 0.286
  })), _path2530 || (_path2530 = /*#__PURE__*/React.createElement("path", {
    d: "M36 40v1h-1v-1z",
    fill: "#836641",
    fillOpacity: 0.137
  })), _path2531 || (_path2531 = /*#__PURE__*/React.createElement("path", {
    d: "M37 41h-1v-1h1z",
    fill: "#a28b73",
    fillOpacity: 0.043
  })), _path2532 || (_path2532 = /*#__PURE__*/React.createElement("path", {
    d: "M39 41h-1v-1h1z",
    fill: "#a2847a",
    fillOpacity: 0.529
  })), _path2533 || (_path2533 = /*#__PURE__*/React.createElement("path", {
    d: "M40 41h-1v-1h1z",
    fill: "#ae867c"
  })), _path2534 || (_path2534 = /*#__PURE__*/React.createElement("path", {
    d: "M41 40v1h-1v-1z",
    fill: "#ae8477"
  })), _path2535 || (_path2535 = /*#__PURE__*/React.createElement("path", {
    d: "M42 41h-1v-1h1z",
    fill: "#9d715a"
  })), _path2536 || (_path2536 = /*#__PURE__*/React.createElement("path", {
    d: "M43 40v1h-1v-1z",
    fill: "#6b3d1f"
  })), _path2537 || (_path2537 = /*#__PURE__*/React.createElement("path", {
    d: "M43 41v-1h1v1z",
    fill: "#6a4331",
    fillOpacity: 0.282
  })), _path2538 || (_path2538 = /*#__PURE__*/React.createElement("path", {
    d: "M60 40v1h-1v-1z",
    fill: "#785c46",
    fillOpacity: 0.141
  })), _path2539 || (_path2539 = /*#__PURE__*/React.createElement("path", {
    d: "M60 41v-1h1v1z",
    fill: "#835935",
    fillOpacity: 0.769
  })), _path2540 || (_path2540 = /*#__PURE__*/React.createElement("path", {
    d: "M62 40v1h-1v-1z",
    fill: "#8d5a2e"
  })), _path2541 || (_path2541 = /*#__PURE__*/React.createElement("path", {
    d: "M62 41v-1h1v1z",
    fill: "#87572c"
  })), _path2542 || (_path2542 = /*#__PURE__*/React.createElement("path", {
    d: "M63 41v-1h1v1z",
    fill: "#825228"
  })), _path2543 || (_path2543 = /*#__PURE__*/React.createElement("path", {
    d: "M64 41v-1h1v1z",
    fill: "#7d4f25"
  })), _path2544 || (_path2544 = /*#__PURE__*/React.createElement("path", {
    d: "M65 40h1v1h-1z",
    fill: "#794c24",
    fillOpacity: 0.992
  })), _path2545 || (_path2545 = /*#__PURE__*/React.createElement("path", {
    d: "M67 40v1h-1v-1z",
    fill: "#754a27",
    fillOpacity: 0.992
  })), _path2546 || (_path2546 = /*#__PURE__*/React.createElement("path", {
    d: "M67 41v-1h1v1z",
    fill: "#784b25"
  })), _path2547 || (_path2547 = /*#__PURE__*/React.createElement("path", {
    d: "M68 40h1v1h-1z",
    fill: "#7a4c22"
  })), _path2548 || (_path2548 = /*#__PURE__*/React.createElement("path", {
    d: "M69 41v-1h1v1z",
    fill: "#7c4d22"
  })), _path2549 || (_path2549 = /*#__PURE__*/React.createElement("path", {
    d: "M70 41v-1h1v1z",
    fill: "#7c4c1f"
  })), _path2550 || (_path2550 = /*#__PURE__*/React.createElement("path", {
    d: "M71 40h1v1h-1z",
    fill: "#825121"
  })), _path2551 || (_path2551 = /*#__PURE__*/React.createElement("path", {
    d: "M73 40v1h-1v-1z",
    fill: "#825020"
  })), _path2552 || (_path2552 = /*#__PURE__*/React.createElement("path", {
    d: "M74 40v1h-1v-1z",
    fill: "#885729"
  })), _path2553 || (_path2553 = /*#__PURE__*/React.createElement("path", {
    d: "M74 41v-1h1v1z",
    fill: "#8d5d2f"
  })), _path2554 || (_path2554 = /*#__PURE__*/React.createElement("path", {
    d: "M76 40v1h-1v-1z",
    fill: "#825222"
  })), _path2555 || (_path2555 = /*#__PURE__*/React.createElement("path", {
    d: "M76 41v-1h1v1z",
    fill: "#85562b"
  })), _path2556 || (_path2556 = /*#__PURE__*/React.createElement("path", {
    d: "M78 40v1h-1v-1z",
    fill: "#9b6f48"
  })), _path2557 || (_path2557 = /*#__PURE__*/React.createElement("path", {
    d: "M80 40v1h-1v-1z",
    fill: "#946944"
  })), _path2558 || (_path2558 = /*#__PURE__*/React.createElement("path", {
    d: "M80 40h1v1h-1z",
    fill: "#8c6343"
  })), _path2559 || (_path2559 = /*#__PURE__*/React.createElement("path", {
    d: "M81 40h1v1h-1z",
    fill: "#8f6645",
    fillOpacity: 0.898
  })), _path2560 || (_path2560 = /*#__PURE__*/React.createElement("path", {
    d: "M83 41h-1v-1h1z",
    fill: "#8d6648",
    fillOpacity: 0.69
  })), _path2561 || (_path2561 = /*#__PURE__*/React.createElement("path", {
    d: "M84 40v1h-1v-1z",
    fill: "#8d674a",
    fillOpacity: 0.416
  })), _path2562 || (_path2562 = /*#__PURE__*/React.createElement("path", {
    d: "M84 40h1v1h-1z",
    fill: "#876751",
    fillOpacity: 0.184
  })), _path2563 || (_path2563 = /*#__PURE__*/React.createElement("path", {
    d: "M94 41v-1h1v1z",
    fill: "#8a5e3e",
    fillOpacity: 0.659
  })), _path2564 || (_path2564 = /*#__PURE__*/React.createElement("path", {
    d: "M108 41h-1v-1h1z",
    fill: "#76645b",
    fillOpacity: 0.11
  })), _path2565 || (_path2565 = /*#__PURE__*/React.createElement("path", {
    d: "M108 41v-1h1v1z",
    fill: "#794a25",
    fillOpacity: 0.925
  })), _path2566 || (_path2566 = /*#__PURE__*/React.createElement("path", {
    d: "M110 40v1h-1v-1z",
    fill: "#75461c"
  })), _path2567 || (_path2567 = /*#__PURE__*/React.createElement("path", {
    d: "M110 40h1v1h-1z",
    fill: "#5c381a"
  })), _path2568 || (_path2568 = /*#__PURE__*/React.createElement("path", {
    d: "M111 41v-1h1v1z",
    fill: "#5c3918"
  })), _path2569 || (_path2569 = /*#__PURE__*/React.createElement("path", {
    d: "M112 40h1v1h-1z",
    fill: "#b47940"
  })), _path2570 || (_path2570 = /*#__PURE__*/React.createElement("path", {
    d: "M113 41v-1h1v1z",
    fill: "#c78a52"
  })), _path2571 || (_path2571 = /*#__PURE__*/React.createElement("path", {
    d: "M115 40v1h-1v-1z",
    fill: "#c1936d",
    fillOpacity: 0.392
  })), _path2572 || (_path2572 = /*#__PURE__*/React.createElement("path", {
    d: "M118 40v1h-1v-1z",
    fill: "#6c5246",
    fillOpacity: 0.157
  })), _path2573 || (_path2573 = /*#__PURE__*/React.createElement("path", {
    d: "M119 41h-1v-1h1z",
    fill: "#83522e",
    fillOpacity: 0.965
  })), _path2574 || (_path2574 = /*#__PURE__*/React.createElement("path", {
    d: "M120 41h-1v-1h1z",
    fill: "#915c2f"
  })), _path2575 || (_path2575 = /*#__PURE__*/React.createElement("path", {
    d: "M120 41v-1h1v1z",
    fill: "#a16d49"
  })), _path2576 || (_path2576 = /*#__PURE__*/React.createElement("path", {
    d: "M121 40h1v1h-1z",
    fill: "#a77e5e",
    fillOpacity: 0.878
  })), _path2577 || (_path2577 = /*#__PURE__*/React.createElement("path", {
    d: "M123 40v1h-1v-1z",
    fill: "#b49687",
    fillOpacity: 0.067
  })), _path2578 || (_path2578 = /*#__PURE__*/React.createElement("path", {
    d: "M6 41v1H5v-1z",
    fill: "#a57854",
    fillOpacity: 0.827
  })), _path2579 || (_path2579 = /*#__PURE__*/React.createElement("path", {
    d: "M6 42v-1h1v1z",
    fill: "#aa7345"
  })), _path2580 || (_path2580 = /*#__PURE__*/React.createElement("path", {
    d: "M8 41v1H7v-1z",
    fill: "#83502b"
  })), _path2581 || (_path2581 = /*#__PURE__*/React.createElement("path", {
    d: "M8 41h1v1H8z",
    fill: "#7e4d25"
  })), _path2582 || (_path2582 = /*#__PURE__*/React.createElement("path", {
    d: "M9 42v-1h1v1z",
    fill: "#884e29"
  })), _path2583 || (_path2583 = /*#__PURE__*/React.createElement("path", {
    d: "M11 41v1h-1v-1z",
    fill: "#935638",
    fillOpacity: 0.886
  })), _path2584 || (_path2584 = /*#__PURE__*/React.createElement("path", {
    d: "M12 42h-1v-1h1z",
    fill: "#905b3d",
    fillOpacity: 0.808
  })), _path2585 || (_path2585 = /*#__PURE__*/React.createElement("path", {
    d: "M13 41v1h-1v-1z",
    fill: "#955c38",
    fillOpacity: 0.973
  })), _path2586 || (_path2586 = /*#__PURE__*/React.createElement("path", {
    d: "M14 41v1h-1v-1z",
    fill: "#9c623e"
  })), _path2587 || (_path2587 = /*#__PURE__*/React.createElement("path", {
    d: "M15 42h-1v-1h1z",
    fill: "#9d6440"
  })), _path2588 || (_path2588 = /*#__PURE__*/React.createElement("path", {
    d: "M15 42v-1h1v1z",
    fill: "#a06643"
  })), _path2589 || (_path2589 = /*#__PURE__*/React.createElement("path", {
    d: "M17 42h-1v-1h1z",
    fill: "#9d6443"
  })), _path2590 || (_path2590 = /*#__PURE__*/React.createElement("path", {
    d: "M18 41v1h-1v-1z",
    fill: "#9d6241"
  })), _path2591 || (_path2591 = /*#__PURE__*/React.createElement("path", {
    d: "M18 42v-1h1v1z",
    fill: "#9c613f"
  })), _path2592 || (_path2592 = /*#__PURE__*/React.createElement("path", {
    d: "M21 41v1h-1v-1z",
    fill: "#9a5e39"
  })), _path2593 || (_path2593 = /*#__PURE__*/React.createElement("path", {
    d: "M21 42v-1h1v1z",
    fill: "#985c3a"
  })), _path2594 || (_path2594 = /*#__PURE__*/React.createElement("path", {
    d: "M22 41h1v1h-1z",
    fill: "#995b38"
  })), _path2595 || (_path2595 = /*#__PURE__*/React.createElement("path", {
    d: "M24 42h-1v-1h1z",
    fill: "#995c36"
  })), _path2596 || (_path2596 = /*#__PURE__*/React.createElement("path", {
    d: "M25 42h-1v-1h1z",
    fill: "#955c34"
  })), _path2597 || (_path2597 = /*#__PURE__*/React.createElement("path", {
    d: "M25 42v-1h1v1z",
    fill: "#975c39"
  })), _path2598 || (_path2598 = /*#__PURE__*/React.createElement("path", {
    d: "M26 41h1v1h-1z",
    fill: "#995e40"
  })), _path2599 || (_path2599 = /*#__PURE__*/React.createElement("path", {
    d: "M27 42v-1h1v1z",
    fill: "#9e6243"
  })), _path2600 || (_path2600 = /*#__PURE__*/React.createElement("path", {
    d: "M29 42h-1v-1h1z",
    fill: "#a16548"
  })), _path2601 || (_path2601 = /*#__PURE__*/React.createElement("path", {
    d: "M30 41v1h-1v-1z",
    fill: "#a2694b"
  })), _path2602 || (_path2602 = /*#__PURE__*/React.createElement("path", {
    d: "M31 42h-1v-1h1z",
    fill: "#a66f56"
  })), _path2603 || (_path2603 = /*#__PURE__*/React.createElement("path", {
    d: "M32 41v1h-1v-1z",
    fill: "#a5725c"
  })), _path2604 || (_path2604 = /*#__PURE__*/React.createElement("path", {
    d: "M33 41v1h-1v-1z",
    fill: "#a87863"
  })), _path2605 || (_path2605 = /*#__PURE__*/React.createElement("path", {
    d: "M34 41v1h-1v-1z",
    fill: "#aa7c68"
  })), _path2606 || (_path2606 = /*#__PURE__*/React.createElement("path", {
    d: "M35 41v1h-1v-1z",
    fill: "#9d7255"
  })), _path2607 || (_path2607 = /*#__PURE__*/React.createElement("path", {
    d: "M36 42h-1v-1h1z",
    fill: "#8d6341",
    fillOpacity: 0.953
  })), _path2608 || (_path2608 = /*#__PURE__*/React.createElement("path", {
    d: "M36 41h1v1h-1z",
    fill: "#8d6240",
    fillOpacity: 0.851
  })), _path2609 || (_path2609 = /*#__PURE__*/React.createElement("path", {
    d: "M37 41h1v1h-1z",
    fill: "#86623c",
    fillOpacity: 0.682
  })), _path2610 || (_path2610 = /*#__PURE__*/React.createElement("path", {
    d: "M39 41v1h-1v-1z",
    fill: "#a07b63",
    fillOpacity: 0.812
  })), _path2611 || (_path2611 = /*#__PURE__*/React.createElement("path", {
    d: "M39 41h1v1h-1z",
    fill: "#ab8476"
  })), _path2612 || (_path2612 = /*#__PURE__*/React.createElement("path", {
    d: "M41 42h-1v-1h1z",
    fill: "#ac857a"
  })), _path2613 || (_path2613 = /*#__PURE__*/React.createElement("path", {
    d: "M42 42h-1v-1h1z",
    fill: "#a27762"
  })), _path2614 || (_path2614 = /*#__PURE__*/React.createElement("path", {
    d: "M42 41h1v1h-1z",
    fill: "#6d3f21"
  })), _path2615 || (_path2615 = /*#__PURE__*/React.createElement("path", {
    d: "M44 42h-1v-1h1z",
    fill: "#6b4332",
    fillOpacity: 0.298
  })), _path2616 || (_path2616 = /*#__PURE__*/React.createElement("path", {
    d: "M61 41v1h-1v-1z",
    fill: "#7f5632",
    fillOpacity: 0.69
  })), _path2617 || (_path2617 = /*#__PURE__*/React.createElement("path", {
    d: "M62 42h-1v-1h1z",
    fill: "#8b5927"
  })), _path2618 || (_path2618 = /*#__PURE__*/React.createElement("path", {
    d: "M64 42h-1v-1h1z",
    fill: "#905f34"
  })), _path2619 || (_path2619 = /*#__PURE__*/React.createElement("path", {
    d: "M66 42h-1v-1h1z",
    fill: "#82592f",
    fillOpacity: 0.78
  })), _path2620 || (_path2620 = /*#__PURE__*/React.createElement("path", {
    d: "M66 42v-1h1v1z",
    fill: "#6b5035",
    fillOpacity: 0.224
  })), _path2621 || (_path2621 = /*#__PURE__*/React.createElement("path", {
    d: "M67 41h1v1h-1z",
    fill: "#68462a",
    fillOpacity: 0.353
  })), _path2622 || (_path2622 = /*#__PURE__*/React.createElement("path", {
    d: "M68 42v-1h1v1z",
    fill: "#674425",
    fillOpacity: 0.51
  })), _path2623 || (_path2623 = /*#__PURE__*/React.createElement("path", {
    d: "M69 41h1v1h-1z",
    fill: "#6c4824",
    fillOpacity: 0.667
  })), _path2624 || (_path2624 = /*#__PURE__*/React.createElement("path", {
    d: "M70 41h1v1h-1z",
    fill: "#6f4721",
    fillOpacity: 0.8
  })), _path2625 || (_path2625 = /*#__PURE__*/React.createElement("path", {
    d: "M72 42h-1v-1h1z",
    fill: "#7d5027",
    fillOpacity: 0.914
  })), _path2626 || (_path2626 = /*#__PURE__*/React.createElement("path", {
    d: "M73 41v1h-1v-1z",
    fill: "#895927"
  })), _path2627 || (_path2627 = /*#__PURE__*/React.createElement("path", {
    d: "M74 41v1h-1v-1z",
    fill: "#8f5d2f"
  })), _path2628 || (_path2628 = /*#__PURE__*/React.createElement("path", {
    d: "M74 41h1v1h-1z",
    fill: "#905c2e"
  })), _path2629 || (_path2629 = /*#__PURE__*/React.createElement("path", {
    d: "M76 41v1h-1v-1z",
    fill: "#865225"
  })), _path2630 || (_path2630 = /*#__PURE__*/React.createElement("path", {
    d: "M77 41v1h-1v-1z",
    fill: "#8b5c2f"
  })), _path2631 || (_path2631 = /*#__PURE__*/React.createElement("path", {
    d: "M78 42h-1v-1h1z",
    fill: "#9f754b"
  })), _path2632 || (_path2632 = /*#__PURE__*/React.createElement("path", {
    d: "M78 42v-1h1v1z",
    fill: "#986e41"
  })), _path2633 || (_path2633 = /*#__PURE__*/React.createElement("path", {
    d: "M79 41h1v1h-1z",
    fill: "#8f6c49",
    fillOpacity: 0.627
  })), _path2634 || (_path2634 = /*#__PURE__*/React.createElement("path", {
    d: "M81 42h-1v-1h1z",
    fill: "#846852",
    fillOpacity: 0.278
  })), _path2635 || (_path2635 = /*#__PURE__*/React.createElement("path", {
    d: "M82 42h-1v-1h1z",
    fill: "#7f664c",
    fillOpacity: 0.078
  })), _path2636 || (_path2636 = /*#__PURE__*/React.createElement("path", {
    d: "M94 41h1v1h-1z",
    fill: "#885a3e",
    fillOpacity: 0.639
  })), _path2637 || (_path2637 = /*#__PURE__*/React.createElement("path", {
    d: "M97 41v1h-1v-1z",
    fill: "#915a31"
  })), _path2638 || (_path2638 = /*#__PURE__*/React.createElement("path", {
    d: "M97 42v-1h1v1z",
    fill: "#896b59",
    fillOpacity: 0.392
  })), _path2639 || (_path2639 = /*#__PURE__*/React.createElement("path", {
    d: "M108 42h-1v-1h1z",
    fill: "#7b625a",
    fillOpacity: 0.122
  })), _path2640 || (_path2640 = /*#__PURE__*/React.createElement("path", {
    d: "M109 42h-1v-1h1z",
    fill: "#774a26",
    fillOpacity: 0.937
  })), _path2641 || (_path2641 = /*#__PURE__*/React.createElement("path", {
    d: "M109 42v-1h1v1z",
    fill: "#74451d"
  })), _path2642 || (_path2642 = /*#__PURE__*/React.createElement("path", {
    d: "M110 41h1v1h-1z",
    fill: "#5d3918"
  })), _path2643 || (_path2643 = /*#__PURE__*/React.createElement("path", {
    d: "M112 42h-1v-1h1z",
    fill: "#603d18"
  })), _path2644 || (_path2644 = /*#__PURE__*/React.createElement("path", {
    d: "M112 42v-1h1v1z",
    fill: "#be8048"
  })), _path2645 || (_path2645 = /*#__PURE__*/React.createElement("path", {
    d: "M114 42h-1v-1h1z",
    fill: "#cc8d54"
  })), _path2646 || (_path2646 = /*#__PURE__*/React.createElement("path", {
    d: "M115 42h-1v-1h1z",
    fill: "#bd916f",
    fillOpacity: 0.384
  })), _path2647 || (_path2647 = /*#__PURE__*/React.createElement("path", {
    d: "M118 41v1h-1v-1z",
    fill: "#67422f",
    fillOpacity: 0.212
  })), _path2648 || (_path2648 = /*#__PURE__*/React.createElement("path", {
    d: "M119 41v1h-1v-1z",
    fill: "#80502b",
    fillOpacity: 0.996
  })), _path2649 || (_path2649 = /*#__PURE__*/React.createElement("path", {
    d: "M119 41h1v1h-1z",
    fill: "#905a2e"
  })), _path2650 || (_path2650 = /*#__PURE__*/React.createElement("path", {
    d: "M120 41h1v1h-1z",
    fill: "#a4714d"
  })), _path2651 || (_path2651 = /*#__PURE__*/React.createElement("path", {
    d: "M122 42h-1v-1h1z",
    fill: "#a78264",
    fillOpacity: 0.8
  })), _path2652 || (_path2652 = /*#__PURE__*/React.createElement("path", {
    d: "M6 43H5v-1h1z",
    fill: "#a37b58",
    fillOpacity: 0.667
  })), _path2653 || (_path2653 = /*#__PURE__*/React.createElement("path", {
    d: "M7 42v1H6v-1z",
    fill: "#b17a4e"
  })), _path2654 || (_path2654 = /*#__PURE__*/React.createElement("path", {
    d: "M7 43v-1h1v1z",
    fill: "#8e5c36"
  })), _path2655 || (_path2655 = /*#__PURE__*/React.createElement("path", {
    d: "M9 42v1H8v-1z",
    fill: "#86542f"
  })), _path2656 || (_path2656 = /*#__PURE__*/React.createElement("path", {
    d: "M10 43H9v-1h1z",
    fill: "#7f4c28"
  })), _path2657 || (_path2657 = /*#__PURE__*/React.createElement("path", {
    d: "M10 43v-1h1v1z",
    fill: "#754a2c",
    fillOpacity: 0.714
  })), _path2658 || (_path2658 = /*#__PURE__*/React.createElement("path", {
    d: "M13 42v1h-1v-1z",
    fill: "#825a3e",
    fillOpacity: 0.176
  })), _path2659 || (_path2659 = /*#__PURE__*/React.createElement("path", {
    d: "M14 43h-1v-1h1z",
    fill: "#855d44",
    fillOpacity: 0.396
  })), _path2660 || (_path2660 = /*#__PURE__*/React.createElement("path", {
    d: "M14 43v-1h1v1z",
    fill: "#895c42",
    fillOpacity: 0.627
  })), _path2661 || (_path2661 = /*#__PURE__*/React.createElement("path", {
    d: "M15 43v-1h1v1z",
    fill: "#936143",
    fillOpacity: 0.812
  })), _path2662 || (_path2662 = /*#__PURE__*/React.createElement("path", {
    d: "M17 42v1h-1v-1z",
    fill: "#965f3e",
    fillOpacity: 0.933
  })), _path2663 || (_path2663 = /*#__PURE__*/React.createElement("path", {
    d: "M17 42h1v1h-1z",
    fill: "#975e3c"
  })), _path2664 || (_path2664 = /*#__PURE__*/React.createElement("path", {
    d: "M18 42h1v1h-1z",
    fill: "#9b603b"
  })), _path2665 || (_path2665 = /*#__PURE__*/React.createElement("path", {
    d: "M21 42h1v1h-1z",
    fill: "#985831"
  })), _path2666 || (_path2666 = /*#__PURE__*/React.createElement("path", {
    d: "M23 43h-1v-1h1z",
    fill: "#955733"
  })), _path2667 || (_path2667 = /*#__PURE__*/React.createElement("path", {
    d: "M24 42v1h-1v-1z",
    fill: "#945832"
  })), _path2668 || (_path2668 = /*#__PURE__*/React.createElement("path", {
    d: "M24 43v-1h1v1z",
    fill: "#955930"
  })), _path2669 || (_path2669 = /*#__PURE__*/React.createElement("path", {
    d: "M25 43v-1h1v1z",
    fill: "#965a37"
  })), _path2670 || (_path2670 = /*#__PURE__*/React.createElement("path", {
    d: "M26 43v-1h1v1z",
    fill: "#985a3a"
  })), _path2671 || (_path2671 = /*#__PURE__*/React.createElement("path", {
    d: "M27 42h1v1h-1z",
    fill: "#9b603d"
  })), _path2672 || (_path2672 = /*#__PURE__*/React.createElement("path", {
    d: "M29 42v1h-1v-1z",
    fill: "#9f6547"
  })), _path2673 || (_path2673 = /*#__PURE__*/React.createElement("path", {
    d: "M29 43v-1h1v1z",
    fill: "#a16a4f"
  })), _path2674 || (_path2674 = /*#__PURE__*/React.createElement("path", {
    d: "M30 42h1v1h-1z",
    fill: "#a77461"
  })), _path2675 || (_path2675 = /*#__PURE__*/React.createElement("path", {
    d: "M31 43v-1h1v1z",
    fill: "#ad8073"
  })), _path2676 || (_path2676 = /*#__PURE__*/React.createElement("path", {
    d: "M32 42h1v1h-1z",
    fill: "#b58b82"
  })), _path2677 || (_path2677 = /*#__PURE__*/React.createElement("path", {
    d: "M34 42v1h-1v-1z",
    fill: "#be958f"
  })), _path2678 || (_path2678 = /*#__PURE__*/React.createElement("path", {
    d: "M34 42h1v1h-1z",
    fill: "#cba19e"
  })), _path2679 || (_path2679 = /*#__PURE__*/React.createElement("path", {
    d: "M36 42v1h-1v-1z",
    fill: "#c89e9b"
  })), _path2680 || (_path2680 = /*#__PURE__*/React.createElement("path", {
    d: "M36 43v-1h1v1z",
    fill: "#bf948d"
  })), _path2681 || (_path2681 = /*#__PURE__*/React.createElement("path", {
    d: "M38 43h-1v-1h1z",
    fill: "#b48678"
  })), _path2682 || (_path2682 = /*#__PURE__*/React.createElement("path", {
    d: "M38 42h1v1h-1z",
    fill: "#b4887c"
  })), _path2683 || (_path2683 = /*#__PURE__*/React.createElement("path", {
    d: "M40 43h-1v-1h1z",
    fill: "#ad867a"
  })), _path2684 || (_path2684 = /*#__PURE__*/React.createElement("path", {
    d: "M40 42h1v1h-1z",
    fill: "#ab877a"
  })), _path2685 || (_path2685 = /*#__PURE__*/React.createElement("path", {
    d: "M42 43h-1v-1h1z",
    fill: "#a37865"
  })), _path2686 || (_path2686 = /*#__PURE__*/React.createElement("path", {
    d: "M43 42v1h-1v-1z",
    fill: "#6d3f23"
  })), _path2687 || (_path2687 = /*#__PURE__*/React.createElement("path", {
    d: "M43 43v-1h1v1z",
    fill: "#694233",
    fillOpacity: 0.314
  })), _path2688 || (_path2688 = /*#__PURE__*/React.createElement("path", {
    d: "M60 42h1v1h-1z",
    fill: "#815833",
    fillOpacity: 0.667
  })), _path2689 || (_path2689 = /*#__PURE__*/React.createElement("path", {
    d: "M62 43h-1v-1h1z",
    fill: "#8a5826"
  })), _path2690 || (_path2690 = /*#__PURE__*/React.createElement("path", {
    d: "M65 43v-1h1v1z",
    fill: "#855f38",
    fillOpacity: 0.71
  })), _path2691 || (_path2691 = /*#__PURE__*/React.createElement("path", {
    d: "M71 43v-1h1v1z",
    fill: "#825d3f",
    fillOpacity: 0.298
  })), _path2692 || (_path2692 = /*#__PURE__*/React.createElement("path", {
    d: "M72 43v-1h1v1z",
    fill: "#8d5d30"
  })), _path2693 || (_path2693 = /*#__PURE__*/React.createElement("path", {
    d: "M74 43h-1v-1h1z",
    fill: "#955f2d"
  })), _path2694 || (_path2694 = /*#__PURE__*/React.createElement("path", {
    d: "M75 43h-1v-1h1z",
    fill: "#8f5c2a"
  })), _path2695 || (_path2695 = /*#__PURE__*/React.createElement("path", {
    d: "M75 43v-1h1v1z",
    fill: "#865222"
  })), _path2696 || (_path2696 = /*#__PURE__*/React.createElement("path", {
    d: "M77 42v1h-1v-1z",
    fill: "#8c5d2e"
  })), _path2697 || (_path2697 = /*#__PURE__*/React.createElement("path", {
    d: "M77 43v-1h1v1z",
    fill: "#a2784b"
  })), _path2698 || (_path2698 = /*#__PURE__*/React.createElement("path", {
    d: "M79 42v1h-1v-1z",
    fill: "#9a7245"
  })), _path2699 || (_path2699 = /*#__PURE__*/React.createElement("path", {
    d: "M79 43v-1h1v1z",
    fill: "#907750",
    fillOpacity: 0.235
  })), _path2700 || (_path2700 = /*#__PURE__*/React.createElement("path", {
    d: "M89 42h1v1h-1z",
    fill: "#836a62",
    fillOpacity: 0.122
  })), _path2701 || (_path2701 = /*#__PURE__*/React.createElement("path", {
    d: "M90 42h1v1h-1z",
    fill: "#876c5d",
    fillOpacity: 0.267
  })), _path2702 || (_path2702 = /*#__PURE__*/React.createElement("path", {
    d: "M91 42h1v1h-1z",
    fill: "#896c5c",
    fillOpacity: 0.443
  })), _path2703 || (_path2703 = /*#__PURE__*/React.createElement("path", {
    d: "M93 42v1h-1v-1z",
    fill: "#886a55",
    fillOpacity: 0.631
  })), _path2704 || (_path2704 = /*#__PURE__*/React.createElement("path", {
    d: "M93 43v-1h1v1z",
    fill: "#8a674e",
    fillOpacity: 0.737
  })), _path2705 || (_path2705 = /*#__PURE__*/React.createElement("path", {
    d: "M95 43h-1v-1h1z",
    fill: "#885530",
    fillOpacity: 0.914
  })), _path2706 || (_path2706 = /*#__PURE__*/React.createElement("path", {
    d: "M96 43h-1v-1h1z",
    fill: "#8d5123"
  })), _path2707 || (_path2707 = /*#__PURE__*/React.createElement("path", {
    d: "M97 43h-1v-1h1z",
    fill: "#8c562a"
  })), _path2708 || (_path2708 = /*#__PURE__*/React.createElement("path", {
    d: "M97 42h1v1h-1z",
    fill: "#8d6645",
    fillOpacity: 0.729
  })), _path2709 || (_path2709 = /*#__PURE__*/React.createElement("path", {
    d: "M99 43h-1v-1h1z",
    fill: "#8f745b",
    fillOpacity: 0.447
  })), _path2710 || (_path2710 = /*#__PURE__*/React.createElement("path", {
    d: "M99 43v-1h1v1z",
    fill: "#8e785f",
    fillOpacity: 0.357
  })), _path2711 || (_path2711 = /*#__PURE__*/React.createElement("path", {
    d: "M101 42v1h-1v-1z",
    fill: "#8b775e",
    fillOpacity: 0.243
  })), _path2712 || (_path2712 = /*#__PURE__*/React.createElement("path", {
    d: "M101 43v-1h1v1z",
    fill: "#88765d",
    fillOpacity: 0.161
  })), _path2713 || (_path2713 = /*#__PURE__*/React.createElement("path", {
    d: "M102 42h1v1h-1z",
    fill: "#918579",
    fillOpacity: 0.082
  })), _path2714 || (_path2714 = /*#__PURE__*/React.createElement("path", {
    d: "M108 43h-1v-1h1z",
    fill: "#75624e",
    fillOpacity: 0.102
  })), _path2715 || (_path2715 = /*#__PURE__*/React.createElement("path", {
    d: "M109 42v1h-1v-1z",
    fill: "#784d29",
    fillOpacity: 0.941
  })), _path2716 || (_path2716 = /*#__PURE__*/React.createElement("path", {
    d: "M111 42v1h-1v-1z",
    fill: "#603b17"
  })), _path2717 || (_path2717 = /*#__PURE__*/React.createElement("path", {
    d: "M112 43h-1v-1h1z",
    fill: "#634119"
  })), _path2718 || (_path2718 = /*#__PURE__*/React.createElement("path", {
    d: "M113 43h-1v-1h1z",
    fill: "#c4864e"
  })), _path2719 || (_path2719 = /*#__PURE__*/React.createElement("path", {
    d: "M113 42h1v1h-1z",
    fill: "#cf915a"
  })), _path2720 || (_path2720 = /*#__PURE__*/React.createElement("path", {
    d: "M114 42h1v1h-1z",
    fill: "#c6997c",
    fillOpacity: 0.353
  })), _path2721 || (_path2721 = /*#__PURE__*/React.createElement("path", {
    d: "M118 42v1h-1v-1z",
    fill: "#724f35",
    fillOpacity: 0.278
  })), _path2722 || (_path2722 = /*#__PURE__*/React.createElement("path", {
    d: "M119 43h-1v-1h1z",
    fill: "#835127"
  })), _path2723 || (_path2723 = /*#__PURE__*/React.createElement("path", {
    d: "M120 42v1h-1v-1z",
    fill: "#935d31"
  })), _path2724 || (_path2724 = /*#__PURE__*/React.createElement("path", {
    d: "M121 42v1h-1v-1z",
    fill: "#a97554"
  })), _path2725 || (_path2725 = /*#__PURE__*/React.createElement("path", {
    d: "M122 42v1h-1v-1z",
    fill: "#a98366",
    fillOpacity: 0.714
  })), _path2726 || (_path2726 = /*#__PURE__*/React.createElement("path", {
    d: "M6 43v1H5v-1z",
    fill: "#a17b5f",
    fillOpacity: 0.471
  })), _path2727 || (_path2727 = /*#__PURE__*/React.createElement("path", {
    d: "M7 43v1H6v-1z",
    fill: "#b27c53"
  })), _path2728 || (_path2728 = /*#__PURE__*/React.createElement("path", {
    d: "M7 43h1v1H7z",
    fill: "#93633c"
  })), _path2729 || (_path2729 = /*#__PURE__*/React.createElement("path", {
    d: "M9 44v-1h1v1z",
    fill: "#81542f"
  })), _path2730 || (_path2730 = /*#__PURE__*/React.createElement("path", {
    d: "M11 43v1h-1v-1z",
    fill: "#79512c",
    fillOpacity: 0.871
  })), _path2731 || (_path2731 = /*#__PURE__*/React.createElement("path", {
    d: "M12 44h-1v-1h1z",
    fill: "#5c5c45",
    fillOpacity: 0.043
  })), _path2732 || (_path2732 = /*#__PURE__*/React.createElement("path", {
    d: "M16 44v-1h1v1z",
    fill: "#885d4c",
    fillOpacity: 0.118
  })), _path2733 || (_path2733 = /*#__PURE__*/React.createElement("path", {
    d: "M18 43v1h-1v-1z",
    fill: "#88604b",
    fillOpacity: 0.278
  })), _path2734 || (_path2734 = /*#__PURE__*/React.createElement("path", {
    d: "M19 44h-1v-1h1z",
    fill: "#855a3e",
    fillOpacity: 0.463
  })), _path2735 || (_path2735 = /*#__PURE__*/React.createElement("path", {
    d: "M20 44h-1v-1h1z",
    fill: "#8c593a",
    fillOpacity: 0.635
  })), _path2736 || (_path2736 = /*#__PURE__*/React.createElement("path", {
    d: "M21 44h-1v-1h1z",
    fill: "#915d3d",
    fillOpacity: 0.784
  })), _path2737 || (_path2737 = /*#__PURE__*/React.createElement("path", {
    d: "M21 44v-1h1v1z",
    fill: "#965a35",
    fillOpacity: 0.976
  })), _path2738 || (_path2738 = /*#__PURE__*/React.createElement("path", {
    d: "M23 43v1h-1v-1z",
    fill: "#995731"
  })), _path2739 || (_path2739 = /*#__PURE__*/React.createElement("path", {
    d: "M24 44h-1v-1h1z",
    fill: "#935530"
  })), _path2740 || (_path2740 = /*#__PURE__*/React.createElement("path", {
    d: "M25 44h-1v-1h1z",
    fill: "#95572e"
  })), _path2741 || (_path2741 = /*#__PURE__*/React.createElement("path", {
    d: "M26 44h-1v-1h1z",
    fill: "#955a35"
  })), _path2742 || (_path2742 = /*#__PURE__*/React.createElement("path", {
    d: "M27 44h-1v-1h1z",
    fill: "#995b39"
  })), _path2743 || (_path2743 = /*#__PURE__*/React.createElement("path", {
    d: "M27 44v-1h1v1z",
    fill: "#995e3c"
  })), _path2744 || (_path2744 = /*#__PURE__*/React.createElement("path", {
    d: "M28 44v-1h1v1z",
    fill: "#9b6144"
  })), _path2745 || (_path2745 = /*#__PURE__*/React.createElement("path", {
    d: "M30 44h-1v-1h1z",
    fill: "#9f664b"
  })), _path2746 || (_path2746 = /*#__PURE__*/React.createElement("path", {
    d: "M30 44v-1h1v1z",
    fill: "#a46f58"
  })), _path2747 || (_path2747 = /*#__PURE__*/React.createElement("path", {
    d: "M31 43h1v1h-1z",
    fill: "#ae7e6e"
  })), _path2748 || (_path2748 = /*#__PURE__*/React.createElement("path", {
    d: "M32 44v-1h1v1z",
    fill: "#bc9086"
  })), _path2749 || (_path2749 = /*#__PURE__*/React.createElement("path", {
    d: "M33 44v-1h1v1z",
    fill: "#c29a97"
  })), _path2750 || (_path2750 = /*#__PURE__*/React.createElement("path", {
    d: "M35 43v1h-1v-1z",
    fill: "#c89fa4"
  })), _path2751 || (_path2751 = /*#__PURE__*/React.createElement("path", {
    d: "M36 44h-1v-1h1z",
    fill: "#cba5a9"
  })), _path2752 || (_path2752 = /*#__PURE__*/React.createElement("path", {
    d: "M37 44h-1v-1h1z",
    fill: "#cda9a9"
  })), _path2753 || (_path2753 = /*#__PURE__*/React.createElement("path", {
    d: "M38 43v1h-1v-1z",
    fill: "#caa7a5"
  })), _path2754 || (_path2754 = /*#__PURE__*/React.createElement("path", {
    d: "M38 44v-1h1v1z",
    fill: "#b8948d"
  })), _path2755 || (_path2755 = /*#__PURE__*/React.createElement("path", {
    d: "M40 43v1h-1v-1z",
    fill: "#ae867a"
  })), _path2756 || (_path2756 = /*#__PURE__*/React.createElement("path", {
    d: "M41 43v1h-1v-1z",
    fill: "#b38a7d"
  })), _path2757 || (_path2757 = /*#__PURE__*/React.createElement("path", {
    d: "M42 43v1h-1v-1z",
    fill: "#a57967"
  })), _path2758 || (_path2758 = /*#__PURE__*/React.createElement("path", {
    d: "M42 43h1v1h-1z",
    fill: "#704127"
  })), _path2759 || (_path2759 = /*#__PURE__*/React.createElement("path", {
    d: "M43 43h1v1h-1z",
    fill: "#6a4135",
    fillOpacity: 0.337
  })), _path2760 || (_path2760 = /*#__PURE__*/React.createElement("path", {
    d: "M60 43h1v1h-1z",
    fill: "#855b35",
    fillOpacity: 0.635
  })), _path2761 || (_path2761 = /*#__PURE__*/React.createElement("path", {
    d: "M62 43v1h-1v-1z",
    fill: "#8d5b29"
  })), _path2762 || (_path2762 = /*#__PURE__*/React.createElement("path", {
    d: "M62 43h1v1h-1z",
    fill: "#8c5c2d"
  })), _path2763 || (_path2763 = /*#__PURE__*/React.createElement("path", {
    d: "M63 43h1v1h-1z",
    fill: "#95643a"
  })), _path2764 || (_path2764 = /*#__PURE__*/React.createElement("path", {
    d: "M65 44h-1v-1h1z",
    fill: "#97663b"
  })), _path2765 || (_path2765 = /*#__PURE__*/React.createElement("path", {
    d: "M66 43v1h-1v-1z",
    fill: "#875f3a",
    fillOpacity: 0.702
  })), _path2766 || (_path2766 = /*#__PURE__*/React.createElement("path", {
    d: "M71 43h1v1h-1z",
    fill: "#886041",
    fillOpacity: 0.227
  })), _path2767 || (_path2767 = /*#__PURE__*/React.createElement("path", {
    d: "M73 43v1h-1v-1z",
    fill: "#8e5f30"
  })), _path2768 || (_path2768 = /*#__PURE__*/React.createElement("path", {
    d: "M73 44v-1h1v1z",
    fill: "#986530"
  })), _path2769 || (_path2769 = /*#__PURE__*/React.createElement("path", {
    d: "M74 44v-1h1v1z",
    fill: "#935f2d"
  })), _path2770 || (_path2770 = /*#__PURE__*/React.createElement("path", {
    d: "M76 43v1h-1v-1z",
    fill: "#895523"
  })), _path2771 || (_path2771 = /*#__PURE__*/React.createElement("path", {
    d: "M77 44h-1v-1h1z",
    fill: "#916333"
  })), _path2772 || (_path2772 = /*#__PURE__*/React.createElement("path", {
    d: "M78 44h-1v-1h1z",
    fill: "#a67c4f"
  })), _path2773 || (_path2773 = /*#__PURE__*/React.createElement("path", {
    d: "M78 44v-1h1v1z",
    fill: "#9f794e"
  })), _path2774 || (_path2774 = /*#__PURE__*/React.createElement("path", {
    d: "M80 44h-1v-1h1z",
    fill: "#927d60",
    fillOpacity: 0.239
  })), _path2775 || (_path2775 = /*#__PURE__*/React.createElement("path", {
    d: "M85 44h-1v-1h1z",
    fill: "#88766d",
    fillOpacity: 0.11
  })), _path2776 || (_path2776 = /*#__PURE__*/React.createElement("path", {
    d: "M86 43v1h-1v-1z",
    fill: "#90756a",
    fillOpacity: 0.263
  })), _path2777 || (_path2777 = /*#__PURE__*/React.createElement("path", {
    d: "M86 43h1v1h-1z",
    fill: "#896e5a",
    fillOpacity: 0.443
  })), _path2778 || (_path2778 = /*#__PURE__*/React.createElement("path", {
    d: "M87 43h1v1h-1z",
    fill: "#8f735d",
    fillOpacity: 0.639
  })), _path2779 || (_path2779 = /*#__PURE__*/React.createElement("path", {
    d: "M89 44h-1v-1h1z",
    fill: "#90715a",
    fillOpacity: 0.808
  })), _path2780 || (_path2780 = /*#__PURE__*/React.createElement("path", {
    d: "M89 43h1v1h-1z",
    fill: "#906e55",
    fillOpacity: 0.937
  })), _path2781 || (_path2781 = /*#__PURE__*/React.createElement("path", {
    d: "M90 44v-1h1v1z",
    fill: "#966e51"
  })), _path2782 || (_path2782 = /*#__PURE__*/React.createElement("path", {
    d: "M91 44v-1h1v1z",
    fill: "#9b7255"
  })), _path2783 || (_path2783 = /*#__PURE__*/React.createElement("path", {
    d: "M92 43h1v1h-1z",
    fill: "#9c7253"
  })), _path2784 || (_path2784 = /*#__PURE__*/React.createElement("path", {
    d: "M94 43v1h-1v-1z",
    fill: "#996b49"
  })), _path2785 || (_path2785 = /*#__PURE__*/React.createElement("path", {
    d: "M95 43v1h-1v-1z",
    fill: "#90582a"
  })), _path2786 || (_path2786 = /*#__PURE__*/React.createElement("path", {
    d: "M96 43v1h-1v-1z",
    fill: "#8d5321"
  })), _path2787 || (_path2787 = /*#__PURE__*/React.createElement("path", {
    d: "M96 43h1v1h-1z",
    fill: "#8c5727"
  })), _path2788 || (_path2788 = /*#__PURE__*/React.createElement("path", {
    d: "M98 43v1h-1v-1z",
    fill: "#94683f"
  })), _path2789 || (_path2789 = /*#__PURE__*/React.createElement("path", {
    d: "M99 43v1h-1v-1z",
    fill: "#9c7251"
  })), _path2790 || (_path2790 = /*#__PURE__*/React.createElement("path", {
    d: "M100 44v-1h1v1z",
    fill: "#977357"
  })), _path2791 || (_path2791 = /*#__PURE__*/React.createElement("path", {
    d: "M101 43h1v1h-1z",
    fill: "#947459",
    fillOpacity: 0.965
  })), _path2792 || (_path2792 = /*#__PURE__*/React.createElement("path", {
    d: "M102 44v-1h1v1z",
    fill: "#907259",
    fillOpacity: 0.906
  })), _path2793 || (_path2793 = /*#__PURE__*/React.createElement("path", {
    d: "M103 44v-1h1v1z",
    fill: "#8e7259",
    fillOpacity: 0.812
  })), _path2794 || (_path2794 = /*#__PURE__*/React.createElement("path", {
    d: "M105 44h-1v-1h1z",
    fill: "#8f735c",
    fillOpacity: 0.71
  })), _path2795 || (_path2795 = /*#__PURE__*/React.createElement("path", {
    d: "M105 43h1v1h-1z",
    fill: "#8c705b",
    fillOpacity: 0.576
  })), _path2796 || (_path2796 = /*#__PURE__*/React.createElement("path", {
    d: "M106 43h1v1h-1z",
    fill: "#846956",
    fillOpacity: 0.416
  })), _path2797 || (_path2797 = /*#__PURE__*/React.createElement("path", {
    d: "M107 44v-1h1v1z",
    fill: "#806750",
    fillOpacity: 0.396
  })), _path2798 || (_path2798 = /*#__PURE__*/React.createElement("path", {
    d: "M109 44h-1v-1h1z",
    fill: "#794b25",
    fillOpacity: 0.961
  })), _path2799 || (_path2799 = /*#__PURE__*/React.createElement("path", {
    d: "M110 44h-1v-1h1z",
    fill: "#74481f"
  })), _path2800 || (_path2800 = /*#__PURE__*/React.createElement("path", {
    d: "M111 44h-1v-1h1z",
    fill: "#5e3a16"
  })), _path2801 || (_path2801 = /*#__PURE__*/React.createElement("path", {
    d: "M111 43h1v1h-1z",
    fill: "#68451b"
  })), _path2802 || (_path2802 = /*#__PURE__*/React.createElement("path", {
    d: "M112 44v-1h1v1z",
    fill: "#c98a51"
  })), _path2803 || (_path2803 = /*#__PURE__*/React.createElement("path", {
    d: "M113 44v-1h1v1z",
    fill: "#d29861"
  })), _path2804 || (_path2804 = /*#__PURE__*/React.createElement("path", {
    d: "M115 44h-1v-1h1z",
    fill: "#cfaa88",
    fillOpacity: 0.294
  })), _path2805 || (_path2805 = /*#__PURE__*/React.createElement("path", {
    d: "M117 44v-1h1v1z",
    fill: "#78523c",
    fillOpacity: 0.365
  })), _path2806 || (_path2806 = /*#__PURE__*/React.createElement("path", {
    d: "M119 43v1h-1v-1z",
    fill: "#855227"
  })), _path2807 || (_path2807 = /*#__PURE__*/React.createElement("path", {
    d: "M119 43h1v1h-1z",
    fill: "#965f36"
  })), _path2808 || (_path2808 = /*#__PURE__*/React.createElement("path", {
    d: "M120 44v-1h1v1z",
    fill: "#ac785b"
  })), _path2809 || (_path2809 = /*#__PURE__*/React.createElement("path", {
    d: "M121 44v-1h1v1z",
    fill: "#a87f64",
    fillOpacity: 0.635
  })), _path2810 || (_path2810 = /*#__PURE__*/React.createElement("path", {
    d: "M5 45v-1h1v1z",
    fill: "#9f735b",
    fillOpacity: 0.294
  })), _path2811 || (_path2811 = /*#__PURE__*/React.createElement("path", {
    d: "M7 44v1H6v-1z",
    fill: "#af7955"
  })), _path2812 || (_path2812 = /*#__PURE__*/React.createElement("path", {
    d: "M7 44h1v1H7z",
    fill: "#996a43"
  })), _path2813 || (_path2813 = /*#__PURE__*/React.createElement("path", {
    d: "M9 44v1H8v-1z",
    fill: "#885b34"
  })), _path2814 || (_path2814 = /*#__PURE__*/React.createElement("path", {
    d: "M10 44v1H9v-1z",
    fill: "#83542e"
  })), _path2815 || (_path2815 = /*#__PURE__*/React.createElement("path", {
    d: "M11 44v1h-1v-1z",
    fill: "#7e502b",
    fillOpacity: 0.961
  })), _path2816 || (_path2816 = /*#__PURE__*/React.createElement("path", {
    d: "M11 45v-1h1v1z",
    fill: "#765d44",
    fillOpacity: 0.161
  })), _path2817 || (_path2817 = /*#__PURE__*/React.createElement("path", {
    d: "M20 44h1v1h-1z",
    fill: "#7f9f9f",
    fillOpacity: 0.031
  })), _path2818 || (_path2818 = /*#__PURE__*/React.createElement("path", {
    d: "M22 44v1h-1v-1z",
    fill: "#8d603d",
    fillOpacity: 0.827
  })), _path2819 || (_path2819 = /*#__PURE__*/React.createElement("path", {
    d: "M23 45h-1v-1h1z",
    fill: "#a2673a"
  })), _path2820 || (_path2820 = /*#__PURE__*/React.createElement("path", {
    d: "M23 44h1v1h-1z",
    fill: "#9b673e"
  })), _path2821 || (_path2821 = /*#__PURE__*/React.createElement("path", {
    d: "M25 45h-1v-1h1z",
    fill: "#8e592e"
  })), _path2822 || (_path2822 = /*#__PURE__*/React.createElement("path", {
    d: "M26 44v1h-1v-1z",
    fill: "#864e28"
  })), _path2823 || (_path2823 = /*#__PURE__*/React.createElement("path", {
    d: "M27 45h-1v-1h1z",
    fill: "#915533"
  })), _path2824 || (_path2824 = /*#__PURE__*/React.createElement("path", {
    d: "M27 45v-1h1v1z",
    fill: "#8c5636",
    fillOpacity: 0.973
  })), _path2825 || (_path2825 = /*#__PURE__*/React.createElement("path", {
    d: "M29 45h-1v-1h1z",
    fill: "#8c5a43",
    fillOpacity: 0.788
  })), _path2826 || (_path2826 = /*#__PURE__*/React.createElement("path", {
    d: "M30 45h-1v-1h1z",
    fill: "#92624c",
    fillOpacity: 0.835
  })), _path2827 || (_path2827 = /*#__PURE__*/React.createElement("path", {
    d: "M30 44h1v1h-1z",
    fill: "#986b54",
    fillOpacity: 0.878
  })), _path2828 || (_path2828 = /*#__PURE__*/React.createElement("path", {
    d: "M32 44v1h-1v-1z",
    fill: "#9f7160",
    fillOpacity: 0.914
  })), _path2829 || (_path2829 = /*#__PURE__*/React.createElement("path", {
    d: "M32 45v-1h1v1z",
    fill: "#a77a6e",
    fillOpacity: 0.945
  })), _path2830 || (_path2830 = /*#__PURE__*/React.createElement("path", {
    d: "M34 44v1h-1v-1z",
    fill: "#b48881",
    fillOpacity: 0.965
  })), _path2831 || (_path2831 = /*#__PURE__*/React.createElement("path", {
    d: "M34 45v-1h1v1z",
    fill: "#bc938d",
    fillOpacity: 0.98
  })), _path2832 || (_path2832 = /*#__PURE__*/React.createElement("path", {
    d: "M35 44h1v1h-1z",
    fill: "#c19a95",
    fillOpacity: 0.992
  })), _path2833 || (_path2833 = /*#__PURE__*/React.createElement("path", {
    d: "M37 45h-1v-1h1z",
    fill: "#c39d9b"
  })), _path2834 || (_path2834 = /*#__PURE__*/React.createElement("path", {
    d: "M37 45v-1h1v1z",
    fill: "#c49f9d"
  })), _path2835 || (_path2835 = /*#__PURE__*/React.createElement("path", {
    d: "M38 44h1v1h-1z",
    fill: "#bb948d"
  })), _path2836 || (_path2836 = /*#__PURE__*/React.createElement("path", {
    d: "M40 45h-1v-1h1z",
    fill: "#ad8478"
  })), _path2837 || (_path2837 = /*#__PURE__*/React.createElement("path", {
    d: "M41 44v1h-1v-1z",
    fill: "#b48b80"
  })), _path2838 || (_path2838 = /*#__PURE__*/React.createElement("path", {
    d: "M42 45h-1v-1h1z",
    fill: "#ac8171"
  })), _path2839 || (_path2839 = /*#__PURE__*/React.createElement("path", {
    d: "M42 45v-1h1v1z",
    fill: "#74442b"
  })), _path2840 || (_path2840 = /*#__PURE__*/React.createElement("path", {
    d: "M43 45v-1h1v1z",
    fill: "#664234",
    fillOpacity: 0.361
  })), _path2841 || (_path2841 = /*#__PURE__*/React.createElement("path", {
    d: "M61 45h-1v-1h1z",
    fill: "#895e3a",
    fillOpacity: 0.612
  })), _path2842 || (_path2842 = /*#__PURE__*/React.createElement("path", {
    d: "M61 44h1v1h-1z",
    fill: "#905e2c"
  })), _path2843 || (_path2843 = /*#__PURE__*/React.createElement("path", {
    d: "M63 45h-1v-1h1z",
    fill: "#8d5d2e"
  })), _path2844 || (_path2844 = /*#__PURE__*/React.createElement("path", {
    d: "M64 45h-1v-1h1z",
    fill: "#94633a"
  })), _path2845 || (_path2845 = /*#__PURE__*/React.createElement("path", {
    d: "M66 44v1h-1v-1z",
    fill: "#8e6442",
    fillOpacity: 0.667
  })), _path2846 || (_path2846 = /*#__PURE__*/React.createElement("path", {
    d: "M72 44v1h-1v-1z",
    fill: "#8c6648",
    fillOpacity: 0.235
  })), _path2847 || (_path2847 = /*#__PURE__*/React.createElement("path", {
    d: "M73 44h1v1h-1z",
    fill: "#966330"
  })), _path2848 || (_path2848 = /*#__PURE__*/React.createElement("path", {
    d: "M75 45h-1v-1h1z",
    fill: "#966230"
  })), _path2849 || (_path2849 = /*#__PURE__*/React.createElement("path", {
    d: "M76 45h-1v-1h1z",
    fill: "#8d5a28"
  })), _path2850 || (_path2850 = /*#__PURE__*/React.createElement("path", {
    d: "M76 44h1v1h-1z",
    fill: "#97693b"
  })), _path2851 || (_path2851 = /*#__PURE__*/React.createElement("path", {
    d: "M77 45v-1h1v1z",
    fill: "#a67c52"
  })), _path2852 || (_path2852 = /*#__PURE__*/React.createElement("path", {
    d: "M78 45v-1h1v1z",
    fill: "#a17b51",
    fillOpacity: 0.996
  })), _path2853 || (_path2853 = /*#__PURE__*/React.createElement("path", {
    d: "M80 44v1h-1v-1z",
    fill: "#94765b",
    fillOpacity: 0.337
  })), _path2854 || (_path2854 = /*#__PURE__*/React.createElement("path", {
    d: "M81 45h-1v-1h1z",
    fill: "#7d6559",
    fillOpacity: 0.247
  })), _path2855 || (_path2855 = /*#__PURE__*/React.createElement("path", {
    d: "M82 44v1h-1v-1z",
    fill: "#866f5f",
    fillOpacity: 0.431
  })), _path2856 || (_path2856 = /*#__PURE__*/React.createElement("path", {
    d: "M82 45v-1h1v1z",
    fill: "#8d6e5b",
    fillOpacity: 0.624
  })), _path2857 || (_path2857 = /*#__PURE__*/React.createElement("path", {
    d: "M83 44h1v1h-1z",
    fill: "#8d6e59",
    fillOpacity: 0.804
  })), _path2858 || (_path2858 = /*#__PURE__*/React.createElement("path", {
    d: "M85 44v1h-1v-1z",
    fill: "#8f7058",
    fillOpacity: 0.925
  })), _path2859 || (_path2859 = /*#__PURE__*/React.createElement("path", {
    d: "M86 45h-1v-1h1z",
    fill: "#937158"
  })), _path2860 || (_path2860 = /*#__PURE__*/React.createElement("path", {
    d: "M87 45h-1v-1h1z",
    fill: "#9a775a"
  })), _path2861 || (_path2861 = /*#__PURE__*/React.createElement("path", {
    d: "M88 44v1h-1v-1z",
    fill: "#9d785a"
  })), _path2862 || (_path2862 = /*#__PURE__*/React.createElement("path", {
    d: "M88 44h1v1h-1z",
    fill: "#9b7557"
  })), _path2863 || (_path2863 = /*#__PURE__*/React.createElement("path", {
    d: "M90 44h1v1h-1z",
    fill: "#9b7253"
  })), _path2864 || (_path2864 = /*#__PURE__*/React.createElement("path", {
    d: "M92 45h-1v-1h1z",
    fill: "#987255"
  })), _path2865 || (_path2865 = /*#__PURE__*/React.createElement("path", {
    d: "M93 45h-1v-1h1z",
    fill: "#987051"
  })), _path2866 || (_path2866 = /*#__PURE__*/React.createElement("path", {
    d: "M95 44v1h-1v-1z",
    fill: "#945d2e"
  })), _path2867 || (_path2867 = /*#__PURE__*/React.createElement("path", {
    d: "M95 44h1v1h-1z",
    fill: "#955d28"
  })), _path2868 || (_path2868 = /*#__PURE__*/React.createElement("path", {
    d: "M98 45h-1v-1h1z",
    fill: "#986c47"
  })), _path2869 || (_path2869 = /*#__PURE__*/React.createElement("path", {
    d: "M98 44h1v1h-1z",
    fill: "#9b7152"
  })), _path2870 || (_path2870 = /*#__PURE__*/React.createElement("path", {
    d: "M100 44v1h-1v-1z",
    fill: "#9b6f52"
  })), _path2871 || (_path2871 = /*#__PURE__*/React.createElement("path", {
    d: "M101 45h-1v-1h1z",
    fill: "#996e52"
  })), _path2872 || (_path2872 = /*#__PURE__*/React.createElement("path", {
    d: "M102 45h-1v-1h1z",
    fill: "#986d51"
  })), _path2873 || (_path2873 = /*#__PURE__*/React.createElement("path", {
    d: "M103 45h-1v-1h1z",
    fill: "#956d4f"
  })), _path2874 || (_path2874 = /*#__PURE__*/React.createElement("path", {
    d: "M104 44v1h-1v-1z",
    fill: "#936d4f"
  })), _path2875 || (_path2875 = /*#__PURE__*/React.createElement("path", {
    d: "M106 45v-1h1v1z",
    fill: "#967051"
  })), _path2876 || (_path2876 = /*#__PURE__*/React.createElement("path", {
    d: "M107 45v-1h1v1z",
    fill: "#8c6847"
  })), _path2877 || (_path2877 = /*#__PURE__*/React.createElement("path", {
    d: "M108 44h1v1h-1z",
    fill: "#7f4c20"
  })), _path2878 || (_path2878 = /*#__PURE__*/React.createElement("path", {
    d: "M109 45v-1h1v1z",
    fill: "#71451c"
  })), _path2879 || (_path2879 = /*#__PURE__*/React.createElement("path", {
    d: "M111 44v1h-1v-1z",
    fill: "#5b3815"
  })), _path2880 || (_path2880 = /*#__PURE__*/React.createElement("path", {
    d: "M112 44v1h-1v-1z",
    fill: "#6a461e"
  })), _path2881 || (_path2881 = /*#__PURE__*/React.createElement("path", {
    d: "M112 45v-1h1v1z",
    fill: "#cf9058"
  })), _path2882 || (_path2882 = /*#__PURE__*/React.createElement("path", {
    d: "M113 44h1v1h-1z",
    fill: "#d39b63"
  })), _path2883 || (_path2883 = /*#__PURE__*/React.createElement("path", {
    d: "M114 45v-1h1v1z",
    fill: "#bd9a79",
    fillOpacity: 0.337
  })), _path2884 || (_path2884 = /*#__PURE__*/React.createElement("path", {
    d: "M118 45h-1v-1h1z",
    fill: "#754c39",
    fillOpacity: 0.416
  })), _path2885 || (_path2885 = /*#__PURE__*/React.createElement("path", {
    d: "M119 44v1h-1v-1z",
    fill: "#865126"
  })), _path2886 || (_path2886 = /*#__PURE__*/React.createElement("path", {
    d: "M119 45v-1h1v1z",
    fill: "#98623a"
  })), _path2887 || (_path2887 = /*#__PURE__*/React.createElement("path", {
    d: "M121 44v1h-1v-1z",
    fill: "#af7b60"
  })), _path2888 || (_path2888 = /*#__PURE__*/React.createElement("path", {
    d: "M121 45v-1h1v1z",
    fill: "#a77f64",
    fillOpacity: 0.525
  })), _path2889 || (_path2889 = /*#__PURE__*/React.createElement("path", {
    d: "M5 46v-1h1v1z",
    fill: "#99725f",
    fillOpacity: 0.157
  })), _path2890 || (_path2890 = /*#__PURE__*/React.createElement("path", {
    d: "M7 45v1H6v-1z",
    fill: "#aa7551",
    fillOpacity: 0.965
  })), _path2891 || (_path2891 = /*#__PURE__*/React.createElement("path", {
    d: "M7 46v-1h1v1z",
    fill: "#9e7049"
  })), _path2892 || (_path2892 = /*#__PURE__*/React.createElement("path", {
    d: "M9 46H8v-1h1z",
    fill: "#895c36"
  })), _path2893 || (_path2893 = /*#__PURE__*/React.createElement("path", {
    d: "M9 45h1v1H9z",
    fill: "#84532e"
  })), _path2894 || (_path2894 = /*#__PURE__*/React.createElement("path", {
    d: "M10 46v-1h1v1z",
    fill: "#81522f"
  })), _path2895 || (_path2895 = /*#__PURE__*/React.createElement("path", {
    d: "M12 45v1h-1v-1z",
    fill: "#785537",
    fillOpacity: 0.306
  })), _path2896 || (_path2896 = /*#__PURE__*/React.createElement("path", {
    d: "M20 45h1v1h-1z",
    fill: "#0ff",
    fillOpacity: 0.008
  })), _path2897 || (_path2897 = /*#__PURE__*/React.createElement("path", {
    d: "M21 46v-1h1v1z",
    fill: "#885c30",
    fillOpacity: 0.8
  })), _path2898 || (_path2898 = /*#__PURE__*/React.createElement("path", {
    d: "M22 46v-1h1v1z",
    fill: "#a06b37"
  })), _path2899 || (_path2899 = /*#__PURE__*/React.createElement("path", {
    d: "M24 45v1h-1v-1z",
    fill: "#a07141"
  })), _path2900 || (_path2900 = /*#__PURE__*/React.createElement("path", {
    d: "M25 46h-1v-1h1z",
    fill: "#865a2d"
  })), _path2901 || (_path2901 = /*#__PURE__*/React.createElement("path", {
    d: "M25 45h1v1h-1z",
    fill: "#713e17"
  })), _path2902 || (_path2902 = /*#__PURE__*/React.createElement("path", {
    d: "M27 46h-1v-1h1z",
    fill: "#7c4321"
  })), _path2903 || (_path2903 = /*#__PURE__*/React.createElement("path", {
    d: "M28 46h-1v-1h1z",
    fill: "#6c3c1a",
    fillOpacity: 0.894
  })), _path2904 || (_path2904 = /*#__PURE__*/React.createElement("path", {
    d: "M28 46v-1h1v1z",
    fill: "#6b5d50",
    fillOpacity: 0.075
  })), _path2905 || (_path2905 = /*#__PURE__*/React.createElement("path", {
    d: "M29 45h1v1h-1z",
    fill: "#7f5f5f",
    fillOpacity: 0.031
  })), _path2906 || (_path2906 = /*#__PURE__*/React.createElement("path", {
    d: "M31 45v1h-1v-1z",
    fill: "#754",
    fillOpacity: 0.059
  })), _path2907 || (_path2907 = /*#__PURE__*/React.createElement("path", {
    d: "M31 46v-1h1v1z",
    fill: "#6a4a3f",
    fillOpacity: 0.094
  })), _path2908 || (_path2908 = /*#__PURE__*/React.createElement("path", {
    d: "M33 45v1h-1v-1z",
    fill: "#745750",
    fillOpacity: 0.137
  })), _path2909 || (_path2909 = /*#__PURE__*/React.createElement("path", {
    d: "M34 45v1h-1v-1z",
    fill: "#76534d",
    fillOpacity: 0.169
  })), _path2910 || (_path2910 = /*#__PURE__*/React.createElement("path", {
    d: "M34 45h1v1h-1z",
    fill: "#7c5d53",
    fillOpacity: 0.192
  })), _path2911 || (_path2911 = /*#__PURE__*/React.createElement("path", {
    d: "M36 45v1h-1v-1z",
    fill: "#886960",
    fillOpacity: 0.227
  })), _path2912 || (_path2912 = /*#__PURE__*/React.createElement("path", {
    d: "M36 46v-1h1v1z",
    fill: "#7f5f5c",
    fillOpacity: 0.282
  })), _path2913 || (_path2913 = /*#__PURE__*/React.createElement("path", {
    d: "M38 45v1h-1v-1z",
    fill: "#7f615a",
    fillOpacity: 0.298
  })), _path2914 || (_path2914 = /*#__PURE__*/React.createElement("path", {
    d: "M39 46h-1v-1h1z",
    fill: "#aa8c82",
    fillOpacity: 0.635
  })), _path2915 || (_path2915 = /*#__PURE__*/React.createElement("path", {
    d: "M40 46h-1v-1h1z",
    fill: "#b58d81"
  })), _path2916 || (_path2916 = /*#__PURE__*/React.createElement("path", {
    d: "M41 46h-1v-1h1z",
    fill: "#b18a80"
  })), _path2917 || (_path2917 = /*#__PURE__*/React.createElement("path", {
    d: "M43 45v1h-1v-1z",
    fill: "#75462b"
  })), _path2918 || (_path2918 = /*#__PURE__*/React.createElement("path", {
    d: "M44 45v1h-1v-1z",
    fill: "#67422d",
    fillOpacity: 0.376
  })), _path2919 || (_path2919 = /*#__PURE__*/React.createElement("path", {
    d: "M61 46h-1v-1h1z",
    fill: "#8a6040",
    fillOpacity: 0.592
  })), _path2920 || (_path2920 = /*#__PURE__*/React.createElement("path", {
    d: "M61 45h1v1h-1z",
    fill: "#935f2e"
  })), _path2921 || (_path2921 = /*#__PURE__*/React.createElement("path", {
    d: "M62 46v-1h1v1z",
    fill: "#905f2e"
  })), _path2922 || (_path2922 = /*#__PURE__*/React.createElement("path", {
    d: "M64 46v-1h1v1z",
    fill: "#9e6c41"
  })), _path2923 || (_path2923 = /*#__PURE__*/React.createElement("path", {
    d: "M66 46h-1v-1h1z",
    fill: "#916847",
    fillOpacity: 0.631
  })), _path2924 || (_path2924 = /*#__PURE__*/React.createElement("path", {
    d: "M72 45v1h-1v-1z",
    fill: "#906a48",
    fillOpacity: 0.235
  })), _path2925 || (_path2925 = /*#__PURE__*/React.createElement("path", {
    d: "M72 45h1v1h-1z",
    fill: "#916235"
  })), _path2926 || (_path2926 = /*#__PURE__*/React.createElement("path", {
    d: "M73 45h1v1h-1z",
    fill: "#996333"
  })), _path2927 || (_path2927 = /*#__PURE__*/React.createElement("path", {
    d: "M75 45v1h-1v-1z",
    fill: "#996432"
  })), _path2928 || (_path2928 = /*#__PURE__*/React.createElement("path", {
    d: "M75 46v-1h1v1z",
    fill: "#915e2c"
  })), _path2929 || (_path2929 = /*#__PURE__*/React.createElement("path", {
    d: "M76 46v-1h1v1z",
    fill: "#956837"
  })), _path2930 || (_path2930 = /*#__PURE__*/React.createElement("path", {
    d: "M78 45v1h-1v-1z",
    fill: "#a77e51"
  })), _path2931 || (_path2931 = /*#__PURE__*/React.createElement("path", {
    d: "M79 45v1h-1v-1z",
    fill: "#9b7041"
  })), _path2932 || (_path2932 = /*#__PURE__*/React.createElement("path", {
    d: "M80 46h-1v-1h1z",
    fill: "#8c6648",
    fillOpacity: 0.957
  })), _path2933 || (_path2933 = /*#__PURE__*/React.createElement("path", {
    d: "M81 45v1h-1v-1z",
    fill: "#876552"
  })), _path2934 || (_path2934 = /*#__PURE__*/React.createElement("path", {
    d: "M81 45h1v1h-1z",
    fill: "#8e6c55"
  })), _path2935 || (_path2935 = /*#__PURE__*/React.createElement("path", {
    d: "M83 45h1v1h-1z",
    fill: "#906c53"
  })), _path2936 || (_path2936 = /*#__PURE__*/React.createElement("path", {
    d: "M84 46v-1h1v1z",
    fill: "#8f6b50"
  })), _path2937 || (_path2937 = /*#__PURE__*/React.createElement("path", {
    d: "M85 46v-1h1v1z",
    fill: "#906d50"
  })), _path2938 || (_path2938 = /*#__PURE__*/React.createElement("path", {
    d: "M86 45h1v1h-1z",
    fill: "#926f51"
  })), _path2939 || (_path2939 = /*#__PURE__*/React.createElement("path", {
    d: "M89 45v1h-1v-1z",
    fill: "#977258"
  })), _path2940 || (_path2940 = /*#__PURE__*/React.createElement("path", {
    d: "M90 46h-1v-1h1z",
    fill: "#9a725b"
  })), _path2941 || (_path2941 = /*#__PURE__*/React.createElement("path", {
    d: "M90 45h1v1h-1z",
    fill: "#9b745b"
  })), _path2942 || (_path2942 = /*#__PURE__*/React.createElement("path", {
    d: "M92 45v1h-1v-1z",
    fill: "#9a755a"
  })), _path2943 || (_path2943 = /*#__PURE__*/React.createElement("path", {
    d: "M92 46v-1h1v1z",
    fill: "#9e755b"
  })), _path2944 || (_path2944 = /*#__PURE__*/React.createElement("path", {
    d: "M93 46v-1h1v1z",
    fill: "#9f6f4d"
  })), _path2945 || (_path2945 = /*#__PURE__*/React.createElement("path", {
    d: "M95 46h-1v-1h1z",
    fill: "#996438"
  })), _path2946 || (_path2946 = /*#__PURE__*/React.createElement("path", {
    d: "M96 46h-1v-1h1z",
    fill: "#986232"
  })), _path2947 || (_path2947 = /*#__PURE__*/React.createElement("path", {
    d: "M96 45h1v1h-1z",
    fill: "#986739"
  })), _path2948 || (_path2948 = /*#__PURE__*/React.createElement("path", {
    d: "M97 45h1v1h-1z",
    fill: "#9a724f"
  })), _path2949 || (_path2949 = /*#__PURE__*/React.createElement("path", {
    d: "M99 45v1h-1v-1z",
    fill: "#9b7658"
  })), _path2950 || (_path2950 = /*#__PURE__*/React.createElement("path", {
    d: "M100 46h-1v-1h1z",
    fill: "#987256"
  })), _path2951 || (_path2951 = /*#__PURE__*/React.createElement("path", {
    d: "M101 45v1h-1v-1z",
    fill: "#967054"
  })), _path2952 || (_path2952 = /*#__PURE__*/React.createElement("path", {
    d: "M102 46h-1v-1h1z",
    fill: "#946d51"
  })), _path2953 || (_path2953 = /*#__PURE__*/React.createElement("path", {
    d: "M103 45v1h-1v-1z",
    fill: "#926b50"
  })), _path2954 || (_path2954 = /*#__PURE__*/React.createElement("path", {
    d: "M104 45v1h-1v-1z",
    fill: "#8f684d"
  })), _path2955 || (_path2955 = /*#__PURE__*/React.createElement("path", {
    d: "M104 45h1v1h-1z",
    fill: "#8f684b"
  })), _path2956 || (_path2956 = /*#__PURE__*/React.createElement("path", {
    d: "M106 45v1h-1v-1z",
    fill: "#8f6849"
  })), _path2957 || (_path2957 = /*#__PURE__*/React.createElement("path", {
    d: "M106 46v-1h1v1z",
    fill: "#906a48"
  })), _path2958 || (_path2958 = /*#__PURE__*/React.createElement("path", {
    d: "M107 46v-1h1v1z",
    fill: "#8b603a"
  })), _path2959 || (_path2959 = /*#__PURE__*/React.createElement("path", {
    d: "M109 46h-1v-1h1z",
    fill: "#804e21"
  })), _path2960 || (_path2960 = /*#__PURE__*/React.createElement("path", {
    d: "M110 45v1h-1v-1z",
    fill: "#74471d"
  })), _path2961 || (_path2961 = /*#__PURE__*/React.createElement("path", {
    d: "M110 45h1v1h-1z",
    fill: "#5f3c1a"
  })), _path2962 || (_path2962 = /*#__PURE__*/React.createElement("path", {
    d: "M111 45h1v1h-1z",
    fill: "#714b21"
  })), _path2963 || (_path2963 = /*#__PURE__*/React.createElement("path", {
    d: "M112 46v-1h1v1z",
    fill: "#d1935c"
  })), _path2964 || (_path2964 = /*#__PURE__*/React.createElement("path", {
    d: "M113 46v-1h1v1z",
    fill: "#ce9660"
  })), _path2965 || (_path2965 = /*#__PURE__*/React.createElement("path", {
    d: "M114 46v-1h1v1z",
    fill: "#9f7558",
    fillOpacity: 0.941
  })), _path2966 || (_path2966 = /*#__PURE__*/React.createElement("path", {
    d: "M116 45v1h-1v-1z",
    fill: "#88674f",
    fillOpacity: 0.827
  })), _path2967 || (_path2967 = /*#__PURE__*/React.createElement("path", {
    d: "M116 45h1v1h-1z",
    fill: "#8e715b",
    fillOpacity: 0.659
  })), _path2968 || (_path2968 = /*#__PURE__*/React.createElement("path", {
    d: "M118 46h-1v-1h1z",
    fill: "#845c39",
    fillOpacity: 0.776
  })), _path2969 || (_path2969 = /*#__PURE__*/React.createElement("path", {
    d: "M119 46h-1v-1h1z",
    fill: "#855223"
  })), _path2970 || (_path2970 = /*#__PURE__*/React.createElement("path", {
    d: "M121 46h-1v-1h1z",
    fill: "#b28060"
  })), _path2971 || (_path2971 = /*#__PURE__*/React.createElement("path", {
    d: "M122 45v1h-1v-1z",
    fill: "#a8856d",
    fillOpacity: 0.427
  })), _path2972 || (_path2972 = /*#__PURE__*/React.createElement("path", {
    d: "M7 46v1H6v-1z",
    fill: "#aa7756",
    fillOpacity: 0.863
  })), _path2973 || (_path2973 = /*#__PURE__*/React.createElement("path", {
    d: "M8 47H7v-1h1z",
    fill: "#a7764f"
  })), _path2974 || (_path2974 = /*#__PURE__*/React.createElement("path", {
    d: "M9 46v1H8v-1z",
    fill: "#8b5c37"
  })), _path2975 || (_path2975 = /*#__PURE__*/React.createElement("path", {
    d: "M10 47H9v-1h1z",
    fill: "#85532e"
  })), _path2976 || (_path2976 = /*#__PURE__*/React.createElement("path", {
    d: "M11 46v1h-1v-1z",
    fill: "#86542e"
  })), _path2977 || (_path2977 = /*#__PURE__*/React.createElement("path", {
    d: "M12 47h-1v-1h1z",
    fill: "#764d30",
    fillOpacity: 0.475
  })), _path2978 || (_path2978 = /*#__PURE__*/React.createElement("path", {
    d: "M22 46v1h-1v-1z",
    fill: "#895b2e",
    fillOpacity: 0.757
  })), _path2979 || (_path2979 = /*#__PURE__*/React.createElement("path", {
    d: "M23 47h-1v-1h1z",
    fill: "#99632d"
  })), _path2980 || (_path2980 = /*#__PURE__*/React.createElement("path", {
    d: "M23 47v-1h1v1z",
    fill: "#986934"
  })), _path2981 || (_path2981 = /*#__PURE__*/React.createElement("path", {
    d: "M25 47h-1v-1h1z",
    fill: "#87592a"
  })), _path2982 || (_path2982 = /*#__PURE__*/React.createElement("path", {
    d: "M26 47h-1v-1h1z",
    fill: "#75421a"
  })), _path2983 || (_path2983 = /*#__PURE__*/React.createElement("path", {
    d: "M27 46v1h-1v-1z",
    fill: "#7f4824"
  })), _path2984 || (_path2984 = /*#__PURE__*/React.createElement("path", {
    d: "M28 47h-1v-1h1z",
    fill: "#704220",
    fillOpacity: 0.906
  })), _path2985 || (_path2985 = /*#__PURE__*/React.createElement("path", {
    d: "M29 47h-1v-1h1z",
    fill: "#6d6155",
    fillOpacity: 0.082
  })), _path2986 || (_path2986 = /*#__PURE__*/React.createElement("path", {
    d: "M38 47v-1h1v1z",
    fill: "#b3a099",
    fillOpacity: 0.412
  })), _path2987 || (_path2987 = /*#__PURE__*/React.createElement("path", {
    d: "M39 47v-1h1v1z",
    fill: "#b68d86"
  })), _path2988 || (_path2988 = /*#__PURE__*/React.createElement("path", {
    d: "M41 47h-1v-1h1z",
    fill: "#b58881"
  })), _path2989 || (_path2989 = /*#__PURE__*/React.createElement("path", {
    d: "M42 47v-1h1v1z",
    fill: "#76482b"
  })), _path2990 || (_path2990 = /*#__PURE__*/React.createElement("path", {
    d: "M44 47h-1v-1h1z",
    fill: "#663f29",
    fillOpacity: 0.412
  })), _path2991 || (_path2991 = /*#__PURE__*/React.createElement("path", {
    d: "M61 46v1h-1v-1z",
    fill: "#8a6144",
    fillOpacity: 0.584
  })), _path2992 || (_path2992 = /*#__PURE__*/React.createElement("path", {
    d: "M62 46v1h-1v-1z",
    fill: "#956030"
  })), _path2993 || (_path2993 = /*#__PURE__*/React.createElement("path", {
    d: "M63 47h-1v-1h1z",
    fill: "#915f2e"
  })), _path2994 || (_path2994 = /*#__PURE__*/React.createElement("path", {
    d: "M63 46h1v1h-1z",
    fill: "#986537"
  })), _path2995 || (_path2995 = /*#__PURE__*/React.createElement("path", {
    d: "M64 46h1v1h-1z",
    fill: "#a06e43"
  })), _path2996 || (_path2996 = /*#__PURE__*/React.createElement("path", {
    d: "M66 46v1h-1v-1z",
    fill: "#926c4b",
    fillOpacity: 0.6
  })), _path2997 || (_path2997 = /*#__PURE__*/React.createElement("path", {
    d: "M71 47v-1h1v1z",
    fill: "#8e6842",
    fillOpacity: 0.239
  })), _path2998 || (_path2998 = /*#__PURE__*/React.createElement("path", {
    d: "M73 46v1h-1v-1z",
    fill: "#936538"
  })), _path2999 || (_path2999 = /*#__PURE__*/React.createElement("path", {
    d: "M73 47v-1h1v1z",
    fill: "#9e6838"
  })), _path3000 || (_path3000 = /*#__PURE__*/React.createElement("path", {
    d: "M74 46h1v1h-1z",
    fill: "#9d6937"
  })), _path3001 || (_path3001 = /*#__PURE__*/React.createElement("path", {
    d: "M76 47h-1v-1h1z",
    fill: "#966331"
  })), _path3002 || (_path3002 = /*#__PURE__*/React.createElement("path", {
    d: "M76 46h1v1h-1z",
    fill: "#946738"
  })), _path3003 || (_path3003 = /*#__PURE__*/React.createElement("path", {
    d: "M78 46v1h-1v-1z",
    fill: "#a87f53"
  })), _path3004 || (_path3004 = /*#__PURE__*/React.createElement("path", {
    d: "M79 47h-1v-1h1z",
    fill: "#98703f"
  })), _path3005 || (_path3005 = /*#__PURE__*/React.createElement("path", {
    d: "M80 47h-1v-1h1z",
    fill: "#896342"
  })), _path3006 || (_path3006 = /*#__PURE__*/React.createElement("path", {
    d: "M81 47h-1v-1h1z",
    fill: "#83604c"
  })), _path3007 || (_path3007 = /*#__PURE__*/React.createElement("path", {
    d: "M81 47v-1h1v1z",
    fill: "#82614c"
  })), _path3008 || (_path3008 = /*#__PURE__*/React.createElement("path", {
    d: "M83 46v1h-1v-1z",
    fill: "#84614b"
  })), _path3009 || (_path3009 = /*#__PURE__*/React.createElement("path", {
    d: "M83 47v-1h1v1z",
    fill: "#85634b"
  })), _path3010 || (_path3010 = /*#__PURE__*/React.createElement("path", {
    d: "M85 46v1h-1v-1z",
    fill: "#85644b"
  })), _path3011 || (_path3011 = /*#__PURE__*/React.createElement("path", {
    d: "M85 46h1v1h-1z",
    fill: "#87674d"
  })), _path3012 || (_path3012 = /*#__PURE__*/React.createElement("path", {
    d: "M86 46h1v1h-1z",
    fill: "#8b6951"
  })), _path3013 || (_path3013 = /*#__PURE__*/React.createElement("path", {
    d: "M88 46h1v1h-1z",
    fill: "#966f5a"
  })), _path3014 || (_path3014 = /*#__PURE__*/React.createElement("path", {
    d: "M90 47h-1v-1h1z",
    fill: "#9a735d"
  })), _path3015 || (_path3015 = /*#__PURE__*/React.createElement("path", {
    d: "M91 47h-1v-1h1z",
    fill: "#9a755d"
  })), _path3016 || (_path3016 = /*#__PURE__*/React.createElement("path", {
    d: "M91 46h1v1h-1z",
    fill: "#9b785d"
  })), _path3017 || (_path3017 = /*#__PURE__*/React.createElement("path", {
    d: "M92 46h1v1h-1z",
    fill: "#a07960"
  })), _path3018 || (_path3018 = /*#__PURE__*/React.createElement("path", {
    d: "M94 46v1h-1v-1z",
    fill: "#9e7252"
  })), _path3019 || (_path3019 = /*#__PURE__*/React.createElement("path", {
    d: "M95 47v-1h1v1z",
    fill: "#976134"
  })), _path3020 || (_path3020 = /*#__PURE__*/React.createElement("path", {
    d: "M97 47h-1v-1h1z",
    fill: "#98673c"
  })), _path3021 || (_path3021 = /*#__PURE__*/React.createElement("path", {
    d: "M97 47v-1h1v1z",
    fill: "#9e7554"
  })), _path3022 || (_path3022 = /*#__PURE__*/React.createElement("path", {
    d: "M99 47h-1v-1h1z",
    fill: "#9f7a60"
  })), _path3023 || (_path3023 = /*#__PURE__*/React.createElement("path", {
    d: "M100 46v1h-1v-1z",
    fill: "#9f7a61"
  })), _path3024 || (_path3024 = /*#__PURE__*/React.createElement("path", {
    d: "M100 47v-1h1v1z",
    fill: "#9d785f"
  })), _path3025 || (_path3025 = /*#__PURE__*/React.createElement("path", {
    d: "M101 47v-1h1v1z",
    fill: "#9b765c"
  })), _path3026 || (_path3026 = /*#__PURE__*/React.createElement("path", {
    d: "M103 47h-1v-1h1z",
    fill: "#99745a"
  })), _path3027 || (_path3027 = /*#__PURE__*/React.createElement("path", {
    d: "M103 46h1v1h-1z",
    fill: "#957056"
  })), _path3028 || (_path3028 = /*#__PURE__*/React.createElement("path", {
    d: "M105 46v1h-1v-1z",
    fill: "#956f57"
  })), _path3029 || (_path3029 = /*#__PURE__*/React.createElement("path", {
    d: "M105 46h1v1h-1z",
    fill: "#956f56"
  })), _path3030 || (_path3030 = /*#__PURE__*/React.createElement("path", {
    d: "M107 46v1h-1v-1z",
    fill: "#936e56"
  })), _path3031 || (_path3031 = /*#__PURE__*/React.createElement("path", {
    d: "M107 47v-1h1v1z",
    fill: "#8f6547"
  })), _path3032 || (_path3032 = /*#__PURE__*/React.createElement("path", {
    d: "M110 47h-1v-1h1z",
    fill: "#754a1f"
  })), _path3033 || (_path3033 = /*#__PURE__*/React.createElement("path", {
    d: "M111 46v1h-1v-1z",
    fill: "#62401c"
  })), _path3034 || (_path3034 = /*#__PURE__*/React.createElement("path", {
    d: "M112 46v1h-1v-1z",
    fill: "#774f23"
  })), _path3035 || (_path3035 = /*#__PURE__*/React.createElement("path", {
    d: "M113 47h-1v-1h1z",
    fill: "#d69660"
  })), _path3036 || (_path3036 = /*#__PURE__*/React.createElement("path", {
    d: "M114 46v1h-1v-1z",
    fill: "#d69c66"
  })), _path3037 || (_path3037 = /*#__PURE__*/React.createElement("path", {
    d: "M115 47h-1v-1h1z",
    fill: "#a57958"
  })), _path3038 || (_path3038 = /*#__PURE__*/React.createElement("path", {
    d: "M116 46v1h-1v-1z",
    fill: "#9a7354"
  })), _path3039 || (_path3039 = /*#__PURE__*/React.createElement("path", {
    d: "M116 47v-1h1v1z",
    fill: "#a67d5b"
  })), _path3040 || (_path3040 = /*#__PURE__*/React.createElement("path", {
    d: "M118 47h-1v-1h1z",
    fill: "#9e7048"
  })), _path3041 || (_path3041 = /*#__PURE__*/React.createElement("path", {
    d: "M119 46v1h-1v-1z",
    fill: "#a16e44"
  })), _path3042 || (_path3042 = /*#__PURE__*/React.createElement("path", {
    d: "M119 46h1v1h-1z",
    fill: "#a27253"
  })), _path3043 || (_path3043 = /*#__PURE__*/React.createElement("path", {
    d: "M120 46h1v1h-1z",
    fill: "#b28163"
  })), _path3044 || (_path3044 = /*#__PURE__*/React.createElement("path", {
    d: "M121 47v-1h1v1z",
    fill: "#ad8c75",
    fillOpacity: 0.357
  })), _path3045 || (_path3045 = /*#__PURE__*/React.createElement("path", {
    d: "M7 47v1H6v-1z",
    fill: "#a8785b",
    fillOpacity: 0.729
  })), _path3046 || (_path3046 = /*#__PURE__*/React.createElement("path", {
    d: "M7 48v-1h1v1z",
    fill: "#b17c55"
  })), _path3047 || (_path3047 = /*#__PURE__*/React.createElement("path", {
    d: "M8 48v-1h1v1z",
    fill: "#8d5e38"
  })), _path3048 || (_path3048 = /*#__PURE__*/React.createElement("path", {
    d: "M10 48H9v-1h1z",
    fill: "#86532d"
  })), _path3049 || (_path3049 = /*#__PURE__*/React.createElement("path", {
    d: "M10 47h1v1h-1z",
    fill: "#87522a"
  })), _path3050 || (_path3050 = /*#__PURE__*/React.createElement("path", {
    d: "M12 47v1h-1v-1z",
    fill: "#7a5130",
    fillOpacity: 0.635
  })), _path3051 || (_path3051 = /*#__PURE__*/React.createElement("path", {
    d: "M21 47h1v1h-1z",
    fill: "#87572d",
    fillOpacity: 0.718
  })), _path3052 || (_path3052 = /*#__PURE__*/React.createElement("path", {
    d: "M23 48h-1v-1h1z",
    fill: "#98612a"
  })), _path3053 || (_path3053 = /*#__PURE__*/React.createElement("path", {
    d: "M23 47h1v1h-1z",
    fill: "#95622d"
  })), _path3054 || (_path3054 = /*#__PURE__*/React.createElement("path", {
    d: "M25 47v1h-1v-1z",
    fill: "#885828"
  })), _path3055 || (_path3055 = /*#__PURE__*/React.createElement("path", {
    d: "M25 48v-1h1v1z",
    fill: "#77431b"
  })), _path3056 || (_path3056 = /*#__PURE__*/React.createElement("path", {
    d: "M27 48h-1v-1h1z",
    fill: "#7b4620"
  })), _path3057 || (_path3057 = /*#__PURE__*/React.createElement("path", {
    d: "M27 48v-1h1v1z",
    fill: "#6f421f",
    fillOpacity: 0.925
  })), _path3058 || (_path3058 = /*#__PURE__*/React.createElement("path", {
    d: "M39 48h-1v-1h1z",
    fill: "#b9a29d",
    fillOpacity: 0.388
  })), _path3059 || (_path3059 = /*#__PURE__*/React.createElement("path", {
    d: "M40 48h-1v-1h1z",
    fill: "#b89086"
  })), _path3060 || (_path3060 = /*#__PURE__*/React.createElement("path", {
    d: "M41 47v1h-1v-1z",
    fill: "#b3887c"
  })), _path3061 || (_path3061 = /*#__PURE__*/React.createElement("path", {
    d: "M41 48v-1h1v1z",
    fill: "#ab8172"
  })), _path3062 || (_path3062 = /*#__PURE__*/React.createElement("path", {
    d: "M43 47v1h-1v-1z",
    fill: "#784a2c"
  })), _path3063 || (_path3063 = /*#__PURE__*/React.createElement("path", {
    d: "M43 47h1v1h-1z",
    fill: "#643f27",
    fillOpacity: 0.427
  })), _path3064 || (_path3064 = /*#__PURE__*/React.createElement("path", {
    d: "M61 47v1h-1v-1z",
    fill: "#8b6448",
    fillOpacity: 0.565
  })), _path3065 || (_path3065 = /*#__PURE__*/React.createElement("path", {
    d: "M61 48v-1h1v1z",
    fill: "#976333"
  })), _path3066 || (_path3066 = /*#__PURE__*/React.createElement("path", {
    d: "M62 48v-1h1v1z",
    fill: "#92602e"
  })), _path3067 || (_path3067 = /*#__PURE__*/React.createElement("path", {
    d: "M65 47v1h-1v-1z",
    fill: "#9e6e42"
  })), _path3068 || (_path3068 = /*#__PURE__*/React.createElement("path", {
    d: "M66 48h-1v-1h1z",
    fill: "#8e6947",
    fillOpacity: 0.588
  })), _path3069 || (_path3069 = /*#__PURE__*/React.createElement("path", {
    d: "M72 47h1v1h-1z",
    fill: "#946539"
  })), _path3070 || (_path3070 = /*#__PURE__*/React.createElement("path", {
    d: "M73 47h1v1h-1z",
    fill: "#a16b3b"
  })), _path3071 || (_path3071 = /*#__PURE__*/React.createElement("path", {
    d: "M75 47v1h-1v-1z",
    fill: "#9e6a38"
  })), _path3072 || (_path3072 = /*#__PURE__*/React.createElement("path", {
    d: "M75 48v-1h1v1z",
    fill: "#966332"
  })), _path3073 || (_path3073 = /*#__PURE__*/React.createElement("path", {
    d: "M78 47v1h-1v-1z",
    fill: "#a98156"
  })), _path3074 || (_path3074 = /*#__PURE__*/React.createElement("path", {
    d: "M78 47h1v1h-1z",
    fill: "#9a7242"
  })), _path3075 || (_path3075 = /*#__PURE__*/React.createElement("path", {
    d: "M81 48h-1v-1h1z",
    fill: "#774c35"
  })), _path3076 || (_path3076 = /*#__PURE__*/React.createElement("path", {
    d: "M82 47v1h-1v-1z",
    fill: "#7a533c"
  })), _path3077 || (_path3077 = /*#__PURE__*/React.createElement("path", {
    d: "M83 47v1h-1v-1z",
    fill: "#805a44"
  })), _path3078 || (_path3078 = /*#__PURE__*/React.createElement("path", {
    d: "M84 47v1h-1v-1z",
    fill: "#845f49"
  })), _path3079 || (_path3079 = /*#__PURE__*/React.createElement("path", {
    d: "M84 48v-1h1v1z",
    fill: "#85624d"
  })), _path3080 || (_path3080 = /*#__PURE__*/React.createElement("path", {
    d: "M85 47h1v1h-1z",
    fill: "#896651"
  })), _path3081 || (_path3081 = /*#__PURE__*/React.createElement("path", {
    d: "M86 48v-1h1v1z",
    fill: "#8b6a54"
  })), _path3082 || (_path3082 = /*#__PURE__*/React.createElement("path", {
    d: "M88 48h-1v-1h1z",
    fill: "#8d6c55"
  })), _path3083 || (_path3083 = /*#__PURE__*/React.createElement("path", {
    d: "M89 48h-1v-1h1z",
    fill: "#8f6d56"
  })), _path3084 || (_path3084 = /*#__PURE__*/React.createElement("path", {
    d: "M90 48h-1v-1h1z",
    fill: "#906e57"
  })), _path3085 || (_path3085 = /*#__PURE__*/React.createElement("path", {
    d: "M91 47v1h-1v-1z",
    fill: "#93705a"
  })), _path3086 || (_path3086 = /*#__PURE__*/React.createElement("path", {
    d: "M91 47h1v1h-1z",
    fill: "#957158"
  })), _path3087 || (_path3087 = /*#__PURE__*/React.createElement("path", {
    d: "M93 47v1h-1v-1z",
    fill: "#997059"
  })), _path3088 || (_path3088 = /*#__PURE__*/React.createElement("path", {
    d: "M94 47v1h-1v-1z",
    fill: "#996d4d"
  })), _path3089 || (_path3089 = /*#__PURE__*/React.createElement("path", {
    d: "M94 48v-1h1v1z",
    fill: "#98673d"
  })), _path3090 || (_path3090 = /*#__PURE__*/React.createElement("path", {
    d: "M96 48v-1h1v1z",
    fill: "#9d6b46"
  })), _path3091 || (_path3091 = /*#__PURE__*/React.createElement("path", {
    d: "M97 47h1v1h-1z",
    fill: "#a17557"
  })), _path3092 || (_path3092 = /*#__PURE__*/React.createElement("path", {
    d: "M98 48v-1h1v1z",
    fill: "#a27b64"
  })), _path3093 || (_path3093 = /*#__PURE__*/React.createElement("path", {
    d: "M100 48h-1v-1h1z",
    fill: "#a37e67"
  })), _path3094 || (_path3094 = /*#__PURE__*/React.createElement("path", {
    d: "M101 47v1h-1v-1z",
    fill: "#a27c64"
  })), _path3095 || (_path3095 = /*#__PURE__*/React.createElement("path", {
    d: "M101 48v-1h1v1z",
    fill: "#a07b61"
  })), _path3096 || (_path3096 = /*#__PURE__*/React.createElement("path", {
    d: "M102 47h1v1h-1z",
    fill: "#a07a60"
  })), _path3097 || (_path3097 = /*#__PURE__*/React.createElement("path", {
    d: "M103 48v-1h1v1z",
    fill: "#a07961"
  })), _path3098 || (_path3098 = /*#__PURE__*/React.createElement("path", {
    d: "M104 48v-1h1v1z",
    fill: "#9f7861"
  })), _path3099 || (_path3099 = /*#__PURE__*/React.createElement("path", {
    d: "M106 47v1h-1v-1z",
    fill: "#9e775f"
  })), _path3100 || (_path3100 = /*#__PURE__*/React.createElement("path", {
    d: "M107 48h-1v-1h1z",
    fill: "#9d7760"
  })), _path3101 || (_path3101 = /*#__PURE__*/React.createElement("path", {
    d: "M107 47h1v1h-1z",
    fill: "#986d50"
  })), _path3102 || (_path3102 = /*#__PURE__*/React.createElement("path", {
    d: "M109 47v1h-1v-1z",
    fill: "#82522a"
  })), _path3103 || (_path3103 = /*#__PURE__*/React.createElement("path", {
    d: "M109 48v-1h1v1z",
    fill: "#774b21"
  })), _path3104 || (_path3104 = /*#__PURE__*/React.createElement("path", {
    d: "M110 48v-1h1v1z",
    fill: "#64401b"
  })), _path3105 || (_path3105 = /*#__PURE__*/React.createElement("path", {
    d: "M112 48h-1v-1h1z",
    fill: "#7d5328"
  })), _path3106 || (_path3106 = /*#__PURE__*/React.createElement("path", {
    d: "M113 47v1h-1v-1z",
    fill: "#df9d68"
  })), _path3107 || (_path3107 = /*#__PURE__*/React.createElement("path", {
    d: "M114 48h-1v-1h1z",
    fill: "#e0a46e"
  })), _path3108 || (_path3108 = /*#__PURE__*/React.createElement("path", {
    d: "M115 48h-1v-1h1z",
    fill: "#a97b5a"
  })), _path3109 || (_path3109 = /*#__PURE__*/React.createElement("path", {
    d: "M116 47v1h-1v-1z",
    fill: "#a27657"
  })), _path3110 || (_path3110 = /*#__PURE__*/React.createElement("path", {
    d: "M116 47h1v1h-1z",
    fill: "#ab7958"
  })), _path3111 || (_path3111 = /*#__PURE__*/React.createElement("path", {
    d: "M118 47v1h-1v-1z",
    fill: "#a97553"
  })), _path3112 || (_path3112 = /*#__PURE__*/React.createElement("path", {
    d: "M118 48v-1h1v1z",
    fill: "#a36f4d"
  })), _path3113 || (_path3113 = /*#__PURE__*/React.createElement("path", {
    d: "M119 48v-1h1v1z",
    fill: "#a47256"
  })), _path3114 || (_path3114 = /*#__PURE__*/React.createElement("path", {
    d: "M120 47h1v1h-1z",
    fill: "#b08266"
  })), _path3115 || (_path3115 = /*#__PURE__*/React.createElement("path", {
    d: "M122 47v1h-1v-1z",
    fill: "#ad8d74",
    fillOpacity: 0.318
  })), _path3116 || (_path3116 = /*#__PURE__*/React.createElement("path", {
    d: "M6 48h1v1H6z",
    fill: "#a17256",
    fillOpacity: 0.576
  })), _path3117 || (_path3117 = /*#__PURE__*/React.createElement("path", {
    d: "M7 48h1v1H7z",
    fill: "#b67e58"
  })), _path3118 || (_path3118 = /*#__PURE__*/React.createElement("path", {
    d: "M9 49H8v-1h1z",
    fill: "#92613c"
  })), _path3119 || (_path3119 = /*#__PURE__*/React.createElement("path", {
    d: "M10 49H9v-1h1z",
    fill: "#86532c"
  })), _path3120 || (_path3120 = /*#__PURE__*/React.createElement("path", {
    d: "M11 49h-1v-1h1z",
    fill: "#875025"
  })), _path3121 || (_path3121 = /*#__PURE__*/React.createElement("path", {
    d: "M12 49h-1v-1h1z",
    fill: "#7f5332",
    fillOpacity: 0.769
  })), _path3122 || (_path3122 = /*#__PURE__*/React.createElement("path", {
    d: "M13 49h-1v-1h1z",
    fill: "#fff",
    fillOpacity: 0.008
  })), _path3123 || (_path3123 = /*#__PURE__*/React.createElement("path", {
    d: "M22 49h-1v-1h1z",
    fill: "#86582c",
    fillOpacity: 0.678
  })), _path3124 || (_path3124 = /*#__PURE__*/React.createElement("path", {
    d: "M23 48v1h-1v-1z",
    fill: "#976028"
  })), _path3125 || (_path3125 = /*#__PURE__*/React.createElement("path", {
    d: "M24 49h-1v-1h1z",
    fill: "#925e2a"
  })), _path3126 || (_path3126 = /*#__PURE__*/React.createElement("path", {
    d: "M25 49h-1v-1h1z",
    fill: "#885628"
  })), _path3127 || (_path3127 = /*#__PURE__*/React.createElement("path", {
    d: "M25 48h1v1h-1z",
    fill: "#77441a"
  })), _path3128 || (_path3128 = /*#__PURE__*/React.createElement("path", {
    d: "M27 49h-1v-1h1z",
    fill: "#74411a"
  })), _path3129 || (_path3129 = /*#__PURE__*/React.createElement("path", {
    d: "M28 48v1h-1v-1z",
    fill: "#714420",
    fillOpacity: 0.933
  })), _path3130 || (_path3130 = /*#__PURE__*/React.createElement("path", {
    d: "M29 49h-1v-1h1z",
    fill: "#6d513f",
    fillOpacity: 0.11
  })), _path3131 || (_path3131 = /*#__PURE__*/React.createElement("path", {
    d: "M38 48h1v1h-1z",
    fill: "#b39b99",
    fillOpacity: 0.373
  })), _path3132 || (_path3132 = /*#__PURE__*/React.createElement("path", {
    d: "M40 49h-1v-1h1z",
    fill: "#bb9189"
  })), _path3133 || (_path3133 = /*#__PURE__*/React.createElement("path", {
    d: "M41 49h-1v-1h1z",
    fill: "#b98b83"
  })), _path3134 || (_path3134 = /*#__PURE__*/React.createElement("path", {
    d: "M42 48v1h-1v-1z",
    fill: "#b08675"
  })), _path3135 || (_path3135 = /*#__PURE__*/React.createElement("path", {
    d: "M43 49h-1v-1h1z",
    fill: "#7a4b2d"
  })), _path3136 || (_path3136 = /*#__PURE__*/React.createElement("path", {
    d: "M43 48h1v1h-1z",
    fill: "#653e27",
    fillOpacity: 0.435
  })), _path3137 || (_path3137 = /*#__PURE__*/React.createElement("path", {
    d: "M60 48h1v1h-1z",
    fill: "#8d6649",
    fillOpacity: 0.529
  })), _path3138 || (_path3138 = /*#__PURE__*/React.createElement("path", {
    d: "M63 49h-1v-1h1z",
    fill: "#94602f"
  })), _path3139 || (_path3139 = /*#__PURE__*/React.createElement("path", {
    d: "M63 49v-1h1v1z",
    fill: "#9b693b"
  })), _path3140 || (_path3140 = /*#__PURE__*/React.createElement("path", {
    d: "M64 49v-1h1v1z",
    fill: "#99693d"
  })), _path3141 || (_path3141 = /*#__PURE__*/React.createElement("path", {
    d: "M65 49v-1h1v1z",
    fill: "#886343",
    fillOpacity: 0.58
  })), _path3142 || (_path3142 = /*#__PURE__*/React.createElement("path", {
    d: "M73 48v1h-1v-1z",
    fill: "#936438"
  })), _path3143 || (_path3143 = /*#__PURE__*/React.createElement("path", {
    d: "M74 48v1h-1v-1z",
    fill: "#9f6a39"
  })), _path3144 || (_path3144 = /*#__PURE__*/React.createElement("path", {
    d: "M74 48h1v1h-1z",
    fill: "#9a6634"
  })), _path3145 || (_path3145 = /*#__PURE__*/React.createElement("path", {
    d: "M76 49h-1v-1h1z",
    fill: "#956232"
  })), _path3146 || (_path3146 = /*#__PURE__*/React.createElement("path", {
    d: "M78 49h-1v-1h1z",
    fill: "#a77f57"
  })), _path3147 || (_path3147 = /*#__PURE__*/React.createElement("path", {
    d: "M78 49v-1h1v1z",
    fill: "#9d7146"
  })), _path3148 || (_path3148 = /*#__PURE__*/React.createElement("path", {
    d: "M80 48v1h-1v-1z",
    fill: "#784724"
  })), _path3149 || (_path3149 = /*#__PURE__*/React.createElement("path", {
    d: "M80 49v-1h1v1z",
    fill: "#6f3a1e"
  })), _path3150 || (_path3150 = /*#__PURE__*/React.createElement("path", {
    d: "M81 49v-1h1v1z",
    fill: "#713d1f"
  })), _path3151 || (_path3151 = /*#__PURE__*/React.createElement("path", {
    d: "M82 48h1v1h-1z",
    fill: "#774224"
  })), _path3152 || (_path3152 = /*#__PURE__*/React.createElement("path", {
    d: "M83 49v-1h1v1z",
    fill: "#804c2f"
  })), _path3153 || (_path3153 = /*#__PURE__*/React.createElement("path", {
    d: "M84 48h1v1h-1z",
    fill: "#825036"
  })), _path3154 || (_path3154 = /*#__PURE__*/React.createElement("path", {
    d: "M85 48h1v1h-1z",
    fill: "#825239"
  })), _path3155 || (_path3155 = /*#__PURE__*/React.createElement("path", {
    d: "M86 49v-1h1v1z",
    fill: "#82563c"
  })), _path3156 || (_path3156 = /*#__PURE__*/React.createElement("path", {
    d: "M87 48h1v1h-1z",
    fill: "#855b42"
  })), _path3157 || (_path3157 = /*#__PURE__*/React.createElement("path", {
    d: "M90 48v1h-1v-1z",
    fill: "#8d6851"
  })), _path3158 || (_path3158 = /*#__PURE__*/React.createElement("path", {
    d: "M91 49h-1v-1h1z",
    fill: "#916c56"
  })), _path3159 || (_path3159 = /*#__PURE__*/React.createElement("path", {
    d: "M92 48v1h-1v-1z",
    fill: "#946d54"
  })), _path3160 || (_path3160 = /*#__PURE__*/React.createElement("path", {
    d: "M93 48v1h-1v-1z",
    fill: "#996d55"
  })), _path3161 || (_path3161 = /*#__PURE__*/React.createElement("path", {
    d: "M94 48v1h-1v-1z",
    fill: "#976947"
  })), _path3162 || (_path3162 = /*#__PURE__*/React.createElement("path", {
    d: "M95 49h-1v-1h1z",
    fill: "#95663b"
  })), _path3163 || (_path3163 = /*#__PURE__*/React.createElement("path", {
    d: "M95 48h1v1h-1z",
    fill: "#99653e"
  })), _path3164 || (_path3164 = /*#__PURE__*/React.createElement("path", {
    d: "M97 48v1h-1v-1z",
    fill: "#9b6746"
  })), _path3165 || (_path3165 = /*#__PURE__*/React.createElement("path", {
    d: "M97 49v-1h1v1z",
    fill: "#9e7054"
  })), _path3166 || (_path3166 = /*#__PURE__*/React.createElement("path", {
    d: "M98 48h1v1h-1z",
    fill: "#9f755f"
  })), _path3167 || (_path3167 = /*#__PURE__*/React.createElement("path", {
    d: "M100 48v1h-1v-1z",
    fill: "#9f7761"
  })), _path3168 || (_path3168 = /*#__PURE__*/React.createElement("path", {
    d: "M100 49v-1h1v1z",
    fill: "#a27961"
  })), _path3169 || (_path3169 = /*#__PURE__*/React.createElement("path", {
    d: "M101 48h1v1h-1z",
    fill: "#a27a60"
  })), _path3170 || (_path3170 = /*#__PURE__*/React.createElement("path", {
    d: "M103 49h-1v-1h1z",
    fill: "#a37a60"
  })), _path3171 || (_path3171 = /*#__PURE__*/React.createElement("path", {
    d: "M103 49v-1h1v1z",
    fill: "#a47a61"
  })), _path3172 || (_path3172 = /*#__PURE__*/React.createElement("path", {
    d: "M105 48v1h-1v-1z",
    fill: "#a47b60"
  })), _path3173 || (_path3173 = /*#__PURE__*/React.createElement("path", {
    d: "M105 49v-1h1v1z",
    fill: "#a37a5d"
  })), _path3174 || (_path3174 = /*#__PURE__*/React.createElement("path", {
    d: "M107 48v1h-1v-1z",
    fill: "#a47c5d"
  })), _path3175 || (_path3175 = /*#__PURE__*/React.createElement("path", {
    d: "M107 48h1v1h-1z",
    fill: "#9e714c"
  })), _path3176 || (_path3176 = /*#__PURE__*/React.createElement("path", {
    d: "M109 49h-1v-1h1z",
    fill: "#865227"
  })), _path3177 || (_path3177 = /*#__PURE__*/React.createElement("path", {
    d: "M110 49h-1v-1h1z",
    fill: "#7a4b21"
  })), _path3178 || (_path3178 = /*#__PURE__*/React.createElement("path", {
    d: "M110 48h1v1h-1z",
    fill: "#65401c"
  })), _path3179 || (_path3179 = /*#__PURE__*/React.createElement("path", {
    d: "M112 48v1h-1v-1z",
    fill: "#81562a"
  })), _path3180 || (_path3180 = /*#__PURE__*/React.createElement("path", {
    d: "M112 48h1v1h-1z",
    fill: "#de9a66"
  })), _path3181 || (_path3181 = /*#__PURE__*/React.createElement("path", {
    d: "M114 48v1h-1v-1z",
    fill: "#dc9f69"
  })), _path3182 || (_path3182 = /*#__PURE__*/React.createElement("path", {
    d: "M115 48v1h-1v-1z",
    fill: "#b2805d"
  })), _path3183 || (_path3183 = /*#__PURE__*/React.createElement("path", {
    d: "M116 49h-1v-1h1z",
    fill: "#a47350"
  })), _path3184 || (_path3184 = /*#__PURE__*/React.createElement("path", {
    d: "M117 48v1h-1v-1z",
    fill: "#a06f4e"
  })), _path3185 || (_path3185 = /*#__PURE__*/React.createElement("path", {
    d: "M117 49v-1h1v1z",
    fill: "#9a6747"
  })), _path3186 || (_path3186 = /*#__PURE__*/React.createElement("path", {
    d: "M119 48v1h-1v-1z",
    fill: "#8c5634"
  })), _path3187 || (_path3187 = /*#__PURE__*/React.createElement("path", {
    d: "M120 49h-1v-1h1z",
    fill: "#a27050"
  })), _path3188 || (_path3188 = /*#__PURE__*/React.createElement("path", {
    d: "M120 49v-1h1v1z",
    fill: "#ae8264"
  })), _path3189 || (_path3189 = /*#__PURE__*/React.createElement("path", {
    d: "M122 49h-1v-1h1z",
    fill: "#a78c72",
    fillOpacity: 0.263
  })), _path3190 || (_path3190 = /*#__PURE__*/React.createElement("path", {
    d: "M7 49v1H6v-1z",
    fill: "#9e7659",
    fillOpacity: 0.404
  })), _path3191 || (_path3191 = /*#__PURE__*/React.createElement("path", {
    d: "M8 49v1H7v-1z",
    fill: "#b47c56"
  })), _path3192 || (_path3192 = /*#__PURE__*/React.createElement("path", {
    d: "M9 49v1H8v-1z",
    fill: "#9c6540"
  })), _path3193 || (_path3193 = /*#__PURE__*/React.createElement("path", {
    d: "M10 49v1H9v-1z",
    fill: "#88552f"
  })), _path3194 || (_path3194 = /*#__PURE__*/React.createElement("path", {
    d: "M10 50v-1h1v1z",
    fill: "#874d22"
  })), _path3195 || (_path3195 = /*#__PURE__*/React.createElement("path", {
    d: "M11 49h1v1h-1z",
    fill: "#7e502e",
    fillOpacity: 0.898
  })), _path3196 || (_path3196 = /*#__PURE__*/React.createElement("path", {
    d: "M13 49v1h-1v-1z",
    fill: "#66593f",
    fillOpacity: 0.078
  })), _path3197 || (_path3197 = /*#__PURE__*/React.createElement("path", {
    d: "M21 49h1v1h-1z",
    fill: "#855b30",
    fillOpacity: 0.635
  })), _path3198 || (_path3198 = /*#__PURE__*/React.createElement("path", {
    d: "M23 50h-1v-1h1z",
    fill: "#965f25"
  })), _path3199 || (_path3199 = /*#__PURE__*/React.createElement("path", {
    d: "M24 50h-1v-1h1z",
    fill: "#8d5b27"
  })), _path3200 || (_path3200 = /*#__PURE__*/React.createElement("path", {
    d: "M24 50v-1h1v1z",
    fill: "#875524"
  })), _path3201 || (_path3201 = /*#__PURE__*/React.createElement("path", {
    d: "M26 49v1h-1v-1z",
    fill: "#79481c"
  })), _path3202 || (_path3202 = /*#__PURE__*/React.createElement("path", {
    d: "M27 49v1h-1v-1z",
    fill: "#78461e"
  })), _path3203 || (_path3203 = /*#__PURE__*/React.createElement("path", {
    d: "M27 49h1v1h-1z",
    fill: "#744724",
    fillOpacity: 0.922
  })), _path3204 || (_path3204 = /*#__PURE__*/React.createElement("path", {
    d: "M28 49h1v1h-1z",
    fill: "#705b47",
    fillOpacity: 0.098
  })), _path3205 || (_path3205 = /*#__PURE__*/React.createElement("path", {
    d: "M39 49v1h-1v-1z",
    fill: "#b39a95",
    fillOpacity: 0.369
  })), _path3206 || (_path3206 = /*#__PURE__*/React.createElement("path", {
    d: "M40 50h-1v-1h1z",
    fill: "#b98d86"
  })), _path3207 || (_path3207 = /*#__PURE__*/React.createElement("path", {
    d: "M40 49h1v1h-1z",
    fill: "#ba8c84"
  })), _path3208 || (_path3208 = /*#__PURE__*/React.createElement("path", {
    d: "M42 49v1h-1v-1z",
    fill: "#ad8473"
  })), _path3209 || (_path3209 = /*#__PURE__*/React.createElement("path", {
    d: "M42 50v-1h1v1z",
    fill: "#7c4c2f"
  })), _path3210 || (_path3210 = /*#__PURE__*/React.createElement("path", {
    d: "M43 49h1v1h-1z",
    fill: "#643d24",
    fillOpacity: 0.439
  })), _path3211 || (_path3211 = /*#__PURE__*/React.createElement("path", {
    d: "M61 49v1h-1v-1z",
    fill: "#87654a",
    fillOpacity: 0.494
  })), _path3212 || (_path3212 = /*#__PURE__*/React.createElement("path", {
    d: "M63 50h-1v-1h1z",
    fill: "#946133"
  })), _path3213 || (_path3213 = /*#__PURE__*/React.createElement("path", {
    d: "M65 49v1h-1v-1z",
    fill: "#966438"
  })), _path3214 || (_path3214 = /*#__PURE__*/React.createElement("path", {
    d: "M66 49v1h-1v-1z",
    fill: "#835e3f",
    fillOpacity: 0.569
  })), _path3215 || (_path3215 = /*#__PURE__*/React.createElement("path", {
    d: "M71 49h1v1h-1z",
    fill: "#896442",
    fillOpacity: 0.239
  })), _path3216 || (_path3216 = /*#__PURE__*/React.createElement("path", {
    d: "M73 50v-1h1v1z",
    fill: "#9d6636"
  })), _path3217 || (_path3217 = /*#__PURE__*/React.createElement("path", {
    d: "M74 49h1v1h-1z",
    fill: "#97602f"
  })), _path3218 || (_path3218 = /*#__PURE__*/React.createElement("path", {
    d: "M77 50v-1h1v1z",
    fill: "#a77e54"
  })), _path3219 || (_path3219 = /*#__PURE__*/React.createElement("path", {
    d: "M78 49h1v1h-1z",
    fill: "#a1744d"
  })), _path3220 || (_path3220 = /*#__PURE__*/React.createElement("path", {
    d: "M80 50h-1v-1h1z",
    fill: "#8f5b38"
  })), _path3221 || (_path3221 = /*#__PURE__*/React.createElement("path", {
    d: "M80 49h1v1h-1z",
    fill: "#8a5632"
  })), _path3222 || (_path3222 = /*#__PURE__*/React.createElement("path", {
    d: "M81 49h1v1h-1z",
    fill: "#8c512e"
  })), _path3223 || (_path3223 = /*#__PURE__*/React.createElement("path", {
    d: "M83 49v1h-1v-1z",
    fill: "#8b4f2b"
  })), _path3224 || (_path3224 = /*#__PURE__*/React.createElement("path", {
    d: "M84 50h-1v-1h1z",
    fill: "#8d532f"
  })), _path3225 || (_path3225 = /*#__PURE__*/React.createElement("path", {
    d: "M85 49v1h-1v-1z",
    fill: "#8a5131"
  })), _path3226 || (_path3226 = /*#__PURE__*/React.createElement("path", {
    d: "M86 50h-1v-1h1z",
    fill: "#844a2e"
  })), _path3227 || (_path3227 = /*#__PURE__*/React.createElement("path", {
    d: "M87 49v1h-1v-1z",
    fill: "#7e4628"
  })), _path3228 || (_path3228 = /*#__PURE__*/React.createElement("path", {
    d: "M87 50v-1h1v1z",
    fill: "#7c4427"
  })), _path3229 || (_path3229 = /*#__PURE__*/React.createElement("path", {
    d: "M89 49v1h-1v-1z",
    fill: "#804a2e"
  })), _path3230 || (_path3230 = /*#__PURE__*/React.createElement("path", {
    d: "M89 50v-1h1v1z",
    fill: "#865236"
  })), _path3231 || (_path3231 = /*#__PURE__*/React.createElement("path", {
    d: "M92 49v1h-1v-1z",
    fill: "#8e5e41"
  })), _path3232 || (_path3232 = /*#__PURE__*/React.createElement("path", {
    d: "M93 50h-1v-1h1z",
    fill: "#906041"
  })), _path3233 || (_path3233 = /*#__PURE__*/React.createElement("path", {
    d: "M94 50v-1h1v1z",
    fill: "#8f5e38"
  })), _path3234 || (_path3234 = /*#__PURE__*/React.createElement("path", {
    d: "M95 50v-1h1v1z",
    fill: "#905c38"
  })), _path3235 || (_path3235 = /*#__PURE__*/React.createElement("path", {
    d: "M96 50v-1h1v1z",
    fill: "#8e5c3b"
  })), _path3236 || (_path3236 = /*#__PURE__*/React.createElement("path", {
    d: "M97 50v-1h1v1z",
    fill: "#936549"
  })), _path3237 || (_path3237 = /*#__PURE__*/React.createElement("path", {
    d: "M99 49v1h-1v-1z",
    fill: "#986f56"
  })), _path3238 || (_path3238 = /*#__PURE__*/React.createElement("path", {
    d: "M100 50h-1v-1h1z",
    fill: "#996f59"
  })), _path3239 || (_path3239 = /*#__PURE__*/React.createElement("path", {
    d: "M100 50v-1h1v1z",
    fill: "#9b725b"
  })), _path3240 || (_path3240 = /*#__PURE__*/React.createElement("path", {
    d: "M102 49v1h-1v-1z",
    fill: "#9f765a"
  })), _path3241 || (_path3241 = /*#__PURE__*/React.createElement("path", {
    d: "M102 49h1v1h-1z",
    fill: "#a37a5b"
  })), _path3242 || (_path3242 = /*#__PURE__*/React.createElement("path", {
    d: "M106 49v1h-1v-1z",
    fill: "#a67b5a"
  })), _path3243 || (_path3243 = /*#__PURE__*/React.createElement("path", {
    d: "M106 50v-1h1v1z",
    fill: "#a97d57"
  })), _path3244 || (_path3244 = /*#__PURE__*/React.createElement("path", {
    d: "M108 49v1h-1v-1z",
    fill: "#a4744c"
  })), _path3245 || (_path3245 = /*#__PURE__*/React.createElement("path", {
    d: "M109 50h-1v-1h1z",
    fill: "#8a562e"
  })), _path3246 || (_path3246 = /*#__PURE__*/React.createElement("path", {
    d: "M109 50v-1h1v1z",
    fill: "#7e4f24"
  })), _path3247 || (_path3247 = /*#__PURE__*/React.createElement("path", {
    d: "M110 50v-1h1v1z",
    fill: "#6a421d"
  })), _path3248 || (_path3248 = /*#__PURE__*/React.createElement("path", {
    d: "M111 50v-1h1v1z",
    fill: "#85592d"
  })), _path3249 || (_path3249 = /*#__PURE__*/React.createElement("path", {
    d: "M113 50h-1v-1h1z",
    fill: "#e09e68"
  })), _path3250 || (_path3250 = /*#__PURE__*/React.createElement("path", {
    d: "M113 49h1v1h-1z",
    fill: "#e0a071"
  })), _path3251 || (_path3251 = /*#__PURE__*/React.createElement("path", {
    d: "M114 49h1v1h-1z",
    fill: "#a56f4e"
  })), _path3252 || (_path3252 = /*#__PURE__*/React.createElement("path", {
    d: "M116 49v1h-1v-1z",
    fill: "#96613f"
  })), _path3253 || (_path3253 = /*#__PURE__*/React.createElement("path", {
    d: "M116 50v-1h1v1z",
    fill: "#92603c"
  })), _path3254 || (_path3254 = /*#__PURE__*/React.createElement("path", {
    d: "M118 50h-1v-1h1z",
    fill: "#925f3e"
  })), _path3255 || (_path3255 = /*#__PURE__*/React.createElement("path", {
    d: "M119 49h1v1h-1z",
    fill: "#a87351"
  })), _path3256 || (_path3256 = /*#__PURE__*/React.createElement("path", {
    d: "M121 49v1h-1v-1z",
    fill: "#ad8262",
    fillOpacity: 0.984
  })), _path3257 || (_path3257 = /*#__PURE__*/React.createElement("path", {
    d: "M122 49v1h-1v-1z",
    fill: "#a68e75",
    fillOpacity: 0.204
  })), _path3258 || (_path3258 = /*#__PURE__*/React.createElement("path", {
    d: "M6 51v-1h1v1z",
    fill: "#9a775c",
    fillOpacity: 0.259
  })), _path3259 || (_path3259 = /*#__PURE__*/React.createElement("path", {
    d: "M7 51v-1h1v1z",
    fill: "#ab7752",
    fillOpacity: 0.996
  })), _path3260 || (_path3260 = /*#__PURE__*/React.createElement("path", {
    d: "M10 50h1v1h-1z",
    fill: "#854a1e"
  })), _path3261 || (_path3261 = /*#__PURE__*/React.createElement("path", {
    d: "M12 50v1h-1v-1z",
    fill: "#73441f",
    fillOpacity: 0.984
  })), _path3262 || (_path3262 = /*#__PURE__*/React.createElement("path", {
    d: "M12 51v-1h1v1z",
    fill: "#694632",
    fillOpacity: 0.2
  })), _path3263 || (_path3263 = /*#__PURE__*/React.createElement("path", {
    d: "M22 51h-1v-1h1z",
    fill: "#825d34",
    fillOpacity: 0.588
  })), _path3264 || (_path3264 = /*#__PURE__*/React.createElement("path", {
    d: "M22 50h1v1h-1z",
    fill: "#975e25"
  })), _path3265 || (_path3265 = /*#__PURE__*/React.createElement("path", {
    d: "M24 51h-1v-1h1z",
    fill: "#925c2a"
  })), _path3266 || (_path3266 = /*#__PURE__*/React.createElement("path", {
    d: "M24 50h1v1h-1z",
    fill: "#8b5729"
  })), _path3267 || (_path3267 = /*#__PURE__*/React.createElement("path", {
    d: "M26 50v1h-1v-1z",
    fill: "#7c491c"
  })), _path3268 || (_path3268 = /*#__PURE__*/React.createElement("path", {
    d: "M27 51h-1v-1h1z",
    fill: "#7c4921"
  })), _path3269 || (_path3269 = /*#__PURE__*/React.createElement("path", {
    d: "M27 51v-1h1v1z",
    fill: "#784b2a",
    fillOpacity: 0.898
  })), _path3270 || (_path3270 = /*#__PURE__*/React.createElement("path", {
    d: "M29 50v1h-1v-1z",
    fill: "#7f6659",
    fillOpacity: 0.078
  })), _path3271 || (_path3271 = /*#__PURE__*/React.createElement("path", {
    d: "M38 50h1v1h-1z",
    fill: "#b59a97",
    fillOpacity: 0.369
  })), _path3272 || (_path3272 = /*#__PURE__*/React.createElement("path", {
    d: "M40 51h-1v-1h1z",
    fill: "#ba8e88"
  })), _path3273 || (_path3273 = /*#__PURE__*/React.createElement("path", {
    d: "M41 50v1h-1v-1z",
    fill: "#b58980"
  })), _path3274 || (_path3274 = /*#__PURE__*/React.createElement("path", {
    d: "M41 50h1v1h-1z",
    fill: "#af8674"
  })), _path3275 || (_path3275 = /*#__PURE__*/React.createElement("path", {
    d: "M43 50v1h-1v-1z",
    fill: "#7d4c31"
  })), _path3276 || (_path3276 = /*#__PURE__*/React.createElement("path", {
    d: "M43 50h1v1h-1z",
    fill: "#663e25",
    fillOpacity: 0.451
  })), _path3277 || (_path3277 = /*#__PURE__*/React.createElement("path", {
    d: "M61 51h-1v-1h1z",
    fill: "#805f42",
    fillOpacity: 0.451
  })), _path3278 || (_path3278 = /*#__PURE__*/React.createElement("path", {
    d: "M62 50v1h-1v-1z",
    fill: "#926234"
  })), _path3279 || (_path3279 = /*#__PURE__*/React.createElement("path", {
    d: "M64 51v-1h1v1z",
    fill: "#966035"
  })), _path3280 || (_path3280 = /*#__PURE__*/React.createElement("path", {
    d: "M65 50h1v1h-1z",
    fill: "#855d3e",
    fillOpacity: 0.545
  })), _path3281 || (_path3281 = /*#__PURE__*/React.createElement("path", {
    d: "M72 50v1h-1v-1z",
    fill: "#89643e",
    fillOpacity: 0.239
  })), _path3282 || (_path3282 = /*#__PURE__*/React.createElement("path", {
    d: "M73 50h1v1h-1z",
    fill: "#9b6332"
  })), _path3283 || (_path3283 = /*#__PURE__*/React.createElement("path", {
    d: "M75 51h-1v-1h1z",
    fill: "#965d2c"
  })), _path3284 || (_path3284 = /*#__PURE__*/React.createElement("path", {
    d: "M75 51v-1h1v1z",
    fill: "#976132"
  })), _path3285 || (_path3285 = /*#__PURE__*/React.createElement("path", {
    d: "M77 51h-1v-1h1z",
    fill: "#97683a"
  })), _path3286 || (_path3286 = /*#__PURE__*/React.createElement("path", {
    d: "M77 50h1v1h-1z",
    fill: "#a97f54"
  })), _path3287 || (_path3287 = /*#__PURE__*/React.createElement("path", {
    d: "M79 50v1h-1v-1z",
    fill: "#a77a53"
  })), _path3288 || (_path3288 = /*#__PURE__*/React.createElement("path", {
    d: "M81 50v1h-1v-1z",
    fill: "#905b34"
  })), _path3289 || (_path3289 = /*#__PURE__*/React.createElement("path", {
    d: "M82 51v-1h1v1z",
    fill: "#915b3a"
  })), _path3290 || (_path3290 = /*#__PURE__*/React.createElement("path", {
    d: "M83 51v-1h1v1z",
    fill: "#945d3a"
  })), _path3291 || (_path3291 = /*#__PURE__*/React.createElement("path", {
    d: "M84 51v-1h1v1z",
    fill: "#975f3b"
  })), _path3292 || (_path3292 = /*#__PURE__*/React.createElement("path", {
    d: "M86 50v1h-1v-1z",
    fill: "#985e3c"
  })), _path3293 || (_path3293 = /*#__PURE__*/React.createElement("path", {
    d: "M86 50h1v1h-1z",
    fill: "#975f3e"
  })), _path3294 || (_path3294 = /*#__PURE__*/React.createElement("path", {
    d: "M87 50h1v1h-1z",
    fill: "#935a3b"
  })), _path3295 || (_path3295 = /*#__PURE__*/React.createElement("path", {
    d: "M88 51v-1h1v1z",
    fill: "#905839"
  })), _path3296 || (_path3296 = /*#__PURE__*/React.createElement("path", {
    d: "M90 51h-1v-1h1z",
    fill: "#8e5738"
  })), _path3297 || (_path3297 = /*#__PURE__*/React.createElement("path", {
    d: "M91 50v1h-1v-1z",
    fill: "#8a5436"
  })), _path3298 || (_path3298 = /*#__PURE__*/React.createElement("path", {
    d: "M91 50h1v1h-1z",
    fill: "#8a5435"
  })), _path3299 || (_path3299 = /*#__PURE__*/React.createElement("path", {
    d: "M95 51h-1v-1h1z",
    fill: "#82502d"
  })), _path3300 || (_path3300 = /*#__PURE__*/React.createElement("path", {
    d: "M96 50v1h-1v-1z",
    fill: "#84522d"
  })), _path3301 || (_path3301 = /*#__PURE__*/React.createElement("path", {
    d: "M96 50h1v1h-1z",
    fill: "#81502c"
  })), _path3302 || (_path3302 = /*#__PURE__*/React.createElement("path", {
    d: "M98 51v-1h1v1z",
    fill: "#8a5c40"
  })), _path3303 || (_path3303 = /*#__PURE__*/React.createElement("path", {
    d: "M100 51h-1v-1h1z",
    fill: "#916347"
  })), _path3304 || (_path3304 = /*#__PURE__*/React.createElement("path", {
    d: "M101 50v1h-1v-1z",
    fill: "#976949"
  })), _path3305 || (_path3305 = /*#__PURE__*/React.createElement("path", {
    d: "M102 51h-1v-1h1z",
    fill: "#9a6c4d"
  })), _path3306 || (_path3306 = /*#__PURE__*/React.createElement("path", {
    d: "M103 50v1h-1v-1z",
    fill: "#9f7053"
  })), _path3307 || (_path3307 = /*#__PURE__*/React.createElement("path", {
    d: "M103 50h1v1h-1z",
    fill: "#a17155"
  })), _path3308 || (_path3308 = /*#__PURE__*/React.createElement("path", {
    d: "M105 51h-1v-1h1z",
    fill: "#a57355"
  })), _path3309 || (_path3309 = /*#__PURE__*/React.createElement("path", {
    d: "M105 51v-1h1v1z",
    fill: "#ac7855"
  })), _path3310 || (_path3310 = /*#__PURE__*/React.createElement("path", {
    d: "M107 51h-1v-1h1z",
    fill: "#b7815b"
  })), _path3311 || (_path3311 = /*#__PURE__*/React.createElement("path", {
    d: "M108 51h-1v-1h1z",
    fill: "#b57e58"
  })), _path3312 || (_path3312 = /*#__PURE__*/React.createElement("path", {
    d: "M109 50v1h-1v-1z",
    fill: "#8d5830"
  })), _path3313 || (_path3313 = /*#__PURE__*/React.createElement("path", {
    d: "M110 51h-1v-1h1z",
    fill: "#7c4e23"
  })), _path3314 || (_path3314 = /*#__PURE__*/React.createElement("path", {
    d: "M111 51h-1v-1h1z",
    fill: "#6c431c"
  })), _path3315 || (_path3315 = /*#__PURE__*/React.createElement("path", {
    d: "M111 50h1v1h-1z",
    fill: "#8c5b2c"
  })), _path3316 || (_path3316 = /*#__PURE__*/React.createElement("path", {
    d: "M112 51v-1h1v1z",
    fill: "#e5a26a"
  })), _path3317 || (_path3317 = /*#__PURE__*/React.createElement("path", {
    d: "M114 50v1h-1v-1z",
    fill: "#e3a578"
  })), _path3318 || (_path3318 = /*#__PURE__*/React.createElement("path", {
    d: "M114 50h1v1h-1z",
    fill: "#9c6747"
  })), _path3319 || (_path3319 = /*#__PURE__*/React.createElement("path", {
    d: "M115 51v-1h1v1z",
    fill: "#976040"
  })), _path3320 || (_path3320 = /*#__PURE__*/React.createElement("path", {
    d: "M117 51h-1v-1h1z",
    fill: "#9f6647"
  })), _path3321 || (_path3321 = /*#__PURE__*/React.createElement("path", {
    d: "M117 51v-1h1v1z",
    fill: "#9d6343"
  })), _path3322 || (_path3322 = /*#__PURE__*/React.createElement("path", {
    d: "M119 50v1h-1v-1z",
    fill: "#975c3b"
  })), _path3323 || (_path3323 = /*#__PURE__*/React.createElement("path", {
    d: "M119 50h1v1h-1z",
    fill: "#ab7554"
  })), _path3324 || (_path3324 = /*#__PURE__*/React.createElement("path", {
    d: "M121 51h-1v-1h1z",
    fill: "#ad8364",
    fillOpacity: 0.973
  })), _path3325 || (_path3325 = /*#__PURE__*/React.createElement("path", {
    d: "M122 50v1h-1v-1z",
    fill: "#a48877",
    fillOpacity: 0.176
  })), _path3326 || (_path3326 = /*#__PURE__*/React.createElement("path", {
    d: "M6 51h1v1H6z",
    fill: "#91745e",
    fillOpacity: 0.137
  })), _path3327 || (_path3327 = /*#__PURE__*/React.createElement("path", {
    d: "M7 51h1v1H7z",
    fill: "#a67653",
    fillOpacity: 0.953
  })), _path3328 || (_path3328 = /*#__PURE__*/React.createElement("path", {
    d: "M9 51v1H8v-1z",
    fill: "#a67046"
  })), _path3329 || (_path3329 = /*#__PURE__*/React.createElement("path", {
    d: "M10 51v1H9v-1z",
    fill: "#8b5327"
  })), _path3330 || (_path3330 = /*#__PURE__*/React.createElement("path", {
    d: "M11 51v1h-1v-1z",
    fill: "#8a5024"
  })), _path3331 || (_path3331 = /*#__PURE__*/React.createElement("path", {
    d: "M12 52h-1v-1h1z",
    fill: "#a16c46"
  })), _path3332 || (_path3332 = /*#__PURE__*/React.createElement("path", {
    d: "M13 51v1h-1v-1z",
    fill: "#ad7e5e",
    fillOpacity: 0.843
  })), _path3333 || (_path3333 = /*#__PURE__*/React.createElement("path", {
    d: "M14 52h-1v-1h1z",
    fill: "#b6896a",
    fillOpacity: 0.729
  })), _path3334 || (_path3334 = /*#__PURE__*/React.createElement("path", {
    d: "M14 51h1v1h-1z",
    fill: "#b78e77",
    fillOpacity: 0.702
  })), _path3335 || (_path3335 = /*#__PURE__*/React.createElement("path", {
    d: "M16 51v1h-1v-1z",
    fill: "#bc9485",
    fillOpacity: 0.631
  })), _path3336 || (_path3336 = /*#__PURE__*/React.createElement("path", {
    d: "M17 52h-1v-1h1z",
    fill: "#b99788",
    fillOpacity: 0.549
  })), _path3337 || (_path3337 = /*#__PURE__*/React.createElement("path", {
    d: "M18 51v1h-1v-1z",
    fill: "#ba9c8b",
    fillOpacity: 0.467
  })), _path3338 || (_path3338 = /*#__PURE__*/React.createElement("path", {
    d: "M19 52h-1v-1h1z",
    fill: "#c1a190",
    fillOpacity: 0.373
  })), _path3339 || (_path3339 = /*#__PURE__*/React.createElement("path", {
    d: "M20 51v1h-1v-1z",
    fill: "#c3a596",
    fillOpacity: 0.267
  })), _path3340 || (_path3340 = /*#__PURE__*/React.createElement("path", {
    d: "M21 51v1h-1v-1z",
    fill: "#bca095",
    fillOpacity: 0.18
  })), _path3341 || (_path3341 = /*#__PURE__*/React.createElement("path", {
    d: "M21 52v-1h1v1z",
    fill: "#8e6845",
    fillOpacity: 0.604
  })), _path3342 || (_path3342 = /*#__PURE__*/React.createElement("path", {
    d: "M23 51v1h-1v-1z",
    fill: "#96622d"
  })), _path3343 || (_path3343 = /*#__PURE__*/React.createElement("path", {
    d: "M24 52h-1v-1h1z",
    fill: "#94612b"
  })), _path3344 || (_path3344 = /*#__PURE__*/React.createElement("path", {
    d: "M24 51h1v1h-1z",
    fill: "#8d5c2a"
  })), _path3345 || (_path3345 = /*#__PURE__*/React.createElement("path", {
    d: "M26 52h-1v-1h1z",
    fill: "#7e4b1e"
  })), _path3346 || (_path3346 = /*#__PURE__*/React.createElement("path", {
    d: "M27 51v1h-1v-1z",
    fill: "#804d24"
  })), _path3347 || (_path3347 = /*#__PURE__*/React.createElement("path", {
    d: "M28 52h-1v-1h1z",
    fill: "#794e2c",
    fillOpacity: 0.882
  })), _path3348 || (_path3348 = /*#__PURE__*/React.createElement("path", {
    d: "M39 51v1h-1v-1z",
    fill: "#b59e99",
    fillOpacity: 0.353
  })), _path3349 || (_path3349 = /*#__PURE__*/React.createElement("path", {
    d: "M39 52v-1h1v1z",
    fill: "#bb928b"
  })), _path3350 || (_path3350 = /*#__PURE__*/React.createElement("path", {
    d: "M40 51h1v1h-1z",
    fill: "#b88b82"
  })), _path3351 || (_path3351 = /*#__PURE__*/React.createElement("path", {
    d: "M42 52h-1v-1h1z",
    fill: "#b28877"
  })), _path3352 || (_path3352 = /*#__PURE__*/React.createElement("path", {
    d: "M42 52v-1h1v1z",
    fill: "#815034"
  })), _path3353 || (_path3353 = /*#__PURE__*/React.createElement("path", {
    d: "M44 51v1h-1v-1z",
    fill: "#643e24",
    fillOpacity: 0.467
  })), _path3354 || (_path3354 = /*#__PURE__*/React.createElement("path", {
    d: "M60 52v-1h1v1z",
    fill: "#8d6a4d",
    fillOpacity: 0.424
  })), _path3355 || (_path3355 = /*#__PURE__*/React.createElement("path", {
    d: "M62 52h-1v-1h1z",
    fill: "#97693a"
  })), _path3356 || (_path3356 = /*#__PURE__*/React.createElement("path", {
    d: "M63 51h1v1h-1z",
    fill: "#9a663b"
  })), _path3357 || (_path3357 = /*#__PURE__*/React.createElement("path", {
    d: "M65 51v1h-1v-1z",
    fill: "#975e34"
  })), _path3358 || (_path3358 = /*#__PURE__*/React.createElement("path", {
    d: "M65 51h1v1h-1z",
    fill: "#86593a",
    fillOpacity: 0.514
  })), _path3359 || (_path3359 = /*#__PURE__*/React.createElement("path", {
    d: "M71 52v-1h1v1z",
    fill: "#815d38",
    fillOpacity: 0.247
  })), _path3360 || (_path3360 = /*#__PURE__*/React.createElement("path", {
    d: "M73 52h-1v-1h1z",
    fill: "#946438"
  })), _path3361 || (_path3361 = /*#__PURE__*/React.createElement("path", {
    d: "M73 52v-1h1v1z",
    fill: "#98602f"
  })), _path3362 || (_path3362 = /*#__PURE__*/React.createElement("path", {
    d: "M75 52h-1v-1h1z",
    fill: "#955d2b"
  })), _path3363 || (_path3363 = /*#__PURE__*/React.createElement("path", {
    d: "M76 52h-1v-1h1z",
    fill: "#976232"
  })), _path3364 || (_path3364 = /*#__PURE__*/React.createElement("path", {
    d: "M76 51h1v1h-1z",
    fill: "#98693b"
  })), _path3365 || (_path3365 = /*#__PURE__*/React.createElement("path", {
    d: "M77 51h1v1h-1z",
    fill: "#aa8257"
  })), _path3366 || (_path3366 = /*#__PURE__*/React.createElement("path", {
    d: "M78 52v-1h1v1z",
    fill: "#a77f59"
  })), _path3367 || (_path3367 = /*#__PURE__*/React.createElement("path", {
    d: "M80 52h-1v-1h1z",
    fill: "#98663e"
  })), _path3368 || (_path3368 = /*#__PURE__*/React.createElement("path", {
    d: "M80 52v-1h1v1z",
    fill: "#955f35"
  })), _path3369 || (_path3369 = /*#__PURE__*/React.createElement("path", {
    d: "M82 52h-1v-1h1z",
    fill: "#975a32"
  })), _path3370 || (_path3370 = /*#__PURE__*/React.createElement("path", {
    d: "M83 51v1h-1v-1z",
    fill: "#955a34"
  })), _path3371 || (_path3371 = /*#__PURE__*/React.createElement("path", {
    d: "M83 51h1v1h-1z",
    fill: "#965c35"
  })), _path3372 || (_path3372 = /*#__PURE__*/React.createElement("path", {
    d: "M84 51h1v1h-1z",
    fill: "#955c36"
  })), _path3373 || (_path3373 = /*#__PURE__*/React.createElement("path", {
    d: "M86 51h1v1h-1z",
    fill: "#99613e"
  })), _path3374 || (_path3374 = /*#__PURE__*/React.createElement("path", {
    d: "M88 52h-1v-1h1z",
    fill: "#9a623f"
  })), _path3375 || (_path3375 = /*#__PURE__*/React.createElement("path", {
    d: "M88 51h1v1h-1z",
    fill: "#9b6441"
  })), _path3376 || (_path3376 = /*#__PURE__*/React.createElement("path", {
    d: "M90 51v1h-1v-1z",
    fill: "#9a6442"
  })), _path3377 || (_path3377 = /*#__PURE__*/React.createElement("path", {
    d: "M90 52v-1h1v1z",
    fill: "#996240"
  })), _path3378 || (_path3378 = /*#__PURE__*/React.createElement("path", {
    d: "M92 51v1h-1v-1z",
    fill: "#996341"
  })), _path3379 || (_path3379 = /*#__PURE__*/React.createElement("path", {
    d: "M94 52h-1v-1h1z",
    fill: "#915b39"
  })), _path3380 || (_path3380 = /*#__PURE__*/React.createElement("path", {
    d: "M95 51v1h-1v-1z",
    fill: "#8d5737"
  })), _path3381 || (_path3381 = /*#__PURE__*/React.createElement("path", {
    d: "M96 52h-1v-1h1z",
    fill: "#8a5636"
  })), _path3382 || (_path3382 = /*#__PURE__*/React.createElement("path", {
    d: "M97 52h-1v-1h1z",
    fill: "#824f2f"
  })), _path3383 || (_path3383 = /*#__PURE__*/React.createElement("path", {
    d: "M98 52h-1v-1h1z",
    fill: "#7f4c2c"
  })), _path3384 || (_path3384 = /*#__PURE__*/React.createElement("path", {
    d: "M100 51v1h-1v-1z",
    fill: "#8c5936"
  })), _path3385 || (_path3385 = /*#__PURE__*/React.createElement("path", {
    d: "M101 52h-1v-1h1z",
    fill: "#8a5933"
  })), _path3386 || (_path3386 = /*#__PURE__*/React.createElement("path", {
    d: "M101 52v-1h1v1z",
    fill: "#824d2e"
  })), _path3387 || (_path3387 = /*#__PURE__*/React.createElement("path", {
    d: "M102 51h1v1h-1z",
    fill: "#7c462b"
  })), _path3388 || (_path3388 = /*#__PURE__*/React.createElement("path", {
    d: "M103 52v-1h1v1z",
    fill: "#7d462b"
  })), _path3389 || (_path3389 = /*#__PURE__*/React.createElement("path", {
    d: "M105 52h-1v-1h1z",
    fill: "#945a3b"
  })), _path3390 || (_path3390 = /*#__PURE__*/React.createElement("path", {
    d: "M105 51h1v1h-1z",
    fill: "#c28560"
  })), _path3391 || (_path3391 = /*#__PURE__*/React.createElement("path", {
    d: "M107 51v1h-1v-1z",
    fill: "#cd8f68"
  })), _path3392 || (_path3392 = /*#__PURE__*/React.createElement("path", {
    d: "M107 52v-1h1v1z",
    fill: "#bd805c"
  })), _path3393 || (_path3393 = /*#__PURE__*/React.createElement("path", {
    d: "M109 52h-1v-1h1z",
    fill: "#915a32"
  })), _path3394 || (_path3394 = /*#__PURE__*/React.createElement("path", {
    d: "M110 52h-1v-1h1z",
    fill: "#805127"
  })), _path3395 || (_path3395 = /*#__PURE__*/React.createElement("path", {
    d: "M111 52h-1v-1h1z",
    fill: "#6f4923"
  })), _path3396 || (_path3396 = /*#__PURE__*/React.createElement("path", {
    d: "M112 51v1h-1v-1z",
    fill: "#8a6031"
  })), _path3397 || (_path3397 = /*#__PURE__*/React.createElement("path", {
    d: "M113 52h-1v-1h1z",
    fill: "#e7a46c"
  })), _path3398 || (_path3398 = /*#__PURE__*/React.createElement("path", {
    d: "M113 51h1v1h-1z",
    fill: "#e8a777"
  })), _path3399 || (_path3399 = /*#__PURE__*/React.createElement("path", {
    d: "M114 51h1v1h-1z",
    fill: "#a76d47"
  })), _path3400 || (_path3400 = /*#__PURE__*/React.createElement("path", {
    d: "M115 51h1v1h-1z",
    fill: "#9a6544"
  })), _path3401 || (_path3401 = /*#__PURE__*/React.createElement("path", {
    d: "M116 52v-1h1v1z",
    fill: "#966449",
    fillOpacity: 0.902
  })), _path3402 || (_path3402 = /*#__PURE__*/React.createElement("path", {
    d: "M117 51h1v1h-1z",
    fill: "#965e40",
    fillOpacity: 0.976
  })), _path3403 || (_path3403 = /*#__PURE__*/React.createElement("path", {
    d: "M119 51v1h-1v-1z",
    fill: "#955d3f"
  })), _path3404 || (_path3404 = /*#__PURE__*/React.createElement("path", {
    d: "M119 51h1v1h-1z",
    fill: "#ac7857"
  })), _path3405 || (_path3405 = /*#__PURE__*/React.createElement("path", {
    d: "M121 52h-1v-1h1z",
    fill: "#af8465",
    fillOpacity: 0.953
  })), _path3406 || (_path3406 = /*#__PURE__*/React.createElement("path", {
    d: "M121 52v-1h1v1z",
    fill: "#a08a74",
    fillOpacity: 0.137
  })), _path3407 || (_path3407 = /*#__PURE__*/React.createElement("path", {
    d: "M8 52v1H7v-1z",
    fill: "#a57553",
    fillOpacity: 0.867
  })), _path3408 || (_path3408 = /*#__PURE__*/React.createElement("path", {
    d: "M9 52h1v1H9z",
    fill: "#8d5125"
  })), _path3409 || (_path3409 = /*#__PURE__*/React.createElement("path", {
    d: "M10 52h1v1h-1z",
    fill: "#91552c"
  })), _path3410 || (_path3410 = /*#__PURE__*/React.createElement("path", {
    d: "M12 53h-1v-1h1z",
    fill: "#a86e4a"
  })), _path3411 || (_path3411 = /*#__PURE__*/React.createElement("path", {
    d: "M12 53v-1h1v1z",
    fill: "#a96f48"
  })), _path3412 || (_path3412 = /*#__PURE__*/React.createElement("path", {
    d: "M14 53h-1v-1h1z",
    fill: "#a76d45"
  })), _path3413 || (_path3413 = /*#__PURE__*/React.createElement("path", {
    d: "M15 53h-1v-1h1z",
    fill: "#a86f4a"
  })), _path3414 || (_path3414 = /*#__PURE__*/React.createElement("path", {
    d: "M15 53v-1h1v1z",
    fill: "#a9704e"
  })), _path3415 || (_path3415 = /*#__PURE__*/React.createElement("path", {
    d: "M16 52h1v1h-1z",
    fill: "#ac7150"
  })), _path3416 || (_path3416 = /*#__PURE__*/React.createElement("path", {
    d: "M17 53v-1h1v1z",
    fill: "#ad7352"
  })), _path3417 || (_path3417 = /*#__PURE__*/React.createElement("path", {
    d: "M19 52v1h-1v-1z",
    fill: "#b07858"
  })), _path3418 || (_path3418 = /*#__PURE__*/React.createElement("path", {
    d: "M19 53v-1h1v1z",
    fill: "#af7a5d"
  })), _path3419 || (_path3419 = /*#__PURE__*/React.createElement("path", {
    d: "M20 52h1v1h-1z",
    fill: "#ad775b",
    fillOpacity: 0.976
  })), _path3420 || (_path3420 = /*#__PURE__*/React.createElement("path", {
    d: "M21 52h1v1h-1z",
    fill: "#b07956",
    fillOpacity: 0.976
  })), _path3421 || (_path3421 = /*#__PURE__*/React.createElement("path", {
    d: "M22 52h1v1h-1z",
    fill: "#b27c52"
  })), _path3422 || (_path3422 = /*#__PURE__*/React.createElement("path", {
    d: "M24 52v1h-1v-1z",
    fill: "#ac794d"
  })), _path3423 || (_path3423 = /*#__PURE__*/React.createElement("path", {
    d: "M24 52h1v1h-1z",
    fill: "#a37247"
  })), _path3424 || (_path3424 = /*#__PURE__*/React.createElement("path", {
    d: "M26 52v1h-1v-1z",
    fill: "#97653b"
  })), _path3425 || (_path3425 = /*#__PURE__*/React.createElement("path", {
    d: "M27 53h-1v-1h1z",
    fill: "#905d35"
  })), _path3426 || (_path3426 = /*#__PURE__*/React.createElement("path", {
    d: "M27 52h1v1h-1z",
    fill: "#835531",
    fillOpacity: 0.875
  })), _path3427 || (_path3427 = /*#__PURE__*/React.createElement("path", {
    d: "M29 52v1h-1v-1z",
    fill: "#787878",
    fillOpacity: 0.067
  })), _path3428 || (_path3428 = /*#__PURE__*/React.createElement("path", {
    d: "M38 53v-1h1v1z",
    fill: "#b4a19b",
    fillOpacity: 0.322
  })), _path3429 || (_path3429 = /*#__PURE__*/React.createElement("path", {
    d: "M40 53h-1v-1h1z",
    fill: "#b78f89"
  })), _path3430 || (_path3430 = /*#__PURE__*/React.createElement("path", {
    d: "M41 53h-1v-1h1z",
    fill: "#ba8d86"
  })), _path3431 || (_path3431 = /*#__PURE__*/React.createElement("path", {
    d: "M42 53h-1v-1h1z",
    fill: "#b48b79"
  })), _path3432 || (_path3432 = /*#__PURE__*/React.createElement("path", {
    d: "M42 53v-1h1v1z",
    fill: "#835236"
  })), _path3433 || (_path3433 = /*#__PURE__*/React.createElement("path", {
    d: "M43 52h1v1h-1z",
    fill: "#643c23",
    fillOpacity: 0.478
  })), _path3434 || (_path3434 = /*#__PURE__*/React.createElement("path", {
    d: "M61 53h-1v-1h1z",
    fill: "#937053",
    fillOpacity: 0.408
  })), _path3435 || (_path3435 = /*#__PURE__*/React.createElement("path", {
    d: "M61 52h1v1h-1z",
    fill: "#9b6c3f"
  })), _path3436 || (_path3436 = /*#__PURE__*/React.createElement("path", {
    d: "M63 53h-1v-1h1z",
    fill: "#96683e"
  })), _path3437 || (_path3437 = /*#__PURE__*/React.createElement("path", {
    d: "M63 52h1v1h-1z",
    fill: "#9b683d"
  })), _path3438 || (_path3438 = /*#__PURE__*/React.createElement("path", {
    d: "M65 52v1h-1v-1z",
    fill: "#965f34"
  })), _path3439 || (_path3439 = /*#__PURE__*/React.createElement("path", {
    d: "M66 53h-1v-1h1z",
    fill: "#865737",
    fillOpacity: 0.482
  })), _path3440 || (_path3440 = /*#__PURE__*/React.createElement("path", {
    d: "M72 53h-1v-1h1z",
    fill: "#835b3b",
    fillOpacity: 0.251
  })), _path3441 || (_path3441 = /*#__PURE__*/React.createElement("path", {
    d: "M73 52h1v1h-1z",
    fill: "#955e2e"
  })), _path3442 || (_path3442 = /*#__PURE__*/React.createElement("path", {
    d: "M76 53v-1h1v1z",
    fill: "#986b41"
  })), _path3443 || (_path3443 = /*#__PURE__*/React.createElement("path", {
    d: "M78 52h1v1h-1z",
    fill: "#a77f58",
    fillOpacity: 0.988
  })), _path3444 || (_path3444 = /*#__PURE__*/React.createElement("path", {
    d: "M79 53v-1h1v1z",
    fill: "#906745",
    fillOpacity: 0.561
  })), _path3445 || (_path3445 = /*#__PURE__*/React.createElement("path", {
    d: "M81 53h-1v-1h1z",
    fill: "#865e3e",
    fillOpacity: 0.58
  })), _path3446 || (_path3446 = /*#__PURE__*/React.createElement("path", {
    d: "M82 53h-1v-1h1z",
    fill: "#8a5c3b",
    fillOpacity: 0.745
  })), _path3447 || (_path3447 = /*#__PURE__*/React.createElement("path", {
    d: "M82 53v-1h1v1z",
    fill: "#8a5c3c",
    fillOpacity: 0.875
  })), _path3448 || (_path3448 = /*#__PURE__*/React.createElement("path", {
    d: "M83 52h1v1h-1z",
    fill: "#8e5a39",
    fillOpacity: 0.973
  })), _path3449 || (_path3449 = /*#__PURE__*/React.createElement("path", {
    d: "M84 53v-1h1v1z",
    fill: "#975d39"
  })), _path3450 || (_path3450 = /*#__PURE__*/React.createElement("path", {
    d: "M85 52h1v1h-1z",
    fill: "#9b603a"
  })), _path3451 || (_path3451 = /*#__PURE__*/React.createElement("path", {
    d: "M87 52v1h-1v-1z",
    fill: "#9c633c"
  })), _path3452 || (_path3452 = /*#__PURE__*/React.createElement("path", {
    d: "M88 53h-1v-1h1z",
    fill: "#9a603a"
  })), _path3453 || (_path3453 = /*#__PURE__*/React.createElement("path", {
    d: "M89 52v1h-1v-1z",
    fill: "#975f3a"
  })), _path3454 || (_path3454 = /*#__PURE__*/React.createElement("path", {
    d: "M90 53h-1v-1h1z",
    fill: "#96603b"
  })), _path3455 || (_path3455 = /*#__PURE__*/React.createElement("path", {
    d: "M91 52v1h-1v-1z",
    fill: "#97613b"
  })), _path3456 || (_path3456 = /*#__PURE__*/React.createElement("path", {
    d: "M91 52h1v1h-1z",
    fill: "#98623b"
  })), _path3457 || (_path3457 = /*#__PURE__*/React.createElement("path", {
    d: "M92 53v-1h1v1z",
    fill: "#966138"
  })), _path3458 || (_path3458 = /*#__PURE__*/React.createElement("path", {
    d: "M94 52v1h-1v-1z",
    fill: "#956036"
  })), _path3459 || (_path3459 = /*#__PURE__*/React.createElement("path", {
    d: "M95 52h1v1h-1z",
    fill: "#99623e"
  })), _path3460 || (_path3460 = /*#__PURE__*/React.createElement("path", {
    d: "M96 53v-1h1v1z",
    fill: "#97623f"
  })), _path3461 || (_path3461 = /*#__PURE__*/React.createElement("path", {
    d: "M98 52v1h-1v-1z",
    fill: "#98603d"
  })), _path3462 || (_path3462 = /*#__PURE__*/React.createElement("path", {
    d: "M100 53h-1v-1h1z",
    fill: "#9a6745"
  })), _path3463 || (_path3463 = /*#__PURE__*/React.createElement("path", {
    d: "M101 52v1h-1v-1z",
    fill: "#976647"
  })), _path3464 || (_path3464 = /*#__PURE__*/React.createElement("path", {
    d: "M102 53h-1v-1h1z",
    fill: "#8e593b"
  })), _path3465 || (_path3465 = /*#__PURE__*/React.createElement("path", {
    d: "M102 52h1v1h-1z",
    fill: "#804529"
  })), _path3466 || (_path3466 = /*#__PURE__*/React.createElement("path", {
    d: "M103 53v-1h1v1z",
    fill: "#783b1e"
  })), _path3467 || (_path3467 = /*#__PURE__*/React.createElement("path", {
    d: "M105 53h-1v-1h1z",
    fill: "#814223"
  })), _path3468 || (_path3468 = /*#__PURE__*/React.createElement("path", {
    d: "M106 52v1h-1v-1z",
    fill: "#b1734e"
  })), _path3469 || (_path3469 = /*#__PURE__*/React.createElement("path", {
    d: "M106 53v-1h1v1z",
    fill: "#b97a52"
  })), _path3470 || (_path3470 = /*#__PURE__*/React.createElement("path", {
    d: "M108 53h-1v-1h1z",
    fill: "#b0734e"
  })), _path3471 || (_path3471 = /*#__PURE__*/React.createElement("path", {
    d: "M109 52v1h-1v-1z",
    fill: "#935e35"
  })), _path3472 || (_path3472 = /*#__PURE__*/React.createElement("path", {
    d: "M109 53v-1h1v1z",
    fill: "#805128"
  })), _path3473 || (_path3473 = /*#__PURE__*/React.createElement("path", {
    d: "M110 53v-1h1v1z",
    fill: "#714924"
  })), _path3474 || (_path3474 = /*#__PURE__*/React.createElement("path", {
    d: "M112 53h-1v-1h1z",
    fill: "#8e6331"
  })), _path3475 || (_path3475 = /*#__PURE__*/React.createElement("path", {
    d: "M112 52h1v1h-1z",
    fill: "#e9a770"
  })), _path3476 || (_path3476 = /*#__PURE__*/React.createElement("path", {
    d: "M113 52h1v1h-1z",
    fill: "#dda275",
    fillOpacity: 0.992
  })), _path3477 || (_path3477 = /*#__PURE__*/React.createElement("path", {
    d: "M114 52h1v1h-1z",
    fill: "#946646",
    fillOpacity: 0.733
  })), _path3478 || (_path3478 = /*#__PURE__*/React.createElement("path", {
    d: "M116 52v1h-1v-1z",
    fill: "#835f4a",
    fillOpacity: 0.365
  })), _path3479 || (_path3479 = /*#__PURE__*/React.createElement("path", {
    d: "M118 52v1h-1v-1z",
    fill: "#86583a",
    fillOpacity: 0.918
  })), _path3480 || (_path3480 = /*#__PURE__*/React.createElement("path", {
    d: "M119 53h-1v-1h1z",
    fill: "#9b5f40"
  })), _path3481 || (_path3481 = /*#__PURE__*/React.createElement("path", {
    d: "M120 53h-1v-1h1z",
    fill: "#af7b5b"
  })), _path3482 || (_path3482 = /*#__PURE__*/React.createElement("path", {
    d: "M121 52v1h-1v-1z",
    fill: "#af8566",
    fillOpacity: 0.933
  })), _path3483 || (_path3483 = /*#__PURE__*/React.createElement("path", {
    d: "M8 54H7v-1h1z",
    fill: "#a47250",
    fillOpacity: 0.749
  })), _path3484 || (_path3484 = /*#__PURE__*/React.createElement("path", {
    d: "M9 54H8v-1h1z",
    fill: "#b1764c"
  })), _path3485 || (_path3485 = /*#__PURE__*/React.createElement("path", {
    d: "M9 54v-1h1v1z",
    fill: "#92552b"
  })), _path3486 || (_path3486 = /*#__PURE__*/React.createElement("path", {
    d: "M11 54h-1v-1h1z",
    fill: "#8f5328"
  })), _path3487 || (_path3487 = /*#__PURE__*/React.createElement("path", {
    d: "M11 54v-1h1v1z",
    fill: "#ab714a"
  })), _path3488 || (_path3488 = /*#__PURE__*/React.createElement("path", {
    d: "M13 54h-1v-1h1z",
    fill: "#b57a56"
  })), _path3489 || (_path3489 = /*#__PURE__*/React.createElement("path", {
    d: "M13 54v-1h1v1z",
    fill: "#b17554"
  })), _path3490 || (_path3490 = /*#__PURE__*/React.createElement("path", {
    d: "M15 54h-1v-1h1z",
    fill: "#a96d46"
  })), _path3491 || (_path3491 = /*#__PURE__*/React.createElement("path", {
    d: "M15 54v-1h1v1z",
    fill: "#a3613d"
  })), _path3492 || (_path3492 = /*#__PURE__*/React.createElement("path", {
    d: "M17 54h-1v-1h1z",
    fill: "#a05f34"
  })), _path3493 || (_path3493 = /*#__PURE__*/React.createElement("path", {
    d: "M17 53h1v1h-1z",
    fill: "#9e5e34"
  })), _path3494 || (_path3494 = /*#__PURE__*/React.createElement("path", {
    d: "M19 54h-1v-1h1z",
    fill: "#9e5f36"
  })), _path3495 || (_path3495 = /*#__PURE__*/React.createElement("path", {
    d: "M19 53h1v1h-1z",
    fill: "#9c5d33"
  })), _path3496 || (_path3496 = /*#__PURE__*/React.createElement("path", {
    d: "M21 53v1h-1v-1z",
    fill: "#9c592d"
  })), _path3497 || (_path3497 = /*#__PURE__*/React.createElement("path", {
    d: "M22 53v1h-1v-1z",
    fill: "#9b562a"
  })), _path3498 || (_path3498 = /*#__PURE__*/React.createElement("path", {
    d: "M22 53h1v1h-1z",
    fill: "#99592e"
  })), _path3499 || (_path3499 = /*#__PURE__*/React.createElement("path", {
    d: "M23 54v-1h1v1z",
    fill: "#9e5e32"
  })), _path3500 || (_path3500 = /*#__PURE__*/React.createElement("path", {
    d: "M25 54h-1v-1h1z",
    fill: "#a26337"
  })), _path3501 || (_path3501 = /*#__PURE__*/React.createElement("path", {
    d: "M25 54v-1h1v1z",
    fill: "#a76b3e"
  })), _path3502 || (_path3502 = /*#__PURE__*/React.createElement("path", {
    d: "M27 54h-1v-1h1z",
    fill: "#a76e43"
  })), _path3503 || (_path3503 = /*#__PURE__*/React.createElement("path", {
    d: "M28 53v1h-1v-1z",
    fill: "#a46f46",
    fillOpacity: 0.984
  })), _path3504 || (_path3504 = /*#__PURE__*/React.createElement("path", {
    d: "M29 54h-1v-1h1z",
    fill: "#a3744f",
    fillOpacity: 0.796
  })), _path3505 || (_path3505 = /*#__PURE__*/React.createElement("path", {
    d: "M30 53v1h-1v-1z",
    fill: "#a07451",
    fillOpacity: 0.616
  })), _path3506 || (_path3506 = /*#__PURE__*/React.createElement("path", {
    d: "M30 54v-1h1v1z",
    fill: "#a17e5b",
    fillOpacity: 0.427
  })), _path3507 || (_path3507 = /*#__PURE__*/React.createElement("path", {
    d: "M31 53h1v1h-1z",
    fill: "#977b5b",
    fillOpacity: 0.251
  })), _path3508 || (_path3508 = /*#__PURE__*/React.createElement("path", {
    d: "M32 54v-1h1v1z",
    fill: "#977a67",
    fillOpacity: 0.106
  })), _path3509 || (_path3509 = /*#__PURE__*/React.createElement("path", {
    d: "M38 54v-1h1v1z",
    fill: "#af9995",
    fillOpacity: 0.314
  })), _path3510 || (_path3510 = /*#__PURE__*/React.createElement("path", {
    d: "M40 53v1h-1v-1z",
    fill: "#b68d85"
  })), _path3511 || (_path3511 = /*#__PURE__*/React.createElement("path", {
    d: "M41 54h-1v-1h1z",
    fill: "#b98c87"
  })), _path3512 || (_path3512 = /*#__PURE__*/React.createElement("path", {
    d: "M41 53h1v1h-1z",
    fill: "#b48c7d"
  })), _path3513 || (_path3513 = /*#__PURE__*/React.createElement("path", {
    d: "M42 53h1v1h-1z",
    fill: "#825339"
  })), _path3514 || (_path3514 = /*#__PURE__*/React.createElement("path", {
    d: "M44 53v1h-1v-1z",
    fill: "#623d25",
    fillOpacity: 0.486
  })), _path3515 || (_path3515 = /*#__PURE__*/React.createElement("path", {
    d: "M60 53h1v1h-1z",
    fill: "#8d6e51",
    fillOpacity: 0.38
  })), _path3516 || (_path3516 = /*#__PURE__*/React.createElement("path", {
    d: "M62 53v1h-1v-1z",
    fill: "#9b6c42"
  })), _path3517 || (_path3517 = /*#__PURE__*/React.createElement("path", {
    d: "M62 54v-1h1v1z",
    fill: "#96693d"
  })), _path3518 || (_path3518 = /*#__PURE__*/React.createElement("path", {
    d: "M65 53h1v1h-1z",
    fill: "#865a36",
    fillOpacity: 0.455
  })), _path3519 || (_path3519 = /*#__PURE__*/React.createElement("path", {
    d: "M72 54h-1v-1h1z",
    fill: "#896540",
    fillOpacity: 0.247
  })), _path3520 || (_path3520 = /*#__PURE__*/React.createElement("path", {
    d: "M72 53h1v1h-1z",
    fill: "#926237"
  })), _path3521 || (_path3521 = /*#__PURE__*/React.createElement("path", {
    d: "M73 53h1v1h-1z",
    fill: "#97602e"
  })), _path3522 || (_path3522 = /*#__PURE__*/React.createElement("path", {
    d: "M74 53h1v1h-1z",
    fill: "#996331"
  })), _path3523 || (_path3523 = /*#__PURE__*/React.createElement("path", {
    d: "M76 53v1h-1v-1z",
    fill: "#9d6a3c"
  })), _path3524 || (_path3524 = /*#__PURE__*/React.createElement("path", {
    d: "M76 53h1v1h-1z",
    fill: "#997045"
  })), _path3525 || (_path3525 = /*#__PURE__*/React.createElement("path", {
    d: "M78 53v1h-1v-1z",
    fill: "#a88050"
  })), _path3526 || (_path3526 = /*#__PURE__*/React.createElement("path", {
    d: "M78 54v-1h1v1z",
    fill: "#a1794f",
    fillOpacity: 0.969
  })), _path3527 || (_path3527 = /*#__PURE__*/React.createElement("path", {
    d: "M80 54h-1v-1h1z",
    fill: "#97826e",
    fillOpacity: 0.145
  })), _path3528 || (_path3528 = /*#__PURE__*/React.createElement("path", {
    d: "M83 54v-1h1v1z",
    fill: "#855c45",
    fillOpacity: 0.173
  })), _path3529 || (_path3529 = /*#__PURE__*/React.createElement("path", {
    d: "M85 53v1h-1v-1z",
    fill: "#8f5f42",
    fillOpacity: 0.314
  })), _path3530 || (_path3530 = /*#__PURE__*/React.createElement("path", {
    d: "M85 54v-1h1v1z",
    fill: "#8d5e3c",
    fillOpacity: 0.467
  })), _path3531 || (_path3531 = /*#__PURE__*/React.createElement("path", {
    d: "M86 53h1v1h-1z",
    fill: "#8c5d3b",
    fillOpacity: 0.655
  })), _path3532 || (_path3532 = /*#__PURE__*/React.createElement("path", {
    d: "M88 53v1h-1v-1z",
    fill: "#8f5b3d",
    fillOpacity: 0.808
  })), _path3533 || (_path3533 = /*#__PURE__*/React.createElement("path", {
    d: "M88 53h1v1h-1z",
    fill: "#925c3d",
    fillOpacity: 0.91
  })), _path3534 || (_path3534 = /*#__PURE__*/React.createElement("path", {
    d: "M89 53h1v1h-1z",
    fill: "#945f3c",
    fillOpacity: 0.965
  })), _path3535 || (_path3535 = /*#__PURE__*/React.createElement("path", {
    d: "M91 53v1h-1v-1z",
    fill: "#96613c",
    fillOpacity: 0.996
  })), _path3536 || (_path3536 = /*#__PURE__*/React.createElement("path", {
    d: "M91 53h1v1h-1z",
    fill: "#98613a"
  })), _path3537 || (_path3537 = /*#__PURE__*/React.createElement("path", {
    d: "M94 54h-1v-1h1z",
    fill: "#945e35"
  })), _path3538 || (_path3538 = /*#__PURE__*/React.createElement("path", {
    d: "M94 53h1v1h-1z",
    fill: "#975d35"
  })), _path3539 || (_path3539 = /*#__PURE__*/React.createElement("path", {
    d: "M97 54v-1h1v1z",
    fill: "#9a5e38"
  })), _path3540 || (_path3540 = /*#__PURE__*/React.createElement("path", {
    d: "M99 53v1h-1v-1z",
    fill: "#965e38"
  })), _path3541 || (_path3541 = /*#__PURE__*/React.createElement("path", {
    d: "M100 54v-1h1v1z",
    fill: "#976141"
  })), _path3542 || (_path3542 = /*#__PURE__*/React.createElement("path", {
    d: "M102 53v1h-1v-1z",
    fill: "#945d3c"
  })), _path3543 || (_path3543 = /*#__PURE__*/React.createElement("path", {
    d: "M102 54v-1h1v1z",
    fill: "#804626"
  })), _path3544 || (_path3544 = /*#__PURE__*/React.createElement("path", {
    d: "M104 54h-1v-1h1z",
    fill: "#7c3c1a"
  })), _path3545 || (_path3545 = /*#__PURE__*/React.createElement("path", {
    d: "M105 53v1h-1v-1z",
    fill: "#985734"
  })), _path3546 || (_path3546 = /*#__PURE__*/React.createElement("path", {
    d: "M105 54v-1h1v1z",
    fill: "#bd805b"
  })), _path3547 || (_path3547 = /*#__PURE__*/React.createElement("path", {
    d: "M107 54h-1v-1h1z",
    fill: "#c2845f"
  })), _path3548 || (_path3548 = /*#__PURE__*/React.createElement("path", {
    d: "M108 53v1h-1v-1z",
    fill: "#bd7b57"
  })), _path3549 || (_path3549 = /*#__PURE__*/React.createElement("path", {
    d: "M109 54h-1v-1h1z",
    fill: "#935f35"
  })), _path3550 || (_path3550 = /*#__PURE__*/React.createElement("path", {
    d: "M110 54h-1v-1h1z",
    fill: "#835229"
  })), _path3551 || (_path3551 = /*#__PURE__*/React.createElement("path", {
    d: "M110 54v-1h1v1z",
    fill: "#714922"
  })), _path3552 || (_path3552 = /*#__PURE__*/React.createElement("path", {
    d: "M112 53v1h-1v-1z",
    fill: "#90632e"
  })), _path3553 || (_path3553 = /*#__PURE__*/React.createElement("path", {
    d: "M112 53h1v1h-1z",
    fill: "#eba76d"
  })), _path3554 || (_path3554 = /*#__PURE__*/React.createElement("path", {
    d: "M114 53v1h-1v-1z",
    fill: "#dda475",
    fillOpacity: 0.902
  })), _path3555 || (_path3555 = /*#__PURE__*/React.createElement("path", {
    d: "M114 53h1v1h-1z",
    fill: "#cfafaf",
    fillOpacity: 0.063
  })), _path3556 || (_path3556 = /*#__PURE__*/React.createElement("path", {
    d: "M117 53v1h-1v-1z",
    fill: "#83736c",
    fillOpacity: 0.129
  })), _path3557 || (_path3557 = /*#__PURE__*/React.createElement("path", {
    d: "M117 53h1v1h-1z",
    fill: "#86593e",
    fillOpacity: 0.949
  })), _path3558 || (_path3558 = /*#__PURE__*/React.createElement("path", {
    d: "M119 53v1h-1v-1z",
    fill: "#99603f"
  })), _path3559 || (_path3559 = /*#__PURE__*/React.createElement("path", {
    d: "M121 54h-1v-1h1z",
    fill: "#b08666",
    fillOpacity: 0.914
  })), _path3560 || (_path3560 = /*#__PURE__*/React.createElement("path", {
    d: "M121 53h1v1h-1z",
    fill: "#a27f68",
    fillOpacity: 0.086
  })), _path3561 || (_path3561 = /*#__PURE__*/React.createElement("path", {
    d: "M7 54h1v1H7z",
    fill: "#a0704d",
    fillOpacity: 0.616
  })), _path3562 || (_path3562 = /*#__PURE__*/React.createElement("path", {
    d: "M8 55v-1h1v1z",
    fill: "#b57c4f"
  })), _path3563 || (_path3563 = /*#__PURE__*/React.createElement("path", {
    d: "M10 54v1H9v-1z",
    fill: "#935a2f"
  })), _path3564 || (_path3564 = /*#__PURE__*/React.createElement("path", {
    d: "M10 55v-1h1v1z",
    fill: "#864b1f"
  })), _path3565 || (_path3565 = /*#__PURE__*/React.createElement("path", {
    d: "M11 54h1v1h-1z",
    fill: "#955a30"
  })), _path3566 || (_path3566 = /*#__PURE__*/React.createElement("path", {
    d: "M13 54v1h-1v-1z",
    fill: "#a26b41"
  })), _path3567 || (_path3567 = /*#__PURE__*/React.createElement("path", {
    d: "M13 54h1v1h-1z",
    fill: "#ae7759"
  })), _path3568 || (_path3568 = /*#__PURE__*/React.createElement("path", {
    d: "M14 54h1v1h-1z",
    fill: "#ba7e5b"
  })), _path3569 || (_path3569 = /*#__PURE__*/React.createElement("path", {
    d: "M16 54v1h-1v-1z",
    fill: "#b07752"
  })), _path3570 || (_path3570 = /*#__PURE__*/React.createElement("path", {
    d: "M16 54h1v1h-1z",
    fill: "#a87144"
  })), _path3571 || (_path3571 = /*#__PURE__*/React.createElement("path", {
    d: "M18 54v1h-1v-1z",
    fill: "#a86b43"
  })), _path3572 || (_path3572 = /*#__PURE__*/React.createElement("path", {
    d: "M19 54v1h-1v-1z",
    fill: "#a3653e"
  })), _path3573 || (_path3573 = /*#__PURE__*/React.createElement("path", {
    d: "M20 55h-1v-1h1z",
    fill: "#a06139"
  })), _path3574 || (_path3574 = /*#__PURE__*/React.createElement("path", {
    d: "M20 54h1v1h-1z",
    fill: "#9d5b2f"
  })), _path3575 || (_path3575 = /*#__PURE__*/React.createElement("path", {
    d: "M21 54h1v1h-1z",
    fill: "#9c5929"
  })), _path3576 || (_path3576 = /*#__PURE__*/React.createElement("path", {
    d: "M22 55v-1h1v1z",
    fill: "#9a5728"
  })), _path3577 || (_path3577 = /*#__PURE__*/React.createElement("path", {
    d: "M24 54v1h-1v-1z",
    fill: "#995729"
  })), _path3578 || (_path3578 = /*#__PURE__*/React.createElement("path", {
    d: "M24 55v-1h1v1z",
    fill: "#9a572a"
  })), _path3579 || (_path3579 = /*#__PURE__*/React.createElement("path", {
    d: "M26 55h-1v-1h1z",
    fill: "#9a562b"
  })), _path3580 || (_path3580 = /*#__PURE__*/React.createElement("path", {
    d: "M27 54v1h-1v-1z",
    fill: "#9a572c"
  })), _path3581 || (_path3581 = /*#__PURE__*/React.createElement("path", {
    d: "M27 55v-1h1v1z",
    fill: "#9a5a2f"
  })), _path3582 || (_path3582 = /*#__PURE__*/React.createElement("path", {
    d: "M29 54v1h-1v-1z",
    fill: "#a06037"
  })), _path3583 || (_path3583 = /*#__PURE__*/React.createElement("path", {
    d: "M29 55v-1h1v1z",
    fill: "#a56841"
  })), _path3584 || (_path3584 = /*#__PURE__*/React.createElement("path", {
    d: "M31 54v1h-1v-1z",
    fill: "#a9724c"
  })), _path3585 || (_path3585 = /*#__PURE__*/React.createElement("path", {
    d: "M32 54v1h-1v-1z",
    fill: "#a67455"
  })), _path3586 || (_path3586 = /*#__PURE__*/React.createElement("path", {
    d: "M32 55v-1h1v1z",
    fill: "#a47257",
    fillOpacity: 0.918
  })), _path3587 || (_path3587 = /*#__PURE__*/React.createElement("path", {
    d: "M33 54h1v1h-1z",
    fill: "#9f7050",
    fillOpacity: 0.773
  })), _path3588 || (_path3588 = /*#__PURE__*/React.createElement("path", {
    d: "M35 55h-1v-1h1z",
    fill: "#8d6446",
    fillOpacity: 0.565
  })), _path3589 || (_path3589 = /*#__PURE__*/React.createElement("path", {
    d: "M35 54h1v1h-1z",
    fill: "#856141",
    fillOpacity: 0.337
  })), _path3590 || (_path3590 = /*#__PURE__*/React.createElement("path", {
    d: "M37 55h-1v-1h1z",
    fill: "#7f6331",
    fillOpacity: 0.141
  })), _path3591 || (_path3591 = /*#__PURE__*/React.createElement("path", {
    d: "M38 55h-1v-1h1z",
    fill: "#484800",
    fillOpacity: 0.027
  })), _path3592 || (_path3592 = /*#__PURE__*/React.createElement("path", {
    d: "M39 54v1h-1v-1z",
    fill: "#b7a1a1",
    fillOpacity: 0.267
  })), _path3593 || (_path3593 = /*#__PURE__*/React.createElement("path", {
    d: "M39 54h1v1h-1z",
    fill: "#b48e86",
    fillOpacity: 0.996
  })), _path3594 || (_path3594 = /*#__PURE__*/React.createElement("path", {
    d: "M40 54h1v1h-1z",
    fill: "#bb9087"
  })), _path3595 || (_path3595 = /*#__PURE__*/React.createElement("path", {
    d: "M42 54v1h-1v-1z",
    fill: "#b58e80"
  })), _path3596 || (_path3596 = /*#__PURE__*/React.createElement("path", {
    d: "M44 54v1h-1v-1z",
    fill: "#613e28",
    fillOpacity: 0.494
  })), _path3597 || (_path3597 = /*#__PURE__*/React.createElement("path", {
    d: "M60 54h1v1h-1z",
    fill: "#886b4e",
    fillOpacity: 0.345
  })), _path3598 || (_path3598 = /*#__PURE__*/React.createElement("path", {
    d: "M62 55h-1v-1h1z",
    fill: "#996c43"
  })), _path3599 || (_path3599 = /*#__PURE__*/React.createElement("path", {
    d: "M63 54v1h-1v-1z",
    fill: "#95693c"
  })), _path3600 || (_path3600 = /*#__PURE__*/React.createElement("path", {
    d: "M65 54v1h-1v-1z",
    fill: "#945e37"
  })), _path3601 || (_path3601 = /*#__PURE__*/React.createElement("path", {
    d: "M66 55h-1v-1h1z",
    fill: "#875937",
    fillOpacity: 0.435
  })), _path3602 || (_path3602 = /*#__PURE__*/React.createElement("path", {
    d: "M72 54v1h-1v-1z",
    fill: "#8b6241",
    fillOpacity: 0.243
  })), _path3603 || (_path3603 = /*#__PURE__*/React.createElement("path", {
    d: "M73 55v-1h1v1z",
    fill: "#9a6330"
  })), _path3604 || (_path3604 = /*#__PURE__*/React.createElement("path", {
    d: "M75 54v1h-1v-1z",
    fill: "#a36c39"
  })), _path3605 || (_path3605 = /*#__PURE__*/React.createElement("path", {
    d: "M75 54h1v1h-1z",
    fill: "#a87446"
  })), _path3606 || (_path3606 = /*#__PURE__*/React.createElement("path", {
    d: "M76 54h1v1h-1z",
    fill: "#9a6f42"
  })), _path3607 || (_path3607 = /*#__PURE__*/React.createElement("path", {
    d: "M78 54v1h-1v-1z",
    fill: "#9a6f3d"
  })), _path3608 || (_path3608 = /*#__PURE__*/React.createElement("path", {
    d: "M78 54h1v1h-1z",
    fill: "#a07a4d",
    fillOpacity: 0.973
  })), _path3609 || (_path3609 = /*#__PURE__*/React.createElement("path", {
    d: "M80 55h-1v-1h1z",
    fill: "#a48871",
    fillOpacity: 0.176
  })), _path3610 || (_path3610 = /*#__PURE__*/React.createElement("path", {
    d: "M88 54h1v1h-1z",
    fill: "#715a49",
    fillOpacity: 0.176
  })), _path3611 || (_path3611 = /*#__PURE__*/React.createElement("path", {
    d: "M90 55h-1v-1h1z",
    fill: "#7a5142",
    fillOpacity: 0.439
  })), _path3612 || (_path3612 = /*#__PURE__*/React.createElement("path", {
    d: "M91 55h-1v-1h1z",
    fill: "#855134",
    fillOpacity: 0.882
  })), _path3613 || (_path3613 = /*#__PURE__*/React.createElement("path", {
    d: "M92 54v1h-1v-1z",
    fill: "#955c3a"
  })), _path3614 || (_path3614 = /*#__PURE__*/React.createElement("path", {
    d: "M94 54v1h-1v-1z",
    fill: "#98623c"
  })), _path3615 || (_path3615 = /*#__PURE__*/React.createElement("path", {
    d: "M94 55v-1h1v1z",
    fill: "#95603c"
  })), _path3616 || (_path3616 = /*#__PURE__*/React.createElement("path", {
    d: "M95 54h1v1h-1z",
    fill: "#985f39"
  })), _path3617 || (_path3617 = /*#__PURE__*/React.createElement("path", {
    d: "M97 54v1h-1v-1z",
    fill: "#975e36"
  })), _path3618 || (_path3618 = /*#__PURE__*/React.createElement("path", {
    d: "M97 55v-1h1v1z",
    fill: "#9c5d3a"
  })), _path3619 || (_path3619 = /*#__PURE__*/React.createElement("path", {
    d: "M99 55h-1v-1h1z",
    fill: "#985e38"
  })), _path3620 || (_path3620 = /*#__PURE__*/React.createElement("path", {
    d: "M100 54v1h-1v-1z",
    fill: "#985e37"
  })), _path3621 || (_path3621 = /*#__PURE__*/React.createElement("path", {
    d: "M101 55h-1v-1h1z",
    fill: "#945b35"
  })), _path3622 || (_path3622 = /*#__PURE__*/React.createElement("path", {
    d: "M103 55h-1v-1h1z",
    fill: "#844721"
  })), _path3623 || (_path3623 = /*#__PURE__*/React.createElement("path", {
    d: "M104 54v1h-1v-1z",
    fill: "#7c3e19"
  })), _path3624 || (_path3624 = /*#__PURE__*/React.createElement("path", {
    d: "M104 54h1v1h-1z",
    fill: "#a4643f"
  })), _path3625 || (_path3625 = /*#__PURE__*/React.createElement("path", {
    d: "M105 54h1v1h-1z",
    fill: "#c4835c"
  })), _path3626 || (_path3626 = /*#__PURE__*/React.createElement("path", {
    d: "M107 54v1h-1v-1z",
    fill: "#cf8c62"
  })), _path3627 || (_path3627 = /*#__PURE__*/React.createElement("path", {
    d: "M108 54v1h-1v-1z",
    fill: "#c9865f"
  })), _path3628 || (_path3628 = /*#__PURE__*/React.createElement("path", {
    d: "M108 54h1v1h-1z",
    fill: "#936133"
  })), _path3629 || (_path3629 = /*#__PURE__*/React.createElement("path", {
    d: "M109 55v-1h1v1z",
    fill: "#835326"
  })), _path3630 || (_path3630 = /*#__PURE__*/React.createElement("path", {
    d: "M110 55v-1h1v1z",
    fill: "#70491f"
  })), _path3631 || (_path3631 = /*#__PURE__*/React.createElement("path", {
    d: "M111 55v-1h1v1z",
    fill: "#926530"
  })), _path3632 || (_path3632 = /*#__PURE__*/React.createElement("path", {
    d: "M113 54v1h-1v-1z",
    fill: "#eca86b"
  })), _path3633 || (_path3633 = /*#__PURE__*/React.createElement("path", {
    d: "M114 55h-1v-1h1z",
    fill: "#e1a573",
    fillOpacity: 0.882
  })), _path3634 || (_path3634 = /*#__PURE__*/React.createElement("path", {
    d: "M114 54h1v1h-1z",
    fill: "#c4b0b0",
    fillOpacity: 0.051
  })), _path3635 || (_path3635 = /*#__PURE__*/React.createElement("path", {
    d: "M118 54v1h-1v-1z",
    fill: "#87583e",
    fillOpacity: 0.965
  })), _path3636 || (_path3636 = /*#__PURE__*/React.createElement("path", {
    d: "M119 54v1h-1v-1z",
    fill: "#97613f"
  })), _path3637 || (_path3637 = /*#__PURE__*/React.createElement("path", {
    d: "M121 54v1h-1v-1z",
    fill: "#b2896a",
    fillOpacity: 0.902
  })), _path3638 || (_path3638 = /*#__PURE__*/React.createElement("path", {
    d: "M121 55v-1h1v1z",
    fill: "#998c72",
    fillOpacity: 0.078
  })), _path3639 || (_path3639 = /*#__PURE__*/React.createElement("path", {
    d: "M8 55v1H7v-1z",
    fill: "#9d7051",
    fillOpacity: 0.49
  })), _path3640 || (_path3640 = /*#__PURE__*/React.createElement("path", {
    d: "M9 55v1H8v-1z",
    fill: "#b37c50"
  })), _path3641 || (_path3641 = /*#__PURE__*/React.createElement("path", {
    d: "M9 55h1v1H9z",
    fill: "#945f34"
  })), _path3642 || (_path3642 = /*#__PURE__*/React.createElement("path", {
    d: "M11 56h-1v-1h1z",
    fill: "#844c23"
  })), _path3643 || (_path3643 = /*#__PURE__*/React.createElement("path", {
    d: "M11 55h1v1h-1z",
    fill: "#874c22"
  })), _path3644 || (_path3644 = /*#__PURE__*/React.createElement("path", {
    d: "M13 56h-1v-1h1z",
    fill: "#824a24",
    fillOpacity: 0.902
  })), _path3645 || (_path3645 = /*#__PURE__*/React.createElement("path", {
    d: "M14 55v1h-1v-1z",
    fill: "#8c6047",
    fillOpacity: 0.392
  })), _path3646 || (_path3646 = /*#__PURE__*/React.createElement("path", {
    d: "M15 56h-1v-1h1z",
    fill: "#916949",
    fillOpacity: 0.596
  })), _path3647 || (_path3647 = /*#__PURE__*/React.createElement("path", {
    d: "M15 55h1v1h-1z",
    fill: "#9d6c4a",
    fillOpacity: 0.831
  })), _path3648 || (_path3648 = /*#__PURE__*/React.createElement("path", {
    d: "M17 55v1h-1v-1z",
    fill: "#a27049",
    fillOpacity: 0.969
  })), _path3649 || (_path3649 = /*#__PURE__*/React.createElement("path", {
    d: "M17 55h1v1h-1z",
    fill: "#ae7953"
  })), _path3650 || (_path3650 = /*#__PURE__*/React.createElement("path", {
    d: "M18 56v-1h1v1z",
    fill: "#b0764f"
  })), _path3651 || (_path3651 = /*#__PURE__*/React.createElement("path", {
    d: "M19 55h1v1h-1z",
    fill: "#b1724a"
  })), _path3652 || (_path3652 = /*#__PURE__*/React.createElement("path", {
    d: "M20 55h1v1h-1z",
    fill: "#ab693e"
  })), _path3653 || (_path3653 = /*#__PURE__*/React.createElement("path", {
    d: "M21 55h1v1h-1z",
    fill: "#a45f33"
  })), _path3654 || (_path3654 = /*#__PURE__*/React.createElement("path", {
    d: "M22 55h1v1h-1z",
    fill: "#a45d31"
  })), _path3655 || (_path3655 = /*#__PURE__*/React.createElement("path", {
    d: "M24 55v1h-1v-1z",
    fill: "#9f5a2f"
  })), _path3656 || (_path3656 = /*#__PURE__*/React.createElement("path", {
    d: "M26 55v1h-1v-1z",
    fill: "#9c572e"
  })), _path3657 || (_path3657 = /*#__PURE__*/React.createElement("path", {
    d: "M27 56v-1h1v1z",
    fill: "#9e5a30"
  })), _path3658 || (_path3658 = /*#__PURE__*/React.createElement("path", {
    d: "M28 55h1v1h-1z",
    fill: "#9f5c36"
  })), _path3659 || (_path3659 = /*#__PURE__*/React.createElement("path", {
    d: "M29 55h1v1h-1z",
    fill: "#a16241"
  })), _path3660 || (_path3660 = /*#__PURE__*/React.createElement("path", {
    d: "M31 55v1h-1v-1z",
    fill: "#aa6f50"
  })), _path3661 || (_path3661 = /*#__PURE__*/React.createElement("path", {
    d: "M32 56h-1v-1h1z",
    fill: "#b37d65"
  })), _path3662 || (_path3662 = /*#__PURE__*/React.createElement("path", {
    d: "M33 55v1h-1v-1z",
    fill: "#bf8c79"
  })), _path3663 || (_path3663 = /*#__PURE__*/React.createElement("path", {
    d: "M34 56h-1v-1h1z",
    fill: "#ca9887"
  })), _path3664 || (_path3664 = /*#__PURE__*/React.createElement("path", {
    d: "M35 56h-1v-1h1z",
    fill: "#c59381"
  })), _path3665 || (_path3665 = /*#__PURE__*/React.createElement("path", {
    d: "M35 56v-1h1v1z",
    fill: "#b88772"
  })), _path3666 || (_path3666 = /*#__PURE__*/React.createElement("path", {
    d: "M37 56h-1v-1h1z",
    fill: "#a7785d",
    fillOpacity: 0.953
  })), _path3667 || (_path3667 = /*#__PURE__*/React.createElement("path", {
    d: "M38 55v1h-1v-1z",
    fill: "#91694a",
    fillOpacity: 0.831
  })), _path3668 || (_path3668 = /*#__PURE__*/React.createElement("path", {
    d: "M38 56v-1h1v1z",
    fill: "#a07567",
    fillOpacity: 0.773
  })), _path3669 || (_path3669 = /*#__PURE__*/React.createElement("path", {
    d: "M40 56h-1v-1h1z",
    fill: "#b98d85",
    fillOpacity: 0.996
  })), _path3670 || (_path3670 = /*#__PURE__*/React.createElement("path", {
    d: "M40 56v-1h1v1z",
    fill: "#bd918a"
  })), _path3671 || (_path3671 = /*#__PURE__*/React.createElement("path", {
    d: "M41 55h1v1h-1z",
    fill: "#b58e81"
  })), _path3672 || (_path3672 = /*#__PURE__*/React.createElement("path", {
    d: "M43 55h1v1h-1z",
    fill: "#634028",
    fillOpacity: 0.514
  })), _path3673 || (_path3673 = /*#__PURE__*/React.createElement("path", {
    d: "M61 55v1h-1v-1z",
    fill: "#89694c",
    fillOpacity: 0.314
  })), _path3674 || (_path3674 = /*#__PURE__*/React.createElement("path", {
    d: "M62 55v1h-1v-1z",
    fill: "#996b43"
  })), _path3675 || (_path3675 = /*#__PURE__*/React.createElement("path", {
    d: "M65 56h-1v-1h1z",
    fill: "#945f37"
  })), _path3676 || (_path3676 = /*#__PURE__*/React.createElement("path", {
    d: "M65 55h1v1h-1z",
    fill: "#845936",
    fillOpacity: 0.424
  })), _path3677 || (_path3677 = /*#__PURE__*/React.createElement("path", {
    d: "M72 56h-1v-1h1z",
    fill: "#85603e",
    fillOpacity: 0.239
  })), _path3678 || (_path3678 = /*#__PURE__*/React.createElement("path", {
    d: "M74 55v1h-1v-1z",
    fill: "#9d6735"
  })), _path3679 || (_path3679 = /*#__PURE__*/React.createElement("path", {
    d: "M74 56v-1h1v1z",
    fill: "#a87341"
  })), _path3680 || (_path3680 = /*#__PURE__*/React.createElement("path", {
    d: "M76 55v1h-1v-1z",
    fill: "#aa7848"
  })), _path3681 || (_path3681 = /*#__PURE__*/React.createElement("path", {
    d: "M76 56v-1h1v1z",
    fill: "#9c7041"
  })), _path3682 || (_path3682 = /*#__PURE__*/React.createElement("path", {
    d: "M78 55v1h-1v-1z",
    fill: "#9e713c"
  })), _path3683 || (_path3683 = /*#__PURE__*/React.createElement("path", {
    d: "M79 55v1h-1v-1z",
    fill: "#a2784b",
    fillOpacity: 0.976
  })), _path3684 || (_path3684 = /*#__PURE__*/React.createElement("path", {
    d: "M79 56v-1h1v1z",
    fill: "#a2856e",
    fillOpacity: 0.173
  })), _path3685 || (_path3685 = /*#__PURE__*/React.createElement("path", {
    d: "M84 55v1h-1v-1z",
    fill: "#557f7f",
    fillOpacity: 0.024
  })), _path3686 || (_path3686 = /*#__PURE__*/React.createElement("path", {
    d: "M85 55v1h-1v-1z",
    fill: "#5c3d36",
    fillOpacity: 0.129
  })), _path3687 || (_path3687 = /*#__PURE__*/React.createElement("path", {
    d: "M86 55v1h-1v-1z",
    fill: "#573528",
    fillOpacity: 0.298
  })), _path3688 || (_path3688 = /*#__PURE__*/React.createElement("path", {
    d: "M86 55h1v1h-1z",
    fill: "#613626",
    fillOpacity: 0.514
  })), _path3689 || (_path3689 = /*#__PURE__*/React.createElement("path", {
    d: "M87 55h1v1h-1z",
    fill: "#663727",
    fillOpacity: 0.733
  })), _path3690 || (_path3690 = /*#__PURE__*/React.createElement("path", {
    d: "M88 56v-1h1v1z",
    fill: "#673824",
    fillOpacity: 0.91
  })), _path3691 || (_path3691 = /*#__PURE__*/React.createElement("path", {
    d: "M90 56h-1v-1h1z",
    fill: "#6c3e27",
    fillOpacity: 0.98
  })), _path3692 || (_path3692 = /*#__PURE__*/React.createElement("path", {
    d: "M91 55v1h-1v-1z",
    fill: "#71442e",
    fillOpacity: 0.941
  })), _path3693 || (_path3693 = /*#__PURE__*/React.createElement("path", {
    d: "M91 55h1v1h-1z",
    fill: "#784b37",
    fillOpacity: 0.804
  })), _path3694 || (_path3694 = /*#__PURE__*/React.createElement("path", {
    d: "M92 55h1v1h-1z",
    fill: "#79503b",
    fillOpacity: 0.624
  })), _path3695 || (_path3695 = /*#__PURE__*/React.createElement("path", {
    d: "M93 55h1v1h-1z",
    fill: "#855a44",
    fillOpacity: 0.396
  })), _path3696 || (_path3696 = /*#__PURE__*/React.createElement("path", {
    d: "M95 56h-1v-1h1z",
    fill: "#90684f",
    fillOpacity: 0.525
  })), _path3697 || (_path3697 = /*#__PURE__*/React.createElement("path", {
    d: "M96 55v1h-1v-1z",
    fill: "#996546"
  })), _path3698 || (_path3698 = /*#__PURE__*/React.createElement("path", {
    d: "M96 55h1v1h-1z",
    fill: "#935e3d"
  })), _path3699 || (_path3699 = /*#__PURE__*/React.createElement("path", {
    d: "M97 56v-1h1v1z",
    fill: "#91573a"
  })), _path3700 || (_path3700 = /*#__PURE__*/React.createElement("path", {
    d: "M98 56v-1h1v1z",
    fill: "#925d3b",
    fillOpacity: 0.996
  })), _path3701 || (_path3701 = /*#__PURE__*/React.createElement("path", {
    d: "M100 55v1h-1v-1z",
    fill: "#905c3a",
    fillOpacity: 0.933
  })), _path3702 || (_path3702 = /*#__PURE__*/React.createElement("path", {
    d: "M100 55h1v1h-1z",
    fill: "#8c5a36",
    fillOpacity: 0.965
  })), _path3703 || (_path3703 = /*#__PURE__*/React.createElement("path", {
    d: "M101 55h1v1h-1z",
    fill: "#8a522c"
  })), _path3704 || (_path3704 = /*#__PURE__*/React.createElement("path", {
    d: "M103 55v1h-1v-1z",
    fill: "#85481f"
  })), _path3705 || (_path3705 = /*#__PURE__*/React.createElement("path", {
    d: "M103 55h1v1h-1z",
    fill: "#7d421c"
  })), _path3706 || (_path3706 = /*#__PURE__*/React.createElement("path", {
    d: "M105 56h-1v-1h1z",
    fill: "#a76841"
  })), _path3707 || (_path3707 = /*#__PURE__*/React.createElement("path", {
    d: "M105 56v-1h1v1z",
    fill: "#c6845c"
  })), _path3708 || (_path3708 = /*#__PURE__*/React.createElement("path", {
    d: "M107 56h-1v-1h1z",
    fill: "#c08663",
    fillOpacity: 0.914
  })), _path3709 || (_path3709 = /*#__PURE__*/React.createElement("path", {
    d: "M108 55v1h-1v-1z",
    fill: "#b27d63",
    fillOpacity: 0.643
  })), _path3710 || (_path3710 = /*#__PURE__*/React.createElement("path", {
    d: "M108 56v-1h1v1z",
    fill: "#8f6037",
    fillOpacity: 0.922
  })), _path3711 || (_path3711 = /*#__PURE__*/React.createElement("path", {
    d: "M109 55h1v1h-1z",
    fill: "#85542c"
  })), _path3712 || (_path3712 = /*#__PURE__*/React.createElement("path", {
    d: "M111 56h-1v-1h1z",
    fill: "#714920"
  })), _path3713 || (_path3713 = /*#__PURE__*/React.createElement("path", {
    d: "M112 55v1h-1v-1z",
    fill: "#956833"
  })), _path3714 || (_path3714 = /*#__PURE__*/React.createElement("path", {
    d: "M112 55h1v1h-1z",
    fill: "#f2af70"
  })), _path3715 || (_path3715 = /*#__PURE__*/React.createElement("path", {
    d: "M114 55v1h-1v-1z",
    fill: "#e4ab79",
    fillOpacity: 0.875
  })), _path3716 || (_path3716 = /*#__PURE__*/React.createElement("path", {
    d: "M114 56v-1h1v1z",
    fill: "#aa9494",
    fillOpacity: 0.047
  })), _path3717 || (_path3717 = /*#__PURE__*/React.createElement("path", {
    d: "M117 55v1h-1v-1z",
    fill: "#78605b",
    fillOpacity: 0.208
  })), _path3718 || (_path3718 = /*#__PURE__*/React.createElement("path", {
    d: "M117 56v-1h1v1z",
    fill: "#845239",
    fillOpacity: 0.984
  })), _path3719 || (_path3719 = /*#__PURE__*/React.createElement("path", {
    d: "M119 56v-1h1v1z",
    fill: "#b48160"
  })), _path3720 || (_path3720 = /*#__PURE__*/React.createElement("path", {
    d: "M120 56v-1h1v1z",
    fill: "#b38b6e",
    fillOpacity: 0.89
  })), _path3721 || (_path3721 = /*#__PURE__*/React.createElement("path", {
    d: "M121 55h1v1h-1z",
    fill: "#9b8d71",
    fillOpacity: 0.071
  })), _path3722 || (_path3722 = /*#__PURE__*/React.createElement("path", {
    d: "M8 56v1H7v-1z",
    fill: "#9a6d51",
    fillOpacity: 0.357
  })), _path3723 || (_path3723 = /*#__PURE__*/React.createElement("path", {
    d: "M9 56v1H8v-1z",
    fill: "#b17953"
  })), _path3724 || (_path3724 = /*#__PURE__*/React.createElement("path", {
    d: "M10 56v1H9v-1z",
    fill: "#9c663f"
  })), _path3725 || (_path3725 = /*#__PURE__*/React.createElement("path", {
    d: "M12 57h-1v-1h1z",
    fill: "#884f27"
  })), _path3726 || (_path3726 = /*#__PURE__*/React.createElement("path", {
    d: "M13 56v1h-1v-1z",
    fill: "#7d4b29",
    fillOpacity: 0.929
  })), _path3727 || (_path3727 = /*#__PURE__*/React.createElement("path", {
    d: "M13 57v-1h1v1z",
    fill: "#685145",
    fillOpacity: 0.086
  })), _path3728 || (_path3728 = /*#__PURE__*/React.createElement("path", {
    d: "M16 57v-1h1v1z",
    fill: "#7f5c3f",
    fillOpacity: 0.173
  })), _path3729 || (_path3729 = /*#__PURE__*/React.createElement("path", {
    d: "M18 56v1h-1v-1z",
    fill: "#956949",
    fillOpacity: 0.341
  })), _path3730 || (_path3730 = /*#__PURE__*/React.createElement("path", {
    d: "M18 57v-1h1v1z",
    fill: "#9e6f52",
    fillOpacity: 0.58
  })), _path3731 || (_path3731 = /*#__PURE__*/React.createElement("path", {
    d: "M20 56v1h-1v-1z",
    fill: "#a5704c",
    fillOpacity: 0.784
  })), _path3732 || (_path3732 = /*#__PURE__*/React.createElement("path", {
    d: "M20 57v-1h1v1z",
    fill: "#a76f49",
    fillOpacity: 0.914
  })), _path3733 || (_path3733 = /*#__PURE__*/React.createElement("path", {
    d: "M22 56v1h-1v-1z",
    fill: "#a86c46",
    fillOpacity: 0.984
  })), _path3734 || (_path3734 = /*#__PURE__*/React.createElement("path", {
    d: "M22 56h1v1h-1z",
    fill: "#ae6c41"
  })), _path3735 || (_path3735 = /*#__PURE__*/React.createElement("path", {
    d: "M24 57h-1v-1h1z",
    fill: "#ae6b41"
  })), _path3736 || (_path3736 = /*#__PURE__*/React.createElement("path", {
    d: "M25 57h-1v-1h1z",
    fill: "#ab6b42"
  })), _path3737 || (_path3737 = /*#__PURE__*/React.createElement("path", {
    d: "M25 56h1v1h-1z",
    fill: "#a9693f"
  })), _path3738 || (_path3738 = /*#__PURE__*/React.createElement("path", {
    d: "M27 56v1h-1v-1z",
    fill: "#a66740"
  })), _path3739 || (_path3739 = /*#__PURE__*/React.createElement("path", {
    d: "M28 56h1v1h-1z",
    fill: "#a56641"
  })), _path3740 || (_path3740 = /*#__PURE__*/React.createElement("path", {
    d: "M30 56v1h-1v-1z",
    fill: "#a96744"
  })), _path3741 || (_path3741 = /*#__PURE__*/React.createElement("path", {
    d: "M30 57v-1h1v1z",
    fill: "#ae7052"
  })), _path3742 || (_path3742 = /*#__PURE__*/React.createElement("path", {
    d: "M31 56h1v1h-1z",
    fill: "#b67f6a"
  })), _path3743 || (_path3743 = /*#__PURE__*/React.createElement("path", {
    d: "M32 57v-1h1v1z",
    fill: "#c09083"
  })), _path3744 || (_path3744 = /*#__PURE__*/React.createElement("path", {
    d: "M33 56h1v1h-1z",
    fill: "#c99c94"
  })), _path3745 || (_path3745 = /*#__PURE__*/React.createElement("path", {
    d: "M34 57v-1h1v1z",
    fill: "#d6a9a6"
  })), _path3746 || (_path3746 = /*#__PURE__*/React.createElement("path", {
    d: "M36 56v1h-1v-1z",
    fill: "#ddb2b2"
  })), _path3747 || (_path3747 = /*#__PURE__*/React.createElement("path", {
    d: "M36 56h1v1h-1z",
    fill: "#e0b4b4"
  })), _path3748 || (_path3748 = /*#__PURE__*/React.createElement("path", {
    d: "M38 57h-1v-1h1z",
    fill: "#ddaaa6"
  })), _path3749 || (_path3749 = /*#__PURE__*/React.createElement("path", {
    d: "M39 56v1h-1v-1z",
    fill: "#cf9e98"
  })), _path3750 || (_path3750 = /*#__PURE__*/React.createElement("path", {
    d: "M39 57v-1h1v1z",
    fill: "#b88d87"
  })), _path3751 || (_path3751 = /*#__PURE__*/React.createElement("path", {
    d: "M40 56h1v1h-1z",
    fill: "#bd9088"
  })), _path3752 || (_path3752 = /*#__PURE__*/React.createElement("path", {
    d: "M42 57h-1v-1h1z",
    fill: "#b4897e"
  })), _path3753 || (_path3753 = /*#__PURE__*/React.createElement("path", {
    d: "M42 57v-1h1v1z",
    fill: "#84553d"
  })), _path3754 || (_path3754 = /*#__PURE__*/React.createElement("path", {
    d: "M44 57h-1v-1h1z",
    fill: "#664029",
    fillOpacity: 0.529
  })), _path3755 || (_path3755 = /*#__PURE__*/React.createElement("path", {
    d: "M61 57h-1v-1h1z",
    fill: "#8b6c50",
    fillOpacity: 0.286
  })), _path3756 || (_path3756 = /*#__PURE__*/React.createElement("path", {
    d: "M61 57v-1h1v1z",
    fill: "#9a6b43"
  })), _path3757 || (_path3757 = /*#__PURE__*/React.createElement("path", {
    d: "M63 57h-1v-1h1z",
    fill: "#96673a"
  })), _path3758 || (_path3758 = /*#__PURE__*/React.createElement("path", {
    d: "M63 56h1v1h-1z",
    fill: "#98653c"
  })), _path3759 || (_path3759 = /*#__PURE__*/React.createElement("path", {
    d: "M65 56v1h-1v-1z",
    fill: "#935e37"
  })), _path3760 || (_path3760 = /*#__PURE__*/React.createElement("path", {
    d: "M66 56v1h-1v-1z",
    fill: "#855b36",
    fillOpacity: 0.404
  })), _path3761 || (_path3761 = /*#__PURE__*/React.createElement("path", {
    d: "M71 57v-1h1v1z",
    fill: "#7f5937",
    fillOpacity: 0.235
  })), _path3762 || (_path3762 = /*#__PURE__*/React.createElement("path", {
    d: "M74 57h-1v-1h1z",
    fill: "#a6713f"
  })), _path3763 || (_path3763 = /*#__PURE__*/React.createElement("path", {
    d: "M75 57h-1v-1h1z",
    fill: "#ae7e4c"
  })), _path3764 || (_path3764 = /*#__PURE__*/React.createElement("path", {
    d: "M76 57h-1v-1h1z",
    fill: "#ad7d4c"
  })), _path3765 || (_path3765 = /*#__PURE__*/React.createElement("path", {
    d: "M78 56v1h-1v-1z",
    fill: "#9e723b"
  })), _path3766 || (_path3766 = /*#__PURE__*/React.createElement("path", {
    d: "M78 57v-1h1v1z",
    fill: "#9c7546",
    fillOpacity: 0.961
  })), _path3767 || (_path3767 = /*#__PURE__*/React.createElement("path", {
    d: "M80 56v1h-1v-1z",
    fill: "#876b57",
    fillOpacity: 0.251
  })), _path3768 || (_path3768 = /*#__PURE__*/React.createElement("path", {
    d: "M81 57h-1v-1h1z",
    fill: "#4f2d21",
    fillOpacity: 0.239
  })), _path3769 || (_path3769 = /*#__PURE__*/React.createElement("path", {
    d: "M81 56h1v1h-1z",
    fill: "#553220",
    fillOpacity: 0.455
  })), _path3770 || (_path3770 = /*#__PURE__*/React.createElement("path", {
    d: "M83 56v1h-1v-1z",
    fill: "#57311f",
    fillOpacity: 0.667
  })), _path3771 || (_path3771 = /*#__PURE__*/React.createElement("path", {
    d: "M83 57v-1h1v1z",
    fill: "#653726",
    fillOpacity: 0.851
  })), _path3772 || (_path3772 = /*#__PURE__*/React.createElement("path", {
    d: "M85 57h-1v-1h1z",
    fill: "#693928",
    fillOpacity: 0.973
  })), _path3773 || (_path3773 = /*#__PURE__*/React.createElement("path", {
    d: "M85 57v-1h1v1z",
    fill: "#6c3e27"
  })), _path3774 || (_path3774 = /*#__PURE__*/React.createElement("path", {
    d: "M87 57h-1v-1h1z",
    fill: "#703e28",
    fillOpacity: 0.918
  })), _path3775 || (_path3775 = /*#__PURE__*/React.createElement("path", {
    d: "M88 56v1h-1v-1z",
    fill: "#723d2c",
    fillOpacity: 0.745
  })), _path3776 || (_path3776 = /*#__PURE__*/React.createElement("path", {
    d: "M88 56h1v1h-1z",
    fill: "#794c37",
    fillOpacity: 0.525
  })), _path3777 || (_path3777 = /*#__PURE__*/React.createElement("path", {
    d: "M89 56h1v1h-1z",
    fill: "#785837",
    fillOpacity: 0.306
  })), _path3778 || (_path3778 = /*#__PURE__*/React.createElement("path", {
    d: "M90 57v-1h1v1z",
    fill: "#836d57",
    fillOpacity: 0.137
  })), _path3779 || (_path3779 = /*#__PURE__*/React.createElement("path", {
    d: "M92 57h-1v-1h1z",
    fill: "#99c",
    fillOpacity: 0.02
  })), _path3780 || (_path3780 = /*#__PURE__*/React.createElement("path", {
    d: "M95 56v1h-1v-1z",
    fill: "#876a5d",
    fillOpacity: 0.31
  })), _path3781 || (_path3781 = /*#__PURE__*/React.createElement("path", {
    d: "M96 57h-1v-1h1z",
    fill: "#99684f"
  })), _path3782 || (_path3782 = /*#__PURE__*/React.createElement("path", {
    d: "M97 56v1h-1v-1z",
    fill: "#925d41"
  })), _path3783 || (_path3783 = /*#__PURE__*/React.createElement("path", {
    d: "M97 57v-1h1v1z",
    fill: "#743b21"
  })), _path3784 || (_path3784 = /*#__PURE__*/React.createElement("path", {
    d: "M99 57h-1v-1h1z",
    fill: "#794222"
  })), _path3785 || (_path3785 = /*#__PURE__*/React.createElement("path", {
    d: "M100 56v1h-1v-1z",
    fill: "#784627",
    fillOpacity: 0.863
  })), _path3786 || (_path3786 = /*#__PURE__*/React.createElement("path", {
    d: "M100 56h1v1h-1z",
    fill: "#7c4c2b",
    fillOpacity: 0.761
  })), _path3787 || (_path3787 = /*#__PURE__*/React.createElement("path", {
    d: "M102 57h-1v-1h1z",
    fill: "#844c2b",
    fillOpacity: 0.875
  })), _path3788 || (_path3788 = /*#__PURE__*/React.createElement("path", {
    d: "M103 57h-1v-1h1z",
    fill: "#864721"
  })), _path3789 || (_path3789 = /*#__PURE__*/React.createElement("path", {
    d: "M103 56h1v1h-1z",
    fill: "#81451e"
  })), _path3790 || (_path3790 = /*#__PURE__*/React.createElement("path", {
    d: "M104 57v-1h1v1z",
    fill: "#ad6b3f"
  })), _path3791 || (_path3791 = /*#__PURE__*/React.createElement("path", {
    d: "M106 57h-1v-1h1z",
    fill: "#c18761",
    fillOpacity: 0.937
  })), _path3792 || (_path3792 = /*#__PURE__*/React.createElement("path", {
    d: "M106 57v-1h1v1z",
    fill: "#c59f85",
    fillOpacity: 0.157
  })), _path3793 || (_path3793 = /*#__PURE__*/React.createElement("path", {
    d: "M108 56h1v1h-1z",
    fill: "#8d5e37",
    fillOpacity: 0.851
  })), _path3794 || (_path3794 = /*#__PURE__*/React.createElement("path", {
    d: "M109 56h1v1h-1z",
    fill: "#89562e"
  })), _path3795 || (_path3795 = /*#__PURE__*/React.createElement("path", {
    d: "M110 56h1v1h-1z",
    fill: "#744d25"
  })), _path3796 || (_path3796 = /*#__PURE__*/React.createElement("path", {
    d: "M112 56v1h-1v-1z",
    fill: "#976a35"
  })), _path3797 || (_path3797 = /*#__PURE__*/React.createElement("path", {
    d: "M112 57v-1h1v1z",
    fill: "#f3b170"
  })), _path3798 || (_path3798 = /*#__PURE__*/React.createElement("path", {
    d: "M114 56v1h-1v-1z",
    fill: "#e2a975",
    fillOpacity: 0.831
  })), _path3799 || (_path3799 = /*#__PURE__*/React.createElement("path", {
    d: "M116 56h1v1h-1z",
    fill: "#6e5656",
    fillOpacity: 0.208
  })), _path3800 || (_path3800 = /*#__PURE__*/React.createElement("path", {
    d: "M117 56h1v1h-1z",
    fill: "#77442c",
    fillOpacity: 0.996
  })), _path3801 || (_path3801 = /*#__PURE__*/React.createElement("path", {
    d: "M119 57v-1h1v1z",
    fill: "#b68463"
  })), _path3802 || (_path3802 = /*#__PURE__*/React.createElement("path", {
    d: "M120 56h1v1h-1z",
    fill: "#b28c70",
    fillOpacity: 0.871
  })), _path3803 || (_path3803 = /*#__PURE__*/React.createElement("path", {
    d: "M8 57v1H7v-1z",
    fill: "#946a50",
    fillOpacity: 0.235
  })), _path3804 || (_path3804 = /*#__PURE__*/React.createElement("path", {
    d: "M9 58H8v-1h1z",
    fill: "#aa744f",
    fillOpacity: 0.996
  })), _path3805 || (_path3805 = /*#__PURE__*/React.createElement("path", {
    d: "M10 58H9v-1h1z",
    fill: "#a16943"
  })), _path3806 || (_path3806 = /*#__PURE__*/React.createElement("path", {
    d: "M12 57v1h-1v-1z",
    fill: "#875128"
  })), _path3807 || (_path3807 = /*#__PURE__*/React.createElement("path", {
    d: "M13 57v1h-1v-1z",
    fill: "#825026",
    fillOpacity: 0.984
  })), _path3808 || (_path3808 = /*#__PURE__*/React.createElement("path", {
    d: "M13 57h1v1h-1z",
    fill: "#735537",
    fillOpacity: 0.2
  })), _path3809 || (_path3809 = /*#__PURE__*/React.createElement("path", {
    d: "M20 57h1v1h-1z",
    fill: "#796342",
    fillOpacity: 0.09
  })), _path3810 || (_path3810 = /*#__PURE__*/React.createElement("path", {
    d: "M21 57h1v1h-1z",
    fill: "#8f6140",
    fillOpacity: 0.482
  })), _path3811 || (_path3811 = /*#__PURE__*/React.createElement("path", {
    d: "M22 57h1v1h-1z",
    fill: "#9c6032"
  })), _path3812 || (_path3812 = /*#__PURE__*/React.createElement("path", {
    d: "M24 57v1h-1v-1z",
    fill: "#9e6234"
  })), _path3813 || (_path3813 = /*#__PURE__*/React.createElement("path", {
    d: "M24 57h1v1h-1z",
    fill: "#a06539"
  })), _path3814 || (_path3814 = /*#__PURE__*/React.createElement("path", {
    d: "M26 58h-1v-1h1z",
    fill: "#a6673d"
  })), _path3815 || (_path3815 = /*#__PURE__*/React.createElement("path", {
    d: "M27 57v1h-1v-1z",
    fill: "#ae6d45"
  })), _path3816 || (_path3816 = /*#__PURE__*/React.createElement("path", {
    d: "M28 58h-1v-1h1z",
    fill: "#af744e"
  })), _path3817 || (_path3817 = /*#__PURE__*/React.createElement("path", {
    d: "M28 57h1v1h-1z",
    fill: "#af7755",
    fillOpacity: 0.992
  })), _path3818 || (_path3818 = /*#__PURE__*/React.createElement("path", {
    d: "M29 57h1v1h-1z",
    fill: "#b37955"
  })), _path3819 || (_path3819 = /*#__PURE__*/React.createElement("path", {
    d: "M30 58v-1h1v1z",
    fill: "#ba8060"
  })), _path3820 || (_path3820 = /*#__PURE__*/React.createElement("path", {
    d: "M31 58v-1h1v1z",
    fill: "#c28e73"
  })), _path3821 || (_path3821 = /*#__PURE__*/React.createElement("path", {
    d: "M33 57v1h-1v-1z",
    fill: "#cb9b89"
  })), _path3822 || (_path3822 = /*#__PURE__*/React.createElement("path", {
    d: "M34 57v1h-1v-1z",
    fill: "#d3a49c"
  })), _path3823 || (_path3823 = /*#__PURE__*/React.createElement("path", {
    d: "M35 58h-1v-1h1z",
    fill: "#d4a7a3"
  })), _path3824 || (_path3824 = /*#__PURE__*/React.createElement("path", {
    d: "M35 58v-1h1v1z",
    fill: "#ddb4b2"
  })), _path3825 || (_path3825 = /*#__PURE__*/React.createElement("path", {
    d: "M36 57h1v1h-1z",
    fill: "#dfb7b8"
  })), _path3826 || (_path3826 = /*#__PURE__*/React.createElement("path", {
    d: "M38 58h-1v-1h1z",
    fill: "#dfb6b4"
  })), _path3827 || (_path3827 = /*#__PURE__*/React.createElement("path", {
    d: "M39 58h-1v-1h1z",
    fill: "#d3aca4"
  })), _path3828 || (_path3828 = /*#__PURE__*/React.createElement("path", {
    d: "M39 57h1v1h-1z",
    fill: "#b38c85"
  })), _path3829 || (_path3829 = /*#__PURE__*/React.createElement("path", {
    d: "M40 57h1v1h-1z",
    fill: "#bb8f87"
  })), _path3830 || (_path3830 = /*#__PURE__*/React.createElement("path", {
    d: "M41 57h1v1h-1z",
    fill: "#b08579"
  })), _path3831 || (_path3831 = /*#__PURE__*/React.createElement("path", {
    d: "M43 58h-1v-1h1z",
    fill: "#86543d"
  })), _path3832 || (_path3832 = /*#__PURE__*/React.createElement("path", {
    d: "M44 58h-1v-1h1z",
    fill: "#66402d",
    fillOpacity: 0.529
  })), _path3833 || (_path3833 = /*#__PURE__*/React.createElement("path", {
    d: "M60 57h1v1h-1z",
    fill: "#8c6a53",
    fillOpacity: 0.263
  })), _path3834 || (_path3834 = /*#__PURE__*/React.createElement("path", {
    d: "M62 58h-1v-1h1z",
    fill: "#9a6b46"
  })), _path3835 || (_path3835 = /*#__PURE__*/React.createElement("path", {
    d: "M63 58h-1v-1h1z",
    fill: "#946538"
  })), _path3836 || (_path3836 = /*#__PURE__*/React.createElement("path", {
    d: "M63 58v-1h1v1z",
    fill: "#925f36"
  })), _path3837 || (_path3837 = /*#__PURE__*/React.createElement("path", {
    d: "M66 57v1h-1v-1z",
    fill: "#895e3f",
    fillOpacity: 0.392
  })), _path3838 || (_path3838 = /*#__PURE__*/React.createElement("path", {
    d: "M72 58h-1v-1h1z",
    fill: "#835c41",
    fillOpacity: 0.227
  })), _path3839 || (_path3839 = /*#__PURE__*/React.createElement("path", {
    d: "M72 57h1v1h-1z",
    fill: "#945f34",
    fillOpacity: 0.996
  })), _path3840 || (_path3840 = /*#__PURE__*/React.createElement("path", {
    d: "M74 57v1h-1v-1z",
    fill: "#a67241"
  })), _path3841 || (_path3841 = /*#__PURE__*/React.createElement("path", {
    d: "M75 58v-1h1v1z",
    fill: "#ab7d4c"
  })), _path3842 || (_path3842 = /*#__PURE__*/React.createElement("path", {
    d: "M76 58v-1h1v1z",
    fill: "#9d7140"
  })), _path3843 || (_path3843 = /*#__PURE__*/React.createElement("path", {
    d: "M77 58v-1h1v1z",
    fill: "#9e713a"
  })), _path3844 || (_path3844 = /*#__PURE__*/React.createElement("path", {
    d: "M78 57h1v1h-1z",
    fill: "#a6794d",
    fillOpacity: 0.996
  })), _path3845 || (_path3845 = /*#__PURE__*/React.createElement("path", {
    d: "M79 58v-1h1v1z",
    fill: "#6f422a",
    fillOpacity: 0.973
  })), _path3846 || (_path3846 = /*#__PURE__*/React.createElement("path", {
    d: "M80 57h1v1h-1z",
    fill: "#653520"
  })), _path3847 || (_path3847 = /*#__PURE__*/React.createElement("path", {
    d: "M81 58v-1h1v1z",
    fill: "#6b3d28",
    fillOpacity: 0.984
  })), _path3848 || (_path3848 = /*#__PURE__*/React.createElement("path", {
    d: "M83 58h-1v-1h1z",
    fill: "#714532",
    fillOpacity: 0.855
  })), _path3849 || (_path3849 = /*#__PURE__*/React.createElement("path", {
    d: "M83 57h1v1h-1z",
    fill: "#774838",
    fillOpacity: 0.659
  })), _path3850 || (_path3850 = /*#__PURE__*/React.createElement("path", {
    d: "M84 58v-1h1v1z",
    fill: "#7e4f3f",
    fillOpacity: 0.427
  })), _path3851 || (_path3851 = /*#__PURE__*/React.createElement("path", {
    d: "M85 57h1v1h-1z",
    fill: "#7f5946",
    fillOpacity: 0.212
  })), _path3852 || (_path3852 = /*#__PURE__*/React.createElement("path", {
    d: "M87 57v1h-1v-1z",
    fill: "#7f5f4f",
    fillOpacity: 0.063
  })), _path3853 || (_path3853 = /*#__PURE__*/React.createElement("path", {
    d: "M95 58h-1v-1h1z",
    fill: "#886153",
    fillOpacity: 0.286
  })), _path3854 || (_path3854 = /*#__PURE__*/React.createElement("path", {
    d: "M96 57v1h-1v-1z",
    fill: "#9a684d"
  })), _path3855 || (_path3855 = /*#__PURE__*/React.createElement("path", {
    d: "M96 58v-1h1v1z",
    fill: "#976245"
  })), _path3856 || (_path3856 = /*#__PURE__*/React.createElement("path", {
    d: "M97 57h1v1h-1z",
    fill: "#885741",
    fillOpacity: 0.855
  })), _path3857 || (_path3857 = /*#__PURE__*/React.createElement("path", {
    d: "M99 58h-1v-1h1z",
    fill: "#7b4f36",
    fillOpacity: 0.569
  })), _path3858 || (_path3858 = /*#__PURE__*/React.createElement("path", {
    d: "M100 58h-1v-1h1z",
    fill: "#82553d",
    fillOpacity: 0.769
  })), _path3859 || (_path3859 = /*#__PURE__*/React.createElement("path", {
    d: "M101 57v1h-1v-1z",
    fill: "#825336",
    fillOpacity: 0.898
  })), _path3860 || (_path3860 = /*#__PURE__*/React.createElement("path", {
    d: "M101 58v-1h1v1z",
    fill: "#834c2e",
    fillOpacity: 0.969
  })), _path3861 || (_path3861 = /*#__PURE__*/React.createElement("path", {
    d: "M103 57v1h-1v-1z",
    fill: "#884825"
  })), _path3862 || (_path3862 = /*#__PURE__*/React.createElement("path", {
    d: "M103 57h1v1h-1z",
    fill: "#86481f"
  })), _path3863 || (_path3863 = /*#__PURE__*/React.createElement("path", {
    d: "M105 58h-1v-1h1z",
    fill: "#ad6d42"
  })), _path3864 || (_path3864 = /*#__PURE__*/React.createElement("path", {
    d: "M106 57v1h-1v-1z",
    fill: "#c48860",
    fillOpacity: 0.965
  })), _path3865 || (_path3865 = /*#__PURE__*/React.createElement("path", {
    d: "M107 58h-1v-1h1z",
    fill: "#754e2f",
    fillOpacity: 0.486
  })), _path3866 || (_path3866 = /*#__PURE__*/React.createElement("path", {
    d: "M108 58h-1v-1h1z",
    fill: "#624233",
    fillOpacity: 0.314
  })), _path3867 || (_path3867 = /*#__PURE__*/React.createElement("path", {
    d: "M108 58v-1h1v1z",
    fill: "#8b5c36",
    fillOpacity: 0.886
  })), _path3868 || (_path3868 = /*#__PURE__*/React.createElement("path", {
    d: "M110 57v1h-1v-1z",
    fill: "#87562b"
  })), _path3869 || (_path3869 = /*#__PURE__*/React.createElement("path", {
    d: "M110 58v-1h1v1z",
    fill: "#754d24"
  })), _path3870 || (_path3870 = /*#__PURE__*/React.createElement("path", {
    d: "M112 58h-1v-1h1z",
    fill: "#986f39"
  })), _path3871 || (_path3871 = /*#__PURE__*/React.createElement("path", {
    d: "M113 58h-1v-1h1z",
    fill: "#f3b16e"
  })), _path3872 || (_path3872 = /*#__PURE__*/React.createElement("path", {
    d: "M113 58v-1h1v1z",
    fill: "#e0a66e",
    fillOpacity: 0.78
  })), _path3873 || (_path3873 = /*#__PURE__*/React.createElement("path", {
    d: "M116 58h-1v-1h1z",
    fill: "#785d50",
    fillOpacity: 0.075
  })), _path3874 || (_path3874 = /*#__PURE__*/React.createElement("path", {
    d: "M117 58h-1v-1h1z",
    fill: "#865843",
    fillOpacity: 0.506
  })), _path3875 || (_path3875 = /*#__PURE__*/React.createElement("path", {
    d: "M118 57v1h-1v-1z",
    fill: "#884c2d"
  })), _path3876 || (_path3876 = /*#__PURE__*/React.createElement("path", {
    d: "M119 57v1h-1v-1z",
    fill: "#985e3b"
  })), _path3877 || (_path3877 = /*#__PURE__*/React.createElement("path", {
    d: "M120 58h-1v-1h1z",
    fill: "#b98666"
  })), _path3878 || (_path3878 = /*#__PURE__*/React.createElement("path", {
    d: "M120 58v-1h1v1z",
    fill: "#b28b6d",
    fillOpacity: 0.859
  })), _path3879 || (_path3879 = /*#__PURE__*/React.createElement("path", {
    d: "M8 59H7v-1h1z",
    fill: "#997b66",
    fillOpacity: 0.137
  })), _path3880 || (_path3880 = /*#__PURE__*/React.createElement("path", {
    d: "M9 59H8v-1h1z",
    fill: "#a8734d",
    fillOpacity: 0.949
  })), _path3881 || (_path3881 = /*#__PURE__*/React.createElement("path", {
    d: "M9 59v-1h1v1z",
    fill: "#a76c43"
  })), _path3882 || (_path3882 = /*#__PURE__*/React.createElement("path", {
    d: "M10 58h1v1h-1z",
    fill: "#874e27"
  })), _path3883 || (_path3883 = /*#__PURE__*/React.createElement("path", {
    d: "M11 59v-1h1v1z",
    fill: "#885126"
  })), _path3884 || (_path3884 = /*#__PURE__*/React.createElement("path", {
    d: "M13 58v1h-1v-1z",
    fill: "#865229"
  })), _path3885 || (_path3885 = /*#__PURE__*/React.createElement("path", {
    d: "M13 59v-1h1v1z",
    fill: "#754f33",
    fillOpacity: 0.29
  })), _path3886 || (_path3886 = /*#__PURE__*/React.createElement("path", {
    d: "M22 58v1h-1v-1z",
    fill: "#886445",
    fillOpacity: 0.329
  })), _path3887 || (_path3887 = /*#__PURE__*/React.createElement("path", {
    d: "M22 59v-1h1v1z",
    fill: "#975e2e"
  })), _path3888 || (_path3888 = /*#__PURE__*/React.createElement("path", {
    d: "M24 59h-1v-1h1z",
    fill: "#945a29"
  })), _path3889 || (_path3889 = /*#__PURE__*/React.createElement("path", {
    d: "M25 59h-1v-1h1z",
    fill: "#8f5926"
  })), _path3890 || (_path3890 = /*#__PURE__*/React.createElement("path", {
    d: "M25 58h1v1h-1z",
    fill: "#854f22"
  })), _path3891 || (_path3891 = /*#__PURE__*/React.createElement("path", {
    d: "M27 58v1h-1v-1z",
    fill: "#8e542c"
  })), _path3892 || (_path3892 = /*#__PURE__*/React.createElement("path", {
    d: "M27 58h1v1h-1z",
    fill: "#8c5836",
    fillOpacity: 0.863
  })), _path3893 || (_path3893 = /*#__PURE__*/React.createElement("path", {
    d: "M29 59h-1v-1h1z",
    fill: "#8b5940",
    fillOpacity: 0.647
  })), _path3894 || (_path3894 = /*#__PURE__*/React.createElement("path", {
    d: "M30 58v1h-1v-1z",
    fill: "#945e41"
  })), _path3895 || (_path3895 = /*#__PURE__*/React.createElement("path", {
    d: "M30 59v-1h1v1z",
    fill: "#9c6848"
  })), _path3896 || (_path3896 = /*#__PURE__*/React.createElement("path", {
    d: "M31 58h1v1h-1z",
    fill: "#a67555"
  })), _path3897 || (_path3897 = /*#__PURE__*/React.createElement("path", {
    d: "M33 58v1h-1v-1z",
    fill: "#b08165"
  })), _path3898 || (_path3898 = /*#__PURE__*/React.createElement("path", {
    d: "M34 59h-1v-1h1z",
    fill: "#bd8c78"
  })), _path3899 || (_path3899 = /*#__PURE__*/React.createElement("path", {
    d: "M35 59h-1v-1h1z",
    fill: "#c59582"
  })), _path3900 || (_path3900 = /*#__PURE__*/React.createElement("path", {
    d: "M36 59h-1v-1h1z",
    fill: "#ca9b89"
  })), _path3901 || (_path3901 = /*#__PURE__*/React.createElement("path", {
    d: "M36 58h1v1h-1z",
    fill: "#d1a393"
  })), _path3902 || (_path3902 = /*#__PURE__*/React.createElement("path", {
    d: "M37 58h1v1h-1z",
    fill: "#d3a699"
  })), _path3903 || (_path3903 = /*#__PURE__*/React.createElement("path", {
    d: "M38 59v-1h1v1z",
    fill: "#d5ab9e"
  })), _path3904 || (_path3904 = /*#__PURE__*/React.createElement("path", {
    d: "M39 58h1v1h-1z",
    fill: "#ba9088"
  })), _path3905 || (_path3905 = /*#__PURE__*/React.createElement("path", {
    d: "M41 59h-1v-1h1z",
    fill: "#c1978f"
  })), _path3906 || (_path3906 = /*#__PURE__*/React.createElement("path", {
    d: "M42 59h-1v-1h1z",
    fill: "#ba8b80"
  })), _path3907 || (_path3907 = /*#__PURE__*/React.createElement("path", {
    d: "M42 58h1v1h-1z",
    fill: "#86523a"
  })), _path3908 || (_path3908 = /*#__PURE__*/React.createElement("path", {
    d: "M44 58v1h-1v-1z",
    fill: "#764d38",
    fillOpacity: 0.812
  })), _path3909 || (_path3909 = /*#__PURE__*/React.createElement("path", {
    d: "M45 58v1h-1v-1z",
    fill: "#7f5f54",
    fillOpacity: 0.463
  })), _path3910 || (_path3910 = /*#__PURE__*/React.createElement("path", {
    d: "M45 58h1v1h-1z",
    fill: "#816256",
    fillOpacity: 0.325
  })), _path3911 || (_path3911 = /*#__PURE__*/React.createElement("path", {
    d: "M47 58v1h-1v-1z",
    fill: "#785b51",
    fillOpacity: 0.208
  })), _path3912 || (_path3912 = /*#__PURE__*/React.createElement("path", {
    d: "M47 59v-1h1v1z",
    fill: "#694f4f",
    fillOpacity: 0.114
  })), _path3913 || (_path3913 = /*#__PURE__*/React.createElement("path", {
    d: "M61 58v1h-1v-1z",
    fill: "#8d6d52",
    fillOpacity: 0.255
  })), _path3914 || (_path3914 = /*#__PURE__*/React.createElement("path", {
    d: "M61 59v-1h1v1z",
    fill: "#9a6d47"
  })), _path3915 || (_path3915 = /*#__PURE__*/React.createElement("path", {
    d: "M64 58v1h-1v-1z",
    fill: "#935f37"
  })), _path3916 || (_path3916 = /*#__PURE__*/React.createElement("path", {
    d: "M65 59h-1v-1h1z",
    fill: "#915f33"
  })), _path3917 || (_path3917 = /*#__PURE__*/React.createElement("path", {
    d: "M65 58h1v1h-1z",
    fill: "#895d47",
    fillOpacity: 0.365
  })), _path3918 || (_path3918 = /*#__PURE__*/React.createElement("path", {
    d: "M72 59h-1v-1h1z",
    fill: "#886346",
    fillOpacity: 0.212
  })), _path3919 || (_path3919 = /*#__PURE__*/React.createElement("path", {
    d: "M73 59h-1v-1h1z",
    fill: "#955d33",
    fillOpacity: 0.992
  })), _path3920 || (_path3920 = /*#__PURE__*/React.createElement("path", {
    d: "M74 59h-1v-1h1z",
    fill: "#a87342"
  })), _path3921 || (_path3921 = /*#__PURE__*/React.createElement("path", {
    d: "M74 58h1v1h-1z",
    fill: "#ac7a4a"
  })), _path3922 || (_path3922 = /*#__PURE__*/React.createElement("path", {
    d: "M76 59v-1h1v1z",
    fill: "#9f7343"
  })), _path3923 || (_path3923 = /*#__PURE__*/React.createElement("path", {
    d: "M78 59h-1v-1h1z",
    fill: "#a0733a"
  })), _path3924 || (_path3924 = /*#__PURE__*/React.createElement("path", {
    d: "M78 59v-1h1v1z",
    fill: "#ab8456",
    fillOpacity: 0.976
  })), _path3925 || (_path3925 = /*#__PURE__*/React.createElement("path", {
    d: "M80 59h-1v-1h1z",
    fill: "#825c45",
    fillOpacity: 0.592
  })), _path3926 || (_path3926 = /*#__PURE__*/React.createElement("path", {
    d: "M80 58h1v1h-1z",
    fill: "#79513f",
    fillOpacity: 0.329
  })), _path3927 || (_path3927 = /*#__PURE__*/React.createElement("path", {
    d: "M81 58h1v1h-1z",
    fill: "#866355",
    fillOpacity: 0.141
  })), _path3928 || (_path3928 = /*#__PURE__*/React.createElement("path", {
    d: "M83 58v1h-1v-1z",
    fill: "#b6b6b6",
    fillOpacity: 0.027
  })), _path3929 || (_path3929 = /*#__PURE__*/React.createElement("path", {
    d: "M94 58h1v1h-1z",
    fill: "#875c4d",
    fillOpacity: 0.259
  })), _path3930 || (_path3930 = /*#__PURE__*/React.createElement("path", {
    d: "M95 59v-1h1v1z",
    fill: "#986548"
  })), _path3931 || (_path3931 = /*#__PURE__*/React.createElement("path", {
    d: "M97 58v1h-1v-1z",
    fill: "#996648"
  })), _path3932 || (_path3932 = /*#__PURE__*/React.createElement("path", {
    d: "M97 59v-1h1v1z",
    fill: "#8e6452",
    fillOpacity: 0.773
  })), _path3933 || (_path3933 = /*#__PURE__*/React.createElement("path", {
    d: "M100 59v-1h1v1z",
    fill: "#a19386",
    fillOpacity: 0.075
  })), _path3934 || (_path3934 = /*#__PURE__*/React.createElement("path", {
    d: "M101 58h1v1h-1z",
    fill: "#7f5a46",
    fillOpacity: 0.4
  })), _path3935 || (_path3935 = /*#__PURE__*/React.createElement("path", {
    d: "M102 58h1v1h-1z",
    fill: "#844d2d"
  })), _path3936 || (_path3936 = /*#__PURE__*/React.createElement("path", {
    d: "M103 58h1v1h-1z",
    fill: "#8b4d22"
  })), _path3937 || (_path3937 = /*#__PURE__*/React.createElement("path", {
    d: "M105 59h-1v-1h1z",
    fill: "#b06e46"
  })), _path3938 || (_path3938 = /*#__PURE__*/React.createElement("path", {
    d: "M106 59h-1v-1h1z",
    fill: "#ca865f",
    fillOpacity: 0.996
  })), _path3939 || (_path3939 = /*#__PURE__*/React.createElement("path", {
    d: "M107 58v1h-1v-1z",
    fill: "#824e32",
    fillOpacity: 0.988
  })), _path3940 || (_path3940 = /*#__PURE__*/React.createElement("path", {
    d: "M107 59v-1h1v1z",
    fill: "#78472d"
  })), _path3941 || (_path3941 = /*#__PURE__*/React.createElement("path", {
    d: "M108 59v-1h1v1z",
    fill: "#985c36"
  })), _path3942 || (_path3942 = /*#__PURE__*/React.createElement("path", {
    d: "M111 58v1h-1v-1z",
    fill: "#734f28"
  })), _path3943 || (_path3943 = /*#__PURE__*/React.createElement("path", {
    d: "M112 59h-1v-1h1z",
    fill: "#9d7339"
  })), _path3944 || (_path3944 = /*#__PURE__*/React.createElement("path", {
    d: "M112 59v-1h1v1z",
    fill: "#f1b06e"
  })), _path3945 || (_path3945 = /*#__PURE__*/React.createElement("path", {
    d: "M113 58h1v1h-1z",
    fill: "#d99d64",
    fillOpacity: 0.855
  })), _path3946 || (_path3946 = /*#__PURE__*/React.createElement("path", {
    d: "M114 58h1v1h-1z",
    fill: "#895b41",
    fillOpacity: 0.537
  })), _path3947 || (_path3947 = /*#__PURE__*/React.createElement("path", {
    d: "M116 59h-1v-1h1z",
    fill: "#996848",
    fillOpacity: 0.871
  })), _path3948 || (_path3948 = /*#__PURE__*/React.createElement("path", {
    d: "M117 58v1h-1v-1z",
    fill: "#aa6e49"
  })), _path3949 || (_path3949 = /*#__PURE__*/React.createElement("path", {
    d: "M117 58h1v1h-1z",
    fill: "#a15f40"
  })), _path3950 || (_path3950 = /*#__PURE__*/React.createElement("path", {
    d: "M119 58v1h-1v-1z",
    fill: "#9d6444"
  })), _path3951 || (_path3951 = /*#__PURE__*/React.createElement("path", {
    d: "M119 59v-1h1v1z",
    fill: "#bb8868"
  })), _path3952 || (_path3952 = /*#__PURE__*/React.createElement("path", {
    d: "M121 59h-1v-1h1z",
    fill: "#af8869",
    fillOpacity: 0.835
  })), _path3953 || (_path3953 = /*#__PURE__*/React.createElement("path", {
    d: "M8 60v-1h1v1z",
    fill: "#a97653",
    fillOpacity: 0.867
  })), _path3954 || (_path3954 = /*#__PURE__*/React.createElement("path", {
    d: "M10 59v1H9v-1z",
    fill: "#af734a"
  })), _path3955 || (_path3955 = /*#__PURE__*/React.createElement("path", {
    d: "M10 60v-1h1v1z",
    fill: "#8a4f26"
  })), _path3956 || (_path3956 = /*#__PURE__*/React.createElement("path", {
    d: "M11 59h1v1h-1z",
    fill: "#895025"
  })), _path3957 || (_path3957 = /*#__PURE__*/React.createElement("path", {
    d: "M13 60h-1v-1h1z",
    fill: "#8b5429"
  })), _path3958 || (_path3958 = /*#__PURE__*/React.createElement("path", {
    d: "M13 59h1v1h-1z",
    fill: "#775132",
    fillOpacity: 0.42
  })), _path3959 || (_path3959 = /*#__PURE__*/React.createElement("path", {
    d: "M21 59h1v1h-1z",
    fill: "#876043",
    fillOpacity: 0.31
  })), _path3960 || (_path3960 = /*#__PURE__*/React.createElement("path", {
    d: "M22 59h1v1h-1z",
    fill: "#995f2f"
  })), _path3961 || (_path3961 = /*#__PURE__*/React.createElement("path", {
    d: "M24 59v1h-1v-1z",
    fill: "#955c28"
  })), _path3962 || (_path3962 = /*#__PURE__*/React.createElement("path", {
    d: "M24 59h1v1h-1z",
    fill: "#8e5826"
  })), _path3963 || (_path3963 = /*#__PURE__*/React.createElement("path", {
    d: "M25 60v-1h1v1z",
    fill: "#824c22"
  })), _path3964 || (_path3964 = /*#__PURE__*/React.createElement("path", {
    d: "M26 59h1v1h-1z",
    fill: "#814922"
  })), _path3965 || (_path3965 = /*#__PURE__*/React.createElement("path", {
    d: "M27 60v-1h1v1z",
    fill: "#74411b",
    fillOpacity: 0.98
  })), _path3966 || (_path3966 = /*#__PURE__*/React.createElement("path", {
    d: "M29 59v1h-1v-1z",
    fill: "#77472a",
    fillOpacity: 0.973
  })), _path3967 || (_path3967 = /*#__PURE__*/React.createElement("path", {
    d: "M29 60v-1h1v1z",
    fill: "#84563a"
  })), _path3968 || (_path3968 = /*#__PURE__*/React.createElement("path", {
    d: "M30 59h1v1h-1z",
    fill: "#84573e"
  })), _path3969 || (_path3969 = /*#__PURE__*/React.createElement("path", {
    d: "M32 60h-1v-1h1z",
    fill: "#865841"
  })), _path3970 || (_path3970 = /*#__PURE__*/React.createElement("path", {
    d: "M32 59h1v1h-1z",
    fill: "#875842"
  })), _path3971 || (_path3971 = /*#__PURE__*/React.createElement("path", {
    d: "M34 59v1h-1v-1z",
    fill: "#875940"
  })), _path3972 || (_path3972 = /*#__PURE__*/React.createElement("path", {
    d: "M35 59v1h-1v-1z",
    fill: "#885a40"
  })), _path3973 || (_path3973 = /*#__PURE__*/React.createElement("path", {
    d: "M36 59v1h-1v-1z",
    fill: "#8a5b41"
  })), _path3974 || (_path3974 = /*#__PURE__*/React.createElement("path", {
    d: "M39 60h-1v-1h1z",
    fill: "#a37760"
  })), _path3975 || (_path3975 = /*#__PURE__*/React.createElement("path", {
    d: "M39 59h1v1h-1z",
    fill: "#c89c91"
  })), _path3976 || (_path3976 = /*#__PURE__*/React.createElement("path", {
    d: "M40 59h1v1h-1z",
    fill: "#c79c93"
  })), _path3977 || (_path3977 = /*#__PURE__*/React.createElement("path", {
    d: "M41 59h1v1h-1z",
    fill: "#c09286"
  })), _path3978 || (_path3978 = /*#__PURE__*/React.createElement("path", {
    d: "M42 60v-1h1v1z",
    fill: "#835438"
  })), _path3979 || (_path3979 = /*#__PURE__*/React.createElement("path", {
    d: "M43 60v-1h1v1z",
    fill: "#7f5236"
  })), _path3980 || (_path3980 = /*#__PURE__*/React.createElement("path", {
    d: "M45 60h-1v-1h1z",
    fill: "#8f614e"
  })), _path3981 || (_path3981 = /*#__PURE__*/React.createElement("path", {
    d: "M46 60h-1v-1h1z",
    fill: "#8a5f4e"
  })), _path3982 || (_path3982 = /*#__PURE__*/React.createElement("path", {
    d: "M46 59h1v1h-1z",
    fill: "#855b4b",
    fillOpacity: 0.992
  })), _path3983 || (_path3983 = /*#__PURE__*/React.createElement("path", {
    d: "M48 60h-1v-1h1z",
    fill: "#825a4a",
    fillOpacity: 0.941
  })), _path3984 || (_path3984 = /*#__PURE__*/React.createElement("path", {
    d: "M49 60h-1v-1h1z",
    fill: "#845b4b",
    fillOpacity: 0.863
  })), _path3985 || (_path3985 = /*#__PURE__*/React.createElement("path", {
    d: "M49 60v-1h1v1z",
    fill: "#825e4d",
    fillOpacity: 0.761
  })), _path3986 || (_path3986 = /*#__PURE__*/React.createElement("path", {
    d: "M50 59h1v1h-1z",
    fill: "#7f5e4d",
    fillOpacity: 0.643
  })), _path3987 || (_path3987 = /*#__PURE__*/React.createElement("path", {
    d: "M52 60h-1v-1h1z",
    fill: "#7e604f",
    fillOpacity: 0.506
  })), _path3988 || (_path3988 = /*#__PURE__*/React.createElement("path", {
    d: "M52 59h1v1h-1z",
    fill: "#7e624e",
    fillOpacity: 0.357
  })), _path3989 || (_path3989 = /*#__PURE__*/React.createElement("path", {
    d: "M54 59v1h-1v-1z",
    fill: "#816655",
    fillOpacity: 0.224
  })), _path3990 || (_path3990 = /*#__PURE__*/React.createElement("path", {
    d: "M54 60v-1h1v1z",
    fill: "#7a665b",
    fillOpacity: 0.098
  })), _path3991 || (_path3991 = /*#__PURE__*/React.createElement("path", {
    d: "M55 59h1v1h-1z",
    fill: "#3f7f7f",
    fillOpacity: 0.016
  })), _path3992 || (_path3992 = /*#__PURE__*/React.createElement("path", {
    d: "M61 59v1h-1v-1z",
    fill: "#8f745d",
    fillOpacity: 0.224
  })), _path3993 || (_path3993 = /*#__PURE__*/React.createElement("path", {
    d: "M62 60h-1v-1h1z",
    fill: "#996f4b"
  })), _path3994 || (_path3994 = /*#__PURE__*/React.createElement("path", {
    d: "M63 60h-1v-1h1z",
    fill: "#9a6940"
  })), _path3995 || (_path3995 = /*#__PURE__*/React.createElement("path", {
    d: "M64 59v1h-1v-1z",
    fill: "#97613c"
  })), _path3996 || (_path3996 = /*#__PURE__*/React.createElement("path", {
    d: "M64 60v-1h1v1z",
    fill: "#906038"
  })), _path3997 || (_path3997 = /*#__PURE__*/React.createElement("path", {
    d: "M65 60v-1h1v1z",
    fill: "#845d45",
    fillOpacity: 0.333
  })), _path3998 || (_path3998 = /*#__PURE__*/React.createElement("path", {
    d: "M72 59v1h-1v-1z",
    fill: "#84644a",
    fillOpacity: 0.188
  })), _path3999 || (_path3999 = /*#__PURE__*/React.createElement("path", {
    d: "M72 59h1v1h-1z",
    fill: "#966037",
    fillOpacity: 0.98
  })), _path4000 || (_path4000 = /*#__PURE__*/React.createElement("path", {
    d: "M73 59h1v1h-1z",
    fill: "#a87242"
  })), _path4001 || (_path4001 = /*#__PURE__*/React.createElement("path", {
    d: "M75 60h-1v-1h1z",
    fill: "#aa7747"
  })), _path4002 || (_path4002 = /*#__PURE__*/React.createElement("path", {
    d: "M75 60v-1h1v1z",
    fill: "#a87a4a"
  })), _path4003 || (_path4003 = /*#__PURE__*/React.createElement("path", {
    d: "M77 59v1h-1v-1z",
    fill: "#a07544"
  })), _path4004 || (_path4004 = /*#__PURE__*/React.createElement("path", {
    d: "M78 59v1h-1v-1z",
    fill: "#a4773d"
  })), _path4005 || (_path4005 = /*#__PURE__*/React.createElement("path", {
    d: "M79 60h-1v-1h1z",
    fill: "#a78255",
    fillOpacity: 0.898
  })), _path4006 || (_path4006 = /*#__PURE__*/React.createElement("path", {
    d: "M80 59v1h-1v-1z",
    fill: "#c8c8b6",
    fillOpacity: 0.055
  })), _path4007 || (_path4007 = /*#__PURE__*/React.createElement("path", {
    d: "M95 60h-1v-1h1z",
    fill: "#7f5944",
    fillOpacity: 0.235
  })), _path4008 || (_path4008 = /*#__PURE__*/React.createElement("path", {
    d: "M96 60h-1v-1h1z",
    fill: "#966144"
  })), _path4009 || (_path4009 = /*#__PURE__*/React.createElement("path", {
    d: "M97 60h-1v-1h1z",
    fill: "#9a6647"
  })), _path4010 || (_path4010 = /*#__PURE__*/React.createElement("path", {
    d: "M98 59v1h-1v-1z",
    fill: "#8d6455",
    fillOpacity: 0.835
  })), _path4011 || (_path4011 = /*#__PURE__*/React.createElement("path", {
    d: "M102 60h-1v-1h1z",
    fill: "#784833",
    fillOpacity: 0.275
  })), _path4012 || (_path4012 = /*#__PURE__*/React.createElement("path", {
    d: "M103 60v-1h1v1z",
    fill: "#8f5229"
  })), _path4013 || (_path4013 = /*#__PURE__*/React.createElement("path", {
    d: "M104 60v-1h1v1z",
    fill: "#b5754b"
  })), _path4014 || (_path4014 = /*#__PURE__*/React.createElement("path", {
    d: "M106 59v1h-1v-1z",
    fill: "#c88c65",
    fillOpacity: 0.894
  })), _path4015 || (_path4015 = /*#__PURE__*/React.createElement("path", {
    d: "M107 60h-1v-1h1z",
    fill: "#ab876d",
    fillOpacity: 0.192
  })), _path4016 || (_path4016 = /*#__PURE__*/React.createElement("path", {
    d: "M107 59h1v1h-1z",
    fill: "#886b51",
    fillOpacity: 0.271
  })), _path4017 || (_path4017 = /*#__PURE__*/React.createElement("path", {
    d: "M109 59v1h-1v-1z",
    fill: "#90623c",
    fillOpacity: 0.89
  })), _path4018 || (_path4018 = /*#__PURE__*/React.createElement("path", {
    d: "M109 60v-1h1v1z",
    fill: "#8c5c33"
  })), _path4019 || (_path4019 = /*#__PURE__*/React.createElement("path", {
    d: "M110 60v-1h1v1z",
    fill: "#764f28"
  })), _path4020 || (_path4020 = /*#__PURE__*/React.createElement("path", {
    d: "M111 60v-1h1v1z",
    fill: "#a17438"
  })), _path4021 || (_path4021 = /*#__PURE__*/React.createElement("path", {
    d: "M112 59h1v1h-1z",
    fill: "#eeae6c"
  })), _path4022 || (_path4022 = /*#__PURE__*/React.createElement("path", {
    d: "M113 59h1v1h-1z",
    fill: "#d0935b"
  })), _path4023 || (_path4023 = /*#__PURE__*/React.createElement("path", {
    d: "M114 59h1v1h-1z",
    fill: "#a16a47"
  })), _path4024 || (_path4024 = /*#__PURE__*/React.createElement("path", {
    d: "M115 59h1v1h-1z",
    fill: "#9e6645"
  })), _path4025 || (_path4025 = /*#__PURE__*/React.createElement("path", {
    d: "M117 60h-1v-1h1z",
    fill: "#89512e"
  })), _path4026 || (_path4026 = /*#__PURE__*/React.createElement("path", {
    d: "M118 59v1h-1v-1z",
    fill: "#8a4e2d"
  })), _path4027 || (_path4027 = /*#__PURE__*/React.createElement("path", {
    d: "M119 60h-1v-1h1z",
    fill: "#a0674b"
  })), _path4028 || (_path4028 = /*#__PURE__*/React.createElement("path", {
    d: "M120 59v1h-1v-1z",
    fill: "#bb8969"
  })), _path4029 || (_path4029 = /*#__PURE__*/React.createElement("path", {
    d: "M121 59v1h-1v-1z",
    fill: "#ad8668",
    fillOpacity: 0.812
  })), _path4030 || (_path4030 = /*#__PURE__*/React.createElement("path", {
    d: "M9 60v1H8v-1z",
    fill: "#a67553",
    fillOpacity: 0.769
  })), _path4031 || (_path4031 = /*#__PURE__*/React.createElement("path", {
    d: "M10 61H9v-1h1z",
    fill: "#b57a54"
  })), _path4032 || (_path4032 = /*#__PURE__*/React.createElement("path", {
    d: "M11 60v1h-1v-1z",
    fill: "#8d522a"
  })), _path4033 || (_path4033 = /*#__PURE__*/React.createElement("path", {
    d: "M11 61v-1h1v1z",
    fill: "#864e25"
  })), _path4034 || (_path4034 = /*#__PURE__*/React.createElement("path", {
    d: "M13 61h-1v-1h1z",
    fill: "#8b5328"
  })), _path4035 || (_path4035 = /*#__PURE__*/React.createElement("path", {
    d: "M14 60v1h-1v-1z",
    fill: "#785030",
    fillOpacity: 0.533
  })), _path4036 || (_path4036 = /*#__PURE__*/React.createElement("path", {
    d: "M21 61v-1h1v1z",
    fill: "#85603e",
    fillOpacity: 0.271
  })), _path4037 || (_path4037 = /*#__PURE__*/React.createElement("path", {
    d: "M23 61h-1v-1h1z",
    fill: "#965d2d"
  })), _path4038 || (_path4038 = /*#__PURE__*/React.createElement("path", {
    d: "M23 61v-1h1v1z",
    fill: "#925b28"
  })), _path4039 || (_path4039 = /*#__PURE__*/React.createElement("path", {
    d: "M24 60h1v1h-1z",
    fill: "#8d5324"
  })), _path4040 || (_path4040 = /*#__PURE__*/React.createElement("path", {
    d: "M26 60v1h-1v-1z",
    fill: "#844520"
  })), _path4041 || (_path4041 = /*#__PURE__*/React.createElement("path", {
    d: "M26 61v-1h1v1z",
    fill: "#7d3f1a"
  })), _path4042 || (_path4042 = /*#__PURE__*/React.createElement("path", {
    d: "M28 61h-1v-1h1z",
    fill: "#7c441a"
  })), _path4043 || (_path4043 = /*#__PURE__*/React.createElement("path", {
    d: "M29 60v1h-1v-1z",
    fill: "#86522d"
  })), _path4044 || (_path4044 = /*#__PURE__*/React.createElement("path", {
    d: "M30 61h-1v-1h1z",
    fill: "#8c5d3c"
  })), _path4045 || (_path4045 = /*#__PURE__*/React.createElement("path", {
    d: "M30 61v-1h1v1z",
    fill: "#8b5e42"
  })), _path4046 || (_path4046 = /*#__PURE__*/React.createElement("path", {
    d: "M31 61v-1h1v1z",
    fill: "#8b5e46"
  })), _path4047 || (_path4047 = /*#__PURE__*/React.createElement("path", {
    d: "M32 61v-1h1v1z",
    fill: "#8c5e46"
  })), _path4048 || (_path4048 = /*#__PURE__*/React.createElement("path", {
    d: "M33 61v-1h1v1z",
    fill: "#895c42"
  })), _path4049 || (_path4049 = /*#__PURE__*/React.createElement("path", {
    d: "M35 61h-1v-1h1z",
    fill: "#875a40"
  })), _path4050 || (_path4050 = /*#__PURE__*/React.createElement("path", {
    d: "M36 60v1h-1v-1z",
    fill: "#85583f"
  })), _path4051 || (_path4051 = /*#__PURE__*/React.createElement("path", {
    d: "M36 60h1v1h-1z",
    fill: "#86593f"
  })), _path4052 || (_path4052 = /*#__PURE__*/React.createElement("path", {
    d: "M38 60v1h-1v-1z",
    fill: "#86583d"
  })), _path4053 || (_path4053 = /*#__PURE__*/React.createElement("path", {
    d: "M39 61h-1v-1h1z",
    fill: "#9d7159"
  })), _path4054 || (_path4054 = /*#__PURE__*/React.createElement("path", {
    d: "M40 61h-1v-1h1z",
    fill: "#ca9d90"
  })), _path4055 || (_path4055 = /*#__PURE__*/React.createElement("path", {
    d: "M40 61v-1h1v1z",
    fill: "#c7998f"
  })), _path4056 || (_path4056 = /*#__PURE__*/React.createElement("path", {
    d: "M41 60h1v1h-1z",
    fill: "#c09686"
  })), _path4057 || (_path4057 = /*#__PURE__*/React.createElement("path", {
    d: "M43 61h-1v-1h1z",
    fill: "#845439"
  })), _path4058 || (_path4058 = /*#__PURE__*/React.createElement("path", {
    d: "M44 60v1h-1v-1z",
    fill: "#7b4d32"
  })), _path4059 || (_path4059 = /*#__PURE__*/React.createElement("path", {
    d: "M44 60h1v1h-1z",
    fill: "#8a5d45"
  })), _path4060 || (_path4060 = /*#__PURE__*/React.createElement("path", {
    d: "M46 61h-1v-1h1z",
    fill: "#885f45"
  })), _path4061 || (_path4061 = /*#__PURE__*/React.createElement("path", {
    d: "M46 60h1v1h-1z",
    fill: "#896046"
  })), _path4062 || (_path4062 = /*#__PURE__*/React.createElement("path", {
    d: "M48 61h-1v-1h1z",
    fill: "#8d6347"
  })), _path4063 || (_path4063 = /*#__PURE__*/React.createElement("path", {
    d: "M49 60h1v1h-1z",
    fill: "#92634a"
  })), _path4064 || (_path4064 = /*#__PURE__*/React.createElement("path", {
    d: "M50 61v-1h1v1z",
    fill: "#92644a"
  })), _path4065 || (_path4065 = /*#__PURE__*/React.createElement("path", {
    d: "M52 61h-1v-1h1z",
    fill: "#926549"
  })), _path4066 || (_path4066 = /*#__PURE__*/React.createElement("path", {
    d: "M53 61h-1v-1h1z",
    fill: "#8c6143"
  })), _path4067 || (_path4067 = /*#__PURE__*/React.createElement("path", {
    d: "M54 61h-1v-1h1z",
    fill: "#85573c",
    fillOpacity: 0.992
  })), _path4068 || (_path4068 = /*#__PURE__*/React.createElement("path", {
    d: "M55 60v1h-1v-1z",
    fill: "#83533b",
    fillOpacity: 0.918
  })), _path4069 || (_path4069 = /*#__PURE__*/React.createElement("path", {
    d: "M55 61v-1h1v1z",
    fill: "#80503d",
    fillOpacity: 0.816
  })), _path4070 || (_path4070 = /*#__PURE__*/React.createElement("path", {
    d: "M56 60h1v1h-1z",
    fill: "#81523f",
    fillOpacity: 0.663
  })), _path4071 || (_path4071 = /*#__PURE__*/React.createElement("path", {
    d: "M58 61h-1v-1h1z",
    fill: "#815440",
    fillOpacity: 0.51
  })), _path4072 || (_path4072 = /*#__PURE__*/React.createElement("path", {
    d: "M58 60h1v1h-1z",
    fill: "#7b5844",
    fillOpacity: 0.349
  })), _path4073 || (_path4073 = /*#__PURE__*/React.createElement("path", {
    d: "M59 60h1v1h-1z",
    fill: "#795645",
    fillOpacity: 0.231
  })), _path4074 || (_path4074 = /*#__PURE__*/React.createElement("path", {
    d: "M61 61h-1v-1h1z",
    fill: "#88664f",
    fillOpacity: 0.353
  })), _path4075 || (_path4075 = /*#__PURE__*/React.createElement("path", {
    d: "M61 60h1v1h-1z",
    fill: "#986943",
    fillOpacity: 0.996
  })), _path4076 || (_path4076 = /*#__PURE__*/React.createElement("path", {
    d: "M62 61v-1h1v1z",
    fill: "#9b653c"
  })), _path4077 || (_path4077 = /*#__PURE__*/React.createElement("path", {
    d: "M64 60v1h-1v-1z",
    fill: "#9d643f"
  })), _path4078 || (_path4078 = /*#__PURE__*/React.createElement("path", {
    d: "M64 61v-1h1v1z",
    fill: "#93633b"
  })), _path4079 || (_path4079 = /*#__PURE__*/React.createElement("path", {
    d: "M66 61h-1v-1h1z",
    fill: "#83634a",
    fillOpacity: 0.282
  })), _path4080 || (_path4080 = /*#__PURE__*/React.createElement("path", {
    d: "M71 60h1v1h-1z",
    fill: "#8c664c",
    fillOpacity: 0.157
  })), _path4081 || (_path4081 = /*#__PURE__*/React.createElement("path", {
    d: "M72 60h1v1h-1z",
    fill: "#97623a",
    fillOpacity: 0.961
  })), _path4082 || (_path4082 = /*#__PURE__*/React.createElement("path", {
    d: "M74 60v1h-1v-1z",
    fill: "#a87241"
  })), _path4083 || (_path4083 = /*#__PURE__*/React.createElement("path", {
    d: "M75 61h-1v-1h1z",
    fill: "#aa7646"
  })), _path4084 || (_path4084 = /*#__PURE__*/React.createElement("path", {
    d: "M76 60v1h-1v-1z",
    fill: "#ac7d4d"
  })), _path4085 || (_path4085 = /*#__PURE__*/React.createElement("path", {
    d: "M78 61h-1v-1h1z",
    fill: "#a5793f"
  })), _path4086 || (_path4086 = /*#__PURE__*/React.createElement("path", {
    d: "M79 60v1h-1v-1z",
    fill: "#a0784c",
    fillOpacity: 0.886
  })), _path4087 || (_path4087 = /*#__PURE__*/React.createElement("path", {
    d: "M80 60v1h-1v-1z",
    fill: "#99b2b2",
    fillOpacity: 0.039
  })), _path4088 || (_path4088 = /*#__PURE__*/React.createElement("path", {
    d: "M94 60h1v1h-1z",
    fill: "#714b41",
    fillOpacity: 0.184
  })), _path4089 || (_path4089 = /*#__PURE__*/React.createElement("path", {
    d: "M95 61v-1h1v1z",
    fill: "#875437",
    fillOpacity: 0.992
  })), _path4090 || (_path4090 = /*#__PURE__*/React.createElement("path", {
    d: "M96 60h1v1h-1z",
    fill: "#996343"
  })), _path4091 || (_path4091 = /*#__PURE__*/React.createElement("path", {
    d: "M98 61h-1v-1h1z",
    fill: "#8f6656",
    fillOpacity: 0.855
  })), _path4092 || (_path4092 = /*#__PURE__*/React.createElement("path", {
    d: "M98 60h1v1h-1z",
    fill: "#7f7f7f",
    fillOpacity: 0.039
  })), _path4093 || (_path4093 = /*#__PURE__*/React.createElement("path", {
    d: "M102 61h-1v-1h1z",
    fill: "#774d3a",
    fillOpacity: 0.31
  })), _path4094 || (_path4094 = /*#__PURE__*/React.createElement("path", {
    d: "M102 61v-1h1v1z",
    fill: "#8e522f"
  })), _path4095 || (_path4095 = /*#__PURE__*/React.createElement("path", {
    d: "M103 61v-1h1v1z",
    fill: "#92562d"
  })), _path4096 || (_path4096 = /*#__PURE__*/React.createElement("path", {
    d: "M104 60h1v1h-1z",
    fill: "#bc7b51"
  })), _path4097 || (_path4097 = /*#__PURE__*/React.createElement("path", {
    d: "M105 60h1v1h-1z",
    fill: "#c6906a",
    fillOpacity: 0.835
  })), _path4098 || (_path4098 = /*#__PURE__*/React.createElement("path", {
    d: "M109 60v1h-1v-1z",
    fill: "#8d5f3f",
    fillOpacity: 0.792
  })), _path4099 || (_path4099 = /*#__PURE__*/React.createElement("path", {
    d: "M110 60v1h-1v-1z",
    fill: "#8e5d34"
  })), _path4100 || (_path4100 = /*#__PURE__*/React.createElement("path", {
    d: "M110 61v-1h1v1z",
    fill: "#774e28"
  })), _path4101 || (_path4101 = /*#__PURE__*/React.createElement("path", {
    d: "M112 60v1h-1v-1z",
    fill: "#a0753e"
  })), _path4102 || (_path4102 = /*#__PURE__*/React.createElement("path", {
    d: "M112 61v-1h1v1z",
    fill: "#f1ae69"
  })), _path4103 || (_path4103 = /*#__PURE__*/React.createElement("path", {
    d: "M114 61h-1v-1h1z",
    fill: "#d4975d",
    fillOpacity: 0.843
  })), _path4104 || (_path4104 = /*#__PURE__*/React.createElement("path", {
    d: "M114 60h1v1h-1z",
    fill: "#845c45",
    fillOpacity: 0.475
  })), _path4105 || (_path4105 = /*#__PURE__*/React.createElement("path", {
    d: "M116 61h-1v-1h1z",
    fill: "#784c2b",
    fillOpacity: 0.616
  })), _path4106 || (_path4106 = /*#__PURE__*/React.createElement("path", {
    d: "M117 61h-1v-1h1z",
    fill: "#7c4c2f",
    fillOpacity: 0.82
  })), _path4107 || (_path4107 = /*#__PURE__*/React.createElement("path", {
    d: "M117 61v-1h1v1z",
    fill: "#895138"
  })), _path4108 || (_path4108 = /*#__PURE__*/React.createElement("path", {
    d: "M119 61h-1v-1h1z",
    fill: "#a26c4a"
  })), _path4109 || (_path4109 = /*#__PURE__*/React.createElement("path", {
    d: "M119 61v-1h1v1z",
    fill: "#b98767"
  })), _path4110 || (_path4110 = /*#__PURE__*/React.createElement("path", {
    d: "M120 61v-1h1v1z",
    fill: "#ad8469",
    fillOpacity: 0.784
  })), _path4111 || (_path4111 = /*#__PURE__*/React.createElement("path", {
    d: "M9 61v1H8v-1z",
    fill: "#a57452",
    fillOpacity: 0.663
  })), _path4112 || (_path4112 = /*#__PURE__*/React.createElement("path", {
    d: "M10 61v1H9v-1z",
    fill: "#b87e58"
  })), _path4113 || (_path4113 = /*#__PURE__*/React.createElement("path", {
    d: "M10 62v-1h1v1z",
    fill: "#925831"
  })), _path4114 || (_path4114 = /*#__PURE__*/React.createElement("path", {
    d: "M12 62h-1v-1h1z",
    fill: "#874f26"
  })), _path4115 || (_path4115 = /*#__PURE__*/React.createElement("path", {
    d: "M13 62h-1v-1h1z",
    fill: "#8c5528"
  })), _path4116 || (_path4116 = /*#__PURE__*/React.createElement("path", {
    d: "M13 61h1v1h-1z",
    fill: "#7d5233",
    fillOpacity: 0.627
  })), _path4117 || (_path4117 = /*#__PURE__*/React.createElement("path", {
    d: "M22 61v1h-1v-1z",
    fill: "#816246",
    fillOpacity: 0.255
  })), _path4118 || (_path4118 = /*#__PURE__*/React.createElement("path", {
    d: "M22 62v-1h1v1z",
    fill: "#8d5b32"
  })), _path4119 || (_path4119 = /*#__PURE__*/React.createElement("path", {
    d: "M24 62h-1v-1h1z",
    fill: "#8c5323"
  })), _path4120 || (_path4120 = /*#__PURE__*/React.createElement("path", {
    d: "M25 62h-1v-1h1z",
    fill: "#894f20"
  })), _path4121 || (_path4121 = /*#__PURE__*/React.createElement("path", {
    d: "M25 62v-1h1v1z",
    fill: "#884920"
  })), _path4122 || (_path4122 = /*#__PURE__*/React.createElement("path", {
    d: "M27 61v1h-1v-1z",
    fill: "#864a22"
  })), _path4123 || (_path4123 = /*#__PURE__*/React.createElement("path", {
    d: "M27 61h1v1h-1z",
    fill: "#864d26"
  })), _path4124 || (_path4124 = /*#__PURE__*/React.createElement("path", {
    d: "M29 62h-1v-1h1z",
    fill: "#8f5832"
  })), _path4125 || (_path4125 = /*#__PURE__*/React.createElement("path", {
    d: "M32 62h-1v-1h1z",
    fill: "#8d5f3d"
  })), _path4126 || (_path4126 = /*#__PURE__*/React.createElement("path", {
    d: "M32 62v-1h1v1z",
    fill: "#8c5d3b"
  })), _path4127 || (_path4127 = /*#__PURE__*/React.createElement("path", {
    d: "M33 61h1v1h-1z",
    fill: "#89593a"
  })), _path4128 || (_path4128 = /*#__PURE__*/React.createElement("path", {
    d: "M35 61v1h-1v-1z",
    fill: "#865839"
  })), _path4129 || (_path4129 = /*#__PURE__*/React.createElement("path", {
    d: "M36 62h-1v-1h1z",
    fill: "#885a3c"
  })), _path4130 || (_path4130 = /*#__PURE__*/React.createElement("path", {
    d: "M37 62v-1h1v1z",
    fill: "#8a5b42"
  })), _path4131 || (_path4131 = /*#__PURE__*/React.createElement("path", {
    d: "M38 61h1v1h-1z",
    fill: "#9f725d"
  })), _path4132 || (_path4132 = /*#__PURE__*/React.createElement("path", {
    d: "M39 61h1v1h-1z",
    fill: "#c7988d"
  })), _path4133 || (_path4133 = /*#__PURE__*/React.createElement("path", {
    d: "M41 61v1h-1v-1z",
    fill: "#c29489"
  })), _path4134 || (_path4134 = /*#__PURE__*/React.createElement("path", {
    d: "M42 61v1h-1v-1z",
    fill: "#c19685"
  })), _path4135 || (_path4135 = /*#__PURE__*/React.createElement("path", {
    d: "M42 62v-1h1v1z",
    fill: "#85533a"
  })), _path4136 || (_path4136 = /*#__PURE__*/React.createElement("path", {
    d: "M44 62h-1v-1h1z",
    fill: "#7d4c32"
  })), _path4137 || (_path4137 = /*#__PURE__*/React.createElement("path", {
    d: "M44 61h1v1h-1z",
    fill: "#8b5f47"
  })), _path4138 || (_path4138 = /*#__PURE__*/React.createElement("path", {
    d: "M45 61h1v1h-1z",
    fill: "#8d6148"
  })), _path4139 || (_path4139 = /*#__PURE__*/React.createElement("path", {
    d: "M47 61h1v1h-1z",
    fill: "#8f6347"
  })), _path4140 || (_path4140 = /*#__PURE__*/React.createElement("path", {
    d: "M49 62v-1h1v1z",
    fill: "#8f6144"
  })), _path4141 || (_path4141 = /*#__PURE__*/React.createElement("path", {
    d: "M50 61h1v1h-1z",
    fill: "#8d5d3e"
  })), _path4142 || (_path4142 = /*#__PURE__*/React.createElement("path", {
    d: "M52 62h-1v-1h1z",
    fill: "#8a5738"
  })), _path4143 || (_path4143 = /*#__PURE__*/React.createElement("path", {
    d: "M53 62h-1v-1h1z",
    fill: "#875535"
  })), _path4144 || (_path4144 = /*#__PURE__*/React.createElement("path", {
    d: "M54 61v1h-1v-1z",
    fill: "#865534"
  })), _path4145 || (_path4145 = /*#__PURE__*/React.createElement("path", {
    d: "M54 62v-1h1v1z",
    fill: "#895636"
  })), _path4146 || (_path4146 = /*#__PURE__*/React.createElement("path", {
    d: "M56 62h-1v-1h1z",
    fill: "#8d5a3a"
  })), _path4147 || (_path4147 = /*#__PURE__*/React.createElement("path", {
    d: "M56 62v-1h1v1z",
    fill: "#8f5d3e"
  })), _path4148 || (_path4148 = /*#__PURE__*/React.createElement("path", {
    d: "M57 61h1v1h-1z",
    fill: "#925c42"
  })), _path4149 || (_path4149 = /*#__PURE__*/React.createElement("path", {
    d: "M58 61h1v1h-1z",
    fill: "#8f5c42"
  })), _path4150 || (_path4150 = /*#__PURE__*/React.createElement("path", {
    d: "M60 62h-1v-1h1z",
    fill: "#895940"
  })), _path4151 || (_path4151 = /*#__PURE__*/React.createElement("path", {
    d: "M61 61v1h-1v-1z",
    fill: "#885237",
    fillOpacity: 0.973
  })), _path4152 || (_path4152 = /*#__PURE__*/React.createElement("path", {
    d: "M62 62v-1h1v1z",
    fill: "#864b22"
  })), _path4153 || (_path4153 = /*#__PURE__*/React.createElement("path", {
    d: "M64 61h1v1h-1z",
    fill: "#89522a"
  })), _path4154 || (_path4154 = /*#__PURE__*/React.createElement("path", {
    d: "M65 61h1v1h-1z",
    fill: "#824f2c",
    fillOpacity: 0.627
  })), _path4155 || (_path4155 = /*#__PURE__*/React.createElement("path", {
    d: "M66 62v-1h1v1z",
    fill: "#7c5538",
    fillOpacity: 0.353
  })), _path4156 || (_path4156 = /*#__PURE__*/React.createElement("path", {
    d: "M68 62h-1v-1h1z",
    fill: "#845e42",
    fillOpacity: 0.212
  })), _path4157 || (_path4157 = /*#__PURE__*/React.createElement("path", {
    d: "M69 61v1h-1v-1z",
    fill: "#7f7155",
    fillOpacity: 0.071
  })), _path4158 || (_path4158 = /*#__PURE__*/React.createElement("path", {
    d: "M71 62v-1h1v1z",
    fill: "#8a6657",
    fillOpacity: 0.137
  })), _path4159 || (_path4159 = /*#__PURE__*/React.createElement("path", {
    d: "M73 61v1h-1v-1z",
    fill: "#98643b",
    fillOpacity: 0.949
  })), _path4160 || (_path4160 = /*#__PURE__*/React.createElement("path", {
    d: "M74 62h-1v-1h1z",
    fill: "#a97141"
  })), _path4161 || (_path4161 = /*#__PURE__*/React.createElement("path", {
    d: "M74 61h1v1h-1z",
    fill: "#ab7646"
  })), _path4162 || (_path4162 = /*#__PURE__*/React.createElement("path", {
    d: "M76 62h-1v-1h1z",
    fill: "#ad7e4f"
  })), _path4163 || (_path4163 = /*#__PURE__*/React.createElement("path", {
    d: "M76 61h1v1h-1z",
    fill: "#9e7341"
  })), _path4164 || (_path4164 = /*#__PURE__*/React.createElement("path", {
    d: "M77 62v-1h1v1z",
    fill: "#a1773f"
  })), _path4165 || (_path4165 = /*#__PURE__*/React.createElement("path", {
    d: "M78 62v-1h1v1z",
    fill: "#a27647",
    fillOpacity: 0.961
  })), _path4166 || (_path4166 = /*#__PURE__*/React.createElement("path", {
    d: "M80 62h-1v-1h1z",
    fill: "#794a25",
    fillOpacity: 0.592
  })), _path4167 || (_path4167 = /*#__PURE__*/React.createElement("path", {
    d: "M81 61v1h-1v-1z",
    fill: "#764528",
    fillOpacity: 0.373
  })), _path4168 || (_path4168 = /*#__PURE__*/React.createElement("path", {
    d: "M82 62h-1v-1h1z",
    fill: "#6c463b",
    fillOpacity: 0.184
  })), _path4169 || (_path4169 = /*#__PURE__*/React.createElement("path", {
    d: "M82 62v-1h1v1z",
    fill: "#544",
    fillOpacity: 0.059
  })), _path4170 || (_path4170 = /*#__PURE__*/React.createElement("path", {
    d: "M93 61h1v1h-1z",
    fill: "#6c4934",
    fillOpacity: 0.286
  })), _path4171 || (_path4171 = /*#__PURE__*/React.createElement("path", {
    d: "M95 61v1h-1v-1z",
    fill: "#6a4224",
    fillOpacity: 0.6
  })), _path4172 || (_path4172 = /*#__PURE__*/React.createElement("path", {
    d: "M95 61h1v1h-1z",
    fill: "#743e1e"
  })), _path4173 || (_path4173 = /*#__PURE__*/React.createElement("path", {
    d: "M97 61v1h-1v-1z",
    fill: "#8c5437"
  })), _path4174 || (_path4174 = /*#__PURE__*/React.createElement("path", {
    d: "M97 62v-1h1v1z",
    fill: "#936956",
    fillOpacity: 0.871
  })), _path4175 || (_path4175 = /*#__PURE__*/React.createElement("path", {
    d: "M98 61h1v1h-1z",
    fill: "#6d6d6d",
    fillOpacity: 0.055
  })), _path4176 || (_path4176 = /*#__PURE__*/React.createElement("path", {
    d: "M102 61v1h-1v-1z",
    fill: "#79503b",
    fillOpacity: 0.337
  })), _path4177 || (_path4177 = /*#__PURE__*/React.createElement("path", {
    d: "M103 62h-1v-1h1z",
    fill: "#8f5732"
  })), _path4178 || (_path4178 = /*#__PURE__*/React.createElement("path", {
    d: "M104 62h-1v-1h1z",
    fill: "#985931"
  })), _path4179 || (_path4179 = /*#__PURE__*/React.createElement("path", {
    d: "M104 62v-1h1v1z",
    fill: "#c48059"
  })), _path4180 || (_path4180 = /*#__PURE__*/React.createElement("path", {
    d: "M106 62h-1v-1h1z",
    fill: "#c98e70",
    fillOpacity: 0.839
  })), _path4181 || (_path4181 = /*#__PURE__*/React.createElement("path", {
    d: "M107 62h-1v-1h1z",
    fill: "#a57866",
    fillOpacity: 0.224
  })), _path4182 || (_path4182 = /*#__PURE__*/React.createElement("path", {
    d: "M107 62v-1h1v1z",
    fill: "#ad7353",
    fillOpacity: 0.529
  })), _path4183 || (_path4183 = /*#__PURE__*/React.createElement("path", {
    d: "M108 61h1v1h-1z",
    fill: "#976338",
    fillOpacity: 0.949
  })), _path4184 || (_path4184 = /*#__PURE__*/React.createElement("path", {
    d: "M109 62v-1h1v1z",
    fill: "#8a5935"
  })), _path4185 || (_path4185 = /*#__PURE__*/React.createElement("path", {
    d: "M111 62h-1v-1h1z",
    fill: "#764d29"
  })), _path4186 || (_path4186 = /*#__PURE__*/React.createElement("path", {
    d: "M111 62v-1h1v1z",
    fill: "#a27540"
  })), _path4187 || (_path4187 = /*#__PURE__*/React.createElement("path", {
    d: "M112 62v-1h1v1z",
    fill: "#f4b069"
  })), _path4188 || (_path4188 = /*#__PURE__*/React.createElement("path", {
    d: "M113 61h1v1h-1z",
    fill: "#dea163",
    fillOpacity: 0.671
  })), _path4189 || (_path4189 = /*#__PURE__*/React.createElement("path", {
    d: "M117 61v1h-1v-1z",
    fill: "#845f51",
    fillOpacity: 0.294
  })), _path4190 || (_path4190 = /*#__PURE__*/React.createElement("path", {
    d: "M118 62h-1v-1h1z",
    fill: "#844f31"
  })), _path4191 || (_path4191 = /*#__PURE__*/React.createElement("path", {
    d: "M118 62v-1h1v1z",
    fill: "#a16947"
  })), _path4192 || (_path4192 = /*#__PURE__*/React.createElement("path", {
    d: "M119 62v-1h1v1z",
    fill: "#ba8767"
  })), _path4193 || (_path4193 = /*#__PURE__*/React.createElement("path", {
    d: "M121 61v1h-1v-1z",
    fill: "#af8468",
    fillOpacity: 0.776
  })), _path4194 || (_path4194 = /*#__PURE__*/React.createElement("path", {
    d: "M9 63H8v-1h1z",
    fill: "#a47051",
    fillOpacity: 0.541
  })), _path4195 || (_path4195 = /*#__PURE__*/React.createElement("path", {
    d: "M9 62h1v1H9z",
    fill: "#bc835c"
  })), _path4196 || (_path4196 = /*#__PURE__*/React.createElement("path", {
    d: "M11 62h1v1h-1z",
    fill: "#854d23"
  })), _path4197 || (_path4197 = /*#__PURE__*/React.createElement("path", {
    d: "M12 63v-1h1v1z",
    fill: "#895328"
  })), _path4198 || (_path4198 = /*#__PURE__*/React.createElement("path", {
    d: "M14 62v1h-1v-1z",
    fill: "#7d5232",
    fillOpacity: 0.718
  })), _path4199 || (_path4199 = /*#__PURE__*/React.createElement("path", {
    d: "M20 62h1v1h-1z",
    fill: "#876b58",
    fillOpacity: 0.42
  })), _path4200 || (_path4200 = /*#__PURE__*/React.createElement("path", {
    d: "M22 63h-1v-1h1z",
    fill: "#8a6341",
    fillOpacity: 0.835
  })), _path4201 || (_path4201 = /*#__PURE__*/React.createElement("path", {
    d: "M22 62h1v1h-1z",
    fill: "#8c582c"
  })), _path4202 || (_path4202 = /*#__PURE__*/React.createElement("path", {
    d: "M24 62v1h-1v-1z",
    fill: "#8b5024"
  })), _path4203 || (_path4203 = /*#__PURE__*/React.createElement("path", {
    d: "M24 62h1v1h-1z",
    fill: "#8a5023"
  })), _path4204 || (_path4204 = /*#__PURE__*/React.createElement("path", {
    d: "M26 62v1h-1v-1z",
    fill: "#8a4e22"
  })), _path4205 || (_path4205 = /*#__PURE__*/React.createElement("path", {
    d: "M26 63v-1h1v1z",
    fill: "#894e22"
  })), _path4206 || (_path4206 = /*#__PURE__*/React.createElement("path", {
    d: "M28 63h-1v-1h1z",
    fill: "#894f24"
  })), _path4207 || (_path4207 = /*#__PURE__*/React.createElement("path", {
    d: "M29 62v1h-1v-1z",
    fill: "#8c542a"
  })), _path4208 || (_path4208 = /*#__PURE__*/React.createElement("path", {
    d: "M29 62h1v1h-1z",
    fill: "#8e5a31"
  })), _path4209 || (_path4209 = /*#__PURE__*/React.createElement("path", {
    d: "M30 62h1v1h-1z",
    fill: "#8e5d36"
  })), _path4210 || (_path4210 = /*#__PURE__*/React.createElement("path", {
    d: "M33 62h1v1h-1z",
    fill: "#8e5e3b"
  })), _path4211 || (_path4211 = /*#__PURE__*/React.createElement("path", {
    d: "M34 62h1v1h-1z",
    fill: "#8e5f3e"
  })), _path4212 || (_path4212 = /*#__PURE__*/React.createElement("path", {
    d: "M35 63v-1h1v1z",
    fill: "#8d5f3e"
  })), _path4213 || (_path4213 = /*#__PURE__*/React.createElement("path", {
    d: "M36 62h1v1h-1z",
    fill: "#8d5e3f"
  })), _path4214 || (_path4214 = /*#__PURE__*/React.createElement("path", {
    d: "M37 63v-1h1v1z",
    fill: "#895a3b"
  })), _path4215 || (_path4215 = /*#__PURE__*/React.createElement("path", {
    d: "M39 63h-1v-1h1z",
    fill: "#a07158"
  })), _path4216 || (_path4216 = /*#__PURE__*/React.createElement("path", {
    d: "M40 63h-1v-1h1z",
    fill: "#ca9b8e"
  })), _path4217 || (_path4217 = /*#__PURE__*/React.createElement("path", {
    d: "M41 62v1h-1v-1z",
    fill: "#c09386"
  })), _path4218 || (_path4218 = /*#__PURE__*/React.createElement("path", {
    d: "M41 62h1v1h-1z",
    fill: "#c19786"
  })), _path4219 || (_path4219 = /*#__PURE__*/React.createElement("path", {
    d: "M42 63v-1h1v1z",
    fill: "#85553c"
  })), _path4220 || (_path4220 = /*#__PURE__*/React.createElement("path", {
    d: "M43 63v-1h1v1z",
    fill: "#804e2e"
  })), _path4221 || (_path4221 = /*#__PURE__*/React.createElement("path", {
    d: "M45 63h-1v-1h1z",
    fill: "#906243"
  })), _path4222 || (_path4222 = /*#__PURE__*/React.createElement("path", {
    d: "M45 63v-1h1v1z",
    fill: "#8d6141"
  })), _path4223 || (_path4223 = /*#__PURE__*/React.createElement("path", {
    d: "M46 62h1v1h-1z",
    fill: "#8d6140"
  })), _path4224 || (_path4224 = /*#__PURE__*/React.createElement("path", {
    d: "M48 62v1h-1v-1z",
    fill: "#8e613f"
  })), _path4225 || (_path4225 = /*#__PURE__*/React.createElement("path", {
    d: "M48 62h1v1h-1z",
    fill: "#8b5d3b"
  })), _path4226 || (_path4226 = /*#__PURE__*/React.createElement("path", {
    d: "M49 63v-1h1v1z",
    fill: "#8b5b39"
  })), _path4227 || (_path4227 = /*#__PURE__*/React.createElement("path", {
    d: "M50 63v-1h1v1z",
    fill: "#895736"
  })), _path4228 || (_path4228 = /*#__PURE__*/React.createElement("path", {
    d: "M51 62h1v1h-1z",
    fill: "#895434"
  })), _path4229 || (_path4229 = /*#__PURE__*/React.createElement("path", {
    d: "M53 62v1h-1v-1z",
    fill: "#8a5637"
  })), _path4230 || (_path4230 = /*#__PURE__*/React.createElement("path", {
    d: "M53 62h1v1h-1z",
    fill: "#8b5b3a"
  })), _path4231 || (_path4231 = /*#__PURE__*/React.createElement("path", {
    d: "M55 62v1h-1v-1z",
    fill: "#8e5e3e"
  })), _path4232 || (_path4232 = /*#__PURE__*/React.createElement("path", {
    d: "M56 63h-1v-1h1z",
    fill: "#916242"
  })), _path4233 || (_path4233 = /*#__PURE__*/React.createElement("path", {
    d: "M56 62h1v1h-1z",
    fill: "#8f6142"
  })), _path4234 || (_path4234 = /*#__PURE__*/React.createElement("path", {
    d: "M58 63h-1v-1h1z",
    fill: "#906043"
  })), _path4235 || (_path4235 = /*#__PURE__*/React.createElement("path", {
    d: "M58 62h1v1h-1z",
    fill: "#905e3f"
  })), _path4236 || (_path4236 = /*#__PURE__*/React.createElement("path", {
    d: "M60 62v1h-1v-1z",
    fill: "#8f5b39"
  })), _path4237 || (_path4237 = /*#__PURE__*/React.createElement("path", {
    d: "M60 62h1v1h-1z",
    fill: "#925835"
  })), _path4238 || (_path4238 = /*#__PURE__*/React.createElement("path", {
    d: "M62 62v1h-1v-1z",
    fill: "#935630"
  })), _path4239 || (_path4239 = /*#__PURE__*/React.createElement("path", {
    d: "M63 62v1h-1v-1z",
    fill: "#905329"
  })), _path4240 || (_path4240 = /*#__PURE__*/React.createElement("path", {
    d: "M63 63v-1h1v1z",
    fill: "#8f5127"
  })), _path4241 || (_path4241 = /*#__PURE__*/React.createElement("path", {
    d: "M65 62h1v1h-1z",
    fill: "#914f20"
  })), _path4242 || (_path4242 = /*#__PURE__*/React.createElement("path", {
    d: "M67 63v-1h1v1z",
    fill: "#8a5028",
    fillOpacity: 0.988
  })), _path4243 || (_path4243 = /*#__PURE__*/React.createElement("path", {
    d: "M69 63h-1v-1h1z",
    fill: "#8a5530",
    fillOpacity: 0.875
  })), _path4244 || (_path4244 = /*#__PURE__*/React.createElement("path", {
    d: "M70 62v1h-1v-1z",
    fill: "#8b6856",
    fillOpacity: 0.173
  })), _path4245 || (_path4245 = /*#__PURE__*/React.createElement("path", {
    d: "M72 62v1h-1v-1z",
    fill: "#7f674f",
    fillOpacity: 0.125
  })), _path4246 || (_path4246 = /*#__PURE__*/React.createElement("path", {
    d: "M73 62v1h-1v-1z",
    fill: "#976337",
    fillOpacity: 0.937
  })), _path4247 || (_path4247 = /*#__PURE__*/React.createElement("path", {
    d: "M73 62h1v1h-1z",
    fill: "#a8703e"
  })), _path4248 || (_path4248 = /*#__PURE__*/React.createElement("path", {
    d: "M75 62v1h-1v-1z",
    fill: "#ac7645"
  })), _path4249 || (_path4249 = /*#__PURE__*/React.createElement("path", {
    d: "M75 63v-1h1v1z",
    fill: "#a97748"
  })), _path4250 || (_path4250 = /*#__PURE__*/React.createElement("path", {
    d: "M76 63v-1h1v1z",
    fill: "#9f723e"
  })), _path4251 || (_path4251 = /*#__PURE__*/React.createElement("path", {
    d: "M78 63h-1v-1h1z",
    fill: "#a2753e"
  })), _path4252 || (_path4252 = /*#__PURE__*/React.createElement("path", {
    d: "M78 62h1v1h-1z",
    fill: "#a37445",
    fillOpacity: 0.988
  })), _path4253 || (_path4253 = /*#__PURE__*/React.createElement("path", {
    d: "M79 63v-1h1v1z",
    fill: "#855632",
    fillOpacity: 0.965
  })), _path4254 || (_path4254 = /*#__PURE__*/React.createElement("path", {
    d: "M80 63v-1h1v1z",
    fill: "#885434"
  })), _path4255 || (_path4255 = /*#__PURE__*/React.createElement("path", {
    d: "M83 63h-1v-1h1z",
    fill: "#804830",
    fillOpacity: 0.91
  })), _path4256 || (_path4256 = /*#__PURE__*/React.createElement("path", {
    d: "M83 62h1v1h-1z",
    fill: "#7c442a",
    fillOpacity: 0.725
  })), _path4257 || (_path4257 = /*#__PURE__*/React.createElement("path", {
    d: "M84 63v-1h1v1z",
    fill: "#744429",
    fillOpacity: 0.525
  })), _path4258 || (_path4258 = /*#__PURE__*/React.createElement("path", {
    d: "M85 62h1v1h-1z",
    fill: "#694029",
    fillOpacity: 0.341
  })), _path4259 || (_path4259 = /*#__PURE__*/React.createElement("path", {
    d: "M87 63h-1v-1h1z",
    fill: "#67412b",
    fillOpacity: 0.184
  })), _path4260 || (_path4260 = /*#__PURE__*/React.createElement("path", {
    d: "M88 63h-1v-1h1z",
    fill: "#6f5f3f",
    fillOpacity: 0.063
  })), _path4261 || (_path4261 = /*#__PURE__*/React.createElement("path", {
    d: "M89 62v1h-1v-1z",
    fill: "#6a5241",
    fillOpacity: 0.122
  })), _path4262 || (_path4262 = /*#__PURE__*/React.createElement("path", {
    d: "M90 63h-1v-1h1z",
    fill: "#6b4935",
    fillOpacity: 0.298
  })), _path4263 || (_path4263 = /*#__PURE__*/React.createElement("path", {
    d: "M90 62h1v1h-1z",
    fill: "#744a33",
    fillOpacity: 0.522
  })), _path4264 || (_path4264 = /*#__PURE__*/React.createElement("path", {
    d: "M92 62v1h-1v-1z",
    fill: "#764a32",
    fillOpacity: 0.753
  })), _path4265 || (_path4265 = /*#__PURE__*/React.createElement("path", {
    d: "M92 63v-1h1v1z",
    fill: "#7e4f33",
    fillOpacity: 0.941
  })), _path4266 || (_path4266 = /*#__PURE__*/React.createElement("path", {
    d: "M93 63v-1h1v1z",
    fill: "#815031",
    fillOpacity: 0.996
  })), _path4267 || (_path4267 = /*#__PURE__*/React.createElement("path", {
    d: "M94 63v-1h1v1z",
    fill: "#87563c",
    fillOpacity: 0.949
  })), _path4268 || (_path4268 = /*#__PURE__*/React.createElement("path", {
    d: "M95 62h1v1h-1z",
    fill: "#945a3d",
    fillOpacity: 0.992
  })), _path4269 || (_path4269 = /*#__PURE__*/React.createElement("path", {
    d: "M96 63v-1h1v1z",
    fill: "#8f5e3d"
  })), _path4270 || (_path4270 = /*#__PURE__*/React.createElement("path", {
    d: "M98 62v1h-1v-1z",
    fill: "#8b6c51",
    fillOpacity: 0.898
  })), _path4271 || (_path4271 = /*#__PURE__*/React.createElement("path", {
    d: "M99 62v1h-1v-1z",
    fill: "#6b6b5d",
    fillOpacity: 0.075
  })), _path4272 || (_path4272 = /*#__PURE__*/React.createElement("path", {
    d: "M102 63h-1v-1h1z",
    fill: "#82543c",
    fillOpacity: 0.345
  })), _path4273 || (_path4273 = /*#__PURE__*/React.createElement("path", {
    d: "M102 62h1v1h-1z",
    fill: "#935835"
  })), _path4274 || (_path4274 = /*#__PURE__*/React.createElement("path", {
    d: "M104 62v1h-1v-1z",
    fill: "#985a34"
  })), _path4275 || (_path4275 = /*#__PURE__*/React.createElement("path", {
    d: "M105 63h-1v-1h1z",
    fill: "#bc8357"
  })), _path4276 || (_path4276 = /*#__PURE__*/React.createElement("path", {
    d: "M106 62v1h-1v-1z",
    fill: "#d18c68",
    fillOpacity: 0.996
  })), _path4277 || (_path4277 = /*#__PURE__*/React.createElement("path", {
    d: "M106 63v-1h1v1z",
    fill: "#cc8c68"
  })), _path4278 || (_path4278 = /*#__PURE__*/React.createElement("path", {
    d: "M108 63h-1v-1h1z",
    fill: "#c78965"
  })), _path4279 || (_path4279 = /*#__PURE__*/React.createElement("path", {
    d: "M108 62h1v1h-1z",
    fill: "#996941",
    fillOpacity: 0.98
  })), _path4280 || (_path4280 = /*#__PURE__*/React.createElement("path", {
    d: "M110 62h1v1h-1z",
    fill: "#7a4f25"
  })), _path4281 || (_path4281 = /*#__PURE__*/React.createElement("path", {
    d: "M112 63h-1v-1h1z",
    fill: "#a97943"
  })), _path4282 || (_path4282 = /*#__PURE__*/React.createElement("path", {
    d: "M113 63h-1v-1h1z",
    fill: "#f5b069"
  })), _path4283 || (_path4283 = /*#__PURE__*/React.createElement("path", {
    d: "M114 62v1h-1v-1z",
    fill: "#dca267",
    fillOpacity: 0.659
  })), _path4284 || (_path4284 = /*#__PURE__*/React.createElement("path", {
    d: "M117 63h-1v-1h1z",
    fill: "#826149",
    fillOpacity: 0.298
  })), _path4285 || (_path4285 = /*#__PURE__*/React.createElement("path", {
    d: "M117 62h1v1h-1z",
    fill: "#844d2f"
  })), _path4286 || (_path4286 = /*#__PURE__*/React.createElement("path", {
    d: "M118 62h1v1h-1z",
    fill: "#a16847"
  })), _path4287 || (_path4287 = /*#__PURE__*/React.createElement("path", {
    d: "M120 62v1h-1v-1z",
    fill: "#bc8867"
  })), _path4288 || (_path4288 = /*#__PURE__*/React.createElement("path", {
    d: "M120 63v-1h1v1z",
    fill: "#b18567",
    fillOpacity: 0.773
  })), _path4289 || (_path4289 = /*#__PURE__*/React.createElement("path", {
    d: "M9 63v1H8v-1z",
    fill: "#a37758",
    fillOpacity: 0.427
  })), _path4290 || (_path4290 = /*#__PURE__*/React.createElement("path", {
    d: "M9 64v-1h1v1z",
    fill: "#be8660"
  })), _path4291 || (_path4291 = /*#__PURE__*/React.createElement("path", {
    d: "M10 64v-1h1v1z",
    fill: "#9d653d"
  })), _path4292 || (_path4292 = /*#__PURE__*/React.createElement("path", {
    d: "M12 64h-1v-1h1z",
    fill: "#884e25"
  })), _path4293 || (_path4293 = /*#__PURE__*/React.createElement("path", {
    d: "M13 64v-1h1v1z",
    fill: "#7e4e2c",
    fillOpacity: 0.804
  })), _path4294 || (_path4294 = /*#__PURE__*/React.createElement("path", {
    d: "M18 63v1h-1v-1z",
    fill: "#7f7266",
    fillOpacity: 0.078
  })), _path4295 || (_path4295 = /*#__PURE__*/React.createElement("path", {
    d: "M19 64h-1v-1h1z",
    fill: "#876e61",
    fillOpacity: 0.443
  })), _path4296 || (_path4296 = /*#__PURE__*/React.createElement("path", {
    d: "M20 63v1h-1v-1z",
    fill: "#8c6956",
    fillOpacity: 0.847
  })), _path4297 || (_path4297 = /*#__PURE__*/React.createElement("path", {
    d: "M20 64v-1h1v1z",
    fill: "#95684b"
  })), _path4298 || (_path4298 = /*#__PURE__*/React.createElement("path", {
    d: "M23 64h-1v-1h1z",
    fill: "#8c5726"
  })), _path4299 || (_path4299 = /*#__PURE__*/React.createElement("path", {
    d: "M23 64v-1h1v1z",
    fill: "#8e5226"
  })), _path4300 || (_path4300 = /*#__PURE__*/React.createElement("path", {
    d: "M26 63v1h-1v-1z",
    fill: "#884d22"
  })), _path4301 || (_path4301 = /*#__PURE__*/React.createElement("path", {
    d: "M27 63v1h-1v-1z",
    fill: "#874c21"
  })), _path4302 || (_path4302 = /*#__PURE__*/React.createElement("path", {
    d: "M28 63v1h-1v-1z",
    fill: "#854c20"
  })), _path4303 || (_path4303 = /*#__PURE__*/React.createElement("path", {
    d: "M28 64v-1h1v1z",
    fill: "#895124"
  })), _path4304 || (_path4304 = /*#__PURE__*/React.createElement("path", {
    d: "M30 63v1h-1v-1z",
    fill: "#8c572b"
  })), _path4305 || (_path4305 = /*#__PURE__*/React.createElement("path", {
    d: "M31 64h-1v-1h1z",
    fill: "#8c5b32"
  })), _path4306 || (_path4306 = /*#__PURE__*/React.createElement("path", {
    d: "M32 63v1h-1v-1z",
    fill: "#8e5c38"
  })), _path4307 || (_path4307 = /*#__PURE__*/React.createElement("path", {
    d: "M32 64v-1h1v1z",
    fill: "#8f5d3b"
  })), _path4308 || (_path4308 = /*#__PURE__*/React.createElement("path", {
    d: "M37 63v1h-1v-1z",
    fill: "#8d5d3c"
  })), _path4309 || (_path4309 = /*#__PURE__*/React.createElement("path", {
    d: "M37 63h1v1h-1z",
    fill: "#895b36"
  })), _path4310 || (_path4310 = /*#__PURE__*/React.createElement("path", {
    d: "M38 64v-1h1v1z",
    fill: "#a07355"
  })), _path4311 || (_path4311 = /*#__PURE__*/React.createElement("path", {
    d: "M39 63h1v1h-1z",
    fill: "#cd9e8f"
  })), _path4312 || (_path4312 = /*#__PURE__*/React.createElement("path", {
    d: "M40 63h1v1h-1z",
    fill: "#be9183"
  })), _path4313 || (_path4313 = /*#__PURE__*/React.createElement("path", {
    d: "M41 63h1v1h-1z",
    fill: "#c39987"
  })), _path4314 || (_path4314 = /*#__PURE__*/React.createElement("path", {
    d: "M44 64h-1v-1h1z",
    fill: "#82512d"
  })), _path4315 || (_path4315 = /*#__PURE__*/React.createElement("path", {
    d: "M44 64v-1h1v1z",
    fill: "#8f6139"
  })), _path4316 || (_path4316 = /*#__PURE__*/React.createElement("path", {
    d: "M46 64h-1v-1h1z",
    fill: "#8c5f35"
  })), _path4317 || (_path4317 = /*#__PURE__*/React.createElement("path", {
    d: "M47 63v1h-1v-1z",
    fill: "#8a5b34"
  })), _path4318 || (_path4318 = /*#__PURE__*/React.createElement("path", {
    d: "M48 64h-1v-1h1z",
    fill: "#885935"
  })), _path4319 || (_path4319 = /*#__PURE__*/React.createElement("path", {
    d: "M50 63v1h-1v-1z",
    fill: "#885834"
  })), _path4320 || (_path4320 = /*#__PURE__*/React.createElement("path", {
    d: "M51 63v1h-1v-1z",
    fill: "#895836"
  })), _path4321 || (_path4321 = /*#__PURE__*/React.createElement("path", {
    d: "M52 64v-1h1v1z",
    fill: "#905e3e"
  })), _path4322 || (_path4322 = /*#__PURE__*/React.createElement("path", {
    d: "M56 64h-1v-1h1z",
    fill: "#8f613f"
  })), _path4323 || (_path4323 = /*#__PURE__*/React.createElement("path", {
    d: "M57 64h-1v-1h1z",
    fill: "#8e603e"
  })), _path4324 || (_path4324 = /*#__PURE__*/React.createElement("path", {
    d: "M59 63v1h-1v-1z",
    fill: "#925f3b"
  })), _path4325 || (_path4325 = /*#__PURE__*/React.createElement("path", {
    d: "M59 64v-1h1v1z",
    fill: "#935e38"
  })), _path4326 || (_path4326 = /*#__PURE__*/React.createElement("path", {
    d: "M62 63v1h-1v-1z",
    fill: "#925a30"
  })), _path4327 || (_path4327 = /*#__PURE__*/React.createElement("path", {
    d: "M62 64v-1h1v1z",
    fill: "#945a2e"
  })), _path4328 || (_path4328 = /*#__PURE__*/React.createElement("path", {
    d: "M64 64h-1v-1h1z",
    fill: "#92572b"
  })), _path4329 || (_path4329 = /*#__PURE__*/React.createElement("path", {
    d: "M65 64h-1v-1h1z",
    fill: "#91542b"
  })), _path4330 || (_path4330 = /*#__PURE__*/React.createElement("path", {
    d: "M66 64h-1v-1h1z",
    fill: "#93572e"
  })), _path4331 || (_path4331 = /*#__PURE__*/React.createElement("path", {
    d: "M66 64v-1h1v1z",
    fill: "#945a33"
  })), _path4332 || (_path4332 = /*#__PURE__*/React.createElement("path", {
    d: "M68 64v-1h1v1z",
    fill: "#a66940"
  })), _path4333 || (_path4333 = /*#__PURE__*/React.createElement("path", {
    d: "M70 64h-1v-1h1z",
    fill: "#91715d",
    fillOpacity: 0.247
  })), _path4334 || (_path4334 = /*#__PURE__*/React.createElement("path", {
    d: "M71 64v-1h1v1z",
    fill: "#846755",
    fillOpacity: 0.106
  })), _path4335 || (_path4335 = /*#__PURE__*/React.createElement("path", {
    d: "M73 63v1h-1v-1z",
    fill: "#996738",
    fillOpacity: 0.918
  })), _path4336 || (_path4336 = /*#__PURE__*/React.createElement("path", {
    d: "M73 64v-1h1v1z",
    fill: "#a7713a"
  })), _path4337 || (_path4337 = /*#__PURE__*/React.createElement("path", {
    d: "M74 63h1v1h-1z",
    fill: "#ab7643"
  })), _path4338 || (_path4338 = /*#__PURE__*/React.createElement("path", {
    d: "M76 64h-1v-1h1z",
    fill: "#ad7b4a"
  })), _path4339 || (_path4339 = /*#__PURE__*/React.createElement("path", {
    d: "M78 63v1h-1v-1z",
    fill: "#a7773d"
  })), _path4340 || (_path4340 = /*#__PURE__*/React.createElement("path", {
    d: "M79 63v1h-1v-1z",
    fill: "#9f7448",
    fillOpacity: 0.867
  })), _path4341 || (_path4341 = /*#__PURE__*/React.createElement("path", {
    d: "M79 63h1v1h-1z",
    fill: "#977c67",
    fillOpacity: 0.145
  })), _path4342 || (_path4342 = /*#__PURE__*/React.createElement("path", {
    d: "M81 63v1h-1v-1z",
    fill: "#8c6650",
    fillOpacity: 0.235
  })), _path4343 || (_path4343 = /*#__PURE__*/React.createElement("path", {
    d: "M81 64v-1h1v1z",
    fill: "#8f6347",
    fillOpacity: 0.404
  })), _path4344 || (_path4344 = /*#__PURE__*/React.createElement("path", {
    d: "M83 63v1h-1v-1z",
    fill: "#915f46",
    fillOpacity: 0.6
  })), _path4345 || (_path4345 = /*#__PURE__*/React.createElement("path", {
    d: "M83 64v-1h1v1z",
    fill: "#915c3d",
    fillOpacity: 0.898
  })), _path4346 || (_path4346 = /*#__PURE__*/React.createElement("path", {
    d: "M85 64h-1v-1h1z",
    fill: "#985c39"
  })), _path4347 || (_path4347 = /*#__PURE__*/React.createElement("path", {
    d: "M85 64v-1h1v1z",
    fill: "#8f5737"
  })), _path4348 || (_path4348 = /*#__PURE__*/React.createElement("path", {
    d: "M86 64v-1h1v1z",
    fill: "#865030",
    fillOpacity: 0.992
  })), _path4349 || (_path4349 = /*#__PURE__*/React.createElement("path", {
    d: "M88 63v1h-1v-1z",
    fill: "#814b2e",
    fillOpacity: 0.91
  })), _path4350 || (_path4350 = /*#__PURE__*/React.createElement("path", {
    d: "M88 64v-1h1v1z",
    fill: "#7a4529",
    fillOpacity: 0.949
  })), _path4351 || (_path4351 = /*#__PURE__*/React.createElement("path", {
    d: "M89 63h1v1h-1z",
    fill: "#7d4527"
  })), _path4352 || (_path4352 = /*#__PURE__*/React.createElement("path", {
    d: "M91 64h-1v-1h1z",
    fill: "#864c2c"
  })), _path4353 || (_path4353 = /*#__PURE__*/React.createElement("path", {
    d: "M91 63h1v1h-1z",
    fill: "#865039",
    fillOpacity: 0.941
  })), _path4354 || (_path4354 = /*#__PURE__*/React.createElement("path", {
    d: "M93 64h-1v-1h1z",
    fill: "#8b5b49",
    fillOpacity: 0.502
  })), _path4355 || (_path4355 = /*#__PURE__*/React.createElement("path", {
    d: "M94 64h-1v-1h1z",
    fill: "#886c55",
    fillOpacity: 0.212
  })), _path4356 || (_path4356 = /*#__PURE__*/React.createElement("path", {
    d: "M95 63v1h-1v-1z",
    fill: "#9c8975",
    fillOpacity: 0.153
  })), _path4357 || (_path4357 = /*#__PURE__*/React.createElement("path", {
    d: "M95 64v-1h1v1z",
    fill: "#976952",
    fillOpacity: 0.925
  })), _path4358 || (_path4358 = /*#__PURE__*/React.createElement("path", {
    d: "M97 63v1h-1v-1z",
    fill: "#9f6546"
  })), _path4359 || (_path4359 = /*#__PURE__*/React.createElement("path", {
    d: "M97 64v-1h1v1z",
    fill: "#8e664e",
    fillOpacity: 0.937
  })), _path4360 || (_path4360 = /*#__PURE__*/React.createElement("path", {
    d: "M98 64v-1h1v1z",
    fill: "#7b7269",
    fillOpacity: 0.114
  })), _path4361 || (_path4361 = /*#__PURE__*/React.createElement("path", {
    d: "M101 63h1v1h-1z",
    fill: "#825941",
    fillOpacity: 0.369
  })), _path4362 || (_path4362 = /*#__PURE__*/React.createElement("path", {
    d: "M102 64v-1h1v1z",
    fill: "#965b37"
  })), _path4363 || (_path4363 = /*#__PURE__*/React.createElement("path", {
    d: "M104 64h-1v-1h1z",
    fill: "#9b5d3a"
  })), _path4364 || (_path4364 = /*#__PURE__*/React.createElement("path", {
    d: "M105 63v1h-1v-1z",
    fill: "#c2845a"
  })), _path4365 || (_path4365 = /*#__PURE__*/React.createElement("path", {
    d: "M105 63h1v1h-1z",
    fill: "#d3926d",
    fillOpacity: 0.965
  })), _path4366 || (_path4366 = /*#__PURE__*/React.createElement("path", {
    d: "M107 63v1h-1v-1z",
    fill: "#c5916d",
    fillOpacity: 0.627
  })), _path4367 || (_path4367 = /*#__PURE__*/React.createElement("path", {
    d: "M107 64v-1h1v1z",
    fill: "#b48365",
    fillOpacity: 0.227
  })), _path4368 || (_path4368 = /*#__PURE__*/React.createElement("path", {
    d: "M108 63h1v1h-1z",
    fill: "#926644",
    fillOpacity: 0.725
  })), _path4369 || (_path4369 = /*#__PURE__*/React.createElement("path", {
    d: "M110 63v1h-1v-1z",
    fill: "#996237"
  })), _path4370 || (_path4370 = /*#__PURE__*/React.createElement("path", {
    d: "M110 63h1v1h-1z",
    fill: "#7a532e"
  })), _path4371 || (_path4371 = /*#__PURE__*/React.createElement("path", {
    d: "M112 63v1h-1v-1z",
    fill: "#ab7a43"
  })), _path4372 || (_path4372 = /*#__PURE__*/React.createElement("path", {
    d: "M112 63h1v1h-1z",
    fill: "#f6ae69"
  })), _path4373 || (_path4373 = /*#__PURE__*/React.createElement("path", {
    d: "M114 64h-1v-1h1z",
    fill: "#d69e66",
    fillOpacity: 0.635
  })), _path4374 || (_path4374 = /*#__PURE__*/React.createElement("path", {
    d: "M116 64v-1h1v1z",
    fill: "#7d5642",
    fillOpacity: 0.302
  })), _path4375 || (_path4375 = /*#__PURE__*/React.createElement("path", {
    d: "M117 63h1v1h-1z",
    fill: "#824b2d"
  })), _path4376 || (_path4376 = /*#__PURE__*/React.createElement("path", {
    d: "M119 63v1h-1v-1z",
    fill: "#a26b49"
  })), _path4377 || (_path4377 = /*#__PURE__*/React.createElement("path", {
    d: "M120 63h1v1h-1z",
    fill: "#b18566",
    fillOpacity: 0.773
  })), _path4378 || (_path4378 = /*#__PURE__*/React.createElement("path", {
    d: "M8 64h1v1H8z",
    fill: "#9d795e",
    fillOpacity: 0.329
  })), _path4379 || (_path4379 = /*#__PURE__*/React.createElement("path", {
    d: "M10 64v1H9v-1z",
    fill: "#b7805b"
  })), _path4380 || (_path4380 = /*#__PURE__*/React.createElement("path", {
    d: "M10 65v-1h1v1z",
    fill: "#a26942"
  })), _path4381 || (_path4381 = /*#__PURE__*/React.createElement("path", {
    d: "M13 64h1v1h-1z",
    fill: "#804a26",
    fillOpacity: 0.855
  })), _path4382 || (_path4382 = /*#__PURE__*/React.createElement("path", {
    d: "M15 65v-1h1v1z",
    fill: "#7f746a",
    fillOpacity: 0.094
  })), _path4383 || (_path4383 = /*#__PURE__*/React.createElement("path", {
    d: "M16 64h1v1h-1z",
    fill: "#856859",
    fillOpacity: 0.478
  })), _path4384 || (_path4384 = /*#__PURE__*/React.createElement("path", {
    d: "M18 65h-1v-1h1z",
    fill: "#8c6756",
    fillOpacity: 0.871
  })), _path4385 || (_path4385 = /*#__PURE__*/React.createElement("path", {
    d: "M18 64h1v1h-1z",
    fill: "#916c54"
  })), _path4386 || (_path4386 = /*#__PURE__*/React.createElement("path", {
    d: "M20 65v-1h1v1z",
    fill: "#8c623e"
  })), _path4387 || (_path4387 = /*#__PURE__*/React.createElement("path", {
    d: "M22 65h-1v-1h1z",
    fill: "#895a2f"
  })), _path4388 || (_path4388 = /*#__PURE__*/React.createElement("path", {
    d: "M23 65h-1v-1h1z",
    fill: "#8a5325"
  })), _path4389 || (_path4389 = /*#__PURE__*/React.createElement("path", {
    d: "M23 64h1v1h-1z",
    fill: "#8b4f23"
  })), _path4390 || (_path4390 = /*#__PURE__*/React.createElement("path", {
    d: "M25 65h-1v-1h1z",
    fill: "#884b1f"
  })), _path4391 || (_path4391 = /*#__PURE__*/React.createElement("path", {
    d: "M25 65v-1h1v1z",
    fill: "#85471e"
  })), _path4392 || (_path4392 = /*#__PURE__*/React.createElement("path", {
    d: "M26 65v-1h1v1z",
    fill: "#81471c"
  })), _path4393 || (_path4393 = /*#__PURE__*/React.createElement("path", {
    d: "M28 65h-1v-1h1z",
    fill: "#804a1b"
  })), _path4394 || (_path4394 = /*#__PURE__*/React.createElement("path", {
    d: "M28 64h1v1h-1z",
    fill: "#875124"
  })), _path4395 || (_path4395 = /*#__PURE__*/React.createElement("path", {
    d: "M30 64h1v1h-1z",
    fill: "#885731"
  })), _path4396 || (_path4396 = /*#__PURE__*/React.createElement("path", {
    d: "M31 65v-1h1v1z",
    fill: "#895933"
  })), _path4397 || (_path4397 = /*#__PURE__*/React.createElement("path", {
    d: "M35 64h1v1h-1z",
    fill: "#8b5937"
  })), _path4398 || (_path4398 = /*#__PURE__*/React.createElement("path", {
    d: "M36 64h1v1h-1z",
    fill: "#8a5835"
  })), _path4399 || (_path4399 = /*#__PURE__*/React.createElement("path", {
    d: "M37 65v-1h1v1z",
    fill: "#855732"
  })), _path4400 || (_path4400 = /*#__PURE__*/React.createElement("path", {
    d: "M38 64h1v1h-1z",
    fill: "#9f7254"
  })), _path4401 || (_path4401 = /*#__PURE__*/React.createElement("path", {
    d: "M39 64h1v1h-1z",
    fill: "#cd9f90"
  })), _path4402 || (_path4402 = /*#__PURE__*/React.createElement("path", {
    d: "M40 64h1v1h-1z",
    fill: "#bc8f80"
  })), _path4403 || (_path4403 = /*#__PURE__*/React.createElement("path", {
    d: "M41 65v-1h1v1z",
    fill: "#c49986"
  })), _path4404 || (_path4404 = /*#__PURE__*/React.createElement("path", {
    d: "M43 64v1h-1v-1z",
    fill: "#895b3f"
  })), _path4405 || (_path4405 = /*#__PURE__*/React.createElement("path", {
    d: "M43 64h1v1h-1z",
    fill: "#81512c"
  })), _path4406 || (_path4406 = /*#__PURE__*/React.createElement("path", {
    d: "M44 65v-1h1v1z",
    fill: "#8d5b31"
  })), _path4407 || (_path4407 = /*#__PURE__*/React.createElement("path", {
    d: "M45 64h1v1h-1z",
    fill: "#89562c"
  })), _path4408 || (_path4408 = /*#__PURE__*/React.createElement("path", {
    d: "M46 64h1v1h-1z",
    fill: "#87552c"
  })), _path4409 || (_path4409 = /*#__PURE__*/React.createElement("path", {
    d: "M48 64h1v1h-1z",
    fill: "#885633"
  })), _path4410 || (_path4410 = /*#__PURE__*/React.createElement("path", {
    d: "M50 65h-1v-1h1z",
    fill: "#8d5a37"
  })), _path4411 || (_path4411 = /*#__PURE__*/React.createElement("path", {
    d: "M51 64h1v1h-1z",
    fill: "#8d603d"
  })), _path4412 || (_path4412 = /*#__PURE__*/React.createElement("path", {
    d: "M53 64v1h-1v-1z",
    fill: "#91613f"
  })), _path4413 || (_path4413 = /*#__PURE__*/React.createElement("path", {
    d: "M53 64h1v1h-1z",
    fill: "#90603f"
  })), _path4414 || (_path4414 = /*#__PURE__*/React.createElement("path", {
    d: "M55 65v-1h1v1z",
    fill: "#91603d"
  })), _path4415 || (_path4415 = /*#__PURE__*/React.createElement("path", {
    d: "M57 65h-1v-1h1z",
    fill: "#93613e"
  })), _path4416 || (_path4416 = /*#__PURE__*/React.createElement("path", {
    d: "M58 64v1h-1v-1z",
    fill: "#93613c"
  })), _path4417 || (_path4417 = /*#__PURE__*/React.createElement("path", {
    d: "M58 64h1v1h-1z",
    fill: "#925e37"
  })), _path4418 || (_path4418 = /*#__PURE__*/React.createElement("path", {
    d: "M59 64h1v1h-1z",
    fill: "#905932"
  })), _path4419 || (_path4419 = /*#__PURE__*/React.createElement("path", {
    d: "M60 64h1v1h-1z",
    fill: "#8f582f"
  })), _path4420 || (_path4420 = /*#__PURE__*/React.createElement("path", {
    d: "M61 65v-1h1v1z",
    fill: "#8c562b"
  })), _path4421 || (_path4421 = /*#__PURE__*/React.createElement("path", {
    d: "M63 65h-1v-1h1z",
    fill: "#8d572d"
  })), _path4422 || (_path4422 = /*#__PURE__*/React.createElement("path", {
    d: "M64 65h-1v-1h1z",
    fill: "#925b35"
  })), _path4423 || (_path4423 = /*#__PURE__*/React.createElement("path", {
    d: "M65 64v1h-1v-1z",
    fill: "#9b6241"
  })), _path4424 || (_path4424 = /*#__PURE__*/React.createElement("path", {
    d: "M66 64v1h-1v-1z",
    fill: "#a36c4d"
  })), _path4425 || (_path4425 = /*#__PURE__*/React.createElement("path", {
    d: "M66 65v-1h1v1z",
    fill: "#a06748"
  })), _path4426 || (_path4426 = /*#__PURE__*/React.createElement("path", {
    d: "M68 65h-1v-1h1z",
    fill: "#9f664a",
    fillOpacity: 0.973
  })), _path4427 || (_path4427 = /*#__PURE__*/React.createElement("path", {
    d: "M69 65h-1v-1h1z",
    fill: "#9b6e55",
    fillOpacity: 0.553
  })), _path4428 || (_path4428 = /*#__PURE__*/React.createElement("path", {
    d: "M69 65v-1h1v1z",
    fill: "#866",
    fillOpacity: 0.059
  })), _path4429 || (_path4429 = /*#__PURE__*/React.createElement("path", {
    d: "M72 64v1h-1v-1z",
    fill: "#967f68",
    fillOpacity: 0.086
  })), _path4430 || (_path4430 = /*#__PURE__*/React.createElement("path", {
    d: "M72 64h1v1h-1z",
    fill: "#a57446",
    fillOpacity: 0.902
  })), _path4431 || (_path4431 = /*#__PURE__*/React.createElement("path", {
    d: "M74 65h-1v-1h1z",
    fill: "#b07b45"
  })), _path4432 || (_path4432 = /*#__PURE__*/React.createElement("path", {
    d: "M75 65h-1v-1h1z",
    fill: "#ad7948"
  })), _path4433 || (_path4433 = /*#__PURE__*/React.createElement("path", {
    d: "M75 65v-1h1v1z",
    fill: "#b28151"
  })), _path4434 || (_path4434 = /*#__PURE__*/React.createElement("path", {
    d: "M77 65h-1v-1h1z",
    fill: "#9b6d3a"
  })), _path4435 || (_path4435 = /*#__PURE__*/React.createElement("path", {
    d: "M77 64h1v1h-1z",
    fill: "#a7773e"
  })), _path4436 || (_path4436 = /*#__PURE__*/React.createElement("path", {
    d: "M79 64v1h-1v-1z",
    fill: "#9a7348",
    fillOpacity: 0.847
  })), _path4437 || (_path4437 = /*#__PURE__*/React.createElement("path", {
    d: "M81 64v1h-1v-1z",
    fill: "#593e30",
    fillOpacity: 0.145
  })), _path4438 || (_path4438 = /*#__PURE__*/React.createElement("path", {
    d: "M82 64v1h-1v-1z",
    fill: "#613b29",
    fillOpacity: 0.337
  })), _path4439 || (_path4439 = /*#__PURE__*/React.createElement("path", {
    d: "M83 65h-1v-1h1z",
    fill: "#6a3e2b",
    fillOpacity: 0.58
  })), _path4440 || (_path4440 = /*#__PURE__*/React.createElement("path", {
    d: "M84 64v1h-1v-1z",
    fill: "#77452e",
    fillOpacity: 0.906
  })), _path4441 || (_path4441 = /*#__PURE__*/React.createElement("path", {
    d: "M84 65v-1h1v1z",
    fill: "#8c5135"
  })), _path4442 || (_path4442 = /*#__PURE__*/React.createElement("path", {
    d: "M85 64h1v1h-1z",
    fill: "#8f593e",
    fillOpacity: 0.984
  })), _path4443 || (_path4443 = /*#__PURE__*/React.createElement("path", {
    d: "M86 65v-1h1v1z",
    fill: "#906244",
    fillOpacity: 0.867
  })), _path4444 || (_path4444 = /*#__PURE__*/React.createElement("path", {
    d: "M87 65v-1h1v1z",
    fill: "#945f46",
    fillOpacity: 0.741
  })), _path4445 || (_path4445 = /*#__PURE__*/React.createElement("path", {
    d: "M89 65h-1v-1h1z",
    fill: "#925c44",
    fillOpacity: 0.835
  })), _path4446 || (_path4446 = /*#__PURE__*/React.createElement("path", {
    d: "M89 65v-1h1v1z",
    fill: "#8f593c",
    fillOpacity: 0.949
  })), _path4447 || (_path4447 = /*#__PURE__*/React.createElement("path", {
    d: "M90 64h1v1h-1z",
    fill: "#915939"
  })), _path4448 || (_path4448 = /*#__PURE__*/React.createElement("path", {
    d: "M91 65v-1h1v1z",
    fill: "#8a5031"
  })), _path4449 || (_path4449 = /*#__PURE__*/React.createElement("path", {
    d: "M92 65v-1h1v1z",
    fill: "#804626",
    fillOpacity: 0.855
  })), _path4450 || (_path4450 = /*#__PURE__*/React.createElement("path", {
    d: "M94 64v1h-1v-1z",
    fill: "#784122",
    fillOpacity: 0.69
  })), _path4451 || (_path4451 = /*#__PURE__*/React.createElement("path", {
    d: "M95 65h-1v-1h1z",
    fill: "#74452a",
    fillOpacity: 0.565
  })), _path4452 || (_path4452 = /*#__PURE__*/React.createElement("path", {
    d: "M95 64h1v1h-1z",
    fill: "#8c5339",
    fillOpacity: 0.945
  })), _path4453 || (_path4453 = /*#__PURE__*/React.createElement("path", {
    d: "M97 64v1h-1v-1z",
    fill: "#965a3b"
  })), _path4454 || (_path4454 = /*#__PURE__*/React.createElement("path", {
    d: "M97 64h1v1h-1z",
    fill: "#8b6145",
    fillOpacity: 0.953
  })), _path4455 || (_path4455 = /*#__PURE__*/React.createElement("path", {
    d: "M99 64v1h-1v-1z",
    fill: "#7f776e",
    fillOpacity: 0.118
  })), _path4456 || (_path4456 = /*#__PURE__*/React.createElement("path", {
    d: "M101 65v-1h1v1z",
    fill: "#865e49",
    fillOpacity: 0.38
  })), _path4457 || (_path4457 = /*#__PURE__*/React.createElement("path", {
    d: "M102 64h1v1h-1z",
    fill: "#945b36"
  })), _path4458 || (_path4458 = /*#__PURE__*/React.createElement("path", {
    d: "M104 64v1h-1v-1z",
    fill: "#9c5b39"
  })), _path4459 || (_path4459 = /*#__PURE__*/React.createElement("path", {
    d: "M104 64h1v1h-1z",
    fill: "#cd8860"
  })), _path4460 || (_path4460 = /*#__PURE__*/React.createElement("path", {
    d: "M106 64v1h-1v-1z",
    fill: "#c99174",
    fillOpacity: 0.714
  })), _path4461 || (_path4461 = /*#__PURE__*/React.createElement("path", {
    d: "M108 64h1v1h-1z",
    fill: "#966949",
    fillOpacity: 0.682
  })), _path4462 || (_path4462 = /*#__PURE__*/React.createElement("path", {
    d: "M109 65v-1h1v1z",
    fill: "#99693c"
  })), _path4463 || (_path4463 = /*#__PURE__*/React.createElement("path", {
    d: "M111 64v1h-1v-1z",
    fill: "#795631"
  })), _path4464 || (_path4464 = /*#__PURE__*/React.createElement("path", {
    d: "M111 65v-1h1v1z",
    fill: "#ae7c44"
  })), _path4465 || (_path4465 = /*#__PURE__*/React.createElement("path", {
    d: "M112 64h1v1h-1z",
    fill: "#f6ad67"
  })), _path4466 || (_path4466 = /*#__PURE__*/React.createElement("path", {
    d: "M114 65h-1v-1h1z",
    fill: "#d49f68",
    fillOpacity: 0.584
  })), _path4467 || (_path4467 = /*#__PURE__*/React.createElement("path", {
    d: "M117 65h-1v-1h1z",
    fill: "#714a38",
    fillOpacity: 0.282
  })), _path4468 || (_path4468 = /*#__PURE__*/React.createElement("path", {
    d: "M118 65h-1v-1h1z",
    fill: "#7b4024"
  })), _path4469 || (_path4469 = /*#__PURE__*/React.createElement("path", {
    d: "M118 65v-1h1v1z",
    fill: "#a36a49"
  })), _path4470 || (_path4470 = /*#__PURE__*/React.createElement("path", {
    d: "M120 64v1h-1v-1z",
    fill: "#c18b6a"
  })), _path4471 || (_path4471 = /*#__PURE__*/React.createElement("path", {
    d: "M121 64v1h-1v-1z",
    fill: "#af8261",
    fillOpacity: 0.776
  })), _path4472 || (_path4472 = /*#__PURE__*/React.createElement("path", {
    d: "M9 66H8v-1h1z",
    fill: "#9c7459",
    fillOpacity: 0.224
  })), _path4473 || (_path4473 = /*#__PURE__*/React.createElement("path", {
    d: "M9 66v-1h1v1z",
    fill: "#b17b56",
    fillOpacity: 0.992
  })), _path4474 || (_path4474 = /*#__PURE__*/React.createElement("path", {
    d: "M11 66h-1v-1h1z",
    fill: "#a86f47"
  })), _path4475 || (_path4475 = /*#__PURE__*/React.createElement("path", {
    d: "M13 66h-1v-1h1z",
    fill: "#8a4e20"
  })), _path4476 || (_path4476 = /*#__PURE__*/React.createElement("path", {
    d: "M14 65v1h-1v-1z",
    fill: "#824a24",
    fillOpacity: 0.941
  })), _path4477 || (_path4477 = /*#__PURE__*/React.createElement("path", {
    d: "M15 66h-1v-1h1z",
    fill: "#8d6452",
    fillOpacity: 0.608
  })), _path4478 || (_path4478 = /*#__PURE__*/React.createElement("path", {
    d: "M16 66h-1v-1h1z",
    fill: "#916e5b",
    fillOpacity: 0.886
  })), _path4479 || (_path4479 = /*#__PURE__*/React.createElement("path", {
    d: "M16 66v-1h1v1z",
    fill: "#987057"
  })), _path4480 || (_path4480 = /*#__PURE__*/React.createElement("path", {
    d: "M18 66h-1v-1h1z",
    fill: "#966b50"
  })), _path4481 || (_path4481 = /*#__PURE__*/React.createElement("path", {
    d: "M18 66v-1h1v1z",
    fill: "#92684e"
  })), _path4482 || (_path4482 = /*#__PURE__*/React.createElement("path", {
    d: "M20 66h-1v-1h1z",
    fill: "#8c664a"
  })), _path4483 || (_path4483 = /*#__PURE__*/React.createElement("path", {
    d: "M21 65v1h-1v-1z",
    fill: "#8b623c"
  })), _path4484 || (_path4484 = /*#__PURE__*/React.createElement("path", {
    d: "M22 66h-1v-1h1z",
    fill: "#8c5b2d"
  })), _path4485 || (_path4485 = /*#__PURE__*/React.createElement("path", {
    d: "M23 65v1h-1v-1z",
    fill: "#895123"
  })), _path4486 || (_path4486 = /*#__PURE__*/React.createElement("path", {
    d: "M24 66h-1v-1h1z",
    fill: "#834a1f"
  })), _path4487 || (_path4487 = /*#__PURE__*/React.createElement("path", {
    d: "M24 65h1v1h-1z",
    fill: "#7e431a"
  })), _path4488 || (_path4488 = /*#__PURE__*/React.createElement("path", {
    d: "M26 66h-1v-1h1z",
    fill: "#7f411b"
  })), _path4489 || (_path4489 = /*#__PURE__*/React.createElement("path", {
    d: "M27 66h-1v-1h1z",
    fill: "#80471e"
  })), _path4490 || (_path4490 = /*#__PURE__*/React.createElement("path", {
    d: "M27 65h1v1h-1z",
    fill: "#814d21"
  })), _path4491 || (_path4491 = /*#__PURE__*/React.createElement("path", {
    d: "M28 66v-1h1v1z",
    fill: "#86552c"
  })), _path4492 || (_path4492 = /*#__PURE__*/React.createElement("path", {
    d: "M29 65h1v1h-1z",
    fill: "#8b5a37"
  })), _path4493 || (_path4493 = /*#__PURE__*/React.createElement("path", {
    d: "M30 66v-1h1v1z",
    fill: "#8a5b38"
  })), _path4494 || (_path4494 = /*#__PURE__*/React.createElement("path", {
    d: "M34 66h-1v-1h1z",
    fill: "#895b39"
  })), _path4495 || (_path4495 = /*#__PURE__*/React.createElement("path", {
    d: "M34 65h1v1h-1z",
    fill: "#885936"
  })), _path4496 || (_path4496 = /*#__PURE__*/React.createElement("path", {
    d: "M35 66v-1h1v1z",
    fill: "#895935"
  })), _path4497 || (_path4497 = /*#__PURE__*/React.createElement("path", {
    d: "M37 65v1h-1v-1z",
    fill: "#8c5a37"
  })), _path4498 || (_path4498 = /*#__PURE__*/React.createElement("path", {
    d: "M37 65h1v1h-1z",
    fill: "#8d5d3a"
  })), _path4499 || (_path4499 = /*#__PURE__*/React.createElement("path", {
    d: "M38 66v-1h1v1z",
    fill: "#a57759"
  })), _path4500 || (_path4500 = /*#__PURE__*/React.createElement("path", {
    d: "M39 66v-1h1v1z",
    fill: "#cfa190"
  })), _path4501 || (_path4501 = /*#__PURE__*/React.createElement("path", {
    d: "M40 66v-1h1v1z",
    fill: "#be9184"
  })), _path4502 || (_path4502 = /*#__PURE__*/React.createElement("path", {
    d: "M42 66h-1v-1h1z",
    fill: "#c59b88"
  })), _path4503 || (_path4503 = /*#__PURE__*/React.createElement("path", {
    d: "M42 65h1v1h-1z",
    fill: "#8c5d42"
  })), _path4504 || (_path4504 = /*#__PURE__*/React.createElement("path", {
    d: "M44 65v1h-1v-1z",
    fill: "#7e4c28"
  })), _path4505 || (_path4505 = /*#__PURE__*/React.createElement("path", {
    d: "M44 65h1v1h-1z",
    fill: "#87542c"
  })), _path4506 || (_path4506 = /*#__PURE__*/React.createElement("path", {
    d: "M45 66v-1h1v1z",
    fill: "#88542c"
  })), _path4507 || (_path4507 = /*#__PURE__*/React.createElement("path", {
    d: "M47 66h-1v-1h1z",
    fill: "#8a5730"
  })), _path4508 || (_path4508 = /*#__PURE__*/React.createElement("path", {
    d: "M47 66v-1h1v1z",
    fill: "#8c5b34"
  })), _path4509 || (_path4509 = /*#__PURE__*/React.createElement("path", {
    d: "M48 65h1v1h-1z",
    fill: "#8d5d38"
  })), _path4510 || (_path4510 = /*#__PURE__*/React.createElement("path", {
    d: "M50 65v1h-1v-1z",
    fill: "#905f3a"
  })), _path4511 || (_path4511 = /*#__PURE__*/React.createElement("path", {
    d: "M50 66v-1h1v1z",
    fill: "#90613b"
  })), _path4512 || (_path4512 = /*#__PURE__*/React.createElement("path", {
    d: "M51 65h1v1h-1z",
    fill: "#8f603b"
  })), _path4513 || (_path4513 = /*#__PURE__*/React.createElement("path", {
    d: "M55 66h-1v-1h1z",
    fill: "#8b5a34"
  })), _path4514 || (_path4514 = /*#__PURE__*/React.createElement("path", {
    d: "M56 66h-1v-1h1z",
    fill: "#8b5a33"
  })), _path4515 || (_path4515 = /*#__PURE__*/React.createElement("path", {
    d: "M57 65v1h-1v-1z",
    fill: "#8c5a31"
  })), _path4516 || (_path4516 = /*#__PURE__*/React.createElement("path", {
    d: "M58 66h-1v-1h1z",
    fill: "#89582e"
  })), _path4517 || (_path4517 = /*#__PURE__*/React.createElement("path", {
    d: "M59 65v1h-1v-1z",
    fill: "#89552b"
  })), _path4518 || (_path4518 = /*#__PURE__*/React.createElement("path", {
    d: "M60 65v1h-1v-1z",
    fill: "#864f25"
  })), _path4519 || (_path4519 = /*#__PURE__*/React.createElement("path", {
    d: "M60 66v-1h1v1z",
    fill: "#7f4920"
  })), _path4520 || (_path4520 = /*#__PURE__*/React.createElement("path", {
    d: "M62 65v1h-1v-1z",
    fill: "#7a461f"
  })), _path4521 || (_path4521 = /*#__PURE__*/React.createElement("path", {
    d: "M64 65v1h-1v-1z",
    fill: "#8c5b39"
  })), _path4522 || (_path4522 = /*#__PURE__*/React.createElement("path", {
    d: "M64 66v-1h1v1z",
    fill: "#99654d"
  })), _path4523 || (_path4523 = /*#__PURE__*/React.createElement("path", {
    d: "M66 65v1h-1v-1z",
    fill: "#a57058"
  })), _path4524 || (_path4524 = /*#__PURE__*/React.createElement("path", {
    d: "M66 65h1v1h-1z",
    fill: "#a67154"
  })), _path4525 || (_path4525 = /*#__PURE__*/React.createElement("path", {
    d: "M67 65h1v1h-1z",
    fill: "#a97960",
    fillOpacity: 0.878
  })), _path4526 || (_path4526 = /*#__PURE__*/React.createElement("path", {
    d: "M69 65v1h-1v-1z",
    fill: "#dfdfdf",
    fillOpacity: 0.031
  })), _path4527 || (_path4527 = /*#__PURE__*/React.createElement("path", {
    d: "M71 65h1v1h-1z",
    fill: "#8c7266",
    fillOpacity: 0.078
  })), _path4528 || (_path4528 = /*#__PURE__*/React.createElement("path", {
    d: "M72 65h1v1h-1z",
    fill: "#a6764c",
    fillOpacity: 0.894
  })), _path4529 || (_path4529 = /*#__PURE__*/React.createElement("path", {
    d: "M74 65v1h-1v-1z",
    fill: "#b68150"
  })), _path4530 || (_path4530 = /*#__PURE__*/React.createElement("path", {
    d: "M75 66h-1v-1h1z",
    fill: "#b18050"
  })), _path4531 || (_path4531 = /*#__PURE__*/React.createElement("path", {
    d: "M77 66h-1v-1h1z",
    fill: "#9b6d3b"
  })), _path4532 || (_path4532 = /*#__PURE__*/React.createElement("path", {
    d: "M78 66h-1v-1h1z",
    fill: "#a57741"
  })), _path4533 || (_path4533 = /*#__PURE__*/React.createElement("path", {
    d: "M78 66v-1h1v1z",
    fill: "#9e703f",
    fillOpacity: 0.965
  })), _path4534 || (_path4534 = /*#__PURE__*/React.createElement("path", {
    d: "M80 65v1h-1v-1z",
    fill: "#734323",
    fillOpacity: 0.89
  })), _path4535 || (_path4535 = /*#__PURE__*/React.createElement("path", {
    d: "M81 65v1h-1v-1z",
    fill: "#754329"
  })), _path4536 || (_path4536 = /*#__PURE__*/React.createElement("path", {
    d: "M82 65h1v1h-1z",
    fill: "#7d4e32",
    fillOpacity: 0.886
  })), _path4537 || (_path4537 = /*#__PURE__*/React.createElement("path", {
    d: "M84 65v1h-1v-1z",
    fill: "#82553b",
    fillOpacity: 0.675
  })), _path4538 || (_path4538 = /*#__PURE__*/React.createElement("path", {
    d: "M84 65h1v1h-1z",
    fill: "#815e44",
    fillOpacity: 0.424
  })), _path4539 || (_path4539 = /*#__PURE__*/React.createElement("path", {
    d: "M85 65h1v1h-1z",
    fill: "#7a5844",
    fillOpacity: 0.204
  })), _path4540 || (_path4540 = /*#__PURE__*/React.createElement("path", {
    d: "M86 66v-1h1v1z",
    fill: "#7f6d6d",
    fillOpacity: 0.055
  })), _path4541 || (_path4541 = /*#__PURE__*/React.createElement("path", {
    d: "M89 66h-1v-1h1z",
    fill: "#bf9f9f",
    fillOpacity: 0.031
  })), _path4542 || (_path4542 = /*#__PURE__*/React.createElement("path", {
    d: "M89 65h1v1h-1z",
    fill: "#947163",
    fillOpacity: 0.141
  })), _path4543 || (_path4543 = /*#__PURE__*/React.createElement("path", {
    d: "M91 66h-1v-1h1z",
    fill: "#986956",
    fillOpacity: 0.302
  })), _path4544 || (_path4544 = /*#__PURE__*/React.createElement("path", {
    d: "M92 66h-1v-1h1z",
    fill: "#996b52",
    fillOpacity: 0.494
  })), _path4545 || (_path4545 = /*#__PURE__*/React.createElement("path", {
    d: "M93 65v1h-1v-1z",
    fill: "#936047",
    fillOpacity: 0.714
  })), _path4546 || (_path4546 = /*#__PURE__*/React.createElement("path", {
    d: "M93 65h1v1h-1z",
    fill: "#8e5b43",
    fillOpacity: 0.875
  })), _path4547 || (_path4547 = /*#__PURE__*/React.createElement("path", {
    d: "M94 65h1v1h-1z",
    fill: "#8c573e",
    fillOpacity: 0.984
  })), _path4548 || (_path4548 = /*#__PURE__*/React.createElement("path", {
    d: "M96 65v1h-1v-1z",
    fill: "#8c4f2f"
  })), _path4549 || (_path4549 = /*#__PURE__*/React.createElement("path", {
    d: "M96 65h1v1h-1z",
    fill: "#824d27"
  })), _path4550 || (_path4550 = /*#__PURE__*/React.createElement("path", {
    d: "M97 65h1v1h-1z",
    fill: "#7b4322",
    fillOpacity: 0.992
  })), _path4551 || (_path4551 = /*#__PURE__*/React.createElement("path", {
    d: "M98 65h1v1h-1z",
    fill: "#6f3d1f",
    fillOpacity: 0.733
  })), _path4552 || (_path4552 = /*#__PURE__*/React.createElement("path", {
    d: "M100 65v1h-1v-1z",
    fill: "#6d3d25",
    fillOpacity: 0.502
  })), _path4553 || (_path4553 = /*#__PURE__*/React.createElement("path", {
    d: "M100 66v-1h1v1z",
    fill: "#603b27",
    fillOpacity: 0.302
  })), _path4554 || (_path4554 = /*#__PURE__*/React.createElement("path", {
    d: "M102 65v1h-1v-1z",
    fill: "#85583f",
    fillOpacity: 0.533
  })), _path4555 || (_path4555 = /*#__PURE__*/React.createElement("path", {
    d: "M102 66v-1h1v1z",
    fill: "#985939"
  })), _path4556 || (_path4556 = /*#__PURE__*/React.createElement("path", {
    d: "M104 65h1v1h-1z",
    fill: "#ce8c60"
  })), _path4557 || (_path4557 = /*#__PURE__*/React.createElement("path", {
    d: "M105 65h1v1h-1z",
    fill: "#c79172",
    fillOpacity: 0.647
  })), _path4558 || (_path4558 = /*#__PURE__*/React.createElement("path", {
    d: "M109 66h-1v-1h1z",
    fill: "#916749",
    fillOpacity: 0.678
  })), _path4559 || (_path4559 = /*#__PURE__*/React.createElement("path", {
    d: "M109 65h1v1h-1z",
    fill: "#946737"
  })), _path4560 || (_path4560 = /*#__PURE__*/React.createElement("path", {
    d: "M110 66v-1h1v1z",
    fill: "#7c532c"
  })), _path4561 || (_path4561 = /*#__PURE__*/React.createElement("path", {
    d: "M111 65h1v1h-1z",
    fill: "#af7e44"
  })), _path4562 || (_path4562 = /*#__PURE__*/React.createElement("path", {
    d: "M112 65h1v1h-1z",
    fill: "#f4ab65"
  })), _path4563 || (_path4563 = /*#__PURE__*/React.createElement("path", {
    d: "M113 66v-1h1v1z",
    fill: "#d5a06c",
    fillOpacity: 0.478
  })), _path4564 || (_path4564 = /*#__PURE__*/React.createElement("path", {
    d: "M116 66h-1v-1h1z",
    fill: "#866",
    fillOpacity: 0.118
  })), _path4565 || (_path4565 = /*#__PURE__*/React.createElement("path", {
    d: "M117 65v1h-1v-1z",
    fill: "#8e5d47",
    fillOpacity: 0.62
  })), _path4566 || (_path4566 = /*#__PURE__*/React.createElement("path", {
    d: "M117 66v-1h1v1z",
    fill: "#925333"
  })), _path4567 || (_path4567 = /*#__PURE__*/React.createElement("path", {
    d: "M118 65h1v1h-1z",
    fill: "#a26a46"
  })), _path4568 || (_path4568 = /*#__PURE__*/React.createElement("path", {
    d: "M120 66h-1v-1h1z",
    fill: "#c18c69"
  })), _path4569 || (_path4569 = /*#__PURE__*/React.createElement("path", {
    d: "M121 66h-1v-1h1z",
    fill: "#aa7e5d",
    fillOpacity: 0.78
  })), _path4570 || (_path4570 = /*#__PURE__*/React.createElement("path", {
    d: "M121 65h1v1h-1z",
    fill: "#007f7f",
    fillOpacity: 0.008
  })), _path4571 || (_path4571 = /*#__PURE__*/React.createElement("path", {
    d: "M9 66v1H8v-1z",
    fill: "#a17257",
    fillOpacity: 0.149
  })), _path4572 || (_path4572 = /*#__PURE__*/React.createElement("path", {
    d: "M9 67v-1h1v1z",
    fill: "#ae7a53",
    fillOpacity: 0.965
  })), _path4573 || (_path4573 = /*#__PURE__*/React.createElement("path", {
    d: "M10 66h1v1h-1z",
    fill: "#ac744c"
  })), _path4574 || (_path4574 = /*#__PURE__*/React.createElement("path", {
    d: "M12 67h-1v-1h1z",
    fill: "#884d25"
  })), _path4575 || (_path4575 = /*#__PURE__*/React.createElement("path", {
    d: "M12 66h1v1h-1z",
    fill: "#894b21"
  })), _path4576 || (_path4576 = /*#__PURE__*/React.createElement("path", {
    d: "M13 66h1v1h-1z",
    fill: "#884c26"
  })), _path4577 || (_path4577 = /*#__PURE__*/React.createElement("path", {
    d: "M15 66v1h-1v-1z",
    fill: "#946446"
  })), _path4578 || (_path4578 = /*#__PURE__*/React.createElement("path", {
    d: "M15 67v-1h1v1z",
    fill: "#8d694e"
  })), _path4579 || (_path4579 = /*#__PURE__*/React.createElement("path", {
    d: "M16 67v-1h1v1z",
    fill: "#8a674b"
  })), _path4580 || (_path4580 = /*#__PURE__*/React.createElement("path", {
    d: "M18 66v1h-1v-1z",
    fill: "#8a654a"
  })), _path4581 || (_path4581 = /*#__PURE__*/React.createElement("path", {
    d: "M18 66h1v1h-1z",
    fill: "#8a6348"
  })), _path4582 || (_path4582 = /*#__PURE__*/React.createElement("path", {
    d: "M20 66v1h-1v-1z",
    fill: "#8a6344"
  })), _path4583 || (_path4583 = /*#__PURE__*/React.createElement("path", {
    d: "M20 67v-1h1v1z",
    fill: "#895f3a"
  })), _path4584 || (_path4584 = /*#__PURE__*/React.createElement("path", {
    d: "M21 66h1v1h-1z",
    fill: "#87592d"
  })), _path4585 || (_path4585 = /*#__PURE__*/React.createElement("path", {
    d: "M22 66h1v1h-1z",
    fill: "#845021"
  })), _path4586 || (_path4586 = /*#__PURE__*/React.createElement("path", {
    d: "M24 67h-1v-1h1z",
    fill: "#834a1e"
  })), _path4587 || (_path4587 = /*#__PURE__*/React.createElement("path", {
    d: "M24 66h1v1h-1z",
    fill: "#81481d"
  })), _path4588 || (_path4588 = /*#__PURE__*/React.createElement("path", {
    d: "M26 66v1h-1v-1z",
    fill: "#7f451e"
  })), _path4589 || (_path4589 = /*#__PURE__*/React.createElement("path", {
    d: "M27 66v1h-1v-1z",
    fill: "#7b431d"
  })), _path4590 || (_path4590 = /*#__PURE__*/React.createElement("path", {
    d: "M27 66h1v1h-1z",
    fill: "#7b4921"
  })), _path4591 || (_path4591 = /*#__PURE__*/React.createElement("path", {
    d: "M29 67h-1v-1h1z",
    fill: "#835532"
  })), _path4592 || (_path4592 = /*#__PURE__*/React.createElement("path", {
    d: "M29 66h1v1h-1z",
    fill: "#8a5f40"
  })), _path4593 || (_path4593 = /*#__PURE__*/React.createElement("path", {
    d: "M30 66h1v1h-1z",
    fill: "#8b6044"
  })), _path4594 || (_path4594 = /*#__PURE__*/React.createElement("path", {
    d: "M31 66h1v1h-1z",
    fill: "#885e41"
  })), _path4595 || (_path4595 = /*#__PURE__*/React.createElement("path", {
    d: "M32 67v-1h1v1z",
    fill: "#865d3e"
  })), _path4596 || (_path4596 = /*#__PURE__*/React.createElement("path", {
    d: "M34 66v1h-1v-1z",
    fill: "#875e3e"
  })), _path4597 || (_path4597 = /*#__PURE__*/React.createElement("path", {
    d: "M34 66h1v1h-1z",
    fill: "#865c3b"
  })), _path4598 || (_path4598 = /*#__PURE__*/React.createElement("path", {
    d: "M35 66h1v1h-1z",
    fill: "#8b5f3c"
  })), _path4599 || (_path4599 = /*#__PURE__*/React.createElement("path", {
    d: "M37 66v1h-1v-1z",
    fill: "#8b5e3a"
  })), _path4600 || (_path4600 = /*#__PURE__*/React.createElement("path", {
    d: "M37 67v-1h1v1z",
    fill: "#8a5d37"
  })), _path4601 || (_path4601 = /*#__PURE__*/React.createElement("path", {
    d: "M39 66v1h-1v-1z",
    fill: "#a17451"
  })), _path4602 || (_path4602 = /*#__PURE__*/React.createElement("path", {
    d: "M40 67h-1v-1h1z",
    fill: "#d4a692"
  })), _path4603 || (_path4603 = /*#__PURE__*/React.createElement("path", {
    d: "M40 66h1v1h-1z",
    fill: "#c19385"
  })), _path4604 || (_path4604 = /*#__PURE__*/React.createElement("path", {
    d: "M42 66v1h-1v-1z",
    fill: "#c79c8b"
  })), _path4605 || (_path4605 = /*#__PURE__*/React.createElement("path", {
    d: "M42 67v-1h1v1z",
    fill: "#8d5d44"
  })), _path4606 || (_path4606 = /*#__PURE__*/React.createElement("path", {
    d: "M44 66v1h-1v-1z",
    fill: "#7f4e2b"
  })), _path4607 || (_path4607 = /*#__PURE__*/React.createElement("path", {
    d: "M45 67h-1v-1h1z",
    fill: "#8a5b36"
  })), _path4608 || (_path4608 = /*#__PURE__*/React.createElement("path", {
    d: "M46 67h-1v-1h1z",
    fill: "#8d5e39"
  })), _path4609 || (_path4609 = /*#__PURE__*/React.createElement("path", {
    d: "M47 66v1h-1v-1z",
    fill: "#8e5f3a"
  })), _path4610 || (_path4610 = /*#__PURE__*/React.createElement("path", {
    d: "M48 67v-1h1v1z",
    fill: "#91633e"
  })), _path4611 || (_path4611 = /*#__PURE__*/React.createElement("path", {
    d: "M49 67v-1h1v1z",
    fill: "#90623c"
  })), _path4612 || (_path4612 = /*#__PURE__*/React.createElement("path", {
    d: "M50 66h1v1h-1z",
    fill: "#8d6037"
  })), _path4613 || (_path4613 = /*#__PURE__*/React.createElement("path", {
    d: "M51 66h1v1h-1z",
    fill: "#8d6035"
  })), _path4614 || (_path4614 = /*#__PURE__*/React.createElement("path", {
    d: "M52 66h1v1h-1z",
    fill: "#8e6137"
  })), _path4615 || (_path4615 = /*#__PURE__*/React.createElement("path", {
    d: "M53 67v-1h1v1z",
    fill: "#8e5f32"
  })), _path4616 || (_path4616 = /*#__PURE__*/React.createElement("path", {
    d: "M55 66v1h-1v-1z",
    fill: "#8e5f31"
  })), _path4617 || (_path4617 = /*#__PURE__*/React.createElement("path", {
    d: "M55 67v-1h1v1z",
    fill: "#8b5b2c"
  })), _path4618 || (_path4618 = /*#__PURE__*/React.createElement("path", {
    d: "M57 67h-1v-1h1z",
    fill: "#895929"
  })), _path4619 || (_path4619 = /*#__PURE__*/React.createElement("path", {
    d: "M57 66h1v1h-1z",
    fill: "#875727"
  })), _path4620 || (_path4620 = /*#__PURE__*/React.createElement("path", {
    d: "M59 66v1h-1v-1z",
    fill: "#855425"
  })), _path4621 || (_path4621 = /*#__PURE__*/React.createElement("path", {
    d: "M59 67v-1h1v1z",
    fill: "#7a481e"
  })), _path4622 || (_path4622 = /*#__PURE__*/React.createElement("path", {
    d: "M60 67v-1h1v1z",
    fill: "#754523"
  })), _path4623 || (_path4623 = /*#__PURE__*/React.createElement("path", {
    d: "M62 67h-1v-1h1z",
    fill: "#754729"
  })), _path4624 || (_path4624 = /*#__PURE__*/React.createElement("path", {
    d: "M64 67h-1v-1h1z",
    fill: "#946747"
  })), _path4625 || (_path4625 = /*#__PURE__*/React.createElement("path", {
    d: "M64 67v-1h1v1z",
    fill: "#9f6c53"
  })), _path4626 || (_path4626 = /*#__PURE__*/React.createElement("path", {
    d: "M65 67v-1h1v1z",
    fill: "#7e482f"
  })), _path4627 || (_path4627 = /*#__PURE__*/React.createElement("path", {
    d: "M66 67v-1h1v1z",
    fill: "#af7b5c"
  })), _path4628 || (_path4628 = /*#__PURE__*/React.createElement("path", {
    d: "M68 66v1h-1v-1z",
    fill: "#b2866b",
    fillOpacity: 0.875
  })), _path4629 || (_path4629 = /*#__PURE__*/React.createElement("path", {
    d: "M73 66v1h-1v-1z",
    fill: "#a3744a",
    fillOpacity: 0.875
  })), _path4630 || (_path4630 = /*#__PURE__*/React.createElement("path", {
    d: "M74 67h-1v-1h1z",
    fill: "#b47f50"
  })), _path4631 || (_path4631 = /*#__PURE__*/React.createElement("path", {
    d: "M75 67h-1v-1h1z",
    fill: "#b38154"
  })), _path4632 || (_path4632 = /*#__PURE__*/React.createElement("path", {
    d: "M76 67h-1v-1h1z",
    fill: "#af8152"
  })), _path4633 || (_path4633 = /*#__PURE__*/React.createElement("path", {
    d: "M77 66h1v1h-1z",
    fill: "#a47542"
  })), _path4634 || (_path4634 = /*#__PURE__*/React.createElement("path", {
    d: "M78 67v-1h1v1z",
    fill: "#9f7347",
    fillOpacity: 0.961
  })), _path4635 || (_path4635 = /*#__PURE__*/React.createElement("path", {
    d: "M80 66v1h-1v-1z",
    fill: "#84583a",
    fillOpacity: 0.647
  })), _path4636 || (_path4636 = /*#__PURE__*/React.createElement("path", {
    d: "M81 67h-1v-1h1z",
    fill: "#885c47",
    fillOpacity: 0.431
  })), _path4637 || (_path4637 = /*#__PURE__*/React.createElement("path", {
    d: "M81 67v-1h1v1z",
    fill: "#916955",
    fillOpacity: 0.2
  })), _path4638 || (_path4638 = /*#__PURE__*/React.createElement("path", {
    d: "M83 66v1h-1v-1z",
    fill: "#8b8b8b",
    fillOpacity: 0.043
  })), _path4639 || (_path4639 = /*#__PURE__*/React.createElement("path", {
    d: "M95 66v1h-1v-1z",
    fill: "#967f6e",
    fillOpacity: 0.173
  })), _path4640 || (_path4640 = /*#__PURE__*/React.createElement("path", {
    d: "M96 67h-1v-1h1z",
    fill: "#9b6b51",
    fillOpacity: 0.878
  })), _path4641 || (_path4641 = /*#__PURE__*/React.createElement("path", {
    d: "M98 67h-1v-1h1z",
    fill: "#9d6347"
  })), _path4642 || (_path4642 = /*#__PURE__*/React.createElement("path", {
    d: "M99 67h-1v-1h1z",
    fill: "#935c41",
    fillOpacity: 0.949
  })), _path4643 || (_path4643 = /*#__PURE__*/React.createElement("path", {
    d: "M100 66v1h-1v-1z",
    fill: "#8f5338",
    fillOpacity: 0.992
  })), _path4644 || (_path4644 = /*#__PURE__*/React.createElement("path", {
    d: "M101 67h-1v-1h1z",
    fill: "#874f2f"
  })), _path4645 || (_path4645 = /*#__PURE__*/React.createElement("path", {
    d: "M102 66v1h-1v-1z",
    fill: "#8b5330"
  })), _path4646 || (_path4646 = /*#__PURE__*/React.createElement("path", {
    d: "M104 67h-1v-1h1z",
    fill: "#9f643e"
  })), _path4647 || (_path4647 = /*#__PURE__*/React.createElement("path", {
    d: "M105 67h-1v-1h1z",
    fill: "#d28e65"
  })), _path4648 || (_path4648 = /*#__PURE__*/React.createElement("path", {
    d: "M105 66h1v1h-1z",
    fill: "#c99578",
    fillOpacity: 0.616
  })), _path4649 || (_path4649 = /*#__PURE__*/React.createElement("path", {
    d: "M108 66h1v1h-1z",
    fill: "#8d6544",
    fillOpacity: 0.643
  })), _path4650 || (_path4650 = /*#__PURE__*/React.createElement("path", {
    d: "M109 67v-1h1v1z",
    fill: "#8e6032"
  })), _path4651 || (_path4651 = /*#__PURE__*/React.createElement("path", {
    d: "M110 67v-1h1v1z",
    fill: "#7c532f"
  })), _path4652 || (_path4652 = /*#__PURE__*/React.createElement("path", {
    d: "M111 67v-1h1v1z",
    fill: "#ab7e42"
  })), _path4653 || (_path4653 = /*#__PURE__*/React.createElement("path", {
    d: "M112 66h1v1h-1z",
    fill: "#f2aa64"
  })), _path4654 || (_path4654 = /*#__PURE__*/React.createElement("path", {
    d: "M113 66h1v1h-1z",
    fill: "#ca905e",
    fillOpacity: 0.569
  })), _path4655 || (_path4655 = /*#__PURE__*/React.createElement("path", {
    d: "M115 66v1h-1v-1z",
    fill: "#855842",
    fillOpacity: 0.541
  })), _path4656 || (_path4656 = /*#__PURE__*/React.createElement("path", {
    d: "M116 66v1h-1v-1z",
    fill: "#966649",
    fillOpacity: 0.941
  })), _path4657 || (_path4657 = /*#__PURE__*/React.createElement("path", {
    d: "M117 67h-1v-1h1z",
    fill: "#a86d4b"
  })), _path4658 || (_path4658 = /*#__PURE__*/React.createElement("path", {
    d: "M118 67v-1h1v1z",
    fill: "#a46c4a"
  })), _path4659 || (_path4659 = /*#__PURE__*/React.createElement("path", {
    d: "M120 66v1h-1v-1z",
    fill: "#c18c68"
  })), _path4660 || (_path4660 = /*#__PURE__*/React.createElement("path", {
    d: "M120 66h1v1h-1z",
    fill: "#ab7f5d",
    fillOpacity: 0.8
  })), _path4661 || (_path4661 = /*#__PURE__*/React.createElement("path", {
    d: "M8 67h1v1H8z",
    fill: "#906358",
    fillOpacity: 0.09
  })), _path4662 || (_path4662 = /*#__PURE__*/React.createElement("path", {
    d: "M9 67h1v1H9z",
    fill: "#ad7954",
    fillOpacity: 0.925
  })), _path4663 || (_path4663 = /*#__PURE__*/React.createElement("path", {
    d: "M11 68h-1v-1h1z",
    fill: "#b27952"
  })), _path4664 || (_path4664 = /*#__PURE__*/React.createElement("path", {
    d: "M11 68v-1h1v1z",
    fill: "#894d23"
  })), _path4665 || (_path4665 = /*#__PURE__*/React.createElement("path", {
    d: "M12 68v-1h1v1z",
    fill: "#864921"
  })), _path4666 || (_path4666 = /*#__PURE__*/React.createElement("path", {
    d: "M14 67v1h-1v-1z",
    fill: "#874821"
  })), _path4667 || (_path4667 = /*#__PURE__*/React.createElement("path", {
    d: "M15 68h-1v-1h1z",
    fill: "#804824"
  })), _path4668 || (_path4668 = /*#__PURE__*/React.createElement("path", {
    d: "M15 67h1v1h-1z",
    fill: "#895936"
  })), _path4669 || (_path4669 = /*#__PURE__*/React.createElement("path", {
    d: "M17 67v1h-1v-1z",
    fill: "#8b5f3e"
  })), _path4670 || (_path4670 = /*#__PURE__*/React.createElement("path", {
    d: "M17 67h1v1h-1z",
    fill: "#8c6445"
  })), _path4671 || (_path4671 = /*#__PURE__*/React.createElement("path", {
    d: "M18 67h1v1h-1z",
    fill: "#8d6447"
  })), _path4672 || (_path4672 = /*#__PURE__*/React.createElement("path", {
    d: "M19 68v-1h1v1z",
    fill: "#896343"
  })), _path4673 || (_path4673 = /*#__PURE__*/React.createElement("path", {
    d: "M21 68h-1v-1h1z",
    fill: "#8b633f"
  })), _path4674 || (_path4674 = /*#__PURE__*/React.createElement("path", {
    d: "M21 67h1v1h-1z",
    fill: "#8d6238"
  })), _path4675 || (_path4675 = /*#__PURE__*/React.createElement("path", {
    d: "M22 67h1v1h-1z",
    fill: "#8a5c2e"
  })), _path4676 || (_path4676 = /*#__PURE__*/React.createElement("path", {
    d: "M24 67v1h-1v-1z",
    fill: "#8a5728"
  })), _path4677 || (_path4677 = /*#__PURE__*/React.createElement("path", {
    d: "M25 68h-1v-1h1z",
    fill: "#885324"
  })), _path4678 || (_path4678 = /*#__PURE__*/React.createElement("path", {
    d: "M26 67v1h-1v-1z",
    fill: "#844d21"
  })), _path4679 || (_path4679 = /*#__PURE__*/React.createElement("path", {
    d: "M27 68h-1v-1h1z",
    fill: "#7f491e"
  })), _path4680 || (_path4680 = /*#__PURE__*/React.createElement("path", {
    d: "M28 67v1h-1v-1z",
    fill: "#804d25"
  })), _path4681 || (_path4681 = /*#__PURE__*/React.createElement("path", {
    d: "M29 67v1h-1v-1z",
    fill: "#855737"
  })), _path4682 || (_path4682 = /*#__PURE__*/React.createElement("path", {
    d: "M30 67v1h-1v-1z",
    fill: "#886245"
  })), _path4683 || (_path4683 = /*#__PURE__*/React.createElement("path", {
    d: "M32 68h-1v-1h1z",
    fill: "#896349"
  })), _path4684 || (_path4684 = /*#__PURE__*/React.createElement("path", {
    d: "M33 67v1h-1v-1z",
    fill: "#896549"
  })), _path4685 || (_path4685 = /*#__PURE__*/React.createElement("path", {
    d: "M33 68v-1h1v1z",
    fill: "#8b6649"
  })), _path4686 || (_path4686 = /*#__PURE__*/React.createElement("path", {
    d: "M34 67h1v1h-1z",
    fill: "#8c6848"
  })), _path4687 || (_path4687 = /*#__PURE__*/React.createElement("path", {
    d: "M35 68v-1h1v1z",
    fill: "#8c6746"
  })), _path4688 || (_path4688 = /*#__PURE__*/React.createElement("path", {
    d: "M36 67h1v1h-1z",
    fill: "#8c6644"
  })), _path4689 || (_path4689 = /*#__PURE__*/React.createElement("path", {
    d: "M38 67v1h-1v-1z",
    fill: "#88603e"
  })), _path4690 || (_path4690 = /*#__PURE__*/React.createElement("path", {
    d: "M38 68v-1h1v1z",
    fill: "#a07557"
  })), _path4691 || (_path4691 = /*#__PURE__*/React.createElement("path", {
    d: "M39 67h1v1h-1z",
    fill: "#daac9b"
  })), _path4692 || (_path4692 = /*#__PURE__*/React.createElement("path", {
    d: "M40 68v-1h1v1z",
    fill: "#c29287"
  })), _path4693 || (_path4693 = /*#__PURE__*/React.createElement("path", {
    d: "M41 67h1v1h-1z",
    fill: "#c59a8b"
  })), _path4694 || (_path4694 = /*#__PURE__*/React.createElement("path", {
    d: "M43 67v1h-1v-1z",
    fill: "#8d5e45"
  })), _path4695 || (_path4695 = /*#__PURE__*/React.createElement("path", {
    d: "M43 67h1v1h-1z",
    fill: "#805332"
  })), _path4696 || (_path4696 = /*#__PURE__*/React.createElement("path", {
    d: "M45 68h-1v-1h1z",
    fill: "#8e6442"
  })), _path4697 || (_path4697 = /*#__PURE__*/React.createElement("path", {
    d: "M46 67v1h-1v-1z",
    fill: "#8e6543"
  })), _path4698 || (_path4698 = /*#__PURE__*/React.createElement("path", {
    d: "M46 67h1v1h-1z",
    fill: "#8f6441"
  })), _path4699 || (_path4699 = /*#__PURE__*/React.createElement("path", {
    d: "M48 67v1h-1v-1z",
    fill: "#90633f"
  })), _path4700 || (_path4700 = /*#__PURE__*/React.createElement("path", {
    d: "M48 67h1v1h-1z",
    fill: "#92633e"
  })), _path4701 || (_path4701 = /*#__PURE__*/React.createElement("path", {
    d: "M49 67h1v1h-1z",
    fill: "#90633c"
  })), _path4702 || (_path4702 = /*#__PURE__*/React.createElement("path", {
    d: "M50 68v-1h1v1z",
    fill: "#91653a"
  })), _path4703 || (_path4703 = /*#__PURE__*/React.createElement("path", {
    d: "M51 67h1v1h-1z",
    fill: "#926637"
  })), _path4704 || (_path4704 = /*#__PURE__*/React.createElement("path", {
    d: "M53 68h-1v-1h1z",
    fill: "#926536"
  })), _path4705 || (_path4705 = /*#__PURE__*/React.createElement("path", {
    d: "M53 67h1v1h-1z",
    fill: "#946334"
  })), _path4706 || (_path4706 = /*#__PURE__*/React.createElement("path", {
    d: "M54 67h1v1h-1z",
    fill: "#966534"
  })), _path4707 || (_path4707 = /*#__PURE__*/React.createElement("path", {
    d: "M56 67v1h-1v-1z",
    fill: "#936332"
  })), _path4708 || (_path4708 = /*#__PURE__*/React.createElement("path", {
    d: "M56 68v-1h1v1z",
    fill: "#88582a"
  })), _path4709 || (_path4709 = /*#__PURE__*/React.createElement("path", {
    d: "M58 68h-1v-1h1z",
    fill: "#7b4b1e"
  })), _path4710 || (_path4710 = /*#__PURE__*/React.createElement("path", {
    d: "M58 67h1v1h-1z",
    fill: "#7d4c25"
  })), _path4711 || (_path4711 = /*#__PURE__*/React.createElement("path", {
    d: "M59 67h1v1h-1z",
    fill: "#794b2c"
  })), _path4712 || (_path4712 = /*#__PURE__*/React.createElement("path", {
    d: "M61 67v1h-1v-1z",
    fill: "#7d543b"
  })), _path4713 || (_path4713 = /*#__PURE__*/React.createElement("path", {
    d: "M61 67h1v1h-1z",
    fill: "#855b44"
  })), _path4714 || (_path4714 = /*#__PURE__*/React.createElement("path", {
    d: "M63 67v1h-1v-1z",
    fill: "#94684d"
  })), _path4715 || (_path4715 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68h-1v-1h1z",
    fill: "#a57658"
  })), _path4716 || (_path4716 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68v-1h1v1z",
    fill: "#a87456"
  })), _path4717 || (_path4717 = /*#__PURE__*/React.createElement("path", {
    d: "M65 68v-1h1v1z",
    fill: "#7f482a"
  })), _path4718 || (_path4718 = /*#__PURE__*/React.createElement("path", {
    d: "M66 67h1v1h-1z",
    fill: "#b17c5c"
  })), _path4719 || (_path4719 = /*#__PURE__*/React.createElement("path", {
    d: "M68 67v1h-1v-1z",
    fill: "#af8568",
    fillOpacity: 0.871
  })), _path4720 || (_path4720 = /*#__PURE__*/React.createElement("path", {
    d: "M72 67v1h-1v-1z",
    fill: "#7f6d5b",
    fillOpacity: 0.055
  })), _path4721 || (_path4721 = /*#__PURE__*/React.createElement("path", {
    d: "M72 67h1v1h-1z",
    fill: "#a37349",
    fillOpacity: 0.863
  })), _path4722 || (_path4722 = /*#__PURE__*/React.createElement("path", {
    d: "M73 67h1v1h-1z",
    fill: "#b37e4e"
  })), _path4723 || (_path4723 = /*#__PURE__*/React.createElement("path", {
    d: "M75 67v1h-1v-1z",
    fill: "#b68356"
  })), _path4724 || (_path4724 = /*#__PURE__*/React.createElement("path", {
    d: "M78 67v1h-1v-1z",
    fill: "#a97843"
  })), _path4725 || (_path4725 = /*#__PURE__*/React.createElement("path", {
    d: "M78 67h1v1h-1z",
    fill: "#9f784f",
    fillOpacity: 0.765
  })), _path4726 || (_path4726 = /*#__PURE__*/React.createElement("path", {
    d: "M95 67h1v1h-1z",
    fill: "#956853",
    fillOpacity: 0.804
  })), _path4727 || (_path4727 = /*#__PURE__*/React.createElement("path", {
    d: "M98 67v1h-1v-1z",
    fill: "#9c684f"
  })), _path4728 || (_path4728 = /*#__PURE__*/React.createElement("path", {
    d: "M98 68v-1h1v1z",
    fill: "#977264",
    fillOpacity: 0.357
  })), _path4729 || (_path4729 = /*#__PURE__*/React.createElement("path", {
    d: "M100 68h-1v-1h1z",
    fill: "#a1725d",
    fillOpacity: 0.149
  })), _path4730 || (_path4730 = /*#__PURE__*/React.createElement("path", {
    d: "M101 67v1h-1v-1z",
    fill: "#9c6c52",
    fillOpacity: 0.314
  })), _path4731 || (_path4731 = /*#__PURE__*/React.createElement("path", {
    d: "M102 68h-1v-1h1z",
    fill: "#916347",
    fillOpacity: 0.741
  })), _path4732 || (_path4732 = /*#__PURE__*/React.createElement("path", {
    d: "M104 67v1h-1v-1z",
    fill: "#a36742"
  })), _path4733 || (_path4733 = /*#__PURE__*/React.createElement("path", {
    d: "M105 68h-1v-1h1z",
    fill: "#d48f67"
  })), _path4734 || (_path4734 = /*#__PURE__*/React.createElement("path", {
    d: "M106 68h-1v-1h1z",
    fill: "#cb9578",
    fillOpacity: 0.58
  })), _path4735 || (_path4735 = /*#__PURE__*/React.createElement("path", {
    d: "M109 67v1h-1v-1z",
    fill: "#8e6645",
    fillOpacity: 0.631
  })), _path4736 || (_path4736 = /*#__PURE__*/React.createElement("path", {
    d: "M109 68v-1h1v1z",
    fill: "#906235"
  })), _path4737 || (_path4737 = /*#__PURE__*/React.createElement("path", {
    d: "M110 67h1v1h-1z",
    fill: "#7d542f"
  })), _path4738 || (_path4738 = /*#__PURE__*/React.createElement("path", {
    d: "M111 67h1v1h-1z",
    fill: "#ac8145"
  })), _path4739 || (_path4739 = /*#__PURE__*/React.createElement("path", {
    d: "M112 68v-1h1v1z",
    fill: "#f2ab68"
  })), _path4740 || (_path4740 = /*#__PURE__*/React.createElement("path", {
    d: "M114 68h-1v-1h1z",
    fill: "#bc7c4d"
  })), _path4741 || (_path4741 = /*#__PURE__*/React.createElement("path", {
    d: "M115 68h-1v-1h1z",
    fill: "#915e3f"
  })), _path4742 || (_path4742 = /*#__PURE__*/React.createElement("path", {
    d: "M116 68h-1v-1h1z",
    fill: "#976749",
    fillOpacity: 0.694
  })), _path4743 || (_path4743 = /*#__PURE__*/React.createElement("path", {
    d: "M117 68h-1v-1h1z",
    fill: "#895d41",
    fillOpacity: 0.537
  })), _path4744 || (_path4744 = /*#__PURE__*/React.createElement("path", {
    d: "M117 68v-1h1v1z",
    fill: "#854f30",
    fillOpacity: 0.996
  })), _path4745 || (_path4745 = /*#__PURE__*/React.createElement("path", {
    d: "M119 67v1h-1v-1z",
    fill: "#ac7050"
  })), _path4746 || (_path4746 = /*#__PURE__*/React.createElement("path", {
    d: "M120 67v1h-1v-1z",
    fill: "#c08b66"
  })), _path4747 || (_path4747 = /*#__PURE__*/React.createElement("path", {
    d: "M121 67v1h-1v-1z",
    fill: "#ac7f5c",
    fillOpacity: 0.824
  })), _path4748 || (_path4748 = /*#__PURE__*/React.createElement("path", {
    d: "M9 69v-1h1v1z",
    fill: "#b07a56",
    fillOpacity: 0.867
  })), _path4749 || (_path4749 = /*#__PURE__*/React.createElement("path", {
    d: "M10 69v-1h1v1z",
    fill: "#b77e58"
  })), _path4750 || (_path4750 = /*#__PURE__*/React.createElement("path", {
    d: "M11 69v-1h1v1z",
    fill: "#8b4c22"
  })), _path4751 || (_path4751 = /*#__PURE__*/React.createElement("path", {
    d: "M12 68h1v1h-1z",
    fill: "#7e431b"
  })), _path4752 || (_path4752 = /*#__PURE__*/React.createElement("path", {
    d: "M13 69v-1h1v1z",
    fill: "#793e1a"
  })), _path4753 || (_path4753 = /*#__PURE__*/React.createElement("path", {
    d: "M14 68h1v1h-1z",
    fill: "#6a3015"
  })), _path4754 || (_path4754 = /*#__PURE__*/React.createElement("path", {
    d: "M15 69v-1h1v1z",
    fill: "#8a4b29"
  })), _path4755 || (_path4755 = /*#__PURE__*/React.createElement("path", {
    d: "M17 69h-1v-1h1z",
    fill: "#925026"
  })), _path4756 || (_path4756 = /*#__PURE__*/React.createElement("path", {
    d: "M17 68h1v1h-1z",
    fill: "#92552e"
  })), _path4757 || (_path4757 = /*#__PURE__*/React.createElement("path", {
    d: "M19 68v1h-1v-1z",
    fill: "#945d3b"
  })), _path4758 || (_path4758 = /*#__PURE__*/React.createElement("path", {
    d: "M20 69v-1h1v1z",
    fill: "#9c6e4b"
  })), _path4759 || (_path4759 = /*#__PURE__*/React.createElement("path", {
    d: "M21 69v-1h1v1z",
    fill: "#a0724b"
  })), _path4760 || (_path4760 = /*#__PURE__*/React.createElement("path", {
    d: "M24 69h-1v-1h1z",
    fill: "#926233"
  })), _path4761 || (_path4761 = /*#__PURE__*/React.createElement("path", {
    d: "M25 68v1h-1v-1z",
    fill: "#8b5a27"
  })), _path4762 || (_path4762 = /*#__PURE__*/React.createElement("path", {
    d: "M26 69h-1v-1h1z",
    fill: "#875422"
  })), _path4763 || (_path4763 = /*#__PURE__*/React.createElement("path", {
    d: "M27 69h-1v-1h1z",
    fill: "#865220"
  })), _path4764 || (_path4764 = /*#__PURE__*/React.createElement("path", {
    d: "M27 69v-1h1v1z",
    fill: "#865425"
  })), _path4765 || (_path4765 = /*#__PURE__*/React.createElement("path", {
    d: "M28 69v-1h1v1z",
    fill: "#8b5e39"
  })), _path4766 || (_path4766 = /*#__PURE__*/React.createElement("path", {
    d: "M30 68v1h-1v-1z",
    fill: "#926b49"
  })), _path4767 || (_path4767 = /*#__PURE__*/React.createElement("path", {
    d: "M30 69v-1h1v1z",
    fill: "#956e4f"
  })), _path4768 || (_path4768 = /*#__PURE__*/React.createElement("path", {
    d: "M32 68v1h-1v-1z",
    fill: "#977153"
  })), _path4769 || (_path4769 = /*#__PURE__*/React.createElement("path", {
    d: "M32 69v-1h1v1z",
    fill: "#946f50"
  })), _path4770 || (_path4770 = /*#__PURE__*/React.createElement("path", {
    d: "M33 69v-1h1v1z",
    fill: "#946f4e"
  })), _path4771 || (_path4771 = /*#__PURE__*/React.createElement("path", {
    d: "M35 68v1h-1v-1z",
    fill: "#916c4d"
  })), _path4772 || (_path4772 = /*#__PURE__*/React.createElement("path", {
    d: "M35 68h1v1h-1z",
    fill: "#8e684b"
  })), _path4773 || (_path4773 = /*#__PURE__*/React.createElement("path", {
    d: "M37 69h-1v-1h1z",
    fill: "#8d664b"
  })), _path4774 || (_path4774 = /*#__PURE__*/React.createElement("path", {
    d: "M38 68v1h-1v-1z",
    fill: "#896148"
  })), _path4775 || (_path4775 = /*#__PURE__*/React.createElement("path", {
    d: "M38 69v-1h1v1z",
    fill: "#a17760"
  })), _path4776 || (_path4776 = /*#__PURE__*/React.createElement("path", {
    d: "M39 69v-1h1v1z",
    fill: "#d9ada1"
  })), _path4777 || (_path4777 = /*#__PURE__*/React.createElement("path", {
    d: "M41 69h-1v-1h1z",
    fill: "#c2948b"
  })), _path4778 || (_path4778 = /*#__PURE__*/React.createElement("path", {
    d: "M42 69h-1v-1h1z",
    fill: "#c49989"
  })), _path4779 || (_path4779 = /*#__PURE__*/React.createElement("path", {
    d: "M42 69v-1h1v1z",
    fill: "#8d5f43"
  })), _path4780 || (_path4780 = /*#__PURE__*/React.createElement("path", {
    d: "M44 68v1h-1v-1z",
    fill: "#855635"
  })), _path4781 || (_path4781 = /*#__PURE__*/React.createElement("path", {
    d: "M44 69v-1h1v1z",
    fill: "#956a4c"
  })), _path4782 || (_path4782 = /*#__PURE__*/React.createElement("path", {
    d: "M45 69v-1h1v1z",
    fill: "#94694a"
  })), _path4783 || (_path4783 = /*#__PURE__*/React.createElement("path", {
    d: "M48 69h-1v-1h1z",
    fill: "#956843"
  })), _path4784 || (_path4784 = /*#__PURE__*/React.createElement("path", {
    d: "M49 68v1h-1v-1z",
    fill: "#976840"
  })), _path4785 || (_path4785 = /*#__PURE__*/React.createElement("path", {
    d: "M50 69v-1h1v1z",
    fill: "#95683d"
  })), _path4786 || (_path4786 = /*#__PURE__*/React.createElement("path", {
    d: "M52 69h-1v-1h1z",
    fill: "#956639"
  })), _path4787 || (_path4787 = /*#__PURE__*/React.createElement("path", {
    d: "M54 69h-1v-1h1z",
    fill: "#945f35"
  })), _path4788 || (_path4788 = /*#__PURE__*/React.createElement("path", {
    d: "M55 69h-1v-1h1z",
    fill: "#8f5c30"
  })), _path4789 || (_path4789 = /*#__PURE__*/React.createElement("path", {
    d: "M56 69h-1v-1h1z",
    fill: "#8b5930"
  })), _path4790 || (_path4790 = /*#__PURE__*/React.createElement("path", {
    d: "M57 68v1h-1v-1z",
    fill: "#7f4d2b"
  })), _path4791 || (_path4791 = /*#__PURE__*/React.createElement("path", {
    d: "M58 69h-1v-1h1z",
    fill: "#79482a"
  })), _path4792 || (_path4792 = /*#__PURE__*/React.createElement("path", {
    d: "M58 68h1v1h-1z",
    fill: "#815337"
  })), _path4793 || (_path4793 = /*#__PURE__*/React.createElement("path", {
    d: "M59 69v-1h1v1z",
    fill: "#82573e"
  })), _path4794 || (_path4794 = /*#__PURE__*/React.createElement("path", {
    d: "M60 68h1v1h-1z",
    fill: "#865b43"
  })), _path4795 || (_path4795 = /*#__PURE__*/React.createElement("path", {
    d: "M62 68v1h-1v-1z",
    fill: "#94674e"
  })), _path4796 || (_path4796 = /*#__PURE__*/React.createElement("path", {
    d: "M62 68h1v1h-1z",
    fill: "#a27154"
  })), _path4797 || (_path4797 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68v1h-1v-1z",
    fill: "#ae785a"
  })), _path4798 || (_path4798 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68h1v1h-1z",
    fill: "#ab7456"
  })), _path4799 || (_path4799 = /*#__PURE__*/React.createElement("path", {
    d: "M66 69h-1v-1h1z",
    fill: "#814b2b"
  })), _path4800 || (_path4800 = /*#__PURE__*/React.createElement("path", {
    d: "M66 69v-1h1v1z",
    fill: "#af7a57"
  })), _path4801 || (_path4801 = /*#__PURE__*/React.createElement("path", {
    d: "M68 69h-1v-1h1z",
    fill: "#af8466",
    fillOpacity: 0.867
  })), _path4802 || (_path4802 = /*#__PURE__*/React.createElement("path", {
    d: "M68 69v-1h1v1z",
    fill: "#aaaa94",
    fillOpacity: 0.047
  })), _path4803 || (_path4803 = /*#__PURE__*/React.createElement("path", {
    d: "M71 69v-1h1v1z",
    fill: "#8b7373",
    fillOpacity: 0.043
  })), _path4804 || (_path4804 = /*#__PURE__*/React.createElement("path", {
    d: "M73 68v1h-1v-1z",
    fill: "#a6764a",
    fillOpacity: 0.851
  })), _path4805 || (_path4805 = /*#__PURE__*/React.createElement("path", {
    d: "M73 69v-1h1v1z",
    fill: "#b5814f"
  })), _path4806 || (_path4806 = /*#__PURE__*/React.createElement("path", {
    d: "M74 69v-1h1v1z",
    fill: "#ba8659"
  })), _path4807 || (_path4807 = /*#__PURE__*/React.createElement("path", {
    d: "M76 69h-1v-1h1z",
    fill: "#b28153"
  })), _path4808 || (_path4808 = /*#__PURE__*/React.createElement("path", {
    d: "M78 68v1h-1v-1z",
    fill: "#aa7742"
  })), _path4809 || (_path4809 = /*#__PURE__*/React.createElement("path", {
    d: "M79 69h-1v-1h1z",
    fill: "#9e764d",
    fillOpacity: 0.733
  })), _path4810 || (_path4810 = /*#__PURE__*/React.createElement("path", {
    d: "M96 69h-1v-1h1z",
    fill: "#966451",
    fillOpacity: 0.765
  })), _path4811 || (_path4811 = /*#__PURE__*/React.createElement("path", {
    d: "M97 69h-1v-1h1z",
    fill: "#a66e4d"
  })), _path4812 || (_path4812 = /*#__PURE__*/React.createElement("path", {
    d: "M98 69h-1v-1h1z",
    fill: "#986a4f"
  })), _path4813 || (_path4813 = /*#__PURE__*/React.createElement("path", {
    d: "M98 68h1v1h-1z",
    fill: "#8d715f",
    fillOpacity: 0.325
  })), _path4814 || (_path4814 = /*#__PURE__*/React.createElement("path", {
    d: "M102 68v1h-1v-1z",
    fill: "#8c624b",
    fillOpacity: 0.478
  })), _path4815 || (_path4815 = /*#__PURE__*/React.createElement("path", {
    d: "M103 68v1h-1v-1z",
    fill: "#9b6039"
  })), _path4816 || (_path4816 = /*#__PURE__*/React.createElement("path", {
    d: "M103 68h1v1h-1z",
    fill: "#a16640"
  })), _path4817 || (_path4817 = /*#__PURE__*/React.createElement("path", {
    d: "M104 68h1v1h-1z",
    fill: "#d7916b"
  })), _path4818 || (_path4818 = /*#__PURE__*/React.createElement("path", {
    d: "M105 69v-1h1v1z",
    fill: "#ce9a7e",
    fillOpacity: 0.537
  })), _path4819 || (_path4819 = /*#__PURE__*/React.createElement("path", {
    d: "M109 69h-1v-1h1z",
    fill: "#946b4b",
    fillOpacity: 0.612
  })), _path4820 || (_path4820 = /*#__PURE__*/React.createElement("path", {
    d: "M109 68h1v1h-1z",
    fill: "#98683a"
  })), _path4821 || (_path4821 = /*#__PURE__*/React.createElement("path", {
    d: "M110 68h1v1h-1z",
    fill: "#805732"
  })), _path4822 || (_path4822 = /*#__PURE__*/React.createElement("path", {
    d: "M112 68v1h-1v-1z",
    fill: "#b28448"
  })), _path4823 || (_path4823 = /*#__PURE__*/React.createElement("path", {
    d: "M112 68h1v1h-1z",
    fill: "#f4ab68"
  })), _path4824 || (_path4824 = /*#__PURE__*/React.createElement("path", {
    d: "M113 69v-1h1v1z",
    fill: "#bb8355",
    fillOpacity: 0.761
  })), _path4825 || (_path4825 = /*#__PURE__*/React.createElement("path", {
    d: "M115 69h-1v-1h1z",
    fill: "#795940",
    fillOpacity: 0.247
  })), _path4826 || (_path4826 = /*#__PURE__*/React.createElement("path", {
    d: "M116 68h1v1h-1z",
    fill: "#6c5347",
    fillOpacity: 0.239
  })), _path4827 || (_path4827 = /*#__PURE__*/React.createElement("path", {
    d: "M117 68h1v1h-1z",
    fill: "#845036"
  })), _path4828 || (_path4828 = /*#__PURE__*/React.createElement("path", {
    d: "M118 68h1v1h-1z",
    fill: "#af7252"
  })), _path4829 || (_path4829 = /*#__PURE__*/React.createElement("path", {
    d: "M120 68v1h-1v-1z",
    fill: "#c18a65"
  })), _path4830 || (_path4830 = /*#__PURE__*/React.createElement("path", {
    d: "M120 69v-1h1v1z",
    fill: "#ad7d59",
    fillOpacity: 0.835
  })), _path4831 || (_path4831 = /*#__PURE__*/React.createElement("path", {
    d: "M10 69v1H9v-1z",
    fill: "#af7b56",
    fillOpacity: 0.796
  })), _path4832 || (_path4832 = /*#__PURE__*/React.createElement("path", {
    d: "M10 69h1v1h-1z",
    fill: "#bb825b"
  })), _path4833 || (_path4833 = /*#__PURE__*/React.createElement("path", {
    d: "M11 69h1v1h-1z",
    fill: "#8c4c22"
  })), _path4834 || (_path4834 = /*#__PURE__*/React.createElement("path", {
    d: "M12 70v-1h1v1z",
    fill: "#763c17"
  })), _path4835 || (_path4835 = /*#__PURE__*/React.createElement("path", {
    d: "M14 70h-1v-1h1z",
    fill: "#643012"
  })), _path4836 || (_path4836 = /*#__PURE__*/React.createElement("path", {
    d: "M14 70v-1h1v1z",
    fill: "#491b09"
  })), _path4837 || (_path4837 = /*#__PURE__*/React.createElement("path", {
    d: "M16 69v1h-1v-1z",
    fill: "#5b2710"
  })), _path4838 || (_path4838 = /*#__PURE__*/React.createElement("path", {
    d: "M16 69h1v1h-1z",
    fill: "#763816"
  })), _path4839 || (_path4839 = /*#__PURE__*/React.createElement("path", {
    d: "M17 70v-1h1v1z",
    fill: "#884824"
  })), _path4840 || (_path4840 = /*#__PURE__*/React.createElement("path", {
    d: "M19 69v1h-1v-1z",
    fill: "#94532f"
  })), _path4841 || (_path4841 = /*#__PURE__*/React.createElement("path", {
    d: "M20 70h-1v-1h1z",
    fill: "#995832"
  })), _path4842 || (_path4842 = /*#__PURE__*/React.createElement("path", {
    d: "M20 69h1v1h-1z",
    fill: "#9a5b35"
  })), _path4843 || (_path4843 = /*#__PURE__*/React.createElement("path", {
    d: "M22 69h1v1h-1z",
    fill: "#925630"
  })), _path4844 || (_path4844 = /*#__PURE__*/React.createElement("path", {
    d: "M24 69v1h-1v-1z",
    fill: "#91562e"
  })), _path4845 || (_path4845 = /*#__PURE__*/React.createElement("path", {
    d: "M24 70v-1h1v1z",
    fill: "#955b2e"
  })), _path4846 || (_path4846 = /*#__PURE__*/React.createElement("path", {
    d: "M25 70v-1h1v1z",
    fill: "#925b2b"
  })), _path4847 || (_path4847 = /*#__PURE__*/React.createElement("path", {
    d: "M26 70v-1h1v1z",
    fill: "#8f5925"
  })), _path4848 || (_path4848 = /*#__PURE__*/React.createElement("path", {
    d: "M29 70h-1v-1h1z",
    fill: "#936439"
  })), _path4849 || (_path4849 = /*#__PURE__*/React.createElement("path", {
    d: "M29 70v-1h1v1z",
    fill: "#9a7048"
  })), _path4850 || (_path4850 = /*#__PURE__*/React.createElement("path", {
    d: "M30 69h1v1h-1z",
    fill: "#9c724e"
  })), _path4851 || (_path4851 = /*#__PURE__*/React.createElement("path", {
    d: "M31 70v-1h1v1z",
    fill: "#9a7450"
  })), _path4852 || (_path4852 = /*#__PURE__*/React.createElement("path", {
    d: "M33 69v1h-1v-1z",
    fill: "#99724f"
  })), _path4853 || (_path4853 = /*#__PURE__*/React.createElement("path", {
    d: "M34 69v1h-1v-1z",
    fill: "#986f4c"
  })), _path4854 || (_path4854 = /*#__PURE__*/React.createElement("path", {
    d: "M35 70h-1v-1h1z",
    fill: "#976e4d"
  })), _path4855 || (_path4855 = /*#__PURE__*/React.createElement("path", {
    d: "M36 69v1h-1v-1z",
    fill: "#966c4f"
  })), _path4856 || (_path4856 = /*#__PURE__*/React.createElement("path", {
    d: "M36 70v-1h1v1z",
    fill: "#946a50"
  })), _path4857 || (_path4857 = /*#__PURE__*/React.createElement("path", {
    d: "M37 70v-1h1v1z",
    fill: "#92684d"
  })), _path4858 || (_path4858 = /*#__PURE__*/React.createElement("path", {
    d: "M39 70h-1v-1h1z",
    fill: "#a97f66"
  })), _path4859 || (_path4859 = /*#__PURE__*/React.createElement("path", {
    d: "M39 69h1v1h-1z",
    fill: "#d8ad9e"
  })), _path4860 || (_path4860 = /*#__PURE__*/React.createElement("path", {
    d: "M41 69v1h-1v-1z",
    fill: "#c39789"
  })), _path4861 || (_path4861 = /*#__PURE__*/React.createElement("path", {
    d: "M42 69v1h-1v-1z",
    fill: "#c69a89"
  })), _path4862 || (_path4862 = /*#__PURE__*/React.createElement("path", {
    d: "M43 69v1h-1v-1z",
    fill: "#8c5e40"
  })), _path4863 || (_path4863 = /*#__PURE__*/React.createElement("path", {
    d: "M43 69h1v1h-1z",
    fill: "#855533"
  })), _path4864 || (_path4864 = /*#__PURE__*/React.createElement("path", {
    d: "M45 70h-1v-1h1z",
    fill: "#966647"
  })), _path4865 || (_path4865 = /*#__PURE__*/React.createElement("path", {
    d: "M45 70v-1h1v1z",
    fill: "#976847"
  })), _path4866 || (_path4866 = /*#__PURE__*/React.createElement("path", {
    d: "M46 70v-1h1v1z",
    fill: "#9a6a46"
  })), _path4867 || (_path4867 = /*#__PURE__*/React.createElement("path", {
    d: "M48 69v1h-1v-1z",
    fill: "#996a42"
  })), _path4868 || (_path4868 = /*#__PURE__*/React.createElement("path", {
    d: "M48 69h1v1h-1z",
    fill: "#97693f"
  })), _path4869 || (_path4869 = /*#__PURE__*/React.createElement("path", {
    d: "M50 69h1v1h-1z",
    fill: "#94643b"
  })), _path4870 || (_path4870 = /*#__PURE__*/React.createElement("path", {
    d: "M51 69h1v1h-1z",
    fill: "#92613a"
  })), _path4871 || (_path4871 = /*#__PURE__*/React.createElement("path", {
    d: "M53 70v-1h1v1z",
    fill: "#905d37"
  })), _path4872 || (_path4872 = /*#__PURE__*/React.createElement("path", {
    d: "M54 69h1v1h-1z",
    fill: "#8f5a34"
  })), _path4873 || (_path4873 = /*#__PURE__*/React.createElement("path", {
    d: "M55 70v-1h1v1z",
    fill: "#8b5836"
  })), _path4874 || (_path4874 = /*#__PURE__*/React.createElement("path", {
    d: "M57 70h-1v-1h1z",
    fill: "#86563b"
  })), _path4875 || (_path4875 = /*#__PURE__*/React.createElement("path", {
    d: "M58 69v1h-1v-1z",
    fill: "#83553e"
  })), _path4876 || (_path4876 = /*#__PURE__*/React.createElement("path", {
    d: "M59 69v1h-1v-1z",
    fill: "#80523d"
  })), _path4877 || (_path4877 = /*#__PURE__*/React.createElement("path", {
    d: "M59 70v-1h1v1z",
    fill: "#7e543b"
  })), _path4878 || (_path4878 = /*#__PURE__*/React.createElement("path", {
    d: "M60 70v-1h1v1z",
    fill: "#8d5f41"
  })), _path4879 || (_path4879 = /*#__PURE__*/React.createElement("path", {
    d: "M63 69h1v1h-1z",
    fill: "#ae795a"
  })), _path4880 || (_path4880 = /*#__PURE__*/React.createElement("path", {
    d: "M64 69h1v1h-1z",
    fill: "#ac7659"
  })), _path4881 || (_path4881 = /*#__PURE__*/React.createElement("path", {
    d: "M66 69v1h-1v-1z",
    fill: "#864f30"
  })), _path4882 || (_path4882 = /*#__PURE__*/React.createElement("path", {
    d: "M67 69v1h-1v-1z",
    fill: "#b07b59"
  })), _path4883 || (_path4883 = /*#__PURE__*/React.createElement("path", {
    d: "M67 70v-1h1v1z",
    fill: "#b08567",
    fillOpacity: 0.867
  })), _path4884 || (_path4884 = /*#__PURE__*/React.createElement("path", {
    d: "M69 70h-1v-1h1z",
    fill: "#bfaa94",
    fillOpacity: 0.047
  })), _path4885 || (_path4885 = /*#__PURE__*/React.createElement("path", {
    d: "M73 69v1h-1v-1z",
    fill: "#a67649",
    fillOpacity: 0.843
  })), _path4886 || (_path4886 = /*#__PURE__*/React.createElement("path", {
    d: "M73 69h1v1h-1z",
    fill: "#b6824e"
  })), _path4887 || (_path4887 = /*#__PURE__*/React.createElement("path", {
    d: "M75 70h-1v-1h1z",
    fill: "#b98759"
  })), _path4888 || (_path4888 = /*#__PURE__*/React.createElement("path", {
    d: "M75 70v-1h1v1z",
    fill: "#b38254"
  })), _path4889 || (_path4889 = /*#__PURE__*/React.createElement("path", {
    d: "M76 70v-1h1v1z",
    fill: "#9d6c3c"
  })), _path4890 || (_path4890 = /*#__PURE__*/React.createElement("path", {
    d: "M77 69h1v1h-1z",
    fill: "#a97742"
  })), _path4891 || (_path4891 = /*#__PURE__*/React.createElement("path", {
    d: "M79 70h-1v-1h1z",
    fill: "#a27b54",
    fillOpacity: 0.702
  })), _path4892 || (_path4892 = /*#__PURE__*/React.createElement("path", {
    d: "M95 69h1v1h-1z",
    fill: "#8f634f",
    fillOpacity: 0.702
  })), _path4893 || (_path4893 = /*#__PURE__*/React.createElement("path", {
    d: "M96 70v-1h1v1z",
    fill: "#a87156"
  })), _path4894 || (_path4894 = /*#__PURE__*/React.createElement("path", {
    d: "M98 69v1h-1v-1z",
    fill: "#9c6c53"
  })), _path4895 || (_path4895 = /*#__PURE__*/React.createElement("path", {
    d: "M98 70v-1h1v1z",
    fill: "#8c6f60",
    fillOpacity: 0.384
  })), _path4896 || (_path4896 = /*#__PURE__*/React.createElement("path", {
    d: "M102 70h-1v-1h1z",
    fill: "#896347",
    fillOpacity: 0.545
  })), _path4897 || (_path4897 = /*#__PURE__*/React.createElement("path", {
    d: "M104 70v-1h1v1z",
    fill: "#d7926c"
  })), _path4898 || (_path4898 = /*#__PURE__*/React.createElement("path", {
    d: "M105 69h1v1h-1z",
    fill: "#c9997f",
    fillOpacity: 0.431
  })), _path4899 || (_path4899 = /*#__PURE__*/React.createElement("path", {
    d: "M108 70h-1v-1h1z",
    fill: "#ad7f68",
    fillOpacity: 0.259
  })), _path4900 || (_path4900 = /*#__PURE__*/React.createElement("path", {
    d: "M108 70v-1h1v1z",
    fill: "#9e714d",
    fillOpacity: 0.827
  })), _path4901 || (_path4901 = /*#__PURE__*/React.createElement("path", {
    d: "M110 69h1v1h-1z",
    fill: "#855b34"
  })), _path4902 || (_path4902 = /*#__PURE__*/React.createElement("path", {
    d: "M112 70h-1v-1h1z",
    fill: "#b48246"
  })), _path4903 || (_path4903 = /*#__PURE__*/React.createElement("path", {
    d: "M113 70h-1v-1h1z",
    fill: "#f3a863"
  })), _path4904 || (_path4904 = /*#__PURE__*/React.createElement("path", {
    d: "M113 69h1v1h-1z",
    fill: "#daa372",
    fillOpacity: 0.384
  })), _path4905 || (_path4905 = /*#__PURE__*/React.createElement("path", {
    d: "M117 70h-1v-1h1z",
    fill: "#735141",
    fillOpacity: 0.259
  })), _path4906 || (_path4906 = /*#__PURE__*/React.createElement("path", {
    d: "M117 69h1v1h-1z",
    fill: "#81492f"
  })), _path4907 || (_path4907 = /*#__PURE__*/React.createElement("path", {
    d: "M119 70h-1v-1h1z",
    fill: "#ac7352"
  })), _path4908 || (_path4908 = /*#__PURE__*/React.createElement("path", {
    d: "M119 69h1v1h-1z",
    fill: "#bf8965"
  })), _path4909 || (_path4909 = /*#__PURE__*/React.createElement("path", {
    d: "M121 69v1h-1v-1z",
    fill: "#ad7e5a",
    fillOpacity: 0.875
  })), _path4910 || (_path4910 = /*#__PURE__*/React.createElement("path", {
    d: "M9 71v-1h1v1z",
    fill: "#ad7c5a",
    fillOpacity: 0.749
  })), _path4911 || (_path4911 = /*#__PURE__*/React.createElement("path", {
    d: "M10 70h1v1h-1z",
    fill: "#be845c"
  })), _path4912 || (_path4912 = /*#__PURE__*/React.createElement("path", {
    d: "M12 70v1h-1v-1z",
    fill: "#94552b"
  })), _path4913 || (_path4913 = /*#__PURE__*/React.createElement("path", {
    d: "M12 70h1v1h-1z",
    fill: "#ad724c"
  })), _path4914 || (_path4914 = /*#__PURE__*/React.createElement("path", {
    d: "M14 70v1h-1v-1z",
    fill: "#b07955"
  })), _path4915 || (_path4915 = /*#__PURE__*/React.createElement("path", {
    d: "M14 71v-1h1v1z",
    fill: "#ab7552"
  })), _path4916 || (_path4916 = /*#__PURE__*/React.createElement("path", {
    d: "M17 71h-1v-1h1z",
    fill: "#8c5838"
  })), _path4917 || (_path4917 = /*#__PURE__*/React.createElement("path", {
    d: "M17 70h1v1h-1z",
    fill: "#804b29"
  })), _path4918 || (_path4918 = /*#__PURE__*/React.createElement("path", {
    d: "M18 70h1v1h-1z",
    fill: "#804622"
  })), _path4919 || (_path4919 = /*#__PURE__*/React.createElement("path", {
    d: "M19 70h1v1h-1z",
    fill: "#854824"
  })), _path4920 || (_path4920 = /*#__PURE__*/React.createElement("path", {
    d: "M20 71v-1h1v1z",
    fill: "#8b4c25"
  })), _path4921 || (_path4921 = /*#__PURE__*/React.createElement("path", {
    d: "M21 71v-1h1v1z",
    fill: "#935129"
  })), _path4922 || (_path4922 = /*#__PURE__*/React.createElement("path", {
    d: "M22 70h1v1h-1z",
    fill: "#8f4824"
  })), _path4923 || (_path4923 = /*#__PURE__*/React.createElement("path", {
    d: "M24 71h-1v-1h1z",
    fill: "#8d4725"
  })), _path4924 || (_path4924 = /*#__PURE__*/React.createElement("path", {
    d: "M24 70h1v1h-1z",
    fill: "#8b4522"
  })), _path4925 || (_path4925 = /*#__PURE__*/React.createElement("path", {
    d: "M25 70h1v1h-1z",
    fill: "#8d4820"
  })), _path4926 || (_path4926 = /*#__PURE__*/React.createElement("path", {
    d: "M26 70h1v1h-1z",
    fill: "#965326"
  })), _path4927 || (_path4927 = /*#__PURE__*/React.createElement("path", {
    d: "M28 70v1h-1v-1z",
    fill: "#9a5a2a"
  })), _path4928 || (_path4928 = /*#__PURE__*/React.createElement("path", {
    d: "M28 71v-1h1v1z",
    fill: "#9c5f31"
  })), _path4929 || (_path4929 = /*#__PURE__*/React.createElement("path", {
    d: "M30 71h-1v-1h1z",
    fill: "#975f34"
  })), _path4930 || (_path4930 = /*#__PURE__*/React.createElement("path", {
    d: "M30 71v-1h1v1z",
    fill: "#946036"
  })), _path4931 || (_path4931 = /*#__PURE__*/React.createElement("path", {
    d: "M32 71h-1v-1h1z",
    fill: "#94633d"
  })), _path4932 || (_path4932 = /*#__PURE__*/React.createElement("path", {
    d: "M33 70v1h-1v-1z",
    fill: "#956540"
  })), _path4933 || (_path4933 = /*#__PURE__*/React.createElement("path", {
    d: "M35 71v-1h1v1z",
    fill: "#986c4a"
  })), _path4934 || (_path4934 = /*#__PURE__*/React.createElement("path", {
    d: "M36 70h1v1h-1z",
    fill: "#9b6f4f"
  })), _path4935 || (_path4935 = /*#__PURE__*/React.createElement("path", {
    d: "M37 70h1v1h-1z",
    fill: "#996b4a"
  })), _path4936 || (_path4936 = /*#__PURE__*/React.createElement("path", {
    d: "M38 71v-1h1v1z",
    fill: "#ab7c63"
  })), _path4937 || (_path4937 = /*#__PURE__*/React.createElement("path", {
    d: "M40 70v1h-1v-1z",
    fill: "#dcb0a0"
  })), _path4938 || (_path4938 = /*#__PURE__*/React.createElement("path", {
    d: "M41 71h-1v-1h1z",
    fill: "#c8998a"
  })), _path4939 || (_path4939 = /*#__PURE__*/React.createElement("path", {
    d: "M42 71h-1v-1h1z",
    fill: "#c29381"
  })), _path4940 || (_path4940 = /*#__PURE__*/React.createElement("path", {
    d: "M42 70h1v1h-1z",
    fill: "#895c3a"
  })), _path4941 || (_path4941 = /*#__PURE__*/React.createElement("path", {
    d: "M43 70h1v1h-1z",
    fill: "#85562e"
  })), _path4942 || (_path4942 = /*#__PURE__*/React.createElement("path", {
    d: "M45 71h-1v-1h1z",
    fill: "#9b6a3f"
  })), _path4943 || (_path4943 = /*#__PURE__*/React.createElement("path", {
    d: "M45 71v-1h1v1z",
    fill: "#9e6b3e"
  })), _path4944 || (_path4944 = /*#__PURE__*/React.createElement("path", {
    d: "M46 70h1v1h-1z",
    fill: "#9c6b3c"
  })), _path4945 || (_path4945 = /*#__PURE__*/React.createElement("path", {
    d: "M49 71h-1v-1h1z",
    fill: "#916238"
  })), _path4946 || (_path4946 = /*#__PURE__*/React.createElement("path", {
    d: "M50 70v1h-1v-1z",
    fill: "#91633b"
  })), _path4947 || (_path4947 = /*#__PURE__*/React.createElement("path", {
    d: "M50 71v-1h1v1z",
    fill: "#8b5c3a"
  })), _path4948 || (_path4948 = /*#__PURE__*/React.createElement("path", {
    d: "M51 71v-1h1v1z",
    fill: "#885a39"
  })), _path4949 || (_path4949 = /*#__PURE__*/React.createElement("path", {
    d: "M53 70v1h-1v-1z",
    fill: "#8b5e38"
  })), _path4950 || (_path4950 = /*#__PURE__*/React.createElement("path", {
    d: "M54 71h-1v-1h1z",
    fill: "#8e613b"
  })), _path4951 || (_path4951 = /*#__PURE__*/React.createElement("path", {
    d: "M54 71v-1h1v1z",
    fill: "#926543"
  })), _path4952 || (_path4952 = /*#__PURE__*/React.createElement("path", {
    d: "M56 71h-1v-1h1z",
    fill: "#895c3d"
  })), _path4953 || (_path4953 = /*#__PURE__*/React.createElement("path", {
    d: "M57 70v1h-1v-1z",
    fill: "#815738"
  })), _path4954 || (_path4954 = /*#__PURE__*/React.createElement("path", {
    d: "M58 71h-1v-1h1z",
    fill: "#7d5333"
  })), _path4955 || (_path4955 = /*#__PURE__*/React.createElement("path", {
    d: "M58 70h1v1h-1z",
    fill: "#835637"
  })), _path4956 || (_path4956 = /*#__PURE__*/React.createElement("path", {
    d: "M60 71v-1h1v1z",
    fill: "#916243"
  })), _path4957 || (_path4957 = /*#__PURE__*/React.createElement("path", {
    d: "M62 70v1h-1v-1z",
    fill: "#9a684b"
  })), _path4958 || (_path4958 = /*#__PURE__*/React.createElement("path", {
    d: "M62 71v-1h1v1z",
    fill: "#a47556"
  })), _path4959 || (_path4959 = /*#__PURE__*/React.createElement("path", {
    d: "M64 70v1h-1v-1z",
    fill: "#a77857"
  })), _path4960 || (_path4960 = /*#__PURE__*/React.createElement("path", {
    d: "M64 71v-1h1v1z",
    fill: "#9f6a4a"
  })), _path4961 || (_path4961 = /*#__PURE__*/React.createElement("path", {
    d: "M66 71h-1v-1h1z",
    fill: "#925a38"
  })), _path4962 || (_path4962 = /*#__PURE__*/React.createElement("path", {
    d: "M67 71v-1h1v1z",
    fill: "#b18569",
    fillOpacity: 0.875
  })), _path4963 || (_path4963 = /*#__PURE__*/React.createElement("path", {
    d: "M69 70v1h-1v-1z",
    fill: "#b6a37f",
    fillOpacity: 0.055
  })), _path4964 || (_path4964 = /*#__PURE__*/React.createElement("path", {
    d: "M73 71h-1v-1h1z",
    fill: "#9f7549",
    fillOpacity: 0.835
  })), _path4965 || (_path4965 = /*#__PURE__*/React.createElement("path", {
    d: "M74 70v1h-1v-1z",
    fill: "#b5814c"
  })), _path4966 || (_path4966 = /*#__PURE__*/React.createElement("path", {
    d: "M74 70h1v1h-1z",
    fill: "#b88a5a"
  })), _path4967 || (_path4967 = /*#__PURE__*/React.createElement("path", {
    d: "M79 70v1h-1v-1z",
    fill: "#a47c55",
    fillOpacity: 0.675
  })), _path4968 || (_path4968 = /*#__PURE__*/React.createElement("path", {
    d: "M95 70h1v1h-1z",
    fill: "#8e654f",
    fillOpacity: 0.651
  })), _path4969 || (_path4969 = /*#__PURE__*/React.createElement("path", {
    d: "M97 71h-1v-1h1z",
    fill: "#ab7054"
  })), _path4970 || (_path4970 = /*#__PURE__*/React.createElement("path", {
    d: "M98 70v1h-1v-1z",
    fill: "#9f6d51"
  })), _path4971 || (_path4971 = /*#__PURE__*/React.createElement("path", {
    d: "M99 71h-1v-1h1z",
    fill: "#886d5d",
    fillOpacity: 0.439
  })), _path4972 || (_path4972 = /*#__PURE__*/React.createElement("path", {
    d: "M102 71h-1v-1h1z",
    fill: "#8f6046",
    fillOpacity: 0.6
  })), _path4973 || (_path4973 = /*#__PURE__*/React.createElement("path", {
    d: "M103 71h-1v-1h1z",
    fill: "#9b5f3a"
  })), _path4974 || (_path4974 = /*#__PURE__*/React.createElement("path", {
    d: "M104 71h-1v-1h1z",
    fill: "#a66844"
  })), _path4975 || (_path4975 = /*#__PURE__*/React.createElement("path", {
    d: "M105 70v1h-1v-1z",
    fill: "#d2916c"
  })), _path4976 || (_path4976 = /*#__PURE__*/React.createElement("path", {
    d: "M105 71v-1h1v1z",
    fill: "#ca906e",
    fillOpacity: 0.651
  })), _path4977 || (_path4977 = /*#__PURE__*/React.createElement("path", {
    d: "M107 70v1h-1v-1z",
    fill: "#c28966",
    fillOpacity: 0.729
  })), _path4978 || (_path4978 = /*#__PURE__*/React.createElement("path", {
    d: "M107 70h1v1h-1z",
    fill: "#cd8b69"
  })), _path4979 || (_path4979 = /*#__PURE__*/React.createElement("path", {
    d: "M108 70h1v1h-1z",
    fill: "#af754b"
  })), _path4980 || (_path4980 = /*#__PURE__*/React.createElement("path", {
    d: "M110 70h1v1h-1z",
    fill: "#855b36"
  })), _path4981 || (_path4981 = /*#__PURE__*/React.createElement("path", {
    d: "M112 70v1h-1v-1z",
    fill: "#b98549"
  })), _path4982 || (_path4982 = /*#__PURE__*/React.createElement("path", {
    d: "M112 70h1v1h-1z",
    fill: "#f3a861"
  })), _path4983 || (_path4983 = /*#__PURE__*/React.createElement("path", {
    d: "M114 70v1h-1v-1z",
    fill: "#d49b6b",
    fillOpacity: 0.38
  })), _path4984 || (_path4984 = /*#__PURE__*/React.createElement("path", {
    d: "M116 70h1v1h-1z",
    fill: "#7d5550",
    fillOpacity: 0.224
  })), _path4985 || (_path4985 = /*#__PURE__*/React.createElement("path", {
    d: "M117 70h1v1h-1z",
    fill: "#884f35",
    fillOpacity: 0.992
  })), _path4986 || (_path4986 = /*#__PURE__*/React.createElement("path", {
    d: "M118 70h1v1h-1z",
    fill: "#ae7753"
  })), _path4987 || (_path4987 = /*#__PURE__*/React.createElement("path", {
    d: "M120 71h-1v-1h1z",
    fill: "#be8b67"
  })), _path4988 || (_path4988 = /*#__PURE__*/React.createElement("path", {
    d: "M120 71v-1h1v1z",
    fill: "#b0805b",
    fillOpacity: 0.882
  })), _path4989 || (_path4989 = /*#__PURE__*/React.createElement("path", {
    d: "M122 71h-1v-1h1z",
    fill: "#8f6f5f",
    fillOpacity: 0.063
  })), _path4990 || (_path4990 = /*#__PURE__*/React.createElement("path", {
    d: "M10 71v1H9v-1z",
    fill: "#ac7e5c",
    fillOpacity: 0.706
  })), _path4991 || (_path4991 = /*#__PURE__*/React.createElement("path", {
    d: "M10 72v-1h1v1z",
    fill: "#c0875f"
  })), _path4992 || (_path4992 = /*#__PURE__*/React.createElement("path", {
    d: "M12 72h-1v-1h1z",
    fill: "#97592e"
  })), _path4993 || (_path4993 = /*#__PURE__*/React.createElement("path", {
    d: "M13 71v1h-1v-1z",
    fill: "#af7046"
  })), _path4994 || (_path4994 = /*#__PURE__*/React.createElement("path", {
    d: "M13 71h1v1h-1z",
    fill: "#b2744b"
  })), _path4995 || (_path4995 = /*#__PURE__*/React.createElement("path", {
    d: "M15 71v1h-1v-1z",
    fill: "#b47952"
  })), _path4996 || (_path4996 = /*#__PURE__*/React.createElement("path", {
    d: "M15 71h1v1h-1z",
    fill: "#b98058"
  })), _path4997 || (_path4997 = /*#__PURE__*/React.createElement("path", {
    d: "M16 71h1v1h-1z",
    fill: "#bd865e"
  })), _path4998 || (_path4998 = /*#__PURE__*/React.createElement("path", {
    d: "M17 71h1v1h-1z",
    fill: "#bd875f"
  })), _path4999 || (_path4999 = /*#__PURE__*/React.createElement("path", {
    d: "M18 72v-1h1v1z",
    fill: "#be8860"
  })), _path5000 || (_path5000 = /*#__PURE__*/React.createElement("path", {
    d: "M19 71h1v1h-1z",
    fill: "#b27d55"
  })), _path5001 || (_path5001 = /*#__PURE__*/React.createElement("path", {
    d: "M20 71h1v1h-1z",
    fill: "#a56e46"
  })), _path5002 || (_path5002 = /*#__PURE__*/React.createElement("path", {
    d: "M21 71h1v1h-1z",
    fill: "#9a6037"
  })), _path5003 || (_path5003 = /*#__PURE__*/React.createElement("path", {
    d: "M23 72h-1v-1h1z",
    fill: "#8d502a"
  })), _path5004 || (_path5004 = /*#__PURE__*/React.createElement("path", {
    d: "M23 72v-1h1v1z",
    fill: "#844421"
  })), _path5005 || (_path5005 = /*#__PURE__*/React.createElement("path", {
    d: "M25 72h-1v-1h1z",
    fill: "#803e1c"
  })), _path5006 || (_path5006 = /*#__PURE__*/React.createElement("path", {
    d: "M26 72h-1v-1h1z",
    fill: "#823d1b"
  })), _path5007 || (_path5007 = /*#__PURE__*/React.createElement("path", {
    d: "M27 71v1h-1v-1z",
    fill: "#904c24"
  })), _path5008 || (_path5008 = /*#__PURE__*/React.createElement("path", {
    d: "M28 71v1h-1v-1z",
    fill: "#9d5a2f"
  })), _path5009 || (_path5009 = /*#__PURE__*/React.createElement("path", {
    d: "M28 71h1v1h-1z",
    fill: "#a35f32"
  })), _path5010 || (_path5010 = /*#__PURE__*/React.createElement("path", {
    d: "M30 72h-1v-1h1z",
    fill: "#9d592c"
  })), _path5011 || (_path5011 = /*#__PURE__*/React.createElement("path", {
    d: "M30 71h1v1h-1z",
    fill: "#99572d"
  })), _path5012 || (_path5012 = /*#__PURE__*/React.createElement("path", {
    d: "M32 71v1h-1v-1z",
    fill: "#9e5e36"
  })), _path5013 || (_path5013 = /*#__PURE__*/React.createElement("path", {
    d: "M33 71h1v1h-1z",
    fill: "#985c37"
  })), _path5014 || (_path5014 = /*#__PURE__*/React.createElement("path", {
    d: "M35 72h-1v-1h1z",
    fill: "#a06644"
  })), _path5015 || (_path5015 = /*#__PURE__*/React.createElement("path", {
    d: "M37 71v1h-1v-1z",
    fill: "#9c6845"
  })), _path5016 || (_path5016 = /*#__PURE__*/React.createElement("path", {
    d: "M37 72v-1h1v1z",
    fill: "#9c6443"
  })), _path5017 || (_path5017 = /*#__PURE__*/React.createElement("path", {
    d: "M39 71v1h-1v-1z",
    fill: "#ad795d"
  })), _path5018 || (_path5018 = /*#__PURE__*/React.createElement("path", {
    d: "M39 71h1v1h-1z",
    fill: "#d8ac9a"
  })), _path5019 || (_path5019 = /*#__PURE__*/React.createElement("path", {
    d: "M41 72h-1v-1h1z",
    fill: "#c59787"
  })), _path5020 || (_path5020 = /*#__PURE__*/React.createElement("path", {
    d: "M42 71v1h-1v-1z",
    fill: "#c0937f"
  })), _path5021 || (_path5021 = /*#__PURE__*/React.createElement("path", {
    d: "M44 71v1h-1v-1z",
    fill: "#85542b"
  })), _path5022 || (_path5022 = /*#__PURE__*/React.createElement("path", {
    d: "M44 72v-1h1v1z",
    fill: "#946337"
  })), _path5023 || (_path5023 = /*#__PURE__*/React.createElement("path", {
    d: "M45 71h1v1h-1z",
    fill: "#905e32"
  })), _path5024 || (_path5024 = /*#__PURE__*/React.createElement("path", {
    d: "M47 71v1h-1v-1z",
    fill: "#8f5e33"
  })), _path5025 || (_path5025 = /*#__PURE__*/React.createElement("path", {
    d: "M48 71v1h-1v-1z",
    fill: "#8c5d35"
  })), _path5026 || (_path5026 = /*#__PURE__*/React.createElement("path", {
    d: "M48 71h1v1h-1z",
    fill: "#8a5d3a"
  })), _path5027 || (_path5027 = /*#__PURE__*/React.createElement("path", {
    d: "M50 72h-1v-1h1z",
    fill: "#8e6243"
  })), _path5028 || (_path5028 = /*#__PURE__*/React.createElement("path", {
    d: "M50 71h1v1h-1z",
    fill: "#8e6245"
  })), _path5029 || (_path5029 = /*#__PURE__*/React.createElement("path", {
    d: "M52 71v1h-1v-1z",
    fill: "#8b5d40"
  })), _path5030 || (_path5030 = /*#__PURE__*/React.createElement("path", {
    d: "M53 71v1h-1v-1z",
    fill: "#8e6140"
  })), _path5031 || (_path5031 = /*#__PURE__*/React.createElement("path", {
    d: "M53 71h1v1h-1z",
    fill: "#8f623f"
  })), _path5032 || (_path5032 = /*#__PURE__*/React.createElement("path", {
    d: "M54 72v-1h1v1z",
    fill: "#8b613f"
  })), _path5033 || (_path5033 = /*#__PURE__*/React.createElement("path", {
    d: "M56 72h-1v-1h1z",
    fill: "#845b3b"
  })), _path5034 || (_path5034 = /*#__PURE__*/React.createElement("path", {
    d: "M58 71v1h-1v-1z",
    fill: "#825230"
  })), _path5035 || (_path5035 = /*#__PURE__*/React.createElement("path", {
    d: "M58 71h1v1h-1z",
    fill: "#885837"
  })), _path5036 || (_path5036 = /*#__PURE__*/React.createElement("path", {
    d: "M60 71v1h-1v-1z",
    fill: "#7f5737"
  })), _path5037 || (_path5037 = /*#__PURE__*/React.createElement("path", {
    d: "M60 72v-1h1v1z",
    fill: "#846040",
    fillOpacity: 0.831
  })), _path5038 || (_path5038 = /*#__PURE__*/React.createElement("path", {
    d: "M62 72h-1v-1h1z",
    fill: "#976d4e",
    fillOpacity: 0.937
  })), _path5039 || (_path5039 = /*#__PURE__*/React.createElement("path", {
    d: "M63 71v1h-1v-1z",
    fill: "#a87957"
  })), _path5040 || (_path5040 = /*#__PURE__*/React.createElement("path", {
    d: "M63 71h1v1h-1z",
    fill: "#905d39"
  })), _path5041 || (_path5041 = /*#__PURE__*/React.createElement("path", {
    d: "M64 71h1v1h-1z",
    fill: "#8c532e"
  })), _path5042 || (_path5042 = /*#__PURE__*/React.createElement("path", {
    d: "M65 72v-1h1v1z",
    fill: "#925833"
  })), _path5043 || (_path5043 = /*#__PURE__*/React.createElement("path", {
    d: "M68 72h-1v-1h1z",
    fill: "#b18668",
    fillOpacity: 0.878
  })), _path5044 || (_path5044 = /*#__PURE__*/React.createElement("path", {
    d: "M72 71h1v1h-1z",
    fill: "#9f7448",
    fillOpacity: 0.796
  })), _path5045 || (_path5045 = /*#__PURE__*/React.createElement("path", {
    d: "M74 72h-1v-1h1z",
    fill: "#b5814d"
  })), _path5046 || (_path5046 = /*#__PURE__*/React.createElement("path", {
    d: "M78 72v-1h1v1z",
    fill: "#a07850",
    fillOpacity: 0.655
  })), _path5047 || (_path5047 = /*#__PURE__*/React.createElement("path", {
    d: "M95 71h1v1h-1z",
    fill: "#8f654f",
    fillOpacity: 0.58
  })), _path5048 || (_path5048 = /*#__PURE__*/React.createElement("path", {
    d: "M96 72v-1h1v1z",
    fill: "#a87053"
  })), _path5049 || (_path5049 = /*#__PURE__*/React.createElement("path", {
    d: "M99 72h-1v-1h1z",
    fill: "#856b57",
    fillOpacity: 0.494
  })), _path5050 || (_path5050 = /*#__PURE__*/React.createElement("path", {
    d: "M102 71v1h-1v-1z",
    fill: "#946147",
    fillOpacity: 0.655
  })), _path5051 || (_path5051 = /*#__PURE__*/React.createElement("path", {
    d: "M103 72h-1v-1h1z",
    fill: "#a0613a"
  })), _path5052 || (_path5052 = /*#__PURE__*/React.createElement("path", {
    d: "M104 71v1h-1v-1z",
    fill: "#a66a46"
  })), _path5053 || (_path5053 = /*#__PURE__*/React.createElement("path", {
    d: "M105 72h-1v-1h1z",
    fill: "#d3926e"
  })), _path5054 || (_path5054 = /*#__PURE__*/React.createElement("path", {
    d: "M105 71h1v1h-1z",
    fill: "#e19d75"
  })), _path5055 || (_path5055 = /*#__PURE__*/React.createElement("path", {
    d: "M107 71v1h-1v-1z",
    fill: "#cd906c",
    fillOpacity: 0.902
  })), _path5056 || (_path5056 = /*#__PURE__*/React.createElement("path", {
    d: "M108 72h-1v-1h1z",
    fill: "#c08a68",
    fillOpacity: 0.498
  })), _path5057 || (_path5057 = /*#__PURE__*/React.createElement("path", {
    d: "M108 71h1v1h-1z",
    fill: "#a17550",
    fillOpacity: 0.655
  })), _path5058 || (_path5058 = /*#__PURE__*/React.createElement("path", {
    d: "M109 72v-1h1v1z",
    fill: "#a07248"
  })), _path5059 || (_path5059 = /*#__PURE__*/React.createElement("path", {
    d: "M110 72v-1h1v1z",
    fill: "#7f5d33"
  })), _path5060 || (_path5060 = /*#__PURE__*/React.createElement("path", {
    d: "M112 72h-1v-1h1z",
    fill: "#bd864b"
  })), _path5061 || (_path5061 = /*#__PURE__*/React.createElement("path", {
    d: "M112 71h1v1h-1z",
    fill: "#f2a963"
  })), _path5062 || (_path5062 = /*#__PURE__*/React.createElement("path", {
    d: "M114 72h-1v-1h1z",
    fill: "#d79e6e",
    fillOpacity: 0.353
  })), _path5063 || (_path5063 = /*#__PURE__*/React.createElement("path", {
    d: "M117 72h-1v-1h1z",
    fill: "#87625d",
    fillOpacity: 0.192
  })), _path5064 || (_path5064 = /*#__PURE__*/React.createElement("path", {
    d: "M117 71h1v1h-1z",
    fill: "#945d42",
    fillOpacity: 0.976
  })), _path5065 || (_path5065 = /*#__PURE__*/React.createElement("path", {
    d: "M118 72v-1h1v1z",
    fill: "#b57e5a"
  })), _path5066 || (_path5066 = /*#__PURE__*/React.createElement("path", {
    d: "M119 71h1v1h-1z",
    fill: "#be8a68"
  })), _path5067 || (_path5067 = /*#__PURE__*/React.createElement("path", {
    d: "M121 71v1h-1v-1z",
    fill: "#b1815e",
    fillOpacity: 0.89
  })), _path5068 || (_path5068 = /*#__PURE__*/React.createElement("path", {
    d: "M121 72v-1h1v1z",
    fill: "#9b7f63",
    fillOpacity: 0.071
  })), _path5069 || (_path5069 = /*#__PURE__*/React.createElement("path", {
    d: "M9 73v-1h1v1z",
    fill: "#ac7d5b",
    fillOpacity: 0.643
  })), _path5070 || (_path5070 = /*#__PURE__*/React.createElement("path", {
    d: "M10 72h1v1h-1z",
    fill: "#c28b64"
  })), _path5071 || (_path5071 = /*#__PURE__*/React.createElement("path", {
    d: "M12 72v1h-1v-1z",
    fill: "#995c30"
  })), _path5072 || (_path5072 = /*#__PURE__*/React.createElement("path", {
    d: "M12 72h1v1h-1z",
    fill: "#ae6d43"
  })), _path5073 || (_path5073 = /*#__PURE__*/React.createElement("path", {
    d: "M14 72v1h-1v-1z",
    fill: "#b07047"
  })), _path5074 || (_path5074 = /*#__PURE__*/React.createElement("path", {
    d: "M15 73h-1v-1h1z",
    fill: "#b17249"
  })), _path5075 || (_path5075 = /*#__PURE__*/React.createElement("path", {
    d: "M16 73h-1v-1h1z",
    fill: "#b3764b"
  })), _path5076 || (_path5076 = /*#__PURE__*/React.createElement("path", {
    d: "M16 73v-1h1v1z",
    fill: "#b6794f"
  })), _path5077 || (_path5077 = /*#__PURE__*/React.createElement("path", {
    d: "M18 73h-1v-1h1z",
    fill: "#b97c53"
  })), _path5078 || (_path5078 = /*#__PURE__*/React.createElement("path", {
    d: "M19 72v1h-1v-1z",
    fill: "#bc8057"
  })), _path5079 || (_path5079 = /*#__PURE__*/React.createElement("path", {
    d: "M20 73h-1v-1h1z",
    fill: "#b97e54"
  })), _path5080 || (_path5080 = /*#__PURE__*/React.createElement("path", {
    d: "M21 73h-1v-1h1z",
    fill: "#b98056"
  })), _path5081 || (_path5081 = /*#__PURE__*/React.createElement("path", {
    d: "M22 73h-1v-1h1z",
    fill: "#ba8358"
  })), _path5082 || (_path5082 = /*#__PURE__*/React.createElement("path", {
    d: "M23 72v1h-1v-1z",
    fill: "#bc875b"
  })), _path5083 || (_path5083 = /*#__PURE__*/React.createElement("path", {
    d: "M23 72h1v1h-1z",
    fill: "#ba8359"
  })), _path5084 || (_path5084 = /*#__PURE__*/React.createElement("path", {
    d: "M24 73v-1h1v1z",
    fill: "#b57b54"
  })), _path5085 || (_path5085 = /*#__PURE__*/React.createElement("path", {
    d: "M25 73v-1h1v1z",
    fill: "#a76e48"
  })), _path5086 || (_path5086 = /*#__PURE__*/React.createElement("path", {
    d: "M26 73v-1h1v1z",
    fill: "#995f3a"
  })), _path5087 || (_path5087 = /*#__PURE__*/React.createElement("path", {
    d: "M27 72h1v1h-1z",
    fill: "#8e562e"
  })), _path5088 || (_path5088 = /*#__PURE__*/React.createElement("path", {
    d: "M29 72v1h-1v-1z",
    fill: "#864c24"
  })), _path5089 || (_path5089 = /*#__PURE__*/React.createElement("path", {
    d: "M30 73h-1v-1h1z",
    fill: "#82441f"
  })), _path5090 || (_path5090 = /*#__PURE__*/React.createElement("path", {
    d: "M30 72h1v1h-1z",
    fill: "#824422"
  })), _path5091 || (_path5091 = /*#__PURE__*/React.createElement("path", {
    d: "M32 73h-1v-1h1z",
    fill: "#8e502d"
  })), _path5092 || (_path5092 = /*#__PURE__*/React.createElement("path", {
    d: "M33 73h-1v-1h1z",
    fill: "#965736"
  })), _path5093 || (_path5093 = /*#__PURE__*/React.createElement("path", {
    d: "M34 72v1h-1v-1z",
    fill: "#9a5a3b"
  })), _path5094 || (_path5094 = /*#__PURE__*/React.createElement("path", {
    d: "M35 73h-1v-1h1z",
    fill: "#a4654b"
  })), _path5095 || (_path5095 = /*#__PURE__*/React.createElement("path", {
    d: "M36 72v1h-1v-1z",
    fill: "#a6694f"
  })), _path5096 || (_path5096 = /*#__PURE__*/React.createElement("path", {
    d: "M36 72h1v1h-1z",
    fill: "#a96e50"
  })), _path5097 || (_path5097 = /*#__PURE__*/React.createElement("path", {
    d: "M37 72h1v1h-1z",
    fill: "#a96c4f"
  })), _path5098 || (_path5098 = /*#__PURE__*/React.createElement("path", {
    d: "M38 73v-1h1v1z",
    fill: "#bc866b"
  })), _path5099 || (_path5099 = /*#__PURE__*/React.createElement("path", {
    d: "M39 72h1v1h-1z",
    fill: "#d8aa97"
  })), _path5100 || (_path5100 = /*#__PURE__*/React.createElement("path", {
    d: "M40 73v-1h1v1z",
    fill: "#c69685"
  })), _path5101 || (_path5101 = /*#__PURE__*/React.createElement("path", {
    d: "M41 72h1v1h-1z",
    fill: "#c69887"
  })), _path5102 || (_path5102 = /*#__PURE__*/React.createElement("path", {
    d: "M43 73h-1v-1h1z",
    fill: "#906045"
  })), _path5103 || (_path5103 = /*#__PURE__*/React.createElement("path", {
    d: "M43 73v-1h1v1z",
    fill: "#64351a"
  })), _path5104 || (_path5104 = /*#__PURE__*/React.createElement("path", {
    d: "M44 72h1v1h-1z",
    fill: "#51250c"
  })), _path5105 || (_path5105 = /*#__PURE__*/React.createElement("path", {
    d: "M45 73v-1h1v1z",
    fill: "#693d1b"
  })), _path5106 || (_path5106 = /*#__PURE__*/React.createElement("path", {
    d: "M47 72v1h-1v-1z",
    fill: "#815432"
  })), _path5107 || (_path5107 = /*#__PURE__*/React.createElement("path", {
    d: "M47 73v-1h1v1z",
    fill: "#86593c"
  })), _path5108 || (_path5108 = /*#__PURE__*/React.createElement("path", {
    d: "M49 72v1h-1v-1z",
    fill: "#90634b"
  })), _path5109 || (_path5109 = /*#__PURE__*/React.createElement("path", {
    d: "M50 72v1h-1v-1z",
    fill: "#92664d"
  })), _path5110 || (_path5110 = /*#__PURE__*/React.createElement("path", {
    d: "M51 73h-1v-1h1z",
    fill: "#8e6246"
  })), _path5111 || (_path5111 = /*#__PURE__*/React.createElement("path", {
    d: "M52 73h-1v-1h1z",
    fill: "#926545"
  })), _path5112 || (_path5112 = /*#__PURE__*/React.createElement("path", {
    d: "M53 73h-1v-1h1z",
    fill: "#956844"
  })), _path5113 || (_path5113 = /*#__PURE__*/React.createElement("path", {
    d: "M54 72v1h-1v-1z",
    fill: "#91623d"
  })), _path5114 || (_path5114 = /*#__PURE__*/React.createElement("path", {
    d: "M55 72h1v1h-1z",
    fill: "#86562f"
  })), _path5115 || (_path5115 = /*#__PURE__*/React.createElement("path", {
    d: "M57 73v-1h1v1z",
    fill: "#7a5132",
    fillOpacity: 0.976
  })), _path5116 || (_path5116 = /*#__PURE__*/React.createElement("path", {
    d: "M59 73h-1v-1h1z",
    fill: "#7b553a",
    fillOpacity: 0.714
  })), _path5117 || (_path5117 = /*#__PURE__*/React.createElement("path", {
    d: "M59 72h1v1h-1z",
    fill: "#765842",
    fillOpacity: 0.329
  })), _path5118 || (_path5118 = /*#__PURE__*/React.createElement("path", {
    d: "M60 72h1v1h-1z",
    fill: "#757589",
    fillOpacity: 0.051
  })), _path5119 || (_path5119 = /*#__PURE__*/React.createElement("path", {
    d: "M62 72v1h-1v-1z",
    fill: "#926d52",
    fillOpacity: 0.776
  })), _path5120 || (_path5120 = /*#__PURE__*/React.createElement("path", {
    d: "M63 72v1h-1v-1z",
    fill: "#a87651"
  })), _path5121 || (_path5121 = /*#__PURE__*/React.createElement("path", {
    d: "M64 72v1h-1v-1z",
    fill: "#925a36"
  })), _path5122 || (_path5122 = /*#__PURE__*/React.createElement("path", {
    d: "M64 73v-1h1v1z",
    fill: "#8f542e"
  })), _path5123 || (_path5123 = /*#__PURE__*/React.createElement("path", {
    d: "M65 72h1v1h-1z",
    fill: "#915731"
  })), _path5124 || (_path5124 = /*#__PURE__*/React.createElement("path", {
    d: "M66 72h1v1h-1z",
    fill: "#b27e5b"
  })), _path5125 || (_path5125 = /*#__PURE__*/React.createElement("path", {
    d: "M67 73v-1h1v1z",
    fill: "#b18767",
    fillOpacity: 0.878
  })), _path5126 || (_path5126 = /*#__PURE__*/React.createElement("path", {
    d: "M72 73v-1h1v1z",
    fill: "#997246",
    fillOpacity: 0.761
  })), _path5127 || (_path5127 = /*#__PURE__*/React.createElement("path", {
    d: "M74 72v1h-1v-1z",
    fill: "#b3804d"
  })), _path5128 || (_path5128 = /*#__PURE__*/React.createElement("path", {
    d: "M76 72v1h-1v-1z",
    fill: "#b18155"
  })), _path5129 || (_path5129 = /*#__PURE__*/React.createElement("path", {
    d: "M77 73v-1h1v1z",
    fill: "#aa7a46"
  })), _path5130 || (_path5130 = /*#__PURE__*/React.createElement("path", {
    d: "M79 72v1h-1v-1z",
    fill: "#9b744a",
    fillOpacity: 0.616
  })), _path5131 || (_path5131 = /*#__PURE__*/React.createElement("path", {
    d: "M96 72v1h-1v-1z",
    fill: "#8e644d",
    fillOpacity: 0.518
  })), _path5132 || (_path5132 = /*#__PURE__*/React.createElement("path", {
    d: "M96 73v-1h1v1z",
    fill: "#a67153"
  })), _path5133 || (_path5133 = /*#__PURE__*/React.createElement("path", {
    d: "M98 72v1h-1v-1z",
    fill: "#a16e51"
  })), _path5134 || (_path5134 = /*#__PURE__*/React.createElement("path", {
    d: "M98 73v-1h1v1z",
    fill: "#886955",
    fillOpacity: 0.549
  })), _path5135 || (_path5135 = /*#__PURE__*/React.createElement("path", {
    d: "M101 72h1v1h-1z",
    fill: "#976248",
    fillOpacity: 0.714
  })), _path5136 || (_path5136 = /*#__PURE__*/React.createElement("path", {
    d: "M103 72v1h-1v-1z",
    fill: "#9f613f"
  })), _path5137 || (_path5137 = /*#__PURE__*/React.createElement("path", {
    d: "M103 72h1v1h-1z",
    fill: "#ab6b44"
  })), _path5138 || (_path5138 = /*#__PURE__*/React.createElement("path", {
    d: "M104 72h1v1h-1z",
    fill: "#d8956d"
  })), _path5139 || (_path5139 = /*#__PURE__*/React.createElement("path", {
    d: "M106 73h-1v-1h1z",
    fill: "#c99677",
    fillOpacity: 0.525
  })), _path5140 || (_path5140 = /*#__PURE__*/React.createElement("path", {
    d: "M107 73h-1v-1h1z",
    fill: "#a5997f",
    fillOpacity: 0.078
  })), _path5141 || (_path5141 = /*#__PURE__*/React.createElement("path", {
    d: "M109 72v1h-1v-1z",
    fill: "#977657",
    fillOpacity: 0.514
  })), _path5142 || (_path5142 = /*#__PURE__*/React.createElement("path", {
    d: "M110 72v1h-1v-1z",
    fill: "#a27246"
  })), _path5143 || (_path5143 = /*#__PURE__*/React.createElement("path", {
    d: "M110 73v-1h1v1z",
    fill: "#805d30"
  })), _path5144 || (_path5144 = /*#__PURE__*/React.createElement("path", {
    d: "M111 73v-1h1v1z",
    fill: "#bc844a"
  })), _path5145 || (_path5145 = /*#__PURE__*/React.createElement("path", {
    d: "M112 72h1v1h-1z",
    fill: "#f2aa65"
  })), _path5146 || (_path5146 = /*#__PURE__*/React.createElement("path", {
    d: "M114 73h-1v-1h1z",
    fill: "#d6a674",
    fillOpacity: 0.318
  })), _path5147 || (_path5147 = /*#__PURE__*/React.createElement("path", {
    d: "M117 72v1h-1v-1z",
    fill: "#8c665f",
    fillOpacity: 0.157
  })), _path5148 || (_path5148 = /*#__PURE__*/React.createElement("path", {
    d: "M117 73v-1h1v1z",
    fill: "#915c40",
    fillOpacity: 0.961
  })), _path5149 || (_path5149 = /*#__PURE__*/React.createElement("path", {
    d: "M119 72v1h-1v-1z",
    fill: "#b17a56"
  })), _path5150 || (_path5150 = /*#__PURE__*/React.createElement("path", {
    d: "M120 72v1h-1v-1z",
    fill: "#bc8967"
  })), _path5151 || (_path5151 = /*#__PURE__*/React.createElement("path", {
    d: "M120 73v-1h1v1z",
    fill: "#b2815f",
    fillOpacity: 0.902
  })), _path5152 || (_path5152 = /*#__PURE__*/React.createElement("path", {
    d: "M122 73h-1v-1h1z",
    fill: "#997266",
    fillOpacity: 0.078
  })), _path5153 || (_path5153 = /*#__PURE__*/React.createElement("path", {
    d: "M9 73h1v1H9z",
    fill: "#a97c5c",
    fillOpacity: 0.596
  })), _path5154 || (_path5154 = /*#__PURE__*/React.createElement("path", {
    d: "M10 73h1v1h-1z",
    fill: "#c18963"
  })), _path5155 || (_path5155 = /*#__PURE__*/React.createElement("path", {
    d: "M12 74h-1v-1h1z",
    fill: "#985c31"
  })), _path5156 || (_path5156 = /*#__PURE__*/React.createElement("path", {
    d: "M12 73h1v1h-1z",
    fill: "#ac6b3e"
  })), _path5157 || (_path5157 = /*#__PURE__*/React.createElement("path", {
    d: "M13 74v-1h1v1z",
    fill: "#b37144"
  })), _path5158 || (_path5158 = /*#__PURE__*/React.createElement("path", {
    d: "M14 73h1v1h-1z",
    fill: "#b57747"
  })), _path5159 || (_path5159 = /*#__PURE__*/React.createElement("path", {
    d: "M15 74v-1h1v1z",
    fill: "#ba7c4d"
  })), _path5160 || (_path5160 = /*#__PURE__*/React.createElement("path", {
    d: "M17 74h-1v-1h1z",
    fill: "#bd8154"
  })), _path5161 || (_path5161 = /*#__PURE__*/React.createElement("path", {
    d: "M18 73v1h-1v-1z",
    fill: "#bd8258"
  })), _path5162 || (_path5162 = /*#__PURE__*/React.createElement("path", {
    d: "M19 74h-1v-1h1z",
    fill: "#c18459"
  })), _path5163 || (_path5163 = /*#__PURE__*/React.createElement("path", {
    d: "M19 73h1v1h-1z",
    fill: "#bf8256"
  })), _path5164 || (_path5164 = /*#__PURE__*/React.createElement("path", {
    d: "M20 74v-1h1v1z",
    fill: "#bd7e52"
  })), _path5165 || (_path5165 = /*#__PURE__*/React.createElement("path", {
    d: "M22 73v1h-1v-1z",
    fill: "#b8794e"
  })), _path5166 || (_path5166 = /*#__PURE__*/React.createElement("path", {
    d: "M22 73h1v1h-1z",
    fill: "#b47b4e"
  })), _path5167 || (_path5167 = /*#__PURE__*/React.createElement("path", {
    d: "M24 74h-1v-1h1z",
    fill: "#b87d51"
  })), _path5168 || (_path5168 = /*#__PURE__*/React.createElement("path", {
    d: "M25 73v1h-1v-1z",
    fill: "#be8155"
  })), _path5169 || (_path5169 = /*#__PURE__*/React.createElement("path", {
    d: "M26 74h-1v-1h1z",
    fill: "#c3875b"
  })), _path5170 || (_path5170 = /*#__PURE__*/React.createElement("path", {
    d: "M26 73h1v1h-1z",
    fill: "#c4885e"
  })), _path5171 || (_path5171 = /*#__PURE__*/React.createElement("path", {
    d: "M28 74h-1v-1h1z",
    fill: "#c58b5f"
  })), _path5172 || (_path5172 = /*#__PURE__*/React.createElement("path", {
    d: "M28 73h1v1h-1z",
    fill: "#c2885d"
  })), _path5173 || (_path5173 = /*#__PURE__*/React.createElement("path", {
    d: "M30 73v1h-1v-1z",
    fill: "#bd845d"
  })), _path5174 || (_path5174 = /*#__PURE__*/React.createElement("path", {
    d: "M30 74v-1h1v1z",
    fill: "#af7652"
  })), _path5175 || (_path5175 = /*#__PURE__*/React.createElement("path", {
    d: "M32 74h-1v-1h1z",
    fill: "#9f6643"
  })), _path5176 || (_path5176 = /*#__PURE__*/React.createElement("path", {
    d: "M33 73v1h-1v-1z",
    fill: "#8e5634"
  })), _path5177 || (_path5177 = /*#__PURE__*/React.createElement("path", {
    d: "M33 74v-1h1v1z",
    fill: "#7e4929"
  })), _path5178 || (_path5178 = /*#__PURE__*/React.createElement("path", {
    d: "M35 73v1h-1v-1z",
    fill: "#743f21"
  })), _path5179 || (_path5179 = /*#__PURE__*/React.createElement("path", {
    d: "M35 74v-1h1v1z",
    fill: "#6b361d"
  })), _path5180 || (_path5180 = /*#__PURE__*/React.createElement("path", {
    d: "M36 73h1v1h-1z",
    fill: "#6b351c"
  })), _path5181 || (_path5181 = /*#__PURE__*/React.createElement("path", {
    d: "M38 73v1h-1v-1z",
    fill: "#703722"
  })), _path5182 || (_path5182 = /*#__PURE__*/React.createElement("path", {
    d: "M39 73v1h-1v-1z",
    fill: "#96624e"
  })), _path5183 || (_path5183 = /*#__PURE__*/React.createElement("path", {
    d: "M39 74v-1h1v1z",
    fill: "#daad9c"
  })), _path5184 || (_path5184 = /*#__PURE__*/React.createElement("path", {
    d: "M40 73h1v1h-1z",
    fill: "#c79685"
  })), _path5185 || (_path5185 = /*#__PURE__*/React.createElement("path", {
    d: "M42 73v1h-1v-1z",
    fill: "#c59786"
  })), _path5186 || (_path5186 = /*#__PURE__*/React.createElement("path", {
    d: "M43 74h-1v-1h1z",
    fill: "#916249"
  })), _path5187 || (_path5187 = /*#__PURE__*/React.createElement("path", {
    d: "M44 74h-1v-1h1z",
    fill: "#5e321d"
  })), _path5188 || (_path5188 = /*#__PURE__*/React.createElement("path", {
    d: "M44 74v-1h1v1z",
    fill: "#47200c"
  })), _path5189 || (_path5189 = /*#__PURE__*/React.createElement("path", {
    d: "M45 73h1v1h-1z",
    fill: "#623e1e"
  })), _path5190 || (_path5190 = /*#__PURE__*/React.createElement("path", {
    d: "M47 73v1h-1v-1z",
    fill: "#7d5637"
  })), _path5191 || (_path5191 = /*#__PURE__*/React.createElement("path", {
    d: "M48 74h-1v-1h1z",
    fill: "#865c40"
  })), _path5192 || (_path5192 = /*#__PURE__*/React.createElement("path", {
    d: "M49 74v-1h1v1z",
    fill: "#926548"
  })), _path5193 || (_path5193 = /*#__PURE__*/React.createElement("path", {
    d: "M51 73v1h-1v-1z",
    fill: "#946748"
  })), _path5194 || (_path5194 = /*#__PURE__*/React.createElement("path", {
    d: "M51 74v-1h1v1z",
    fill: "#936645"
  })), _path5195 || (_path5195 = /*#__PURE__*/React.createElement("path", {
    d: "M53 74h-1v-1h1z",
    fill: "#91613d"
  })), _path5196 || (_path5196 = /*#__PURE__*/React.createElement("path", {
    d: "M55 74h-1v-1h1z",
    fill: "#8a5c33"
  })), _path5197 || (_path5197 = /*#__PURE__*/React.createElement("path", {
    d: "M56 74h-1v-1h1z",
    fill: "#7d5430",
    fillOpacity: 0.898
  })), _path5198 || (_path5198 = /*#__PURE__*/React.createElement("path", {
    d: "M57 73v1h-1v-1z",
    fill: "#765236",
    fillOpacity: 0.584
  })), _path5199 || (_path5199 = /*#__PURE__*/React.createElement("path", {
    d: "M57 73h1v1h-1z",
    fill: "#715946",
    fillOpacity: 0.212
  })), _path5200 || (_path5200 = /*#__PURE__*/React.createElement("path", {
    d: "M62 73v1h-1v-1z",
    fill: "#916b4b",
    fillOpacity: 0.765
  })), _path5201 || (_path5201 = /*#__PURE__*/React.createElement("path", {
    d: "M63 74h-1v-1h1z",
    fill: "#a8744e"
  })), _path5202 || (_path5202 = /*#__PURE__*/React.createElement("path", {
    d: "M65 74h-1v-1h1z",
    fill: "#8f5532"
  })), _path5203 || (_path5203 = /*#__PURE__*/React.createElement("path", {
    d: "M66 73v1h-1v-1z",
    fill: "#8e5530"
  })), _path5204 || (_path5204 = /*#__PURE__*/React.createElement("path", {
    d: "M67 74h-1v-1h1z",
    fill: "#b07e59"
  })), _path5205 || (_path5205 = /*#__PURE__*/React.createElement("path", {
    d: "M73 74h-1v-1h1z",
    fill: "#997147",
    fillOpacity: 0.737
  })), _path5206 || (_path5206 = /*#__PURE__*/React.createElement("path", {
    d: "M75 74h-1v-1h1z",
    fill: "#b98a5a"
  })), _path5207 || (_path5207 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74h-1v-1h1z",
    fill: "#a0703f"
  })), _path5208 || (_path5208 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74v-1h1v1z",
    fill: "#b07f4d"
  })), _path5209 || (_path5209 = /*#__PURE__*/React.createElement("path", {
    d: "M78 74v-1h1v1z",
    fill: "#a07852",
    fillOpacity: 0.58
  })), _path5210 || (_path5210 = /*#__PURE__*/React.createElement("path", {
    d: "M95 74v-1h1v1z",
    fill: "#87644c",
    fillOpacity: 0.486
  })), _path5211 || (_path5211 = /*#__PURE__*/React.createElement("path", {
    d: "M97 73v1h-1v-1z",
    fill: "#a06e4e"
  })), _path5212 || (_path5212 = /*#__PURE__*/React.createElement("path", {
    d: "M99 73v1h-1v-1z",
    fill: "#8c6c57",
    fillOpacity: 0.62
  })), _path5213 || (_path5213 = /*#__PURE__*/React.createElement("path", {
    d: "M102 73v1h-1v-1z",
    fill: "#956046",
    fillOpacity: 0.784
  })), _path5214 || (_path5214 = /*#__PURE__*/React.createElement("path", {
    d: "M102 73h1v1h-1z",
    fill: "#9e603d"
  })), _path5215 || (_path5215 = /*#__PURE__*/React.createElement("path", {
    d: "M104 74h-1v-1h1z",
    fill: "#ae6e47"
  })), _path5216 || (_path5216 = /*#__PURE__*/React.createElement("path", {
    d: "M105 74h-1v-1h1z",
    fill: "#cf9471",
    fillOpacity: 0.992
  })), _path5217 || (_path5217 = /*#__PURE__*/React.createElement("path", {
    d: "M105 74v-1h1v1z",
    fill: "#c09981",
    fillOpacity: 0.208
  })), _path5218 || (_path5218 = /*#__PURE__*/React.createElement("path", {
    d: "M108 73h1v1h-1z",
    fill: "#987655",
    fillOpacity: 0.506
  })), _path5219 || (_path5219 = /*#__PURE__*/React.createElement("path", {
    d: "M109 73h1v1h-1z",
    fill: "#9e7246"
  })), _path5220 || (_path5220 = /*#__PURE__*/React.createElement("path", {
    d: "M110 73h1v1h-1z",
    fill: "#805d35"
  })), _path5221 || (_path5221 = /*#__PURE__*/React.createElement("path", {
    d: "M112 73v1h-1v-1z",
    fill: "#bd8349"
  })), _path5222 || (_path5222 = /*#__PURE__*/React.createElement("path", {
    d: "M112 73h1v1h-1z",
    fill: "#f7af6b"
  })), _path5223 || (_path5223 = /*#__PURE__*/React.createElement("path", {
    d: "M113 74v-1h1v1z",
    fill: "#daaf7a",
    fillOpacity: 0.302
  })), _path5224 || (_path5224 = /*#__PURE__*/React.createElement("path", {
    d: "M117 73v1h-1v-1z",
    fill: "#8b6262",
    fillOpacity: 0.122
  })), _path5225 || (_path5225 = /*#__PURE__*/React.createElement("path", {
    d: "M118 74h-1v-1h1z",
    fill: "#915b41",
    fillOpacity: 0.937
  })), _path5226 || (_path5226 = /*#__PURE__*/React.createElement("path", {
    d: "M119 73v1h-1v-1z",
    fill: "#ad7753"
  })), _path5227 || (_path5227 = /*#__PURE__*/React.createElement("path", {
    d: "M121 74h-1v-1h1z",
    fill: "#b38160",
    fillOpacity: 0.91
  })), _path5228 || (_path5228 = /*#__PURE__*/React.createElement("path", {
    d: "M122 74h-1v-1h1z",
    fill: "#916d61",
    fillOpacity: 0.082
  })), _path5229 || (_path5229 = /*#__PURE__*/React.createElement("path", {
    d: "M10 75H9v-1h1z",
    fill: "#a57a5b",
    fillOpacity: 0.537
  })), _path5230 || (_path5230 = /*#__PURE__*/React.createElement("path", {
    d: "M10 74h1v1h-1z",
    fill: "#c08761"
  })), _path5231 || (_path5231 = /*#__PURE__*/React.createElement("path", {
    d: "M12 74v1h-1v-1z",
    fill: "#9c5f38"
  })), _path5232 || (_path5232 = /*#__PURE__*/React.createElement("path", {
    d: "M12 75v-1h1v1z",
    fill: "#985b30"
  })), _path5233 || (_path5233 = /*#__PURE__*/React.createElement("path", {
    d: "M14 74v1h-1v-1z",
    fill: "#9e5e31"
  })), _path5234 || (_path5234 = /*#__PURE__*/React.createElement("path", {
    d: "M15 75h-1v-1h1z",
    fill: "#a36534"
  })), _path5235 || (_path5235 = /*#__PURE__*/React.createElement("path", {
    d: "M15 74h1v1h-1z",
    fill: "#b17047"
  })), _path5236 || (_path5236 = /*#__PURE__*/React.createElement("path", {
    d: "M17 74v1h-1v-1z",
    fill: "#b87a4a"
  })), _path5237 || (_path5237 = /*#__PURE__*/React.createElement("path", {
    d: "M17 75v-1h1v1z",
    fill: "#bb8152"
  })), _path5238 || (_path5238 = /*#__PURE__*/React.createElement("path", {
    d: "M18 74h1v1h-1z",
    fill: "#bf8759"
  })), _path5239 || (_path5239 = /*#__PURE__*/React.createElement("path", {
    d: "M19 75v-1h1v1z",
    fill: "#c18a5f"
  })), _path5240 || (_path5240 = /*#__PURE__*/React.createElement("path", {
    d: "M21 75v-1h1v1z",
    fill: "#bd855d"
  })), _path5241 || (_path5241 = /*#__PURE__*/React.createElement("path", {
    d: "M23 75h-1v-1h1z",
    fill: "#be875d"
  })), _path5242 || (_path5242 = /*#__PURE__*/React.createElement("path", {
    d: "M24 74v1h-1v-1z",
    fill: "#c1865c"
  })), _path5243 || (_path5243 = /*#__PURE__*/React.createElement("path", {
    d: "M24 74h1v1h-1z",
    fill: "#c2855a"
  })), _path5244 || (_path5244 = /*#__PURE__*/React.createElement("path", {
    d: "M27 75h-1v-1h1z",
    fill: "#bd8256"
  })), _path5245 || (_path5245 = /*#__PURE__*/React.createElement("path", {
    d: "M28 74h1v1h-1z",
    fill: "#bf8357"
  })), _path5246 || (_path5246 = /*#__PURE__*/React.createElement("path", {
    d: "M29 75v-1h1v1z",
    fill: "#c4895f"
  })), _path5247 || (_path5247 = /*#__PURE__*/React.createElement("path", {
    d: "M30 74h1v1h-1z",
    fill: "#c88f69"
  })), _path5248 || (_path5248 = /*#__PURE__*/React.createElement("path", {
    d: "M32 74v1h-1v-1z",
    fill: "#ca936d"
  })), _path5249 || (_path5249 = /*#__PURE__*/React.createElement("path", {
    d: "M32 74h1v1h-1z",
    fill: "#cd986f"
  })), _path5250 || (_path5250 = /*#__PURE__*/React.createElement("path", {
    d: "M34 74v1h-1v-1z",
    fill: "#cc976b"
  })), _path5251 || (_path5251 = /*#__PURE__*/React.createElement("path", {
    d: "M34 74h1v1h-1z",
    fill: "#c08d5e"
  })), _path5252 || (_path5252 = /*#__PURE__*/React.createElement("path", {
    d: "M35 74h1v1h-1z",
    fill: "#b17d50"
  })), _path5253 || (_path5253 = /*#__PURE__*/React.createElement("path", {
    d: "M36 75v-1h1v1z",
    fill: "#a26b42"
  })), _path5254 || (_path5254 = /*#__PURE__*/React.createElement("path", {
    d: "M38 75h-1v-1h1z",
    fill: "#8c5834"
  })), _path5255 || (_path5255 = /*#__PURE__*/React.createElement("path", {
    d: "M39 75h-1v-1h1z",
    fill: "#9d6c50"
  })), _path5256 || (_path5256 = /*#__PURE__*/React.createElement("path", {
    d: "M39 74h1v1h-1z",
    fill: "#d7a998"
  })), _path5257 || (_path5257 = /*#__PURE__*/React.createElement("path", {
    d: "M41 74v1h-1v-1z",
    fill: "#c29386"
  })), _path5258 || (_path5258 = /*#__PURE__*/React.createElement("path", {
    d: "M42 74v1h-1v-1z",
    fill: "#c09384"
  })), _path5259 || (_path5259 = /*#__PURE__*/React.createElement("path", {
    d: "M43 74v1h-1v-1z",
    fill: "#976751"
  })), _path5260 || (_path5260 = /*#__PURE__*/React.createElement("path", {
    d: "M43 74h1v1h-1z",
    fill: "#7d523c"
  })), _path5261 || (_path5261 = /*#__PURE__*/React.createElement("path", {
    d: "M45 75h-1v-1h1z",
    fill: "#704830"
  })), _path5262 || (_path5262 = /*#__PURE__*/React.createElement("path", {
    d: "M45 74h1v1h-1z",
    fill: "#7e573a"
  })), _path5263 || (_path5263 = /*#__PURE__*/React.createElement("path", {
    d: "M46 74h1v1h-1z",
    fill: "#8c6248"
  })), _path5264 || (_path5264 = /*#__PURE__*/React.createElement("path", {
    d: "M48 74v1h-1v-1z",
    fill: "#94674d"
  })), _path5265 || (_path5265 = /*#__PURE__*/React.createElement("path", {
    d: "M49 74h1v1h-1z",
    fill: "#8f6443"
  })), _path5266 || (_path5266 = /*#__PURE__*/React.createElement("path", {
    d: "M50 75v-1h1v1z",
    fill: "#946340"
  })), _path5267 || (_path5267 = /*#__PURE__*/React.createElement("path", {
    d: "M52 75v-1h1v1z",
    fill: "#8c5c3b"
  })), _path5268 || (_path5268 = /*#__PURE__*/React.createElement("path", {
    d: "M53 74h1v1h-1z",
    fill: "#825a3b",
    fillOpacity: 0.796
  })), _path5269 || (_path5269 = /*#__PURE__*/React.createElement("path", {
    d: "M55 74v1h-1v-1z",
    fill: "#795b3c",
    fillOpacity: 0.427
  })), _path5270 || (_path5270 = /*#__PURE__*/React.createElement("path", {
    d: "M62 75h-1v-1h1z",
    fill: "#8f694a",
    fillOpacity: 0.737
  })), _path5271 || (_path5271 = /*#__PURE__*/React.createElement("path", {
    d: "M63 75h-1v-1h1z",
    fill: "#a6734d"
  })), _path5272 || (_path5272 = /*#__PURE__*/React.createElement("path", {
    d: "M63 75v-1h1v1z",
    fill: "#905937"
  })), _path5273 || (_path5273 = /*#__PURE__*/React.createElement("path", {
    d: "M67 75h-1v-1h1z",
    fill: "#af7f59"
  })), _path5274 || (_path5274 = /*#__PURE__*/React.createElement("path", {
    d: "M73 75h-1v-1h1z",
    fill: "#9a724c",
    fillOpacity: 0.71
  })), _path5275 || (_path5275 = /*#__PURE__*/React.createElement("path", {
    d: "M74 75v-1h1v1z",
    fill: "#b9895b"
  })), _path5276 || (_path5276 = /*#__PURE__*/React.createElement("path", {
    d: "M75 75v-1h1v1z",
    fill: "#b18154"
  })), _path5277 || (_path5277 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74v1h-1v-1z",
    fill: "#a17141"
  })), _path5278 || (_path5278 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74h1v1h-1z",
    fill: "#ba895d"
  })), _path5279 || (_path5279 = /*#__PURE__*/React.createElement("path", {
    d: "M78 74h1v1h-1z",
    fill: "#a6845f",
    fillOpacity: 0.553
  })), _path5280 || (_path5280 = /*#__PURE__*/React.createElement("path", {
    d: "M96 74v1h-1v-1z",
    fill: "#836453",
    fillOpacity: 0.42
  })), _path5281 || (_path5281 = /*#__PURE__*/React.createElement("path", {
    d: "M96 75v-1h1v1z",
    fill: "#9b6c4d"
  })), _path5282 || (_path5282 = /*#__PURE__*/React.createElement("path", {
    d: "M98 74v1h-1v-1z",
    fill: "#9d6e50"
  })), _path5283 || (_path5283 = /*#__PURE__*/React.createElement("path", {
    d: "M98 75v-1h1v1z",
    fill: "#896b55",
    fillOpacity: 0.678
  })), _path5284 || (_path5284 = /*#__PURE__*/React.createElement("path", {
    d: "M101 74v1h-1v-1z",
    fill: "#7f557f",
    fillOpacity: 0.024
  })), _path5285 || (_path5285 = /*#__PURE__*/React.createElement("path", {
    d: "M101 75v-1h1v1z",
    fill: "#966045",
    fillOpacity: 0.843
  })), _path5286 || (_path5286 = /*#__PURE__*/React.createElement("path", {
    d: "M103 74v1h-1v-1z",
    fill: "#995d3a"
  })), _path5287 || (_path5287 = /*#__PURE__*/React.createElement("path", {
    d: "M104 74v1h-1v-1z",
    fill: "#b2734d"
  })), _path5288 || (_path5288 = /*#__PURE__*/React.createElement("path", {
    d: "M105 75h-1v-1h1z",
    fill: "#d29474",
    fillOpacity: 0.961
  })), _path5289 || (_path5289 = /*#__PURE__*/React.createElement("path", {
    d: "M106 75h-1v-1h1z",
    fill: "#bd9689",
    fillOpacity: 0.153
  })), _path5290 || (_path5290 = /*#__PURE__*/React.createElement("path", {
    d: "M108 75v-1h1v1z",
    fill: "#9c785a",
    fillOpacity: 0.498
  })), _path5291 || (_path5291 = /*#__PURE__*/React.createElement("path", {
    d: "M110 74h1v1h-1z",
    fill: "#835d35"
  })), _path5292 || (_path5292 = /*#__PURE__*/React.createElement("path", {
    d: "M112 75h-1v-1h1z",
    fill: "#bf884c"
  })), _path5293 || (_path5293 = /*#__PURE__*/React.createElement("path", {
    d: "M113 75h-1v-1h1z",
    fill: "#f4af6c"
  })), _path5294 || (_path5294 = /*#__PURE__*/React.createElement("path", {
    d: "M113 75v-1h1v1z",
    fill: "#d8b17f",
    fillOpacity: 0.282
  })), _path5295 || (_path5295 = /*#__PURE__*/React.createElement("path", {
    d: "M117 75h-1v-1h1z",
    fill: "#725959",
    fillOpacity: 0.078
  })), _path5296 || (_path5296 = /*#__PURE__*/React.createElement("path", {
    d: "M118 75h-1v-1h1z",
    fill: "#905941",
    fillOpacity: 0.902
  })), _path5297 || (_path5297 = /*#__PURE__*/React.createElement("path", {
    d: "M119 75h-1v-1h1z",
    fill: "#a9724d"
  })), _path5298 || (_path5298 = /*#__PURE__*/React.createElement("path", {
    d: "M120 74v1h-1v-1z",
    fill: "#c28968"
  })), _path5299 || (_path5299 = /*#__PURE__*/React.createElement("path", {
    d: "M120 74h1v1h-1z",
    fill: "#b58264",
    fillOpacity: 0.922
  })), _path5300 || (_path5300 = /*#__PURE__*/React.createElement("path", {
    d: "M122 74v1h-1v-1z",
    fill: "#937562",
    fillOpacity: 0.102
  })), _path5301 || (_path5301 = /*#__PURE__*/React.createElement("path", {
    d: "M9 76v-1h1v1z",
    fill: "#a17655",
    fillOpacity: 0.482
  })), _path5302 || (_path5302 = /*#__PURE__*/React.createElement("path", {
    d: "M11 76h-1v-1h1z",
    fill: "#bf8660"
  })), _path5303 || (_path5303 = /*#__PURE__*/React.createElement("path", {
    d: "M11 76v-1h1v1z",
    fill: "#9f633b"
  })), _path5304 || (_path5304 = /*#__PURE__*/React.createElement("path", {
    d: "M12 75h1v1h-1z",
    fill: "#8e4a24"
  })), _path5305 || (_path5305 = /*#__PURE__*/React.createElement("path", {
    d: "M14 75v1h-1v-1z",
    fill: "#914c26"
  })), _path5306 || (_path5306 = /*#__PURE__*/React.createElement("path", {
    d: "M14 75h1v1h-1z",
    fill: "#8a5128",
    fillOpacity: 0.847
  })), _path5307 || (_path5307 = /*#__PURE__*/React.createElement("path", {
    d: "M16 75v1h-1v-1z",
    fill: "#936245",
    fillOpacity: 0.345
  })), _path5308 || (_path5308 = /*#__PURE__*/React.createElement("path", {
    d: "M16 75h1v1h-1z",
    fill: "#996645",
    fillOpacity: 0.529
  })), _path5309 || (_path5309 = /*#__PURE__*/React.createElement("path", {
    d: "M18 76h-1v-1h1z",
    fill: "#a26d4a",
    fillOpacity: 0.702
  })), _path5310 || (_path5310 = /*#__PURE__*/React.createElement("path", {
    d: "M18 76v-1h1v1z",
    fill: "#a8714c",
    fillOpacity: 0.851
  })), _path5311 || (_path5311 = /*#__PURE__*/React.createElement("path", {
    d: "M19 75h1v1h-1z",
    fill: "#b2764b",
    fillOpacity: 0.949
  })), _path5312 || (_path5312 = /*#__PURE__*/React.createElement("path", {
    d: "M20 76v-1h1v1z",
    fill: "#b7794d"
  })), _path5313 || (_path5313 = /*#__PURE__*/React.createElement("path", {
    d: "M22 76h-1v-1h1z",
    fill: "#ba7a4d"
  })), _path5314 || (_path5314 = /*#__PURE__*/React.createElement("path", {
    d: "M23 75v1h-1v-1z",
    fill: "#bb7b4c"
  })), _path5315 || (_path5315 = /*#__PURE__*/React.createElement("path", {
    d: "M23 76v-1h1v1z",
    fill: "#bd8054"
  })), _path5316 || (_path5316 = /*#__PURE__*/React.createElement("path", {
    d: "M25 76h-1v-1h1z",
    fill: "#bf8459"
  })), _path5317 || (_path5317 = /*#__PURE__*/React.createElement("path", {
    d: "M26 75h1v1h-1z",
    fill: "#c3865a"
  })), _path5318 || (_path5318 = /*#__PURE__*/React.createElement("path", {
    d: "M28 75v1h-1v-1z",
    fill: "#c4875b"
  })), _path5319 || (_path5319 = /*#__PURE__*/React.createElement("path", {
    d: "M28 76v-1h1v1z",
    fill: "#c5885d"
  })), _path5320 || (_path5320 = /*#__PURE__*/React.createElement("path", {
    d: "M30 75v1h-1v-1z",
    fill: "#c78c60"
  })), _path5321 || (_path5321 = /*#__PURE__*/React.createElement("path", {
    d: "M31 76h-1v-1h1z",
    fill: "#c68c65"
  })), _path5322 || (_path5322 = /*#__PURE__*/React.createElement("path", {
    d: "M31 75h1v1h-1z",
    fill: "#c28a63"
  })), _path5323 || (_path5323 = /*#__PURE__*/React.createElement("path", {
    d: "M33 76h-1v-1h1z",
    fill: "#c38c64"
  })), _path5324 || (_path5324 = /*#__PURE__*/React.createElement("path", {
    d: "M34 76h-1v-1h1z",
    fill: "#c38b66"
  })), _path5325 || (_path5325 = /*#__PURE__*/React.createElement("path", {
    d: "M35 75v1h-1v-1z",
    fill: "#c38c65"
  })), _path5326 || (_path5326 = /*#__PURE__*/React.createElement("path", {
    d: "M35 76v-1h1v1z",
    fill: "#c48c62"
  })), _path5327 || (_path5327 = /*#__PURE__*/React.createElement("path", {
    d: "M36 76v-1h1v1z",
    fill: "#c68c5f"
  })), _path5328 || (_path5328 = /*#__PURE__*/React.createElement("path", {
    d: "M37 75h1v1h-1z",
    fill: "#c68e5d"
  })), _path5329 || (_path5329 = /*#__PURE__*/React.createElement("path", {
    d: "M39 76h-1v-1h1z",
    fill: "#d29f79"
  })), _path5330 || (_path5330 = /*#__PURE__*/React.createElement("path", {
    d: "M40 76v-1h1v1z",
    fill: "#c59687"
  })), _path5331 || (_path5331 = /*#__PURE__*/React.createElement("path", {
    d: "M41 76v-1h1v1z",
    fill: "#bc8e7d"
  })), _path5332 || (_path5332 = /*#__PURE__*/React.createElement("path", {
    d: "M43 76h-1v-1h1z",
    fill: "#966851"
  })), _path5333 || (_path5333 = /*#__PURE__*/React.createElement("path", {
    d: "M43 75h1v1h-1z",
    fill: "#8d644e"
  })), _path5334 || (_path5334 = /*#__PURE__*/React.createElement("path", {
    d: "M45 75v1h-1v-1z",
    fill: "#926952"
  })), _path5335 || (_path5335 = /*#__PURE__*/React.createElement("path", {
    d: "M46 76h-1v-1h1z",
    fill: "#986e56"
  })), _path5336 || (_path5336 = /*#__PURE__*/React.createElement("path", {
    d: "M47 76h-1v-1h1z",
    fill: "#976c55"
  })), _path5337 || (_path5337 = /*#__PURE__*/React.createElement("path", {
    d: "M48 75v1h-1v-1z",
    fill: "#95694f"
  })), _path5338 || (_path5338 = /*#__PURE__*/React.createElement("path", {
    d: "M49 76h-1v-1h1z",
    fill: "#906543"
  })), _path5339 || (_path5339 = /*#__PURE__*/React.createElement("path", {
    d: "M50 75v1h-1v-1z",
    fill: "#916541"
  })), _path5340 || (_path5340 = /*#__PURE__*/React.createElement("path", {
    d: "M51 75v1h-1v-1z",
    fill: "#8f6543",
    fillOpacity: 0.933
  })), _path5341 || (_path5341 = /*#__PURE__*/React.createElement("path", {
    d: "M51 76v-1h1v1z",
    fill: "#886043",
    fillOpacity: 0.639
  })), _path5342 || (_path5342 = /*#__PURE__*/React.createElement("path", {
    d: "M52 75h1v1h-1z",
    fill: "#7f5f46",
    fillOpacity: 0.282
  })), _path5343 || (_path5343 = /*#__PURE__*/React.createElement("path", {
    d: "M61 75h1v1h-1z",
    fill: "#916b4d",
    fillOpacity: 0.71
  })), _path5344 || (_path5344 = /*#__PURE__*/React.createElement("path", {
    d: "M62 76v-1h1v1z",
    fill: "#a9744f"
  })), _path5345 || (_path5345 = /*#__PURE__*/React.createElement("path", {
    d: "M64 75v1h-1v-1z",
    fill: "#915a36"
  })), _path5346 || (_path5346 = /*#__PURE__*/React.createElement("path", {
    d: "M64 76v-1h1v1z",
    fill: "#864f28"
  })), _path5347 || (_path5347 = /*#__PURE__*/React.createElement("path", {
    d: "M66 76h-1v-1h1z",
    fill: "#824e25"
  })), _path5348 || (_path5348 = /*#__PURE__*/React.createElement("path", {
    d: "M67 75v1h-1v-1z",
    fill: "#af7e59"
  })), _path5349 || (_path5349 = /*#__PURE__*/React.createElement("path", {
    d: "M67 76v-1h1v1z",
    fill: "#b38868",
    fillOpacity: 0.882
  })), _path5350 || (_path5350 = /*#__PURE__*/React.createElement("path", {
    d: "M68 76v-1h1v1z",
    fill: "#9f8f6f",
    fillOpacity: 0.063
  })), _path5351 || (_path5351 = /*#__PURE__*/React.createElement("path", {
    d: "M73 76h-1v-1h1z",
    fill: "#9c724e",
    fillOpacity: 0.69
  })), _path5352 || (_path5352 = /*#__PURE__*/React.createElement("path", {
    d: "M74 75v1h-1v-1z",
    fill: "#b17e4c"
  })), _path5353 || (_path5353 = /*#__PURE__*/React.createElement("path", {
    d: "M74 76v-1h1v1z",
    fill: "#b48656"
  })), _path5354 || (_path5354 = /*#__PURE__*/React.createElement("path", {
    d: "M75 76v-1h1v1z",
    fill: "#b08153"
  })), _path5355 || (_path5355 = /*#__PURE__*/React.createElement("path", {
    d: "M76 76v-1h1v1z",
    fill: "#a17342"
  })), _path5356 || (_path5356 = /*#__PURE__*/React.createElement("path", {
    d: "M78 75v1h-1v-1z",
    fill: "#bd8d60"
  })), _path5357 || (_path5357 = /*#__PURE__*/React.createElement("path", {
    d: "M79 76h-1v-1h1z",
    fill: "#a3805d",
    fillOpacity: 0.537
  })), _path5358 || (_path5358 = /*#__PURE__*/React.createElement("path", {
    d: "M96 75v1h-1v-1z",
    fill: "#866758",
    fillOpacity: 0.349
  })), _path5359 || (_path5359 = /*#__PURE__*/React.createElement("path", {
    d: "M97 76h-1v-1h1z",
    fill: "#9b684d"
  })), _path5360 || (_path5360 = /*#__PURE__*/React.createElement("path", {
    d: "M97 76v-1h1v1z",
    fill: "#9f6e4d"
  })), _path5361 || (_path5361 = /*#__PURE__*/React.createElement("path", {
    d: "M98 75h1v1h-1z",
    fill: "#866751",
    fillOpacity: 0.753
  })), _path5362 || (_path5362 = /*#__PURE__*/React.createElement("path", {
    d: "M101 75v1h-1v-1z",
    fill: "#8d7171",
    fillOpacity: 0.071
  })), _path5363 || (_path5363 = /*#__PURE__*/React.createElement("path", {
    d: "M102 76h-1v-1h1z",
    fill: "#986046",
    fillOpacity: 0.898
  })), _path5364 || (_path5364 = /*#__PURE__*/React.createElement("path", {
    d: "M103 75v1h-1v-1z",
    fill: "#985c38"
  })), _path5365 || (_path5365 = /*#__PURE__*/React.createElement("path", {
    d: "M103 76v-1h1v1z",
    fill: "#b67752"
  })), _path5366 || (_path5366 = /*#__PURE__*/React.createElement("path", {
    d: "M104 75h1v1h-1z",
    fill: "#d3997a",
    fillOpacity: 0.922
  })), _path5367 || (_path5367 = /*#__PURE__*/React.createElement("path", {
    d: "M105 76v-1h1v1z",
    fill: "#bc9b90",
    fillOpacity: 0.09
  })), _path5368 || (_path5368 = /*#__PURE__*/React.createElement("path", {
    d: "M108 76v-1h1v1z",
    fill: "#9a7759",
    fillOpacity: 0.478
  })), _path5369 || (_path5369 = /*#__PURE__*/React.createElement("path", {
    d: "M110 75h1v1h-1z",
    fill: "#89633a"
  })), _path5370 || (_path5370 = /*#__PURE__*/React.createElement("path", {
    d: "M112 75v1h-1v-1z",
    fill: "#c38d51"
  })), _path5371 || (_path5371 = /*#__PURE__*/React.createElement("path", {
    d: "M112 75h1v1h-1z",
    fill: "#eeab6a"
  })), _path5372 || (_path5372 = /*#__PURE__*/React.createElement("path", {
    d: "M114 75v1h-1v-1z",
    fill: "#d8ae7f",
    fillOpacity: 0.235
  })), _path5373 || (_path5373 = /*#__PURE__*/React.createElement("path", {
    d: "M117 76v-1h1v1z",
    fill: "#8b583e",
    fillOpacity: 0.863
  })), _path5374 || (_path5374 = /*#__PURE__*/React.createElement("path", {
    d: "M119 75v1h-1v-1z",
    fill: "#a56d47"
  })), _path5375 || (_path5375 = /*#__PURE__*/React.createElement("path", {
    d: "M119 76v-1h1v1z",
    fill: "#bf8765"
  })), _path5376 || (_path5376 = /*#__PURE__*/React.createElement("path", {
    d: "M121 76h-1v-1h1z",
    fill: "#b17e61",
    fillOpacity: 0.945
  })), _path5377 || (_path5377 = /*#__PURE__*/React.createElement("path", {
    d: "M122 76h-1v-1h1z",
    fill: "#97775f",
    fillOpacity: 0.125
  })), _path5378 || (_path5378 = /*#__PURE__*/React.createElement("path", {
    d: "M10 76v1H9v-1z",
    fill: "#a17451",
    fillOpacity: 0.427
  })), _path5379 || (_path5379 = /*#__PURE__*/React.createElement("path", {
    d: "M10 76h1v1h-1z",
    fill: "#bd845e"
  })), _path5380 || (_path5380 = /*#__PURE__*/React.createElement("path", {
    d: "M11 76h1v1h-1z",
    fill: "#9f623a"
  })), _path5381 || (_path5381 = /*#__PURE__*/React.createElement("path", {
    d: "M12 76h1v1h-1z",
    fill: "#904e26"
  })), _path5382 || (_path5382 = /*#__PURE__*/React.createElement("path", {
    d: "M13 77v-1h1v1z",
    fill: "#8e4f26"
  })), _path5383 || (_path5383 = /*#__PURE__*/React.createElement("path", {
    d: "M15 76v1h-1v-1z",
    fill: "#834d2d",
    fillOpacity: 0.827
  })), _path5384 || (_path5384 = /*#__PURE__*/React.createElement("path", {
    d: "M20 76v1h-1v-1z",
    fill: "#96694b",
    fillOpacity: 0.133
  })), _path5385 || (_path5385 = /*#__PURE__*/React.createElement("path", {
    d: "M20 76h1v1h-1z",
    fill: "#a27655",
    fillOpacity: 0.271
  })), _path5386 || (_path5386 = /*#__PURE__*/React.createElement("path", {
    d: "M21 77v-1h1v1z",
    fill: "#a17352",
    fillOpacity: 0.459
  })), _path5387 || (_path5387 = /*#__PURE__*/React.createElement("path", {
    d: "M22 77v-1h1v1z",
    fill: "#9d643f",
    fillOpacity: 0.91
  })), _path5388 || (_path5388 = /*#__PURE__*/React.createElement("path", {
    d: "M23 77v-1h1v1z",
    fill: "#aa6b41"
  })), _path5389 || (_path5389 = /*#__PURE__*/React.createElement("path", {
    d: "M25 76v1h-1v-1z",
    fill: "#b07249"
  })), _path5390 || (_path5390 = /*#__PURE__*/React.createElement("path", {
    d: "M25 76h1v1h-1z",
    fill: "#b27349"
  })), _path5391 || (_path5391 = /*#__PURE__*/React.createElement("path", {
    d: "M27 76v1h-1v-1z",
    fill: "#b47546"
  })), _path5392 || (_path5392 = /*#__PURE__*/React.createElement("path", {
    d: "M27 76h1v1h-1z",
    fill: "#bf7f4e"
  })), _path5393 || (_path5393 = /*#__PURE__*/React.createElement("path", {
    d: "M29 76v1h-1v-1z",
    fill: "#c08051"
  })), _path5394 || (_path5394 = /*#__PURE__*/React.createElement("path", {
    d: "M29 77v-1h1v1z",
    fill: "#c28255"
  })), _path5395 || (_path5395 = /*#__PURE__*/React.createElement("path", {
    d: "M30 76h1v1h-1z",
    fill: "#c4855c"
  })), _path5396 || (_path5396 = /*#__PURE__*/React.createElement("path", {
    d: "M32 76v1h-1v-1z",
    fill: "#c2865e"
  })), _path5397 || (_path5397 = /*#__PURE__*/React.createElement("path", {
    d: "M33 76v1h-1v-1z",
    fill: "#c48960"
  })), _path5398 || (_path5398 = /*#__PURE__*/React.createElement("path", {
    d: "M33 76h1v1h-1z",
    fill: "#c58a62"
  })), _path5399 || (_path5399 = /*#__PURE__*/React.createElement("path", {
    d: "M35 76v1h-1v-1z",
    fill: "#c48b62"
  })), _path5400 || (_path5400 = /*#__PURE__*/React.createElement("path", {
    d: "M35 76h1v1h-1z",
    fill: "#c3885e"
  })), _path5401 || (_path5401 = /*#__PURE__*/React.createElement("path", {
    d: "M36 77v-1h1v1z",
    fill: "#c18357"
  })), _path5402 || (_path5402 = /*#__PURE__*/React.createElement("path", {
    d: "M37 77v-1h1v1z",
    fill: "#bf825a"
  })), _path5403 || (_path5403 = /*#__PURE__*/React.createElement("path", {
    d: "M39 77h-1v-1h1z",
    fill: "#ce9977"
  })), _path5404 || (_path5404 = /*#__PURE__*/React.createElement("path", {
    d: "M40 76h1v1h-1z",
    fill: "#c79684"
  })), _path5405 || (_path5405 = /*#__PURE__*/React.createElement("path", {
    d: "M41 77v-1h1v1z",
    fill: "#c1917e"
  })), _path5406 || (_path5406 = /*#__PURE__*/React.createElement("path", {
    d: "M42 77v-1h1v1z",
    fill: "#956751"
  })), _path5407 || (_path5407 = /*#__PURE__*/React.createElement("path", {
    d: "M44 76v1h-1v-1z",
    fill: "#8f6752"
  })), _path5408 || (_path5408 = /*#__PURE__*/React.createElement("path", {
    d: "M45 77h-1v-1h1z",
    fill: "#956b55"
  })), _path5409 || (_path5409 = /*#__PURE__*/React.createElement("path", {
    d: "M45 76h1v1h-1z",
    fill: "#966e58"
  })), _path5410 || (_path5410 = /*#__PURE__*/React.createElement("path", {
    d: "M46 77v-1h1v1z",
    fill: "#946d55"
  })), _path5411 || (_path5411 = /*#__PURE__*/React.createElement("path", {
    d: "M48 76v1h-1v-1z",
    fill: "#966d52"
  })), _path5412 || (_path5412 = /*#__PURE__*/React.createElement("path", {
    d: "M49 76v1h-1v-1z",
    fill: "#956a4c",
    fillOpacity: 0.969
  })), _path5413 || (_path5413 = /*#__PURE__*/React.createElement("path", {
    d: "M49 77v-1h1v1z",
    fill: "#896549",
    fillOpacity: 0.573
  })), _path5414 || (_path5414 = /*#__PURE__*/React.createElement("path", {
    d: "M50 76h1v1h-1z",
    fill: "#7f6b5d",
    fillOpacity: 0.149
  })), _path5415 || (_path5415 = /*#__PURE__*/React.createElement("path", {
    d: "M62 77h-1v-1h1z",
    fill: "#8e694d",
    fillOpacity: 0.694
  })), _path5416 || (_path5416 = /*#__PURE__*/React.createElement("path", {
    d: "M63 77h-1v-1h1z",
    fill: "#a77450"
  })), _path5417 || (_path5417 = /*#__PURE__*/React.createElement("path", {
    d: "M64 77h-1v-1h1z",
    fill: "#8e5935"
  })), _path5418 || (_path5418 = /*#__PURE__*/React.createElement("path", {
    d: "M64 76h1v1h-1z",
    fill: "#713d1a"
  })), _path5419 || (_path5419 = /*#__PURE__*/React.createElement("path", {
    d: "M65 77v-1h1v1z",
    fill: "#794720"
  })), _path5420 || (_path5420 = /*#__PURE__*/React.createElement("path", {
    d: "M67 77h-1v-1h1z",
    fill: "#b0805a"
  })), _path5421 || (_path5421 = /*#__PURE__*/React.createElement("path", {
    d: "M68 76v1h-1v-1z",
    fill: "#b38968",
    fillOpacity: 0.886
  })), _path5422 || (_path5422 = /*#__PURE__*/React.createElement("path", {
    d: "M69 77h-1v-1h1z",
    fill: "#a58769",
    fillOpacity: 0.067
  })), _path5423 || (_path5423 = /*#__PURE__*/React.createElement("path", {
    d: "M72 77v-1h1v1z",
    fill: "#9d734d",
    fillOpacity: 0.659
  })), _path5424 || (_path5424 = /*#__PURE__*/React.createElement("path", {
    d: "M74 77h-1v-1h1z",
    fill: "#b17f4b"
  })), _path5425 || (_path5425 = /*#__PURE__*/React.createElement("path", {
    d: "M75 77h-1v-1h1z",
    fill: "#b28554"
  })), _path5426 || (_path5426 = /*#__PURE__*/React.createElement("path", {
    d: "M75 77v-1h1v1z",
    fill: "#ae8051"
  })), _path5427 || (_path5427 = /*#__PURE__*/React.createElement("path", {
    d: "M77 76v1h-1v-1z",
    fill: "#a27543"
  })), _path5428 || (_path5428 = /*#__PURE__*/React.createElement("path", {
    d: "M77 76h1v1h-1z",
    fill: "#b58657"
  })), _path5429 || (_path5429 = /*#__PURE__*/React.createElement("path", {
    d: "M79 77h-1v-1h1z",
    fill: "#9c7753",
    fillOpacity: 0.518
  })), _path5430 || (_path5430 = /*#__PURE__*/React.createElement("path", {
    d: "M96 76v1h-1v-1z",
    fill: "#7f665d",
    fillOpacity: 0.204
  })), _path5431 || (_path5431 = /*#__PURE__*/React.createElement("path", {
    d: "M97 77h-1v-1h1z",
    fill: "#89604c",
    fillOpacity: 0.851
  })), _path5432 || (_path5432 = /*#__PURE__*/React.createElement("path", {
    d: "M98 77h-1v-1h1z",
    fill: "#93664c",
    fillOpacity: 0.906
  })), _path5433 || (_path5433 = /*#__PURE__*/React.createElement("path", {
    d: "M99 77h-1v-1h1z",
    fill: "#826350",
    fillOpacity: 0.561
  })), _path5434 || (_path5434 = /*#__PURE__*/React.createElement("path", {
    d: "M100 76h1v1h-1z",
    fill: "#906e66",
    fillOpacity: 0.118
  })), _path5435 || (_path5435 = /*#__PURE__*/React.createElement("path", {
    d: "M102 77h-1v-1h1z",
    fill: "#975d42",
    fillOpacity: 0.937
  })), _path5436 || (_path5436 = /*#__PURE__*/React.createElement("path", {
    d: "M104 77h-1v-1h1z",
    fill: "#bb7a58"
  })), _path5437 || (_path5437 = /*#__PURE__*/React.createElement("path", {
    d: "M104 77v-1h1v1z",
    fill: "#d39c7e",
    fillOpacity: 0.882
  })), _path5438 || (_path5438 = /*#__PURE__*/React.createElement("path", {
    d: "M106 77h-1v-1h1z",
    fill: "#b09c89",
    fillOpacity: 0.051
  })), _path5439 || (_path5439 = /*#__PURE__*/React.createElement("path", {
    d: "M108 76h1v1h-1z",
    fill: "#967353",
    fillOpacity: 0.467
  })), _path5440 || (_path5440 = /*#__PURE__*/React.createElement("path", {
    d: "M110 77h-1v-1h1z",
    fill: "#9b6f47"
  })), _path5441 || (_path5441 = /*#__PURE__*/React.createElement("path", {
    d: "M110 77v-1h1v1z",
    fill: "#8a633a"
  })), _path5442 || (_path5442 = /*#__PURE__*/React.createElement("path", {
    d: "M112 76v1h-1v-1z",
    fill: "#c38d52"
  })), _path5443 || (_path5443 = /*#__PURE__*/React.createElement("path", {
    d: "M113 76v1h-1v-1z",
    fill: "#ebab6d",
    fillOpacity: 0.984
  })), _path5444 || (_path5444 = /*#__PURE__*/React.createElement("path", {
    d: "M113 76h1v1h-1z",
    fill: "#d5b07c",
    fillOpacity: 0.192
  })), _path5445 || (_path5445 = /*#__PURE__*/React.createElement("path", {
    d: "M118 77h-1v-1h1z",
    fill: "#8d5c46",
    fillOpacity: 0.82
  })), _path5446 || (_path5446 = /*#__PURE__*/React.createElement("path", {
    d: "M119 76v1h-1v-1z",
    fill: "#a86d4d"
  })), _path5447 || (_path5447 = /*#__PURE__*/React.createElement("path", {
    d: "M120 76v1h-1v-1z",
    fill: "#bc8362"
  })), _path5448 || (_path5448 = /*#__PURE__*/React.createElement("path", {
    d: "M121 76v1h-1v-1z",
    fill: "#ad7b5e",
    fillOpacity: 0.973
  })), _path5449 || (_path5449 = /*#__PURE__*/React.createElement("path", {
    d: "M10 78H9v-1h1z",
    fill: "#a77757",
    fillOpacity: 0.376
  })), _path5450 || (_path5450 = /*#__PURE__*/React.createElement("path", {
    d: "M11 78h-1v-1h1z",
    fill: "#bd835c"
  })), _path5451 || (_path5451 = /*#__PURE__*/React.createElement("path", {
    d: "M11 78v-1h1v1z",
    fill: "#a1643c"
  })), _path5452 || (_path5452 = /*#__PURE__*/React.createElement("path", {
    d: "M13 78h-1v-1h1z",
    fill: "#90512a"
  })), _path5453 || (_path5453 = /*#__PURE__*/React.createElement("path", {
    d: "M14 77v1h-1v-1z",
    fill: "#8d4f26"
  })), _path5454 || (_path5454 = /*#__PURE__*/React.createElement("path", {
    d: "M14 77h1v1h-1z",
    fill: "#89512f",
    fillOpacity: 0.863
  })), _path5455 || (_path5455 = /*#__PURE__*/React.createElement("path", {
    d: "M20 77h1v1h-1z",
    fill: "#553c36",
    fillOpacity: 0.165
  })), _path5456 || (_path5456 = /*#__PURE__*/React.createElement("path", {
    d: "M21 77h1v1h-1z",
    fill: "#4c2517",
    fillOpacity: 0.639
  })), _path5457 || (_path5457 = /*#__PURE__*/React.createElement("path", {
    d: "M22 77h1v1h-1z",
    fill: "#51200e",
    fillOpacity: 0.969
  })), _path5458 || (_path5458 = /*#__PURE__*/React.createElement("path", {
    d: "M24 77v1h-1v-1z",
    fill: "#6a331f"
  })), _path5459 || (_path5459 = /*#__PURE__*/React.createElement("path", {
    d: "M24 78v-1h1v1z",
    fill: "#92593f"
  })), _path5460 || (_path5460 = /*#__PURE__*/React.createElement("path", {
    d: "M26 77v1h-1v-1z",
    fill: "#ac7453"
  })), _path5461 || (_path5461 = /*#__PURE__*/React.createElement("path", {
    d: "M26 78v-1h1v1z",
    fill: "#b47d54"
  })), _path5462 || (_path5462 = /*#__PURE__*/React.createElement("path", {
    d: "M27 78v-1h1v1z",
    fill: "#b47d52",
    fillOpacity: 0.827
  })), _path5463 || (_path5463 = /*#__PURE__*/React.createElement("path", {
    d: "M29 77v1h-1v-1z",
    fill: "#b77e54",
    fillOpacity: 0.792
  })), _path5464 || (_path5464 = /*#__PURE__*/React.createElement("path", {
    d: "M30 78h-1v-1h1z",
    fill: "#bd8157",
    fillOpacity: 0.925
  })), _path5465 || (_path5465 = /*#__PURE__*/React.createElement("path", {
    d: "M30 78v-1h1v1z",
    fill: "#be825a"
  })), _path5466 || (_path5466 = /*#__PURE__*/React.createElement("path", {
    d: "M32 78h-1v-1h1z",
    fill: "#c3845d"
  })), _path5467 || (_path5467 = /*#__PURE__*/React.createElement("path", {
    d: "M32 78v-1h1v1z",
    fill: "#c18458"
  })), _path5468 || (_path5468 = /*#__PURE__*/React.createElement("path", {
    d: "M34 77v1h-1v-1z",
    fill: "#c18454"
  })), _path5469 || (_path5469 = /*#__PURE__*/React.createElement("path", {
    d: "M35 78h-1v-1h1z",
    fill: "#bd8357"
  })), _path5470 || (_path5470 = /*#__PURE__*/React.createElement("path", {
    d: "M36 77v1h-1v-1z",
    fill: "#be8054"
  })), _path5471 || (_path5471 = /*#__PURE__*/React.createElement("path", {
    d: "M37 77v1h-1v-1z",
    fill: "#ba7d4e"
  })), _path5472 || (_path5472 = /*#__PURE__*/React.createElement("path", {
    d: "M38 77v1h-1v-1z",
    fill: "#bb7f52"
  })), _path5473 || (_path5473 = /*#__PURE__*/React.createElement("path", {
    d: "M38 78v-1h1v1z",
    fill: "#ce9974"
  })), _path5474 || (_path5474 = /*#__PURE__*/React.createElement("path", {
    d: "M40 77v1h-1v-1z",
    fill: "#d2a390"
  })), _path5475 || (_path5475 = /*#__PURE__*/React.createElement("path", {
    d: "M40 78v-1h1v1z",
    fill: "#c79283"
  })), _path5476 || (_path5476 = /*#__PURE__*/React.createElement("path", {
    d: "M42 77v1h-1v-1z",
    fill: "#c08f7a"
  })), _path5477 || (_path5477 = /*#__PURE__*/React.createElement("path", {
    d: "M42 77h1v1h-1z",
    fill: "#956850"
  })), _path5478 || (_path5478 = /*#__PURE__*/React.createElement("path", {
    d: "M43 77h1v1h-1z",
    fill: "#946b57"
  })), _path5479 || (_path5479 = /*#__PURE__*/React.createElement("path", {
    d: "M45 77v1h-1v-1z",
    fill: "#9b7059"
  })), _path5480 || (_path5480 = /*#__PURE__*/React.createElement("path", {
    d: "M45 78v-1h1v1z",
    fill: "#966e57"
  })), _path5481 || (_path5481 = /*#__PURE__*/React.createElement("path", {
    d: "M47 77v1h-1v-1z",
    fill: "#956b54"
  })), _path5482 || (_path5482 = /*#__PURE__*/React.createElement("path", {
    d: "M48 77v1h-1v-1z",
    fill: "#915f46"
  })), _path5483 || (_path5483 = /*#__PURE__*/React.createElement("path", {
    d: "M49 78h-1v-1h1z",
    fill: "#80452b"
  })), _path5484 || (_path5484 = /*#__PURE__*/React.createElement("path", {
    d: "M50 77v1h-1v-1z",
    fill: "#6d3117",
    fillOpacity: 0.886
  })), _path5485 || (_path5485 = /*#__PURE__*/React.createElement("path", {
    d: "M50 78v-1h1v1z",
    fill: "#6d3217",
    fillOpacity: 0.769
  })), _path5486 || (_path5486 = /*#__PURE__*/React.createElement("path", {
    d: "M52 77v1h-1v-1z",
    fill: "#6a321a",
    fillOpacity: 0.612
  })), _path5487 || (_path5487 = /*#__PURE__*/React.createElement("path", {
    d: "M52 78v-1h1v1z",
    fill: "#673422",
    fillOpacity: 0.435
  })), _path5488 || (_path5488 = /*#__PURE__*/React.createElement("path", {
    d: "M53 77h1v1h-1z",
    fill: "#683b2d",
    fillOpacity: 0.286
  })), _path5489 || (_path5489 = /*#__PURE__*/React.createElement("path", {
    d: "M55 77v1h-1v-1z",
    fill: "#674437",
    fillOpacity: 0.145
  })), _path5490 || (_path5490 = /*#__PURE__*/React.createElement("path", {
    d: "M55 78v-1h1v1z",
    fill: "#5c5c5c",
    fillOpacity: 0.043
  })), _path5491 || (_path5491 = /*#__PURE__*/React.createElement("path", {
    d: "M62 78h-1v-1h1z",
    fill: "#8d674a",
    fillOpacity: 0.659
  })), _path5492 || (_path5492 = /*#__PURE__*/React.createElement("path", {
    d: "M62 78v-1h1v1z",
    fill: "#a0704a"
  })), _path5493 || (_path5493 = /*#__PURE__*/React.createElement("path", {
    d: "M66 78h-1v-1h1z",
    fill: "#6c3c1b"
  })), _path5494 || (_path5494 = /*#__PURE__*/React.createElement("path", {
    d: "M67 77v1h-1v-1z",
    fill: "#b1805b"
  })), _path5495 || (_path5495 = /*#__PURE__*/React.createElement("path", {
    d: "M67 78v-1h1v1z",
    fill: "#b78c6c",
    fillOpacity: 0.89
  })), _path5496 || (_path5496 = /*#__PURE__*/React.createElement("path", {
    d: "M68 77h1v1h-1z",
    fill: "#a59678",
    fillOpacity: 0.067
  })), _path5497 || (_path5497 = /*#__PURE__*/React.createElement("path", {
    d: "M72 77h1v1h-1z",
    fill: "#9a704c",
    fillOpacity: 0.655
  })), _path5498 || (_path5498 = /*#__PURE__*/React.createElement("path", {
    d: "M74 78v-1h1v1z",
    fill: "#b38756"
  })), _path5499 || (_path5499 = /*#__PURE__*/React.createElement("path", {
    d: "M76 77v1h-1v-1z",
    fill: "#ac8051"
  })), _path5500 || (_path5500 = /*#__PURE__*/React.createElement("path", {
    d: "M76 78v-1h1v1z",
    fill: "#a07442"
  })), _path5501 || (_path5501 = /*#__PURE__*/React.createElement("path", {
    d: "M79 77v1h-1v-1z",
    fill: "#9b7750",
    fillOpacity: 0.494
  })), _path5502 || (_path5502 = /*#__PURE__*/React.createElement("path", {
    d: "M96 78v-1h1v1z",
    fill: "#735c5c",
    fillOpacity: 0.043
  })), _path5503 || (_path5503 = /*#__PURE__*/React.createElement("path", {
    d: "M97 77h1v1h-1z",
    fill: "#735c5c",
    fillOpacity: 0.086
  })), _path5504 || (_path5504 = /*#__PURE__*/React.createElement("path", {
    d: "M101 78h-1v-1h1z",
    fill: "#946f64",
    fillOpacity: 0.188
  })), _path5505 || (_path5505 = /*#__PURE__*/React.createElement("path", {
    d: "M101 77h1v1h-1z",
    fill: "#985d3f",
    fillOpacity: 0.976
  })), _path5506 || (_path5506 = /*#__PURE__*/React.createElement("path", {
    d: "M102 78v-1h1v1z",
    fill: "#975932"
  })), _path5507 || (_path5507 = /*#__PURE__*/React.createElement("path", {
    d: "M103 78v-1h1v1z",
    fill: "#be7e5a"
  })), _path5508 || (_path5508 = /*#__PURE__*/React.createElement("path", {
    d: "M104 77h1v1h-1z",
    fill: "#d49f83",
    fillOpacity: 0.816
  })), _path5509 || (_path5509 = /*#__PURE__*/React.createElement("path", {
    d: "M108 78v-1h1v1z",
    fill: "#8e6b49",
    fillOpacity: 0.435
  })), _path5510 || (_path5510 = /*#__PURE__*/React.createElement("path", {
    d: "M110 77v1h-1v-1z",
    fill: "#976c44"
  })), _path5511 || (_path5511 = /*#__PURE__*/React.createElement("path", {
    d: "M110 78v-1h1v1z",
    fill: "#865f36"
  })), _path5512 || (_path5512 = /*#__PURE__*/React.createElement("path", {
    d: "M112 78h-1v-1h1z",
    fill: "#cb9659"
  })), _path5513 || (_path5513 = /*#__PURE__*/React.createElement("path", {
    d: "M113 77v1h-1v-1z",
    fill: "#f2b577",
    fillOpacity: 0.961
  })), _path5514 || (_path5514 = /*#__PURE__*/React.createElement("path", {
    d: "M113 78v-1h1v1z",
    fill: "#d7b082",
    fillOpacity: 0.153
  })), _path5515 || (_path5515 = /*#__PURE__*/React.createElement("path", {
    d: "M117 78v-1h1v1z",
    fill: "#8d5c4e",
    fillOpacity: 0.765
  })), _path5516 || (_path5516 = /*#__PURE__*/React.createElement("path", {
    d: "M118 77h1v1h-1z",
    fill: "#a96d52"
  })), _path5517 || (_path5517 = /*#__PURE__*/React.createElement("path", {
    d: "M119 77h1v1h-1z",
    fill: "#bb8362"
  })), _path5518 || (_path5518 = /*#__PURE__*/React.createElement("path", {
    d: "M120 78v-1h1v1z",
    fill: "#ac795d",
    fillOpacity: 0.984
  })), _path5519 || (_path5519 = /*#__PURE__*/React.createElement("path", {
    d: "M121 77h1v1h-1z",
    fill: "#937062",
    fillOpacity: 0.204
  })), _path5520 || (_path5520 = /*#__PURE__*/React.createElement("path", {
    d: "M10 78v1H9v-1z",
    fill: "#a5795f",
    fillOpacity: 0.345
  })), _path5521 || (_path5521 = /*#__PURE__*/React.createElement("path", {
    d: "M10 78h1v1h-1z",
    fill: "#be8158"
  })), _path5522 || (_path5522 = /*#__PURE__*/React.createElement("path", {
    d: "M11 79v-1h1v1z",
    fill: "#a2663d"
  })), _path5523 || (_path5523 = /*#__PURE__*/React.createElement("path", {
    d: "M13 78v1h-1v-1z",
    fill: "#91512b"
  })), _path5524 || (_path5524 = /*#__PURE__*/React.createElement("path", {
    d: "M13 79v-1h1v1z",
    fill: "#8e4d24"
  })), _path5525 || (_path5525 = /*#__PURE__*/React.createElement("path", {
    d: "M15 78v1h-1v-1z",
    fill: "#865130",
    fillOpacity: 0.878
  })), _path5526 || (_path5526 = /*#__PURE__*/React.createElement("path", {
    d: "M18 79v-1h1v1z",
    fill: "#6e5252",
    fillOpacity: 0.145
  })), _path5527 || (_path5527 = /*#__PURE__*/React.createElement("path", {
    d: "M20 78v1h-1v-1z",
    fill: "#573125",
    fillOpacity: 0.584
  })), _path5528 || (_path5528 = /*#__PURE__*/React.createElement("path", {
    d: "M20 79v-1h1v1z",
    fill: "#512214",
    fillOpacity: 0.973
  })), _path5529 || (_path5529 = /*#__PURE__*/React.createElement("path", {
    d: "M22 78v1h-1v-1z",
    fill: "#612e1c"
  })), _path5530 || (_path5530 = /*#__PURE__*/React.createElement("path", {
    d: "M23 79h-1v-1h1z",
    fill: "#774733",
    fillOpacity: 0.996
  })), _path5531 || (_path5531 = /*#__PURE__*/React.createElement("path", {
    d: "M23 79v-1h1v1z",
    fill: "#8e5b3f"
  })), _path5532 || (_path5532 = /*#__PURE__*/React.createElement("path", {
    d: "M25 78v1h-1v-1z",
    fill: "#95603a"
  })), _path5533 || (_path5533 = /*#__PURE__*/React.createElement("path", {
    d: "M25 79v-1h1v1z",
    fill: "#ad7f5e"
  })), _path5534 || (_path5534 = /*#__PURE__*/React.createElement("path", {
    d: "M26 78h1v1h-1z",
    fill: "#ba8e6c"
  })), _path5535 || (_path5535 = /*#__PURE__*/React.createElement("path", {
    d: "M28 78v1h-1v-1z",
    fill: "#a9836b",
    fillOpacity: 0.373
  })), _path5536 || (_path5536 = /*#__PURE__*/React.createElement("path", {
    d: "M30 79h-1v-1h1z",
    fill: "#a6896b",
    fillOpacity: 0.102
  })), _path5537 || (_path5537 = /*#__PURE__*/React.createElement("path", {
    d: "M31 79h-1v-1h1z",
    fill: "#ae8366",
    fillOpacity: 0.235
  })), _path5538 || (_path5538 = /*#__PURE__*/React.createElement("path", {
    d: "M32 78v1h-1v-1z",
    fill: "#ad7a61",
    fillOpacity: 0.514
  })), _path5539 || (_path5539 = /*#__PURE__*/React.createElement("path", {
    d: "M33 78v1h-1v-1z",
    fill: "#b47c58",
    fillOpacity: 0.988
  })), _path5540 || (_path5540 = /*#__PURE__*/React.createElement("path", {
    d: "M33 79v-1h1v1z",
    fill: "#c08558"
  })), _path5541 || (_path5541 = /*#__PURE__*/React.createElement("path", {
    d: "M35 78v1h-1v-1z",
    fill: "#be865e"
  })), _path5542 || (_path5542 = /*#__PURE__*/React.createElement("path", {
    d: "M35 79v-1h1v1z",
    fill: "#c18056"
  })), _path5543 || (_path5543 = /*#__PURE__*/React.createElement("path", {
    d: "M37 79h-1v-1h1z",
    fill: "#c38457"
  })), _path5544 || (_path5544 = /*#__PURE__*/React.createElement("path", {
    d: "M38 78v1h-1v-1z",
    fill: "#c58557"
  })), _path5545 || (_path5545 = /*#__PURE__*/React.createElement("path", {
    d: "M39 78v1h-1v-1z",
    fill: "#d39873"
  })), _path5546 || (_path5546 = /*#__PURE__*/React.createElement("path", {
    d: "M39 78h1v1h-1z",
    fill: "#d4a18f"
  })), _path5547 || (_path5547 = /*#__PURE__*/React.createElement("path", {
    d: "M40 79v-1h1v1z",
    fill: "#c89484"
  })), _path5548 || (_path5548 = /*#__PURE__*/React.createElement("path", {
    d: "M41 78h1v1h-1z",
    fill: "#bf8d78"
  })), _path5549 || (_path5549 = /*#__PURE__*/React.createElement("path", {
    d: "M43 78v1h-1v-1z",
    fill: "#956851"
  })), _path5550 || (_path5550 = /*#__PURE__*/React.createElement("path", {
    d: "M43 78h1v1h-1z",
    fill: "#8f6858",
    fillOpacity: 0.929
  })), _path5551 || (_path5551 = /*#__PURE__*/React.createElement("path", {
    d: "M45 78v1h-1v-1z",
    fill: "#8e6e5a",
    fillOpacity: 0.631
  })), _path5552 || (_path5552 = /*#__PURE__*/React.createElement("path", {
    d: "M45 78h1v1h-1z",
    fill: "#90725d",
    fillOpacity: 0.298
  })), _path5553 || (_path5553 = /*#__PURE__*/React.createElement("path", {
    d: "M47 78v1h-1v-1z",
    fill: "#866351",
    fillOpacity: 0.282
  })), _path5554 || (_path5554 = /*#__PURE__*/React.createElement("path", {
    d: "M47 78h1v1h-1z",
    fill: "#7b4f39",
    fillOpacity: 0.455
  })), _path5555 || (_path5555 = /*#__PURE__*/React.createElement("path", {
    d: "M48 79v-1h1v1z",
    fill: "#814a2e",
    fillOpacity: 0.643
  })), _path5556 || (_path5556 = /*#__PURE__*/React.createElement("path", {
    d: "M50 79h-1v-1h1z",
    fill: "#834a2a",
    fillOpacity: 0.816
  })), _path5557 || (_path5557 = /*#__PURE__*/React.createElement("path", {
    d: "M51 79h-1v-1h1z",
    fill: "#804829",
    fillOpacity: 0.941
  })), _path5558 || (_path5558 = /*#__PURE__*/React.createElement("path", {
    d: "M52 79h-1v-1h1z",
    fill: "#814528"
  })), _path5559 || (_path5559 = /*#__PURE__*/React.createElement("path", {
    d: "M53 79h-1v-1h1z",
    fill: "#834225"
  })), _path5560 || (_path5560 = /*#__PURE__*/React.createElement("path", {
    d: "M54 78v1h-1v-1z",
    fill: "#7d3b20"
  })), _path5561 || (_path5561 = /*#__PURE__*/React.createElement("path", {
    d: "M54 79v-1h1v1z",
    fill: "#74341b",
    fillOpacity: 0.984
  })), _path5562 || (_path5562 = /*#__PURE__*/React.createElement("path", {
    d: "M56 79h-1v-1h1z",
    fill: "#6d3017",
    fillOpacity: 0.882
  })), _path5563 || (_path5563 = /*#__PURE__*/React.createElement("path", {
    d: "M56 79v-1h1v1z",
    fill: "#682f1d",
    fillOpacity: 0.718
  })), _path5564 || (_path5564 = /*#__PURE__*/React.createElement("path", {
    d: "M58 79h-1v-1h1z",
    fill: "#633321",
    fillOpacity: 0.541
  })), _path5565 || (_path5565 = /*#__PURE__*/React.createElement("path", {
    d: "M58 78h1v1h-1z",
    fill: "#5c311f",
    fillOpacity: 0.38
  })), _path5566 || (_path5566 = /*#__PURE__*/React.createElement("path", {
    d: "M59 78h1v1h-1z",
    fill: "#654130",
    fillOpacity: 0.227
  })), _path5567 || (_path5567 = /*#__PURE__*/React.createElement("path", {
    d: "M61 78v1h-1v-1z",
    fill: "#825d48",
    fillOpacity: 0.192
  })), _path5568 || (_path5568 = /*#__PURE__*/React.createElement("path", {
    d: "M61 79v-1h1v1z",
    fill: "#936951",
    fillOpacity: 0.784
  })), _path5569 || (_path5569 = /*#__PURE__*/React.createElement("path", {
    d: "M62 79v-1h1v1z",
    fill: "#ab7c60"
  })), _path5570 || (_path5570 = /*#__PURE__*/React.createElement("path", {
    d: "M63 78h1v1h-1z",
    fill: "#b78b73"
  })), _path5571 || (_path5571 = /*#__PURE__*/React.createElement("path", {
    d: "M64 78h1v1h-1z",
    fill: "#b5866f"
  })), _path5572 || (_path5572 = /*#__PURE__*/React.createElement("path", {
    d: "M66 79v-1h1v1z",
    fill: "#b07f5c"
  })), _path5573 || (_path5573 = /*#__PURE__*/React.createElement("path", {
    d: "M68 78v1h-1v-1z",
    fill: "#b98f72",
    fillOpacity: 0.894
  })), _path5574 || (_path5574 = /*#__PURE__*/React.createElement("path", {
    d: "M68 79v-1h1v1z",
    fill: "#aa8d7f",
    fillOpacity: 0.071
  })), _path5575 || (_path5575 = /*#__PURE__*/React.createElement("path", {
    d: "M73 79h-1v-1h1z",
    fill: "#9a704a",
    fillOpacity: 0.62
  })), _path5576 || (_path5576 = /*#__PURE__*/React.createElement("path", {
    d: "M75 78v1h-1v-1z",
    fill: "#b38757"
  })), _path5577 || (_path5577 = /*#__PURE__*/React.createElement("path", {
    d: "M75 78h1v1h-1z",
    fill: "#ad8052"
  })), _path5578 || (_path5578 = /*#__PURE__*/React.createElement("path", {
    d: "M78 78v1h-1v-1z",
    fill: "#ab7b48"
  })), _path5579 || (_path5579 = /*#__PURE__*/React.createElement("path", {
    d: "M79 79h-1v-1h1z",
    fill: "#9e7851",
    fillOpacity: 0.455
  })), _path5580 || (_path5580 = /*#__PURE__*/React.createElement("path", {
    d: "M100 78h1v1h-1z",
    fill: "#906b5c",
    fillOpacity: 0.271
  })), _path5581 || (_path5581 = /*#__PURE__*/React.createElement("path", {
    d: "M103 79h-1v-1h1z",
    fill: "#9a5a34"
  })), _path5582 || (_path5582 = /*#__PURE__*/React.createElement("path", {
    d: "M104 79h-1v-1h1z",
    fill: "#c2865c"
  })), _path5583 || (_path5583 = /*#__PURE__*/React.createElement("path", {
    d: "M104 79v-1h1v1z",
    fill: "#d3a286",
    fillOpacity: 0.714
  })), _path5584 || (_path5584 = /*#__PURE__*/React.createElement("path", {
    d: "M109 79h-1v-1h1z",
    fill: "#946f50",
    fillOpacity: 0.384
  })), _path5585 || (_path5585 = /*#__PURE__*/React.createElement("path", {
    d: "M110 79h-1v-1h1z",
    fill: "#98714a"
  })), _path5586 || (_path5586 = /*#__PURE__*/React.createElement("path", {
    d: "M111 79h-1v-1h1z",
    fill: "#79562b"
  })), _path5587 || (_path5587 = /*#__PURE__*/React.createElement("path", {
    d: "M111 79v-1h1v1z",
    fill: "#ca9555"
  })), _path5588 || (_path5588 = /*#__PURE__*/React.createElement("path", {
    d: "M112 78h1v1h-1z",
    fill: "#f1b478",
    fillOpacity: 0.937
  })), _path5589 || (_path5589 = /*#__PURE__*/React.createElement("path", {
    d: "M114 79h-1v-1h1z",
    fill: "#cfa77f",
    fillOpacity: 0.125
  })), _path5590 || (_path5590 = /*#__PURE__*/React.createElement("path", {
    d: "M117 78h1v1h-1z",
    fill: "#8d5e57",
    fillOpacity: 0.698
  })), _path5591 || (_path5591 = /*#__PURE__*/React.createElement("path", {
    d: "M118 79v-1h1v1z",
    fill: "#a86f54"
  })), _path5592 || (_path5592 = /*#__PURE__*/React.createElement("path", {
    d: "M119 78h1v1h-1z",
    fill: "#bc8464"
  })), _path5593 || (_path5593 = /*#__PURE__*/React.createElement("path", {
    d: "M121 78v1h-1v-1z",
    fill: "#ad795d",
    fillOpacity: 0.996
  })), _path5594 || (_path5594 = /*#__PURE__*/React.createElement("path", {
    d: "M122 79h-1v-1h1z",
    fill: "#92705a",
    fillOpacity: 0.231
  })), _path5595 || (_path5595 = /*#__PURE__*/React.createElement("path", {
    d: "M9 79h1v1H9z",
    fill: "#9f795c",
    fillOpacity: 0.314
  })), _path5596 || (_path5596 = /*#__PURE__*/React.createElement("path", {
    d: "M10 79h1v1h-1z",
    fill: "#bc8159"
  })), _path5597 || (_path5597 = /*#__PURE__*/React.createElement("path", {
    d: "M11 79h1v1h-1z",
    fill: "#a4683e"
  })), _path5598 || (_path5598 = /*#__PURE__*/React.createElement("path", {
    d: "M13 79h1v1h-1z",
    fill: "#8f5023"
  })), _path5599 || (_path5599 = /*#__PURE__*/React.createElement("path", {
    d: "M15 79v1h-1v-1z",
    fill: "#875029",
    fillOpacity: 0.89
  })), _path5600 || (_path5600 = /*#__PURE__*/React.createElement("path", {
    d: "M17 79v1h-1v-1z",
    fill: "#745f5f",
    fillOpacity: 0.094
  })), _path5601 || (_path5601 = /*#__PURE__*/React.createElement("path", {
    d: "M17 80v-1h1v1z",
    fill: "#5e382d",
    fillOpacity: 0.51
  })), _path5602 || (_path5602 = /*#__PURE__*/React.createElement("path", {
    d: "M19 79v1h-1v-1z",
    fill: "#592b18",
    fillOpacity: 0.929
  })), _path5603 || (_path5603 = /*#__PURE__*/React.createElement("path", {
    d: "M20 80h-1v-1h1z",
    fill: "#642d1b"
  })), _path5604 || (_path5604 = /*#__PURE__*/React.createElement("path", {
    d: "M20 79h1v1h-1z",
    fill: "#6e3d32",
    fillOpacity: 0.898
  })), _path5605 || (_path5605 = /*#__PURE__*/React.createElement("path", {
    d: "M21 79h1v1h-1z",
    fill: "#7d5851",
    fillOpacity: 0.431
  })), _path5606 || (_path5606 = /*#__PURE__*/React.createElement("path", {
    d: "M23 79v1h-1v-1z",
    fill: "#936643",
    fillOpacity: 0.635
  })), _path5607 || (_path5607 = /*#__PURE__*/React.createElement("path", {
    d: "M24 79v1h-1v-1z",
    fill: "#9f6533"
  })), _path5608 || (_path5608 = /*#__PURE__*/React.createElement("path", {
    d: "M26 80h-1v-1h1z",
    fill: "#ac7f5e"
  })), _path5609 || (_path5609 = /*#__PURE__*/React.createElement("path", {
    d: "M26 80v-1h1v1z",
    fill: "#ba9173"
  })), _path5610 || (_path5610 = /*#__PURE__*/React.createElement("path", {
    d: "M27 79h1v1h-1z",
    fill: "#aa8672",
    fillOpacity: 0.357
  })), _path5611 || (_path5611 = /*#__PURE__*/React.createElement("path", {
    d: "M31 80v-1h1v1z",
    fill: "#5a4334",
    fillOpacity: 0.133
  })), _path5612 || (_path5612 = /*#__PURE__*/React.createElement("path", {
    d: "M32 79h1v1h-1z",
    fill: "#7e4a31",
    fillOpacity: 0.969
  })), _path5613 || (_path5613 = /*#__PURE__*/React.createElement("path", {
    d: "M33 79h1v1h-1z",
    fill: "#915632"
  })), _path5614 || (_path5614 = /*#__PURE__*/React.createElement("path", {
    d: "M34 80v-1h1v1z",
    fill: "#ac7658"
  })), _path5615 || (_path5615 = /*#__PURE__*/React.createElement("path", {
    d: "M36 80h-1v-1h1z",
    fill: "#bc8266"
  })), _path5616 || (_path5616 = /*#__PURE__*/React.createElement("path", {
    d: "M36 80v-1h1v1z",
    fill: "#b37e5e",
    fillOpacity: 0.737
  })), _path5617 || (_path5617 = /*#__PURE__*/React.createElement("path", {
    d: "M37 80v-1h1v1z",
    fill: "#ae7c58",
    fillOpacity: 0.62
  })), _path5618 || (_path5618 = /*#__PURE__*/React.createElement("path", {
    d: "M38 79h1v1h-1z",
    fill: "#c7977b",
    fillOpacity: 0.812
  })), _path5619 || (_path5619 = /*#__PURE__*/React.createElement("path", {
    d: "M39 79h1v1h-1z",
    fill: "#d3a08e"
  })), _path5620 || (_path5620 = /*#__PURE__*/React.createElement("path", {
    d: "M41 79v1h-1v-1z",
    fill: "#cb9887"
  })), _path5621 || (_path5621 = /*#__PURE__*/React.createElement("path", {
    d: "M41 79h1v1h-1z",
    fill: "#c28e7c"
  })), _path5622 || (_path5622 = /*#__PURE__*/React.createElement("path", {
    d: "M43 79v1h-1v-1z",
    fill: "#9b6c57"
  })), _path5623 || (_path5623 = /*#__PURE__*/React.createElement("path", {
    d: "M43 80v-1h1v1z",
    fill: "#876858",
    fillOpacity: 0.42
  })), _path5624 || (_path5624 = /*#__PURE__*/React.createElement("path", {
    d: "M50 80v-1h1v1z",
    fill: "#997a66",
    fillOpacity: 0.098
  })), _path5625 || (_path5625 = /*#__PURE__*/React.createElement("path", {
    d: "M52 80h-1v-1h1z",
    fill: "#885d48",
    fillOpacity: 0.235
  })), _path5626 || (_path5626 = /*#__PURE__*/React.createElement("path", {
    d: "M53 79v1h-1v-1z",
    fill: "#8a5945",
    fillOpacity: 0.404
  })), _path5627 || (_path5627 = /*#__PURE__*/React.createElement("path", {
    d: "M54 80h-1v-1h1z",
    fill: "#8c553f",
    fillOpacity: 0.584
  })), _path5628 || (_path5628 = /*#__PURE__*/React.createElement("path", {
    d: "M54 79h1v1h-1z",
    fill: "#894f32",
    fillOpacity: 0.729
  })), _path5629 || (_path5629 = /*#__PURE__*/React.createElement("path", {
    d: "M56 79v1h-1v-1z",
    fill: "#84482a",
    fillOpacity: 0.839
  })), _path5630 || (_path5630 = /*#__PURE__*/React.createElement("path", {
    d: "M57 80h-1v-1h1z",
    fill: "#804427",
    fillOpacity: 0.937
  })), _path5631 || (_path5631 = /*#__PURE__*/React.createElement("path", {
    d: "M58 79v1h-1v-1z",
    fill: "#7c4127"
  })), _path5632 || (_path5632 = /*#__PURE__*/React.createElement("path", {
    d: "M58 79h1v1h-1z",
    fill: "#794125"
  })), _path5633 || (_path5633 = /*#__PURE__*/React.createElement("path", {
    d: "M60 79v1h-1v-1z",
    fill: "#815137"
  })), _path5634 || (_path5634 = /*#__PURE__*/React.createElement("path", {
    d: "M60 80v-1h1v1z",
    fill: "#946952",
    fillOpacity: 0.996
  })), _path5635 || (_path5635 = /*#__PURE__*/React.createElement("path", {
    d: "M62 80h-1v-1h1z",
    fill: "#a97b6b"
  })), _path5636 || (_path5636 = /*#__PURE__*/React.createElement("path", {
    d: "M63 79v1h-1v-1z",
    fill: "#b08373"
  })), _path5637 || (_path5637 = /*#__PURE__*/React.createElement("path", {
    d: "M63 80v-1h1v1z",
    fill: "#a4735b"
  })), _path5638 || (_path5638 = /*#__PURE__*/React.createElement("path", {
    d: "M64 80v-1h1v1z",
    fill: "#915d3c"
  })), _path5639 || (_path5639 = /*#__PURE__*/React.createElement("path", {
    d: "M65 79h1v1h-1z",
    fill: "#834d29"
  })), _path5640 || (_path5640 = /*#__PURE__*/React.createElement("path", {
    d: "M67 80h-1v-1h1z",
    fill: "#b38361"
  })), _path5641 || (_path5641 = /*#__PURE__*/React.createElement("path", {
    d: "M68 79v1h-1v-1z",
    fill: "#bb9075",
    fillOpacity: 0.906
  })), _path5642 || (_path5642 = /*#__PURE__*/React.createElement("path", {
    d: "M69 80h-1v-1h1z",
    fill: "#aa9179",
    fillOpacity: 0.082
  })), _path5643 || (_path5643 = /*#__PURE__*/React.createElement("path", {
    d: "M73 79v1h-1v-1z",
    fill: "#a0754d",
    fillOpacity: 0.58
  })), _path5644 || (_path5644 = /*#__PURE__*/React.createElement("path", {
    d: "M74 79v1h-1v-1z",
    fill: "#b4824e"
  })), _path5645 || (_path5645 = /*#__PURE__*/React.createElement("path", {
    d: "M74 80v-1h1v1z",
    fill: "#b58757"
  })), _path5646 || (_path5646 = /*#__PURE__*/React.createElement("path", {
    d: "M75 79h1v1h-1z",
    fill: "#ae7f51"
  })), _path5647 || (_path5647 = /*#__PURE__*/React.createElement("path", {
    d: "M77 80v-1h1v1z",
    fill: "#a97a4a"
  })), _path5648 || (_path5648 = /*#__PURE__*/React.createElement("path", {
    d: "M79 79v1h-1v-1z",
    fill: "#a07b55",
    fillOpacity: 0.412
  })), _path5649 || (_path5649 = /*#__PURE__*/React.createElement("path", {
    d: "M101 80h-1v-1h1z",
    fill: "#8e6353",
    fillOpacity: 0.373
  })), _path5650 || (_path5650 = /*#__PURE__*/React.createElement("path", {
    d: "M102 80h-1v-1h1z",
    fill: "#a06140"
  })), _path5651 || (_path5651 = /*#__PURE__*/React.createElement("path", {
    d: "M103 79h1v1h-1z",
    fill: "#c58a64"
  })), _path5652 || (_path5652 = /*#__PURE__*/React.createElement("path", {
    d: "M104 80v-1h1v1z",
    fill: "#d3a288",
    fillOpacity: 0.592
  })), _path5653 || (_path5653 = /*#__PURE__*/React.createElement("path", {
    d: "M108 79h1v1h-1z",
    fill: "#9c795c",
    fillOpacity: 0.345
  })), _path5654 || (_path5654 = /*#__PURE__*/React.createElement("path", {
    d: "M110 79v1h-1v-1z",
    fill: "#99734d"
  })), _path5655 || (_path5655 = /*#__PURE__*/React.createElement("path", {
    d: "M110 80v-1h1v1z",
    fill: "#7f592e"
  })), _path5656 || (_path5656 = /*#__PURE__*/React.createElement("path", {
    d: "M111 79h1v1h-1z",
    fill: "#cc9254"
  })), _path5657 || (_path5657 = /*#__PURE__*/React.createElement("path", {
    d: "M113 80h-1v-1h1z",
    fill: "#eeaf76",
    fillOpacity: 0.929
  })), _path5658 || (_path5658 = /*#__PURE__*/React.createElement("path", {
    d: "M114 80h-1v-1h1z",
    fill: "#d3a783",
    fillOpacity: 0.114
  })), _path5659 || (_path5659 = /*#__PURE__*/React.createElement("path", {
    d: "M118 80h-1v-1h1z",
    fill: "#91645a",
    fillOpacity: 0.627
  })), _path5660 || (_path5660 = /*#__PURE__*/React.createElement("path", {
    d: "M118 79h1v1h-1z",
    fill: "#a87052"
  })), _path5661 || (_path5661 = /*#__PURE__*/React.createElement("path", {
    d: "M120 80h-1v-1h1z",
    fill: "#bd8463"
  })), _path5662 || (_path5662 = /*#__PURE__*/React.createElement("path", {
    d: "M120 80v-1h1v1z",
    fill: "#b17b5d"
  })), _path5663 || (_path5663 = /*#__PURE__*/React.createElement("path", {
    d: "M121 80v-1h1v1z",
    fill: "#966f59",
    fillOpacity: 0.278
  })), _path5664 || (_path5664 = /*#__PURE__*/React.createElement("path", {
    d: "M9 81v-1h1v1z",
    fill: "#9b785f",
    fillOpacity: 0.282
  })), _path5665 || (_path5665 = /*#__PURE__*/React.createElement("path", {
    d: "M10 80h1v1h-1z",
    fill: "#b9805a"
  })), _path5666 || (_path5666 = /*#__PURE__*/React.createElement("path", {
    d: "M11 81v-1h1v1z",
    fill: "#aa6e43"
  })), _path5667 || (_path5667 = /*#__PURE__*/React.createElement("path", {
    d: "M12 80h1v1h-1z",
    fill: "#90532a"
  })), _path5668 || (_path5668 = /*#__PURE__*/React.createElement("path", {
    d: "M14 80h1v1h-1z",
    fill: "#884e26",
    fillOpacity: 0.933
  })), _path5669 || (_path5669 = /*#__PURE__*/React.createElement("path", {
    d: "M16 80v1h-1v-1z",
    fill: "#61402f",
    fillOpacity: 0.545
  })), _path5670 || (_path5670 = /*#__PURE__*/React.createElement("path", {
    d: "M17 81h-1v-1h1z",
    fill: "#54291b",
    fillOpacity: 0.886
  })), _path5671 || (_path5671 = /*#__PURE__*/React.createElement("path", {
    d: "M18 81h-1v-1h1z",
    fill: "#602e19"
  })), _path5672 || (_path5672 = /*#__PURE__*/React.createElement("path", {
    d: "M18 81v-1h1v1z",
    fill: "#6b412d",
    fillOpacity: 0.949
  })), _path5673 || (_path5673 = /*#__PURE__*/React.createElement("path", {
    d: "M19 80h1v1h-1z",
    fill: "#795549",
    fillOpacity: 0.541
  })), _path5674 || (_path5674 = /*#__PURE__*/React.createElement("path", {
    d: "M20 80h1v1h-1z",
    fill: "#886d6d",
    fillOpacity: 0.11
  })), _path5675 || (_path5675 = /*#__PURE__*/React.createElement("path", {
    d: "M23 81h-1v-1h1z",
    fill: "#8a663e",
    fillOpacity: 0.525
  })), _path5676 || (_path5676 = /*#__PURE__*/React.createElement("path", {
    d: "M23 81v-1h1v1z",
    fill: "#a26632"
  })), _path5677 || (_path5677 = /*#__PURE__*/React.createElement("path", {
    d: "M24 80h1v1h-1z",
    fill: "#9b6436"
  })), _path5678 || (_path5678 = /*#__PURE__*/React.createElement("path", {
    d: "M25 80h1v1h-1z",
    fill: "#ab7d5e"
  })), _path5679 || (_path5679 = /*#__PURE__*/React.createElement("path", {
    d: "M27 80v1h-1v-1z",
    fill: "#b88f75"
  })), _path5680 || (_path5680 = /*#__PURE__*/React.createElement("path", {
    d: "M27 81v-1h1v1z",
    fill: "#ac8978",
    fillOpacity: 0.341
  })), _path5681 || (_path5681 = /*#__PURE__*/React.createElement("path", {
    d: "M32 80v1h-1v-1z",
    fill: "#69574f",
    fillOpacity: 0.114
  })), _path5682 || (_path5682 = /*#__PURE__*/React.createElement("path", {
    d: "M32 80h1v1h-1z",
    fill: "#6d381e",
    fillOpacity: 0.953
  })), _path5683 || (_path5683 = /*#__PURE__*/React.createElement("path", {
    d: "M34 81h-1v-1h1z",
    fill: "#773713"
  })), _path5684 || (_path5684 = /*#__PURE__*/React.createElement("path", {
    d: "M35 80v1h-1v-1z",
    fill: "#a77057"
  })), _path5685 || (_path5685 = /*#__PURE__*/React.createElement("path", {
    d: "M35 81v-1h1v1z",
    fill: "#bc8b7d"
  })), _path5686 || (_path5686 = /*#__PURE__*/React.createElement("path", {
    d: "M37 81h-1v-1h1z",
    fill: "#a8857b",
    fillOpacity: 0.427
  })), _path5687 || (_path5687 = /*#__PURE__*/React.createElement("path", {
    d: "M38 81v-1h1v1z",
    fill: "#dfc3bc",
    fillOpacity: 0.286
  })), _path5688 || (_path5688 = /*#__PURE__*/React.createElement("path", {
    d: "M40 80v1h-1v-1z",
    fill: "#cd9f91"
  })), _path5689 || (_path5689 = /*#__PURE__*/React.createElement("path", {
    d: "M40 81v-1h1v1z",
    fill: "#cd9c88"
  })), _path5690 || (_path5690 = /*#__PURE__*/React.createElement("path", {
    d: "M41 81v-1h1v1z",
    fill: "#c09178"
  })), _path5691 || (_path5691 = /*#__PURE__*/React.createElement("path", {
    d: "M43 81h-1v-1h1z",
    fill: "#9c6e57"
  })), _path5692 || (_path5692 = /*#__PURE__*/React.createElement("path", {
    d: "M43 81v-1h1v1z",
    fill: "#896c5d",
    fillOpacity: 0.341
  })), _path5693 || (_path5693 = /*#__PURE__*/React.createElement("path", {
    d: "M56 81h-1v-1h1z",
    fill: "#665d55",
    fillOpacity: 0.118
  })), _path5694 || (_path5694 = /*#__PURE__*/React.createElement("path", {
    d: "M57 80v1h-1v-1z",
    fill: "#6f4630",
    fillOpacity: 0.557
  })), _path5695 || (_path5695 = /*#__PURE__*/React.createElement("path", {
    d: "M57 81v-1h1v1z",
    fill: "#724421",
    fillOpacity: 0.992
  })), _path5696 || (_path5696 = /*#__PURE__*/React.createElement("path", {
    d: "M58 80h1v1h-1z",
    fill: "#7a4a29"
  })), _path5697 || (_path5697 = /*#__PURE__*/React.createElement("path", {
    d: "M60 81h-1v-1h1z",
    fill: "#8c624d"
  })), _path5698 || (_path5698 = /*#__PURE__*/React.createElement("path", {
    d: "M60 80h1v1h-1z",
    fill: "#9c7664",
    fillOpacity: 0.863
  })), _path5699 || (_path5699 = /*#__PURE__*/React.createElement("path", {
    d: "M62 80v1h-1v-1z",
    fill: "#a2725d",
    fillOpacity: 0.929
  })), _path5700 || (_path5700 = /*#__PURE__*/React.createElement("path", {
    d: "M63 81h-1v-1h1z",
    fill: "#8e563c"
  })), _path5701 || (_path5701 = /*#__PURE__*/React.createElement("path", {
    d: "M63 80h1v1h-1z",
    fill: "#814929"
  })), _path5702 || (_path5702 = /*#__PURE__*/React.createElement("path", {
    d: "M65 81h-1v-1h1z",
    fill: "#89532d"
  })), _path5703 || (_path5703 = /*#__PURE__*/React.createElement("path", {
    d: "M65 80h1v1h-1z",
    fill: "#89552f"
  })), _path5704 || (_path5704 = /*#__PURE__*/React.createElement("path", {
    d: "M67 80v1h-1v-1z",
    fill: "#b68564"
  })), _path5705 || (_path5705 = /*#__PURE__*/React.createElement("path", {
    d: "M67 81v-1h1v1z",
    fill: "#bc9178",
    fillOpacity: 0.914
  })), _path5706 || (_path5706 = /*#__PURE__*/React.createElement("path", {
    d: "M69 81h-1v-1h1z",
    fill: "#aa947f",
    fillOpacity: 0.094
  })), _path5707 || (_path5707 = /*#__PURE__*/React.createElement("path", {
    d: "M72 80h1v1h-1z",
    fill: "#9b6f47",
    fillOpacity: 0.573
  })), _path5708 || (_path5708 = /*#__PURE__*/React.createElement("path", {
    d: "M74 80v1h-1v-1z",
    fill: "#b07b48"
  })), _path5709 || (_path5709 = /*#__PURE__*/React.createElement("path", {
    d: "M74 80h1v1h-1z",
    fill: "#b38353"
  })), _path5710 || (_path5710 = /*#__PURE__*/React.createElement("path", {
    d: "M76 80v1h-1v-1z",
    fill: "#af7f4f"
  })), _path5711 || (_path5711 = /*#__PURE__*/React.createElement("path", {
    d: "M76 81v-1h1v1z",
    fill: "#a47544"
  })), _path5712 || (_path5712 = /*#__PURE__*/React.createElement("path", {
    d: "M77 80h1v1h-1z",
    fill: "#a87a4d"
  })), _path5713 || (_path5713 = /*#__PURE__*/React.createElement("path", {
    d: "M79 80v1h-1v-1z",
    fill: "#a07f5c",
    fillOpacity: 0.369
  })), _path5714 || (_path5714 = /*#__PURE__*/React.createElement("path", {
    d: "M100 81v-1h1v1z",
    fill: "#94644f",
    fillOpacity: 0.478
  })), _path5715 || (_path5715 = /*#__PURE__*/React.createElement("path", {
    d: "M102 80v1h-1v-1z",
    fill: "#a4603d"
  })), _path5716 || (_path5716 = /*#__PURE__*/React.createElement("path", {
    d: "M102 81v-1h1v1z",
    fill: "#9b5c3b"
  })), _path5717 || (_path5717 = /*#__PURE__*/React.createElement("path", {
    d: "M103 80h1v1h-1z",
    fill: "#c78d6b"
  })), _path5718 || (_path5718 = /*#__PURE__*/React.createElement("path", {
    d: "M105 81h-1v-1h1z",
    fill: "#d5a58c",
    fillOpacity: 0.482
  })), _path5719 || (_path5719 = /*#__PURE__*/React.createElement("path", {
    d: "M108 81v-1h1v1z",
    fill: "#9a795e",
    fillOpacity: 0.329
  })), _path5720 || (_path5720 = /*#__PURE__*/React.createElement("path", {
    d: "M110 81h-1v-1h1z",
    fill: "#98734d"
  })), _path5721 || (_path5721 = /*#__PURE__*/React.createElement("path", {
    d: "M111 81h-1v-1h1z",
    fill: "#886338"
  })), _path5722 || (_path5722 = /*#__PURE__*/React.createElement("path", {
    d: "M112 80v1h-1v-1z",
    fill: "#d0975a"
  })), _path5723 || (_path5723 = /*#__PURE__*/React.createElement("path", {
    d: "M113 81h-1v-1h1z",
    fill: "#eeaf77",
    fillOpacity: 0.906
  })), _path5724 || (_path5724 = /*#__PURE__*/React.createElement("path", {
    d: "M113 81v-1h1v1z",
    fill: "#dcb98b",
    fillOpacity: 0.086
  })), _path5725 || (_path5725 = /*#__PURE__*/React.createElement("path", {
    d: "M117 80h1v1h-1z",
    fill: "#8b6458",
    fillOpacity: 0.565
  })), _path5726 || (_path5726 = /*#__PURE__*/React.createElement("path", {
    d: "M119 80v1h-1v-1z",
    fill: "#a97357"
  })), _path5727 || (_path5727 = /*#__PURE__*/React.createElement("path", {
    d: "M120 80v1h-1v-1z",
    fill: "#be8465"
  })), _path5728 || (_path5728 = /*#__PURE__*/React.createElement("path", {
    d: "M120 81v-1h1v1z",
    fill: "#b37c5e"
  })), _path5729 || (_path5729 = /*#__PURE__*/React.createElement("path", {
    d: "M121 80h1v1h-1z",
    fill: "#936f5a",
    fillOpacity: 0.333
  })), _path5730 || (_path5730 = /*#__PURE__*/React.createElement("path", {
    d: "M9 82v-1h1v1z",
    fill: "#9f795f",
    fillOpacity: 0.263
  })), _path5731 || (_path5731 = /*#__PURE__*/React.createElement("path", {
    d: "M11 81v1h-1v-1z",
    fill: "#b67f59"
  })), _path5732 || (_path5732 = /*#__PURE__*/React.createElement("path", {
    d: "M11 81h1v1h-1z",
    fill: "#ad7045"
  })), _path5733 || (_path5733 = /*#__PURE__*/React.createElement("path", {
    d: "M12 82v-1h1v1z",
    fill: "#915328"
  })), _path5734 || (_path5734 = /*#__PURE__*/React.createElement("path", {
    d: "M13 82v-1h1v1z",
    fill: "#8b4f26"
  })), _path5735 || (_path5735 = /*#__PURE__*/React.createElement("path", {
    d: "M15 81v1h-1v-1z",
    fill: "#894e28"
  })), _path5736 || (_path5736 = /*#__PURE__*/React.createElement("path", {
    d: "M15 81h1v1h-1z",
    fill: "#63321a"
  })), _path5737 || (_path5737 = /*#__PURE__*/React.createElement("path", {
    d: "M16 81h1v1h-1z",
    fill: "#673727"
  })), _path5738 || (_path5738 = /*#__PURE__*/React.createElement("path", {
    d: "M17 82v-1h1v1z",
    fill: "#735044",
    fillOpacity: 0.631
  })), _path5739 || (_path5739 = /*#__PURE__*/React.createElement("path", {
    d: "M22 82v-1h1v1z",
    fill: "#83633e",
    fillOpacity: 0.494
  })), _path5740 || (_path5740 = /*#__PURE__*/React.createElement("path", {
    d: "M24 81v1h-1v-1z",
    fill: "#9c6637"
  })), _path5741 || (_path5741 = /*#__PURE__*/React.createElement("path", {
    d: "M25 82h-1v-1h1z",
    fill: "#996233"
  })), _path5742 || (_path5742 = /*#__PURE__*/React.createElement("path", {
    d: "M25 82v-1h1v1z",
    fill: "#ab7c5d"
  })), _path5743 || (_path5743 = /*#__PURE__*/React.createElement("path", {
    d: "M26 82v-1h1v1z",
    fill: "#b88d73"
  })), _path5744 || (_path5744 = /*#__PURE__*/React.createElement("path", {
    d: "M28 82h-1v-1h1z",
    fill: "#aa8375",
    fillOpacity: 0.341
  })), _path5745 || (_path5745 = /*#__PURE__*/React.createElement("path", {
    d: "M31 82h-1v-1h1z",
    fill: "#7c5541",
    fillOpacity: 0.153
  })), _path5746 || (_path5746 = /*#__PURE__*/React.createElement("path", {
    d: "M32 82h-1v-1h1z",
    fill: "#703c2b",
    fillOpacity: 0.647
  })), _path5747 || (_path5747 = /*#__PURE__*/React.createElement("path", {
    d: "M33 81v1h-1v-1z",
    fill: "#723718",
    fillOpacity: 0.992
  })), _path5748 || (_path5748 = /*#__PURE__*/React.createElement("path", {
    d: "M34 81v1h-1v-1z",
    fill: "#793c1b"
  })), _path5749 || (_path5749 = /*#__PURE__*/React.createElement("path", {
    d: "M35 81v1h-1v-1z",
    fill: "#a36b53"
  })), _path5750 || (_path5750 = /*#__PURE__*/React.createElement("path", {
    d: "M36 81v1h-1v-1z",
    fill: "#be8d7d"
  })), _path5751 || (_path5751 = /*#__PURE__*/React.createElement("path", {
    d: "M37 82h-1v-1h1z",
    fill: "#a78579",
    fillOpacity: 0.478
  })), _path5752 || (_path5752 = /*#__PURE__*/React.createElement("path", {
    d: "M39 82h-1v-1h1z",
    fill: "#d9bcb3",
    fillOpacity: 0.318
  })), _path5753 || (_path5753 = /*#__PURE__*/React.createElement("path", {
    d: "M39 82v-1h1v1z",
    fill: "#cc9b8b"
  })), _path5754 || (_path5754 = /*#__PURE__*/React.createElement("path", {
    d: "M40 81h1v1h-1z",
    fill: "#ca9a85"
  })), _path5755 || (_path5755 = /*#__PURE__*/React.createElement("path", {
    d: "M41 82v-1h1v1z",
    fill: "#bf8e76"
  })), _path5756 || (_path5756 = /*#__PURE__*/React.createElement("path", {
    d: "M42 82v-1h1v1z",
    fill: "#986e5c"
  })), _path5757 || (_path5757 = /*#__PURE__*/React.createElement("path", {
    d: "M44 81v1h-1v-1z",
    fill: "#826b65",
    fillOpacity: 0.306
  })), _path5758 || (_path5758 = /*#__PURE__*/React.createElement("path", {
    d: "M54 81v1h-1v-1z",
    fill: "#644935",
    fillOpacity: 0.149
  })), _path5759 || (_path5759 = /*#__PURE__*/React.createElement("path", {
    d: "M54 82v-1h1v1z",
    fill: "#67452e",
    fillOpacity: 0.522
  })), _path5760 || (_path5760 = /*#__PURE__*/React.createElement("path", {
    d: "M56 81v1h-1v-1z",
    fill: "#6d4225",
    fillOpacity: 0.871
  })), _path5761 || (_path5761 = /*#__PURE__*/React.createElement("path", {
    d: "M57 82h-1v-1h1z",
    fill: "#764728"
  })), _path5762 || (_path5762 = /*#__PURE__*/React.createElement("path", {
    d: "M58 81v1h-1v-1z",
    fill: "#7e5439",
    fillOpacity: 0.992
  })), _path5763 || (_path5763 = /*#__PURE__*/React.createElement("path", {
    d: "M58 82v-1h1v1z",
    fill: "#89654f",
    fillOpacity: 0.757
  })), _path5764 || (_path5764 = /*#__PURE__*/React.createElement("path", {
    d: "M59 82v-1h1v1z",
    fill: "#917664",
    fillOpacity: 0.337
  })), _path5765 || (_path5765 = /*#__PURE__*/React.createElement("path", {
    d: "M62 82h-1v-1h1z",
    fill: "#896047",
    fillOpacity: 0.529
  })), _path5766 || (_path5766 = /*#__PURE__*/React.createElement("path", {
    d: "M63 82h-1v-1h1z",
    fill: "#9e6a48"
  })), _path5767 || (_path5767 = /*#__PURE__*/React.createElement("path", {
    d: "M64 82h-1v-1h1z",
    fill: "#8e5933"
  })), _path5768 || (_path5768 = /*#__PURE__*/React.createElement("path", {
    d: "M66 81v1h-1v-1z",
    fill: "#89552d"
  })), _path5769 || (_path5769 = /*#__PURE__*/React.createElement("path", {
    d: "M67 82h-1v-1h1z",
    fill: "#b68465"
  })), _path5770 || (_path5770 = /*#__PURE__*/React.createElement("path", {
    d: "M67 81h1v1h-1z",
    fill: "#bc917b",
    fillOpacity: 0.922
  })), _path5771 || (_path5771 = /*#__PURE__*/React.createElement("path", {
    d: "M68 82v-1h1v1z",
    fill: "#b09389",
    fillOpacity: 0.102
  })), _path5772 || (_path5772 = /*#__PURE__*/React.createElement("path", {
    d: "M73 81v1h-1v-1z",
    fill: "#91643d",
    fillOpacity: 0.565
  })), _path5773 || (_path5773 = /*#__PURE__*/React.createElement("path", {
    d: "M74 82h-1v-1h1z",
    fill: "#ab7542"
  })), _path5774 || (_path5774 = /*#__PURE__*/React.createElement("path", {
    d: "M75 82v-1h1v1z",
    fill: "#ae7d4d"
  })), _path5775 || (_path5775 = /*#__PURE__*/React.createElement("path", {
    d: "M77 81v1h-1v-1z",
    fill: "#a77747"
  })), _path5776 || (_path5776 = /*#__PURE__*/React.createElement("path", {
    d: "M78 81v1h-1v-1z",
    fill: "#a97b50"
  })), _path5777 || (_path5777 = /*#__PURE__*/React.createElement("path", {
    d: "M79 82h-1v-1h1z",
    fill: "#9f7c5c",
    fillOpacity: 0.345
  })), _path5778 || (_path5778 = /*#__PURE__*/React.createElement("path", {
    d: "M100 81h1v1h-1z",
    fill: "#93604a",
    fillOpacity: 0.604
  })), _path5779 || (_path5779 = /*#__PURE__*/React.createElement("path", {
    d: "M101 82v-1h1v1z",
    fill: "#a55e3a"
  })), _path5780 || (_path5780 = /*#__PURE__*/React.createElement("path", {
    d: "M102 81h1v1h-1z",
    fill: "#9c5f3f"
  })), _path5781 || (_path5781 = /*#__PURE__*/React.createElement("path", {
    d: "M104 82h-1v-1h1z",
    fill: "#c68d6d"
  })), _path5782 || (_path5782 = /*#__PURE__*/React.createElement("path", {
    d: "M105 82h-1v-1h1z",
    fill: "#d6a58d",
    fillOpacity: 0.345
  })), _path5783 || (_path5783 = /*#__PURE__*/React.createElement("path", {
    d: "M108 81h1v1h-1z",
    fill: "#917457",
    fillOpacity: 0.31
  })), _path5784 || (_path5784 = /*#__PURE__*/React.createElement("path", {
    d: "M111 82h-1v-1h1z",
    fill: "#876439"
  })), _path5785 || (_path5785 = /*#__PURE__*/React.createElement("path", {
    d: "M111 82v-1h1v1z",
    fill: "#cf9b5c"
  })), _path5786 || (_path5786 = /*#__PURE__*/React.createElement("path", {
    d: "M113 81v1h-1v-1z",
    fill: "#efb178",
    fillOpacity: 0.886
  })), _path5787 || (_path5787 = /*#__PURE__*/React.createElement("path", {
    d: "M114 81v1h-1v-1z",
    fill: "#d4aa8d",
    fillOpacity: 0.071
  })), _path5788 || (_path5788 = /*#__PURE__*/React.createElement("path", {
    d: "M118 81v1h-1v-1z",
    fill: "#7d5f55",
    fillOpacity: 0.2
  })), _path5789 || (_path5789 = /*#__PURE__*/React.createElement("path", {
    d: "M118 82v-1h1v1z",
    fill: "#92664d",
    fillOpacity: 0.773
  })), _path5790 || (_path5790 = /*#__PURE__*/React.createElement("path", {
    d: "M120 82h-1v-1h1z",
    fill: "#b38266",
    fillOpacity: 0.906
  })), _path5791 || (_path5791 = /*#__PURE__*/React.createElement("path", {
    d: "M120 81h1v1h-1z",
    fill: "#a27156",
    fillOpacity: 0.831
  })), _path5792 || (_path5792 = /*#__PURE__*/React.createElement("path", {
    d: "M122 81v1h-1v-1z",
    fill: "#8d6856",
    fillOpacity: 0.22
  })), _path5793 || (_path5793 = /*#__PURE__*/React.createElement("path", {
    d: "M9 82h1v1H9z",
    fill: "#9d775d",
    fillOpacity: 0.235
  })), _path5794 || (_path5794 = /*#__PURE__*/React.createElement("path", {
    d: "M11 83h-1v-1h1z",
    fill: "#b57e56",
    fillOpacity: 0.996
  })), _path5795 || (_path5795 = /*#__PURE__*/React.createElement("path", {
    d: "M12 82v1h-1v-1z",
    fill: "#ae7145"
  })), _path5796 || (_path5796 = /*#__PURE__*/React.createElement("path", {
    d: "M12 82h1v1h-1z",
    fill: "#915227"
  })), _path5797 || (_path5797 = /*#__PURE__*/React.createElement("path", {
    d: "M14 83h-1v-1h1z",
    fill: "#8e502a"
  })), _path5798 || (_path5798 = /*#__PURE__*/React.createElement("path", {
    d: "M15 83h-1v-1h1z",
    fill: "#8b4d29"
  })), _path5799 || (_path5799 = /*#__PURE__*/React.createElement("path", {
    d: "M15 82h1v1h-1z",
    fill: "#77503b",
    fillOpacity: 0.769
  })), _path5800 || (_path5800 = /*#__PURE__*/React.createElement("path", {
    d: "M16 83v-1h1v1z",
    fill: "#795c55",
    fillOpacity: 0.271
  })), _path5801 || (_path5801 = /*#__PURE__*/React.createElement("path", {
    d: "M23 83h-1v-1h1z",
    fill: "#85613a",
    fillOpacity: 0.463
  })), _path5802 || (_path5802 = /*#__PURE__*/React.createElement("path", {
    d: "M24 82v1h-1v-1z",
    fill: "#9d6637"
  })), _path5803 || (_path5803 = /*#__PURE__*/React.createElement("path", {
    d: "M24 82h1v1h-1z",
    fill: "#9a6337"
  })), _path5804 || (_path5804 = /*#__PURE__*/React.createElement("path", {
    d: "M26 83h-1v-1h1z",
    fill: "#ab7957"
  })), _path5805 || (_path5805 = /*#__PURE__*/React.createElement("path", {
    d: "M26 83v-1h1v1z",
    fill: "#b58c72"
  })), _path5806 || (_path5806 = /*#__PURE__*/React.createElement("path", {
    d: "M27 82h1v1h-1z",
    fill: "#af9482",
    fillOpacity: 0.29
  })), _path5807 || (_path5807 = /*#__PURE__*/React.createElement("path", {
    d: "M28 83v-1h1v1z",
    fill: "#6f5f4f",
    fillOpacity: 0.063
  })), _path5808 || (_path5808 = /*#__PURE__*/React.createElement("path", {
    d: "M29 83v-1h1v1z",
    fill: "#724a35",
    fillOpacity: 0.482
  })), _path5809 || (_path5809 = /*#__PURE__*/React.createElement("path", {
    d: "M31 82v1h-1v-1z",
    fill: "#7d4527",
    fillOpacity: 0.937
  })), _path5810 || (_path5810 = /*#__PURE__*/React.createElement("path", {
    d: "M31 82h1v1h-1z",
    fill: "#8a4b33"
  })), _path5811 || (_path5811 = /*#__PURE__*/React.createElement("path", {
    d: "M33 82v1h-1v-1z",
    fill: "#8c5034"
  })), _path5812 || (_path5812 = /*#__PURE__*/React.createElement("path", {
    d: "M33 83v-1h1v1z",
    fill: "#85472d"
  })), _path5813 || (_path5813 = /*#__PURE__*/React.createElement("path", {
    d: "M35 83h-1v-1h1z",
    fill: "#a56953"
  })), _path5814 || (_path5814 = /*#__PURE__*/React.createElement("path", {
    d: "M36 82v1h-1v-1z",
    fill: "#be8f7f"
  })), _path5815 || (_path5815 = /*#__PURE__*/React.createElement("path", {
    d: "M37 82v1h-1v-1z",
    fill: "#a7867a",
    fillOpacity: 0.537
  })), _path5816 || (_path5816 = /*#__PURE__*/React.createElement("path", {
    d: "M38 83v-1h1v1z",
    fill: "#d1b0aa",
    fillOpacity: 0.306
  })), _path5817 || (_path5817 = /*#__PURE__*/React.createElement("path", {
    d: "M39 82h1v1h-1z",
    fill: "#c89887"
  })), _path5818 || (_path5818 = /*#__PURE__*/React.createElement("path", {
    d: "M41 83h-1v-1h1z",
    fill: "#ca9987"
  })), _path5819 || (_path5819 = /*#__PURE__*/React.createElement("path", {
    d: "M42 82v1h-1v-1z",
    fill: "#bf8b76"
  })), _path5820 || (_path5820 = /*#__PURE__*/React.createElement("path", {
    d: "M42 82h1v1h-1z",
    fill: "#976d58"
  })), _path5821 || (_path5821 = /*#__PURE__*/React.createElement("path", {
    d: "M44 83h-1v-1h1z",
    fill: "#866e61",
    fillOpacity: 0.298
  })), _path5822 || (_path5822 = /*#__PURE__*/React.createElement("path", {
    d: "M52 82v1h-1v-1z",
    fill: "#694f39",
    fillOpacity: 0.227
  })), _path5823 || (_path5823 = /*#__PURE__*/React.createElement("path", {
    d: "M52 83v-1h1v1z",
    fill: "#74513f",
    fillOpacity: 0.627
  })), _path5824 || (_path5824 = /*#__PURE__*/React.createElement("path", {
    d: "M53 83v-1h1v1z",
    fill: "#7d523a",
    fillOpacity: 0.957
  })), _path5825 || (_path5825 = /*#__PURE__*/React.createElement("path", {
    d: "M55 82h1v1h-1z",
    fill: "#865e45",
    fillOpacity: 0.98
  })), _path5826 || (_path5826 = /*#__PURE__*/React.createElement("path", {
    d: "M56 82h1v1h-1z",
    fill: "#876952",
    fillOpacity: 0.671
  })), _path5827 || (_path5827 = /*#__PURE__*/React.createElement("path", {
    d: "M58 83h-1v-1h1z",
    fill: "#988172",
    fillOpacity: 0.263
  })), _path5828 || (_path5828 = /*#__PURE__*/React.createElement("path", {
    d: "M58 82h1v1h-1z",
    fill: "#fff",
    fillOpacity: 0.016
  })), _path5829 || (_path5829 = /*#__PURE__*/React.createElement("path", {
    d: "M61 82h1v1h-1z",
    fill: "#7b5d3f",
    fillOpacity: 0.267
  })), _path5830 || (_path5830 = /*#__PURE__*/React.createElement("path", {
    d: "M62 82h1v1h-1z",
    fill: "#815a3b",
    fillOpacity: 0.804
  })), _path5831 || (_path5831 = /*#__PURE__*/React.createElement("path", {
    d: "M63 83v-1h1v1z",
    fill: "#875734",
    fillOpacity: 0.961
  })), _path5832 || (_path5832 = /*#__PURE__*/React.createElement("path", {
    d: "M64 83v-1h1v1z",
    fill: "#8c5630"
  })), _path5833 || (_path5833 = /*#__PURE__*/React.createElement("path", {
    d: "M66 82h1v1h-1z",
    fill: "#b58267"
  })), _path5834 || (_path5834 = /*#__PURE__*/React.createElement("path", {
    d: "M67 82h1v1h-1z",
    fill: "#be917e",
    fillOpacity: 0.929
  })), _path5835 || (_path5835 = /*#__PURE__*/React.createElement("path", {
    d: "M69 82v1h-1v-1z",
    fill: "#ad9191",
    fillOpacity: 0.11
  })), _path5836 || (_path5836 = /*#__PURE__*/React.createElement("path", {
    d: "M72 82h1v1h-1z",
    fill: "#976948",
    fillOpacity: 0.702
  })), _path5837 || (_path5837 = /*#__PURE__*/React.createElement("path", {
    d: "M73 82h1v1h-1z",
    fill: "#b27947"
  })), _path5838 || (_path5838 = /*#__PURE__*/React.createElement("path", {
    d: "M75 82h1v1h-1z",
    fill: "#ae7d4c"
  })), _path5839 || (_path5839 = /*#__PURE__*/React.createElement("path", {
    d: "M76 82h1v1h-1z",
    fill: "#a97849"
  })), _path5840 || (_path5840 = /*#__PURE__*/React.createElement("path", {
    d: "M78 83h-1v-1h1z",
    fill: "#aa7b50"
  })), _path5841 || (_path5841 = /*#__PURE__*/React.createElement("path", {
    d: "M79 82v1h-1v-1z",
    fill: "#9d775b",
    fillOpacity: 0.318
  })), _path5842 || (_path5842 = /*#__PURE__*/React.createElement("path", {
    d: "M101 82v1h-1v-1z",
    fill: "#976049",
    fillOpacity: 0.737
  })), _path5843 || (_path5843 = /*#__PURE__*/React.createElement("path", {
    d: "M101 83v-1h1v1z",
    fill: "#a35f3b"
  })), _path5844 || (_path5844 = /*#__PURE__*/React.createElement("path", {
    d: "M103 83h-1v-1h1z",
    fill: "#a46646"
  })), _path5845 || (_path5845 = /*#__PURE__*/React.createElement("path", {
    d: "M103 83v-1h1v1z",
    fill: "#c1876a",
    fillOpacity: 0.996
  })), _path5846 || (_path5846 = /*#__PURE__*/React.createElement("path", {
    d: "M104 82h1v1h-1z",
    fill: "#cba497",
    fillOpacity: 0.231
  })), _path5847 || (_path5847 = /*#__PURE__*/React.createElement("path", {
    d: "M108 83v-1h1v1z",
    fill: "#927665",
    fillOpacity: 0.286
  })), _path5848 || (_path5848 = /*#__PURE__*/React.createElement("path", {
    d: "M109 82h1v1h-1z",
    fill: "#9b7250"
  })), _path5849 || (_path5849 = /*#__PURE__*/React.createElement("path", {
    d: "M110 82h1v1h-1z",
    fill: "#8a673e"
  })), _path5850 || (_path5850 = /*#__PURE__*/React.createElement("path", {
    d: "M111 82h1v1h-1z",
    fill: "#d09755"
  })), _path5851 || (_path5851 = /*#__PURE__*/React.createElement("path", {
    d: "M113 83h-1v-1h1z",
    fill: "#eeac75",
    fillOpacity: 0.871
  })), _path5852 || (_path5852 = /*#__PURE__*/React.createElement("path", {
    d: "M113 83v-1h1v1z",
    fill: "#dba",
    fillOpacity: 0.059
  })), _path5853 || (_path5853 = /*#__PURE__*/React.createElement("path", {
    d: "M120 82v1h-1v-1z",
    fill: "#93866b",
    fillOpacity: 0.075
  })), _path5854 || (_path5854 = /*#__PURE__*/React.createElement("path", {
    d: "M120 83v-1h1v1z",
    fill: "#555",
    fillOpacity: 0.024
  })), _path5855 || (_path5855 = /*#__PURE__*/React.createElement("path", {
    d: "M9 84v-1h1v1z",
    fill: "#a0735a",
    fillOpacity: 0.2
  })), _path5856 || (_path5856 = /*#__PURE__*/React.createElement("path", {
    d: "M11 83v1h-1v-1z",
    fill: "#b37b53",
    fillOpacity: 0.984
  })), _path5857 || (_path5857 = /*#__PURE__*/React.createElement("path", {
    d: "M11 84v-1h1v1z",
    fill: "#b27447"
  })), _path5858 || (_path5858 = /*#__PURE__*/React.createElement("path", {
    d: "M13 83v1h-1v-1z",
    fill: "#915329"
  })), _path5859 || (_path5859 = /*#__PURE__*/React.createElement("path", {
    d: "M13 84v-1h1v1z",
    fill: "#90522b"
  })), _path5860 || (_path5860 = /*#__PURE__*/React.createElement("path", {
    d: "M15 83v1h-1v-1z",
    fill: "#864c29",
    fillOpacity: 0.969
  })), _path5861 || (_path5861 = /*#__PURE__*/React.createElement("path", {
    d: "M15 83h1v1h-1z",
    fill: "#7c5e53",
    fillOpacity: 0.169
  })), _path5862 || (_path5862 = /*#__PURE__*/React.createElement("path", {
    d: "M23 83v1h-1v-1z",
    fill: "#865f39",
    fillOpacity: 0.431
  })), _path5863 || (_path5863 = /*#__PURE__*/React.createElement("path", {
    d: "M23 84v-1h1v1z",
    fill: "#9b6535"
  })), _path5864 || (_path5864 = /*#__PURE__*/React.createElement("path", {
    d: "M24 83h1v1h-1z",
    fill: "#9c6439"
  })), _path5865 || (_path5865 = /*#__PURE__*/React.createElement("path", {
    d: "M26 84h-1v-1h1z",
    fill: "#ad7c5b"
  })), _path5866 || (_path5866 = /*#__PURE__*/React.createElement("path", {
    d: "M27 83v1h-1v-1z",
    fill: "#b1886b",
    fillOpacity: 0.996
  })), _path5867 || (_path5867 = /*#__PURE__*/React.createElement("path", {
    d: "M28 83v1h-1v-1z",
    fill: "#8b5e42",
    fillOpacity: 0.616
  })), _path5868 || (_path5868 = /*#__PURE__*/React.createElement("path", {
    d: "M29 84h-1v-1h1z",
    fill: "#6c3d21",
    fillOpacity: 0.831
  })), _path5869 || (_path5869 = /*#__PURE__*/React.createElement("path", {
    d: "M30 83v1h-1v-1z",
    fill: "#905135"
  })), _path5870 || (_path5870 = /*#__PURE__*/React.createElement("path", {
    d: "M30 83h1v1h-1z",
    fill: "#955c46",
    fillOpacity: 0.906
  })), _path5871 || (_path5871 = /*#__PURE__*/React.createElement("path", {
    d: "M32 83v1h-1v-1z",
    fill: "#8a6250",
    fillOpacity: 0.447
  })), _path5872 || (_path5872 = /*#__PURE__*/React.createElement("path", {
    d: "M32 84v-1h1v1z",
    fill: "#86543a",
    fillOpacity: 0.808
  })), _path5873 || (_path5873 = /*#__PURE__*/React.createElement("path", {
    d: "M33 84v-1h1v1z",
    fill: "#8d5335"
  })), _path5874 || (_path5874 = /*#__PURE__*/React.createElement("path", {
    d: "M35 84h-1v-1h1z",
    fill: "#a06a51"
  })), _path5875 || (_path5875 = /*#__PURE__*/React.createElement("path", {
    d: "M35 84v-1h1v1z",
    fill: "#bf917f"
  })), _path5876 || (_path5876 = /*#__PURE__*/React.createElement("path", {
    d: "M37 84h-1v-1h1z",
    fill: "#ab897d",
    fillOpacity: 0.612
  })), _path5877 || (_path5877 = /*#__PURE__*/React.createElement("path", {
    d: "M38 84v-1h1v1z",
    fill: "#cdada6",
    fillOpacity: 0.306
  })), _path5878 || (_path5878 = /*#__PURE__*/React.createElement("path", {
    d: "M39 84v-1h1v1z",
    fill: "#c79786"
  })), _path5879 || (_path5879 = /*#__PURE__*/React.createElement("path", {
    d: "M41 84h-1v-1h1z",
    fill: "#c99786"
  })), _path5880 || (_path5880 = /*#__PURE__*/React.createElement("path", {
    d: "M42 83v1h-1v-1z",
    fill: "#be8b77"
  })), _path5881 || (_path5881 = /*#__PURE__*/React.createElement("path", {
    d: "M44 84h-1v-1h1z",
    fill: "#826e61",
    fillOpacity: 0.298
  })), _path5882 || (_path5882 = /*#__PURE__*/React.createElement("path", {
    d: "M48 84v-1h1v1z",
    fill: "#4c3319",
    fillOpacity: 0.039
  })), _path5883 || (_path5883 = /*#__PURE__*/React.createElement("path", {
    d: "M49 83h1v1h-1z",
    fill: "#6f5341",
    fillOpacity: 0.322
  })), _path5884 || (_path5884 = /*#__PURE__*/React.createElement("path", {
    d: "M50 83h1v1h-1z",
    fill: "#845d49",
    fillOpacity: 0.718
  })), _path5885 || (_path5885 = /*#__PURE__*/React.createElement("path", {
    d: "M51 83h1v1h-1z",
    fill: "#926855",
    fillOpacity: 0.992
  })), _path5886 || (_path5886 = /*#__PURE__*/React.createElement("path", {
    d: "M52 83h1v1h-1z",
    fill: "#9a715a"
  })), _path5887 || (_path5887 = /*#__PURE__*/React.createElement("path", {
    d: "M53 84v-1h1v1z",
    fill: "#8e6754",
    fillOpacity: 0.933
  })), _path5888 || (_path5888 = /*#__PURE__*/React.createElement("path", {
    d: "M55 83v1h-1v-1z",
    fill: "#916f62",
    fillOpacity: 0.6
  })), _path5889 || (_path5889 = /*#__PURE__*/React.createElement("path", {
    d: "M55 84v-1h1v1z",
    fill: "#968277",
    fillOpacity: 0.192
  })), _path5890 || (_path5890 = /*#__PURE__*/React.createElement("path", {
    d: "M62 83h1v1h-1z",
    fill: "#669",
    fillOpacity: 0.02
  })), _path5891 || (_path5891 = /*#__PURE__*/React.createElement("path", {
    d: "M63 83h1v1h-1z",
    fill: "#7a5237",
    fillOpacity: 0.545
  })), _path5892 || (_path5892 = /*#__PURE__*/React.createElement("path", {
    d: "M66 83v1h-1v-1z",
    fill: "#8e532b"
  })), _path5893 || (_path5893 = /*#__PURE__*/React.createElement("path", {
    d: "M68 83v1h-1v-1z",
    fill: "#be9280",
    fillOpacity: 0.937
  })), _path5894 || (_path5894 = /*#__PURE__*/React.createElement("path", {
    d: "M69 84h-1v-1h1z",
    fill: "#af8f87",
    fillOpacity: 0.125
  })), _path5895 || (_path5895 = /*#__PURE__*/React.createElement("path", {
    d: "M71 84v-1h1v1z",
    fill: "#735c45",
    fillOpacity: 0.043
  })), _path5896 || (_path5896 = /*#__PURE__*/React.createElement("path", {
    d: "M72 84v-1h1v1z",
    fill: "#9e6942",
    fillOpacity: 0.847
  })), _path5897 || (_path5897 = /*#__PURE__*/React.createElement("path", {
    d: "M73 84v-1h1v1z",
    fill: "#b37d4d"
  })), _path5898 || (_path5898 = /*#__PURE__*/React.createElement("path", {
    d: "M74 83h1v1h-1z",
    fill: "#b1804f"
  })), _path5899 || (_path5899 = /*#__PURE__*/React.createElement("path", {
    d: "M76 83v1h-1v-1z",
    fill: "#ad7c4b"
  })), _path5900 || (_path5900 = /*#__PURE__*/React.createElement("path", {
    d: "M76 84v-1h1v1z",
    fill: "#ac7c4d"
  })), _path5901 || (_path5901 = /*#__PURE__*/React.createElement("path", {
    d: "M77 84v-1h1v1z",
    fill: "#ab7d54"
  })), _path5902 || (_path5902 = /*#__PURE__*/React.createElement("path", {
    d: "M79 84h-1v-1h1z",
    fill: "#a17a5d",
    fillOpacity: 0.278
  })), _path5903 || (_path5903 = /*#__PURE__*/React.createElement("path", {
    d: "M100 83v1h-1v-1z",
    fill: "#7f7f7f",
    fillOpacity: 0.047
  })), _path5904 || (_path5904 = /*#__PURE__*/React.createElement("path", {
    d: "M100 83h1v1h-1z",
    fill: "#97614a",
    fillOpacity: 0.851
  })), _path5905 || (_path5905 = /*#__PURE__*/React.createElement("path", {
    d: "M102 83v1h-1v-1z",
    fill: "#a05f3a"
  })), _path5906 || (_path5906 = /*#__PURE__*/React.createElement("path", {
    d: "M102 84v-1h1v1z",
    fill: "#ac7052"
  })), _path5907 || (_path5907 = /*#__PURE__*/React.createElement("path", {
    d: "M104 84h-1v-1h1z",
    fill: "#bd886f",
    fillOpacity: 0.949
  })), _path5908 || (_path5908 = /*#__PURE__*/React.createElement("path", {
    d: "M104 84v-1h1v1z",
    fill: "#ccaea7",
    fillOpacity: 0.137
  })), _path5909 || (_path5909 = /*#__PURE__*/React.createElement("path", {
    d: "M109 83v1h-1v-1z",
    fill: "#937767",
    fillOpacity: 0.251
  })), _path5910 || (_path5910 = /*#__PURE__*/React.createElement("path", {
    d: "M109 84v-1h1v1z",
    fill: "#9a7250"
  })), _path5911 || (_path5911 = /*#__PURE__*/React.createElement("path", {
    d: "M110 83h1v1h-1z",
    fill: "#8c643d"
  })), _path5912 || (_path5912 = /*#__PURE__*/React.createElement("path", {
    d: "M112 83v1h-1v-1z",
    fill: "#d69555"
  })), _path5913 || (_path5913 = /*#__PURE__*/React.createElement("path", {
    d: "M112 83h1v1h-1z",
    fill: "#eba56e",
    fillOpacity: 0.859
  })), _path5914 || (_path5914 = /*#__PURE__*/React.createElement("path", {
    d: "M113 83h1v1h-1z",
    fill: "#d7b0b0",
    fillOpacity: 0.051
  })), _path5915 || (_path5915 = /*#__PURE__*/React.createElement("path", {
    d: "M9 84h1v1H9z",
    fill: "#a47c60",
    fillOpacity: 0.176
  })), _path5916 || (_path5916 = /*#__PURE__*/React.createElement("path", {
    d: "M10 85v-1h1v1z",
    fill: "#b17950",
    fillOpacity: 0.969
  })), _path5917 || (_path5917 = /*#__PURE__*/React.createElement("path", {
    d: "M11 85v-1h1v1z",
    fill: "#b27345"
  })), _path5918 || (_path5918 = /*#__PURE__*/React.createElement("path", {
    d: "M12 85v-1h1v1z",
    fill: "#8e5326"
  })), _path5919 || (_path5919 = /*#__PURE__*/React.createElement("path", {
    d: "M14 84v1h-1v-1z",
    fill: "#8d5026"
  })), _path5920 || (_path5920 = /*#__PURE__*/React.createElement("path", {
    d: "M15 84v1h-1v-1z",
    fill: "#874c2a",
    fillOpacity: 0.969
  })), _path5921 || (_path5921 = /*#__PURE__*/React.createElement("path", {
    d: "M15 84h1v1h-1z",
    fill: "#825e53",
    fillOpacity: 0.169
  })), _path5922 || (_path5922 = /*#__PURE__*/React.createElement("path", {
    d: "M23 84v1h-1v-1z",
    fill: "#88613b",
    fillOpacity: 0.388
  })), _path5923 || (_path5923 = /*#__PURE__*/React.createElement("path", {
    d: "M23 84h1v1h-1z",
    fill: "#9a6639"
  })), _path5924 || (_path5924 = /*#__PURE__*/React.createElement("path", {
    d: "M25 84v1h-1v-1z",
    fill: "#9b663b"
  })), _path5925 || (_path5925 = /*#__PURE__*/React.createElement("path", {
    d: "M26 84v1h-1v-1z",
    fill: "#9b6644"
  })), _path5926 || (_path5926 = /*#__PURE__*/React.createElement("path", {
    d: "M26 85v-1h1v1z",
    fill: "#7d4324"
  })), _path5927 || (_path5927 = /*#__PURE__*/React.createElement("path", {
    d: "M28 84v1h-1v-1z",
    fill: "#78351a"
  })), _path5928 || (_path5928 = /*#__PURE__*/React.createElement("path", {
    d: "M29 84v1h-1v-1z",
    fill: "#864b37",
    fillOpacity: 0.988
  })), _path5929 || (_path5929 = /*#__PURE__*/React.createElement("path", {
    d: "M30 84v1h-1v-1z",
    fill: "#966455",
    fillOpacity: 0.584
  })), _path5930 || (_path5930 = /*#__PURE__*/React.createElement("path", {
    d: "M30 84h1v1h-1z",
    fill: "#997f77",
    fillOpacity: 0.118
  })), _path5931 || (_path5931 = /*#__PURE__*/React.createElement("path", {
    d: "M32 84h1v1h-1z",
    fill: "#83523e",
    fillOpacity: 0.69
  })), _path5932 || (_path5932 = /*#__PURE__*/React.createElement("path", {
    d: "M34 84v1h-1v-1z",
    fill: "#935e3c"
  })), _path5933 || (_path5933 = /*#__PURE__*/React.createElement("path", {
    d: "M34 84h1v1h-1z",
    fill: "#9f6c51"
  })), _path5934 || (_path5934 = /*#__PURE__*/React.createElement("path", {
    d: "M35 84h1v1h-1z",
    fill: "#bf907e"
  })), _path5935 || (_path5935 = /*#__PURE__*/React.createElement("path", {
    d: "M36 85v-1h1v1z",
    fill: "#b28d80",
    fillOpacity: 0.678
  })), _path5936 || (_path5936 = /*#__PURE__*/React.createElement("path", {
    d: "M38 84h1v1h-1z",
    fill: "#cfaca5",
    fillOpacity: 0.314
  })), _path5937 || (_path5937 = /*#__PURE__*/React.createElement("path", {
    d: "M39 84h1v1h-1z",
    fill: "#cc998a"
  })), _path5938 || (_path5938 = /*#__PURE__*/React.createElement("path", {
    d: "M41 84v1h-1v-1z",
    fill: "#ca9785"
  })), _path5939 || (_path5939 = /*#__PURE__*/React.createElement("path", {
    d: "M41 84h1v1h-1z",
    fill: "#bc8871"
  })), _path5940 || (_path5940 = /*#__PURE__*/React.createElement("path", {
    d: "M43 84h1v1h-1z",
    fill: "#836d63",
    fillOpacity: 0.282
  })), _path5941 || (_path5941 = /*#__PURE__*/React.createElement("path", {
    d: "M47 85h-1v-1h1z",
    fill: "#584237",
    fillOpacity: 0.09
  })), _path5942 || (_path5942 = /*#__PURE__*/React.createElement("path", {
    d: "M48 84v1h-1v-1z",
    fill: "#735140",
    fillOpacity: 0.431
  })), _path5943 || (_path5943 = /*#__PURE__*/React.createElement("path", {
    d: "M48 85v-1h1v1z",
    fill: "#8a6556",
    fillOpacity: 0.808
  })), _path5944 || (_path5944 = /*#__PURE__*/React.createElement("path", {
    d: "M50 85h-1v-1h1z",
    fill: "#a07966"
  })), _path5945 || (_path5945 = /*#__PURE__*/React.createElement("path", {
    d: "M50 84h1v1h-1z",
    fill: "#a67d6b"
  })), _path5946 || (_path5946 = /*#__PURE__*/React.createElement("path", {
    d: "M51 84h1v1h-1z",
    fill: "#9d7162",
    fillOpacity: 0.871
  })), _path5947 || (_path5947 = /*#__PURE__*/React.createElement("path", {
    d: "M53 85h-1v-1h1z",
    fill: "#967064",
    fillOpacity: 0.498
  })), _path5948 || (_path5948 = /*#__PURE__*/React.createElement("path", {
    d: "M53 84h1v1h-1z",
    fill: "#917b74",
    fillOpacity: 0.137
  })), _path5949 || (_path5949 = /*#__PURE__*/React.createElement("path", {
    d: "M63 85v-1h1v1z",
    fill: "#7b543b",
    fillOpacity: 0.486
  })), _path5950 || (_path5950 = /*#__PURE__*/React.createElement("path", {
    d: "M64 85v-1h1v1z",
    fill: "#8e5835"
  })), _path5951 || (_path5951 = /*#__PURE__*/React.createElement("path", {
    d: "M66 85h-1v-1h1z",
    fill: "#89502a"
  })), _path5952 || (_path5952 = /*#__PURE__*/React.createElement("path", {
    d: "M66 84h1v1h-1z",
    fill: "#b58268"
  })), _path5953 || (_path5953 = /*#__PURE__*/React.createElement("path", {
    d: "M67 85v-1h1v1z",
    fill: "#c19482",
    fillOpacity: 0.949
  })), _path5954 || (_path5954 = /*#__PURE__*/React.createElement("path", {
    d: "M68 84h1v1h-1z",
    fill: "#b89b8d",
    fillOpacity: 0.141
  })), _path5955 || (_path5955 = /*#__PURE__*/React.createElement("path", {
    d: "M72 85v-1h1v1z",
    fill: "#976741",
    fillOpacity: 0.902
  })), _path5956 || (_path5956 = /*#__PURE__*/React.createElement("path", {
    d: "M73 84h1v1h-1z",
    fill: "#b17d4d"
  })), _path5957 || (_path5957 = /*#__PURE__*/React.createElement("path", {
    d: "M75 84v1h-1v-1z",
    fill: "#b2804e"
  })), _path5958 || (_path5958 = /*#__PURE__*/React.createElement("path", {
    d: "M77 84v1h-1v-1z",
    fill: "#af8253"
  })), _path5959 || (_path5959 = /*#__PURE__*/React.createElement("path", {
    d: "M77 85v-1h1v1z",
    fill: "#ac8158"
  })), _path5960 || (_path5960 = /*#__PURE__*/React.createElement("path", {
    d: "M79 84v1h-1v-1z",
    fill: "#9d7959",
    fillOpacity: 0.247
  })), _path5961 || (_path5961 = /*#__PURE__*/React.createElement("path", {
    d: "M100 85h-1v-1h1z",
    fill: "#886e66",
    fillOpacity: 0.118
  })), _path5962 || (_path5962 = /*#__PURE__*/React.createElement("path", {
    d: "M101 84v1h-1v-1z",
    fill: "#a16b52",
    fillOpacity: 0.937
  })), _path5963 || (_path5963 = /*#__PURE__*/React.createElement("path", {
    d: "M102 85h-1v-1h1z",
    fill: "#a0623d"
  })), _path5964 || (_path5964 = /*#__PURE__*/React.createElement("path", {
    d: "M103 84v1h-1v-1z",
    fill: "#b4785e"
  })), _path5965 || (_path5965 = /*#__PURE__*/React.createElement("path", {
    d: "M103 85v-1h1v1z",
    fill: "#bb8c78",
    fillOpacity: 0.839
  })), _path5966 || (_path5966 = /*#__PURE__*/React.createElement("path", {
    d: "M104 85v-1h1v1z",
    fill: "#c6c6c6",
    fillOpacity: 0.035
  })), _path5967 || (_path5967 = /*#__PURE__*/React.createElement("path", {
    d: "M109 85h-1v-1h1z",
    fill: "#90776a",
    fillOpacity: 0.235
  })), _path5968 || (_path5968 = /*#__PURE__*/React.createElement("path", {
    d: "M109 84h1v1h-1z",
    fill: "#976e4e"
  })), _path5969 || (_path5969 = /*#__PURE__*/React.createElement("path", {
    d: "M110 85v-1h1v1z",
    fill: "#865c35"
  })), _path5970 || (_path5970 = /*#__PURE__*/React.createElement("path", {
    d: "M111 85v-1h1v1z",
    fill: "#cb8849"
  })), _path5971 || (_path5971 = /*#__PURE__*/React.createElement("path", {
    d: "M113 84v1h-1v-1z",
    fill: "#e7a46a",
    fillOpacity: 0.835
  })), _path5972 || (_path5972 = /*#__PURE__*/React.createElement("path", {
    d: "M113 85v-1h1v1z",
    fill: "#c6aaaa",
    fillOpacity: 0.035
  })), _path5973 || (_path5973 = /*#__PURE__*/React.createElement("path", {
    d: "M9 86v-1h1v1z",
    fill: "#aa8567",
    fillOpacity: 0.165
  })), _path5974 || (_path5974 = /*#__PURE__*/React.createElement("path", {
    d: "M10 85h1v1h-1z",
    fill: "#b27a51",
    fillOpacity: 0.965
  })), _path5975 || (_path5975 = /*#__PURE__*/React.createElement("path", {
    d: "M12 85h1v1h-1z",
    fill: "#8c4c21"
  })), _path5976 || (_path5976 = /*#__PURE__*/React.createElement("path", {
    d: "M14 86h-1v-1h1z",
    fill: "#7f421f"
  })), _path5977 || (_path5977 = /*#__PURE__*/React.createElement("path", {
    d: "M14 85h1v1h-1z",
    fill: "#743f21",
    fillOpacity: 0.98
  })), _path5978 || (_path5978 = /*#__PURE__*/React.createElement("path", {
    d: "M16 85v1h-1v-1z",
    fill: "#67483c",
    fillOpacity: 0.165
  })), _path5979 || (_path5979 = /*#__PURE__*/React.createElement("path", {
    d: "M23 86h-1v-1h1z",
    fill: "#8f6c4a",
    fillOpacity: 0.322
  })), _path5980 || (_path5980 = /*#__PURE__*/React.createElement("path", {
    d: "M24 86v-1h1v1z",
    fill: "#804b26"
  })), _path5981 || (_path5981 = /*#__PURE__*/React.createElement("path", {
    d: "M25 85h1v1h-1z",
    fill: "#693111"
  })), _path5982 || (_path5982 = /*#__PURE__*/React.createElement("path", {
    d: "M27 86h-1v-1h1z",
    fill: "#763921"
  })), _path5983 || (_path5983 = /*#__PURE__*/React.createElement("path", {
    d: "M27 85h1v1h-1z",
    fill: "#845141",
    fillOpacity: 0.761
  })), _path5984 || (_path5984 = /*#__PURE__*/React.createElement("path", {
    d: "M28 86v-1h1v1z",
    fill: "#977067",
    fillOpacity: 0.231
  })), _path5985 || (_path5985 = /*#__PURE__*/React.createElement("path", {
    d: "M33 85v1h-1v-1z",
    fill: "#815740",
    fillOpacity: 0.604
  })), _path5986 || (_path5986 = /*#__PURE__*/React.createElement("path", {
    d: "M35 86h-1v-1h1z",
    fill: "#9e6c50"
  })), _path5987 || (_path5987 = /*#__PURE__*/React.createElement("path", {
    d: "M35 85h1v1h-1z",
    fill: "#bd8d7a"
  })), _path5988 || (_path5988 = /*#__PURE__*/React.createElement("path", {
    d: "M37 86h-1v-1h1z",
    fill: "#b68d7e",
    fillOpacity: 0.773
  })), _path5989 || (_path5989 = /*#__PURE__*/React.createElement("path", {
    d: "M38 86v-1h1v1z",
    fill: "#c7a49e",
    fillOpacity: 0.322
  })), _path5990 || (_path5990 = /*#__PURE__*/React.createElement("path", {
    d: "M40 86h-1v-1h1z",
    fill: "#cd9a8a"
  })), _path5991 || (_path5991 = /*#__PURE__*/React.createElement("path", {
    d: "M40 86v-1h1v1z",
    fill: "#cb9684"
  })), _path5992 || (_path5992 = /*#__PURE__*/React.createElement("path", {
    d: "M41 85h1v1h-1z",
    fill: "#ba836b"
  })), _path5993 || (_path5993 = /*#__PURE__*/React.createElement("path", {
    d: "M43 86h-1v-1h1z",
    fill: "#9b715c"
  })), _path5994 || (_path5994 = /*#__PURE__*/React.createElement("path", {
    d: "M44 86h-1v-1h1z",
    fill: "#836c61",
    fillOpacity: 0.267
  })), _path5995 || (_path5995 = /*#__PURE__*/React.createElement("path", {
    d: "M45 85v1h-1v-1z",
    fill: "#5c4638",
    fillOpacity: 0.141
  })), _path5996 || (_path5996 = /*#__PURE__*/React.createElement("path", {
    d: "M46 85v1h-1v-1z",
    fill: "#7b5746",
    fillOpacity: 0.525
  })), _path5997 || (_path5997 = /*#__PURE__*/React.createElement("path", {
    d: "M47 86h-1v-1h1z",
    fill: "#8c6857",
    fillOpacity: 0.894
  })), _path5998 || (_path5998 = /*#__PURE__*/React.createElement("path", {
    d: "M48 86h-1v-1h1z",
    fill: "#a77d6c"
  })), _path5999 || (_path5999 = /*#__PURE__*/React.createElement("path", {
    d: "M48 85h1v1h-1z",
    fill: "#a37d6d"
  })), _path6000 || (_path6000 = /*#__PURE__*/React.createElement("path", {
    d: "M50 85v1h-1v-1z",
    fill: "#987164",
    fillOpacity: 0.808
  })), _path6001 || (_path6001 = /*#__PURE__*/React.createElement("path", {
    d: "M51 86h-1v-1h1z",
    fill: "#917064",
    fillOpacity: 0.42
  })), _path6002 || (_path6002 = /*#__PURE__*/React.createElement("path", {
    d: "M51 86v-1h1v1z",
    fill: "#867878",
    fillOpacity: 0.075
  })), _path6003 || (_path6003 = /*#__PURE__*/React.createElement("path", {
    d: "M64 85v1h-1v-1z",
    fill: "#7c5239",
    fillOpacity: 0.451
  })), _path6004 || (_path6004 = /*#__PURE__*/React.createElement("path", {
    d: "M65 86h-1v-1h1z",
    fill: "#8c5533"
  })), _path6005 || (_path6005 = /*#__PURE__*/React.createElement("path", {
    d: "M66 86h-1v-1h1z",
    fill: "#844b26"
  })), _path6006 || (_path6006 = /*#__PURE__*/React.createElement("path", {
    d: "M67 85h1v1h-1z",
    fill: "#c59886",
    fillOpacity: 0.957
  })), _path6007 || (_path6007 = /*#__PURE__*/React.createElement("path", {
    d: "M69 85v1h-1v-1z",
    fill: "#bda396",
    fillOpacity: 0.153
  })), _path6008 || (_path6008 = /*#__PURE__*/React.createElement("path", {
    d: "M71 86v-1h1v1z",
    fill: "#7f0000",
    fillOpacity: 0.008
  })), _path6009 || (_path6009 = /*#__PURE__*/React.createElement("path", {
    d: "M73 85v1h-1v-1z",
    fill: "#996d4b",
    fillOpacity: 0.529
  })), _path6010 || (_path6010 = /*#__PURE__*/React.createElement("path", {
    d: "M73 86v-1h1v1z",
    fill: "#b27e4b"
  })), _path6011 || (_path6011 = /*#__PURE__*/React.createElement("path", {
    d: "M74 85h1v1h-1z",
    fill: "#b2814d"
  })), _path6012 || (_path6012 = /*#__PURE__*/React.createElement("path", {
    d: "M75 85h1v1h-1z",
    fill: "#af7f4d"
  })), _path6013 || (_path6013 = /*#__PURE__*/React.createElement("path", {
    d: "M77 85v1h-1v-1z",
    fill: "#af8354"
  })), _path6014 || (_path6014 = /*#__PURE__*/React.createElement("path", {
    d: "M78 86h-1v-1h1z",
    fill: "#ad825a",
    fillOpacity: 0.996
  })), _path6015 || (_path6015 = /*#__PURE__*/React.createElement("path", {
    d: "M79 85v1h-1v-1z",
    fill: "#aa8162",
    fillOpacity: 0.224
  })), _path6016 || (_path6016 = /*#__PURE__*/React.createElement("path", {
    d: "M100 85v1h-1v-1z",
    fill: "#99766d",
    fillOpacity: 0.227
  })), _path6017 || (_path6017 = /*#__PURE__*/React.createElement("path", {
    d: "M100 86v-1h1v1z",
    fill: "#aa7358",
    fillOpacity: 0.996
  })), _path6018 || (_path6018 = /*#__PURE__*/React.createElement("path", {
    d: "M102 85v1h-1v-1z",
    fill: "#9f653f"
  })), _path6019 || (_path6019 = /*#__PURE__*/React.createElement("path", {
    d: "M103 86h-1v-1h1z",
    fill: "#b77d66"
  })), _path6020 || (_path6020 = /*#__PURE__*/React.createElement("path", {
    d: "M103 85h1v1h-1z",
    fill: "#b78c7e",
    fillOpacity: 0.718
  })), _path6021 || (_path6021 = /*#__PURE__*/React.createElement("path", {
    d: "M109 86h-1v-1h1z",
    fill: "#917265",
    fillOpacity: 0.227
  })), _path6022 || (_path6022 = /*#__PURE__*/React.createElement("path", {
    d: "M110 86h-1v-1h1z",
    fill: "#946b4c"
  })), _path6023 || (_path6023 = /*#__PURE__*/React.createElement("path", {
    d: "M110 85h1v1h-1z",
    fill: "#91663f"
  })), _path6024 || (_path6024 = /*#__PURE__*/React.createElement("path", {
    d: "M112 85v1h-1v-1z",
    fill: "#d49454"
  })), _path6025 || (_path6025 = /*#__PURE__*/React.createElement("path", {
    d: "M113 86h-1v-1h1z",
    fill: "#ecaa6f",
    fillOpacity: 0.8
  })), _path6026 || (_path6026 = /*#__PURE__*/React.createElement("path", {
    d: "M10 86v1H9v-1z",
    fill: "#ac7f6c",
    fillOpacity: 0.157
  })), _path6027 || (_path6027 = /*#__PURE__*/React.createElement("path", {
    d: "M10 86h1v1h-1z",
    fill: "#b27b53",
    fillOpacity: 0.957
  })), _path6028 || (_path6028 = /*#__PURE__*/React.createElement("path", {
    d: "M11 86h1v1h-1z",
    fill: "#ae7143"
  })), _path6029 || (_path6029 = /*#__PURE__*/React.createElement("path", {
    d: "M12 87v-1h1v1z",
    fill: "#955425"
  })), _path6030 || (_path6030 = /*#__PURE__*/React.createElement("path", {
    d: "M14 87h-1v-1h1z",
    fill: "#a1643b"
  })), _path6031 || (_path6031 = /*#__PURE__*/React.createElement("path", {
    d: "M14 87v-1h1v1z",
    fill: "#aa7759",
    fillOpacity: 0.996
  })), _path6032 || (_path6032 = /*#__PURE__*/React.createElement("path", {
    d: "M16 86v1h-1v-1z",
    fill: "#ad8771",
    fillOpacity: 0.722
  })), _path6033 || (_path6033 = /*#__PURE__*/React.createElement("path", {
    d: "M16 86h1v1h-1z",
    fill: "#a68b75",
    fillOpacity: 0.451
  })), _path6034 || (_path6034 = /*#__PURE__*/React.createElement("path", {
    d: "M17 87v-1h1v1z",
    fill: "#a58377",
    fillOpacity: 0.235
  })), _path6035 || (_path6035 = /*#__PURE__*/React.createElement("path", {
    d: "M19 87h-1v-1h1z",
    fill: "#7f685c",
    fillOpacity: 0.086
  })), _path6036 || (_path6036 = /*#__PURE__*/React.createElement("path", {
    d: "M22 87h-1v-1h1z",
    fillOpacity: 0.027
  })), _path6037 || (_path6037 = /*#__PURE__*/React.createElement("path", {
    d: "M22 86h1v1h-1z",
    fill: "#6c452e",
    fillOpacity: 0.518
  })), _path6038 || (_path6038 = /*#__PURE__*/React.createElement("path", {
    d: "M24 87h-1v-1h1z",
    fill: "#6f3a1d"
  })), _path6039 || (_path6039 = /*#__PURE__*/React.createElement("path", {
    d: "M25 86v1h-1v-1z",
    fill: "#70371d"
  })), _path6040 || (_path6040 = /*#__PURE__*/React.createElement("path", {
    d: "M26 87h-1v-1h1z",
    fill: "#895236"
  })), _path6041 || (_path6041 = /*#__PURE__*/React.createElement("path", {
    d: "M26 87v-1h1v1z",
    fill: "#a1735d",
    fillOpacity: 0.996
  })), _path6042 || (_path6042 = /*#__PURE__*/React.createElement("path", {
    d: "M27 86h1v1h-1z",
    fill: "#a78e85",
    fillOpacity: 0.239
  })), _path6043 || (_path6043 = /*#__PURE__*/React.createElement("path", {
    d: "M33 86v1h-1v-1z",
    fill: "#7b5645",
    fillOpacity: 0.486
  })), _path6044 || (_path6044 = /*#__PURE__*/React.createElement("path", {
    d: "M34 87v-1h1v1z",
    fill: "#996748"
  })), _path6045 || (_path6045 = /*#__PURE__*/React.createElement("path", {
    d: "M35 86h1v1h-1z",
    fill: "#b98b78"
  })), _path6046 || (_path6046 = /*#__PURE__*/React.createElement("path", {
    d: "M36 87v-1h1v1z",
    fill: "#b88c80",
    fillOpacity: 0.839
  })), _path6047 || (_path6047 = /*#__PURE__*/React.createElement("path", {
    d: "M39 87h-1v-1h1z",
    fill: "#c2a299",
    fillOpacity: 0.314
  })), _path6048 || (_path6048 = /*#__PURE__*/React.createElement("path", {
    d: "M40 86v1h-1v-1z",
    fill: "#cb9789"
  })), _path6049 || (_path6049 = /*#__PURE__*/React.createElement("path", {
    d: "M41 86v1h-1v-1z",
    fill: "#cc9683"
  })), _path6050 || (_path6050 = /*#__PURE__*/React.createElement("path", {
    d: "M41 87v-1h1v1z",
    fill: "#b98269"
  })), _path6051 || (_path6051 = /*#__PURE__*/React.createElement("path", {
    d: "M42 87v-1h1v1z",
    fill: "#a07565",
    fillOpacity: 0.996
  })), _path6052 || (_path6052 = /*#__PURE__*/React.createElement("path", {
    d: "M43 87v-1h1v1z",
    fill: "#876457",
    fillOpacity: 0.796
  })), _path6053 || (_path6053 = /*#__PURE__*/React.createElement("path", {
    d: "M44 87v-1h1v1z",
    fill: "#926f5d",
    fillOpacity: 0.941
  })), _path6054 || (_path6054 = /*#__PURE__*/React.createElement("path", {
    d: "M45 87v-1h1v1z",
    fill: "#a98373"
  })), _path6055 || (_path6055 = /*#__PURE__*/React.createElement("path", {
    d: "M46 87v-1h1v1z",
    fill: "#957263",
    fillOpacity: 0.996
  })), _path6056 || (_path6056 = /*#__PURE__*/React.createElement("path", {
    d: "M48 86v1h-1v-1z",
    fill: "#906f60",
    fillOpacity: 0.718
  })), _path6057 || (_path6057 = /*#__PURE__*/React.createElement("path", {
    d: "M49 86v1h-1v-1z",
    fill: "#8c6f5f",
    fillOpacity: 0.314
  })), _path6058 || (_path6058 = /*#__PURE__*/React.createElement("path", {
    d: "M63 87v-1h1v1z",
    fill: "#764a3d",
    fillOpacity: 0.388
  })), _path6059 || (_path6059 = /*#__PURE__*/React.createElement("path", {
    d: "M65 86v1h-1v-1z",
    fill: "#743821"
  })), _path6060 || (_path6060 = /*#__PURE__*/React.createElement("path", {
    d: "M65 87v-1h1v1z",
    fill: "#6f3716"
  })), _path6061 || (_path6061 = /*#__PURE__*/React.createElement("path", {
    d: "M67 87h-1v-1h1z",
    fill: "#b58169"
  })), _path6062 || (_path6062 = /*#__PURE__*/React.createElement("path", {
    d: "M68 86v1h-1v-1z",
    fill: "#c79c88",
    fillOpacity: 0.973
  })), _path6063 || (_path6063 = /*#__PURE__*/React.createElement("path", {
    d: "M68 87v-1h1v1z",
    fill: "#c3a292",
    fillOpacity: 0.184
  })), _path6064 || (_path6064 = /*#__PURE__*/React.createElement("path", {
    d: "M73 86v1h-1v-1z",
    fill: "#a07552",
    fillOpacity: 0.4
  })), _path6065 || (_path6065 = /*#__PURE__*/React.createElement("path", {
    d: "M74 87h-1v-1h1z",
    fill: "#b27d4a"
  })), _path6066 || (_path6066 = /*#__PURE__*/React.createElement("path", {
    d: "M75 87h-1v-1h1z",
    fill: "#b37f4d"
  })), _path6067 || (_path6067 = /*#__PURE__*/React.createElement("path", {
    d: "M75 87v-1h1v1z",
    fill: "#ae7c4d"
  })), _path6068 || (_path6068 = /*#__PURE__*/React.createElement("path", {
    d: "M76 87v-1h1v1z",
    fill: "#af8356"
  })), _path6069 || (_path6069 = /*#__PURE__*/React.createElement("path", {
    d: "M77 86h1v1h-1z",
    fill: "#b0855d",
    fillOpacity: 0.992
  })), _path6070 || (_path6070 = /*#__PURE__*/React.createElement("path", {
    d: "M79 87h-1v-1h1z",
    fill: "#ae8867",
    fillOpacity: 0.212
  })), _path6071 || (_path6071 = /*#__PURE__*/React.createElement("path", {
    d: "M99 87v-1h1v1z",
    fill: "#a17e70",
    fillOpacity: 0.365
  })), _path6072 || (_path6072 = /*#__PURE__*/React.createElement("path", {
    d: "M101 87h-1v-1h1z",
    fill: "#b07457"
  })), _path6073 || (_path6073 = /*#__PURE__*/React.createElement("path", {
    d: "M102 86v1h-1v-1z",
    fill: "#9f643f"
  })), _path6074 || (_path6074 = /*#__PURE__*/React.createElement("path", {
    d: "M102 86h1v1h-1z",
    fill: "#bd8876"
  })), _path6075 || (_path6075 = /*#__PURE__*/React.createElement("path", {
    d: "M104 87h-1v-1h1z",
    fill: "#b78c84",
    fillOpacity: 0.549
  })), _path6076 || (_path6076 = /*#__PURE__*/React.createElement("path", {
    d: "M108 87v-1h1v1z",
    fill: "#8e756b",
    fillOpacity: 0.204
  })), _path6077 || (_path6077 = /*#__PURE__*/React.createElement("path", {
    d: "M109 87v-1h1v1z",
    fill: "#946c4c",
    fillOpacity: 0.992
  })), _path6078 || (_path6078 = /*#__PURE__*/React.createElement("path", {
    d: "M110 86h1v1h-1z",
    fill: "#91673b"
  })), _path6079 || (_path6079 = /*#__PURE__*/React.createElement("path", {
    d: "M112 87h-1v-1h1z",
    fill: "#db9a5e"
  })), _path6080 || (_path6080 = /*#__PURE__*/React.createElement("path", {
    d: "M113 86v1h-1v-1z",
    fill: "#edac73",
    fillOpacity: 0.761
  })), _path6081 || (_path6081 = /*#__PURE__*/React.createElement("path", {
    d: "M10 87h1v1h-1z",
    fill: "#b17a52",
    fillOpacity: 0.953
  })), _path6082 || (_path6082 = /*#__PURE__*/React.createElement("path", {
    d: "M12 87v1h-1v-1z",
    fill: "#b37649"
  })), _path6083 || (_path6083 = /*#__PURE__*/React.createElement("path", {
    d: "M13 87v1h-1v-1z",
    fill: "#9c5b2b"
  })), _path6084 || (_path6084 = /*#__PURE__*/React.createElement("path", {
    d: "M14 87v1h-1v-1z",
    fill: "#a1602d"
  })), _path6085 || (_path6085 = /*#__PURE__*/React.createElement("path", {
    d: "M14 87h1v1h-1z",
    fill: "#b36f42"
  })), _path6086 || (_path6086 = /*#__PURE__*/React.createElement("path", {
    d: "M16 88h-1v-1h1z",
    fill: "#c8845e"
  })), _path6087 || (_path6087 = /*#__PURE__*/React.createElement("path", {
    d: "M16 87h1v1h-1z",
    fill: "#cf9374"
  })), _path6088 || (_path6088 = /*#__PURE__*/React.createElement("path", {
    d: "M18 88h-1v-1h1z",
    fill: "#c79679"
  })), _path6089 || (_path6089 = /*#__PURE__*/React.createElement("path", {
    d: "M19 87v1h-1v-1z",
    fill: "#bb9378",
    fillOpacity: 0.914
  })), _path6090 || (_path6090 = /*#__PURE__*/React.createElement("path", {
    d: "M19 87h1v1h-1z",
    fill: "#b5917c",
    fillOpacity: 0.761
  })), _path6091 || (_path6091 = /*#__PURE__*/React.createElement("path", {
    d: "M20 87h1v1h-1z",
    fill: "#ab8b77",
    fillOpacity: 0.561
  })), _path6092 || (_path6092 = /*#__PURE__*/React.createElement("path", {
    d: "M21 88v-1h1v1z",
    fill: "#866148",
    fillOpacity: 0.757
  })), _path6093 || (_path6093 = /*#__PURE__*/React.createElement("path", {
    d: "M22 87h1v1h-1z",
    fill: "#733e1d"
  })), _path6094 || (_path6094 = /*#__PURE__*/React.createElement("path", {
    d: "M24 87v1h-1v-1z",
    fill: "#7d4426"
  })), _path6095 || (_path6095 = /*#__PURE__*/React.createElement("path", {
    d: "M25 88h-1v-1h1z",
    fill: "#8f5c45"
  })), _path6096 || (_path6096 = /*#__PURE__*/React.createElement("path", {
    d: "M25 87h1v1h-1z",
    fill: "#a5704f"
  })), _path6097 || (_path6097 = /*#__PURE__*/React.createElement("path", {
    d: "M27 88h-1v-1h1z",
    fill: "#af8366",
    fillOpacity: 0.996
  })), _path6098 || (_path6098 = /*#__PURE__*/React.createElement("path", {
    d: "M27 87h1v1h-1z",
    fill: "#af9183",
    fillOpacity: 0.227
  })), _path6099 || (_path6099 = /*#__PURE__*/React.createElement("path", {
    d: "M33 88h-1v-1h1z",
    fill: "#7b5a47",
    fillOpacity: 0.365
  })), _path6100 || (_path6100 = /*#__PURE__*/React.createElement("path", {
    d: "M35 88v-1h1v1z",
    fill: "#b68673"
  })), _path6101 || (_path6101 = /*#__PURE__*/React.createElement("path", {
    d: "M36 88v-1h1v1z",
    fill: "#b88c7f",
    fillOpacity: 0.918
  })), _path6102 || (_path6102 = /*#__PURE__*/React.createElement("path", {
    d: "M37 87h1v1h-1z",
    fill: "#987",
    fillOpacity: 0.059
  })), _path6103 || (_path6103 = /*#__PURE__*/React.createElement("path", {
    d: "M38 88v-1h1v1z",
    fill: "#c0a198",
    fillOpacity: 0.322
  })), _path6104 || (_path6104 = /*#__PURE__*/React.createElement("path", {
    d: "M40 88h-1v-1h1z",
    fill: "#cb9588"
  })), _path6105 || (_path6105 = /*#__PURE__*/React.createElement("path", {
    d: "M41 87v1h-1v-1z",
    fill: "#cc9482"
  })), _path6106 || (_path6106 = /*#__PURE__*/React.createElement("path", {
    d: "M42 87v1h-1v-1z",
    fill: "#b98068"
  })), _path6107 || (_path6107 = /*#__PURE__*/React.createElement("path", {
    d: "M43 87v1h-1v-1z",
    fill: "#a97c6f"
  })), _path6108 || (_path6108 = /*#__PURE__*/React.createElement("path", {
    d: "M43 88v-1h1v1z",
    fill: "#a27e76"
  })), _path6109 || (_path6109 = /*#__PURE__*/React.createElement("path", {
    d: "M45 87v1h-1v-1z",
    fill: "#916f64",
    fillOpacity: 0.957
  })), _path6110 || (_path6110 = /*#__PURE__*/React.createElement("path", {
    d: "M45 88v-1h1v1z",
    fill: "#977a6e",
    fillOpacity: 0.588
  })), _path6111 || (_path6111 = /*#__PURE__*/React.createElement("path", {
    d: "M47 88h-1v-1h1z",
    fill: "#836960",
    fillOpacity: 0.227
  })), _path6112 || (_path6112 = /*#__PURE__*/React.createElement("path", {
    d: "M62 88v-1h1v1z",
    fill: "#855e4e",
    fillOpacity: 0.255
  })), _path6113 || (_path6113 = /*#__PURE__*/React.createElement("path", {
    d: "M64 87v1h-1v-1z",
    fill: "#9f6c57",
    fillOpacity: 0.757
  })), _path6114 || (_path6114 = /*#__PURE__*/React.createElement("path", {
    d: "M64 88v-1h1v1z",
    fill: "#ad735f"
  })), _path6115 || (_path6115 = /*#__PURE__*/React.createElement("path", {
    d: "M65 88v-1h1v1z",
    fill: "#773f29"
  })), _path6116 || (_path6116 = /*#__PURE__*/React.createElement("path", {
    d: "M67 87v1h-1v-1z",
    fill: "#b07b67"
  })), _path6117 || (_path6117 = /*#__PURE__*/React.createElement("path", {
    d: "M67 87h1v1h-1z",
    fill: "#c89c8c",
    fillOpacity: 0.996
  })), _path6118 || (_path6118 = /*#__PURE__*/React.createElement("path", {
    d: "M69 87v1h-1v-1z",
    fill: "#c29f97",
    fillOpacity: 0.231
  })), _path6119 || (_path6119 = /*#__PURE__*/React.createElement("path", {
    d: "M72 87h1v1h-1z",
    fill: "#9e7755",
    fillOpacity: 0.384
  })), _path6120 || (_path6120 = /*#__PURE__*/React.createElement("path", {
    d: "M74 87v1h-1v-1z",
    fill: "#ad7847"
  })), _path6121 || (_path6121 = /*#__PURE__*/React.createElement("path", {
    d: "M74 88v-1h1v1z",
    fill: "#b17c4c"
  })), _path6122 || (_path6122 = /*#__PURE__*/React.createElement("path", {
    d: "M75 88v-1h1v1z",
    fill: "#ae7c4c"
  })), _path6123 || (_path6123 = /*#__PURE__*/React.createElement("path", {
    d: "M76 87h1v1h-1z",
    fill: "#b18559"
  })), _path6124 || (_path6124 = /*#__PURE__*/React.createElement("path", {
    d: "M78 88h-1v-1h1z",
    fill: "#b38762",
    fillOpacity: 0.988
  })), _path6125 || (_path6125 = /*#__PURE__*/React.createElement("path", {
    d: "M79 88h-1v-1h1z",
    fill: "#af8c6e",
    fillOpacity: 0.2
  })), _path6126 || (_path6126 = /*#__PURE__*/React.createElement("path", {
    d: "M99 87h1v1h-1z",
    fill: "#a47c6d",
    fillOpacity: 0.522
  })), _path6127 || (_path6127 = /*#__PURE__*/React.createElement("path", {
    d: "M101 87v1h-1v-1z",
    fill: "#ac6d4e"
  })), _path6128 || (_path6128 = /*#__PURE__*/React.createElement("path", {
    d: "M102 88h-1v-1h1z",
    fill: "#a36544"
  })), _path6129 || (_path6129 = /*#__PURE__*/React.createElement("path", {
    d: "M102 87h1v1h-1z",
    fill: "#bf8e80"
  })), _path6130 || (_path6130 = /*#__PURE__*/React.createElement("path", {
    d: "M103 87h1v1h-1z",
    fill: "#b49088",
    fillOpacity: 0.388
  })), _path6131 || (_path6131 = /*#__PURE__*/React.createElement("path", {
    d: "M109 88h-1v-1h1z",
    fill: "#9e8277",
    fillOpacity: 0.176
  })), _path6132 || (_path6132 = /*#__PURE__*/React.createElement("path", {
    d: "M109 87h1v1h-1z",
    fill: "#a77e5e",
    fillOpacity: 0.98
  })), _path6133 || (_path6133 = /*#__PURE__*/React.createElement("path", {
    d: "M111 88h-1v-1h1z",
    fill: "#996e43"
  })), _path6134 || (_path6134 = /*#__PURE__*/React.createElement("path", {
    d: "M111 87h1v1h-1z",
    fill: "#de9a61"
  })), _path6135 || (_path6135 = /*#__PURE__*/React.createElement("path", {
    d: "M112 88v-1h1v1z",
    fill: "#f2ae77",
    fillOpacity: 0.71
  })), _path6136 || (_path6136 = /*#__PURE__*/React.createElement("path", {
    d: "M9 89v-1h1v1z",
    fill: "#9e7559",
    fillOpacity: 0.145
  })), _path6137 || (_path6137 = /*#__PURE__*/React.createElement("path", {
    d: "M10 89v-1h1v1z",
    fill: "#ae774e",
    fillOpacity: 0.953
  })), _path6138 || (_path6138 = /*#__PURE__*/React.createElement("path", {
    d: "M12 89h-1v-1h1z",
    fill: "#b3764a"
  })), _path6139 || (_path6139 = /*#__PURE__*/React.createElement("path", {
    d: "M13 88v1h-1v-1z",
    fill: "#9d5e36"
  })), _path6140 || (_path6140 = /*#__PURE__*/React.createElement("path", {
    d: "M13 89v-1h1v1z",
    fill: "#97562e"
  })), _path6141 || (_path6141 = /*#__PURE__*/React.createElement("path", {
    d: "M14 88h1v1h-1z",
    fill: "#92522d",
    fillOpacity: 0.984
  })), _path6142 || (_path6142 = /*#__PURE__*/React.createElement("path", {
    d: "M16 88v1h-1v-1z",
    fill: "#975a2f",
    fillOpacity: 0.573
  })), _path6143 || (_path6143 = /*#__PURE__*/React.createElement("path", {
    d: "M17 89h-1v-1h1z",
    fill: "#9e6235",
    fillOpacity: 0.631
  })), _path6144 || (_path6144 = /*#__PURE__*/React.createElement("path", {
    d: "M18 88v1h-1v-1z",
    fill: "#ae7044",
    fillOpacity: 0.816
  })), _path6145 || (_path6145 = /*#__PURE__*/React.createElement("path", {
    d: "M18 89v-1h1v1z",
    fill: "#b57a4b"
  })), _path6146 || (_path6146 = /*#__PURE__*/React.createElement("path", {
    d: "M20 88h1v1h-1z",
    fill: "#cd956f"
  })), _path6147 || (_path6147 = /*#__PURE__*/React.createElement("path", {
    d: "M21 89v-1h1v1z",
    fill: "#c97"
  })), _path6148 || (_path6148 = /*#__PURE__*/React.createElement("path", {
    d: "M23 88v1h-1v-1z",
    fill: "#c59474"
  })), _path6149 || (_path6149 = /*#__PURE__*/React.createElement("path", {
    d: "M24 89h-1v-1h1z",
    fill: "#bd8c6a"
  })), _path6150 || (_path6150 = /*#__PURE__*/React.createElement("path", {
    d: "M25 89h-1v-1h1z",
    fill: "#ad7e5c"
  })), _path6151 || (_path6151 = /*#__PURE__*/React.createElement("path", {
    d: "M26 89h-1v-1h1z",
    fill: "#a77552"
  })), _path6152 || (_path6152 = /*#__PURE__*/React.createElement("path", {
    d: "M27 88v1h-1v-1z",
    fill: "#a57859",
    fillOpacity: 0.992
  })), _path6153 || (_path6153 = /*#__PURE__*/React.createElement("path", {
    d: "M28 88v1h-1v-1z",
    fill: "#9a7c64",
    fillOpacity: 0.298
  })), _path6154 || (_path6154 = /*#__PURE__*/React.createElement("path", {
    d: "M32 89v-1h1v1z",
    fill: "#775641",
    fillOpacity: 0.243
  })), _path6155 || (_path6155 = /*#__PURE__*/React.createElement("path", {
    d: "M34 88v1h-1v-1z",
    fill: "#8b5a3d"
  })), _path6156 || (_path6156 = /*#__PURE__*/React.createElement("path", {
    d: "M35 88v1h-1v-1z",
    fill: "#935d3d"
  })), _path6157 || (_path6157 = /*#__PURE__*/React.createElement("path", {
    d: "M36 89h-1v-1h1z",
    fill: "#b3836e"
  })), _path6158 || (_path6158 = /*#__PURE__*/React.createElement("path", {
    d: "M36 89v-1h1v1z",
    fill: "#b78d80",
    fillOpacity: 0.976
  })), _path6159 || (_path6159 = /*#__PURE__*/React.createElement("path", {
    d: "M37 89v-1h1v1z",
    fill: "#a28b7b",
    fillOpacity: 0.129
  })), _path6160 || (_path6160 = /*#__PURE__*/React.createElement("path", {
    d: "M39 88v1h-1v-1z",
    fill: "#bf9d94",
    fillOpacity: 0.329
  })), _path6161 || (_path6161 = /*#__PURE__*/React.createElement("path", {
    d: "M39 88h1v1h-1z",
    fill: "#ca9486"
  })), _path6162 || (_path6162 = /*#__PURE__*/React.createElement("path", {
    d: "M41 89h-1v-1h1z",
    fill: "#cd937f"
  })), _path6163 || (_path6163 = /*#__PURE__*/React.createElement("path", {
    d: "M42 89h-1v-1h1z",
    fill: "#b78269"
  })), _path6164 || (_path6164 = /*#__PURE__*/React.createElement("path", {
    d: "M42 89v-1h1v1z",
    fill: "#a88275",
    fillOpacity: 0.996
  })), _path6165 || (_path6165 = /*#__PURE__*/React.createElement("path", {
    d: "M44 88v1h-1v-1z",
    fill: "#8f7770",
    fillOpacity: 0.612
  })), _path6166 || (_path6166 = /*#__PURE__*/React.createElement("path", {
    d: "M45 89h-1v-1h1z",
    fill: "#79615b",
    fillOpacity: 0.165
  })), _path6167 || (_path6167 = /*#__PURE__*/React.createElement("path", {
    d: "M59 89v-1h1v1z",
    fill: "#48486d",
    fillOpacity: 0.027
  })), _path6168 || (_path6168 = /*#__PURE__*/React.createElement("path", {
    d: "M60 89v-1h1v1z",
    fill: "#825649",
    fillOpacity: 0.314
  })), _path6169 || (_path6169 = /*#__PURE__*/React.createElement("path", {
    d: "M62 89h-1v-1h1z",
    fill: "#9a6a55",
    fillOpacity: 0.729
  })), _path6170 || (_path6170 = /*#__PURE__*/React.createElement("path", {
    d: "M63 89h-1v-1h1z",
    fill: "#af7b63"
  })), _path6171 || (_path6171 = /*#__PURE__*/React.createElement("path", {
    d: "M63 88h1v1h-1z",
    fill: "#c58c72"
  })), _path6172 || (_path6172 = /*#__PURE__*/React.createElement("path", {
    d: "M65 88v1h-1v-1z",
    fill: "#b57b65"
  })), _path6173 || (_path6173 = /*#__PURE__*/React.createElement("path", {
    d: "M66 88v1h-1v-1z",
    fill: "#86492e"
  })), _path6174 || (_path6174 = /*#__PURE__*/React.createElement("path", {
    d: "M67 89h-1v-1h1z",
    fill: "#ae7965"
  })), _path6175 || (_path6175 = /*#__PURE__*/React.createElement("path", {
    d: "M68 88v1h-1v-1z",
    fill: "#cc9e91"
  })), _path6176 || (_path6176 = /*#__PURE__*/React.createElement("path", {
    d: "M69 89h-1v-1h1z",
    fill: "#be9e96",
    fillOpacity: 0.278
  })), _path6177 || (_path6177 = /*#__PURE__*/React.createElement("path", {
    d: "M73 88v1h-1v-1z",
    fill: "#956c4e",
    fillOpacity: 0.369
  })), _path6178 || (_path6178 = /*#__PURE__*/React.createElement("path", {
    d: "M74 89h-1v-1h1z",
    fill: "#a87546"
  })), _path6179 || (_path6179 = /*#__PURE__*/React.createElement("path", {
    d: "M74 88h1v1h-1z",
    fill: "#ad7949"
  })), _path6180 || (_path6180 = /*#__PURE__*/React.createElement("path", {
    d: "M76 88v1h-1v-1z",
    fill: "#a87547"
  })), _path6181 || (_path6181 = /*#__PURE__*/React.createElement("path", {
    d: "M76 88h1v1h-1z",
    fill: "#af8359"
  })), _path6182 || (_path6182 = /*#__PURE__*/React.createElement("path", {
    d: "M77 89v-1h1v1z",
    fill: "#b38965",
    fillOpacity: 0.984
  })), _path6183 || (_path6183 = /*#__PURE__*/React.createElement("path", {
    d: "M78 89v-1h1v1z",
    fill: "#ad8d71",
    fillOpacity: 0.184
  })), _path6184 || (_path6184 = /*#__PURE__*/React.createElement("path", {
    d: "M99 89v-1h1v1z",
    fill: "#a1725f",
    fillOpacity: 0.663
  })), _path6185 || (_path6185 = /*#__PURE__*/React.createElement("path", {
    d: "M101 89h-1v-1h1z",
    fill: "#a56543"
  })), _path6186 || (_path6186 = /*#__PURE__*/React.createElement("path", {
    d: "M102 88v1h-1v-1z",
    fill: "#ac6f50"
  })), _path6187 || (_path6187 = /*#__PURE__*/React.createElement("path", {
    d: "M103 89h-1v-1h1z",
    fill: "#ba9082",
    fillOpacity: 0.992
  })), _path6188 || (_path6188 = /*#__PURE__*/React.createElement("path", {
    d: "M104 88v1h-1v-1z",
    fill: "#a88e85",
    fillOpacity: 0.231
  })), _path6189 || (_path6189 = /*#__PURE__*/React.createElement("path", {
    d: "M108 88h1v1h-1z",
    fill: "#9d857f",
    fillOpacity: 0.165
  })), _path6190 || (_path6190 = /*#__PURE__*/React.createElement("path", {
    d: "M109 89v-1h1v1z",
    fill: "#ac8465",
    fillOpacity: 0.973
  })), _path6191 || (_path6191 = /*#__PURE__*/React.createElement("path", {
    d: "M111 88v1h-1v-1z",
    fill: "#9f7147"
  })), _path6192 || (_path6192 = /*#__PURE__*/React.createElement("path", {
    d: "M111 88h1v1h-1z",
    fill: "#dc965f"
  })), _path6193 || (_path6193 = /*#__PURE__*/React.createElement("path", {
    d: "M112 88h1v1h-1z",
    fill: "#eca874",
    fillOpacity: 0.659
  })), _path6194 || (_path6194 = /*#__PURE__*/React.createElement("path", {
    d: "M9 89h1v1H9z",
    fill: "#a17857",
    fillOpacity: 0.149
  })), _path6195 || (_path6195 = /*#__PURE__*/React.createElement("path", {
    d: "M11 90h-1v-1h1z",
    fill: "#ad764c",
    fillOpacity: 0.953
  })), _path6196 || (_path6196 = /*#__PURE__*/React.createElement("path", {
    d: "M12 89v1h-1v-1z",
    fill: "#b07348"
  })), _path6197 || (_path6197 = /*#__PURE__*/React.createElement("path", {
    d: "M12 90v-1h1v1z",
    fill: "#9b613b"
  })), _path6198 || (_path6198 = /*#__PURE__*/React.createElement("path", {
    d: "M14 89v1h-1v-1z",
    fill: "#995c32"
  })), _path6199 || (_path6199 = /*#__PURE__*/React.createElement("path", {
    d: "M15 90h-1v-1h1z",
    fill: "#895536",
    fillOpacity: 0.973
  })), _path6200 || (_path6200 = /*#__PURE__*/React.createElement("path", {
    d: "M16 90h-1v-1h1z",
    fill: "#77665d",
    fillOpacity: 0.118
  })), _path6201 || (_path6201 = /*#__PURE__*/React.createElement("path", {
    d: "M16 89h1v1h-1z",
    fill: "#5ff",
    fillOpacity: 0.012
  })), _path6202 || (_path6202 = /*#__PURE__*/React.createElement("path", {
    d: "M17 90v-1h1v1z",
    fill: "#68412c",
    fillOpacity: 0.49
  })), _path6203 || (_path6203 = /*#__PURE__*/React.createElement("path", {
    d: "M19 89v1h-1v-1z",
    fill: "#74391a",
    fillOpacity: 0.996
  })), _path6204 || (_path6204 = /*#__PURE__*/React.createElement("path", {
    d: "M21 89v1h-1v-1z",
    fill: "#a06642",
    fillOpacity: 0.824
  })), _path6205 || (_path6205 = /*#__PURE__*/React.createElement("path", {
    d: "M22 90h-1v-1h1z",
    fill: "#ad704e",
    fillOpacity: 0.714
  })), _path6206 || (_path6206 = /*#__PURE__*/React.createElement("path", {
    d: "M22 90v-1h1v1z",
    fill: "#b67a56",
    fillOpacity: 0.882
  })), _path6207 || (_path6207 = /*#__PURE__*/React.createElement("path", {
    d: "M24 89v1h-1v-1z",
    fill: "#bf8358"
  })), _path6208 || (_path6208 = /*#__PURE__*/React.createElement("path", {
    d: "M24 90v-1h1v1z",
    fill: "#c1895e"
  })), _path6209 || (_path6209 = /*#__PURE__*/React.createElement("path", {
    d: "M26 89v1h-1v-1z",
    fill: "#c78c67"
  })), _path6210 || (_path6210 = /*#__PURE__*/React.createElement("path", {
    d: "M26 90v-1h1v1z",
    fill: "#c28b66"
  })), _path6211 || (_path6211 = /*#__PURE__*/React.createElement("path", {
    d: "M28 90h-1v-1h1z",
    fill: "#ba8a69",
    fillOpacity: 0.945
  })), _path6212 || (_path6212 = /*#__PURE__*/React.createElement("path", {
    d: "M29 89v1h-1v-1z",
    fill: "#b2856f",
    fillOpacity: 0.78
  })), _path6213 || (_path6213 = /*#__PURE__*/React.createElement("path", {
    d: "M29 89h1v1h-1z",
    fill: "#ab826a",
    fillOpacity: 0.573
  })), _path6214 || (_path6214 = /*#__PURE__*/React.createElement("path", {
    d: "M31 89v1h-1v-1z",
    fill: "#997760",
    fillOpacity: 0.353
  })), _path6215 || (_path6215 = /*#__PURE__*/React.createElement("path", {
    d: "M33 90h-1v-1h1z",
    fill: "#81604c",
    fillOpacity: 0.208
  })), _path6216 || (_path6216 = /*#__PURE__*/React.createElement("path", {
    d: "M34 90h-1v-1h1z",
    fill: "#895a3c",
    fillOpacity: 0.957
  })), _path6217 || (_path6217 = /*#__PURE__*/React.createElement("path", {
    d: "M34 89h1v1h-1z",
    fill: "#945c3c"
  })), _path6218 || (_path6218 = /*#__PURE__*/React.createElement("path", {
    d: "M36 89v1h-1v-1z",
    fill: "#b07e6a"
  })), _path6219 || (_path6219 = /*#__PURE__*/React.createElement("path", {
    d: "M37 89v1h-1v-1z",
    fill: "#b78c80"
  })), _path6220 || (_path6220 = /*#__PURE__*/React.createElement("path", {
    d: "M38 90h-1v-1h1z",
    fill: "#ad9086",
    fillOpacity: 0.208
  })), _path6221 || (_path6221 = /*#__PURE__*/React.createElement("path", {
    d: "M38 89h1v1h-1z",
    fill: "#bd9b95",
    fillOpacity: 0.322
  })), _path6222 || (_path6222 = /*#__PURE__*/React.createElement("path", {
    d: "M40 89v1h-1v-1z",
    fill: "#cb9482"
  })), _path6223 || (_path6223 = /*#__PURE__*/React.createElement("path", {
    d: "M40 90v-1h1v1z",
    fill: "#cf947c"
  })), _path6224 || (_path6224 = /*#__PURE__*/React.createElement("path", {
    d: "M41 89h1v1h-1z",
    fill: "#b88068"
  })), _path6225 || (_path6225 = /*#__PURE__*/React.createElement("path", {
    d: "M43 90h-1v-1h1z",
    fill: "#a48175",
    fillOpacity: 0.965
  })), _path6226 || (_path6226 = /*#__PURE__*/React.createElement("path", {
    d: "M44 89v1h-1v-1z",
    fill: "#ac9797",
    fillOpacity: 0.145
  })), _path6227 || (_path6227 = /*#__PURE__*/React.createElement("path", {
    d: "M58 89v1h-1v-1z",
    fill: "#626262",
    fillOpacity: 0.051
  })), _path6228 || (_path6228 = /*#__PURE__*/React.createElement("path", {
    d: "M59 89v1h-1v-1z",
    fill: "#674237",
    fillOpacity: 0.376
  })), _path6229 || (_path6229 = /*#__PURE__*/React.createElement("path", {
    d: "M60 89v1h-1v-1z",
    fill: "#835240",
    fillOpacity: 0.788
  })), _path6230 || (_path6230 = /*#__PURE__*/React.createElement("path", {
    d: "M60 90v-1h1v1z",
    fill: "#a66e5b"
  })), _path6231 || (_path6231 = /*#__PURE__*/React.createElement("path", {
    d: "M61 89h1v1h-1z",
    fill: "#b78171"
  })), _path6232 || (_path6232 = /*#__PURE__*/React.createElement("path", {
    d: "M63 90h-1v-1h1z",
    fill: "#a97e6c",
    fillOpacity: 0.82
  })), _path6233 || (_path6233 = /*#__PURE__*/React.createElement("path", {
    d: "M63 90v-1h1v1z",
    fill: "#9c6f5d",
    fillOpacity: 0.612
  })), _path6234 || (_path6234 = /*#__PURE__*/React.createElement("path", {
    d: "M65 89v1h-1v-1z",
    fill: "#8d533c",
    fillOpacity: 0.988
  })), _path6235 || (_path6235 = /*#__PURE__*/React.createElement("path", {
    d: "M66 89v1h-1v-1z",
    fill: "#8c4f28"
  })), _path6236 || (_path6236 = /*#__PURE__*/React.createElement("path", {
    d: "M66 89h1v1h-1z",
    fill: "#b27b64"
  })), _path6237 || (_path6237 = /*#__PURE__*/React.createElement("path", {
    d: "M67 90v-1h1v1z",
    fill: "#d2a495"
  })), _path6238 || (_path6238 = /*#__PURE__*/React.createElement("path", {
    d: "M69 90h-1v-1h1z",
    fill: "#c09d97",
    fillOpacity: 0.318
  })), _path6239 || (_path6239 = /*#__PURE__*/React.createElement("path", {
    d: "M72 90v-1h1v1z",
    fill: "#956f55",
    fillOpacity: 0.341
  })), _path6240 || (_path6240 = /*#__PURE__*/React.createElement("path", {
    d: "M73 89h1v1h-1z",
    fill: "#a8764b"
  })), _path6241 || (_path6241 = /*#__PURE__*/React.createElement("path", {
    d: "M74 90v-1h1v1z",
    fill: "#af7a4b"
  })), _path6242 || (_path6242 = /*#__PURE__*/React.createElement("path", {
    d: "M76 89v1h-1v-1z",
    fill: "#a47245"
  })), _path6243 || (_path6243 = /*#__PURE__*/React.createElement("path", {
    d: "M77 89v1h-1v-1z",
    fill: "#b0845a"
  })), _path6244 || (_path6244 = /*#__PURE__*/React.createElement("path", {
    d: "M77 90v-1h1v1z",
    fill: "#b58a67",
    fillOpacity: 0.973
  })), _path6245 || (_path6245 = /*#__PURE__*/React.createElement("path", {
    d: "M79 89v1h-1v-1z",
    fill: "#aa8573",
    fillOpacity: 0.165
  })), _path6246 || (_path6246 = /*#__PURE__*/React.createElement("path", {
    d: "M99 89h1v1h-1z",
    fill: "#a16a54",
    fillOpacity: 0.78
  })), _path6247 || (_path6247 = /*#__PURE__*/React.createElement("path", {
    d: "M101 89v1h-1v-1z",
    fill: "#a86642"
  })), _path6248 || (_path6248 = /*#__PURE__*/React.createElement("path", {
    d: "M101 90v-1h1v1z",
    fill: "#ba7f62"
  })), _path6249 || (_path6249 = /*#__PURE__*/React.createElement("path", {
    d: "M103 89v1h-1v-1z",
    fill: "#b79185",
    fillOpacity: 0.929
  })), _path6250 || (_path6250 = /*#__PURE__*/React.createElement("path", {
    d: "M103 90v-1h1v1z",
    fill: "#9c8989",
    fillOpacity: 0.102
  })), _path6251 || (_path6251 = /*#__PURE__*/React.createElement("path", {
    d: "M109 89v1h-1v-1z",
    fill: "#a38f82",
    fillOpacity: 0.153
  })), _path6252 || (_path6252 = /*#__PURE__*/React.createElement("path", {
    d: "M109 90v-1h1v1z",
    fill: "#a67f62",
    fillOpacity: 0.965
  })), _path6253 || (_path6253 = /*#__PURE__*/React.createElement("path", {
    d: "M111 90h-1v-1h1z",
    fill: "#9f6f46"
  })), _path6254 || (_path6254 = /*#__PURE__*/React.createElement("path", {
    d: "M112 90h-1v-1h1z",
    fill: "#e09863"
  })), _path6255 || (_path6255 = /*#__PURE__*/React.createElement("path", {
    d: "M113 90h-1v-1h1z",
    fill: "#e8a572",
    fillOpacity: 0.627
  })), _path6256 || (_path6256 = /*#__PURE__*/React.createElement("path", {
    d: "M10 90h1v1h-1z",
    fill: "#ac7549",
    fillOpacity: 0.953
  })), _path6257 || (_path6257 = /*#__PURE__*/React.createElement("path", {
    d: "M11 90h1v1h-1z",
    fill: "#af7243"
  })), _path6258 || (_path6258 = /*#__PURE__*/React.createElement("path", {
    d: "M12 90h1v1h-1z",
    fill: "#9b6238"
  })), _path6259 || (_path6259 = /*#__PURE__*/React.createElement("path", {
    d: "M14 90v1h-1v-1z",
    fill: "#995c35"
  })), _path6260 || (_path6260 = /*#__PURE__*/React.createElement("path", {
    d: "M15 91h-1v-1h1z",
    fill: "#8e5837",
    fillOpacity: 0.973
  })), _path6261 || (_path6261 = /*#__PURE__*/React.createElement("path", {
    d: "M15 90h1v1h-1z",
    fill: "#774f3a",
    fillOpacity: 0.478
  })), _path6262 || (_path6262 = /*#__PURE__*/React.createElement("path", {
    d: "M16 91v-1h1v1z",
    fill: "#5f3422",
    fillOpacity: 0.784
  })), _path6263 || (_path6263 = /*#__PURE__*/React.createElement("path", {
    d: "M18 90v1h-1v-1z",
    fill: "#69361c"
  })), _path6264 || (_path6264 = /*#__PURE__*/React.createElement("path", {
    d: "M18 91v-1h1v1z",
    fill: "#6f402b",
    fillOpacity: 0.929
  })), _path6265 || (_path6265 = /*#__PURE__*/React.createElement("path", {
    d: "M20 91h-1v-1h1z",
    fill: "#755242",
    fillOpacity: 0.494
  })), _path6266 || (_path6266 = /*#__PURE__*/React.createElement("path", {
    d: "M21 90v1h-1v-1z",
    fill: "#5f5f5f",
    fillOpacity: 0.063
  })), _path6267 || (_path6267 = /*#__PURE__*/React.createElement("path", {
    d: "M22 91v-1h1v1z",
    fill: "#8c6446",
    fillOpacity: 0.2
  })), _path6268 || (_path6268 = /*#__PURE__*/React.createElement("path", {
    d: "M23 91v-1h1v1z",
    fill: "#9d663d",
    fillOpacity: 0.965
  })), _path6269 || (_path6269 = /*#__PURE__*/React.createElement("path", {
    d: "M24 90h1v1h-1z",
    fill: "#a66b3d"
  })), _path6270 || (_path6270 = /*#__PURE__*/React.createElement("path", {
    d: "M25 90h1v1h-1z",
    fill: "#a96e44"
  })), _path6271 || (_path6271 = /*#__PURE__*/React.createElement("path", {
    d: "M26 90h1v1h-1z",
    fill: "#b67446"
  })), _path6272 || (_path6272 = /*#__PURE__*/React.createElement("path", {
    d: "M27 91v-1h1v1z",
    fill: "#b47a51",
    fillOpacity: 0.98
  })), _path6273 || (_path6273 = /*#__PURE__*/React.createElement("path", {
    d: "M28 91v-1h1v1z",
    fill: "#c48659"
  })), _path6274 || (_path6274 = /*#__PURE__*/React.createElement("path", {
    d: "M30 90v1h-1v-1z",
    fill: "#cf8f62"
  })), _path6275 || (_path6275 = /*#__PURE__*/React.createElement("path", {
    d: "M30 91v-1h1v1z",
    fill: "#cc8f67"
  })), _path6276 || (_path6276 = /*#__PURE__*/React.createElement("path", {
    d: "M31 90h1v1h-1z",
    fill: "#bc8663",
    fillOpacity: 0.98
  })), _path6277 || (_path6277 = /*#__PURE__*/React.createElement("path", {
    d: "M32 91v-1h1v1z",
    fill: "#b5815f",
    fillOpacity: 0.894
  })), _path6278 || (_path6278 = /*#__PURE__*/React.createElement("path", {
    d: "M33 91v-1h1v1z",
    fill: "#a67350",
    fillOpacity: 0.988
  })), _path6279 || (_path6279 = /*#__PURE__*/React.createElement("path", {
    d: "M35 90v1h-1v-1z",
    fill: "#a06a48"
  })), _path6280 || (_path6280 = /*#__PURE__*/React.createElement("path", {
    d: "M36 90v1h-1v-1z",
    fill: "#ab7558"
  })), _path6281 || (_path6281 = /*#__PURE__*/React.createElement("path", {
    d: "M37 90v1h-1v-1z",
    fill: "#b78873"
  })), _path6282 || (_path6282 = /*#__PURE__*/React.createElement("path", {
    d: "M38 90v1h-1v-1z",
    fill: "#ab8a7b",
    fillOpacity: 0.333
  })), _path6283 || (_path6283 = /*#__PURE__*/React.createElement("path", {
    d: "M38 91v-1h1v1z",
    fill: "#c19c9c",
    fillOpacity: 0.294
  })), _path6284 || (_path6284 = /*#__PURE__*/React.createElement("path", {
    d: "M39 90h1v1h-1z",
    fill: "#ce927e"
  })), _path6285 || (_path6285 = /*#__PURE__*/React.createElement("path", {
    d: "M40 90h1v1h-1z",
    fill: "#cc927a"
  })), _path6286 || (_path6286 = /*#__PURE__*/React.createElement("path", {
    d: "M42 91h-1v-1h1z",
    fill: "#b68067"
  })), _path6287 || (_path6287 = /*#__PURE__*/React.createElement("path", {
    d: "M42 90h1v1h-1z",
    fill: "#a58277",
    fillOpacity: 0.949
  })), _path6288 || (_path6288 = /*#__PURE__*/React.createElement("path", {
    d: "M43 91v-1h1v1z",
    fill: "#a29494",
    fillOpacity: 0.141
  })), _path6289 || (_path6289 = /*#__PURE__*/React.createElement("path", {
    d: "M56 91h-1v-1h1z",
    fill: "#593f33",
    fillOpacity: 0.078
  })), _path6290 || (_path6290 = /*#__PURE__*/React.createElement("path", {
    d: "M57 90v1h-1v-1z",
    fill: "#593328",
    fillOpacity: 0.424
  })), _path6291 || (_path6291 = /*#__PURE__*/React.createElement("path", {
    d: "M58 91h-1v-1h1z",
    fill: "#5c2f1f",
    fillOpacity: 0.835
  })), _path6292 || (_path6292 = /*#__PURE__*/React.createElement("path", {
    d: "M58 91v-1h1v1z",
    fill: "#774430"
  })), _path6293 || (_path6293 = /*#__PURE__*/React.createElement("path", {
    d: "M59 90h1v1h-1z",
    fill: "#94614e"
  })), _path6294 || (_path6294 = /*#__PURE__*/React.createElement("path", {
    d: "M60 90h1v1h-1z",
    fill: "#9e6f63",
    fillOpacity: 0.796
  })), _path6295 || (_path6295 = /*#__PURE__*/React.createElement("path", {
    d: "M62 90v1h-1v-1z",
    fill: "#a17b73",
    fillOpacity: 0.373
  })), _path6296 || (_path6296 = /*#__PURE__*/React.createElement("path", {
    d: "M63 90v1h-1v-1z",
    fill: "#a2a2a2",
    fillOpacity: 0.043
  })), _path6297 || (_path6297 = /*#__PURE__*/React.createElement("path", {
    d: "M64 91h-1v-1h1z",
    fill: "#6d5050",
    fillOpacity: 0.137
  })), _path6298 || (_path6298 = /*#__PURE__*/React.createElement("path", {
    d: "M65 91h-1v-1h1z",
    fill: "#8e5838",
    fillOpacity: 0.969
  })), _path6299 || (_path6299 = /*#__PURE__*/React.createElement("path", {
    d: "M66 90h1v1h-1z",
    fill: "#af7a5e"
  })), _path6300 || (_path6300 = /*#__PURE__*/React.createElement("path", {
    d: "M67 90h1v1h-1z",
    fill: "#d5a899"
  })), _path6301 || (_path6301 = /*#__PURE__*/React.createElement("path", {
    d: "M69 90v1h-1v-1z",
    fill: "#bf9b95",
    fillOpacity: 0.38
  })), _path6302 || (_path6302 = /*#__PURE__*/React.createElement("path", {
    d: "M72 91v-1h1v1z",
    fill: "#987052",
    fillOpacity: 0.302
  })), _path6303 || (_path6303 = /*#__PURE__*/React.createElement("path", {
    d: "M73 91v-1h1v1z",
    fill: "#a97449"
  })), _path6304 || (_path6304 = /*#__PURE__*/React.createElement("path", {
    d: "M75 91h-1v-1h1z",
    fill: "#af7b4b"
  })), _path6305 || (_path6305 = /*#__PURE__*/React.createElement("path", {
    d: "M75 90h1v1h-1z",
    fill: "#a77749"
  })), _path6306 || (_path6306 = /*#__PURE__*/React.createElement("path", {
    d: "M77 91h-1v-1h1z",
    fill: "#b5875d"
  })), _path6307 || (_path6307 = /*#__PURE__*/React.createElement("path", {
    d: "M78 90v1h-1v-1z",
    fill: "#b68d6b",
    fillOpacity: 0.953
  })), _path6308 || (_path6308 = /*#__PURE__*/React.createElement("path", {
    d: "M79 91h-1v-1h1z",
    fill: "#aa8b73",
    fillOpacity: 0.129
  })), _path6309 || (_path6309 = /*#__PURE__*/React.createElement("path", {
    d: "M99 90v1h-1v-1z",
    fill: "#967f73",
    fillOpacity: 0.086
  })), _path6310 || (_path6310 = /*#__PURE__*/React.createElement("path", {
    d: "M99 90h1v1h-1z",
    fill: "#a66b50",
    fillOpacity: 0.914
  })), _path6311 || (_path6311 = /*#__PURE__*/React.createElement("path", {
    d: "M100 91v-1h1v1z",
    fill: "#a96847"
  })), _path6312 || (_path6312 = /*#__PURE__*/React.createElement("path", {
    d: "M102 90v1h-1v-1z",
    fill: "#c3876c"
  })), _path6313 || (_path6313 = /*#__PURE__*/React.createElement("path", {
    d: "M103 91h-1v-1h1z",
    fill: "#b08e8a",
    fillOpacity: 0.816
  })), _path6314 || (_path6314 = /*#__PURE__*/React.createElement("path", {
    d: "M103 90h1v1h-1z",
    fill: "#966",
    fillOpacity: 0.02
  })), _path6315 || (_path6315 = /*#__PURE__*/React.createElement("path", {
    d: "M109 91h-1v-1h1z",
    fill: "#aa948d",
    fillOpacity: 0.141
  })), _path6316 || (_path6316 = /*#__PURE__*/React.createElement("path", {
    d: "M109 90h1v1h-1z",
    fill: "#a68064",
    fillOpacity: 0.957
  })), _path6317 || (_path6317 = /*#__PURE__*/React.createElement("path", {
    d: "M110 90h1v1h-1z",
    fill: "#9e6f4b"
  })), _path6318 || (_path6318 = /*#__PURE__*/React.createElement("path", {
    d: "M112 90v1h-1v-1z",
    fill: "#e49b64"
  })), _path6319 || (_path6319 = /*#__PURE__*/React.createElement("path", {
    d: "M112 91v-1h1v1z",
    fill: "#eba673",
    fillOpacity: 0.6
  })), _path6320 || (_path6320 = /*#__PURE__*/React.createElement("path", {
    d: "M10 91v1H9v-1z",
    fill: "#a3755b",
    fillOpacity: 0.153
  })), _path6321 || (_path6321 = /*#__PURE__*/React.createElement("path", {
    d: "M10 92v-1h1v1z",
    fill: "#aa7548",
    fillOpacity: 0.957
  })), _path6322 || (_path6322 = /*#__PURE__*/React.createElement("path", {
    d: "M13 91h1v1h-1z",
    fill: "#995c38"
  })), _path6323 || (_path6323 = /*#__PURE__*/React.createElement("path", {
    d: "M15 91v1h-1v-1z",
    fill: "#945834"
  })), _path6324 || (_path6324 = /*#__PURE__*/React.createElement("path", {
    d: "M16 92h-1v-1h1z",
    fill: "#723c1e"
  })), _path6325 || (_path6325 = /*#__PURE__*/React.createElement("path", {
    d: "M16 91h1v1h-1z",
    fill: "#6a3824"
  })), _path6326 || (_path6326 = /*#__PURE__*/React.createElement("path", {
    d: "M17 92v-1h1v1z",
    fill: "#744c3a",
    fillOpacity: 0.678
  })), _path6327 || (_path6327 = /*#__PURE__*/React.createElement("path", {
    d: "M19 92h-1v-1h1z",
    fill: "#826a5e",
    fillOpacity: 0.169
  })), _path6328 || (_path6328 = /*#__PURE__*/React.createElement("path", {
    d: "M23 91v1h-1v-1z",
    fill: "#836650",
    fillOpacity: 0.137
  })), _path6329 || (_path6329 = /*#__PURE__*/React.createElement("path", {
    d: "M24 91v1h-1v-1z",
    fill: "#94663e",
    fillOpacity: 0.957
  })), _path6330 || (_path6330 = /*#__PURE__*/React.createElement("path", {
    d: "M25 91v1h-1v-1z",
    fill: "#996437"
  })), _path6331 || (_path6331 = /*#__PURE__*/React.createElement("path", {
    d: "M25 92v-1h1v1z",
    fill: "#936038"
  })), _path6332 || (_path6332 = /*#__PURE__*/React.createElement("path", {
    d: "M27 92h-1v-1h1z",
    fill: "#a7734f",
    fillOpacity: 0.969
  })), _path6333 || (_path6333 = /*#__PURE__*/React.createElement("path", {
    d: "M27 91h1v1h-1z",
    fill: "#a1785a",
    fillOpacity: 0.298
  })), _path6334 || (_path6334 = /*#__PURE__*/React.createElement("path", {
    d: "M28 91h1v1h-1z",
    fill: "#a16e44",
    fillOpacity: 0.29
  })), _path6335 || (_path6335 = /*#__PURE__*/React.createElement("path", {
    d: "M29 92v-1h1v1z",
    fill: "#aa6a3f",
    fillOpacity: 0.486
  })), _path6336 || (_path6336 = /*#__PURE__*/React.createElement("path", {
    d: "M30 91h1v1h-1z",
    fill: "#ac7148",
    fillOpacity: 0.706
  })), _path6337 || (_path6337 = /*#__PURE__*/React.createElement("path", {
    d: "M31 92v-1h1v1z",
    fill: "#b37549",
    fillOpacity: 0.886
  })), _path6338 || (_path6338 = /*#__PURE__*/React.createElement("path", {
    d: "M32 91h1v1h-1z",
    fill: "#b77949"
  })), _path6339 || (_path6339 = /*#__PURE__*/React.createElement("path", {
    d: "M33 91h1v1h-1z",
    fill: "#c28254"
  })), _path6340 || (_path6340 = /*#__PURE__*/React.createElement("path", {
    d: "M34 92v-1h1v1z",
    fill: "#c38759"
  })), _path6341 || (_path6341 = /*#__PURE__*/React.createElement("path", {
    d: "M36 92h-1v-1h1z",
    fill: "#bc845a"
  })), _path6342 || (_path6342 = /*#__PURE__*/React.createElement("path", {
    d: "M37 91v1h-1v-1z",
    fill: "#b7815c"
  })), _path6343 || (_path6343 = /*#__PURE__*/React.createElement("path", {
    d: "M38 92h-1v-1h1z",
    fill: "#ab7758",
    fillOpacity: 0.843
  })), _path6344 || (_path6344 = /*#__PURE__*/React.createElement("path", {
    d: "M39 92h-1v-1h1z",
    fill: "#b2816a",
    fillOpacity: 0.749
  })), _path6345 || (_path6345 = /*#__PURE__*/React.createElement("path", {
    d: "M39 91h1v1h-1z",
    fill: "#c9907f"
  })), _path6346 || (_path6346 = /*#__PURE__*/React.createElement("path", {
    d: "M40 91h1v1h-1z",
    fill: "#c98f77"
  })), _path6347 || (_path6347 = /*#__PURE__*/React.createElement("path", {
    d: "M41 92v-1h1v1z",
    fill: "#b58065"
  })), _path6348 || (_path6348 = /*#__PURE__*/React.createElement("path", {
    d: "M43 91v1h-1v-1z",
    fill: "#a58276",
    fillOpacity: 0.937
  })), _path6349 || (_path6349 = /*#__PURE__*/React.createElement("path", {
    d: "M44 92h-1v-1h1z",
    fill: "#9f8f8f",
    fillOpacity: 0.125
  })), _path6350 || (_path6350 = /*#__PURE__*/React.createElement("path", {
    d: "M53 92v-1h1v1z",
    fill: "#4f3d3d",
    fillOpacity: 0.114
  })), _path6351 || (_path6351 = /*#__PURE__*/React.createElement("path", {
    d: "M55 91v1h-1v-1z",
    fill: "#5d392a",
    fillOpacity: 0.49
  })), _path6352 || (_path6352 = /*#__PURE__*/React.createElement("path", {
    d: "M56 91v1h-1v-1z",
    fill: "#63341e",
    fillOpacity: 0.875
  })), _path6353 || (_path6353 = /*#__PURE__*/React.createElement("path", {
    d: "M56 92v-1h1v1z",
    fill: "#6f3920"
  })), _path6354 || (_path6354 = /*#__PURE__*/React.createElement("path", {
    d: "M58 91v1h-1v-1z",
    fill: "#7a4632"
  })), _path6355 || (_path6355 = /*#__PURE__*/React.createElement("path", {
    d: "M58 92v-1h1v1z",
    fill: "#87594c",
    fillOpacity: 0.745
  })), _path6356 || (_path6356 = /*#__PURE__*/React.createElement("path", {
    d: "M60 91v1h-1v-1z",
    fill: "#8e7067",
    fillOpacity: 0.329
  })), _path6357 || (_path6357 = /*#__PURE__*/React.createElement("path", {
    d: "M60 91h1v1h-1z",
    fill: "#91b6b6",
    fillOpacity: 0.027
  })), _path6358 || (_path6358 = /*#__PURE__*/React.createElement("path", {
    d: "M63 92v-1h1v1z",
    fill: "#7b6057",
    fillOpacity: 0.114
  })), _path6359 || (_path6359 = /*#__PURE__*/React.createElement("path", {
    d: "M65 91v1h-1v-1z",
    fill: "#8e5a37",
    fillOpacity: 0.941
  })), _path6360 || (_path6360 = /*#__PURE__*/React.createElement("path", {
    d: "M66 91v1h-1v-1z",
    fill: "#935830"
  })), _path6361 || (_path6361 = /*#__PURE__*/React.createElement("path", {
    d: "M67 92h-1v-1h1z",
    fill: "#ab7559"
  })), _path6362 || (_path6362 = /*#__PURE__*/React.createElement("path", {
    d: "M67 91h1v1h-1z",
    fill: "#d8a99b"
  })), _path6363 || (_path6363 = /*#__PURE__*/React.createElement("path", {
    d: "M69 92h-1v-1h1z",
    fill: "#c49f98",
    fillOpacity: 0.459
  })), _path6364 || (_path6364 = /*#__PURE__*/React.createElement("path", {
    d: "M72 92v-1h1v1z",
    fill: "#956d50",
    fillOpacity: 0.275
  })), _path6365 || (_path6365 = /*#__PURE__*/React.createElement("path", {
    d: "M73 91h1v1h-1z",
    fill: "#a77348"
  })), _path6366 || (_path6366 = /*#__PURE__*/React.createElement("path", {
    d: "M75 91v1h-1v-1z",
    fill: "#b17c4d"
  })), _path6367 || (_path6367 = /*#__PURE__*/React.createElement("path", {
    d: "M76 92h-1v-1h1z",
    fill: "#a8774a"
  })), _path6368 || (_path6368 = /*#__PURE__*/React.createElement("path", {
    d: "M77 92h-1v-1h1z",
    fill: "#b78960"
  })), _path6369 || (_path6369 = /*#__PURE__*/React.createElement("path", {
    d: "M78 92h-1v-1h1z",
    fill: "#b78e6e",
    fillOpacity: 0.941
  })), _path6370 || (_path6370 = /*#__PURE__*/React.createElement("path", {
    d: "M99 91v1h-1v-1z",
    fill: "#947863",
    fillOpacity: 0.141
  })), _path6371 || (_path6371 = /*#__PURE__*/React.createElement("path", {
    d: "M100 91v1h-1v-1z",
    fill: "#a36e52",
    fillOpacity: 0.863
  })), _path6372 || (_path6372 = /*#__PURE__*/React.createElement("path", {
    d: "M101 92h-1v-1h1z",
    fill: "#a66c4c"
  })), _path6373 || (_path6373 = /*#__PURE__*/React.createElement("path", {
    d: "M101 92v-1h1v1z",
    fill: "#ba8265",
    fillOpacity: 0.996
  })), _path6374 || (_path6374 = /*#__PURE__*/React.createElement("path", {
    d: "M103 92h-1v-1h1z",
    fill: "#9a786f",
    fillOpacity: 0.467
  })), _path6375 || (_path6375 = /*#__PURE__*/React.createElement("path", {
    d: "M109 91v1h-1v-1z",
    fill: "#af978f",
    fillOpacity: 0.125
  })), _path6376 || (_path6376 = /*#__PURE__*/React.createElement("path", {
    d: "M110 91v1h-1v-1z",
    fill: "#ae856c",
    fillOpacity: 0.941
  })), _path6377 || (_path6377 = /*#__PURE__*/React.createElement("path", {
    d: "M110 91h1v1h-1z",
    fill: "#a67552"
  })), _path6378 || (_path6378 = /*#__PURE__*/React.createElement("path", {
    d: "M112 92h-1v-1h1z",
    fill: "#e6a06b"
  })), _path6379 || (_path6379 = /*#__PURE__*/React.createElement("path", {
    d: "M113 91v1h-1v-1z",
    fill: "#ecae7f",
    fillOpacity: 0.58
  })), _path6380 || (_path6380 = /*#__PURE__*/React.createElement("path", {
    d: "M9 93v-1h1v1z",
    fill: "#a17c5d",
    fillOpacity: 0.161
  })), _path6381 || (_path6381 = /*#__PURE__*/React.createElement("path", {
    d: "M11 93h-1v-1h1z",
    fill: "#ac7649",
    fillOpacity: 0.961
  })), _path6382 || (_path6382 = /*#__PURE__*/React.createElement("path", {
    d: "M12 92h1v1h-1z",
    fill: "#9f6238"
  })), _path6383 || (_path6383 = /*#__PURE__*/React.createElement("path", {
    d: "M13 92h1v1h-1z",
    fill: "#9c5c37"
  })), _path6384 || (_path6384 = /*#__PURE__*/React.createElement("path", {
    d: "M15 93h-1v-1h1z",
    fill: "#925a39"
  })), _path6385 || (_path6385 = /*#__PURE__*/React.createElement("path", {
    d: "M16 93h-1v-1h1z",
    fill: "#7d523c",
    fillOpacity: 0.831
  })), _path6386 || (_path6386 = /*#__PURE__*/React.createElement("path", {
    d: "M17 93h-1v-1h1z",
    fill: "#795a4a",
    fillOpacity: 0.322
  })), _path6387 || (_path6387 = /*#__PURE__*/React.createElement("path", {
    d: "M22 92h1v1h-1z",
    fill: "#837352",
    fillOpacity: 0.122
  })), _path6388 || (_path6388 = /*#__PURE__*/React.createElement("path", {
    d: "M24 93h-1v-1h1z",
    fill: "#91663c",
    fillOpacity: 0.941
  })), _path6389 || (_path6389 = /*#__PURE__*/React.createElement("path", {
    d: "M25 92v1h-1v-1z",
    fill: "#986434"
  })), _path6390 || (_path6390 = /*#__PURE__*/React.createElement("path", {
    d: "M25 92h1v1h-1z",
    fill: "#905d32"
  })), _path6391 || (_path6391 = /*#__PURE__*/React.createElement("path", {
    d: "M26 92h1v1h-1z",
    fill: "#a27555",
    fillOpacity: 0.969
  })), _path6392 || (_path6392 = /*#__PURE__*/React.createElement("path", {
    d: "M27 92h1v1h-1z",
    fill: "#a3897c",
    fillOpacity: 0.153
  })), _path6393 || (_path6393 = /*#__PURE__*/React.createElement("path", {
    d: "M32 93h-1v-1h1z",
    fill: "#8d6346",
    fillOpacity: 0.071
  })), _path6394 || (_path6394 = /*#__PURE__*/React.createElement("path", {
    d: "M33 93h-1v-1h1z",
    fill: "#965f37",
    fillOpacity: 0.2
  })), _path6395 || (_path6395 = /*#__PURE__*/React.createElement("path", {
    d: "M33 93v-1h1v1z",
    fill: "#a16d49",
    fillOpacity: 0.682
  })), _path6396 || (_path6396 = /*#__PURE__*/React.createElement("path", {
    d: "M35 92v1h-1v-1z",
    fill: "#b5774e"
  })), _path6397 || (_path6397 = /*#__PURE__*/React.createElement("path", {
    d: "M35 93v-1h1v1z",
    fill: "#b3744a"
  })), _path6398 || (_path6398 = /*#__PURE__*/React.createElement("path", {
    d: "M36 93v-1h1v1z",
    fill: "#b97a4b"
  })), _path6399 || (_path6399 = /*#__PURE__*/React.createElement("path", {
    d: "M37 92h1v1h-1z",
    fill: "#c28154"
  })), _path6400 || (_path6400 = /*#__PURE__*/React.createElement("path", {
    d: "M38 93v-1h1v1z",
    fill: "#c38965"
  })), _path6401 || (_path6401 = /*#__PURE__*/React.createElement("path", {
    d: "M40 92v1h-1v-1z",
    fill: "#c6917a"
  })), _path6402 || (_path6402 = /*#__PURE__*/React.createElement("path", {
    d: "M40 93v-1h1v1z",
    fill: "#ca9073"
  })), _path6403 || (_path6403 = /*#__PURE__*/React.createElement("path", {
    d: "M41 92h1v1h-1z",
    fill: "#b78065"
  })), _path6404 || (_path6404 = /*#__PURE__*/React.createElement("path", {
    d: "M43 93h-1v-1h1z",
    fill: "#a17c71",
    fillOpacity: 0.933
  })), _path6405 || (_path6405 = /*#__PURE__*/React.createElement("path", {
    d: "M43 93v-1h1v1z",
    fill: "#958c8c",
    fillOpacity: 0.114
  })), _path6406 || (_path6406 = /*#__PURE__*/React.createElement("path", {
    d: "M52 93h-1v-1h1z",
    fill: "#5e4133",
    fillOpacity: 0.137
  })), _path6407 || (_path6407 = /*#__PURE__*/React.createElement("path", {
    d: "M52 92h1v1h-1z",
    fill: "#724633",
    fillOpacity: 0.541
  })), _path6408 || (_path6408 = /*#__PURE__*/React.createElement("path", {
    d: "M54 93h-1v-1h1z",
    fill: "#784833",
    fillOpacity: 0.91
  })), _path6409 || (_path6409 = /*#__PURE__*/React.createElement("path", {
    d: "M55 93h-1v-1h1z",
    fill: "#814f36"
  })), _path6410 || (_path6410 = /*#__PURE__*/React.createElement("path", {
    d: "M56 93h-1v-1h1z",
    fill: "#7d4d36"
  })), _path6411 || (_path6411 = /*#__PURE__*/React.createElement("path", {
    d: "M56 92h1v1h-1z",
    fill: "#845947",
    fillOpacity: 0.718
  })), _path6412 || (_path6412 = /*#__PURE__*/React.createElement("path", {
    d: "M58 93h-1v-1h1z",
    fill: "#91715f",
    fillOpacity: 0.282
  })), _path6413 || (_path6413 = /*#__PURE__*/React.createElement("path", {
    d: "M64 92v1h-1v-1z",
    fill: "#555",
    fillOpacity: 0.059
  })), _path6414 || (_path6414 = /*#__PURE__*/React.createElement("path", {
    d: "M65 93h-1v-1h1z",
    fill: "#8b5c3a",
    fillOpacity: 0.886
  })), _path6415 || (_path6415 = /*#__PURE__*/React.createElement("path", {
    d: "M65 92h1v1h-1z",
    fill: "#975b33"
  })), _path6416 || (_path6416 = /*#__PURE__*/React.createElement("path", {
    d: "M66 92h1v1h-1z",
    fill: "#a66e53"
  })), _path6417 || (_path6417 = /*#__PURE__*/React.createElement("path", {
    d: "M67 93v-1h1v1z",
    fill: "#daa89c"
  })), _path6418 || (_path6418 = /*#__PURE__*/React.createElement("path", {
    d: "M69 92v1h-1v-1z",
    fill: "#c29b97",
    fillOpacity: 0.541
  })), _path6419 || (_path6419 = /*#__PURE__*/React.createElement("path", {
    d: "M73 92v1h-1v-1z",
    fill: "#8e644b",
    fillOpacity: 0.239
  })), _path6420 || (_path6420 = /*#__PURE__*/React.createElement("path", {
    d: "M73 92h1v1h-1z",
    fill: "#a6734a"
  })), _path6421 || (_path6421 = /*#__PURE__*/React.createElement("path", {
    d: "M74 92h1v1h-1z",
    fill: "#b07b4c"
  })), _path6422 || (_path6422 = /*#__PURE__*/React.createElement("path", {
    d: "M75 93v-1h1v1z",
    fill: "#a7764a"
  })), _path6423 || (_path6423 = /*#__PURE__*/React.createElement("path", {
    d: "M76 93v-1h1v1z",
    fill: "#b98b64"
  })), _path6424 || (_path6424 = /*#__PURE__*/React.createElement("path", {
    d: "M78 93h-1v-1h1z",
    fill: "#bd9475",
    fillOpacity: 0.918
  })), _path6425 || (_path6425 = /*#__PURE__*/React.createElement("path", {
    d: "M78 92h1v1h-1z",
    fill: "#9f8a74",
    fillOpacity: 0.094
  })), _path6426 || (_path6426 = /*#__PURE__*/React.createElement("path", {
    d: "M100 93h-1v-1h1z",
    fill: "#997259",
    fillOpacity: 0.078
  })), _path6427 || (_path6427 = /*#__PURE__*/React.createElement("path", {
    d: "M100 92h1v1h-1z",
    fill: "#997461",
    fillOpacity: 0.267
  })), _path6428 || (_path6428 = /*#__PURE__*/React.createElement("path", {
    d: "M102 93h-1v-1h1z",
    fill: "#aa816d",
    fillOpacity: 0.247
  })), _path6429 || (_path6429 = /*#__PURE__*/React.createElement("path", {
    d: "M103 92v1h-1v-1z",
    fill: "#500",
    fillOpacity: 0.012
  })), _path6430 || (_path6430 = /*#__PURE__*/React.createElement("path", {
    d: "M108 93v-1h1v1z",
    fill: "#ac9c94",
    fillOpacity: 0.122
  })), _path6431 || (_path6431 = /*#__PURE__*/React.createElement("path", {
    d: "M109 92h1v1h-1z",
    fill: "#ad866c",
    fillOpacity: 0.945
  })), _path6432 || (_path6432 = /*#__PURE__*/React.createElement("path", {
    d: "M110 92h1v1h-1z",
    fill: "#ab7854"
  })), _path6433 || (_path6433 = /*#__PURE__*/React.createElement("path", {
    d: "M112 92v1h-1v-1z",
    fill: "#e9a471"
  })), _path6434 || (_path6434 = /*#__PURE__*/React.createElement("path", {
    d: "M112 92h1v1h-1z",
    fill: "#ecb188",
    fillOpacity: 0.541
  })), _path6435 || (_path6435 = /*#__PURE__*/React.createElement("path", {
    d: "M10 93v1H9v-1z",
    fill: "#a77c63",
    fillOpacity: 0.161
  })), _path6436 || (_path6436 = /*#__PURE__*/React.createElement("path", {
    d: "M11 93v1h-1v-1z",
    fill: "#ae794b",
    fillOpacity: 0.961
  })), _path6437 || (_path6437 = /*#__PURE__*/React.createElement("path", {
    d: "M11 93h1v1h-1z",
    fill: "#b27646"
  })), _path6438 || (_path6438 = /*#__PURE__*/React.createElement("path", {
    d: "M13 94v-1h1v1z",
    fill: "#9e5c36"
  })), _path6439 || (_path6439 = /*#__PURE__*/React.createElement("path", {
    d: "M15 93v1h-1v-1z",
    fill: "#8f5838",
    fillOpacity: 0.957
  })), _path6440 || (_path6440 = /*#__PURE__*/React.createElement("path", {
    d: "M16 93v1h-1v-1z",
    fill: "#886b55",
    fillOpacity: 0.176
  })), _path6441 || (_path6441 = /*#__PURE__*/React.createElement("path", {
    d: "M22 94v-1h1v1z",
    fill: "#8a6a55",
    fillOpacity: 0.094
  })), _path6442 || (_path6442 = /*#__PURE__*/React.createElement("path", {
    d: "M24 94h-1v-1h1z",
    fill: "#906138",
    fillOpacity: 0.925
  })), _path6443 || (_path6443 = /*#__PURE__*/React.createElement("path", {
    d: "M24 93h1v1h-1z",
    fill: "#9b6335"
  })), _path6444 || (_path6444 = /*#__PURE__*/React.createElement("path", {
    d: "M27 93v1h-1v-1z",
    fill: "#a37250",
    fillOpacity: 0.957
  })), _path6445 || (_path6445 = /*#__PURE__*/React.createElement("path", {
    d: "M27 93h1v1h-1z",
    fill: "#a17f6b",
    fillOpacity: 0.149
  })), _path6446 || (_path6446 = /*#__PURE__*/React.createElement("path", {
    d: "M33 93h1v1h-1z",
    fill: "#876955",
    fillOpacity: 0.361
  })), _path6447 || (_path6447 = /*#__PURE__*/React.createElement("path", {
    d: "M35 94h-1v-1h1z",
    fill: "#9c6745"
  })), _path6448 || (_path6448 = /*#__PURE__*/React.createElement("path", {
    d: "M35 93h1v1h-1z",
    fill: "#9e6544"
  })), _path6449 || (_path6449 = /*#__PURE__*/React.createElement("path", {
    d: "M36 94v-1h1v1z",
    fill: "#b9805d"
  })), _path6450 || (_path6450 = /*#__PURE__*/React.createElement("path", {
    d: "M38 94h-1v-1h1z",
    fill: "#b58260",
    fillOpacity: 0.929
  })), _path6451 || (_path6451 = /*#__PURE__*/React.createElement("path", {
    d: "M39 93v1h-1v-1z",
    fill: "#b7856d",
    fillOpacity: 0.792
  })), _path6452 || (_path6452 = /*#__PURE__*/React.createElement("path", {
    d: "M39 93h1v1h-1z",
    fill: "#cb927d"
  })), _path6453 || (_path6453 = /*#__PURE__*/React.createElement("path", {
    d: "M41 94h-1v-1h1z",
    fill: "#c58c70"
  })), _path6454 || (_path6454 = /*#__PURE__*/React.createElement("path", {
    d: "M41 94v-1h1v1z",
    fill: "#b77f65"
  })), _path6455 || (_path6455 = /*#__PURE__*/React.createElement("path", {
    d: "M42 94v-1h1v1z",
    fill: "#9f786e",
    fillOpacity: 0.918
  })), _path6456 || (_path6456 = /*#__PURE__*/React.createElement("path", {
    d: "M43 93h1v1h-1z",
    fill: "#947f7f",
    fillOpacity: 0.094
  })), _path6457 || (_path6457 = /*#__PURE__*/React.createElement("path", {
    d: "M50 94h-1v-1h1z",
    fill: "#714f44",
    fillOpacity: 0.176
  })), _path6458 || (_path6458 = /*#__PURE__*/React.createElement("path", {
    d: "M51 93v1h-1v-1z",
    fill: "#7b513e",
    fillOpacity: 0.576
  })), _path6459 || (_path6459 = /*#__PURE__*/React.createElement("path", {
    d: "M52 93v1h-1v-1z",
    fill: "#885a45",
    fillOpacity: 0.933
  })), _path6460 || (_path6460 = /*#__PURE__*/React.createElement("path", {
    d: "M52 93h1v1h-1z",
    fill: "#99644c"
  })), _path6461 || (_path6461 = /*#__PURE__*/React.createElement("path", {
    d: "M54 94h-1v-1h1z",
    fill: "#8f5d47",
    fillOpacity: 0.996
  })), _path6462 || (_path6462 = /*#__PURE__*/React.createElement("path", {
    d: "M55 94h-1v-1h1z",
    fill: "#8b5d4f",
    fillOpacity: 0.682
  })), _path6463 || (_path6463 = /*#__PURE__*/React.createElement("path", {
    d: "M56 94h-1v-1h1z",
    fill: "#896961",
    fillOpacity: 0.247
  })), _path6464 || (_path6464 = /*#__PURE__*/React.createElement("path", {
    d: "M64 93v1h-1v-1z",
    fill: "#2a557f",
    fillOpacity: 0.024
  })), _path6465 || (_path6465 = /*#__PURE__*/React.createElement("path", {
    d: "M65 93v1h-1v-1z",
    fill: "#8a5f40",
    fillOpacity: 0.816
  })), _path6466 || (_path6466 = /*#__PURE__*/React.createElement("path", {
    d: "M65 94v-1h1v1z",
    fill: "#9a5f38"
  })), _path6467 || (_path6467 = /*#__PURE__*/React.createElement("path", {
    d: "M67 94h-1v-1h1z",
    fill: "#a26a4f"
  })), _path6468 || (_path6468 = /*#__PURE__*/React.createElement("path", {
    d: "M68 94h-1v-1h1z",
    fill: "#dca99d"
  })), _path6469 || (_path6469 = /*#__PURE__*/React.createElement("path", {
    d: "M68 94v-1h1v1z",
    fill: "#c29b98",
    fillOpacity: 0.631
  })), _path6470 || (_path6470 = /*#__PURE__*/React.createElement("path", {
    d: "M72 93h1v1h-1z",
    fill: "#90654c",
    fillOpacity: 0.208
  })), _path6471 || (_path6471 = /*#__PURE__*/React.createElement("path", {
    d: "M74 94h-1v-1h1z",
    fill: "#a5734a",
    fillOpacity: 0.992
  })), _path6472 || (_path6472 = /*#__PURE__*/React.createElement("path", {
    d: "M75 94h-1v-1h1z",
    fill: "#b07b4d"
  })), _path6473 || (_path6473 = /*#__PURE__*/React.createElement("path", {
    d: "M75 93h1v1h-1z",
    fill: "#a9774c"
  })), _path6474 || (_path6474 = /*#__PURE__*/React.createElement("path", {
    d: "M76 93h1v1h-1z",
    fill: "#be8e69"
  })), _path6475 || (_path6475 = /*#__PURE__*/React.createElement("path", {
    d: "M78 93v1h-1v-1z",
    fill: "#c2987c",
    fillOpacity: 0.906
  })), _path6476 || (_path6476 = /*#__PURE__*/React.createElement("path", {
    d: "M78 94v-1h1v1z",
    fill: "#b2998c",
    fillOpacity: 0.078
  })), _path6477 || (_path6477 = /*#__PURE__*/React.createElement("path", {
    d: "M109 94h-1v-1h1z",
    fill: "#9c9389",
    fillOpacity: 0.102
  })), _path6478 || (_path6478 = /*#__PURE__*/React.createElement("path", {
    d: "M109 93h1v1h-1z",
    fill: "#9f7e63",
    fillOpacity: 0.878
  })), _path6479 || (_path6479 = /*#__PURE__*/React.createElement("path", {
    d: "M111 94h-1v-1h1z",
    fill: "#a37754"
  })), _path6480 || (_path6480 = /*#__PURE__*/React.createElement("path", {
    d: "M112 93v1h-1v-1z",
    fill: "#d79f75",
    fillOpacity: 0.965
  })), _path6481 || (_path6481 = /*#__PURE__*/React.createElement("path", {
    d: "M112 93h1v1h-1z",
    fill: "#e3b08b",
    fillOpacity: 0.329
  })), _path6482 || (_path6482 = /*#__PURE__*/React.createElement("path", {
    d: "M9 94h1v1H9z",
    fill: "#a87f62",
    fillOpacity: 0.173
  })), _path6483 || (_path6483 = /*#__PURE__*/React.createElement("path", {
    d: "M11 95h-1v-1h1z",
    fill: "#b47d50",
    fillOpacity: 0.969
  })), _path6484 || (_path6484 = /*#__PURE__*/React.createElement("path", {
    d: "M12 94h1v1h-1z",
    fill: "#9c603a"
  })), _path6485 || (_path6485 = /*#__PURE__*/React.createElement("path", {
    d: "M15 95h-1v-1h1z",
    fill: "#8d5734",
    fillOpacity: 0.937
  })), _path6486 || (_path6486 = /*#__PURE__*/React.createElement("path", {
    d: "M16 95h-1v-1h1z",
    fill: "#7b624a",
    fillOpacity: 0.122
  })), _path6487 || (_path6487 = /*#__PURE__*/React.createElement("path", {
    d: "M24 94v1h-1v-1z",
    fill: "#8c5c34",
    fillOpacity: 0.902
  })), _path6488 || (_path6488 = /*#__PURE__*/React.createElement("path", {
    d: "M24 95v-1h1v1z",
    fill: "#965e2e"
  })), _path6489 || (_path6489 = /*#__PURE__*/React.createElement("path", {
    d: "M26 94v1h-1v-1z",
    fill: "#935d35"
  })), _path6490 || (_path6490 = /*#__PURE__*/React.createElement("path", {
    d: "M26 95v-1h1v1z",
    fill: "#a06f4e",
    fillOpacity: 0.945
  })), _path6491 || (_path6491 = /*#__PURE__*/React.createElement("path", {
    d: "M28 95h-1v-1h1z",
    fill: "#9a836c",
    fillOpacity: 0.129
  })), _path6492 || (_path6492 = /*#__PURE__*/React.createElement("path", {
    d: "M34 94v1h-1v-1z",
    fill: "#816b50",
    fillOpacity: 0.224
  })), _path6493 || (_path6493 = /*#__PURE__*/React.createElement("path", {
    d: "M35 94v1h-1v-1z",
    fill: "#936042",
    fillOpacity: 0.992
  })), _path6494 || (_path6494 = /*#__PURE__*/React.createElement("path", {
    d: "M36 94v1h-1v-1z",
    fill: "#956345"
  })), _path6495 || (_path6495 = /*#__PURE__*/React.createElement("path", {
    d: "M36 95v-1h1v1z",
    fill: "#b5826a"
  })), _path6496 || (_path6496 = /*#__PURE__*/React.createElement("path", {
    d: "M37 94h1v1h-1z",
    fill: "#b98c78",
    fillOpacity: 0.894
  })), _path6497 || (_path6497 = /*#__PURE__*/React.createElement("path", {
    d: "M39 95h-1v-1h1z",
    fill: "#bf9082",
    fillOpacity: 0.659
  })), _path6498 || (_path6498 = /*#__PURE__*/React.createElement("path", {
    d: "M39 94h1v1h-1z",
    fill: "#cf9280"
  })), _path6499 || (_path6499 = /*#__PURE__*/React.createElement("path", {
    d: "M40 95v-1h1v1z",
    fill: "#c38a6e"
  })), _path6500 || (_path6500 = /*#__PURE__*/React.createElement("path", {
    d: "M41 95v-1h1v1z",
    fill: "#b27c60"
  })), _path6501 || (_path6501 = /*#__PURE__*/React.createElement("path", {
    d: "M42 94h1v1h-1z",
    fill: "#9d7268",
    fillOpacity: 0.898
  })), _path6502 || (_path6502 = /*#__PURE__*/React.createElement("path", {
    d: "M44 95h-1v-1h1z",
    fill: "#7f6672",
    fillOpacity: 0.078
  })), _path6503 || (_path6503 = /*#__PURE__*/React.createElement("path", {
    d: "M48 95h-1v-1h1z",
    fill: "#71423d",
    fillOpacity: 0.212
  })), _path6504 || (_path6504 = /*#__PURE__*/React.createElement("path", {
    d: "M48 95v-1h1v1z",
    fill: "#815745",
    fillOpacity: 0.62
  })), _path6505 || (_path6505 = /*#__PURE__*/React.createElement("path", {
    d: "M49 94h1v1h-1z",
    fill: "#926455",
    fillOpacity: 0.961
  })), _path6506 || (_path6506 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95h-1v-1h1z",
    fill: "#a5705c"
  })), _path6507 || (_path6507 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95v-1h1v1z",
    fill: "#906452",
    fillOpacity: 0.976
  })), _path6508 || (_path6508 = /*#__PURE__*/React.createElement("path", {
    d: "M53 94v1h-1v-1z",
    fill: "#8c6357",
    fillOpacity: 0.655
  })), _path6509 || (_path6509 = /*#__PURE__*/React.createElement("path", {
    d: "M53 95v-1h1v1z",
    fill: "#916d60",
    fillOpacity: 0.227
  })), _path6510 || (_path6510 = /*#__PURE__*/React.createElement("path", {
    d: "M64 94h1v1h-1z",
    fill: "#865a42",
    fillOpacity: 0.722
  })), _path6511 || (_path6511 = /*#__PURE__*/React.createElement("path", {
    d: "M67 94v1h-1v-1z",
    fill: "#9e6546"
  })), _path6512 || (_path6512 = /*#__PURE__*/React.createElement("path", {
    d: "M67 95v-1h1v1z",
    fill: "#d7a79c"
  })), _path6513 || (_path6513 = /*#__PURE__*/React.createElement("path", {
    d: "M68 94h1v1h-1z",
    fill: "#c49f9a",
    fillOpacity: 0.714
  })), _path6514 || (_path6514 = /*#__PURE__*/React.createElement("path", {
    d: "M72 94h1v1h-1z",
    fill: "#846a55",
    fillOpacity: 0.188
  })), _path6515 || (_path6515 = /*#__PURE__*/React.createElement("path", {
    d: "M74 94v1h-1v-1z",
    fill: "#a2734a",
    fillOpacity: 0.98
  })), _path6516 || (_path6516 = /*#__PURE__*/React.createElement("path", {
    d: "M74 95v-1h1v1z",
    fill: "#b17b4b"
  })), _path6517 || (_path6517 = /*#__PURE__*/React.createElement("path", {
    d: "M76 94v1h-1v-1z",
    fill: "#a97649"
  })), _path6518 || (_path6518 = /*#__PURE__*/React.createElement("path", {
    d: "M76 95v-1h1v1z",
    fill: "#c19573"
  })), _path6519 || (_path6519 = /*#__PURE__*/React.createElement("path", {
    d: "M77 95v-1h1v1z",
    fill: "#c09c85",
    fillOpacity: 0.894
  })), _path6520 || (_path6520 = /*#__PURE__*/React.createElement("path", {
    d: "M79 94v1h-1v-1z",
    fill: "#aa9b9b",
    fillOpacity: 0.071
  })), _path6521 || (_path6521 = /*#__PURE__*/React.createElement("path", {
    d: "M110 94v1h-1v-1z",
    fill: "#886e55",
    fillOpacity: 0.118
  })), _path6522 || (_path6522 = /*#__PURE__*/React.createElement("path", {
    d: "M110 95v-1h1v1z",
    fill: "#8e7058",
    fillOpacity: 0.259
  })), _path6523 || (_path6523 = /*#__PURE__*/React.createElement("path", {
    d: "M112 94v1h-1v-1z",
    fill: "#b69177",
    fillOpacity: 0.192
  })), _path6524 || (_path6524 = /*#__PURE__*/React.createElement("path", {
    d: "M9 96v-1h1v1z",
    fill: "#a0735f",
    fillOpacity: 0.2
  })), _path6525 || (_path6525 = /*#__PURE__*/React.createElement("path", {
    d: "M11 95v1h-1v-1z",
    fill: "#b57c51",
    fillOpacity: 0.984
  })), _path6526 || (_path6526 = /*#__PURE__*/React.createElement("path", {
    d: "M12 95h1v1h-1z",
    fill: "#9e603a"
  })), _path6527 || (_path6527 = /*#__PURE__*/React.createElement("path", {
    d: "M14 96h-1v-1h1z",
    fill: "#a1643d"
  })), _path6528 || (_path6528 = /*#__PURE__*/React.createElement("path", {
    d: "M15 95v1h-1v-1z",
    fill: "#905b36",
    fillOpacity: 0.918
  })), _path6529 || (_path6529 = /*#__PURE__*/React.createElement("path", {
    d: "M15 96v-1h1v1z",
    fill: "#896b58",
    fillOpacity: 0.102
  })), _path6530 || (_path6530 = /*#__PURE__*/React.createElement("path", {
    d: "M24 96h-1v-1h1z",
    fill: "#875830",
    fillOpacity: 0.878
  })), _path6531 || (_path6531 = /*#__PURE__*/React.createElement("path", {
    d: "M25 96h-1v-1h1z",
    fill: "#915828"
  })), _path6532 || (_path6532 = /*#__PURE__*/React.createElement("path", {
    d: "M26 96h-1v-1h1z",
    fill: "#8d582e"
  })), _path6533 || (_path6533 = /*#__PURE__*/React.createElement("path", {
    d: "M26 95h1v1h-1z",
    fill: "#9c6b4c",
    fillOpacity: 0.929
  })), _path6534 || (_path6534 = /*#__PURE__*/React.createElement("path", {
    d: "M35 95v1h-1v-1z",
    fill: "#905e45",
    fillOpacity: 0.918
  })), _path6535 || (_path6535 = /*#__PURE__*/React.createElement("path", {
    d: "M36 96h-1v-1h1z",
    fill: "#9b6648"
  })), _path6536 || (_path6536 = /*#__PURE__*/React.createElement("path", {
    d: "M36 95h1v1h-1z",
    fill: "#ac7860"
  })), _path6537 || (_path6537 = /*#__PURE__*/React.createElement("path", {
    d: "M38 95v1h-1v-1z",
    fill: "#b88873",
    fillOpacity: 0.996
  })), _path6538 || (_path6538 = /*#__PURE__*/React.createElement("path", {
    d: "M38 96v-1h1v1z",
    fill: "#c3917d",
    fillOpacity: 0.984
  })), _path6539 || (_path6539 = /*#__PURE__*/React.createElement("path", {
    d: "M39 95h1v1h-1z",
    fill: "#c98f7a"
  })), _path6540 || (_path6540 = /*#__PURE__*/React.createElement("path", {
    d: "M41 96h-1v-1h1z",
    fill: "#bf8767"
  })), _path6541 || (_path6541 = /*#__PURE__*/React.createElement("path", {
    d: "M41 95h1v1h-1z",
    fill: "#b0775b"
  })), _path6542 || (_path6542 = /*#__PURE__*/React.createElement("path", {
    d: "M43 96h-1v-1h1z",
    fill: "#967167",
    fillOpacity: 0.882
  })), _path6543 || (_path6543 = /*#__PURE__*/React.createElement("path", {
    d: "M44 95v1h-1v-1z",
    fill: "#71718d",
    fillOpacity: 0.035
  })), _path6544 || (_path6544 = /*#__PURE__*/React.createElement("path", {
    d: "M45 95h1v1h-1z",
    fill: "#774e3d",
    fillOpacity: 0.243
  })), _path6545 || (_path6545 = /*#__PURE__*/React.createElement("path", {
    d: "M47 95v1h-1v-1z",
    fill: "#88594a",
    fillOpacity: 0.682
  })), _path6546 || (_path6546 = /*#__PURE__*/React.createElement("path", {
    d: "M47 96v-1h1v1z",
    fill: "#966458",
    fillOpacity: 0.988
  })), _path6547 || (_path6547 = /*#__PURE__*/React.createElement("path", {
    d: "M48 96v-1h1v1z",
    fill: "#a6705f"
  })), _path6548 || (_path6548 = /*#__PURE__*/React.createElement("path", {
    d: "M50 95v1h-1v-1z",
    fill: "#956355",
    fillOpacity: 0.937
  })), _path6549 || (_path6549 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95v1h-1v-1z",
    fill: "#8b5e50",
    fillOpacity: 0.624
  })), _path6550 || (_path6550 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95h1v1h-1z",
    fill: "#886350",
    fillOpacity: 0.212
  })), _path6551 || (_path6551 = /*#__PURE__*/React.createElement("path", {
    d: "M65 96h-1v-1h1z",
    fill: "#885845",
    fillOpacity: 0.608
  })), _path6552 || (_path6552 = /*#__PURE__*/React.createElement("path", {
    d: "M66 96h-1v-1h1z",
    fill: "#965a35"
  })), _path6553 || (_path6553 = /*#__PURE__*/React.createElement("path", {
    d: "M68 96h-1v-1h1z",
    fill: "#d1a095"
  })), _path6554 || (_path6554 = /*#__PURE__*/React.createElement("path", {
    d: "M68 96v-1h1v1z",
    fill: "#c49e97",
    fillOpacity: 0.8
  })), _path6555 || (_path6555 = /*#__PURE__*/React.createElement("path", {
    d: "M74 96h-1v-1h1z",
    fill: "#9e7048",
    fillOpacity: 0.976
  })), _path6556 || (_path6556 = /*#__PURE__*/React.createElement("path", {
    d: "M74 95h1v1h-1z",
    fill: "#b17c4b"
  })), _path6557 || (_path6557 = /*#__PURE__*/React.createElement("path", {
    d: "M75 95h1v1h-1z",
    fill: "#a97547"
  })), _path6558 || (_path6558 = /*#__PURE__*/React.createElement("path", {
    d: "M76 95h1v1h-1z",
    fill: "#c49979"
  })), _path6559 || (_path6559 = /*#__PURE__*/React.createElement("path", {
    d: "M77 96v-1h1v1z",
    fill: "#c3a08a",
    fillOpacity: 0.871
  })), _path6560 || (_path6560 = /*#__PURE__*/React.createElement("path", {
    d: "M10 97H9v-1h1z",
    fill: "#9c6f5a",
    fillOpacity: 0.243
  })), _path6561 || (_path6561 = /*#__PURE__*/React.createElement("path", {
    d: "M10 96h1v1h-1z",
    fill: "#b67b50"
  })), _path6562 || (_path6562 = /*#__PURE__*/React.createElement("path", {
    d: "M11 96h1v1h-1z",
    fill: "#b27343"
  })), _path6563 || (_path6563 = /*#__PURE__*/React.createElement("path", {
    d: "M13 97h-1v-1h1z",
    fill: "#9e623a"
  })), _path6564 || (_path6564 = /*#__PURE__*/React.createElement("path", {
    d: "M13 96h1v1h-1z",
    fill: "#a3673f"
  })), _path6565 || (_path6565 = /*#__PURE__*/React.createElement("path", {
    d: "M15 97h-1v-1h1z",
    fill: "#925e39",
    fillOpacity: 0.902
  })), _path6566 || (_path6566 = /*#__PURE__*/React.createElement("path", {
    d: "M16 96v1h-1v-1z",
    fill: "#7f6851",
    fillOpacity: 0.086
  })), _path6567 || (_path6567 = /*#__PURE__*/React.createElement("path", {
    d: "M23 96v1h-1v-1z",
    fill: "#664c4c",
    fillOpacity: 0.039
  })), _path6568 || (_path6568 = /*#__PURE__*/React.createElement("path", {
    d: "M24 96v1h-1v-1z",
    fill: "#84562f",
    fillOpacity: 0.863
  })), _path6569 || (_path6569 = /*#__PURE__*/React.createElement("path", {
    d: "M24 96h1v1h-1z",
    fill: "#8d5525"
  })), _path6570 || (_path6570 = /*#__PURE__*/React.createElement("path", {
    d: "M26 96v1h-1v-1z",
    fill: "#824d24"
  })), _path6571 || (_path6571 = /*#__PURE__*/React.createElement("path", {
    d: "M26 97v-1h1v1z",
    fill: "#956648",
    fillOpacity: 0.925
  })), _path6572 || (_path6572 = /*#__PURE__*/React.createElement("path", {
    d: "M27 96h1v1h-1z",
    fill: "#9c756b",
    fillOpacity: 0.102
  })), _path6573 || (_path6573 = /*#__PURE__*/React.createElement("path", {
    d: "M34 97v-1h1v1z",
    fill: "#92634f",
    fillOpacity: 0.792
  })), _path6574 || (_path6574 = /*#__PURE__*/React.createElement("path", {
    d: "M36 96v1h-1v-1z",
    fill: "#9c6648"
  })), _path6575 || (_path6575 = /*#__PURE__*/React.createElement("path", {
    d: "M36 96h1v1h-1z",
    fill: "#a9745b"
  })), _path6576 || (_path6576 = /*#__PURE__*/React.createElement("path", {
    d: "M38 97h-1v-1h1z",
    fill: "#ba876f"
  })), _path6577 || (_path6577 = /*#__PURE__*/React.createElement("path", {
    d: "M39 97h-1v-1h1z",
    fill: "#c7917a"
  })), _path6578 || (_path6578 = /*#__PURE__*/React.createElement("path", {
    d: "M39 96h1v1h-1z",
    fill: "#c69074"
  })), _path6579 || (_path6579 = /*#__PURE__*/React.createElement("path", {
    d: "M41 96v1h-1v-1z",
    fill: "#be8564"
  })), _path6580 || (_path6580 = /*#__PURE__*/React.createElement("path", {
    d: "M41 96h1v1h-1z",
    fill: "#b0755b"
  })), _path6581 || (_path6581 = /*#__PURE__*/React.createElement("path", {
    d: "M42 97v-1h1v1z",
    fill: "#9b7167",
    fillOpacity: 0.886
  })), _path6582 || (_path6582 = /*#__PURE__*/React.createElement("path", {
    d: "M43 97v-1h1v1z",
    fill: "#725240",
    fillOpacity: 0.341
  })), _path6583 || (_path6583 = /*#__PURE__*/React.createElement("path", {
    d: "M45 97h-1v-1h1z",
    fill: "#855946",
    fillOpacity: 0.694
  })), _path6584 || (_path6584 = /*#__PURE__*/React.createElement("path", {
    d: "M46 96v1h-1v-1z",
    fill: "#976651"
  })), _path6585 || (_path6585 = /*#__PURE__*/React.createElement("path", {
    d: "M47 96v1h-1v-1z",
    fill: "#a46f5d"
  })), _path6586 || (_path6586 = /*#__PURE__*/React.createElement("path", {
    d: "M48 96v1h-1v-1z",
    fill: "#8e6150",
    fillOpacity: 0.89
  })), _path6587 || (_path6587 = /*#__PURE__*/React.createElement("path", {
    d: "M48 97v-1h1v1z",
    fill: "#845c4c",
    fillOpacity: 0.498
  })), _path6588 || (_path6588 = /*#__PURE__*/React.createElement("path", {
    d: "M49 97v-1h1v1z",
    fill: "#835c55",
    fillOpacity: 0.129
  })), _path6589 || (_path6589 = /*#__PURE__*/React.createElement("path", {
    d: "M65 96v1h-1v-1z",
    fill: "#875743",
    fillOpacity: 0.502
  })), _path6590 || (_path6590 = /*#__PURE__*/React.createElement("path", {
    d: "M65 97v-1h1v1z",
    fill: "#955c38"
  })), _path6591 || (_path6591 = /*#__PURE__*/React.createElement("path", {
    d: "M66 96h1v1h-1z",
    fill: "#945a39"
  })), _path6592 || (_path6592 = /*#__PURE__*/React.createElement("path", {
    d: "M67 96h1v1h-1z",
    fill: "#cc9a8a"
  })), _path6593 || (_path6593 = /*#__PURE__*/React.createElement("path", {
    d: "M69 97h-1v-1h1z",
    fill: "#c49b92",
    fillOpacity: 0.878
  })), _path6594 || (_path6594 = /*#__PURE__*/React.createElement("path", {
    d: "M70 96v1h-1v-1z",
    fill: "#af9f9f",
    fillOpacity: 0.063
  })), _path6595 || (_path6595 = /*#__PURE__*/React.createElement("path", {
    d: "M72 96h1v1h-1z",
    fill: "#7f5f52",
    fillOpacity: 0.157
  })), _path6596 || (_path6596 = /*#__PURE__*/React.createElement("path", {
    d: "M73 96h1v1h-1z",
    fill: "#996a44",
    fillOpacity: 0.969
  })), _path6597 || (_path6597 = /*#__PURE__*/React.createElement("path", {
    d: "M74 97v-1h1v1z",
    fill: "#b07a49"
  })), _path6598 || (_path6598 = /*#__PURE__*/React.createElement("path", {
    d: "M75 97v-1h1v1z",
    fill: "#a97548"
  })), _path6599 || (_path6599 = /*#__PURE__*/React.createElement("path", {
    d: "M77 96v1h-1v-1z",
    fill: "#c4987a"
  })), _path6600 || (_path6600 = /*#__PURE__*/React.createElement("path", {
    d: "M77 97v-1h1v1z",
    fill: "#c5a18e",
    fillOpacity: 0.847
  })), _path6601 || (_path6601 = /*#__PURE__*/React.createElement("path", {
    d: "M78 96h1v1h-1z",
    fill: "#b2b2b2",
    fillOpacity: 0.039
  })), _path6602 || (_path6602 = /*#__PURE__*/React.createElement("path", {
    d: "M9 98v-1h1v1z",
    fill: "#a3755f",
    fillOpacity: 0.263
  })), _path6603 || (_path6603 = /*#__PURE__*/React.createElement("path", {
    d: "M11 98h-1v-1h1z",
    fill: "#b97b51"
  })), _path6604 || (_path6604 = /*#__PURE__*/React.createElement("path", {
    d: "M13 98h-1v-1h1z",
    fill: "#9b6137"
  })), _path6605 || (_path6605 = /*#__PURE__*/React.createElement("path", {
    d: "M14 98h-1v-1h1z",
    fill: "#a46940"
  })), _path6606 || (_path6606 = /*#__PURE__*/React.createElement("path", {
    d: "M15 98h-1v-1h1z",
    fill: "#95613d",
    fillOpacity: 0.898
  })), _path6607 || (_path6607 = /*#__PURE__*/React.createElement("path", {
    d: "M16 97v1h-1v-1z",
    fill: "#796155",
    fillOpacity: 0.082
  })), _path6608 || (_path6608 = /*#__PURE__*/React.createElement("path", {
    d: "M22 97h1v1h-1z",
    fill: "#5f5f3f",
    fillOpacity: 0.031
  })), _path6609 || (_path6609 = /*#__PURE__*/React.createElement("path", {
    d: "M24 97v1h-1v-1z",
    fill: "#7d512d",
    fillOpacity: 0.859
  })), _path6610 || (_path6610 = /*#__PURE__*/React.createElement("path", {
    d: "M24 97h1v1h-1z",
    fill: "#8f5626"
  })), _path6611 || (_path6611 = /*#__PURE__*/React.createElement("path", {
    d: "M26 97v1h-1v-1z",
    fill: "#814a21"
  })), _path6612 || (_path6612 = /*#__PURE__*/React.createElement("path", {
    d: "M27 98h-1v-1h1z",
    fill: "#895c40",
    fillOpacity: 0.918
  })), _path6613 || (_path6613 = /*#__PURE__*/React.createElement("path", {
    d: "M28 98h-1v-1h1z",
    fill: "#91796d",
    fillOpacity: 0.082
  })), _path6614 || (_path6614 = /*#__PURE__*/React.createElement("path", {
    d: "M35 97v1h-1v-1z",
    fill: "#8d6352",
    fillOpacity: 0.616
  })), _path6615 || (_path6615 = /*#__PURE__*/React.createElement("path", {
    d: "M35 98v-1h1v1z",
    fill: "#9c684a"
  })), _path6616 || (_path6616 = /*#__PURE__*/React.createElement("path", {
    d: "M36 98v-1h1v1z",
    fill: "#a26f55"
  })), _path6617 || (_path6617 = /*#__PURE__*/React.createElement("path", {
    d: "M38 97v1h-1v-1z",
    fill: "#b6836a"
  })), _path6618 || (_path6618 = /*#__PURE__*/React.createElement("path", {
    d: "M38 98v-1h1v1z",
    fill: "#c58c74"
  })), _path6619 || (_path6619 = /*#__PURE__*/React.createElement("path", {
    d: "M39 98v-1h1v1z",
    fill: "#c48d71"
  })), _path6620 || (_path6620 = /*#__PURE__*/React.createElement("path", {
    d: "M40 98v-1h1v1z",
    fill: "#c08364"
  })), _path6621 || (_path6621 = /*#__PURE__*/React.createElement("path", {
    d: "M41 98v-1h1v1z",
    fill: "#b0785b"
  })), _path6622 || (_path6622 = /*#__PURE__*/React.createElement("path", {
    d: "M42 97h1v1h-1z",
    fill: "#a3776b",
    fillOpacity: 0.996
  })), _path6623 || (_path6623 = /*#__PURE__*/React.createElement("path", {
    d: "M43 97h1v1h-1z",
    fill: "#946856"
  })), _path6624 || (_path6624 = /*#__PURE__*/React.createElement("path", {
    d: "M45 97v1h-1v-1z",
    fill: "#a16d58"
  })), _path6625 || (_path6625 = /*#__PURE__*/React.createElement("path", {
    d: "M46 98h-1v-1h1z",
    fill: "#8e5f4b",
    fillOpacity: 0.871
  })), _path6626 || (_path6626 = /*#__PURE__*/React.createElement("path", {
    d: "M47 97v1h-1v-1z",
    fill: "#815645",
    fillOpacity: 0.463
  })), _path6627 || (_path6627 = /*#__PURE__*/React.createElement("path", {
    d: "M48 98h-1v-1h1z",
    fill: "#7f5f4a",
    fillOpacity: 0.094
  })), _path6628 || (_path6628 = /*#__PURE__*/React.createElement("path", {
    d: "M65 98h-1v-1h1z",
    fill: "#835444",
    fillOpacity: 0.38
  })), _path6629 || (_path6629 = /*#__PURE__*/React.createElement("path", {
    d: "M66 97v1h-1v-1z",
    fill: "#935d3c"
  })), _path6630 || (_path6630 = /*#__PURE__*/React.createElement("path", {
    d: "M67 97v1h-1v-1z",
    fill: "#915835"
  })), _path6631 || (_path6631 = /*#__PURE__*/React.createElement("path", {
    d: "M67 98v-1h1v1z",
    fill: "#c69381"
  })), _path6632 || (_path6632 = /*#__PURE__*/React.createElement("path", {
    d: "M69 97v1h-1v-1z",
    fill: "#c59b90",
    fillOpacity: 0.953
  })), _path6633 || (_path6633 = /*#__PURE__*/React.createElement("path", {
    d: "M70 98h-1v-1h1z",
    fill: "#aa9292",
    fillOpacity: 0.129
  })), _path6634 || (_path6634 = /*#__PURE__*/React.createElement("path", {
    d: "M73 98h-1v-1h1z",
    fill: "#7c6052",
    fillOpacity: 0.145
  })), _path6635 || (_path6635 = /*#__PURE__*/React.createElement("path", {
    d: "M74 97v1h-1v-1z",
    fill: "#976742",
    fillOpacity: 0.965
  })), _path6636 || (_path6636 = /*#__PURE__*/React.createElement("path", {
    d: "M74 97h1v1h-1z",
    fill: "#ac7746"
  })), _path6637 || (_path6637 = /*#__PURE__*/React.createElement("path", {
    d: "M76 97v1h-1v-1z",
    fill: "#a87448"
  })), _path6638 || (_path6638 = /*#__PURE__*/React.createElement("path", {
    d: "M76 98v-1h1v1z",
    fill: "#c5997d"
  })), _path6639 || (_path6639 = /*#__PURE__*/React.createElement("path", {
    d: "M78 97v1h-1v-1z",
    fill: "#c7a391",
    fillOpacity: 0.827
  })), _path6640 || (_path6640 = /*#__PURE__*/React.createElement("path", {
    d: "M79 97v1h-1v-1z",
    fill: "#bfbfbf",
    fillOpacity: 0.031
  })), _path6641 || (_path6641 = /*#__PURE__*/React.createElement("path", {
    d: "M10 98v1H9v-1z",
    fill: "#ab7f62",
    fillOpacity: 0.275
  })), _path6642 || (_path6642 = /*#__PURE__*/React.createElement("path", {
    d: "M10 99v-1h1v1z",
    fill: "#bc8256"
  })), _path6643 || (_path6643 = /*#__PURE__*/React.createElement("path", {
    d: "M11 99v-1h1v1z",
    fill: "#aa6f40"
  })), _path6644 || (_path6644 = /*#__PURE__*/React.createElement("path", {
    d: "M12 99v-1h1v1z",
    fill: "#9b6036"
  })), _path6645 || (_path6645 = /*#__PURE__*/React.createElement("path", {
    d: "M13 99v-1h1v1z",
    fill: "#a5683e"
  })), _path6646 || (_path6646 = /*#__PURE__*/React.createElement("path", {
    d: "M15 98v1h-1v-1z",
    fill: "#96613d",
    fillOpacity: 0.878
  })), _path6647 || (_path6647 = /*#__PURE__*/React.createElement("path", {
    d: "M24 99h-1v-1h1z",
    fill: "#6d4c2e",
    fillOpacity: 0.302
  })), _path6648 || (_path6648 = /*#__PURE__*/React.createElement("path", {
    d: "M25 99h-1v-1h1z",
    fill: "#704b29",
    fillOpacity: 0.62
  })), _path6649 || (_path6649 = /*#__PURE__*/React.createElement("path", {
    d: "M25 99v-1h1v1z",
    fill: "#6b4426",
    fillOpacity: 0.643
  })), _path6650 || (_path6650 = /*#__PURE__*/React.createElement("path", {
    d: "M27 98v1h-1v-1z",
    fill: "#76503b",
    fillOpacity: 0.286
  })), _path6651 || (_path6651 = /*#__PURE__*/React.createElement("path", {
    d: "M35 98v1h-1v-1z",
    fill: "#825d4f",
    fillOpacity: 0.451
  })), _path6652 || (_path6652 = /*#__PURE__*/React.createElement("path", {
    d: "M37 99h-1v-1h1z",
    fill: "#a57151"
  })), _path6653 || (_path6653 = /*#__PURE__*/React.createElement("path", {
    d: "M38 99h-1v-1h1z",
    fill: "#ba8568"
  })), _path6654 || (_path6654 = /*#__PURE__*/React.createElement("path", {
    d: "M39 99h-1v-1h1z",
    fill: "#cd927a"
  })), _path6655 || (_path6655 = /*#__PURE__*/React.createElement("path", {
    d: "M40 98v1h-1v-1z",
    fill: "#c78c70"
  })), _path6656 || (_path6656 = /*#__PURE__*/React.createElement("path", {
    d: "M40 98h1v1h-1z",
    fill: "#be8362"
  })), _path6657 || (_path6657 = /*#__PURE__*/React.createElement("path", {
    d: "M41 99v-1h1v1z",
    fill: "#ad7859"
  })), _path6658 || (_path6658 = /*#__PURE__*/React.createElement("path", {
    d: "M42 99v-1h1v1z",
    fill: "#a77d73"
  })), _path6659 || (_path6659 = /*#__PURE__*/React.createElement("path", {
    d: "M43 99v-1h1v1z",
    fill: "#886358",
    fillOpacity: 0.843
  })), _path6660 || (_path6660 = /*#__PURE__*/React.createElement("path", {
    d: "M44 99v-1h1v1z",
    fill: "#7a584b",
    fillOpacity: 0.439
  })), _path6661 || (_path6661 = /*#__PURE__*/React.createElement("path", {
    d: "M45 98h1v1h-1z",
    fill: "#72594c",
    fillOpacity: 0.078
  })), _path6662 || (_path6662 = /*#__PURE__*/React.createElement("path", {
    d: "M65 98v1h-1v-1z",
    fill: "#815a4a",
    fillOpacity: 0.255
  })), _path6663 || (_path6663 = /*#__PURE__*/React.createElement("path", {
    d: "M66 98v1h-1v-1z",
    fill: "#915b3c"
  })), _path6664 || (_path6664 = /*#__PURE__*/React.createElement("path", {
    d: "M67 99h-1v-1h1z",
    fill: "#905633"
  })), _path6665 || (_path6665 = /*#__PURE__*/React.createElement("path", {
    d: "M67 98h1v1h-1z",
    fill: "#bf8b75"
  })), _path6666 || (_path6666 = /*#__PURE__*/React.createElement("path", {
    d: "M68 99v-1h1v1z",
    fill: "#c39b91"
  })), _path6667 || (_path6667 = /*#__PURE__*/React.createElement("path", {
    d: "M69 98h1v1h-1z",
    fill: "#b69994",
    fillOpacity: 0.235
  })), _path6668 || (_path6668 = /*#__PURE__*/React.createElement("path", {
    d: "M73 98v1h-1v-1z",
    fill: "#735a4a",
    fillOpacity: 0.122
  })), _path6669 || (_path6669 = /*#__PURE__*/React.createElement("path", {
    d: "M74 99h-1v-1h1z",
    fill: "#966742",
    fillOpacity: 0.945
  })), _path6670 || (_path6670 = /*#__PURE__*/React.createElement("path", {
    d: "M75 99h-1v-1h1z",
    fill: "#aa7544"
  })), _path6671 || (_path6671 = /*#__PURE__*/React.createElement("path", {
    d: "M75 99v-1h1v1z",
    fill: "#aa764c"
  })), _path6672 || (_path6672 = /*#__PURE__*/React.createElement("path", {
    d: "M77 98v1h-1v-1z",
    fill: "#ca9e82"
  })), _path6673 || (_path6673 = /*#__PURE__*/React.createElement("path", {
    d: "M77 98h1v1h-1z",
    fill: "#caa494",
    fillOpacity: 0.804
  })), _path6674 || (_path6674 = /*#__PURE__*/React.createElement("path", {
    d: "M79 99h-1v-1h1z",
    fill: "#ccc",
    fillOpacity: 0.02
  })), _path6675 || (_path6675 = /*#__PURE__*/React.createElement("path", {
    d: "M9 99h1v1H9z",
    fill: "#aa7f62",
    fillOpacity: 0.306
  })), _path6676 || (_path6676 = /*#__PURE__*/React.createElement("path", {
    d: "M10 99h1v1h-1z",
    fill: "#c2895c"
  })), _path6677 || (_path6677 = /*#__PURE__*/React.createElement("path", {
    d: "M12 100h-1v-1h1z",
    fill: "#ae7546"
  })), _path6678 || (_path6678 = /*#__PURE__*/React.createElement("path", {
    d: "M14 100h-1v-1h1z",
    fill: "#a76b40"
  })), _path6679 || (_path6679 = /*#__PURE__*/React.createElement("path", {
    d: "M14 100v-1h1v1z",
    fill: "#966240",
    fillOpacity: 0.859
  })), _path6680 || (_path6680 = /*#__PURE__*/React.createElement("path", {
    d: "M15 99h1v1h-1z",
    fill: "#898975",
    fillOpacity: 0.051
  })), _path6681 || (_path6681 = /*#__PURE__*/React.createElement("path", {
    d: "M34 99h1v1h-1z",
    fill: "#785750",
    fillOpacity: 0.149
  })), _path6682 || (_path6682 = /*#__PURE__*/React.createElement("path", {
    d: "M36 99v1h-1v-1z",
    fill: "#855442",
    fillOpacity: 0.69
  })), _path6683 || (_path6683 = /*#__PURE__*/React.createElement("path", {
    d: "M36 99h1v1h-1z",
    fill: "#93614f",
    fillOpacity: 0.831
  })), _path6684 || (_path6684 = /*#__PURE__*/React.createElement("path", {
    d: "M37 99h1v1h-1z",
    fill: "#a17b67",
    fillOpacity: 0.698
  })), _path6685 || (_path6685 = /*#__PURE__*/React.createElement("path", {
    d: "M39 100h-1v-1h1z",
    fill: "#c6927f",
    fillOpacity: 0.8
  })), _path6686 || (_path6686 = /*#__PURE__*/React.createElement("path", {
    d: "M39 99h1v1h-1z",
    fill: "#ca8e72"
  })), _path6687 || (_path6687 = /*#__PURE__*/React.createElement("path", {
    d: "M41 99v1h-1v-1z",
    fill: "#be8361"
  })), _path6688 || (_path6688 = /*#__PURE__*/React.createElement("path", {
    d: "M41 100v-1h1v1z",
    fill: "#b17d63"
  })), _path6689 || (_path6689 = /*#__PURE__*/React.createElement("path", {
    d: "M42 99h1v1h-1z",
    fill: "#a3847c",
    fillOpacity: 0.733
  })), _path6690 || (_path6690 = /*#__PURE__*/React.createElement("path", {
    d: "M65 99v1h-1v-1z",
    fill: "#826255",
    fillOpacity: 0.153
  })), _path6691 || (_path6691 = /*#__PURE__*/React.createElement("path", {
    d: "M66 99v1h-1v-1z",
    fill: "#8f5a3d",
    fillOpacity: 0.957
  })), _path6692 || (_path6692 = /*#__PURE__*/React.createElement("path", {
    d: "M67 99h1v1h-1z",
    fill: "#b7826a"
  })), _path6693 || (_path6693 = /*#__PURE__*/React.createElement("path", {
    d: "M69 99v1h-1v-1z",
    fill: "#c79c92"
  })), _path6694 || (_path6694 = /*#__PURE__*/React.createElement("path", {
    d: "M69 100v-1h1v1z",
    fill: "#b6968e",
    fillOpacity: 0.373
  })), _path6695 || (_path6695 = /*#__PURE__*/React.createElement("path", {
    d: "M74 99v1h-1v-1z",
    fill: "#996944",
    fillOpacity: 0.922
  })), _path6696 || (_path6696 = /*#__PURE__*/React.createElement("path", {
    d: "M74 100v-1h1v1z",
    fill: "#ab7444"
  })), _path6697 || (_path6697 = /*#__PURE__*/React.createElement("path", {
    d: "M75 100v-1h1v1z",
    fill: "#ad7a50"
  })), _path6698 || (_path6698 = /*#__PURE__*/React.createElement("path", {
    d: "M76 100v-1h1v1z",
    fill: "#ca9d83"
  })), _path6699 || (_path6699 = /*#__PURE__*/React.createElement("path", {
    d: "M77 99h1v1h-1z",
    fill: "#cca594",
    fillOpacity: 0.796
  })), _path6700 || (_path6700 = /*#__PURE__*/React.createElement("path", {
    d: "M79 99v1h-1v-1z",
    fill: "#bfffff",
    fillOpacity: 0.016
  })), _path6701 || (_path6701 = /*#__PURE__*/React.createElement("path", {
    d: "M9 101v-1h1v1z",
    fill: "#aa8063",
    fillOpacity: 0.341
  })), _path6702 || (_path6702 = /*#__PURE__*/React.createElement("path", {
    d: "M11 100v1h-1v-1z",
    fill: "#c58b5e"
  })), _path6703 || (_path6703 = /*#__PURE__*/React.createElement("path", {
    d: "M12 101h-1v-1h1z",
    fill: "#ad7446"
  })), _path6704 || (_path6704 = /*#__PURE__*/React.createElement("path", {
    d: "M12 100h1v1h-1z",
    fill: "#9f6539"
  })), _path6705 || (_path6705 = /*#__PURE__*/React.createElement("path", {
    d: "M13 101v-1h1v1z",
    fill: "#a86d42"
  })), _path6706 || (_path6706 = /*#__PURE__*/React.createElement("path", {
    d: "M15 100v1h-1v-1z",
    fill: "#976644",
    fillOpacity: 0.831
  })), _path6707 || (_path6707 = /*#__PURE__*/React.createElement("path", {
    d: "M38 101v-1h1v1z",
    fill: "#c09385",
    fillOpacity: 0.576
  })), _path6708 || (_path6708 = /*#__PURE__*/React.createElement("path", {
    d: "M40 100v1h-1v-1z",
    fill: "#cf9478"
  })), _path6709 || (_path6709 = /*#__PURE__*/React.createElement("path", {
    d: "M41 101h-1v-1h1z",
    fill: "#c38763"
  })), _path6710 || (_path6710 = /*#__PURE__*/React.createElement("path", {
    d: "M42 101h-1v-1h1z",
    fill: "#b68063"
  })), _path6711 || (_path6711 = /*#__PURE__*/React.createElement("path", {
    d: "M42 100h1v1h-1z",
    fill: "#a1857d",
    fillOpacity: 0.624
  })), _path6712 || (_path6712 = /*#__PURE__*/React.createElement("path", {
    d: "M64 100h1v1h-1z",
    fill: "#786969",
    fillOpacity: 0.067
  })), _path6713 || (_path6713 = /*#__PURE__*/React.createElement("path", {
    d: "M66 101h-1v-1h1z",
    fill: "#8c5a41",
    fillOpacity: 0.882
  })), _path6714 || (_path6714 = /*#__PURE__*/React.createElement("path", {
    d: "M66 101v-1h1v1z",
    fill: "#935837"
  })), _path6715 || (_path6715 = /*#__PURE__*/React.createElement("path", {
    d: "M68 100v1h-1v-1z",
    fill: "#ab755c"
  })), _path6716 || (_path6716 = /*#__PURE__*/React.createElement("path", {
    d: "M69 101h-1v-1h1z",
    fill: "#ca998e"
  })), _path6717 || (_path6717 = /*#__PURE__*/React.createElement("path", {
    d: "M69 100h1v1h-1z",
    fill: "#b78e88",
    fillOpacity: 0.506
  })), _path6718 || (_path6718 = /*#__PURE__*/React.createElement("path", {
    d: "M73 100v1h-1v-1z",
    fill: "#6d4848",
    fillOpacity: 0.082
  })), _path6719 || (_path6719 = /*#__PURE__*/React.createElement("path", {
    d: "M73 101v-1h1v1z",
    fill: "#986843",
    fillOpacity: 0.91
  })), _path6720 || (_path6720 = /*#__PURE__*/React.createElement("path", {
    d: "M74 101v-1h1v1z",
    fill: "#ac7444"
  })), _path6721 || (_path6721 = /*#__PURE__*/React.createElement("path", {
    d: "M76 101h-1v-1h1z",
    fill: "#ae7a50"
  })), _path6722 || (_path6722 = /*#__PURE__*/React.createElement("path", {
    d: "M77 100h1v1h-1z",
    fill: "#cba493",
    fillOpacity: 0.78
  })), _path6723 || (_path6723 = /*#__PURE__*/React.createElement("path", {
    d: "M9 101h1v1H9z",
    fill: "#aa8063",
    fillOpacity: 0.38
  })), _path6724 || (_path6724 = /*#__PURE__*/React.createElement("path", {
    d: "M11 102h-1v-1h1z",
    fill: "#c68b5e"
  })), _path6725 || (_path6725 = /*#__PURE__*/React.createElement("path", {
    d: "M12 101v1h-1v-1z",
    fill: "#af7649"
  })), _path6726 || (_path6726 = /*#__PURE__*/React.createElement("path", {
    d: "M12 102v-1h1v1z",
    fill: "#a1663a"
  })), _path6727 || (_path6727 = /*#__PURE__*/React.createElement("path", {
    d: "M14 102h-1v-1h1z",
    fill: "#a86d43"
  })), _path6728 || (_path6728 = /*#__PURE__*/React.createElement("path", {
    d: "M14 102v-1h1v1z",
    fill: "#9a6a49",
    fillOpacity: 0.788
  })), _path6729 || (_path6729 = /*#__PURE__*/React.createElement("path", {
    d: "M39 102h-1v-1h1z",
    fill: "#c39685",
    fillOpacity: 0.659
  })), _path6730 || (_path6730 = /*#__PURE__*/React.createElement("path", {
    d: "M39 101h1v1h-1z",
    fill: "#cf9272"
  })), _path6731 || (_path6731 = /*#__PURE__*/React.createElement("path", {
    d: "M41 101v1h-1v-1z",
    fill: "#c58a68"
  })), _path6732 || (_path6732 = /*#__PURE__*/React.createElement("path", {
    d: "M41 102v-1h1v1z",
    fill: "#b78264"
  })), _path6733 || (_path6733 = /*#__PURE__*/React.createElement("path", {
    d: "M43 101v1h-1v-1z",
    fill: "#a58279",
    fillOpacity: 0.569
  })), _path6734 || (_path6734 = /*#__PURE__*/React.createElement("path", {
    d: "M65 101v1h-1v-1z",
    fill: "#55a",
    fillOpacity: 0.012
  })), _path6735 || (_path6735 = /*#__PURE__*/React.createElement("path", {
    d: "M65 102v-1h1v1z",
    fill: "#8a5841",
    fillOpacity: 0.788
  })), _path6736 || (_path6736 = /*#__PURE__*/React.createElement("path", {
    d: "M68 102h-1v-1h1z",
    fill: "#a36c54"
  })), _path6737 || (_path6737 = /*#__PURE__*/React.createElement("path", {
    d: "M68 101h1v1h-1z",
    fill: "#cc9689"
  })), _path6738 || (_path6738 = /*#__PURE__*/React.createElement("path", {
    d: "M69 101h1v1h-1z",
    fill: "#b88a83",
    fillOpacity: 0.663
  })), _path6739 || (_path6739 = /*#__PURE__*/React.createElement("path", {
    d: "M72 101h1v1h-1z",
    fill: "#5d5043",
    fillOpacity: 0.075
  })), _path6740 || (_path6740 = /*#__PURE__*/React.createElement("path", {
    d: "M74 102h-1v-1h1z",
    fill: "#996a44",
    fillOpacity: 0.902
  })), _path6741 || (_path6741 = /*#__PURE__*/React.createElement("path", {
    d: "M75 101v1h-1v-1z",
    fill: "#ac7242"
  })), _path6742 || (_path6742 = /*#__PURE__*/React.createElement("path", {
    d: "M75 102v-1h1v1z",
    fill: "#ac754d"
  })), _path6743 || (_path6743 = /*#__PURE__*/React.createElement("path", {
    d: "M77 102v-1h1v1z",
    fill: "#c8a190",
    fillOpacity: 0.769
  })), _path6744 || (_path6744 = /*#__PURE__*/React.createElement("path", {
    d: "M9 103v-1h1v1z",
    fill: "#a67a5a",
    fillOpacity: 0.431
  })), _path6745 || (_path6745 = /*#__PURE__*/React.createElement("path", {
    d: "M11 103v-1h1v1z",
    fill: "#af7548"
  })), _path6746 || (_path6746 = /*#__PURE__*/React.createElement("path", {
    d: "M12 102h1v1h-1z",
    fill: "#a3683c"
  })), _path6747 || (_path6747 = /*#__PURE__*/React.createElement("path", {
    d: "M14 102v1h-1v-1z",
    fill: "#a96d43"
  })), _path6748 || (_path6748 = /*#__PURE__*/React.createElement("path", {
    d: "M15 103h-1v-1h1z",
    fill: "#9a6b4b",
    fillOpacity: 0.737
  })), _path6749 || (_path6749 = /*#__PURE__*/React.createElement("path", {
    d: "M38 103v-1h1v1z",
    fill: "#c3947e",
    fillOpacity: 0.694
  })), _path6750 || (_path6750 = /*#__PURE__*/React.createElement("path", {
    d: "M39 103v-1h1v1z",
    fill: "#cc8e70"
  })), _path6751 || (_path6751 = /*#__PURE__*/React.createElement("path", {
    d: "M40 103v-1h1v1z",
    fill: "#c58969"
  })), _path6752 || (_path6752 = /*#__PURE__*/React.createElement("path", {
    d: "M41 103v-1h1v1z",
    fill: "#b68266"
  })), _path6753 || (_path6753 = /*#__PURE__*/React.createElement("path", {
    d: "M42 102h1v1h-1z",
    fill: "#9e8078",
    fillOpacity: 0.529
  })), _path6754 || (_path6754 = /*#__PURE__*/React.createElement("path", {
    d: "M66 103h-1v-1h1z",
    fill: "#885844",
    fillOpacity: 0.643
  })), _path6755 || (_path6755 = /*#__PURE__*/React.createElement("path", {
    d: "M68 103h-1v-1h1z",
    fill: "#a1684c"
  })), _path6756 || (_path6756 = /*#__PURE__*/React.createElement("path", {
    d: "M69 102v1h-1v-1z",
    fill: "#c79585"
  })), _path6757 || (_path6757 = /*#__PURE__*/React.createElement("path", {
    d: "M69 102h1v1h-1z",
    fill: "#b98a80",
    fillOpacity: 0.796
  })), _path6758 || (_path6758 = /*#__PURE__*/React.createElement("path", {
    d: "M73 102v1h-1v-1z",
    fill: "#5a4b4b",
    fillOpacity: 0.067
  })), _path6759 || (_path6759 = /*#__PURE__*/React.createElement("path", {
    d: "M74 102v1h-1v-1z",
    fill: "#996b44",
    fillOpacity: 0.894
  })), _path6760 || (_path6760 = /*#__PURE__*/React.createElement("path", {
    d: "M74 102h1v1h-1z",
    fill: "#ab7343"
  })), _path6761 || (_path6761 = /*#__PURE__*/React.createElement("path", {
    d: "M76 103h-1v-1h1z",
    fill: "#a7724a"
  })), _path6762 || (_path6762 = /*#__PURE__*/React.createElement("path", {
    d: "M77 103h-1v-1h1z",
    fill: "#cd9d81"
  })), _path6763 || (_path6763 = /*#__PURE__*/React.createElement("path", {
    d: "M78 103h-1v-1h1z",
    fill: "#c9a190",
    fillOpacity: 0.749
  })), _path6764 || (_path6764 = /*#__PURE__*/React.createElement("path", {
    d: "M10 103v1H9v-1z",
    fill: "#ae7d5b",
    fillOpacity: 0.471
  })), _path6765 || (_path6765 = /*#__PURE__*/React.createElement("path", {
    d: "M12 104h-1v-1h1z",
    fill: "#ac7144"
  })), _path6766 || (_path6766 = /*#__PURE__*/React.createElement("path", {
    d: "M12 103h1v1h-1z",
    fill: "#a4693c"
  })), _path6767 || (_path6767 = /*#__PURE__*/React.createElement("path", {
    d: "M13 104v-1h1v1z",
    fill: "#ab6d43"
  })), _path6768 || (_path6768 = /*#__PURE__*/React.createElement("path", {
    d: "M15 103v1h-1v-1z",
    fill: "#9b694a",
    fillOpacity: 0.682
  })), _path6769 || (_path6769 = /*#__PURE__*/React.createElement("path", {
    d: "M39 104h-1v-1h1z",
    fill: "#be8d76",
    fillOpacity: 0.725
  })), _path6770 || (_path6770 = /*#__PURE__*/React.createElement("path", {
    d: "M40 104h-1v-1h1z",
    fill: "#c08567"
  })), _path6771 || (_path6771 = /*#__PURE__*/React.createElement("path", {
    d: "M41 103v1h-1v-1z",
    fill: "#bc7f5e"
  })), _path6772 || (_path6772 = /*#__PURE__*/React.createElement("path", {
    d: "M42 103v1h-1v-1z",
    fill: "#b07b5f"
  })), _path6773 || (_path6773 = /*#__PURE__*/React.createElement("path", {
    d: "M43 104h-1v-1h1z",
    fill: "#967c72",
    fillOpacity: 0.498
  })), _path6774 || (_path6774 = /*#__PURE__*/React.createElement("path", {
    d: "M65 104v-1h1v1z",
    fill: "#8c5b49",
    fillOpacity: 0.478
  })), _path6775 || (_path6775 = /*#__PURE__*/React.createElement("path", {
    d: "M66 103h1v1h-1z",
    fill: "#9b5f3e"
  })), _path6776 || (_path6776 = /*#__PURE__*/React.createElement("path", {
    d: "M68 103v1h-1v-1z",
    fill: "#9c5f40"
  })), _path6777 || (_path6777 = /*#__PURE__*/React.createElement("path", {
    d: "M68 103h1v1h-1z",
    fill: "#bc8c7a"
  })), _path6778 || (_path6778 = /*#__PURE__*/React.createElement("path", {
    d: "M70 104h-1v-1h1z",
    fill: "#ba877b",
    fillOpacity: 0.914
  })), _path6779 || (_path6779 = /*#__PURE__*/React.createElement("path", {
    d: "M71 103v1h-1v-1z",
    fill: "#b7998e",
    fillOpacity: 0.098
  })), _path6780 || (_path6780 = /*#__PURE__*/React.createElement("path", {
    d: "M72 103h1v1h-1z",
    fill: "#5b4848",
    fillOpacity: 0.055
  })), _path6781 || (_path6781 = /*#__PURE__*/React.createElement("path", {
    d: "M73 103h1v1h-1z",
    fill: "#9a6a44",
    fillOpacity: 0.875
  })), _path6782 || (_path6782 = /*#__PURE__*/React.createElement("path", {
    d: "M75 104h-1v-1h1z",
    fill: "#ad7649"
  })), _path6783 || (_path6783 = /*#__PURE__*/React.createElement("path", {
    d: "M75 104v-1h1v1z",
    fill: "#a7744c"
  })), _path6784 || (_path6784 = /*#__PURE__*/React.createElement("path", {
    d: "M77 103v1h-1v-1z",
    fill: "#cc9c7d"
  })), _path6785 || (_path6785 = /*#__PURE__*/React.createElement("path", {
    d: "M77 104v-1h1v1z",
    fill: "#cba28d",
    fillOpacity: 0.714
  })), _path6786 || (_path6786 = /*#__PURE__*/React.createElement("path", {
    d: "M10 105H9v-1h1z",
    fill: "#b18260",
    fillOpacity: 0.506
  })), _path6787 || (_path6787 = /*#__PURE__*/React.createElement("path", {
    d: "M11 105h-1v-1h1z",
    fill: "#c5895c"
  })), _path6788 || (_path6788 = /*#__PURE__*/React.createElement("path", {
    d: "M12 104v1h-1v-1z",
    fill: "#a86c3e"
  })), _path6789 || (_path6789 = /*#__PURE__*/React.createElement("path", {
    d: "M12 105v-1h1v1z",
    fill: "#a26638"
  })), _path6790 || (_path6790 = /*#__PURE__*/React.createElement("path", {
    d: "M14 105h-1v-1h1z",
    fill: "#a7693f"
  })), _path6791 || (_path6791 = /*#__PURE__*/React.createElement("path", {
    d: "M14 105v-1h1v1z",
    fill: "#986647",
    fillOpacity: 0.616
  })), _path6792 || (_path6792 = /*#__PURE__*/React.createElement("path", {
    d: "M38 104h1v1h-1z",
    fill: "#c18d76",
    fillOpacity: 0.769
  })), _path6793 || (_path6793 = /*#__PURE__*/React.createElement("path", {
    d: "M39 104h1v1h-1z",
    fill: "#c38867"
  })), _path6794 || (_path6794 = /*#__PURE__*/React.createElement("path", {
    d: "M41 104v1h-1v-1z",
    fill: "#be7f5f"
  })), _path6795 || (_path6795 = /*#__PURE__*/React.createElement("path", {
    d: "M42 105h-1v-1h1z",
    fill: "#ae7a5d"
  })), _path6796 || (_path6796 = /*#__PURE__*/React.createElement("path", {
    d: "M42 105v-1h1v1z",
    fill: "#95786d",
    fillOpacity: 0.455
  })), _path6797 || (_path6797 = /*#__PURE__*/React.createElement("path", {
    d: "M65 104h1v1h-1z",
    fill: "#815545",
    fillOpacity: 0.318
  })), _path6798 || (_path6798 = /*#__PURE__*/React.createElement("path", {
    d: "M66 104h1v1h-1z",
    fill: "#93583b"
  })), _path6799 || (_path6799 = /*#__PURE__*/React.createElement("path", {
    d: "M68 105h-1v-1h1z",
    fill: "#995b3a"
  })), _path6800 || (_path6800 = /*#__PURE__*/React.createElement("path", {
    d: "M68 104h1v1h-1z",
    fill: "#b5816c"
  })), _path6801 || (_path6801 = /*#__PURE__*/React.createElement("path", {
    d: "M70 104v1h-1v-1z",
    fill: "#b98778",
    fillOpacity: 0.988
  })), _path6802 || (_path6802 = /*#__PURE__*/React.createElement("path", {
    d: "M71 105h-1v-1h1z",
    fill: "#b89288",
    fillOpacity: 0.212
  })), _path6803 || (_path6803 = /*#__PURE__*/React.createElement("path", {
    d: "M73 104v1h-1v-1z",
    fill: "#6a6a55",
    fillOpacity: 0.047
  })), _path6804 || (_path6804 = /*#__PURE__*/React.createElement("path", {
    d: "M74 104v1h-1v-1z",
    fill: "#9d6d4a",
    fillOpacity: 0.859
  })), _path6805 || (_path6805 = /*#__PURE__*/React.createElement("path", {
    d: "M75 105h-1v-1h1z",
    fill: "#ab744b"
  })), _path6806 || (_path6806 = /*#__PURE__*/React.createElement("path", {
    d: "M75 105v-1h1v1z",
    fill: "#aa764d"
  })), _path6807 || (_path6807 = /*#__PURE__*/React.createElement("path", {
    d: "M76 105v-1h1v1z",
    fill: "#ca9b79"
  })), _path6808 || (_path6808 = /*#__PURE__*/React.createElement("path", {
    d: "M77 104h1v1h-1z",
    fill: "#c8a18a",
    fillOpacity: 0.694
  })), _path6809 || (_path6809 = /*#__PURE__*/React.createElement("path", {
    d: "M9 106v-1h1v1z",
    fill: "#af8260",
    fillOpacity: 0.569
  })), _path6810 || (_path6810 = /*#__PURE__*/React.createElement("path", {
    d: "M10 106v-1h1v1z",
    fill: "#c78a5c"
  })), _path6811 || (_path6811 = /*#__PURE__*/React.createElement("path", {
    d: "M12 105h1v1h-1z",
    fill: "#a26333"
  })), _path6812 || (_path6812 = /*#__PURE__*/React.createElement("path", {
    d: "M13 106v-1h1v1z",
    fill: "#a4653b"
  })), _path6813 || (_path6813 = /*#__PURE__*/React.createElement("path", {
    d: "M15 105v1h-1v-1z",
    fill: "#986646",
    fillOpacity: 0.565
  })), _path6814 || (_path6814 = /*#__PURE__*/React.createElement("path", {
    d: "M38 106h-1v-1h1z",
    fill: "#aad4d4",
    fillOpacity: 0.024
  })), _path6815 || (_path6815 = /*#__PURE__*/React.createElement("path", {
    d: "M39 105v1h-1v-1z",
    fill: "#c48d74",
    fillOpacity: 0.808
  })), _path6816 || (_path6816 = /*#__PURE__*/React.createElement("path", {
    d: "M39 106v-1h1v1z",
    fill: "#c28763"
  })), _path6817 || (_path6817 = /*#__PURE__*/React.createElement("path", {
    d: "M41 106h-1v-1h1z",
    fill: "#c07f5f"
  })), _path6818 || (_path6818 = /*#__PURE__*/React.createElement("path", {
    d: "M42 106h-1v-1h1z",
    fill: "#af795d"
  })), _path6819 || (_path6819 = /*#__PURE__*/React.createElement("path", {
    d: "M42 106v-1h1v1z",
    fill: "#95786b",
    fillOpacity: 0.408
  })), _path6820 || (_path6820 = /*#__PURE__*/React.createElement("path", {
    d: "M65 106v-1h1v1z",
    fill: "#684741",
    fillOpacity: 0.153
  })), _path6821 || (_path6821 = /*#__PURE__*/React.createElement("path", {
    d: "M67 105v1h-1v-1z",
    fill: "#834d36",
    fillOpacity: 0.988
  })), _path6822 || (_path6822 = /*#__PURE__*/React.createElement("path", {
    d: "M67 105h1v1h-1z",
    fill: "#9a5d38"
  })), _path6823 || (_path6823 = /*#__PURE__*/React.createElement("path", {
    d: "M69 105v1h-1v-1z",
    fill: "#b3795f"
  })), _path6824 || (_path6824 = /*#__PURE__*/React.createElement("path", {
    d: "M70 106h-1v-1h1z",
    fill: "#c1927e"
  })), _path6825 || (_path6825 = /*#__PURE__*/React.createElement("path", {
    d: "M70 105h1v1h-1z",
    fill: "#b1928e",
    fillOpacity: 0.259
  })), _path6826 || (_path6826 = /*#__PURE__*/React.createElement("path", {
    d: "M73 106v-1h1v1z",
    fill: "#a37553",
    fillOpacity: 0.827
  })), _path6827 || (_path6827 = /*#__PURE__*/React.createElement("path", {
    d: "M75 105v1h-1v-1z",
    fill: "#ab764c"
  })), _path6828 || (_path6828 = /*#__PURE__*/React.createElement("path", {
    d: "M76 106h-1v-1h1z",
    fill: "#a9754b"
  })), _path6829 || (_path6829 = /*#__PURE__*/React.createElement("path", {
    d: "M77 106h-1v-1h1z",
    fill: "#ca9b7a"
  })), _path6830 || (_path6830 = /*#__PURE__*/React.createElement("path", {
    d: "M77 106v-1h1v1z",
    fill: "#c8a38d",
    fillOpacity: 0.659
  })), _path6831 || (_path6831 = /*#__PURE__*/React.createElement("path", {
    d: "M9 106h1v1H9z",
    fill: "#ac7c5a",
    fillOpacity: 0.62
  })), _path6832 || (_path6832 = /*#__PURE__*/React.createElement("path", {
    d: "M11 107h-1v-1h1z",
    fill: "#c4885c"
  })), _path6833 || (_path6833 = /*#__PURE__*/React.createElement("path", {
    d: "M12 107v-1h1v1z",
    fill: "#a06131"
  })), _path6834 || (_path6834 = /*#__PURE__*/React.createElement("path", {
    d: "M14 106v1h-1v-1z",
    fill: "#a36135"
  })), _path6835 || (_path6835 = /*#__PURE__*/React.createElement("path", {
    d: "M14 107v-1h1v1z",
    fill: "#996949",
    fillOpacity: 0.502
  })), _path6836 || (_path6836 = /*#__PURE__*/React.createElement("path", {
    d: "M37 106h1v1h-1z",
    fill: "#d0b9b9",
    fillOpacity: 0.043
  })), _path6837 || (_path6837 = /*#__PURE__*/React.createElement("path", {
    d: "M39 107h-1v-1h1z",
    fill: "#c78e76",
    fillOpacity: 0.843
  })), _path6838 || (_path6838 = /*#__PURE__*/React.createElement("path", {
    d: "M40 107h-1v-1h1z",
    fill: "#c38561"
  })), _path6839 || (_path6839 = /*#__PURE__*/React.createElement("path", {
    d: "M41 106v1h-1v-1z",
    fill: "#be7d5c"
  })), _path6840 || (_path6840 = /*#__PURE__*/React.createElement("path", {
    d: "M41 106h1v1h-1z",
    fill: "#ac795d"
  })), _path6841 || (_path6841 = /*#__PURE__*/React.createElement("path", {
    d: "M43 106v1h-1v-1z",
    fill: "#987f74",
    fillOpacity: 0.361
  })), _path6842 || (_path6842 = /*#__PURE__*/React.createElement("path", {
    d: "M65 107v-1h1v1z",
    fill: "#7f3f3f",
    fillOpacity: 0.016
  })), _path6843 || (_path6843 = /*#__PURE__*/React.createElement("path", {
    d: "M66 106h1v1h-1z",
    fill: "#724430",
    fillOpacity: 0.478
  })), _path6844 || (_path6844 = /*#__PURE__*/React.createElement("path", {
    d: "M68 106v1h-1v-1z",
    fill: "#855434",
    fillOpacity: 0.839
  })), _path6845 || (_path6845 = /*#__PURE__*/React.createElement("path", {
    d: "M68 107v-1h1v1z",
    fill: "#a27055",
    fillOpacity: 0.945
  })), _path6846 || (_path6846 = /*#__PURE__*/React.createElement("path", {
    d: "M69 107v-1h1v1z",
    fill: "#b78e78",
    fillOpacity: 0.533
  })), _path6847 || (_path6847 = /*#__PURE__*/React.createElement("path", {
    d: "M70 107v-1h1v1z",
    fill: "#aa8d8d",
    fillOpacity: 0.035
  })), _path6848 || (_path6848 = /*#__PURE__*/React.createElement("path", {
    d: "M73 106v1h-1v-1z",
    fill: "#7f7fbf",
    fillOpacity: 0.016
  })), _path6849 || (_path6849 = /*#__PURE__*/React.createElement("path", {
    d: "M74 107h-1v-1h1z",
    fill: "#a87b56",
    fillOpacity: 0.796
  })), _path6850 || (_path6850 = /*#__PURE__*/React.createElement("path", {
    d: "M75 106v1h-1v-1z",
    fill: "#b1794e"
  })), _path6851 || (_path6851 = /*#__PURE__*/React.createElement("path", {
    d: "M75 107v-1h1v1z",
    fill: "#ab784c"
  })), _path6852 || (_path6852 = /*#__PURE__*/React.createElement("path", {
    d: "M77 106v1h-1v-1z",
    fill: "#cc9c7a"
  })), _path6853 || (_path6853 = /*#__PURE__*/React.createElement("path", {
    d: "M77 107v-1h1v1z",
    fill: "#c5a08a",
    fillOpacity: 0.627
  })), _path6854 || (_path6854 = /*#__PURE__*/React.createElement("path", {
    d: "M9 107h1v1H9z",
    fill: "#a87551",
    fillOpacity: 0.678
  })), _path6855 || (_path6855 = /*#__PURE__*/React.createElement("path", {
    d: "M11 108h-1v-1h1z",
    fill: "#c0855a"
  })), _path6856 || (_path6856 = /*#__PURE__*/React.createElement("path", {
    d: "M12 108h-1v-1h1z",
    fill: "#a5693c"
  })), _path6857 || (_path6857 = /*#__PURE__*/React.createElement("path", {
    d: "M12 107h1v1h-1z",
    fill: "#9f6133"
  })), _path6858 || (_path6858 = /*#__PURE__*/React.createElement("path", {
    d: "M13 108v-1h1v1z",
    fill: "#9f5e30"
  })), _path6859 || (_path6859 = /*#__PURE__*/React.createElement("path", {
    d: "M14 107h1v1h-1z",
    fill: "#9a6b4e",
    fillOpacity: 0.42
  })), _path6860 || (_path6860 = /*#__PURE__*/React.createElement("path", {
    d: "M38 107v1h-1v-1z",
    fill: "#cca599",
    fillOpacity: 0.078
  })), _path6861 || (_path6861 = /*#__PURE__*/React.createElement("path", {
    d: "M38 108v-1h1v1z",
    fill: "#c58c75",
    fillOpacity: 0.894
  })), _path6862 || (_path6862 = /*#__PURE__*/React.createElement("path", {
    d: "M39 108v-1h1v1z",
    fill: "#c58462"
  })), _path6863 || (_path6863 = /*#__PURE__*/React.createElement("path", {
    d: "M40 108v-1h1v1z",
    fill: "#bd7d5a"
  })), _path6864 || (_path6864 = /*#__PURE__*/React.createElement("path", {
    d: "M42 108h-1v-1h1z",
    fill: "#ab7a5f"
  })), _path6865 || (_path6865 = /*#__PURE__*/React.createElement("path", {
    d: "M42 107h1v1h-1z",
    fill: "#977d74",
    fillOpacity: 0.318
  })), _path6866 || (_path6866 = /*#__PURE__*/React.createElement("path", {
    d: "M67 107h1v1h-1z",
    fill: "#624e3a",
    fillOpacity: 0.051
  })), _path6867 || (_path6867 = /*#__PURE__*/React.createElement("path", {
    d: "M69 107v1h-1v-1z",
    fill: "#725749",
    fillOpacity: 0.149
  })), _path6868 || (_path6868 = /*#__PURE__*/React.createElement("path", {
    d: "M74 107v1h-1v-1z",
    fill: "#a1734e",
    fillOpacity: 0.78
  })), _path6869 || (_path6869 = /*#__PURE__*/React.createElement("path", {
    d: "M74 107h1v1h-1z",
    fill: "#b87d53"
  })), _path6870 || (_path6870 = /*#__PURE__*/React.createElement("path", {
    d: "M75 107h1v1h-1z",
    fill: "#a9774b"
  })), _path6871 || (_path6871 = /*#__PURE__*/React.createElement("path", {
    d: "M77 108h-1v-1h1z",
    fill: "#cd9b78"
  })), _path6872 || (_path6872 = /*#__PURE__*/React.createElement("path", {
    d: "M78 107v1h-1v-1z",
    fill: "#c4a187",
    fillOpacity: 0.6
  })), _path6873 || (_path6873 = /*#__PURE__*/React.createElement("path", {
    d: "M10 108v1H9v-1z",
    fill: "#a6714f",
    fillOpacity: 0.733
  })), _path6874 || (_path6874 = /*#__PURE__*/React.createElement("path", {
    d: "M12 108h1v1h-1z",
    fill: "#a36437"
  })), _path6875 || (_path6875 = /*#__PURE__*/React.createElement("path", {
    d: "M13 108h1v1h-1z",
    fill: "#a06437"
  })), _path6876 || (_path6876 = /*#__PURE__*/React.createElement("path", {
    d: "M15 108v1h-1v-1z",
    fill: "#9b6e52",
    fillOpacity: 0.353
  })), _path6877 || (_path6877 = /*#__PURE__*/React.createElement("path", {
    d: "M38 109h-1v-1h1z",
    fill: "#caa79e",
    fillOpacity: 0.114
  })), _path6878 || (_path6878 = /*#__PURE__*/React.createElement("path", {
    d: "M39 108v1h-1v-1z",
    fill: "#c38a73",
    fillOpacity: 0.929
  })), _path6879 || (_path6879 = /*#__PURE__*/React.createElement("path", {
    d: "M39 109v-1h1v1z",
    fill: "#c48360"
  })), _path6880 || (_path6880 = /*#__PURE__*/React.createElement("path", {
    d: "M41 109v-1h1v1z",
    fill: "#a3745b"
  })), _path6881 || (_path6881 = /*#__PURE__*/React.createElement("path", {
    d: "M42 109v-1h1v1z",
    fill: "#94776f",
    fillOpacity: 0.243
  })), _path6882 || (_path6882 = /*#__PURE__*/React.createElement("path", {
    d: "M73 109v-1h1v1z",
    fill: "#976945",
    fillOpacity: 0.765
  })), _path6883 || (_path6883 = /*#__PURE__*/React.createElement("path", {
    d: "M74 108h1v1h-1z",
    fill: "#b47a4f"
  })), _path6884 || (_path6884 = /*#__PURE__*/React.createElement("path", {
    d: "M76 109h-1v-1h1z",
    fill: "#ac794c"
  })), _path6885 || (_path6885 = /*#__PURE__*/React.createElement("path", {
    d: "M77 108v1h-1v-1z",
    fill: "#cc9a77"
  })), _path6886 || (_path6886 = /*#__PURE__*/React.createElement("path", {
    d: "M77 109v-1h1v1z",
    fill: "#c19e84",
    fillOpacity: 0.588
  })), _path6887 || (_path6887 = /*#__PURE__*/React.createElement("path", {
    d: "M9 110H8v-1h1z",
    fill: "#7fffff",
    fillOpacity: 0.008
  })), _path6888 || (_path6888 = /*#__PURE__*/React.createElement("path", {
    d: "M9 110v-1h1v1z",
    fill: "#a5704d",
    fillOpacity: 0.784
  })), _path6889 || (_path6889 = /*#__PURE__*/React.createElement("path", {
    d: "M10 110v-1h1v1z",
    fill: "#bd7e53"
  })), _path6890 || (_path6890 = /*#__PURE__*/React.createElement("path", {
    d: "M12 109v1h-1v-1z",
    fill: "#a46639"
  })), _path6891 || (_path6891 = /*#__PURE__*/React.createElement("path", {
    d: "M13 110h-1v-1h1z",
    fill: "#a76a3c"
  })), _path6892 || (_path6892 = /*#__PURE__*/React.createElement("path", {
    d: "M14 109v1h-1v-1z",
    fill: "#a26c40"
  })), _path6893 || (_path6893 = /*#__PURE__*/React.createElement("path", {
    d: "M14 110v-1h1v1z",
    fill: "#986d4d",
    fillOpacity: 0.282
  })), _path6894 || (_path6894 = /*#__PURE__*/React.createElement("path", {
    d: "M37 109h1v1h-1z",
    fill: "#cda29b",
    fillOpacity: 0.141
  })), _path6895 || (_path6895 = /*#__PURE__*/React.createElement("path", {
    d: "M39 110h-1v-1h1z",
    fill: "#c58b73",
    fillOpacity: 0.953
  })), _path6896 || (_path6896 = /*#__PURE__*/React.createElement("path", {
    d: "M42 109v1h-1v-1z",
    fill: "#9e715a",
    fillOpacity: 0.996
  })), _path6897 || (_path6897 = /*#__PURE__*/React.createElement("path", {
    d: "M43 110h-1v-1h1z",
    fill: "#887167",
    fillOpacity: 0.212
  })), _path6898 || (_path6898 = /*#__PURE__*/React.createElement("path", {
    d: "M73 109h1v1h-1z",
    fill: "#956543",
    fillOpacity: 0.757
  })), _path6899 || (_path6899 = /*#__PURE__*/React.createElement("path", {
    d: "M74 110v-1h1v1z",
    fill: "#ad7147"
  })), _path6900 || (_path6900 = /*#__PURE__*/React.createElement("path", {
    d: "M75 110v-1h1v1z",
    fill: "#b07c50"
  })), _path6901 || (_path6901 = /*#__PURE__*/React.createElement("path", {
    d: "M76 110v-1h1v1z",
    fill: "#c99573"
  })), _path6902 || (_path6902 = /*#__PURE__*/React.createElement("path", {
    d: "M77 109h1v1h-1z",
    fill: "#c19d82",
    fillOpacity: 0.573
  })), _path6903 || (_path6903 = /*#__PURE__*/React.createElement("path", {
    d: "M8 111v-1h1v1z",
    fill: "#717171",
    fillOpacity: 0.035
  })), _path6904 || (_path6904 = /*#__PURE__*/React.createElement("path", {
    d: "M10 111H9v-1h1z",
    fill: "#a4704d",
    fillOpacity: 0.839
  })), _path6905 || (_path6905 = /*#__PURE__*/React.createElement("path", {
    d: "M11 110v1h-1v-1z",
    fill: "#b87a4e"
  })), _path6906 || (_path6906 = /*#__PURE__*/React.createElement("path", {
    d: "M13 111v-1h1v1z",
    fill: "#a16a3f",
    fillOpacity: 0.996
  })), _path6907 || (_path6907 = /*#__PURE__*/React.createElement("path", {
    d: "M14 110h1v1h-1z",
    fill: "#916d51",
    fillOpacity: 0.22
  })), _path6908 || (_path6908 = /*#__PURE__*/React.createElement("path", {
    d: "M37 110h1v1h-1z",
    fill: "#c99f8f",
    fillOpacity: 0.188
  })), _path6909 || (_path6909 = /*#__PURE__*/React.createElement("path", {
    d: "M39 110v1h-1v-1z",
    fill: "#c48b71",
    fillOpacity: 0.98
  })), _path6910 || (_path6910 = /*#__PURE__*/React.createElement("path", {
    d: "M41 111h-1v-1h1z",
    fill: "#ba7957"
  })), _path6911 || (_path6911 = /*#__PURE__*/React.createElement("path", {
    d: "M41 111v-1h1v1z",
    fill: "#9c7058",
    fillOpacity: 0.98
  })), _path6912 || (_path6912 = /*#__PURE__*/React.createElement("path", {
    d: "M43 110v1h-1v-1z",
    fill: "#877167",
    fillOpacity: 0.184
  })), _path6913 || (_path6913 = /*#__PURE__*/React.createElement("path", {
    d: "M74 111h-1v-1h1z",
    fill: "#96633e",
    fillOpacity: 0.733
  })), _path6914 || (_path6914 = /*#__PURE__*/React.createElement("path", {
    d: "M74 111v-1h1v1z",
    fill: "#a76c41"
  })), _path6915 || (_path6915 = /*#__PURE__*/React.createElement("path", {
    d: "M76 111h-1v-1h1z",
    fill: "#ad7a51"
  })), _path6916 || (_path6916 = /*#__PURE__*/React.createElement("path", {
    d: "M76 110h1v1h-1z",
    fill: "#ca9672"
  })), _path6917 || (_path6917 = /*#__PURE__*/React.createElement("path", {
    d: "M78 111h-1v-1h1z",
    fill: "#bf997d",
    fillOpacity: 0.549
  })), _path6918 || (_path6918 = /*#__PURE__*/React.createElement("path", {
    d: "M9 112H8v-1h1z",
    fill: "#716355",
    fillOpacity: 0.071
  })), _path6919 || (_path6919 = /*#__PURE__*/React.createElement("path", {
    d: "M10 111v1H9v-1z",
    fill: "#a46f4c",
    fillOpacity: 0.898
  })), _path6920 || (_path6920 = /*#__PURE__*/React.createElement("path", {
    d: "M10 111h1v1h-1z",
    fill: "#b3754a"
  })), _path6921 || (_path6921 = /*#__PURE__*/React.createElement("path", {
    d: "M12 112v-1h1v1z",
    fill: "#a2683e"
  })), _path6922 || (_path6922 = /*#__PURE__*/React.createElement("path", {
    d: "M13 112v-1h1v1z",
    fill: "#9b663d",
    fillOpacity: 0.969
  })), _path6923 || (_path6923 = /*#__PURE__*/React.createElement("path", {
    d: "M15 111v1h-1v-1z",
    fill: "#826855",
    fillOpacity: 0.153
  })), _path6924 || (_path6924 = /*#__PURE__*/React.createElement("path", {
    d: "M37 111h1v1h-1z",
    fill: "#c69785",
    fillOpacity: 0.231
  })), _path6925 || (_path6925 = /*#__PURE__*/React.createElement("path", {
    d: "M39 112h-1v-1h1z",
    fill: "#c2866a"
  })), _path6926 || (_path6926 = /*#__PURE__*/React.createElement("path", {
    d: "M40 112h-1v-1h1z",
    fill: "#bc7c5c"
  })), _path6927 || (_path6927 = /*#__PURE__*/React.createElement("path", {
    d: "M40 111h1v1h-1z",
    fill: "#bb7856"
  })), _path6928 || (_path6928 = /*#__PURE__*/React.createElement("path", {
    d: "M42 112h-1v-1h1z",
    fill: "#9b6f56",
    fillOpacity: 0.961
  })), _path6929 || (_path6929 = /*#__PURE__*/React.createElement("path", {
    d: "M42 111h1v1h-1z",
    fill: "#827568",
    fillOpacity: 0.153
  })), _path6930 || (_path6930 = /*#__PURE__*/React.createElement("path", {
    d: "M73 111h1v1h-1z",
    fill: "#93613b",
    fillOpacity: 0.69
  })), _path6931 || (_path6931 = /*#__PURE__*/React.createElement("path", {
    d: "M74 112v-1h1v1z",
    fill: "#a66e3d"
  })), _path6932 || (_path6932 = /*#__PURE__*/React.createElement("path", {
    d: "M76 111v1h-1v-1z",
    fill: "#a8744a"
  })), _path6933 || (_path6933 = /*#__PURE__*/React.createElement("path", {
    d: "M77 112h-1v-1h1z",
    fill: "#ca9871"
  })), _path6934 || (_path6934 = /*#__PURE__*/React.createElement("path", {
    d: "M78 111v1h-1v-1z",
    fill: "#b19178",
    fillOpacity: 0.529
  })), _path6935 || (_path6935 = /*#__PURE__*/React.createElement("path", {
    d: "M8 113v-1h1v1z",
    fill: "#846651",
    fillOpacity: 0.098
  })), _path6936 || (_path6936 = /*#__PURE__*/React.createElement("path", {
    d: "M9 112h1v1H9z",
    fill: "#aa6f4d",
    fillOpacity: 0.929
  })), _path6937 || (_path6937 = /*#__PURE__*/React.createElement("path", {
    d: "M11 113h-1v-1h1z",
    fill: "#b37247"
  })), _path6938 || (_path6938 = /*#__PURE__*/React.createElement("path", {
    d: "M11 113v-1h1v1z",
    fill: "#a16337"
  })), _path6939 || (_path6939 = /*#__PURE__*/React.createElement("path", {
    d: "M12 113v-1h1v1z",
    fill: "#a7693b"
  })), _path6940 || (_path6940 = /*#__PURE__*/React.createElement("path", {
    d: "M13 113v-1h1v1z",
    fill: "#9a663e",
    fillOpacity: 0.925
  })), _path6941 || (_path6941 = /*#__PURE__*/React.createElement("path", {
    d: "M38 112v1h-1v-1z",
    fill: "#c39283",
    fillOpacity: 0.267
  })), _path6942 || (_path6942 = /*#__PURE__*/React.createElement("path", {
    d: "M39 112v1h-1v-1z",
    fill: "#c38567"
  })), _path6943 || (_path6943 = /*#__PURE__*/React.createElement("path", {
    d: "M40 113h-1v-1h1z",
    fill: "#bb7958"
  })), _path6944 || (_path6944 = /*#__PURE__*/React.createElement("path", {
    d: "M40 113v-1h1v1z",
    fill: "#b67451"
  })), _path6945 || (_path6945 = /*#__PURE__*/React.createElement("path", {
    d: "M42 113h-1v-1h1z",
    fill: "#996e57",
    fillOpacity: 0.929
  })), _path6946 || (_path6946 = /*#__PURE__*/React.createElement("path", {
    d: "M43 113h-1v-1h1z",
    fill: "#917f76",
    fillOpacity: 0.11
  })), _path6947 || (_path6947 = /*#__PURE__*/React.createElement("path", {
    d: "M74 112v1h-1v-1z",
    fill: "#8a6242",
    fillOpacity: 0.498
  })), _path6948 || (_path6948 = /*#__PURE__*/React.createElement("path", {
    d: "M74 112h1v1h-1z",
    fill: "#9e6a3d",
    fillOpacity: 0.933
  })), _path6949 || (_path6949 = /*#__PURE__*/React.createElement("path", {
    d: "M75 112h1v1h-1z",
    fill: "#ac774c"
  })), _path6950 || (_path6950 = /*#__PURE__*/React.createElement("path", {
    d: "M77 112v1h-1v-1z",
    fill: "#ba8e6b",
    fillOpacity: 0.894
  })), _path6951 || (_path6951 = /*#__PURE__*/React.createElement("path", {
    d: "M77 112h1v1h-1z",
    fill: "#a68c75",
    fillOpacity: 0.306
  })), _path6952 || (_path6952 = /*#__PURE__*/React.createElement("path", {
    d: "M9 113v1H8v-1z",
    fill: "#976e60",
    fillOpacity: 0.145
  })), _path6953 || (_path6953 = /*#__PURE__*/React.createElement("path", {
    d: "M10 113v1H9v-1z",
    fill: "#aa704d",
    fillOpacity: 0.984
  })), _path6954 || (_path6954 = /*#__PURE__*/React.createElement("path", {
    d: "M10 114v-1h1v1z",
    fill: "#b17043"
  })), _path6955 || (_path6955 = /*#__PURE__*/React.createElement("path", {
    d: "M11 113h1v1h-1z",
    fill: "#a46537"
  })), _path6956 || (_path6956 = /*#__PURE__*/React.createElement("path", {
    d: "M13 113v1h-1v-1z",
    fill: "#a8693b"
  })), _path6957 || (_path6957 = /*#__PURE__*/React.createElement("path", {
    d: "M13 114v-1h1v1z",
    fill: "#91613d",
    fillOpacity: 0.827
  })), _path6958 || (_path6958 = /*#__PURE__*/React.createElement("path", {
    d: "M38 114h-1v-1h1z",
    fill: "#bc8a7a",
    fillOpacity: 0.318
  })), _path6959 || (_path6959 = /*#__PURE__*/React.createElement("path", {
    d: "M38 113h1v1h-1z",
    fill: "#c68667"
  })), _path6960 || (_path6960 = /*#__PURE__*/React.createElement("path", {
    d: "M40 114h-1v-1h1z",
    fill: "#bd7a57"
  })), _path6961 || (_path6961 = /*#__PURE__*/React.createElement("path", {
    d: "M40 113h1v1h-1z",
    fill: "#b7734f"
  })), _path6962 || (_path6962 = /*#__PURE__*/React.createElement("path", {
    d: "M41 113h1v1h-1z",
    fill: "#9a6f59",
    fillOpacity: 0.894
  })), _path6963 || (_path6963 = /*#__PURE__*/React.createElement("path", {
    d: "M75 114h-1v-1h1z",
    fill: "#83644d",
    fillOpacity: 0.129
  })), _path6964 || (_path6964 = /*#__PURE__*/React.createElement("path", {
    d: "M76 114h-1v-1h1z",
    fill: "#8d6a51",
    fillOpacity: 0.282
  })), _path6965 || (_path6965 = /*#__PURE__*/React.createElement("path", {
    d: "M76 113h1v1h-1z",
    fill: "#a07a67",
    fillOpacity: 0.106
  })), _path6966 || (_path6966 = /*#__PURE__*/React.createElement("path", {
    d: "M9 115v-1h1v1z",
    fill: "#a5704d",
    fillOpacity: 0.682
  })), _path6967 || (_path6967 = /*#__PURE__*/React.createElement("path", {
    d: "M11 114v1h-1v-1z",
    fill: "#a36b46",
    fillOpacity: 0.937
  })), _path6968 || (_path6968 = /*#__PURE__*/React.createElement("path", {
    d: "M12 114v1h-1v-1z",
    fill: "#935d34",
    fillOpacity: 0.812
  })), _path6969 || (_path6969 = /*#__PURE__*/React.createElement("path", {
    d: "M12 115v-1h1v1z",
    fill: "#8b5d3c",
    fillOpacity: 0.545
  })), _path6970 || (_path6970 = /*#__PURE__*/React.createElement("path", {
    d: "M13 114h1v1h-1z",
    fill: "#825f46",
    fillOpacity: 0.2
  })), _path6971 || (_path6971 = /*#__PURE__*/React.createElement("path", {
    d: "M38 115h-1v-1h1z",
    fill: "#bb8b78",
    fillOpacity: 0.373
  })), _path6972 || (_path6972 = /*#__PURE__*/React.createElement("path", {
    d: "M38 115v-1h1v1z",
    fill: "#c28161"
  })), _path6973 || (_path6973 = /*#__PURE__*/React.createElement("path", {
    d: "M40 114v1h-1v-1z",
    fill: "#bc7855"
  })), _path6974 || (_path6974 = /*#__PURE__*/React.createElement("path", {
    d: "M41 115h-1v-1h1z",
    fill: "#b6724e"
  })), _path6975 || (_path6975 = /*#__PURE__*/React.createElement("path", {
    d: "M41 114h1v1h-1z",
    fill: "#9b715c",
    fillOpacity: 0.851
  })), _path6976 || (_path6976 = /*#__PURE__*/React.createElement("path", {
    d: "M9 116v-1h1v1z",
    fill: "#aaf",
    fillOpacity: 0.012
  })), _path6977 || (_path6977 = /*#__PURE__*/React.createElement("path", {
    d: "M10 116v-1h1v1z",
    fill: "#836957",
    fillOpacity: 0.114
  })), _path6978 || (_path6978 = /*#__PURE__*/React.createElement("path", {
    d: "M11 116v-1h1v1z",
    fill: "#5f5f5f",
    fillOpacity: 0.031
  })), _path6979 || (_path6979 = /*#__PURE__*/React.createElement("path", {
    d: "M38 115v1h-1v-1z",
    fill: "#be8d78",
    fillOpacity: 0.431
  })), _path6980 || (_path6980 = /*#__PURE__*/React.createElement("path", {
    d: "M38 116v-1h1v1z",
    fill: "#c28361"
  })), _path6981 || (_path6981 = /*#__PURE__*/React.createElement("path", {
    d: "M39 115h1v1h-1z",
    fill: "#ba7654"
  })), _path6982 || (_path6982 = /*#__PURE__*/React.createElement("path", {
    d: "M40 115h1v1h-1z",
    fill: "#b26d4c"
  })), _path6983 || (_path6983 = /*#__PURE__*/React.createElement("path", {
    d: "M41 116v-1h1v1z",
    fill: "#9d7461",
    fillOpacity: 0.788
  })), _path6984 || (_path6984 = /*#__PURE__*/React.createElement("path", {
    d: "M38 117h-1v-1h1z",
    fill: "#bf8d76",
    fillOpacity: 0.475
  })), _path6985 || (_path6985 = /*#__PURE__*/React.createElement("path", {
    d: "M38 116h1v1h-1z",
    fill: "#c3825e"
  })), _path6986 || (_path6986 = /*#__PURE__*/React.createElement("path", {
    d: "M39 116h1v1h-1z",
    fill: "#ba7652"
  })), _path6987 || (_path6987 = /*#__PURE__*/React.createElement("path", {
    d: "M41 116v1h-1v-1z",
    fill: "#ad6b49"
  })), _path6988 || (_path6988 = /*#__PURE__*/React.createElement("path", {
    d: "M42 117h-1v-1h1z",
    fill: "#9a735f",
    fillOpacity: 0.729
  })), _path6989 || (_path6989 = /*#__PURE__*/React.createElement("path", {
    d: "M38 117v1h-1v-1z",
    fill: "#be8970",
    fillOpacity: 0.525
  })), _path6990 || (_path6990 = /*#__PURE__*/React.createElement("path", {
    d: "M39 117v1h-1v-1z",
    fill: "#c37f59"
  })), _path6991 || (_path6991 = /*#__PURE__*/React.createElement("path", {
    d: "M39 117h1v1h-1z",
    fill: "#b87651"
  })), _path6992 || (_path6992 = /*#__PURE__*/React.createElement("path", {
    d: "M41 118h-1v-1h1z",
    fill: "#ac6c4b"
  })), _path6993 || (_path6993 = /*#__PURE__*/React.createElement("path", {
    d: "M41 117h1v1h-1z",
    fill: "#9c7462",
    fillOpacity: 0.651
  })), _path6994 || (_path6994 = /*#__PURE__*/React.createElement("path", {
    d: "M37 118h1v1h-1z",
    fill: "#bd856b",
    fillOpacity: 0.576
  })), _path6995 || (_path6995 = /*#__PURE__*/React.createElement("path", {
    d: "M38 118h1v1h-1z",
    fill: "#c37e56"
  })), _path6996 || (_path6996 = /*#__PURE__*/React.createElement("path", {
    d: "M39 119v-1h1v1z",
    fill: "#b7744f"
  })), _path6997 || (_path6997 = /*#__PURE__*/React.createElement("path", {
    d: "M40 118h1v1h-1z",
    fill: "#a96d4b"
  })), _path6998 || (_path6998 = /*#__PURE__*/React.createElement("path", {
    d: "M41 119v-1h1v1z",
    fill: "#9a7464",
    fillOpacity: 0.608
  })), _path6999 || (_path6999 = /*#__PURE__*/React.createElement("path", {
    d: "M38 120h-1v-1h1z",
    fill: "#bd8269",
    fillOpacity: 0.627
  })), _path7000 || (_path7000 = /*#__PURE__*/React.createElement("path", {
    d: "M39 120h-1v-1h1z",
    fill: "#c07c55"
  })), _path7001 || (_path7001 = /*#__PURE__*/React.createElement("path", {
    d: "M39 120v-1h1v1z",
    fill: "#b7704c"
  })), _path7002 || (_path7002 = /*#__PURE__*/React.createElement("path", {
    d: "M41 119h1v1h-1z",
    fill: "#977469",
    fillOpacity: 0.541
  })), _path7003 || (_path7003 = /*#__PURE__*/React.createElement("path", {
    d: "M38 121h-1v-1h1z",
    fill: "#be8269",
    fillOpacity: 0.682
  })), _path7004 || (_path7004 = /*#__PURE__*/React.createElement("path", {
    d: "M39 120v1h-1v-1z",
    fill: "#be7c53"
  })), _path7005 || (_path7005 = /*#__PURE__*/React.createElement("path", {
    d: "M40 121h-1v-1h1z",
    fill: "#b5714b"
  })), _path7006 || (_path7006 = /*#__PURE__*/React.createElement("path", {
    d: "M40 120h1v1h-1z",
    fill: "#a56a4b"
  })), _path7007 || (_path7007 = /*#__PURE__*/React.createElement("path", {
    d: "M41 120h1v1h-1z",
    fill: "#916f65",
    fillOpacity: 0.482
  })), _path7008 || (_path7008 = /*#__PURE__*/React.createElement("path", {
    d: "M38 122h-1v-1h1z",
    fill: "#b67f66",
    fillOpacity: 0.761
  })), _path7009 || (_path7009 = /*#__PURE__*/React.createElement("path", {
    d: "M38 121h1v1h-1z",
    fill: "#c37f56"
  })), _path7010 || (_path7010 = /*#__PURE__*/React.createElement("path", {
    d: "M39 121h1v1h-1z",
    fill: "#bb7651"
  })), _path7011 || (_path7011 = /*#__PURE__*/React.createElement("path", {
    d: "M41 121v1h-1v-1z",
    fill: "#9d6a4b"
  })), _path7012 || (_path7012 = /*#__PURE__*/React.createElement("path", {
    d: "M41 122v-1h1v1z",
    fill: "#886f65",
    fillOpacity: 0.286
  })), _path7013 || (_path7013 = /*#__PURE__*/React.createElement("path", {
    d: "M38 122v1h-1v-1z",
    fill: "#aa785d",
    fillOpacity: 0.482
  })), _path7014 || (_path7014 = /*#__PURE__*/React.createElement("path", {
    d: "M39 122v1h-1v-1z",
    fill: "#b37450",
    fillOpacity: 0.784
  })), _path7015 || (_path7015 = /*#__PURE__*/React.createElement("path", {
    d: "M39 122h1v1h-1z",
    fill: "#b17151",
    fillOpacity: 0.847
  })), _path7016 || (_path7016 = /*#__PURE__*/React.createElement("path", {
    d: "M41 123h-1v-1h1z",
    fill: "#936648",
    fillOpacity: 0.624
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFurniture);
export default __webpack_public_path__ + "static/media/furniture.d08f4aaca7b6f9a1dedda89b3a1f6300.svg";
export { ForwardRef as ReactComponent };